import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: any; output: any; }
  bpchar: { input: any; output: any; }
  date: { input: any; output: any; }
  json: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LoginReturn = {
  __typename?: 'LoginReturn';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  needsAgreement: Scalars['Boolean']['output'];
};

export type LogoutReturn = {
  __typename?: 'LogoutReturn';
  logout: Scalars['Boolean']['output'];
};

export type SetPasswordReturn = {
  __typename?: 'SetPasswordReturn';
  passwordSet: Scalars['Boolean']['output'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "V_ORGANICE_EVENT_RAUMBUCHUNG" */
export type V_Organice_Event_Raumbuchung = {
  __typename?: 'V_ORGANICE_EVENT_RAUMBUCHUNG';
  Buchungstag?: Maybe<Scalars['date']['output']>;
  DIP_ID_Raumbuchung: Scalars['String']['output'];
  ID_Raumbuchung: Scalars['numeric']['output'];
  Nutzungsart_Bez?: Maybe<Scalars['String']['output']>;
  Nutzungsart_IDK?: Maybe<Scalars['String']['output']>;
  Raum_Bez?: Maybe<Scalars['String']['output']>;
  Raum_Erfasst_Am?: Maybe<Scalars['date']['output']>;
  Raum_Erfasst_Von?: Maybe<Scalars['String']['output']>;
  Raum_Geaendert_Am?: Maybe<Scalars['date']['output']>;
  Raum_Geaendert_Von?: Maybe<Scalars['String']['output']>;
  Raum_IDK?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  STAMM?: Maybe<V_Organice_Event_Stamm>;
  T_DTS_Create: Scalars['bigint']['output'];
  T_DTS_Update?: Maybe<Scalars['bigint']['output']>;
  T_HASH_Event?: Maybe<Scalars['bpchar']['output']>;
  Uhrzeit_Bis?: Maybe<Scalars['bpchar']['output']>;
  Uhrzeit_Von?: Maybe<Scalars['bpchar']['output']>;
};

/** aggregated selection of "V_ORGANICE_EVENT_RAUMBUCHUNG" */
export type V_Organice_Event_Raumbuchung_Aggregate = {
  __typename?: 'V_ORGANICE_EVENT_RAUMBUCHUNG_aggregate';
  aggregate?: Maybe<V_Organice_Event_Raumbuchung_Aggregate_Fields>;
  nodes: Array<V_Organice_Event_Raumbuchung>;
};

export type V_Organice_Event_Raumbuchung_Aggregate_Bool_Exp = {
  count?: InputMaybe<V_Organice_Event_Raumbuchung_Aggregate_Bool_Exp_Count>;
};

export type V_Organice_Event_Raumbuchung_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<V_Organice_Event_Raumbuchung_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<V_Organice_Event_Raumbuchung_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "V_ORGANICE_EVENT_RAUMBUCHUNG" */
export type V_Organice_Event_Raumbuchung_Aggregate_Fields = {
  __typename?: 'V_ORGANICE_EVENT_RAUMBUCHUNG_aggregate_fields';
  avg?: Maybe<V_Organice_Event_Raumbuchung_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<V_Organice_Event_Raumbuchung_Max_Fields>;
  min?: Maybe<V_Organice_Event_Raumbuchung_Min_Fields>;
  stddev?: Maybe<V_Organice_Event_Raumbuchung_Stddev_Fields>;
  stddev_pop?: Maybe<V_Organice_Event_Raumbuchung_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<V_Organice_Event_Raumbuchung_Stddev_Samp_Fields>;
  sum?: Maybe<V_Organice_Event_Raumbuchung_Sum_Fields>;
  var_pop?: Maybe<V_Organice_Event_Raumbuchung_Var_Pop_Fields>;
  var_samp?: Maybe<V_Organice_Event_Raumbuchung_Var_Samp_Fields>;
  variance?: Maybe<V_Organice_Event_Raumbuchung_Variance_Fields>;
};


/** aggregate fields of "V_ORGANICE_EVENT_RAUMBUCHUNG" */
export type V_Organice_Event_Raumbuchung_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<V_Organice_Event_Raumbuchung_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "V_ORGANICE_EVENT_RAUMBUCHUNG" */
export type V_Organice_Event_Raumbuchung_Aggregate_Order_By = {
  avg?: InputMaybe<V_Organice_Event_Raumbuchung_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<V_Organice_Event_Raumbuchung_Max_Order_By>;
  min?: InputMaybe<V_Organice_Event_Raumbuchung_Min_Order_By>;
  stddev?: InputMaybe<V_Organice_Event_Raumbuchung_Stddev_Order_By>;
  stddev_pop?: InputMaybe<V_Organice_Event_Raumbuchung_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<V_Organice_Event_Raumbuchung_Stddev_Samp_Order_By>;
  sum?: InputMaybe<V_Organice_Event_Raumbuchung_Sum_Order_By>;
  var_pop?: InputMaybe<V_Organice_Event_Raumbuchung_Var_Pop_Order_By>;
  var_samp?: InputMaybe<V_Organice_Event_Raumbuchung_Var_Samp_Order_By>;
  variance?: InputMaybe<V_Organice_Event_Raumbuchung_Variance_Order_By>;
};

/** aggregate avg on columns */
export type V_Organice_Event_Raumbuchung_Avg_Fields = {
  __typename?: 'V_ORGANICE_EVENT_RAUMBUCHUNG_avg_fields';
  ID_Raumbuchung?: Maybe<Scalars['Float']['output']>;
  T_DTS_Create?: Maybe<Scalars['Float']['output']>;
  T_DTS_Update?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "V_ORGANICE_EVENT_RAUMBUCHUNG" */
export type V_Organice_Event_Raumbuchung_Avg_Order_By = {
  ID_Raumbuchung?: InputMaybe<Order_By>;
  T_DTS_Create?: InputMaybe<Order_By>;
  T_DTS_Update?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "V_ORGANICE_EVENT_RAUMBUCHUNG". All fields are combined with a logical 'AND'. */
export type V_Organice_Event_Raumbuchung_Bool_Exp = {
  Buchungstag?: InputMaybe<Date_Comparison_Exp>;
  DIP_ID_Raumbuchung?: InputMaybe<String_Comparison_Exp>;
  ID_Raumbuchung?: InputMaybe<Numeric_Comparison_Exp>;
  Nutzungsart_Bez?: InputMaybe<String_Comparison_Exp>;
  Nutzungsart_IDK?: InputMaybe<String_Comparison_Exp>;
  Raum_Bez?: InputMaybe<String_Comparison_Exp>;
  Raum_Erfasst_Am?: InputMaybe<Date_Comparison_Exp>;
  Raum_Erfasst_Von?: InputMaybe<String_Comparison_Exp>;
  Raum_Geaendert_Am?: InputMaybe<Date_Comparison_Exp>;
  Raum_Geaendert_Von?: InputMaybe<String_Comparison_Exp>;
  Raum_IDK?: InputMaybe<String_Comparison_Exp>;
  STAMM?: InputMaybe<V_Organice_Event_Stamm_Bool_Exp>;
  T_DTS_Create?: InputMaybe<Bigint_Comparison_Exp>;
  T_DTS_Update?: InputMaybe<Bigint_Comparison_Exp>;
  T_HASH_Event?: InputMaybe<Bpchar_Comparison_Exp>;
  Uhrzeit_Bis?: InputMaybe<Bpchar_Comparison_Exp>;
  Uhrzeit_Von?: InputMaybe<Bpchar_Comparison_Exp>;
  _and?: InputMaybe<Array<V_Organice_Event_Raumbuchung_Bool_Exp>>;
  _not?: InputMaybe<V_Organice_Event_Raumbuchung_Bool_Exp>;
  _or?: InputMaybe<Array<V_Organice_Event_Raumbuchung_Bool_Exp>>;
};

/** aggregate max on columns */
export type V_Organice_Event_Raumbuchung_Max_Fields = {
  __typename?: 'V_ORGANICE_EVENT_RAUMBUCHUNG_max_fields';
  Buchungstag?: Maybe<Scalars['date']['output']>;
  DIP_ID_Raumbuchung?: Maybe<Scalars['String']['output']>;
  ID_Raumbuchung?: Maybe<Scalars['numeric']['output']>;
  Nutzungsart_Bez?: Maybe<Scalars['String']['output']>;
  Nutzungsart_IDK?: Maybe<Scalars['String']['output']>;
  Raum_Bez?: Maybe<Scalars['String']['output']>;
  Raum_Erfasst_Am?: Maybe<Scalars['date']['output']>;
  Raum_Erfasst_Von?: Maybe<Scalars['String']['output']>;
  Raum_Geaendert_Am?: Maybe<Scalars['date']['output']>;
  Raum_Geaendert_Von?: Maybe<Scalars['String']['output']>;
  Raum_IDK?: Maybe<Scalars['String']['output']>;
  T_DTS_Create?: Maybe<Scalars['bigint']['output']>;
  T_DTS_Update?: Maybe<Scalars['bigint']['output']>;
  T_HASH_Event?: Maybe<Scalars['bpchar']['output']>;
  Uhrzeit_Bis?: Maybe<Scalars['bpchar']['output']>;
  Uhrzeit_Von?: Maybe<Scalars['bpchar']['output']>;
};

/** order by max() on columns of table "V_ORGANICE_EVENT_RAUMBUCHUNG" */
export type V_Organice_Event_Raumbuchung_Max_Order_By = {
  Buchungstag?: InputMaybe<Order_By>;
  DIP_ID_Raumbuchung?: InputMaybe<Order_By>;
  ID_Raumbuchung?: InputMaybe<Order_By>;
  Nutzungsart_Bez?: InputMaybe<Order_By>;
  Nutzungsart_IDK?: InputMaybe<Order_By>;
  Raum_Bez?: InputMaybe<Order_By>;
  Raum_Erfasst_Am?: InputMaybe<Order_By>;
  Raum_Erfasst_Von?: InputMaybe<Order_By>;
  Raum_Geaendert_Am?: InputMaybe<Order_By>;
  Raum_Geaendert_Von?: InputMaybe<Order_By>;
  Raum_IDK?: InputMaybe<Order_By>;
  T_DTS_Create?: InputMaybe<Order_By>;
  T_DTS_Update?: InputMaybe<Order_By>;
  T_HASH_Event?: InputMaybe<Order_By>;
  Uhrzeit_Bis?: InputMaybe<Order_By>;
  Uhrzeit_Von?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type V_Organice_Event_Raumbuchung_Min_Fields = {
  __typename?: 'V_ORGANICE_EVENT_RAUMBUCHUNG_min_fields';
  Buchungstag?: Maybe<Scalars['date']['output']>;
  DIP_ID_Raumbuchung?: Maybe<Scalars['String']['output']>;
  ID_Raumbuchung?: Maybe<Scalars['numeric']['output']>;
  Nutzungsart_Bez?: Maybe<Scalars['String']['output']>;
  Nutzungsart_IDK?: Maybe<Scalars['String']['output']>;
  Raum_Bez?: Maybe<Scalars['String']['output']>;
  Raum_Erfasst_Am?: Maybe<Scalars['date']['output']>;
  Raum_Erfasst_Von?: Maybe<Scalars['String']['output']>;
  Raum_Geaendert_Am?: Maybe<Scalars['date']['output']>;
  Raum_Geaendert_Von?: Maybe<Scalars['String']['output']>;
  Raum_IDK?: Maybe<Scalars['String']['output']>;
  T_DTS_Create?: Maybe<Scalars['bigint']['output']>;
  T_DTS_Update?: Maybe<Scalars['bigint']['output']>;
  T_HASH_Event?: Maybe<Scalars['bpchar']['output']>;
  Uhrzeit_Bis?: Maybe<Scalars['bpchar']['output']>;
  Uhrzeit_Von?: Maybe<Scalars['bpchar']['output']>;
};

/** order by min() on columns of table "V_ORGANICE_EVENT_RAUMBUCHUNG" */
export type V_Organice_Event_Raumbuchung_Min_Order_By = {
  Buchungstag?: InputMaybe<Order_By>;
  DIP_ID_Raumbuchung?: InputMaybe<Order_By>;
  ID_Raumbuchung?: InputMaybe<Order_By>;
  Nutzungsart_Bez?: InputMaybe<Order_By>;
  Nutzungsart_IDK?: InputMaybe<Order_By>;
  Raum_Bez?: InputMaybe<Order_By>;
  Raum_Erfasst_Am?: InputMaybe<Order_By>;
  Raum_Erfasst_Von?: InputMaybe<Order_By>;
  Raum_Geaendert_Am?: InputMaybe<Order_By>;
  Raum_Geaendert_Von?: InputMaybe<Order_By>;
  Raum_IDK?: InputMaybe<Order_By>;
  T_DTS_Create?: InputMaybe<Order_By>;
  T_DTS_Update?: InputMaybe<Order_By>;
  T_HASH_Event?: InputMaybe<Order_By>;
  Uhrzeit_Bis?: InputMaybe<Order_By>;
  Uhrzeit_Von?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "V_ORGANICE_EVENT_RAUMBUCHUNG". */
export type V_Organice_Event_Raumbuchung_Order_By = {
  Buchungstag?: InputMaybe<Order_By>;
  DIP_ID_Raumbuchung?: InputMaybe<Order_By>;
  ID_Raumbuchung?: InputMaybe<Order_By>;
  Nutzungsart_Bez?: InputMaybe<Order_By>;
  Nutzungsart_IDK?: InputMaybe<Order_By>;
  Raum_Bez?: InputMaybe<Order_By>;
  Raum_Erfasst_Am?: InputMaybe<Order_By>;
  Raum_Erfasst_Von?: InputMaybe<Order_By>;
  Raum_Geaendert_Am?: InputMaybe<Order_By>;
  Raum_Geaendert_Von?: InputMaybe<Order_By>;
  Raum_IDK?: InputMaybe<Order_By>;
  STAMM?: InputMaybe<V_Organice_Event_Stamm_Order_By>;
  T_DTS_Create?: InputMaybe<Order_By>;
  T_DTS_Update?: InputMaybe<Order_By>;
  T_HASH_Event?: InputMaybe<Order_By>;
  Uhrzeit_Bis?: InputMaybe<Order_By>;
  Uhrzeit_Von?: InputMaybe<Order_By>;
};

/** select columns of table "V_ORGANICE_EVENT_RAUMBUCHUNG" */
export enum V_Organice_Event_Raumbuchung_Select_Column {
  /** column name */
  Buchungstag = 'Buchungstag',
  /** column name */
  DIPIDRaumbuchung = 'DIP_ID_Raumbuchung',
  /** column name */
  IDRaumbuchung = 'ID_Raumbuchung',
  /** column name */
  NutzungsartBez = 'Nutzungsart_Bez',
  /** column name */
  NutzungsartIDK = 'Nutzungsart_IDK',
  /** column name */
  RaumBez = 'Raum_Bez',
  /** column name */
  RaumErfasstAm = 'Raum_Erfasst_Am',
  /** column name */
  RaumErfasstVon = 'Raum_Erfasst_Von',
  /** column name */
  RaumGeaendertAm = 'Raum_Geaendert_Am',
  /** column name */
  RaumGeaendertVon = 'Raum_Geaendert_Von',
  /** column name */
  RaumIDK = 'Raum_IDK',
  /** column name */
  TDTSCreate = 'T_DTS_Create',
  /** column name */
  TDTSUpdate = 'T_DTS_Update',
  /** column name */
  THASHEvent = 'T_HASH_Event',
  /** column name */
  UhrzeitBis = 'Uhrzeit_Bis',
  /** column name */
  UhrzeitVon = 'Uhrzeit_Von'
}

/** aggregate stddev on columns */
export type V_Organice_Event_Raumbuchung_Stddev_Fields = {
  __typename?: 'V_ORGANICE_EVENT_RAUMBUCHUNG_stddev_fields';
  ID_Raumbuchung?: Maybe<Scalars['Float']['output']>;
  T_DTS_Create?: Maybe<Scalars['Float']['output']>;
  T_DTS_Update?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "V_ORGANICE_EVENT_RAUMBUCHUNG" */
export type V_Organice_Event_Raumbuchung_Stddev_Order_By = {
  ID_Raumbuchung?: InputMaybe<Order_By>;
  T_DTS_Create?: InputMaybe<Order_By>;
  T_DTS_Update?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type V_Organice_Event_Raumbuchung_Stddev_Pop_Fields = {
  __typename?: 'V_ORGANICE_EVENT_RAUMBUCHUNG_stddev_pop_fields';
  ID_Raumbuchung?: Maybe<Scalars['Float']['output']>;
  T_DTS_Create?: Maybe<Scalars['Float']['output']>;
  T_DTS_Update?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "V_ORGANICE_EVENT_RAUMBUCHUNG" */
export type V_Organice_Event_Raumbuchung_Stddev_Pop_Order_By = {
  ID_Raumbuchung?: InputMaybe<Order_By>;
  T_DTS_Create?: InputMaybe<Order_By>;
  T_DTS_Update?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type V_Organice_Event_Raumbuchung_Stddev_Samp_Fields = {
  __typename?: 'V_ORGANICE_EVENT_RAUMBUCHUNG_stddev_samp_fields';
  ID_Raumbuchung?: Maybe<Scalars['Float']['output']>;
  T_DTS_Create?: Maybe<Scalars['Float']['output']>;
  T_DTS_Update?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "V_ORGANICE_EVENT_RAUMBUCHUNG" */
export type V_Organice_Event_Raumbuchung_Stddev_Samp_Order_By = {
  ID_Raumbuchung?: InputMaybe<Order_By>;
  T_DTS_Create?: InputMaybe<Order_By>;
  T_DTS_Update?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "V_ORGANICE_EVENT_RAUMBUCHUNG" */
export type V_Organice_Event_Raumbuchung_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: V_Organice_Event_Raumbuchung_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type V_Organice_Event_Raumbuchung_Stream_Cursor_Value_Input = {
  Buchungstag?: InputMaybe<Scalars['date']['input']>;
  DIP_ID_Raumbuchung?: InputMaybe<Scalars['String']['input']>;
  ID_Raumbuchung?: InputMaybe<Scalars['numeric']['input']>;
  Nutzungsart_Bez?: InputMaybe<Scalars['String']['input']>;
  Nutzungsart_IDK?: InputMaybe<Scalars['String']['input']>;
  Raum_Bez?: InputMaybe<Scalars['String']['input']>;
  Raum_Erfasst_Am?: InputMaybe<Scalars['date']['input']>;
  Raum_Erfasst_Von?: InputMaybe<Scalars['String']['input']>;
  Raum_Geaendert_Am?: InputMaybe<Scalars['date']['input']>;
  Raum_Geaendert_Von?: InputMaybe<Scalars['String']['input']>;
  Raum_IDK?: InputMaybe<Scalars['String']['input']>;
  T_DTS_Create?: InputMaybe<Scalars['bigint']['input']>;
  T_DTS_Update?: InputMaybe<Scalars['bigint']['input']>;
  T_HASH_Event?: InputMaybe<Scalars['bpchar']['input']>;
  Uhrzeit_Bis?: InputMaybe<Scalars['bpchar']['input']>;
  Uhrzeit_Von?: InputMaybe<Scalars['bpchar']['input']>;
};

/** aggregate sum on columns */
export type V_Organice_Event_Raumbuchung_Sum_Fields = {
  __typename?: 'V_ORGANICE_EVENT_RAUMBUCHUNG_sum_fields';
  ID_Raumbuchung?: Maybe<Scalars['numeric']['output']>;
  T_DTS_Create?: Maybe<Scalars['bigint']['output']>;
  T_DTS_Update?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "V_ORGANICE_EVENT_RAUMBUCHUNG" */
export type V_Organice_Event_Raumbuchung_Sum_Order_By = {
  ID_Raumbuchung?: InputMaybe<Order_By>;
  T_DTS_Create?: InputMaybe<Order_By>;
  T_DTS_Update?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type V_Organice_Event_Raumbuchung_Var_Pop_Fields = {
  __typename?: 'V_ORGANICE_EVENT_RAUMBUCHUNG_var_pop_fields';
  ID_Raumbuchung?: Maybe<Scalars['Float']['output']>;
  T_DTS_Create?: Maybe<Scalars['Float']['output']>;
  T_DTS_Update?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "V_ORGANICE_EVENT_RAUMBUCHUNG" */
export type V_Organice_Event_Raumbuchung_Var_Pop_Order_By = {
  ID_Raumbuchung?: InputMaybe<Order_By>;
  T_DTS_Create?: InputMaybe<Order_By>;
  T_DTS_Update?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type V_Organice_Event_Raumbuchung_Var_Samp_Fields = {
  __typename?: 'V_ORGANICE_EVENT_RAUMBUCHUNG_var_samp_fields';
  ID_Raumbuchung?: Maybe<Scalars['Float']['output']>;
  T_DTS_Create?: Maybe<Scalars['Float']['output']>;
  T_DTS_Update?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "V_ORGANICE_EVENT_RAUMBUCHUNG" */
export type V_Organice_Event_Raumbuchung_Var_Samp_Order_By = {
  ID_Raumbuchung?: InputMaybe<Order_By>;
  T_DTS_Create?: InputMaybe<Order_By>;
  T_DTS_Update?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type V_Organice_Event_Raumbuchung_Variance_Fields = {
  __typename?: 'V_ORGANICE_EVENT_RAUMBUCHUNG_variance_fields';
  ID_Raumbuchung?: Maybe<Scalars['Float']['output']>;
  T_DTS_Create?: Maybe<Scalars['Float']['output']>;
  T_DTS_Update?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "V_ORGANICE_EVENT_RAUMBUCHUNG" */
export type V_Organice_Event_Raumbuchung_Variance_Order_By = {
  ID_Raumbuchung?: InputMaybe<Order_By>;
  T_DTS_Create?: InputMaybe<Order_By>;
  T_DTS_Update?: InputMaybe<Order_By>;
};

/** columns and relationships of "V_ORGANICE_EVENT_STAMM" */
export type V_Organice_Event_Stamm = {
  __typename?: 'V_ORGANICE_EVENT_STAMM';
  Auslandsaussteller_Erwartet?: Maybe<Scalars['numeric']['output']>;
  Auslandsaussteller_Ist?: Maybe<Scalars['numeric']['output']>;
  Bruttoqm_Erwartet?: Maybe<Scalars['numeric']['output']>;
  Bruttoqm_Ist?: Maybe<Scalars['numeric']['output']>;
  DIP_ID_Event: Scalars['String']['output'];
  Einlassuhrzeit?: Maybe<Scalars['bpchar']['output']>;
  Enddatum?: Maybe<Scalars['date']['output']>;
  Enduhrzeit?: Maybe<Scalars['bpchar']['output']>;
  Erfasst_Am?: Maybe<Scalars['date']['output']>;
  Erfasst_Von?: Maybe<Scalars['String']['output']>;
  Geaendert_Am?: Maybe<Scalars['date']['output']>;
  Geaendert_Von?: Maybe<Scalars['String']['output']>;
  Gruendungsjahr?: Maybe<Scalars['numeric']['output']>;
  ID_Rubin?: Maybe<Scalars['numeric']['output']>;
  ID_Salesforce?: Maybe<Scalars['Int']['output']>;
  Inlandsaussteller_Erwartet?: Maybe<Scalars['numeric']['output']>;
  Inlandsaussteller_Ist?: Maybe<Scalars['numeric']['output']>;
  Internetadresse?: Maybe<Scalars['String']['output']>;
  Kongressveranstaltung?: Maybe<Scalars['String']['output']>;
  Kostentraeger_Bez?: Maybe<Scalars['String']['output']>;
  Kostentraeger_IDK?: Maybe<Scalars['String']['output']>;
  Kurztitel?: Maybe<Scalars['String']['output']>;
  Mandant?: Maybe<Scalars['String']['output']>;
  Messeveranstaltung?: Maybe<Scalars['String']['output']>;
  Nettoqm_Erwartet?: Maybe<Scalars['numeric']['output']>;
  Nettoqm_Ist?: Maybe<Scalars['numeric']['output']>;
  Oeffentliche_Veranstaltung?: Maybe<Scalars['String']['output']>;
  Projektverantwortlicher_Bez?: Maybe<Scalars['String']['output']>;
  Projektverantwortlicher_IDK?: Maybe<Scalars['String']['output']>;
  Protokollveranstaltung?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  RAUMBUCHUNG: Array<V_Organice_Event_Raumbuchung>;
  /** An aggregate relationship */
  RAUMBUCHUNG_aggregate: V_Organice_Event_Raumbuchung_Aggregate;
  Rechnungsverantwortlicher_Bez?: Maybe<Scalars['String']['output']>;
  Rechnungsverantwortlicher_IDK?: Maybe<Scalars['String']['output']>;
  Startdatum?: Maybe<Scalars['date']['output']>;
  Startuhrzeit?: Maybe<Scalars['bpchar']['output']>;
  Status_IDK?: Maybe<Scalars['String']['output']>;
  Storno_am?: Maybe<Scalars['date']['output']>;
  T_DTS_Create: Scalars['bigint']['output'];
  T_DTS_Update?: Maybe<Scalars['bigint']['output']>;
  T_Deleted?: Maybe<Scalars['Int']['output']>;
  T_HASH_Event: Scalars['bpchar']['output'];
  T_Locked?: Maybe<Scalars['Int']['output']>;
  T_Mandant: Scalars['String']['output'];
  Technikverantwortlicher_Bez?: Maybe<Scalars['String']['output']>;
  Technikverantwortlicher_IDK?: Maybe<Scalars['String']['output']>;
  Titel?: Maybe<Scalars['String']['output']>;
  VG_Art?: Maybe<Scalars['String']['output']>;
  VG_Typ?: Maybe<Scalars['String']['output']>;
  Veranstaltung_IDK?: Maybe<Scalars['String']['output']>;
  Vertragsnummer?: Maybe<Scalars['numeric']['output']>;
  Zugriff_Bez?: Maybe<Scalars['String']['output']>;
  Zugriff_IDK?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "V_ORGANICE_EVENT_STAMM" */
export type V_Organice_Event_StammRaumbuchungArgs = {
  distinct_on?: InputMaybe<Array<V_Organice_Event_Raumbuchung_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<V_Organice_Event_Raumbuchung_Order_By>>;
  where?: InputMaybe<V_Organice_Event_Raumbuchung_Bool_Exp>;
};


/** columns and relationships of "V_ORGANICE_EVENT_STAMM" */
export type V_Organice_Event_StammRaumbuchung_AggregateArgs = {
  distinct_on?: InputMaybe<Array<V_Organice_Event_Raumbuchung_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<V_Organice_Event_Raumbuchung_Order_By>>;
  where?: InputMaybe<V_Organice_Event_Raumbuchung_Bool_Exp>;
};

/** aggregated selection of "V_ORGANICE_EVENT_STAMM" */
export type V_Organice_Event_Stamm_Aggregate = {
  __typename?: 'V_ORGANICE_EVENT_STAMM_aggregate';
  aggregate?: Maybe<V_Organice_Event_Stamm_Aggregate_Fields>;
  nodes: Array<V_Organice_Event_Stamm>;
};

/** aggregate fields of "V_ORGANICE_EVENT_STAMM" */
export type V_Organice_Event_Stamm_Aggregate_Fields = {
  __typename?: 'V_ORGANICE_EVENT_STAMM_aggregate_fields';
  avg?: Maybe<V_Organice_Event_Stamm_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<V_Organice_Event_Stamm_Max_Fields>;
  min?: Maybe<V_Organice_Event_Stamm_Min_Fields>;
  stddev?: Maybe<V_Organice_Event_Stamm_Stddev_Fields>;
  stddev_pop?: Maybe<V_Organice_Event_Stamm_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<V_Organice_Event_Stamm_Stddev_Samp_Fields>;
  sum?: Maybe<V_Organice_Event_Stamm_Sum_Fields>;
  var_pop?: Maybe<V_Organice_Event_Stamm_Var_Pop_Fields>;
  var_samp?: Maybe<V_Organice_Event_Stamm_Var_Samp_Fields>;
  variance?: Maybe<V_Organice_Event_Stamm_Variance_Fields>;
};


/** aggregate fields of "V_ORGANICE_EVENT_STAMM" */
export type V_Organice_Event_Stamm_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<V_Organice_Event_Stamm_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type V_Organice_Event_Stamm_Avg_Fields = {
  __typename?: 'V_ORGANICE_EVENT_STAMM_avg_fields';
  Auslandsaussteller_Erwartet?: Maybe<Scalars['Float']['output']>;
  Auslandsaussteller_Ist?: Maybe<Scalars['Float']['output']>;
  Bruttoqm_Erwartet?: Maybe<Scalars['Float']['output']>;
  Bruttoqm_Ist?: Maybe<Scalars['Float']['output']>;
  Gruendungsjahr?: Maybe<Scalars['Float']['output']>;
  ID_Rubin?: Maybe<Scalars['Float']['output']>;
  ID_Salesforce?: Maybe<Scalars['Float']['output']>;
  Inlandsaussteller_Erwartet?: Maybe<Scalars['Float']['output']>;
  Inlandsaussteller_Ist?: Maybe<Scalars['Float']['output']>;
  Nettoqm_Erwartet?: Maybe<Scalars['Float']['output']>;
  Nettoqm_Ist?: Maybe<Scalars['Float']['output']>;
  T_DTS_Create?: Maybe<Scalars['Float']['output']>;
  T_DTS_Update?: Maybe<Scalars['Float']['output']>;
  T_Deleted?: Maybe<Scalars['Float']['output']>;
  T_Locked?: Maybe<Scalars['Float']['output']>;
  Vertragsnummer?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "V_ORGANICE_EVENT_STAMM". All fields are combined with a logical 'AND'. */
export type V_Organice_Event_Stamm_Bool_Exp = {
  Auslandsaussteller_Erwartet?: InputMaybe<Numeric_Comparison_Exp>;
  Auslandsaussteller_Ist?: InputMaybe<Numeric_Comparison_Exp>;
  Bruttoqm_Erwartet?: InputMaybe<Numeric_Comparison_Exp>;
  Bruttoqm_Ist?: InputMaybe<Numeric_Comparison_Exp>;
  DIP_ID_Event?: InputMaybe<String_Comparison_Exp>;
  Einlassuhrzeit?: InputMaybe<Bpchar_Comparison_Exp>;
  Enddatum?: InputMaybe<Date_Comparison_Exp>;
  Enduhrzeit?: InputMaybe<Bpchar_Comparison_Exp>;
  Erfasst_Am?: InputMaybe<Date_Comparison_Exp>;
  Erfasst_Von?: InputMaybe<String_Comparison_Exp>;
  Geaendert_Am?: InputMaybe<Date_Comparison_Exp>;
  Geaendert_Von?: InputMaybe<String_Comparison_Exp>;
  Gruendungsjahr?: InputMaybe<Numeric_Comparison_Exp>;
  ID_Rubin?: InputMaybe<Numeric_Comparison_Exp>;
  ID_Salesforce?: InputMaybe<Int_Comparison_Exp>;
  Inlandsaussteller_Erwartet?: InputMaybe<Numeric_Comparison_Exp>;
  Inlandsaussteller_Ist?: InputMaybe<Numeric_Comparison_Exp>;
  Internetadresse?: InputMaybe<String_Comparison_Exp>;
  Kongressveranstaltung?: InputMaybe<String_Comparison_Exp>;
  Kostentraeger_Bez?: InputMaybe<String_Comparison_Exp>;
  Kostentraeger_IDK?: InputMaybe<String_Comparison_Exp>;
  Kurztitel?: InputMaybe<String_Comparison_Exp>;
  Mandant?: InputMaybe<String_Comparison_Exp>;
  Messeveranstaltung?: InputMaybe<String_Comparison_Exp>;
  Nettoqm_Erwartet?: InputMaybe<Numeric_Comparison_Exp>;
  Nettoqm_Ist?: InputMaybe<Numeric_Comparison_Exp>;
  Oeffentliche_Veranstaltung?: InputMaybe<String_Comparison_Exp>;
  Projektverantwortlicher_Bez?: InputMaybe<String_Comparison_Exp>;
  Projektverantwortlicher_IDK?: InputMaybe<String_Comparison_Exp>;
  Protokollveranstaltung?: InputMaybe<String_Comparison_Exp>;
  RAUMBUCHUNG?: InputMaybe<V_Organice_Event_Raumbuchung_Bool_Exp>;
  RAUMBUCHUNG_aggregate?: InputMaybe<V_Organice_Event_Raumbuchung_Aggregate_Bool_Exp>;
  Rechnungsverantwortlicher_Bez?: InputMaybe<String_Comparison_Exp>;
  Rechnungsverantwortlicher_IDK?: InputMaybe<String_Comparison_Exp>;
  Startdatum?: InputMaybe<Date_Comparison_Exp>;
  Startuhrzeit?: InputMaybe<Bpchar_Comparison_Exp>;
  Status_IDK?: InputMaybe<String_Comparison_Exp>;
  Storno_am?: InputMaybe<Date_Comparison_Exp>;
  T_DTS_Create?: InputMaybe<Bigint_Comparison_Exp>;
  T_DTS_Update?: InputMaybe<Bigint_Comparison_Exp>;
  T_Deleted?: InputMaybe<Int_Comparison_Exp>;
  T_HASH_Event?: InputMaybe<Bpchar_Comparison_Exp>;
  T_Locked?: InputMaybe<Int_Comparison_Exp>;
  T_Mandant?: InputMaybe<String_Comparison_Exp>;
  Technikverantwortlicher_Bez?: InputMaybe<String_Comparison_Exp>;
  Technikverantwortlicher_IDK?: InputMaybe<String_Comparison_Exp>;
  Titel?: InputMaybe<String_Comparison_Exp>;
  VG_Art?: InputMaybe<String_Comparison_Exp>;
  VG_Typ?: InputMaybe<String_Comparison_Exp>;
  Veranstaltung_IDK?: InputMaybe<String_Comparison_Exp>;
  Vertragsnummer?: InputMaybe<Numeric_Comparison_Exp>;
  Zugriff_Bez?: InputMaybe<String_Comparison_Exp>;
  Zugriff_IDK?: InputMaybe<String_Comparison_Exp>;
  _and?: InputMaybe<Array<V_Organice_Event_Stamm_Bool_Exp>>;
  _not?: InputMaybe<V_Organice_Event_Stamm_Bool_Exp>;
  _or?: InputMaybe<Array<V_Organice_Event_Stamm_Bool_Exp>>;
};

/** aggregate max on columns */
export type V_Organice_Event_Stamm_Max_Fields = {
  __typename?: 'V_ORGANICE_EVENT_STAMM_max_fields';
  Auslandsaussteller_Erwartet?: Maybe<Scalars['numeric']['output']>;
  Auslandsaussteller_Ist?: Maybe<Scalars['numeric']['output']>;
  Bruttoqm_Erwartet?: Maybe<Scalars['numeric']['output']>;
  Bruttoqm_Ist?: Maybe<Scalars['numeric']['output']>;
  DIP_ID_Event?: Maybe<Scalars['String']['output']>;
  Einlassuhrzeit?: Maybe<Scalars['bpchar']['output']>;
  Enddatum?: Maybe<Scalars['date']['output']>;
  Enduhrzeit?: Maybe<Scalars['bpchar']['output']>;
  Erfasst_Am?: Maybe<Scalars['date']['output']>;
  Erfasst_Von?: Maybe<Scalars['String']['output']>;
  Geaendert_Am?: Maybe<Scalars['date']['output']>;
  Geaendert_Von?: Maybe<Scalars['String']['output']>;
  Gruendungsjahr?: Maybe<Scalars['numeric']['output']>;
  ID_Rubin?: Maybe<Scalars['numeric']['output']>;
  ID_Salesforce?: Maybe<Scalars['Int']['output']>;
  Inlandsaussteller_Erwartet?: Maybe<Scalars['numeric']['output']>;
  Inlandsaussteller_Ist?: Maybe<Scalars['numeric']['output']>;
  Internetadresse?: Maybe<Scalars['String']['output']>;
  Kongressveranstaltung?: Maybe<Scalars['String']['output']>;
  Kostentraeger_Bez?: Maybe<Scalars['String']['output']>;
  Kostentraeger_IDK?: Maybe<Scalars['String']['output']>;
  Kurztitel?: Maybe<Scalars['String']['output']>;
  Mandant?: Maybe<Scalars['String']['output']>;
  Messeveranstaltung?: Maybe<Scalars['String']['output']>;
  Nettoqm_Erwartet?: Maybe<Scalars['numeric']['output']>;
  Nettoqm_Ist?: Maybe<Scalars['numeric']['output']>;
  Oeffentliche_Veranstaltung?: Maybe<Scalars['String']['output']>;
  Projektverantwortlicher_Bez?: Maybe<Scalars['String']['output']>;
  Projektverantwortlicher_IDK?: Maybe<Scalars['String']['output']>;
  Protokollveranstaltung?: Maybe<Scalars['String']['output']>;
  Rechnungsverantwortlicher_Bez?: Maybe<Scalars['String']['output']>;
  Rechnungsverantwortlicher_IDK?: Maybe<Scalars['String']['output']>;
  Startdatum?: Maybe<Scalars['date']['output']>;
  Startuhrzeit?: Maybe<Scalars['bpchar']['output']>;
  Status_IDK?: Maybe<Scalars['String']['output']>;
  Storno_am?: Maybe<Scalars['date']['output']>;
  T_DTS_Create?: Maybe<Scalars['bigint']['output']>;
  T_DTS_Update?: Maybe<Scalars['bigint']['output']>;
  T_Deleted?: Maybe<Scalars['Int']['output']>;
  T_HASH_Event?: Maybe<Scalars['bpchar']['output']>;
  T_Locked?: Maybe<Scalars['Int']['output']>;
  T_Mandant?: Maybe<Scalars['String']['output']>;
  Technikverantwortlicher_Bez?: Maybe<Scalars['String']['output']>;
  Technikverantwortlicher_IDK?: Maybe<Scalars['String']['output']>;
  Titel?: Maybe<Scalars['String']['output']>;
  VG_Art?: Maybe<Scalars['String']['output']>;
  VG_Typ?: Maybe<Scalars['String']['output']>;
  Veranstaltung_IDK?: Maybe<Scalars['String']['output']>;
  Vertragsnummer?: Maybe<Scalars['numeric']['output']>;
  Zugriff_Bez?: Maybe<Scalars['String']['output']>;
  Zugriff_IDK?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type V_Organice_Event_Stamm_Min_Fields = {
  __typename?: 'V_ORGANICE_EVENT_STAMM_min_fields';
  Auslandsaussteller_Erwartet?: Maybe<Scalars['numeric']['output']>;
  Auslandsaussteller_Ist?: Maybe<Scalars['numeric']['output']>;
  Bruttoqm_Erwartet?: Maybe<Scalars['numeric']['output']>;
  Bruttoqm_Ist?: Maybe<Scalars['numeric']['output']>;
  DIP_ID_Event?: Maybe<Scalars['String']['output']>;
  Einlassuhrzeit?: Maybe<Scalars['bpchar']['output']>;
  Enddatum?: Maybe<Scalars['date']['output']>;
  Enduhrzeit?: Maybe<Scalars['bpchar']['output']>;
  Erfasst_Am?: Maybe<Scalars['date']['output']>;
  Erfasst_Von?: Maybe<Scalars['String']['output']>;
  Geaendert_Am?: Maybe<Scalars['date']['output']>;
  Geaendert_Von?: Maybe<Scalars['String']['output']>;
  Gruendungsjahr?: Maybe<Scalars['numeric']['output']>;
  ID_Rubin?: Maybe<Scalars['numeric']['output']>;
  ID_Salesforce?: Maybe<Scalars['Int']['output']>;
  Inlandsaussteller_Erwartet?: Maybe<Scalars['numeric']['output']>;
  Inlandsaussteller_Ist?: Maybe<Scalars['numeric']['output']>;
  Internetadresse?: Maybe<Scalars['String']['output']>;
  Kongressveranstaltung?: Maybe<Scalars['String']['output']>;
  Kostentraeger_Bez?: Maybe<Scalars['String']['output']>;
  Kostentraeger_IDK?: Maybe<Scalars['String']['output']>;
  Kurztitel?: Maybe<Scalars['String']['output']>;
  Mandant?: Maybe<Scalars['String']['output']>;
  Messeveranstaltung?: Maybe<Scalars['String']['output']>;
  Nettoqm_Erwartet?: Maybe<Scalars['numeric']['output']>;
  Nettoqm_Ist?: Maybe<Scalars['numeric']['output']>;
  Oeffentliche_Veranstaltung?: Maybe<Scalars['String']['output']>;
  Projektverantwortlicher_Bez?: Maybe<Scalars['String']['output']>;
  Projektverantwortlicher_IDK?: Maybe<Scalars['String']['output']>;
  Protokollveranstaltung?: Maybe<Scalars['String']['output']>;
  Rechnungsverantwortlicher_Bez?: Maybe<Scalars['String']['output']>;
  Rechnungsverantwortlicher_IDK?: Maybe<Scalars['String']['output']>;
  Startdatum?: Maybe<Scalars['date']['output']>;
  Startuhrzeit?: Maybe<Scalars['bpchar']['output']>;
  Status_IDK?: Maybe<Scalars['String']['output']>;
  Storno_am?: Maybe<Scalars['date']['output']>;
  T_DTS_Create?: Maybe<Scalars['bigint']['output']>;
  T_DTS_Update?: Maybe<Scalars['bigint']['output']>;
  T_Deleted?: Maybe<Scalars['Int']['output']>;
  T_HASH_Event?: Maybe<Scalars['bpchar']['output']>;
  T_Locked?: Maybe<Scalars['Int']['output']>;
  T_Mandant?: Maybe<Scalars['String']['output']>;
  Technikverantwortlicher_Bez?: Maybe<Scalars['String']['output']>;
  Technikverantwortlicher_IDK?: Maybe<Scalars['String']['output']>;
  Titel?: Maybe<Scalars['String']['output']>;
  VG_Art?: Maybe<Scalars['String']['output']>;
  VG_Typ?: Maybe<Scalars['String']['output']>;
  Veranstaltung_IDK?: Maybe<Scalars['String']['output']>;
  Vertragsnummer?: Maybe<Scalars['numeric']['output']>;
  Zugriff_Bez?: Maybe<Scalars['String']['output']>;
  Zugriff_IDK?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "V_ORGANICE_EVENT_STAMM". */
export type V_Organice_Event_Stamm_Order_By = {
  Auslandsaussteller_Erwartet?: InputMaybe<Order_By>;
  Auslandsaussteller_Ist?: InputMaybe<Order_By>;
  Bruttoqm_Erwartet?: InputMaybe<Order_By>;
  Bruttoqm_Ist?: InputMaybe<Order_By>;
  DIP_ID_Event?: InputMaybe<Order_By>;
  Einlassuhrzeit?: InputMaybe<Order_By>;
  Enddatum?: InputMaybe<Order_By>;
  Enduhrzeit?: InputMaybe<Order_By>;
  Erfasst_Am?: InputMaybe<Order_By>;
  Erfasst_Von?: InputMaybe<Order_By>;
  Geaendert_Am?: InputMaybe<Order_By>;
  Geaendert_Von?: InputMaybe<Order_By>;
  Gruendungsjahr?: InputMaybe<Order_By>;
  ID_Rubin?: InputMaybe<Order_By>;
  ID_Salesforce?: InputMaybe<Order_By>;
  Inlandsaussteller_Erwartet?: InputMaybe<Order_By>;
  Inlandsaussteller_Ist?: InputMaybe<Order_By>;
  Internetadresse?: InputMaybe<Order_By>;
  Kongressveranstaltung?: InputMaybe<Order_By>;
  Kostentraeger_Bez?: InputMaybe<Order_By>;
  Kostentraeger_IDK?: InputMaybe<Order_By>;
  Kurztitel?: InputMaybe<Order_By>;
  Mandant?: InputMaybe<Order_By>;
  Messeveranstaltung?: InputMaybe<Order_By>;
  Nettoqm_Erwartet?: InputMaybe<Order_By>;
  Nettoqm_Ist?: InputMaybe<Order_By>;
  Oeffentliche_Veranstaltung?: InputMaybe<Order_By>;
  Projektverantwortlicher_Bez?: InputMaybe<Order_By>;
  Projektverantwortlicher_IDK?: InputMaybe<Order_By>;
  Protokollveranstaltung?: InputMaybe<Order_By>;
  RAUMBUCHUNG_aggregate?: InputMaybe<V_Organice_Event_Raumbuchung_Aggregate_Order_By>;
  Rechnungsverantwortlicher_Bez?: InputMaybe<Order_By>;
  Rechnungsverantwortlicher_IDK?: InputMaybe<Order_By>;
  Startdatum?: InputMaybe<Order_By>;
  Startuhrzeit?: InputMaybe<Order_By>;
  Status_IDK?: InputMaybe<Order_By>;
  Storno_am?: InputMaybe<Order_By>;
  T_DTS_Create?: InputMaybe<Order_By>;
  T_DTS_Update?: InputMaybe<Order_By>;
  T_Deleted?: InputMaybe<Order_By>;
  T_HASH_Event?: InputMaybe<Order_By>;
  T_Locked?: InputMaybe<Order_By>;
  T_Mandant?: InputMaybe<Order_By>;
  Technikverantwortlicher_Bez?: InputMaybe<Order_By>;
  Technikverantwortlicher_IDK?: InputMaybe<Order_By>;
  Titel?: InputMaybe<Order_By>;
  VG_Art?: InputMaybe<Order_By>;
  VG_Typ?: InputMaybe<Order_By>;
  Veranstaltung_IDK?: InputMaybe<Order_By>;
  Vertragsnummer?: InputMaybe<Order_By>;
  Zugriff_Bez?: InputMaybe<Order_By>;
  Zugriff_IDK?: InputMaybe<Order_By>;
};

/** select columns of table "V_ORGANICE_EVENT_STAMM" */
export enum V_Organice_Event_Stamm_Select_Column {
  /** column name */
  AuslandsausstellerErwartet = 'Auslandsaussteller_Erwartet',
  /** column name */
  AuslandsausstellerIst = 'Auslandsaussteller_Ist',
  /** column name */
  BruttoqmErwartet = 'Bruttoqm_Erwartet',
  /** column name */
  BruttoqmIst = 'Bruttoqm_Ist',
  /** column name */
  DIPIDEvent = 'DIP_ID_Event',
  /** column name */
  Einlassuhrzeit = 'Einlassuhrzeit',
  /** column name */
  Enddatum = 'Enddatum',
  /** column name */
  Enduhrzeit = 'Enduhrzeit',
  /** column name */
  ErfasstAm = 'Erfasst_Am',
  /** column name */
  ErfasstVon = 'Erfasst_Von',
  /** column name */
  GeaendertAm = 'Geaendert_Am',
  /** column name */
  GeaendertVon = 'Geaendert_Von',
  /** column name */
  Gruendungsjahr = 'Gruendungsjahr',
  /** column name */
  IDRubin = 'ID_Rubin',
  /** column name */
  IDSalesforce = 'ID_Salesforce',
  /** column name */
  InlandsausstellerErwartet = 'Inlandsaussteller_Erwartet',
  /** column name */
  InlandsausstellerIst = 'Inlandsaussteller_Ist',
  /** column name */
  Internetadresse = 'Internetadresse',
  /** column name */
  Kongressveranstaltung = 'Kongressveranstaltung',
  /** column name */
  KostentraegerBez = 'Kostentraeger_Bez',
  /** column name */
  KostentraegerIDK = 'Kostentraeger_IDK',
  /** column name */
  Kurztitel = 'Kurztitel',
  /** column name */
  Mandant = 'Mandant',
  /** column name */
  Messeveranstaltung = 'Messeveranstaltung',
  /** column name */
  NettoqmErwartet = 'Nettoqm_Erwartet',
  /** column name */
  NettoqmIst = 'Nettoqm_Ist',
  /** column name */
  OeffentlicheVeranstaltung = 'Oeffentliche_Veranstaltung',
  /** column name */
  ProjektverantwortlicherBez = 'Projektverantwortlicher_Bez',
  /** column name */
  ProjektverantwortlicherIDK = 'Projektverantwortlicher_IDK',
  /** column name */
  Protokollveranstaltung = 'Protokollveranstaltung',
  /** column name */
  RechnungsverantwortlicherBez = 'Rechnungsverantwortlicher_Bez',
  /** column name */
  RechnungsverantwortlicherIDK = 'Rechnungsverantwortlicher_IDK',
  /** column name */
  Startdatum = 'Startdatum',
  /** column name */
  Startuhrzeit = 'Startuhrzeit',
  /** column name */
  StatusIDK = 'Status_IDK',
  /** column name */
  StornoAm = 'Storno_am',
  /** column name */
  TDTSCreate = 'T_DTS_Create',
  /** column name */
  TDTSUpdate = 'T_DTS_Update',
  /** column name */
  TDeleted = 'T_Deleted',
  /** column name */
  THASHEvent = 'T_HASH_Event',
  /** column name */
  TLocked = 'T_Locked',
  /** column name */
  TMandant = 'T_Mandant',
  /** column name */
  TechnikverantwortlicherBez = 'Technikverantwortlicher_Bez',
  /** column name */
  TechnikverantwortlicherIDK = 'Technikverantwortlicher_IDK',
  /** column name */
  Titel = 'Titel',
  /** column name */
  VGArt = 'VG_Art',
  /** column name */
  VGTyp = 'VG_Typ',
  /** column name */
  VeranstaltungIDK = 'Veranstaltung_IDK',
  /** column name */
  Vertragsnummer = 'Vertragsnummer',
  /** column name */
  ZugriffBez = 'Zugriff_Bez',
  /** column name */
  ZugriffIDK = 'Zugriff_IDK'
}

/** aggregate stddev on columns */
export type V_Organice_Event_Stamm_Stddev_Fields = {
  __typename?: 'V_ORGANICE_EVENT_STAMM_stddev_fields';
  Auslandsaussteller_Erwartet?: Maybe<Scalars['Float']['output']>;
  Auslandsaussteller_Ist?: Maybe<Scalars['Float']['output']>;
  Bruttoqm_Erwartet?: Maybe<Scalars['Float']['output']>;
  Bruttoqm_Ist?: Maybe<Scalars['Float']['output']>;
  Gruendungsjahr?: Maybe<Scalars['Float']['output']>;
  ID_Rubin?: Maybe<Scalars['Float']['output']>;
  ID_Salesforce?: Maybe<Scalars['Float']['output']>;
  Inlandsaussteller_Erwartet?: Maybe<Scalars['Float']['output']>;
  Inlandsaussteller_Ist?: Maybe<Scalars['Float']['output']>;
  Nettoqm_Erwartet?: Maybe<Scalars['Float']['output']>;
  Nettoqm_Ist?: Maybe<Scalars['Float']['output']>;
  T_DTS_Create?: Maybe<Scalars['Float']['output']>;
  T_DTS_Update?: Maybe<Scalars['Float']['output']>;
  T_Deleted?: Maybe<Scalars['Float']['output']>;
  T_Locked?: Maybe<Scalars['Float']['output']>;
  Vertragsnummer?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type V_Organice_Event_Stamm_Stddev_Pop_Fields = {
  __typename?: 'V_ORGANICE_EVENT_STAMM_stddev_pop_fields';
  Auslandsaussteller_Erwartet?: Maybe<Scalars['Float']['output']>;
  Auslandsaussteller_Ist?: Maybe<Scalars['Float']['output']>;
  Bruttoqm_Erwartet?: Maybe<Scalars['Float']['output']>;
  Bruttoqm_Ist?: Maybe<Scalars['Float']['output']>;
  Gruendungsjahr?: Maybe<Scalars['Float']['output']>;
  ID_Rubin?: Maybe<Scalars['Float']['output']>;
  ID_Salesforce?: Maybe<Scalars['Float']['output']>;
  Inlandsaussteller_Erwartet?: Maybe<Scalars['Float']['output']>;
  Inlandsaussteller_Ist?: Maybe<Scalars['Float']['output']>;
  Nettoqm_Erwartet?: Maybe<Scalars['Float']['output']>;
  Nettoqm_Ist?: Maybe<Scalars['Float']['output']>;
  T_DTS_Create?: Maybe<Scalars['Float']['output']>;
  T_DTS_Update?: Maybe<Scalars['Float']['output']>;
  T_Deleted?: Maybe<Scalars['Float']['output']>;
  T_Locked?: Maybe<Scalars['Float']['output']>;
  Vertragsnummer?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type V_Organice_Event_Stamm_Stddev_Samp_Fields = {
  __typename?: 'V_ORGANICE_EVENT_STAMM_stddev_samp_fields';
  Auslandsaussteller_Erwartet?: Maybe<Scalars['Float']['output']>;
  Auslandsaussteller_Ist?: Maybe<Scalars['Float']['output']>;
  Bruttoqm_Erwartet?: Maybe<Scalars['Float']['output']>;
  Bruttoqm_Ist?: Maybe<Scalars['Float']['output']>;
  Gruendungsjahr?: Maybe<Scalars['Float']['output']>;
  ID_Rubin?: Maybe<Scalars['Float']['output']>;
  ID_Salesforce?: Maybe<Scalars['Float']['output']>;
  Inlandsaussteller_Erwartet?: Maybe<Scalars['Float']['output']>;
  Inlandsaussteller_Ist?: Maybe<Scalars['Float']['output']>;
  Nettoqm_Erwartet?: Maybe<Scalars['Float']['output']>;
  Nettoqm_Ist?: Maybe<Scalars['Float']['output']>;
  T_DTS_Create?: Maybe<Scalars['Float']['output']>;
  T_DTS_Update?: Maybe<Scalars['Float']['output']>;
  T_Deleted?: Maybe<Scalars['Float']['output']>;
  T_Locked?: Maybe<Scalars['Float']['output']>;
  Vertragsnummer?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "V_ORGANICE_EVENT_STAMM" */
export type V_Organice_Event_Stamm_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: V_Organice_Event_Stamm_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type V_Organice_Event_Stamm_Stream_Cursor_Value_Input = {
  Auslandsaussteller_Erwartet?: InputMaybe<Scalars['numeric']['input']>;
  Auslandsaussteller_Ist?: InputMaybe<Scalars['numeric']['input']>;
  Bruttoqm_Erwartet?: InputMaybe<Scalars['numeric']['input']>;
  Bruttoqm_Ist?: InputMaybe<Scalars['numeric']['input']>;
  DIP_ID_Event?: InputMaybe<Scalars['String']['input']>;
  Einlassuhrzeit?: InputMaybe<Scalars['bpchar']['input']>;
  Enddatum?: InputMaybe<Scalars['date']['input']>;
  Enduhrzeit?: InputMaybe<Scalars['bpchar']['input']>;
  Erfasst_Am?: InputMaybe<Scalars['date']['input']>;
  Erfasst_Von?: InputMaybe<Scalars['String']['input']>;
  Geaendert_Am?: InputMaybe<Scalars['date']['input']>;
  Geaendert_Von?: InputMaybe<Scalars['String']['input']>;
  Gruendungsjahr?: InputMaybe<Scalars['numeric']['input']>;
  ID_Rubin?: InputMaybe<Scalars['numeric']['input']>;
  ID_Salesforce?: InputMaybe<Scalars['Int']['input']>;
  Inlandsaussteller_Erwartet?: InputMaybe<Scalars['numeric']['input']>;
  Inlandsaussteller_Ist?: InputMaybe<Scalars['numeric']['input']>;
  Internetadresse?: InputMaybe<Scalars['String']['input']>;
  Kongressveranstaltung?: InputMaybe<Scalars['String']['input']>;
  Kostentraeger_Bez?: InputMaybe<Scalars['String']['input']>;
  Kostentraeger_IDK?: InputMaybe<Scalars['String']['input']>;
  Kurztitel?: InputMaybe<Scalars['String']['input']>;
  Mandant?: InputMaybe<Scalars['String']['input']>;
  Messeveranstaltung?: InputMaybe<Scalars['String']['input']>;
  Nettoqm_Erwartet?: InputMaybe<Scalars['numeric']['input']>;
  Nettoqm_Ist?: InputMaybe<Scalars['numeric']['input']>;
  Oeffentliche_Veranstaltung?: InputMaybe<Scalars['String']['input']>;
  Projektverantwortlicher_Bez?: InputMaybe<Scalars['String']['input']>;
  Projektverantwortlicher_IDK?: InputMaybe<Scalars['String']['input']>;
  Protokollveranstaltung?: InputMaybe<Scalars['String']['input']>;
  Rechnungsverantwortlicher_Bez?: InputMaybe<Scalars['String']['input']>;
  Rechnungsverantwortlicher_IDK?: InputMaybe<Scalars['String']['input']>;
  Startdatum?: InputMaybe<Scalars['date']['input']>;
  Startuhrzeit?: InputMaybe<Scalars['bpchar']['input']>;
  Status_IDK?: InputMaybe<Scalars['String']['input']>;
  Storno_am?: InputMaybe<Scalars['date']['input']>;
  T_DTS_Create?: InputMaybe<Scalars['bigint']['input']>;
  T_DTS_Update?: InputMaybe<Scalars['bigint']['input']>;
  T_Deleted?: InputMaybe<Scalars['Int']['input']>;
  T_HASH_Event?: InputMaybe<Scalars['bpchar']['input']>;
  T_Locked?: InputMaybe<Scalars['Int']['input']>;
  T_Mandant?: InputMaybe<Scalars['String']['input']>;
  Technikverantwortlicher_Bez?: InputMaybe<Scalars['String']['input']>;
  Technikverantwortlicher_IDK?: InputMaybe<Scalars['String']['input']>;
  Titel?: InputMaybe<Scalars['String']['input']>;
  VG_Art?: InputMaybe<Scalars['String']['input']>;
  VG_Typ?: InputMaybe<Scalars['String']['input']>;
  Veranstaltung_IDK?: InputMaybe<Scalars['String']['input']>;
  Vertragsnummer?: InputMaybe<Scalars['numeric']['input']>;
  Zugriff_Bez?: InputMaybe<Scalars['String']['input']>;
  Zugriff_IDK?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type V_Organice_Event_Stamm_Sum_Fields = {
  __typename?: 'V_ORGANICE_EVENT_STAMM_sum_fields';
  Auslandsaussteller_Erwartet?: Maybe<Scalars['numeric']['output']>;
  Auslandsaussteller_Ist?: Maybe<Scalars['numeric']['output']>;
  Bruttoqm_Erwartet?: Maybe<Scalars['numeric']['output']>;
  Bruttoqm_Ist?: Maybe<Scalars['numeric']['output']>;
  Gruendungsjahr?: Maybe<Scalars['numeric']['output']>;
  ID_Rubin?: Maybe<Scalars['numeric']['output']>;
  ID_Salesforce?: Maybe<Scalars['Int']['output']>;
  Inlandsaussteller_Erwartet?: Maybe<Scalars['numeric']['output']>;
  Inlandsaussteller_Ist?: Maybe<Scalars['numeric']['output']>;
  Nettoqm_Erwartet?: Maybe<Scalars['numeric']['output']>;
  Nettoqm_Ist?: Maybe<Scalars['numeric']['output']>;
  T_DTS_Create?: Maybe<Scalars['bigint']['output']>;
  T_DTS_Update?: Maybe<Scalars['bigint']['output']>;
  T_Deleted?: Maybe<Scalars['Int']['output']>;
  T_Locked?: Maybe<Scalars['Int']['output']>;
  Vertragsnummer?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type V_Organice_Event_Stamm_Var_Pop_Fields = {
  __typename?: 'V_ORGANICE_EVENT_STAMM_var_pop_fields';
  Auslandsaussteller_Erwartet?: Maybe<Scalars['Float']['output']>;
  Auslandsaussteller_Ist?: Maybe<Scalars['Float']['output']>;
  Bruttoqm_Erwartet?: Maybe<Scalars['Float']['output']>;
  Bruttoqm_Ist?: Maybe<Scalars['Float']['output']>;
  Gruendungsjahr?: Maybe<Scalars['Float']['output']>;
  ID_Rubin?: Maybe<Scalars['Float']['output']>;
  ID_Salesforce?: Maybe<Scalars['Float']['output']>;
  Inlandsaussteller_Erwartet?: Maybe<Scalars['Float']['output']>;
  Inlandsaussteller_Ist?: Maybe<Scalars['Float']['output']>;
  Nettoqm_Erwartet?: Maybe<Scalars['Float']['output']>;
  Nettoqm_Ist?: Maybe<Scalars['Float']['output']>;
  T_DTS_Create?: Maybe<Scalars['Float']['output']>;
  T_DTS_Update?: Maybe<Scalars['Float']['output']>;
  T_Deleted?: Maybe<Scalars['Float']['output']>;
  T_Locked?: Maybe<Scalars['Float']['output']>;
  Vertragsnummer?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type V_Organice_Event_Stamm_Var_Samp_Fields = {
  __typename?: 'V_ORGANICE_EVENT_STAMM_var_samp_fields';
  Auslandsaussteller_Erwartet?: Maybe<Scalars['Float']['output']>;
  Auslandsaussteller_Ist?: Maybe<Scalars['Float']['output']>;
  Bruttoqm_Erwartet?: Maybe<Scalars['Float']['output']>;
  Bruttoqm_Ist?: Maybe<Scalars['Float']['output']>;
  Gruendungsjahr?: Maybe<Scalars['Float']['output']>;
  ID_Rubin?: Maybe<Scalars['Float']['output']>;
  ID_Salesforce?: Maybe<Scalars['Float']['output']>;
  Inlandsaussteller_Erwartet?: Maybe<Scalars['Float']['output']>;
  Inlandsaussteller_Ist?: Maybe<Scalars['Float']['output']>;
  Nettoqm_Erwartet?: Maybe<Scalars['Float']['output']>;
  Nettoqm_Ist?: Maybe<Scalars['Float']['output']>;
  T_DTS_Create?: Maybe<Scalars['Float']['output']>;
  T_DTS_Update?: Maybe<Scalars['Float']['output']>;
  T_Deleted?: Maybe<Scalars['Float']['output']>;
  T_Locked?: Maybe<Scalars['Float']['output']>;
  Vertragsnummer?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type V_Organice_Event_Stamm_Variance_Fields = {
  __typename?: 'V_ORGANICE_EVENT_STAMM_variance_fields';
  Auslandsaussteller_Erwartet?: Maybe<Scalars['Float']['output']>;
  Auslandsaussteller_Ist?: Maybe<Scalars['Float']['output']>;
  Bruttoqm_Erwartet?: Maybe<Scalars['Float']['output']>;
  Bruttoqm_Ist?: Maybe<Scalars['Float']['output']>;
  Gruendungsjahr?: Maybe<Scalars['Float']['output']>;
  ID_Rubin?: Maybe<Scalars['Float']['output']>;
  ID_Salesforce?: Maybe<Scalars['Float']['output']>;
  Inlandsaussteller_Erwartet?: Maybe<Scalars['Float']['output']>;
  Inlandsaussteller_Ist?: Maybe<Scalars['Float']['output']>;
  Nettoqm_Erwartet?: Maybe<Scalars['Float']['output']>;
  Nettoqm_Ist?: Maybe<Scalars['Float']['output']>;
  T_DTS_Create?: Maybe<Scalars['Float']['output']>;
  T_DTS_Update?: Maybe<Scalars['Float']['output']>;
  T_Deleted?: Maybe<Scalars['Float']['output']>;
  T_Locked?: Maybe<Scalars['Float']['output']>;
  Vertragsnummer?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "allUsers" */
export type AllUsers = {
  __typename?: 'allUsers';
  /** A computed field, executes function "allUsers_attributes" */
  attributes?: Maybe<Scalars['json']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "allUsers_isDisabled" */
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organisation?: Maybe<Organisations>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "allUsers_publicEmail" */
  publicEmail?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "allUsers" */
export type AllUsersAttributesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "allUsers" */
export type AllUsers_Aggregate = {
  __typename?: 'allUsers_aggregate';
  aggregate?: Maybe<AllUsers_Aggregate_Fields>;
  nodes: Array<AllUsers>;
};

/** aggregate fields of "allUsers" */
export type AllUsers_Aggregate_Fields = {
  __typename?: 'allUsers_aggregate_fields';
  avg?: Maybe<AllUsers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AllUsers_Max_Fields>;
  min?: Maybe<AllUsers_Min_Fields>;
  stddev?: Maybe<AllUsers_Stddev_Fields>;
  stddev_pop?: Maybe<AllUsers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AllUsers_Stddev_Samp_Fields>;
  sum?: Maybe<AllUsers_Sum_Fields>;
  var_pop?: Maybe<AllUsers_Var_Pop_Fields>;
  var_samp?: Maybe<AllUsers_Var_Samp_Fields>;
  variance?: Maybe<AllUsers_Variance_Fields>;
};


/** aggregate fields of "allUsers" */
export type AllUsers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AllUsers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type AllUsers_Avg_Fields = {
  __typename?: 'allUsers_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "allUsers". All fields are combined with a logical 'AND'. */
export type AllUsers_Bool_Exp = {
  _and?: InputMaybe<Array<AllUsers_Bool_Exp>>;
  _not?: InputMaybe<AllUsers_Bool_Exp>;
  _or?: InputMaybe<Array<AllUsers_Bool_Exp>>;
  attributes?: InputMaybe<Json_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  isDisabled?: InputMaybe<Boolean_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisationId?: InputMaybe<Bigint_Comparison_Exp>;
  publicEmail?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type AllUsers_Max_Fields = {
  __typename?: 'allUsers_max_fields';
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "allUsers_publicEmail" */
  publicEmail?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AllUsers_Min_Fields = {
  __typename?: 'allUsers_min_fields';
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "allUsers_publicEmail" */
  publicEmail?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "allUsers". */
export type AllUsers_Order_By = {
  attributes?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDisabled?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisations_Order_By>;
  organisationId?: InputMaybe<Order_By>;
  publicEmail?: InputMaybe<Order_By>;
};

/** select columns of table "allUsers" */
export enum AllUsers_Select_Column {
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'lastName',
  /** column name */
  OrganisationId = 'organisationId'
}

/** aggregate stddev on columns */
export type AllUsers_Stddev_Fields = {
  __typename?: 'allUsers_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type AllUsers_Stddev_Pop_Fields = {
  __typename?: 'allUsers_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type AllUsers_Stddev_Samp_Fields = {
  __typename?: 'allUsers_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "allUsers" */
export type AllUsers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AllUsers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AllUsers_Stream_Cursor_Value_Input = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type AllUsers_Sum_Fields = {
  __typename?: 'allUsers_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type AllUsers_Var_Pop_Fields = {
  __typename?: 'allUsers_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type AllUsers_Var_Samp_Fields = {
  __typename?: 'allUsers_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type AllUsers_Variance_Fields = {
  __typename?: 'allUsers_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "articles" */
export type Articles = {
  __typename?: 'articles';
  articleType: Scalars['String']['output'];
  /** An array relationship */
  cartLines: Array<CartLines>;
  /** An aggregate relationship */
  cartLines_aggregate: CartLines_Aggregate;
  /** An array relationship */
  catalogFolderArticles: Array<CatalogFolderArticles>;
  /** An aggregate relationship */
  catalogFolderArticles_aggregate: CatalogFolderArticles_Aggregate;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  price: Scalars['bigint']['output'];
  raw: Scalars['json']['output'];
  tax?: Maybe<Scalars['Int']['output']>;
  unit: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "articles" */
export type ArticlesCartLinesArgs = {
  distinct_on?: InputMaybe<Array<CartLines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CartLines_Order_By>>;
  where?: InputMaybe<CartLines_Bool_Exp>;
};


/** columns and relationships of "articles" */
export type ArticlesCartLines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CartLines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CartLines_Order_By>>;
  where?: InputMaybe<CartLines_Bool_Exp>;
};


/** columns and relationships of "articles" */
export type ArticlesCatalogFolderArticlesArgs = {
  distinct_on?: InputMaybe<Array<CatalogFolderArticles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CatalogFolderArticles_Order_By>>;
  where?: InputMaybe<CatalogFolderArticles_Bool_Exp>;
};


/** columns and relationships of "articles" */
export type ArticlesCatalogFolderArticles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CatalogFolderArticles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CatalogFolderArticles_Order_By>>;
  where?: InputMaybe<CatalogFolderArticles_Bool_Exp>;
};


/** columns and relationships of "articles" */
export type ArticlesRawArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "articles" */
export type Articles_Aggregate = {
  __typename?: 'articles_aggregate';
  aggregate?: Maybe<Articles_Aggregate_Fields>;
  nodes: Array<Articles>;
};

/** aggregate fields of "articles" */
export type Articles_Aggregate_Fields = {
  __typename?: 'articles_aggregate_fields';
  avg?: Maybe<Articles_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Articles_Max_Fields>;
  min?: Maybe<Articles_Min_Fields>;
  stddev?: Maybe<Articles_Stddev_Fields>;
  stddev_pop?: Maybe<Articles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Articles_Stddev_Samp_Fields>;
  sum?: Maybe<Articles_Sum_Fields>;
  var_pop?: Maybe<Articles_Var_Pop_Fields>;
  var_samp?: Maybe<Articles_Var_Samp_Fields>;
  variance?: Maybe<Articles_Variance_Fields>;
};


/** aggregate fields of "articles" */
export type Articles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Articles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Articles_Avg_Fields = {
  __typename?: 'articles_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "articles". All fields are combined with a logical 'AND'. */
export type Articles_Bool_Exp = {
  _and?: InputMaybe<Array<Articles_Bool_Exp>>;
  _not?: InputMaybe<Articles_Bool_Exp>;
  _or?: InputMaybe<Array<Articles_Bool_Exp>>;
  articleType?: InputMaybe<String_Comparison_Exp>;
  cartLines?: InputMaybe<CartLines_Bool_Exp>;
  cartLines_aggregate?: InputMaybe<CartLines_Aggregate_Bool_Exp>;
  catalogFolderArticles?: InputMaybe<CatalogFolderArticles_Bool_Exp>;
  catalogFolderArticles_aggregate?: InputMaybe<CatalogFolderArticles_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  price?: InputMaybe<Bigint_Comparison_Exp>;
  raw?: InputMaybe<Json_Comparison_Exp>;
  tax?: InputMaybe<Int_Comparison_Exp>;
  unit?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "articles" */
export enum Articles_Constraint {
  /** unique or primary key constraint on columns "id" */
  ArticlesPkey = 'articles_pkey'
}

/** input type for incrementing numeric columns in table "articles" */
export type Articles_Inc_Input = {
  price?: InputMaybe<Scalars['bigint']['input']>;
  tax?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "articles" */
export type Articles_Insert_Input = {
  articleType?: InputMaybe<Scalars['String']['input']>;
  cartLines?: InputMaybe<CartLines_Arr_Rel_Insert_Input>;
  catalogFolderArticles?: InputMaybe<CatalogFolderArticles_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['bigint']['input']>;
  raw?: InputMaybe<Scalars['json']['input']>;
  tax?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Articles_Max_Fields = {
  __typename?: 'articles_max_fields';
  articleType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['bigint']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Articles_Min_Fields = {
  __typename?: 'articles_min_fields';
  articleType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['bigint']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "articles" */
export type Articles_Mutation_Response = {
  __typename?: 'articles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Articles>;
};

/** input type for inserting object relation for remote table "articles" */
export type Articles_Obj_Rel_Insert_Input = {
  data: Articles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Articles_On_Conflict>;
};

/** on_conflict condition type for table "articles" */
export type Articles_On_Conflict = {
  constraint: Articles_Constraint;
  update_columns?: Array<Articles_Update_Column>;
  where?: InputMaybe<Articles_Bool_Exp>;
};

/** Ordering options when selecting data from "articles". */
export type Articles_Order_By = {
  articleType?: InputMaybe<Order_By>;
  cartLines_aggregate?: InputMaybe<CartLines_Aggregate_Order_By>;
  catalogFolderArticles_aggregate?: InputMaybe<CatalogFolderArticles_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  raw?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  unit?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: articles */
export type Articles_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "articles" */
export enum Articles_Select_Column {
  /** column name */
  ArticleType = 'articleType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  Raw = 'raw',
  /** column name */
  Tax = 'tax',
  /** column name */
  Unit = 'unit',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "articles" */
export type Articles_Set_Input = {
  articleType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['bigint']['input']>;
  raw?: InputMaybe<Scalars['json']['input']>;
  tax?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Articles_Stddev_Fields = {
  __typename?: 'articles_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Articles_Stddev_Pop_Fields = {
  __typename?: 'articles_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Articles_Stddev_Samp_Fields = {
  __typename?: 'articles_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "articles" */
export type Articles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Articles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Articles_Stream_Cursor_Value_Input = {
  articleType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['bigint']['input']>;
  raw?: InputMaybe<Scalars['json']['input']>;
  tax?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Articles_Sum_Fields = {
  __typename?: 'articles_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  price?: Maybe<Scalars['bigint']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "articles" */
export enum Articles_Update_Column {
  /** column name */
  ArticleType = 'articleType',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  Raw = 'raw',
  /** column name */
  Tax = 'tax',
  /** column name */
  Unit = 'unit'
}

export type Articles_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Articles_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Articles_Set_Input>;
  /** filter the rows which have to be updated */
  where: Articles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Articles_Var_Pop_Fields = {
  __typename?: 'articles_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Articles_Var_Samp_Fields = {
  __typename?: 'articles_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Articles_Variance_Fields = {
  __typename?: 'articles_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "attributeFiles" */
export type AttributeFiles = {
  __typename?: 'attributeFiles';
  /** An object relationship */
  attribute: Attributes;
  attributeId: Scalars['bigint']['output'];
  /** A computed field, executes function "attributeFiles_downloadUrl" */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  file: Files;
  fileId: Scalars['bigint']['output'];
};

/** aggregated selection of "attributeFiles" */
export type AttributeFiles_Aggregate = {
  __typename?: 'attributeFiles_aggregate';
  aggregate?: Maybe<AttributeFiles_Aggregate_Fields>;
  nodes: Array<AttributeFiles>;
};

export type AttributeFiles_Aggregate_Bool_Exp = {
  count?: InputMaybe<AttributeFiles_Aggregate_Bool_Exp_Count>;
};

export type AttributeFiles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AttributeFiles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AttributeFiles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "attributeFiles" */
export type AttributeFiles_Aggregate_Fields = {
  __typename?: 'attributeFiles_aggregate_fields';
  avg?: Maybe<AttributeFiles_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AttributeFiles_Max_Fields>;
  min?: Maybe<AttributeFiles_Min_Fields>;
  stddev?: Maybe<AttributeFiles_Stddev_Fields>;
  stddev_pop?: Maybe<AttributeFiles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AttributeFiles_Stddev_Samp_Fields>;
  sum?: Maybe<AttributeFiles_Sum_Fields>;
  var_pop?: Maybe<AttributeFiles_Var_Pop_Fields>;
  var_samp?: Maybe<AttributeFiles_Var_Samp_Fields>;
  variance?: Maybe<AttributeFiles_Variance_Fields>;
};


/** aggregate fields of "attributeFiles" */
export type AttributeFiles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AttributeFiles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "attributeFiles" */
export type AttributeFiles_Aggregate_Order_By = {
  avg?: InputMaybe<AttributeFiles_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AttributeFiles_Max_Order_By>;
  min?: InputMaybe<AttributeFiles_Min_Order_By>;
  stddev?: InputMaybe<AttributeFiles_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AttributeFiles_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AttributeFiles_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AttributeFiles_Sum_Order_By>;
  var_pop?: InputMaybe<AttributeFiles_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AttributeFiles_Var_Samp_Order_By>;
  variance?: InputMaybe<AttributeFiles_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "attributeFiles" */
export type AttributeFiles_Arr_Rel_Insert_Input = {
  data: Array<AttributeFiles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AttributeFiles_On_Conflict>;
};

/** aggregate avg on columns */
export type AttributeFiles_Avg_Fields = {
  __typename?: 'attributeFiles_avg_fields';
  attributeId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "attributeFiles" */
export type AttributeFiles_Avg_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "attributeFiles". All fields are combined with a logical 'AND'. */
export type AttributeFiles_Bool_Exp = {
  _and?: InputMaybe<Array<AttributeFiles_Bool_Exp>>;
  _not?: InputMaybe<AttributeFiles_Bool_Exp>;
  _or?: InputMaybe<Array<AttributeFiles_Bool_Exp>>;
  attribute?: InputMaybe<Attributes_Bool_Exp>;
  attributeId?: InputMaybe<Bigint_Comparison_Exp>;
  downloadUrl?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "attributeFiles" */
export enum AttributeFiles_Constraint {
  /** unique or primary key constraint on columns "attributeId", "fileId" */
  AttributeFilesPkey = 'attributeFiles_pkey'
}

/** input type for inserting data into table "attributeFiles" */
export type AttributeFiles_Insert_Input = {
  attribute?: InputMaybe<Attributes_Obj_Rel_Insert_Input>;
  attributeId?: InputMaybe<Scalars['bigint']['input']>;
  fileId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type AttributeFiles_Max_Fields = {
  __typename?: 'attributeFiles_max_fields';
  attributeId?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "attributeFiles_downloadUrl" */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "attributeFiles" */
export type AttributeFiles_Max_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AttributeFiles_Min_Fields = {
  __typename?: 'attributeFiles_min_fields';
  attributeId?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "attributeFiles_downloadUrl" */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "attributeFiles" */
export type AttributeFiles_Min_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "attributeFiles" */
export type AttributeFiles_Mutation_Response = {
  __typename?: 'attributeFiles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AttributeFiles>;
};

/** on_conflict condition type for table "attributeFiles" */
export type AttributeFiles_On_Conflict = {
  constraint: AttributeFiles_Constraint;
  update_columns?: Array<AttributeFiles_Update_Column>;
  where?: InputMaybe<AttributeFiles_Bool_Exp>;
};

/** Ordering options when selecting data from "attributeFiles". */
export type AttributeFiles_Order_By = {
  attribute?: InputMaybe<Attributes_Order_By>;
  attributeId?: InputMaybe<Order_By>;
  downloadUrl?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** select columns of table "attributeFiles" */
export enum AttributeFiles_Select_Column {
  /** column name */
  AttributeId = 'attributeId',
  /** column name */
  FileId = 'fileId'
}

/** aggregate stddev on columns */
export type AttributeFiles_Stddev_Fields = {
  __typename?: 'attributeFiles_stddev_fields';
  attributeId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "attributeFiles" */
export type AttributeFiles_Stddev_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AttributeFiles_Stddev_Pop_Fields = {
  __typename?: 'attributeFiles_stddev_pop_fields';
  attributeId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "attributeFiles" */
export type AttributeFiles_Stddev_Pop_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AttributeFiles_Stddev_Samp_Fields = {
  __typename?: 'attributeFiles_stddev_samp_fields';
  attributeId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "attributeFiles" */
export type AttributeFiles_Stddev_Samp_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "attributeFiles" */
export type AttributeFiles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AttributeFiles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AttributeFiles_Stream_Cursor_Value_Input = {
  attributeId?: InputMaybe<Scalars['bigint']['input']>;
  fileId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type AttributeFiles_Sum_Fields = {
  __typename?: 'attributeFiles_sum_fields';
  attributeId?: Maybe<Scalars['bigint']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "attributeFiles" */
export type AttributeFiles_Sum_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "attributeFiles" (current role has no relevant permissions) */
export enum AttributeFiles_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type AttributeFiles_Var_Pop_Fields = {
  __typename?: 'attributeFiles_var_pop_fields';
  attributeId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "attributeFiles" */
export type AttributeFiles_Var_Pop_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AttributeFiles_Var_Samp_Fields = {
  __typename?: 'attributeFiles_var_samp_fields';
  attributeId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "attributeFiles" */
export type AttributeFiles_Var_Samp_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AttributeFiles_Variance_Fields = {
  __typename?: 'attributeFiles_variance_fields';
  attributeId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "attributeFiles" */
export type AttributeFiles_Variance_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** columns and relationships of "attributeGroups" */
export type AttributeGroups = {
  __typename?: 'attributeGroups';
  /** An array relationship */
  attributeValueGroups: Array<AttributeValueGroups>;
  /** An aggregate relationship */
  attributeValueGroups_aggregate: AttributeValueGroups_Aggregate;
  /** An array relationship */
  attributes: Array<Attributes>;
  /** An aggregate relationship */
  attributes_aggregate: Attributes_Aggregate;
  createdAt: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  /** An object relationship */
  serviceModule: ServiceModules;
  serviceModuleId: Scalars['bigint']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  valuesRepeatable: Scalars['Boolean']['output'];
};


/** columns and relationships of "attributeGroups" */
export type AttributeGroupsAttributeValueGroupsArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueGroups_Order_By>>;
  where?: InputMaybe<AttributeValueGroups_Bool_Exp>;
};


/** columns and relationships of "attributeGroups" */
export type AttributeGroupsAttributeValueGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueGroups_Order_By>>;
  where?: InputMaybe<AttributeValueGroups_Bool_Exp>;
};


/** columns and relationships of "attributeGroups" */
export type AttributeGroupsAttributesArgs = {
  distinct_on?: InputMaybe<Array<Attributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attributes_Order_By>>;
  where?: InputMaybe<Attributes_Bool_Exp>;
};


/** columns and relationships of "attributeGroups" */
export type AttributeGroupsAttributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attributes_Order_By>>;
  where?: InputMaybe<Attributes_Bool_Exp>;
};

/** aggregated selection of "attributeGroups" */
export type AttributeGroups_Aggregate = {
  __typename?: 'attributeGroups_aggregate';
  aggregate?: Maybe<AttributeGroups_Aggregate_Fields>;
  nodes: Array<AttributeGroups>;
};

export type AttributeGroups_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<AttributeGroups_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<AttributeGroups_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<AttributeGroups_Aggregate_Bool_Exp_Count>;
};

export type AttributeGroups_Aggregate_Bool_Exp_Bool_And = {
  arguments: AttributeGroups_Select_Column_AttributeGroups_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AttributeGroups_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type AttributeGroups_Aggregate_Bool_Exp_Bool_Or = {
  arguments: AttributeGroups_Select_Column_AttributeGroups_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AttributeGroups_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type AttributeGroups_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AttributeGroups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AttributeGroups_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "attributeGroups" */
export type AttributeGroups_Aggregate_Fields = {
  __typename?: 'attributeGroups_aggregate_fields';
  avg?: Maybe<AttributeGroups_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AttributeGroups_Max_Fields>;
  min?: Maybe<AttributeGroups_Min_Fields>;
  stddev?: Maybe<AttributeGroups_Stddev_Fields>;
  stddev_pop?: Maybe<AttributeGroups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AttributeGroups_Stddev_Samp_Fields>;
  sum?: Maybe<AttributeGroups_Sum_Fields>;
  var_pop?: Maybe<AttributeGroups_Var_Pop_Fields>;
  var_samp?: Maybe<AttributeGroups_Var_Samp_Fields>;
  variance?: Maybe<AttributeGroups_Variance_Fields>;
};


/** aggregate fields of "attributeGroups" */
export type AttributeGroups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AttributeGroups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "attributeGroups" */
export type AttributeGroups_Aggregate_Order_By = {
  avg?: InputMaybe<AttributeGroups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AttributeGroups_Max_Order_By>;
  min?: InputMaybe<AttributeGroups_Min_Order_By>;
  stddev?: InputMaybe<AttributeGroups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AttributeGroups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AttributeGroups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AttributeGroups_Sum_Order_By>;
  var_pop?: InputMaybe<AttributeGroups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AttributeGroups_Var_Samp_Order_By>;
  variance?: InputMaybe<AttributeGroups_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "attributeGroups" */
export type AttributeGroups_Arr_Rel_Insert_Input = {
  data: Array<AttributeGroups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AttributeGroups_On_Conflict>;
};

/** aggregate avg on columns */
export type AttributeGroups_Avg_Fields = {
  __typename?: 'attributeGroups_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "attributeGroups" */
export type AttributeGroups_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "attributeGroups". All fields are combined with a logical 'AND'. */
export type AttributeGroups_Bool_Exp = {
  _and?: InputMaybe<Array<AttributeGroups_Bool_Exp>>;
  _not?: InputMaybe<AttributeGroups_Bool_Exp>;
  _or?: InputMaybe<Array<AttributeGroups_Bool_Exp>>;
  attributeValueGroups?: InputMaybe<AttributeValueGroups_Bool_Exp>;
  attributeValueGroups_aggregate?: InputMaybe<AttributeValueGroups_Aggregate_Bool_Exp>;
  attributes?: InputMaybe<Attributes_Bool_Exp>;
  attributes_aggregate?: InputMaybe<Attributes_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  serviceModule?: InputMaybe<ServiceModules_Bool_Exp>;
  serviceModuleId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  valuesRepeatable?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "attributeGroups" */
export enum AttributeGroups_Constraint {
  /** unique or primary key constraint on columns "id" */
  AttributeGroupsPkey = 'attributeGroups_pkey'
}

/** input type for incrementing numeric columns in table "attributeGroups" */
export type AttributeGroups_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "attributeGroups" */
export type AttributeGroups_Insert_Input = {
  attributeValueGroups?: InputMaybe<AttributeValueGroups_Arr_Rel_Insert_Input>;
  attributes?: InputMaybe<Attributes_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  serviceModule?: InputMaybe<ServiceModules_Obj_Rel_Insert_Input>;
  serviceModuleId?: InputMaybe<Scalars['bigint']['input']>;
  valuesRepeatable?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type AttributeGroups_Max_Fields = {
  __typename?: 'attributeGroups_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "attributeGroups" */
export type AttributeGroups_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AttributeGroups_Min_Fields = {
  __typename?: 'attributeGroups_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "attributeGroups" */
export type AttributeGroups_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "attributeGroups" */
export type AttributeGroups_Mutation_Response = {
  __typename?: 'attributeGroups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AttributeGroups>;
};

/** input type for inserting object relation for remote table "attributeGroups" */
export type AttributeGroups_Obj_Rel_Insert_Input = {
  data: AttributeGroups_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AttributeGroups_On_Conflict>;
};

/** on_conflict condition type for table "attributeGroups" */
export type AttributeGroups_On_Conflict = {
  constraint: AttributeGroups_Constraint;
  update_columns?: Array<AttributeGroups_Update_Column>;
  where?: InputMaybe<AttributeGroups_Bool_Exp>;
};

/** Ordering options when selecting data from "attributeGroups". */
export type AttributeGroups_Order_By = {
  attributeValueGroups_aggregate?: InputMaybe<AttributeValueGroups_Aggregate_Order_By>;
  attributes_aggregate?: InputMaybe<Attributes_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceModule?: InputMaybe<ServiceModules_Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  valuesRepeatable?: InputMaybe<Order_By>;
};

/** primary key columns input for table: attributeGroups */
export type AttributeGroups_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "attributeGroups" */
export enum AttributeGroups_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ServiceModuleId = 'serviceModuleId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ValuesRepeatable = 'valuesRepeatable'
}

/** select "attributeGroups_aggregate_bool_exp_bool_and_arguments_columns" columns of table "attributeGroups" */
export enum AttributeGroups_Select_Column_AttributeGroups_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ValuesRepeatable = 'valuesRepeatable'
}

/** select "attributeGroups_aggregate_bool_exp_bool_or_arguments_columns" columns of table "attributeGroups" */
export enum AttributeGroups_Select_Column_AttributeGroups_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ValuesRepeatable = 'valuesRepeatable'
}

/** input type for updating data in table "attributeGroups" */
export type AttributeGroups_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  valuesRepeatable?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type AttributeGroups_Stddev_Fields = {
  __typename?: 'attributeGroups_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "attributeGroups" */
export type AttributeGroups_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AttributeGroups_Stddev_Pop_Fields = {
  __typename?: 'attributeGroups_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "attributeGroups" */
export type AttributeGroups_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AttributeGroups_Stddev_Samp_Fields = {
  __typename?: 'attributeGroups_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "attributeGroups" */
export type AttributeGroups_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "attributeGroups" */
export type AttributeGroups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AttributeGroups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AttributeGroups_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  serviceModuleId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  valuesRepeatable?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type AttributeGroups_Sum_Fields = {
  __typename?: 'attributeGroups_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "attributeGroups" */
export type AttributeGroups_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** update columns of table "attributeGroups" */
export enum AttributeGroups_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ValuesRepeatable = 'valuesRepeatable'
}

export type AttributeGroups_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AttributeGroups_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AttributeGroups_Set_Input>;
  /** filter the rows which have to be updated */
  where: AttributeGroups_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AttributeGroups_Var_Pop_Fields = {
  __typename?: 'attributeGroups_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "attributeGroups" */
export type AttributeGroups_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AttributeGroups_Var_Samp_Fields = {
  __typename?: 'attributeGroups_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "attributeGroups" */
export type AttributeGroups_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AttributeGroups_Variance_Fields = {
  __typename?: 'attributeGroups_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "attributeGroups" */
export type AttributeGroups_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** columns and relationships of "attributeTypes" */
export type AttributeTypes = {
  __typename?: 'attributeTypes';
  /** An array relationship */
  attributes: Array<Attributes>;
  /** An aggregate relationship */
  attributes_aggregate: Attributes_Aggregate;
  /** An array relationship */
  eventAttributes: Array<EventAttributes>;
  /** An aggregate relationship */
  eventAttributes_aggregate: EventAttributes_Aggregate;
  name: Scalars['String']['output'];
};


/** columns and relationships of "attributeTypes" */
export type AttributeTypesAttributesArgs = {
  distinct_on?: InputMaybe<Array<Attributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attributes_Order_By>>;
  where?: InputMaybe<Attributes_Bool_Exp>;
};


/** columns and relationships of "attributeTypes" */
export type AttributeTypesAttributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attributes_Order_By>>;
  where?: InputMaybe<Attributes_Bool_Exp>;
};


/** columns and relationships of "attributeTypes" */
export type AttributeTypesEventAttributesArgs = {
  distinct_on?: InputMaybe<Array<EventAttributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributes_Order_By>>;
  where?: InputMaybe<EventAttributes_Bool_Exp>;
};


/** columns and relationships of "attributeTypes" */
export type AttributeTypesEventAttributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAttributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributes_Order_By>>;
  where?: InputMaybe<EventAttributes_Bool_Exp>;
};

/** aggregated selection of "attributeTypes" */
export type AttributeTypes_Aggregate = {
  __typename?: 'attributeTypes_aggregate';
  aggregate?: Maybe<AttributeTypes_Aggregate_Fields>;
  nodes: Array<AttributeTypes>;
};

/** aggregate fields of "attributeTypes" */
export type AttributeTypes_Aggregate_Fields = {
  __typename?: 'attributeTypes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AttributeTypes_Max_Fields>;
  min?: Maybe<AttributeTypes_Min_Fields>;
};


/** aggregate fields of "attributeTypes" */
export type AttributeTypes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AttributeTypes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "attributeTypes". All fields are combined with a logical 'AND'. */
export type AttributeTypes_Bool_Exp = {
  _and?: InputMaybe<Array<AttributeTypes_Bool_Exp>>;
  _not?: InputMaybe<AttributeTypes_Bool_Exp>;
  _or?: InputMaybe<Array<AttributeTypes_Bool_Exp>>;
  attributes?: InputMaybe<Attributes_Bool_Exp>;
  attributes_aggregate?: InputMaybe<Attributes_Aggregate_Bool_Exp>;
  eventAttributes?: InputMaybe<EventAttributes_Bool_Exp>;
  eventAttributes_aggregate?: InputMaybe<EventAttributes_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

export enum AttributeTypes_Enum {
  Boolean = 'boolean',
  Date = 'date',
  File = 'file',
  FileMaster = 'fileMaster',
  Number = 'number',
  Select = 'select',
  Text = 'text',
  User = 'user'
}

/** Boolean expression to compare columns of type "attributeTypes_enum". All fields are combined with logical 'AND'. */
export type AttributeTypes_Enum_Comparison_Exp = {
  _eq?: InputMaybe<AttributeTypes_Enum>;
  _in?: InputMaybe<Array<AttributeTypes_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<AttributeTypes_Enum>;
  _nin?: InputMaybe<Array<AttributeTypes_Enum>>;
};

/** aggregate max on columns */
export type AttributeTypes_Max_Fields = {
  __typename?: 'attributeTypes_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AttributeTypes_Min_Fields = {
  __typename?: 'attributeTypes_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "attributeTypes". */
export type AttributeTypes_Order_By = {
  attributes_aggregate?: InputMaybe<Attributes_Aggregate_Order_By>;
  eventAttributes_aggregate?: InputMaybe<EventAttributes_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "attributeTypes" */
export enum AttributeTypes_Select_Column {
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "attributeTypes" */
export type AttributeTypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AttributeTypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AttributeTypes_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "attributeValueComments" */
export type AttributeValueComments = {
  __typename?: 'attributeValueComments';
  /** An object relationship */
  attributeValue: AttributeValues;
  attributeValueId: Scalars['bigint']['output'];
  comment: Scalars['String']['output'];
  /** An array relationship */
  comments: Array<AttributeValueComments>;
  /** An aggregate relationship */
  comments_aggregate: AttributeValueComments_Aggregate;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  fullUser: Users;
  id: Scalars['bigint']['output'];
  isDone?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  /** An object relationship */
  organisation?: Maybe<Organisations>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  parentComment?: Maybe<AttributeValueComments>;
  parentId?: Maybe<Scalars['bigint']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<AllUsers>;
  userId: Scalars['bigint']['output'];
};


/** columns and relationships of "attributeValueComments" */
export type AttributeValueCommentsCommentsArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueComments_Order_By>>;
  where?: InputMaybe<AttributeValueComments_Bool_Exp>;
};


/** columns and relationships of "attributeValueComments" */
export type AttributeValueCommentsComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueComments_Order_By>>;
  where?: InputMaybe<AttributeValueComments_Bool_Exp>;
};


/** columns and relationships of "attributeValueComments" */
export type AttributeValueCommentsNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "attributeValueComments" */
export type AttributeValueCommentsNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** aggregated selection of "attributeValueComments" */
export type AttributeValueComments_Aggregate = {
  __typename?: 'attributeValueComments_aggregate';
  aggregate?: Maybe<AttributeValueComments_Aggregate_Fields>;
  nodes: Array<AttributeValueComments>;
};

export type AttributeValueComments_Aggregate_Bool_Exp = {
  count?: InputMaybe<AttributeValueComments_Aggregate_Bool_Exp_Count>;
};

export type AttributeValueComments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AttributeValueComments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AttributeValueComments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "attributeValueComments" */
export type AttributeValueComments_Aggregate_Fields = {
  __typename?: 'attributeValueComments_aggregate_fields';
  avg?: Maybe<AttributeValueComments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AttributeValueComments_Max_Fields>;
  min?: Maybe<AttributeValueComments_Min_Fields>;
  stddev?: Maybe<AttributeValueComments_Stddev_Fields>;
  stddev_pop?: Maybe<AttributeValueComments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AttributeValueComments_Stddev_Samp_Fields>;
  sum?: Maybe<AttributeValueComments_Sum_Fields>;
  var_pop?: Maybe<AttributeValueComments_Var_Pop_Fields>;
  var_samp?: Maybe<AttributeValueComments_Var_Samp_Fields>;
  variance?: Maybe<AttributeValueComments_Variance_Fields>;
};


/** aggregate fields of "attributeValueComments" */
export type AttributeValueComments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AttributeValueComments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "attributeValueComments" */
export type AttributeValueComments_Aggregate_Order_By = {
  avg?: InputMaybe<AttributeValueComments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AttributeValueComments_Max_Order_By>;
  min?: InputMaybe<AttributeValueComments_Min_Order_By>;
  stddev?: InputMaybe<AttributeValueComments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AttributeValueComments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AttributeValueComments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AttributeValueComments_Sum_Order_By>;
  var_pop?: InputMaybe<AttributeValueComments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AttributeValueComments_Var_Samp_Order_By>;
  variance?: InputMaybe<AttributeValueComments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "attributeValueComments" */
export type AttributeValueComments_Arr_Rel_Insert_Input = {
  data: Array<AttributeValueComments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AttributeValueComments_On_Conflict>;
};

/** aggregate avg on columns */
export type AttributeValueComments_Avg_Fields = {
  __typename?: 'attributeValueComments_avg_fields';
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "attributeValueComments" */
export type AttributeValueComments_Avg_Order_By = {
  attributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "attributeValueComments". All fields are combined with a logical 'AND'. */
export type AttributeValueComments_Bool_Exp = {
  _and?: InputMaybe<Array<AttributeValueComments_Bool_Exp>>;
  _not?: InputMaybe<AttributeValueComments_Bool_Exp>;
  _or?: InputMaybe<Array<AttributeValueComments_Bool_Exp>>;
  attributeValue?: InputMaybe<AttributeValues_Bool_Exp>;
  attributeValueId?: InputMaybe<Bigint_Comparison_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<AttributeValueComments_Bool_Exp>;
  comments_aggregate?: InputMaybe<AttributeValueComments_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  fullUser?: InputMaybe<Users_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  isDone?: InputMaybe<Timestamptz_Comparison_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Bool_Exp>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisationId?: InputMaybe<Bigint_Comparison_Exp>;
  parentComment?: InputMaybe<AttributeValueComments_Bool_Exp>;
  parentId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<AllUsers_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "attributeValueComments" */
export enum AttributeValueComments_Constraint {
  /** unique or primary key constraint on columns "id" */
  AttributeValueCommentsPkey = 'attributeValueComments_pkey'
}

/** input type for incrementing numeric columns in table "attributeValueComments" */
export type AttributeValueComments_Inc_Input = {
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "attributeValueComments" */
export type AttributeValueComments_Insert_Input = {
  attributeValue?: InputMaybe<AttributeValues_Obj_Rel_Insert_Input>;
  attributeValueId?: InputMaybe<Scalars['bigint']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<AttributeValueComments_Arr_Rel_Insert_Input>;
  fullUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  isDone?: InputMaybe<Scalars['timestamptz']['input']>;
  organisation?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
  parentComment?: InputMaybe<AttributeValueComments_Obj_Rel_Insert_Input>;
  parentId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type AttributeValueComments_Max_Fields = {
  __typename?: 'attributeValueComments_max_fields';
  attributeValueId?: Maybe<Scalars['bigint']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  isDone?: Maybe<Scalars['timestamptz']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  parentId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "attributeValueComments" */
export type AttributeValueComments_Max_Order_By = {
  attributeValueId?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDone?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AttributeValueComments_Min_Fields = {
  __typename?: 'attributeValueComments_min_fields';
  attributeValueId?: Maybe<Scalars['bigint']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  isDone?: Maybe<Scalars['timestamptz']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  parentId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "attributeValueComments" */
export type AttributeValueComments_Min_Order_By = {
  attributeValueId?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDone?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "attributeValueComments" */
export type AttributeValueComments_Mutation_Response = {
  __typename?: 'attributeValueComments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AttributeValueComments>;
};

/** input type for inserting object relation for remote table "attributeValueComments" */
export type AttributeValueComments_Obj_Rel_Insert_Input = {
  data: AttributeValueComments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AttributeValueComments_On_Conflict>;
};

/** on_conflict condition type for table "attributeValueComments" */
export type AttributeValueComments_On_Conflict = {
  constraint: AttributeValueComments_Constraint;
  update_columns?: Array<AttributeValueComments_Update_Column>;
  where?: InputMaybe<AttributeValueComments_Bool_Exp>;
};

/** Ordering options when selecting data from "attributeValueComments". */
export type AttributeValueComments_Order_By = {
  attributeValue?: InputMaybe<AttributeValues_Order_By>;
  attributeValueId?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<AttributeValueComments_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fullUser?: InputMaybe<Users_Order_By>;
  id?: InputMaybe<Order_By>;
  isDone?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  organisation?: InputMaybe<Organisations_Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentComment?: InputMaybe<AttributeValueComments_Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<AllUsers_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: attributeValueComments */
export type AttributeValueComments_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "attributeValueComments" */
export enum AttributeValueComments_Select_Column {
  /** column name */
  AttributeValueId = 'attributeValueId',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsDone = 'isDone',
  /** column name */
  OrganisationId = 'organisationId',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "attributeValueComments" */
export type AttributeValueComments_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  isDone?: InputMaybe<Scalars['timestamptz']['input']>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type AttributeValueComments_Stddev_Fields = {
  __typename?: 'attributeValueComments_stddev_fields';
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "attributeValueComments" */
export type AttributeValueComments_Stddev_Order_By = {
  attributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AttributeValueComments_Stddev_Pop_Fields = {
  __typename?: 'attributeValueComments_stddev_pop_fields';
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "attributeValueComments" */
export type AttributeValueComments_Stddev_Pop_Order_By = {
  attributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AttributeValueComments_Stddev_Samp_Fields = {
  __typename?: 'attributeValueComments_stddev_samp_fields';
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "attributeValueComments" */
export type AttributeValueComments_Stddev_Samp_Order_By = {
  attributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "attributeValueComments" */
export type AttributeValueComments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AttributeValueComments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AttributeValueComments_Stream_Cursor_Value_Input = {
  attributeValueId?: InputMaybe<Scalars['bigint']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  isDone?: InputMaybe<Scalars['timestamptz']['input']>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
  parentId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type AttributeValueComments_Sum_Fields = {
  __typename?: 'attributeValueComments_sum_fields';
  attributeValueId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  parentId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "attributeValueComments" */
export type AttributeValueComments_Sum_Order_By = {
  attributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "attributeValueComments" */
export enum AttributeValueComments_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  IsDone = 'isDone',
  /** column name */
  OrganisationId = 'organisationId'
}

export type AttributeValueComments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AttributeValueComments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AttributeValueComments_Set_Input>;
  /** filter the rows which have to be updated */
  where: AttributeValueComments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AttributeValueComments_Var_Pop_Fields = {
  __typename?: 'attributeValueComments_var_pop_fields';
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "attributeValueComments" */
export type AttributeValueComments_Var_Pop_Order_By = {
  attributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AttributeValueComments_Var_Samp_Fields = {
  __typename?: 'attributeValueComments_var_samp_fields';
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "attributeValueComments" */
export type AttributeValueComments_Var_Samp_Order_By = {
  attributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AttributeValueComments_Variance_Fields = {
  __typename?: 'attributeValueComments_variance_fields';
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "attributeValueComments" */
export type AttributeValueComments_Variance_Order_By = {
  attributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "attributeValueGroups" */
export type AttributeValueGroups = {
  __typename?: 'attributeValueGroups';
  /** An object relationship */
  attributeGroup: AttributeGroups;
  attributeGroupId: Scalars['bigint']['output'];
  /** An array relationship */
  attributeValues: Array<AttributeValues>;
  /** An aggregate relationship */
  attributeValues_aggregate: AttributeValues_Aggregate;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "attributeValueGroups" */
export type AttributeValueGroupsAttributeValuesArgs = {
  distinct_on?: InputMaybe<Array<AttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValues_Order_By>>;
  where?: InputMaybe<AttributeValues_Bool_Exp>;
};


/** columns and relationships of "attributeValueGroups" */
export type AttributeValueGroupsAttributeValues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValues_Order_By>>;
  where?: InputMaybe<AttributeValues_Bool_Exp>;
};

/** aggregated selection of "attributeValueGroups" */
export type AttributeValueGroups_Aggregate = {
  __typename?: 'attributeValueGroups_aggregate';
  aggregate?: Maybe<AttributeValueGroups_Aggregate_Fields>;
  nodes: Array<AttributeValueGroups>;
};

export type AttributeValueGroups_Aggregate_Bool_Exp = {
  count?: InputMaybe<AttributeValueGroups_Aggregate_Bool_Exp_Count>;
};

export type AttributeValueGroups_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AttributeValueGroups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AttributeValueGroups_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "attributeValueGroups" */
export type AttributeValueGroups_Aggregate_Fields = {
  __typename?: 'attributeValueGroups_aggregate_fields';
  avg?: Maybe<AttributeValueGroups_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AttributeValueGroups_Max_Fields>;
  min?: Maybe<AttributeValueGroups_Min_Fields>;
  stddev?: Maybe<AttributeValueGroups_Stddev_Fields>;
  stddev_pop?: Maybe<AttributeValueGroups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AttributeValueGroups_Stddev_Samp_Fields>;
  sum?: Maybe<AttributeValueGroups_Sum_Fields>;
  var_pop?: Maybe<AttributeValueGroups_Var_Pop_Fields>;
  var_samp?: Maybe<AttributeValueGroups_Var_Samp_Fields>;
  variance?: Maybe<AttributeValueGroups_Variance_Fields>;
};


/** aggregate fields of "attributeValueGroups" */
export type AttributeValueGroups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AttributeValueGroups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "attributeValueGroups" */
export type AttributeValueGroups_Aggregate_Order_By = {
  avg?: InputMaybe<AttributeValueGroups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AttributeValueGroups_Max_Order_By>;
  min?: InputMaybe<AttributeValueGroups_Min_Order_By>;
  stddev?: InputMaybe<AttributeValueGroups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AttributeValueGroups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AttributeValueGroups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AttributeValueGroups_Sum_Order_By>;
  var_pop?: InputMaybe<AttributeValueGroups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AttributeValueGroups_Var_Samp_Order_By>;
  variance?: InputMaybe<AttributeValueGroups_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "attributeValueGroups" */
export type AttributeValueGroups_Arr_Rel_Insert_Input = {
  data: Array<AttributeValueGroups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AttributeValueGroups_On_Conflict>;
};

/** aggregate avg on columns */
export type AttributeValueGroups_Avg_Fields = {
  __typename?: 'attributeValueGroups_avg_fields';
  attributeGroupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "attributeValueGroups" */
export type AttributeValueGroups_Avg_Order_By = {
  attributeGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "attributeValueGroups". All fields are combined with a logical 'AND'. */
export type AttributeValueGroups_Bool_Exp = {
  _and?: InputMaybe<Array<AttributeValueGroups_Bool_Exp>>;
  _not?: InputMaybe<AttributeValueGroups_Bool_Exp>;
  _or?: InputMaybe<Array<AttributeValueGroups_Bool_Exp>>;
  attributeGroup?: InputMaybe<AttributeGroups_Bool_Exp>;
  attributeGroupId?: InputMaybe<Bigint_Comparison_Exp>;
  attributeValues?: InputMaybe<AttributeValues_Bool_Exp>;
  attributeValues_aggregate?: InputMaybe<AttributeValues_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "attributeValueGroups" */
export enum AttributeValueGroups_Constraint {
  /** unique or primary key constraint on columns "id" */
  AttributeValueGroupPkey = 'attributeValueGroup_pkey'
}

/** input type for inserting data into table "attributeValueGroups" */
export type AttributeValueGroups_Insert_Input = {
  attributeGroup?: InputMaybe<AttributeGroups_Obj_Rel_Insert_Input>;
  attributeGroupId?: InputMaybe<Scalars['bigint']['input']>;
  attributeValues?: InputMaybe<AttributeValues_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type AttributeValueGroups_Max_Fields = {
  __typename?: 'attributeValueGroups_max_fields';
  attributeGroupId?: Maybe<Scalars['bigint']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "attributeValueGroups" */
export type AttributeValueGroups_Max_Order_By = {
  attributeGroupId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AttributeValueGroups_Min_Fields = {
  __typename?: 'attributeValueGroups_min_fields';
  attributeGroupId?: Maybe<Scalars['bigint']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "attributeValueGroups" */
export type AttributeValueGroups_Min_Order_By = {
  attributeGroupId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "attributeValueGroups" */
export type AttributeValueGroups_Mutation_Response = {
  __typename?: 'attributeValueGroups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AttributeValueGroups>;
};

/** input type for inserting object relation for remote table "attributeValueGroups" */
export type AttributeValueGroups_Obj_Rel_Insert_Input = {
  data: AttributeValueGroups_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AttributeValueGroups_On_Conflict>;
};

/** on_conflict condition type for table "attributeValueGroups" */
export type AttributeValueGroups_On_Conflict = {
  constraint: AttributeValueGroups_Constraint;
  update_columns?: Array<AttributeValueGroups_Update_Column>;
  where?: InputMaybe<AttributeValueGroups_Bool_Exp>;
};

/** Ordering options when selecting data from "attributeValueGroups". */
export type AttributeValueGroups_Order_By = {
  attributeGroup?: InputMaybe<AttributeGroups_Order_By>;
  attributeGroupId?: InputMaybe<Order_By>;
  attributeValues_aggregate?: InputMaybe<AttributeValues_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** select columns of table "attributeValueGroups" */
export enum AttributeValueGroups_Select_Column {
  /** column name */
  AttributeGroupId = 'attributeGroupId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** aggregate stddev on columns */
export type AttributeValueGroups_Stddev_Fields = {
  __typename?: 'attributeValueGroups_stddev_fields';
  attributeGroupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "attributeValueGroups" */
export type AttributeValueGroups_Stddev_Order_By = {
  attributeGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AttributeValueGroups_Stddev_Pop_Fields = {
  __typename?: 'attributeValueGroups_stddev_pop_fields';
  attributeGroupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "attributeValueGroups" */
export type AttributeValueGroups_Stddev_Pop_Order_By = {
  attributeGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AttributeValueGroups_Stddev_Samp_Fields = {
  __typename?: 'attributeValueGroups_stddev_samp_fields';
  attributeGroupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "attributeValueGroups" */
export type AttributeValueGroups_Stddev_Samp_Order_By = {
  attributeGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "attributeValueGroups" */
export type AttributeValueGroups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AttributeValueGroups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AttributeValueGroups_Stream_Cursor_Value_Input = {
  attributeGroupId?: InputMaybe<Scalars['bigint']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type AttributeValueGroups_Sum_Fields = {
  __typename?: 'attributeValueGroups_sum_fields';
  attributeGroupId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "attributeValueGroups" */
export type AttributeValueGroups_Sum_Order_By = {
  attributeGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "attributeValueGroups" (current role has no relevant permissions) */
export enum AttributeValueGroups_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type AttributeValueGroups_Var_Pop_Fields = {
  __typename?: 'attributeValueGroups_var_pop_fields';
  attributeGroupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "attributeValueGroups" */
export type AttributeValueGroups_Var_Pop_Order_By = {
  attributeGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AttributeValueGroups_Var_Samp_Fields = {
  __typename?: 'attributeValueGroups_var_samp_fields';
  attributeGroupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "attributeValueGroups" */
export type AttributeValueGroups_Var_Samp_Order_By = {
  attributeGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AttributeValueGroups_Variance_Fields = {
  __typename?: 'attributeValueGroups_variance_fields';
  attributeGroupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "attributeValueGroups" */
export type AttributeValueGroups_Variance_Order_By = {
  attributeGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "attributeValueUploadVersions" */
export type AttributeValueUploadVersions = {
  __typename?: 'attributeValueUploadVersions';
  /** An object relationship */
  attributeValueUpload: AttributeValueUploads;
  attributeValueUploadId: Scalars['bigint']['output'];
  /** A computed field, executes function "attributeValueUploadVersions_downloadUrl" */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  file: Files;
  fileId: Scalars['bigint']['output'];
};

/** aggregated selection of "attributeValueUploadVersions" */
export type AttributeValueUploadVersions_Aggregate = {
  __typename?: 'attributeValueUploadVersions_aggregate';
  aggregate?: Maybe<AttributeValueUploadVersions_Aggregate_Fields>;
  nodes: Array<AttributeValueUploadVersions>;
};

export type AttributeValueUploadVersions_Aggregate_Bool_Exp = {
  count?: InputMaybe<AttributeValueUploadVersions_Aggregate_Bool_Exp_Count>;
};

export type AttributeValueUploadVersions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AttributeValueUploadVersions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AttributeValueUploadVersions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "attributeValueUploadVersions" */
export type AttributeValueUploadVersions_Aggregate_Fields = {
  __typename?: 'attributeValueUploadVersions_aggregate_fields';
  avg?: Maybe<AttributeValueUploadVersions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AttributeValueUploadVersions_Max_Fields>;
  min?: Maybe<AttributeValueUploadVersions_Min_Fields>;
  stddev?: Maybe<AttributeValueUploadVersions_Stddev_Fields>;
  stddev_pop?: Maybe<AttributeValueUploadVersions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AttributeValueUploadVersions_Stddev_Samp_Fields>;
  sum?: Maybe<AttributeValueUploadVersions_Sum_Fields>;
  var_pop?: Maybe<AttributeValueUploadVersions_Var_Pop_Fields>;
  var_samp?: Maybe<AttributeValueUploadVersions_Var_Samp_Fields>;
  variance?: Maybe<AttributeValueUploadVersions_Variance_Fields>;
};


/** aggregate fields of "attributeValueUploadVersions" */
export type AttributeValueUploadVersions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AttributeValueUploadVersions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "attributeValueUploadVersions" */
export type AttributeValueUploadVersions_Aggregate_Order_By = {
  avg?: InputMaybe<AttributeValueUploadVersions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AttributeValueUploadVersions_Max_Order_By>;
  min?: InputMaybe<AttributeValueUploadVersions_Min_Order_By>;
  stddev?: InputMaybe<AttributeValueUploadVersions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AttributeValueUploadVersions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AttributeValueUploadVersions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AttributeValueUploadVersions_Sum_Order_By>;
  var_pop?: InputMaybe<AttributeValueUploadVersions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AttributeValueUploadVersions_Var_Samp_Order_By>;
  variance?: InputMaybe<AttributeValueUploadVersions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "attributeValueUploadVersions" */
export type AttributeValueUploadVersions_Arr_Rel_Insert_Input = {
  data: Array<AttributeValueUploadVersions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AttributeValueUploadVersions_On_Conflict>;
};

/** aggregate avg on columns */
export type AttributeValueUploadVersions_Avg_Fields = {
  __typename?: 'attributeValueUploadVersions_avg_fields';
  attributeValueUploadId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "attributeValueUploadVersions" */
export type AttributeValueUploadVersions_Avg_Order_By = {
  attributeValueUploadId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "attributeValueUploadVersions". All fields are combined with a logical 'AND'. */
export type AttributeValueUploadVersions_Bool_Exp = {
  _and?: InputMaybe<Array<AttributeValueUploadVersions_Bool_Exp>>;
  _not?: InputMaybe<AttributeValueUploadVersions_Bool_Exp>;
  _or?: InputMaybe<Array<AttributeValueUploadVersions_Bool_Exp>>;
  attributeValueUpload?: InputMaybe<AttributeValueUploads_Bool_Exp>;
  attributeValueUploadId?: InputMaybe<Bigint_Comparison_Exp>;
  downloadUrl?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "attributeValueUploadVersions" */
export enum AttributeValueUploadVersions_Constraint {
  /** unique or primary key constraint on columns "attributeValueUploadId", "fileId" */
  AttributeValueUploadVersionsPkey = 'attributeValueUploadVersions_pkey'
}

/** input type for inserting data into table "attributeValueUploadVersions" */
export type AttributeValueUploadVersions_Insert_Input = {
  attributeValueUpload?: InputMaybe<AttributeValueUploads_Obj_Rel_Insert_Input>;
  attributeValueUploadId?: InputMaybe<Scalars['bigint']['input']>;
  fileId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type AttributeValueUploadVersions_Max_Fields = {
  __typename?: 'attributeValueUploadVersions_max_fields';
  attributeValueUploadId?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "attributeValueUploadVersions_downloadUrl" */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "attributeValueUploadVersions" */
export type AttributeValueUploadVersions_Max_Order_By = {
  attributeValueUploadId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AttributeValueUploadVersions_Min_Fields = {
  __typename?: 'attributeValueUploadVersions_min_fields';
  attributeValueUploadId?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "attributeValueUploadVersions_downloadUrl" */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "attributeValueUploadVersions" */
export type AttributeValueUploadVersions_Min_Order_By = {
  attributeValueUploadId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "attributeValueUploadVersions" */
export type AttributeValueUploadVersions_Mutation_Response = {
  __typename?: 'attributeValueUploadVersions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AttributeValueUploadVersions>;
};

/** on_conflict condition type for table "attributeValueUploadVersions" */
export type AttributeValueUploadVersions_On_Conflict = {
  constraint: AttributeValueUploadVersions_Constraint;
  update_columns?: Array<AttributeValueUploadVersions_Update_Column>;
  where?: InputMaybe<AttributeValueUploadVersions_Bool_Exp>;
};

/** Ordering options when selecting data from "attributeValueUploadVersions". */
export type AttributeValueUploadVersions_Order_By = {
  attributeValueUpload?: InputMaybe<AttributeValueUploads_Order_By>;
  attributeValueUploadId?: InputMaybe<Order_By>;
  downloadUrl?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** select columns of table "attributeValueUploadVersions" */
export enum AttributeValueUploadVersions_Select_Column {
  /** column name */
  AttributeValueUploadId = 'attributeValueUploadId',
  /** column name */
  FileId = 'fileId'
}

/** aggregate stddev on columns */
export type AttributeValueUploadVersions_Stddev_Fields = {
  __typename?: 'attributeValueUploadVersions_stddev_fields';
  attributeValueUploadId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "attributeValueUploadVersions" */
export type AttributeValueUploadVersions_Stddev_Order_By = {
  attributeValueUploadId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AttributeValueUploadVersions_Stddev_Pop_Fields = {
  __typename?: 'attributeValueUploadVersions_stddev_pop_fields';
  attributeValueUploadId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "attributeValueUploadVersions" */
export type AttributeValueUploadVersions_Stddev_Pop_Order_By = {
  attributeValueUploadId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AttributeValueUploadVersions_Stddev_Samp_Fields = {
  __typename?: 'attributeValueUploadVersions_stddev_samp_fields';
  attributeValueUploadId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "attributeValueUploadVersions" */
export type AttributeValueUploadVersions_Stddev_Samp_Order_By = {
  attributeValueUploadId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "attributeValueUploadVersions" */
export type AttributeValueUploadVersions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AttributeValueUploadVersions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AttributeValueUploadVersions_Stream_Cursor_Value_Input = {
  attributeValueUploadId?: InputMaybe<Scalars['bigint']['input']>;
  fileId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type AttributeValueUploadVersions_Sum_Fields = {
  __typename?: 'attributeValueUploadVersions_sum_fields';
  attributeValueUploadId?: Maybe<Scalars['bigint']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "attributeValueUploadVersions" */
export type AttributeValueUploadVersions_Sum_Order_By = {
  attributeValueUploadId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "attributeValueUploadVersions" (current role has no relevant permissions) */
export enum AttributeValueUploadVersions_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type AttributeValueUploadVersions_Var_Pop_Fields = {
  __typename?: 'attributeValueUploadVersions_var_pop_fields';
  attributeValueUploadId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "attributeValueUploadVersions" */
export type AttributeValueUploadVersions_Var_Pop_Order_By = {
  attributeValueUploadId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AttributeValueUploadVersions_Var_Samp_Fields = {
  __typename?: 'attributeValueUploadVersions_var_samp_fields';
  attributeValueUploadId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "attributeValueUploadVersions" */
export type AttributeValueUploadVersions_Var_Samp_Order_By = {
  attributeValueUploadId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AttributeValueUploadVersions_Variance_Fields = {
  __typename?: 'attributeValueUploadVersions_variance_fields';
  attributeValueUploadId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "attributeValueUploadVersions" */
export type AttributeValueUploadVersions_Variance_Order_By = {
  attributeValueUploadId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** columns and relationships of "attributeValueUploads" */
export type AttributeValueUploads = {
  __typename?: 'attributeValueUploads';
  /** An object relationship */
  attributeValue: AttributeValues;
  attributeValueId: Scalars['bigint']['output'];
  /** An array relationship */
  attributeValueUploadVersions: Array<AttributeValueUploadVersions>;
  /** An aggregate relationship */
  attributeValueUploadVersions_aggregate: AttributeValueUploadVersions_Aggregate;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "attributeValueUploads" */
export type AttributeValueUploadsAttributeValueUploadVersionsArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<AttributeValueUploadVersions_Bool_Exp>;
};


/** columns and relationships of "attributeValueUploads" */
export type AttributeValueUploadsAttributeValueUploadVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<AttributeValueUploadVersions_Bool_Exp>;
};

/** aggregated selection of "attributeValueUploads" */
export type AttributeValueUploads_Aggregate = {
  __typename?: 'attributeValueUploads_aggregate';
  aggregate?: Maybe<AttributeValueUploads_Aggregate_Fields>;
  nodes: Array<AttributeValueUploads>;
};

export type AttributeValueUploads_Aggregate_Bool_Exp = {
  count?: InputMaybe<AttributeValueUploads_Aggregate_Bool_Exp_Count>;
};

export type AttributeValueUploads_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AttributeValueUploads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AttributeValueUploads_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "attributeValueUploads" */
export type AttributeValueUploads_Aggregate_Fields = {
  __typename?: 'attributeValueUploads_aggregate_fields';
  avg?: Maybe<AttributeValueUploads_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AttributeValueUploads_Max_Fields>;
  min?: Maybe<AttributeValueUploads_Min_Fields>;
  stddev?: Maybe<AttributeValueUploads_Stddev_Fields>;
  stddev_pop?: Maybe<AttributeValueUploads_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AttributeValueUploads_Stddev_Samp_Fields>;
  sum?: Maybe<AttributeValueUploads_Sum_Fields>;
  var_pop?: Maybe<AttributeValueUploads_Var_Pop_Fields>;
  var_samp?: Maybe<AttributeValueUploads_Var_Samp_Fields>;
  variance?: Maybe<AttributeValueUploads_Variance_Fields>;
};


/** aggregate fields of "attributeValueUploads" */
export type AttributeValueUploads_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AttributeValueUploads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "attributeValueUploads" */
export type AttributeValueUploads_Aggregate_Order_By = {
  avg?: InputMaybe<AttributeValueUploads_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AttributeValueUploads_Max_Order_By>;
  min?: InputMaybe<AttributeValueUploads_Min_Order_By>;
  stddev?: InputMaybe<AttributeValueUploads_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AttributeValueUploads_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AttributeValueUploads_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AttributeValueUploads_Sum_Order_By>;
  var_pop?: InputMaybe<AttributeValueUploads_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AttributeValueUploads_Var_Samp_Order_By>;
  variance?: InputMaybe<AttributeValueUploads_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "attributeValueUploads" */
export type AttributeValueUploads_Arr_Rel_Insert_Input = {
  data: Array<AttributeValueUploads_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AttributeValueUploads_On_Conflict>;
};

/** aggregate avg on columns */
export type AttributeValueUploads_Avg_Fields = {
  __typename?: 'attributeValueUploads_avg_fields';
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "attributeValueUploads" */
export type AttributeValueUploads_Avg_Order_By = {
  attributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "attributeValueUploads". All fields are combined with a logical 'AND'. */
export type AttributeValueUploads_Bool_Exp = {
  _and?: InputMaybe<Array<AttributeValueUploads_Bool_Exp>>;
  _not?: InputMaybe<AttributeValueUploads_Bool_Exp>;
  _or?: InputMaybe<Array<AttributeValueUploads_Bool_Exp>>;
  attributeValue?: InputMaybe<AttributeValues_Bool_Exp>;
  attributeValueId?: InputMaybe<Bigint_Comparison_Exp>;
  attributeValueUploadVersions?: InputMaybe<AttributeValueUploadVersions_Bool_Exp>;
  attributeValueUploadVersions_aggregate?: InputMaybe<AttributeValueUploadVersions_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "attributeValueUploads" */
export enum AttributeValueUploads_Constraint {
  /** unique or primary key constraint on columns "id" */
  AttributeValueUploadsPkey = 'attributeValueUploads_pkey'
}

/** input type for inserting data into table "attributeValueUploads" */
export type AttributeValueUploads_Insert_Input = {
  attributeValue?: InputMaybe<AttributeValues_Obj_Rel_Insert_Input>;
  attributeValueId?: InputMaybe<Scalars['bigint']['input']>;
  attributeValueUploadVersions?: InputMaybe<AttributeValueUploadVersions_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type AttributeValueUploads_Max_Fields = {
  __typename?: 'attributeValueUploads_max_fields';
  attributeValueId?: Maybe<Scalars['bigint']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "attributeValueUploads" */
export type AttributeValueUploads_Max_Order_By = {
  attributeValueId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AttributeValueUploads_Min_Fields = {
  __typename?: 'attributeValueUploads_min_fields';
  attributeValueId?: Maybe<Scalars['bigint']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "attributeValueUploads" */
export type AttributeValueUploads_Min_Order_By = {
  attributeValueId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "attributeValueUploads" */
export type AttributeValueUploads_Mutation_Response = {
  __typename?: 'attributeValueUploads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AttributeValueUploads>;
};

/** input type for inserting object relation for remote table "attributeValueUploads" */
export type AttributeValueUploads_Obj_Rel_Insert_Input = {
  data: AttributeValueUploads_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AttributeValueUploads_On_Conflict>;
};

/** on_conflict condition type for table "attributeValueUploads" */
export type AttributeValueUploads_On_Conflict = {
  constraint: AttributeValueUploads_Constraint;
  update_columns?: Array<AttributeValueUploads_Update_Column>;
  where?: InputMaybe<AttributeValueUploads_Bool_Exp>;
};

/** Ordering options when selecting data from "attributeValueUploads". */
export type AttributeValueUploads_Order_By = {
  attributeValue?: InputMaybe<AttributeValues_Order_By>;
  attributeValueId?: InputMaybe<Order_By>;
  attributeValueUploadVersions_aggregate?: InputMaybe<AttributeValueUploadVersions_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: attributeValueUploads */
export type AttributeValueUploads_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "attributeValueUploads" */
export enum AttributeValueUploads_Select_Column {
  /** column name */
  AttributeValueId = 'attributeValueId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "attributeValueUploads" */
export type AttributeValueUploads_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type AttributeValueUploads_Stddev_Fields = {
  __typename?: 'attributeValueUploads_stddev_fields';
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "attributeValueUploads" */
export type AttributeValueUploads_Stddev_Order_By = {
  attributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AttributeValueUploads_Stddev_Pop_Fields = {
  __typename?: 'attributeValueUploads_stddev_pop_fields';
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "attributeValueUploads" */
export type AttributeValueUploads_Stddev_Pop_Order_By = {
  attributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AttributeValueUploads_Stddev_Samp_Fields = {
  __typename?: 'attributeValueUploads_stddev_samp_fields';
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "attributeValueUploads" */
export type AttributeValueUploads_Stddev_Samp_Order_By = {
  attributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "attributeValueUploads" */
export type AttributeValueUploads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AttributeValueUploads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AttributeValueUploads_Stream_Cursor_Value_Input = {
  attributeValueId?: InputMaybe<Scalars['bigint']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type AttributeValueUploads_Sum_Fields = {
  __typename?: 'attributeValueUploads_sum_fields';
  attributeValueId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "attributeValueUploads" */
export type AttributeValueUploads_Sum_Order_By = {
  attributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "attributeValueUploads" */
export enum AttributeValueUploads_Update_Column {
  /** column name */
  Name = 'name'
}

export type AttributeValueUploads_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AttributeValueUploads_Set_Input>;
  /** filter the rows which have to be updated */
  where: AttributeValueUploads_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AttributeValueUploads_Var_Pop_Fields = {
  __typename?: 'attributeValueUploads_var_pop_fields';
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "attributeValueUploads" */
export type AttributeValueUploads_Var_Pop_Order_By = {
  attributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AttributeValueUploads_Var_Samp_Fields = {
  __typename?: 'attributeValueUploads_var_samp_fields';
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "attributeValueUploads" */
export type AttributeValueUploads_Var_Samp_Order_By = {
  attributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AttributeValueUploads_Variance_Fields = {
  __typename?: 'attributeValueUploads_variance_fields';
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "attributeValueUploads" */
export type AttributeValueUploads_Variance_Order_By = {
  attributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "attributeValues" */
export type AttributeValues = {
  __typename?: 'attributeValues';
  /** An object relationship */
  attribute: Attributes;
  attributeId: Scalars['bigint']['output'];
  /** An object relationship */
  attributeValueGroup: AttributeValueGroups;
  attributeValueGroupId: Scalars['bigint']['output'];
  /** An array relationship */
  attributeValueUploads: Array<AttributeValueUploads>;
  /** An aggregate relationship */
  attributeValueUploads_aggregate: AttributeValueUploads_Aggregate;
  /** An array relationship */
  comments: Array<AttributeValueComments>;
  /** An aggregate relationship */
  comments_aggregate: AttributeValueComments_Aggregate;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  fullUser?: Maybe<Users>;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  updatedBy_fullUser?: Maybe<Users>;
  /** An object relationship */
  updatedBy_user?: Maybe<AllUsers>;
  /** An object relationship */
  user?: Maybe<AllUsers>;
  userId?: Maybe<Scalars['bigint']['output']>;
  value: Scalars['json']['output'];
};


/** columns and relationships of "attributeValues" */
export type AttributeValuesAttributeValueUploadsArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueUploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueUploads_Order_By>>;
  where?: InputMaybe<AttributeValueUploads_Bool_Exp>;
};


/** columns and relationships of "attributeValues" */
export type AttributeValuesAttributeValueUploads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueUploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueUploads_Order_By>>;
  where?: InputMaybe<AttributeValueUploads_Bool_Exp>;
};


/** columns and relationships of "attributeValues" */
export type AttributeValuesCommentsArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueComments_Order_By>>;
  where?: InputMaybe<AttributeValueComments_Bool_Exp>;
};


/** columns and relationships of "attributeValues" */
export type AttributeValuesComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueComments_Order_By>>;
  where?: InputMaybe<AttributeValueComments_Bool_Exp>;
};


/** columns and relationships of "attributeValues" */
export type AttributeValuesNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "attributeValues" */
export type AttributeValuesNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "attributeValues" */
export type AttributeValuesValueArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "attributeValues" */
export type AttributeValues_Aggregate = {
  __typename?: 'attributeValues_aggregate';
  aggregate?: Maybe<AttributeValues_Aggregate_Fields>;
  nodes: Array<AttributeValues>;
};

export type AttributeValues_Aggregate_Bool_Exp = {
  count?: InputMaybe<AttributeValues_Aggregate_Bool_Exp_Count>;
};

export type AttributeValues_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AttributeValues_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AttributeValues_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "attributeValues" */
export type AttributeValues_Aggregate_Fields = {
  __typename?: 'attributeValues_aggregate_fields';
  avg?: Maybe<AttributeValues_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<AttributeValues_Max_Fields>;
  min?: Maybe<AttributeValues_Min_Fields>;
  stddev?: Maybe<AttributeValues_Stddev_Fields>;
  stddev_pop?: Maybe<AttributeValues_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AttributeValues_Stddev_Samp_Fields>;
  sum?: Maybe<AttributeValues_Sum_Fields>;
  var_pop?: Maybe<AttributeValues_Var_Pop_Fields>;
  var_samp?: Maybe<AttributeValues_Var_Samp_Fields>;
  variance?: Maybe<AttributeValues_Variance_Fields>;
};


/** aggregate fields of "attributeValues" */
export type AttributeValues_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AttributeValues_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "attributeValues" */
export type AttributeValues_Aggregate_Order_By = {
  avg?: InputMaybe<AttributeValues_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AttributeValues_Max_Order_By>;
  min?: InputMaybe<AttributeValues_Min_Order_By>;
  stddev?: InputMaybe<AttributeValues_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AttributeValues_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AttributeValues_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AttributeValues_Sum_Order_By>;
  var_pop?: InputMaybe<AttributeValues_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AttributeValues_Var_Samp_Order_By>;
  variance?: InputMaybe<AttributeValues_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "attributeValues" */
export type AttributeValues_Arr_Rel_Insert_Input = {
  data: Array<AttributeValues_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AttributeValues_On_Conflict>;
};

/** aggregate avg on columns */
export type AttributeValues_Avg_Fields = {
  __typename?: 'attributeValues_avg_fields';
  attributeId?: Maybe<Scalars['Float']['output']>;
  attributeValueGroupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "attributeValues" */
export type AttributeValues_Avg_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  attributeValueGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "attributeValues". All fields are combined with a logical 'AND'. */
export type AttributeValues_Bool_Exp = {
  _and?: InputMaybe<Array<AttributeValues_Bool_Exp>>;
  _not?: InputMaybe<AttributeValues_Bool_Exp>;
  _or?: InputMaybe<Array<AttributeValues_Bool_Exp>>;
  attribute?: InputMaybe<Attributes_Bool_Exp>;
  attributeId?: InputMaybe<Bigint_Comparison_Exp>;
  attributeValueGroup?: InputMaybe<AttributeValueGroups_Bool_Exp>;
  attributeValueGroupId?: InputMaybe<Bigint_Comparison_Exp>;
  attributeValueUploads?: InputMaybe<AttributeValueUploads_Bool_Exp>;
  attributeValueUploads_aggregate?: InputMaybe<AttributeValueUploads_Aggregate_Bool_Exp>;
  comments?: InputMaybe<AttributeValueComments_Bool_Exp>;
  comments_aggregate?: InputMaybe<AttributeValueComments_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  fullUser?: InputMaybe<Users_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedBy?: InputMaybe<Bigint_Comparison_Exp>;
  updatedBy_fullUser?: InputMaybe<Users_Bool_Exp>;
  updatedBy_user?: InputMaybe<AllUsers_Bool_Exp>;
  user?: InputMaybe<AllUsers_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
  value?: InputMaybe<Json_Comparison_Exp>;
};

/** unique or primary key constraints on table "attributeValues" */
export enum AttributeValues_Constraint {
  /** unique or primary key constraint on columns "attributeId", "attributeValueGroupId" */
  AttributeValuesAttributeIdAttributeValueGroupIdKey = 'attributeValues_attributeId_attributeValueGroupId_key',
  /** unique or primary key constraint on columns "id" */
  AttributeValuesPkey = 'attributeValues_pkey'
}

/** input type for incrementing numeric columns in table "attributeValues" */
export type AttributeValues_Inc_Input = {
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "attributeValues" */
export type AttributeValues_Insert_Input = {
  attribute?: InputMaybe<Attributes_Obj_Rel_Insert_Input>;
  attributeId?: InputMaybe<Scalars['bigint']['input']>;
  attributeValueGroup?: InputMaybe<AttributeValueGroups_Obj_Rel_Insert_Input>;
  attributeValueGroupId?: InputMaybe<Scalars['bigint']['input']>;
  attributeValueUploads?: InputMaybe<AttributeValueUploads_Arr_Rel_Insert_Input>;
  comments?: InputMaybe<AttributeValueComments_Arr_Rel_Insert_Input>;
  fullUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  updatedBy_fullUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['json']['input']>;
};

/** aggregate max on columns */
export type AttributeValues_Max_Fields = {
  __typename?: 'attributeValues_max_fields';
  attributeId?: Maybe<Scalars['bigint']['output']>;
  attributeValueGroupId?: Maybe<Scalars['bigint']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedBy?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "attributeValues" */
export type AttributeValues_Max_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  attributeValueGroupId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AttributeValues_Min_Fields = {
  __typename?: 'attributeValues_min_fields';
  attributeId?: Maybe<Scalars['bigint']['output']>;
  attributeValueGroupId?: Maybe<Scalars['bigint']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedBy?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "attributeValues" */
export type AttributeValues_Min_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  attributeValueGroupId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "attributeValues" */
export type AttributeValues_Mutation_Response = {
  __typename?: 'attributeValues_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AttributeValues>;
};

/** input type for inserting object relation for remote table "attributeValues" */
export type AttributeValues_Obj_Rel_Insert_Input = {
  data: AttributeValues_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AttributeValues_On_Conflict>;
};

/** on_conflict condition type for table "attributeValues" */
export type AttributeValues_On_Conflict = {
  constraint: AttributeValues_Constraint;
  update_columns?: Array<AttributeValues_Update_Column>;
  where?: InputMaybe<AttributeValues_Bool_Exp>;
};

/** Ordering options when selecting data from "attributeValues". */
export type AttributeValues_Order_By = {
  attribute?: InputMaybe<Attributes_Order_By>;
  attributeId?: InputMaybe<Order_By>;
  attributeValueGroup?: InputMaybe<AttributeValueGroups_Order_By>;
  attributeValueGroupId?: InputMaybe<Order_By>;
  attributeValueUploads_aggregate?: InputMaybe<AttributeValueUploads_Aggregate_Order_By>;
  comments_aggregate?: InputMaybe<AttributeValueComments_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fullUser?: InputMaybe<Users_Order_By>;
  id?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  updatedBy_fullUser?: InputMaybe<Users_Order_By>;
  updatedBy_user?: InputMaybe<AllUsers_Order_By>;
  user?: InputMaybe<AllUsers_Order_By>;
  userId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: attributeValues */
export type AttributeValues_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "attributeValues" */
export enum AttributeValues_Select_Column {
  /** column name */
  AttributeId = 'attributeId',
  /** column name */
  AttributeValueGroupId = 'attributeValueGroupId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  UserId = 'userId',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "attributeValues" */
export type AttributeValues_Set_Input = {
  userId?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['json']['input']>;
};

/** aggregate stddev on columns */
export type AttributeValues_Stddev_Fields = {
  __typename?: 'attributeValues_stddev_fields';
  attributeId?: Maybe<Scalars['Float']['output']>;
  attributeValueGroupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "attributeValues" */
export type AttributeValues_Stddev_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  attributeValueGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AttributeValues_Stddev_Pop_Fields = {
  __typename?: 'attributeValues_stddev_pop_fields';
  attributeId?: Maybe<Scalars['Float']['output']>;
  attributeValueGroupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "attributeValues" */
export type AttributeValues_Stddev_Pop_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  attributeValueGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AttributeValues_Stddev_Samp_Fields = {
  __typename?: 'attributeValues_stddev_samp_fields';
  attributeId?: Maybe<Scalars['Float']['output']>;
  attributeValueGroupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "attributeValues" */
export type AttributeValues_Stddev_Samp_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  attributeValueGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "attributeValues" */
export type AttributeValues_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AttributeValues_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AttributeValues_Stream_Cursor_Value_Input = {
  attributeId?: InputMaybe<Scalars['bigint']['input']>;
  attributeValueGroupId?: InputMaybe<Scalars['bigint']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['bigint']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['json']['input']>;
};

/** aggregate sum on columns */
export type AttributeValues_Sum_Fields = {
  __typename?: 'attributeValues_sum_fields';
  attributeId?: Maybe<Scalars['bigint']['output']>;
  attributeValueGroupId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updatedBy?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "attributeValues" */
export type AttributeValues_Sum_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  attributeValueGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "attributeValues" */
export enum AttributeValues_Update_Column {
  /** column name */
  UserId = 'userId',
  /** column name */
  Value = 'value'
}

export type AttributeValues_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AttributeValues_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AttributeValues_Set_Input>;
  /** filter the rows which have to be updated */
  where: AttributeValues_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AttributeValues_Var_Pop_Fields = {
  __typename?: 'attributeValues_var_pop_fields';
  attributeId?: Maybe<Scalars['Float']['output']>;
  attributeValueGroupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "attributeValues" */
export type AttributeValues_Var_Pop_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  attributeValueGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AttributeValues_Var_Samp_Fields = {
  __typename?: 'attributeValues_var_samp_fields';
  attributeId?: Maybe<Scalars['Float']['output']>;
  attributeValueGroupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "attributeValues" */
export type AttributeValues_Var_Samp_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  attributeValueGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AttributeValues_Variance_Fields = {
  __typename?: 'attributeValues_variance_fields';
  attributeId?: Maybe<Scalars['Float']['output']>;
  attributeValueGroupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "attributeValues" */
export type AttributeValues_Variance_Order_By = {
  attributeId?: InputMaybe<Order_By>;
  attributeValueGroupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "attributes" */
export type Attributes = {
  __typename?: 'attributes';
  /** An array relationship */
  attributeFiles: Array<AttributeFiles>;
  /** An aggregate relationship */
  attributeFiles_aggregate: AttributeFiles_Aggregate;
  /** An object relationship */
  attributeGroup: AttributeGroups;
  attributeGroupId: Scalars['bigint']['output'];
  attributeType: AttributeTypes_Enum;
  /** An array relationship */
  attributeValues: Array<AttributeValues>;
  /** An aggregate relationship */
  attributeValues_aggregate: AttributeValues_Aggregate;
  config: Scalars['json']['output'];
  createdAt: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  fileMaster?: Maybe<FileMasters>;
  fileMasterId?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  /** An object relationship */
  organisation?: Maybe<Organisations>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "attributes" */
export type AttributesAttributeFilesArgs = {
  distinct_on?: InputMaybe<Array<AttributeFiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeFiles_Order_By>>;
  where?: InputMaybe<AttributeFiles_Bool_Exp>;
};


/** columns and relationships of "attributes" */
export type AttributesAttributeFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeFiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeFiles_Order_By>>;
  where?: InputMaybe<AttributeFiles_Bool_Exp>;
};


/** columns and relationships of "attributes" */
export type AttributesAttributeValuesArgs = {
  distinct_on?: InputMaybe<Array<AttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValues_Order_By>>;
  where?: InputMaybe<AttributeValues_Bool_Exp>;
};


/** columns and relationships of "attributes" */
export type AttributesAttributeValues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValues_Order_By>>;
  where?: InputMaybe<AttributeValues_Bool_Exp>;
};


/** columns and relationships of "attributes" */
export type AttributesConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "attributes" */
export type Attributes_Aggregate = {
  __typename?: 'attributes_aggregate';
  aggregate?: Maybe<Attributes_Aggregate_Fields>;
  nodes: Array<Attributes>;
};

export type Attributes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Attributes_Aggregate_Bool_Exp_Count>;
};

export type Attributes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Attributes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Attributes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "attributes" */
export type Attributes_Aggregate_Fields = {
  __typename?: 'attributes_aggregate_fields';
  avg?: Maybe<Attributes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Attributes_Max_Fields>;
  min?: Maybe<Attributes_Min_Fields>;
  stddev?: Maybe<Attributes_Stddev_Fields>;
  stddev_pop?: Maybe<Attributes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Attributes_Stddev_Samp_Fields>;
  sum?: Maybe<Attributes_Sum_Fields>;
  var_pop?: Maybe<Attributes_Var_Pop_Fields>;
  var_samp?: Maybe<Attributes_Var_Samp_Fields>;
  variance?: Maybe<Attributes_Variance_Fields>;
};


/** aggregate fields of "attributes" */
export type Attributes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Attributes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "attributes" */
export type Attributes_Aggregate_Order_By = {
  avg?: InputMaybe<Attributes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Attributes_Max_Order_By>;
  min?: InputMaybe<Attributes_Min_Order_By>;
  stddev?: InputMaybe<Attributes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Attributes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Attributes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Attributes_Sum_Order_By>;
  var_pop?: InputMaybe<Attributes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Attributes_Var_Samp_Order_By>;
  variance?: InputMaybe<Attributes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "attributes" */
export type Attributes_Arr_Rel_Insert_Input = {
  data: Array<Attributes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Attributes_On_Conflict>;
};

/** aggregate avg on columns */
export type Attributes_Avg_Fields = {
  __typename?: 'attributes_avg_fields';
  attributeGroupId?: Maybe<Scalars['Float']['output']>;
  fileMasterId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "attributes" */
export type Attributes_Avg_Order_By = {
  attributeGroupId?: InputMaybe<Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "attributes". All fields are combined with a logical 'AND'. */
export type Attributes_Bool_Exp = {
  _and?: InputMaybe<Array<Attributes_Bool_Exp>>;
  _not?: InputMaybe<Attributes_Bool_Exp>;
  _or?: InputMaybe<Array<Attributes_Bool_Exp>>;
  attributeFiles?: InputMaybe<AttributeFiles_Bool_Exp>;
  attributeFiles_aggregate?: InputMaybe<AttributeFiles_Aggregate_Bool_Exp>;
  attributeGroup?: InputMaybe<AttributeGroups_Bool_Exp>;
  attributeGroupId?: InputMaybe<Bigint_Comparison_Exp>;
  attributeType?: InputMaybe<AttributeTypes_Enum_Comparison_Exp>;
  attributeValues?: InputMaybe<AttributeValues_Bool_Exp>;
  attributeValues_aggregate?: InputMaybe<AttributeValues_Aggregate_Bool_Exp>;
  config?: InputMaybe<Json_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  fileMaster?: InputMaybe<FileMasters_Bool_Exp>;
  fileMasterId?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisationId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "attributes" */
export enum Attributes_Constraint {
  /** unique or primary key constraint on columns "id" */
  AttributesPkey = 'attributes_pkey'
}

/** input type for incrementing numeric columns in table "attributes" */
export type Attributes_Inc_Input = {
  fileMasterId?: InputMaybe<Scalars['bigint']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "attributes" */
export type Attributes_Insert_Input = {
  attributeFiles?: InputMaybe<AttributeFiles_Arr_Rel_Insert_Input>;
  attributeGroup?: InputMaybe<AttributeGroups_Obj_Rel_Insert_Input>;
  attributeGroupId?: InputMaybe<Scalars['bigint']['input']>;
  attributeType?: InputMaybe<AttributeTypes_Enum>;
  attributeValues?: InputMaybe<AttributeValues_Arr_Rel_Insert_Input>;
  config?: InputMaybe<Scalars['json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileMaster?: InputMaybe<FileMasters_Obj_Rel_Insert_Input>;
  fileMasterId?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisation?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Attributes_Max_Fields = {
  __typename?: 'attributes_max_fields';
  attributeGroupId?: Maybe<Scalars['bigint']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fileMasterId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "attributes" */
export type Attributes_Max_Order_By = {
  attributeGroupId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Attributes_Min_Fields = {
  __typename?: 'attributes_min_fields';
  attributeGroupId?: Maybe<Scalars['bigint']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fileMasterId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "attributes" */
export type Attributes_Min_Order_By = {
  attributeGroupId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "attributes" */
export type Attributes_Mutation_Response = {
  __typename?: 'attributes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Attributes>;
};

/** input type for inserting object relation for remote table "attributes" */
export type Attributes_Obj_Rel_Insert_Input = {
  data: Attributes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Attributes_On_Conflict>;
};

/** on_conflict condition type for table "attributes" */
export type Attributes_On_Conflict = {
  constraint: Attributes_Constraint;
  update_columns?: Array<Attributes_Update_Column>;
  where?: InputMaybe<Attributes_Bool_Exp>;
};

/** Ordering options when selecting data from "attributes". */
export type Attributes_Order_By = {
  attributeFiles_aggregate?: InputMaybe<AttributeFiles_Aggregate_Order_By>;
  attributeGroup?: InputMaybe<AttributeGroups_Order_By>;
  attributeGroupId?: InputMaybe<Order_By>;
  attributeType?: InputMaybe<Order_By>;
  attributeValues_aggregate?: InputMaybe<AttributeValues_Aggregate_Order_By>;
  config?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  fileMaster?: InputMaybe<FileMasters_Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisations_Order_By>;
  organisationId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: attributes */
export type Attributes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "attributes" */
export enum Attributes_Select_Column {
  /** column name */
  AttributeGroupId = 'attributeGroupId',
  /** column name */
  AttributeType = 'attributeType',
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  FileMasterId = 'fileMasterId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganisationId = 'organisationId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "attributes" */
export type Attributes_Set_Input = {
  attributeType?: InputMaybe<AttributeTypes_Enum>;
  config?: InputMaybe<Scalars['json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileMasterId?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Attributes_Stddev_Fields = {
  __typename?: 'attributes_stddev_fields';
  attributeGroupId?: Maybe<Scalars['Float']['output']>;
  fileMasterId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "attributes" */
export type Attributes_Stddev_Order_By = {
  attributeGroupId?: InputMaybe<Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Attributes_Stddev_Pop_Fields = {
  __typename?: 'attributes_stddev_pop_fields';
  attributeGroupId?: Maybe<Scalars['Float']['output']>;
  fileMasterId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "attributes" */
export type Attributes_Stddev_Pop_Order_By = {
  attributeGroupId?: InputMaybe<Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Attributes_Stddev_Samp_Fields = {
  __typename?: 'attributes_stddev_samp_fields';
  attributeGroupId?: Maybe<Scalars['Float']['output']>;
  fileMasterId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "attributes" */
export type Attributes_Stddev_Samp_Order_By = {
  attributeGroupId?: InputMaybe<Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "attributes" */
export type Attributes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Attributes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Attributes_Stream_Cursor_Value_Input = {
  attributeGroupId?: InputMaybe<Scalars['bigint']['input']>;
  attributeType?: InputMaybe<AttributeTypes_Enum>;
  config?: InputMaybe<Scalars['json']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileMasterId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Attributes_Sum_Fields = {
  __typename?: 'attributes_sum_fields';
  attributeGroupId?: Maybe<Scalars['bigint']['output']>;
  fileMasterId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "attributes" */
export type Attributes_Sum_Order_By = {
  attributeGroupId?: InputMaybe<Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
};

/** update columns of table "attributes" */
export enum Attributes_Update_Column {
  /** column name */
  AttributeType = 'attributeType',
  /** column name */
  Config = 'config',
  /** column name */
  Description = 'description',
  /** column name */
  FileMasterId = 'fileMasterId',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  OrganisationId = 'organisationId'
}

export type Attributes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Attributes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Attributes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Attributes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Attributes_Var_Pop_Fields = {
  __typename?: 'attributes_var_pop_fields';
  attributeGroupId?: Maybe<Scalars['Float']['output']>;
  fileMasterId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "attributes" */
export type Attributes_Var_Pop_Order_By = {
  attributeGroupId?: InputMaybe<Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Attributes_Var_Samp_Fields = {
  __typename?: 'attributes_var_samp_fields';
  attributeGroupId?: Maybe<Scalars['Float']['output']>;
  fileMasterId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "attributes" */
export type Attributes_Var_Samp_Order_By = {
  attributeGroupId?: InputMaybe<Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Attributes_Variance_Fields = {
  __typename?: 'attributes_variance_fields';
  attributeGroupId?: Maybe<Scalars['Float']['output']>;
  fileMasterId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "attributes" */
export type Attributes_Variance_Order_By = {
  attributeGroupId?: InputMaybe<Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** Boolean expression to compare columns of type "bpchar". All fields are combined with logical 'AND'. */
export type Bpchar_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bpchar']['input']>;
  _gt?: InputMaybe<Scalars['bpchar']['input']>;
  _gte?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['bpchar']['input']>;
  _in?: InputMaybe<Array<Scalars['bpchar']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['bpchar']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['bpchar']['input']>;
  _lt?: InputMaybe<Scalars['bpchar']['input']>;
  _lte?: InputMaybe<Scalars['bpchar']['input']>;
  _neq?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['bpchar']['input']>;
  _nin?: InputMaybe<Array<Scalars['bpchar']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['bpchar']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['bpchar']['input']>;
};

/** columns and relationships of "cartLines" */
export type CartLines = {
  __typename?: 'cartLines';
  /** An object relationship */
  article?: Maybe<Articles>;
  articleId?: Maybe<Scalars['bigint']['output']>;
  cardId: Scalars['bigint']['output'];
  /** An object relationship */
  cart: Carts;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  file?: Maybe<Files>;
  fileId?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "cartLines" */
export type CartLines_Aggregate = {
  __typename?: 'cartLines_aggregate';
  aggregate?: Maybe<CartLines_Aggregate_Fields>;
  nodes: Array<CartLines>;
};

export type CartLines_Aggregate_Bool_Exp = {
  count?: InputMaybe<CartLines_Aggregate_Bool_Exp_Count>;
};

export type CartLines_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CartLines_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CartLines_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cartLines" */
export type CartLines_Aggregate_Fields = {
  __typename?: 'cartLines_aggregate_fields';
  avg?: Maybe<CartLines_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<CartLines_Max_Fields>;
  min?: Maybe<CartLines_Min_Fields>;
  stddev?: Maybe<CartLines_Stddev_Fields>;
  stddev_pop?: Maybe<CartLines_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CartLines_Stddev_Samp_Fields>;
  sum?: Maybe<CartLines_Sum_Fields>;
  var_pop?: Maybe<CartLines_Var_Pop_Fields>;
  var_samp?: Maybe<CartLines_Var_Samp_Fields>;
  variance?: Maybe<CartLines_Variance_Fields>;
};


/** aggregate fields of "cartLines" */
export type CartLines_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CartLines_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cartLines" */
export type CartLines_Aggregate_Order_By = {
  avg?: InputMaybe<CartLines_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CartLines_Max_Order_By>;
  min?: InputMaybe<CartLines_Min_Order_By>;
  stddev?: InputMaybe<CartLines_Stddev_Order_By>;
  stddev_pop?: InputMaybe<CartLines_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<CartLines_Stddev_Samp_Order_By>;
  sum?: InputMaybe<CartLines_Sum_Order_By>;
  var_pop?: InputMaybe<CartLines_Var_Pop_Order_By>;
  var_samp?: InputMaybe<CartLines_Var_Samp_Order_By>;
  variance?: InputMaybe<CartLines_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "cartLines" */
export type CartLines_Arr_Rel_Insert_Input = {
  data: Array<CartLines_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CartLines_On_Conflict>;
};

/** aggregate avg on columns */
export type CartLines_Avg_Fields = {
  __typename?: 'cartLines_avg_fields';
  articleId?: Maybe<Scalars['Float']['output']>;
  cardId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "cartLines" */
export type CartLines_Avg_Order_By = {
  articleId?: InputMaybe<Order_By>;
  cardId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "cartLines". All fields are combined with a logical 'AND'. */
export type CartLines_Bool_Exp = {
  _and?: InputMaybe<Array<CartLines_Bool_Exp>>;
  _not?: InputMaybe<CartLines_Bool_Exp>;
  _or?: InputMaybe<Array<CartLines_Bool_Exp>>;
  article?: InputMaybe<Articles_Bool_Exp>;
  articleId?: InputMaybe<Bigint_Comparison_Exp>;
  cardId?: InputMaybe<Bigint_Comparison_Exp>;
  cart?: InputMaybe<Carts_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  price?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "cartLines" */
export enum CartLines_Constraint {
  /** unique or primary key constraint on columns "id" */
  CartLinesPkey = 'cartLines_pkey'
}

/** input type for incrementing numeric columns in table "cartLines" */
export type CartLines_Inc_Input = {
  articleId?: InputMaybe<Scalars['bigint']['input']>;
  fileId?: InputMaybe<Scalars['bigint']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "cartLines" */
export type CartLines_Insert_Input = {
  article?: InputMaybe<Articles_Obj_Rel_Insert_Input>;
  articleId?: InputMaybe<Scalars['bigint']['input']>;
  cardId?: InputMaybe<Scalars['bigint']['input']>;
  cart?: InputMaybe<Carts_Obj_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type CartLines_Max_Fields = {
  __typename?: 'cartLines_max_fields';
  articleId?: Maybe<Scalars['bigint']['output']>;
  cardId?: Maybe<Scalars['bigint']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "cartLines" */
export type CartLines_Max_Order_By = {
  articleId?: InputMaybe<Order_By>;
  cardId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CartLines_Min_Fields = {
  __typename?: 'cartLines_min_fields';
  articleId?: Maybe<Scalars['bigint']['output']>;
  cardId?: Maybe<Scalars['bigint']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "cartLines" */
export type CartLines_Min_Order_By = {
  articleId?: InputMaybe<Order_By>;
  cardId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cartLines" */
export type CartLines_Mutation_Response = {
  __typename?: 'cartLines_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CartLines>;
};

/** on_conflict condition type for table "cartLines" */
export type CartLines_On_Conflict = {
  constraint: CartLines_Constraint;
  update_columns?: Array<CartLines_Update_Column>;
  where?: InputMaybe<CartLines_Bool_Exp>;
};

/** Ordering options when selecting data from "cartLines". */
export type CartLines_Order_By = {
  article?: InputMaybe<Articles_Order_By>;
  articleId?: InputMaybe<Order_By>;
  cardId?: InputMaybe<Order_By>;
  cart?: InputMaybe<Carts_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cartLines */
export type CartLines_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "cartLines" */
export enum CartLines_Select_Column {
  /** column name */
  ArticleId = 'articleId',
  /** column name */
  CardId = 'cardId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "cartLines" */
export type CartLines_Set_Input = {
  articleId?: InputMaybe<Scalars['bigint']['input']>;
  fileId?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type CartLines_Stddev_Fields = {
  __typename?: 'cartLines_stddev_fields';
  articleId?: Maybe<Scalars['Float']['output']>;
  cardId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "cartLines" */
export type CartLines_Stddev_Order_By = {
  articleId?: InputMaybe<Order_By>;
  cardId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type CartLines_Stddev_Pop_Fields = {
  __typename?: 'cartLines_stddev_pop_fields';
  articleId?: Maybe<Scalars['Float']['output']>;
  cardId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "cartLines" */
export type CartLines_Stddev_Pop_Order_By = {
  articleId?: InputMaybe<Order_By>;
  cardId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type CartLines_Stddev_Samp_Fields = {
  __typename?: 'cartLines_stddev_samp_fields';
  articleId?: Maybe<Scalars['Float']['output']>;
  cardId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "cartLines" */
export type CartLines_Stddev_Samp_Order_By = {
  articleId?: InputMaybe<Order_By>;
  cardId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cartLines" */
export type CartLines_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CartLines_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CartLines_Stream_Cursor_Value_Input = {
  articleId?: InputMaybe<Scalars['bigint']['input']>;
  cardId?: InputMaybe<Scalars['bigint']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type CartLines_Sum_Fields = {
  __typename?: 'cartLines_sum_fields';
  articleId?: Maybe<Scalars['bigint']['output']>;
  cardId?: Maybe<Scalars['bigint']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "cartLines" */
export type CartLines_Sum_Order_By = {
  articleId?: InputMaybe<Order_By>;
  cardId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** update columns of table "cartLines" */
export enum CartLines_Update_Column {
  /** column name */
  ArticleId = 'articleId',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Name = 'name',
  /** column name */
  Price = 'price'
}

export type CartLines_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CartLines_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CartLines_Set_Input>;
  /** filter the rows which have to be updated */
  where: CartLines_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CartLines_Var_Pop_Fields = {
  __typename?: 'cartLines_var_pop_fields';
  articleId?: Maybe<Scalars['Float']['output']>;
  cardId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "cartLines" */
export type CartLines_Var_Pop_Order_By = {
  articleId?: InputMaybe<Order_By>;
  cardId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type CartLines_Var_Samp_Fields = {
  __typename?: 'cartLines_var_samp_fields';
  articleId?: Maybe<Scalars['Float']['output']>;
  cardId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "cartLines" */
export type CartLines_Var_Samp_Order_By = {
  articleId?: InputMaybe<Order_By>;
  cardId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type CartLines_Variance_Fields = {
  __typename?: 'cartLines_variance_fields';
  articleId?: Maybe<Scalars['Float']['output']>;
  cardId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "cartLines" */
export type CartLines_Variance_Order_By = {
  articleId?: InputMaybe<Order_By>;
  cardId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** columns and relationships of "carts" */
export type Carts = {
  __typename?: 'carts';
  /** An array relationship */
  cartLines: Array<CartLines>;
  /** An aggregate relationship */
  cartLines_aggregate: CartLines_Aggregate;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  serviceModule: ServiceModules;
  serviceModuleId: Scalars['bigint']['output'];
  submittedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "carts" */
export type CartsCartLinesArgs = {
  distinct_on?: InputMaybe<Array<CartLines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CartLines_Order_By>>;
  where?: InputMaybe<CartLines_Bool_Exp>;
};


/** columns and relationships of "carts" */
export type CartsCartLines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CartLines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CartLines_Order_By>>;
  where?: InputMaybe<CartLines_Bool_Exp>;
};

/** aggregated selection of "carts" */
export type Carts_Aggregate = {
  __typename?: 'carts_aggregate';
  aggregate?: Maybe<Carts_Aggregate_Fields>;
  nodes: Array<Carts>;
};

export type Carts_Aggregate_Bool_Exp = {
  count?: InputMaybe<Carts_Aggregate_Bool_Exp_Count>;
};

export type Carts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Carts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Carts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "carts" */
export type Carts_Aggregate_Fields = {
  __typename?: 'carts_aggregate_fields';
  avg?: Maybe<Carts_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Carts_Max_Fields>;
  min?: Maybe<Carts_Min_Fields>;
  stddev?: Maybe<Carts_Stddev_Fields>;
  stddev_pop?: Maybe<Carts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Carts_Stddev_Samp_Fields>;
  sum?: Maybe<Carts_Sum_Fields>;
  var_pop?: Maybe<Carts_Var_Pop_Fields>;
  var_samp?: Maybe<Carts_Var_Samp_Fields>;
  variance?: Maybe<Carts_Variance_Fields>;
};


/** aggregate fields of "carts" */
export type Carts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Carts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "carts" */
export type Carts_Aggregate_Order_By = {
  avg?: InputMaybe<Carts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Carts_Max_Order_By>;
  min?: InputMaybe<Carts_Min_Order_By>;
  stddev?: InputMaybe<Carts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Carts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Carts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Carts_Sum_Order_By>;
  var_pop?: InputMaybe<Carts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Carts_Var_Samp_Order_By>;
  variance?: InputMaybe<Carts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "carts" */
export type Carts_Arr_Rel_Insert_Input = {
  data: Array<Carts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Carts_On_Conflict>;
};

/** aggregate avg on columns */
export type Carts_Avg_Fields = {
  __typename?: 'carts_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "carts" */
export type Carts_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "carts". All fields are combined with a logical 'AND'. */
export type Carts_Bool_Exp = {
  _and?: InputMaybe<Array<Carts_Bool_Exp>>;
  _not?: InputMaybe<Carts_Bool_Exp>;
  _or?: InputMaybe<Array<Carts_Bool_Exp>>;
  cartLines?: InputMaybe<CartLines_Bool_Exp>;
  cartLines_aggregate?: InputMaybe<CartLines_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  serviceModule?: InputMaybe<ServiceModules_Bool_Exp>;
  serviceModuleId?: InputMaybe<Bigint_Comparison_Exp>;
  submittedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "carts" */
export enum Carts_Constraint {
  /** unique or primary key constraint on columns "id" */
  CartsPkey = 'carts_pkey'
}

/** input type for inserting data into table "carts" */
export type Carts_Insert_Input = {
  cartLines?: InputMaybe<CartLines_Arr_Rel_Insert_Input>;
  serviceModule?: InputMaybe<ServiceModules_Obj_Rel_Insert_Input>;
  serviceModuleId?: InputMaybe<Scalars['bigint']['input']>;
  submittedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Carts_Max_Fields = {
  __typename?: 'carts_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  submittedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "carts" */
export type Carts_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  submittedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Carts_Min_Fields = {
  __typename?: 'carts_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  submittedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "carts" */
export type Carts_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  submittedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "carts" */
export type Carts_Mutation_Response = {
  __typename?: 'carts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Carts>;
};

/** input type for inserting object relation for remote table "carts" */
export type Carts_Obj_Rel_Insert_Input = {
  data: Carts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Carts_On_Conflict>;
};

/** on_conflict condition type for table "carts" */
export type Carts_On_Conflict = {
  constraint: Carts_Constraint;
  update_columns?: Array<Carts_Update_Column>;
  where?: InputMaybe<Carts_Bool_Exp>;
};

/** Ordering options when selecting data from "carts". */
export type Carts_Order_By = {
  cartLines_aggregate?: InputMaybe<CartLines_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  serviceModule?: InputMaybe<ServiceModules_Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  submittedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: carts */
export type Carts_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "carts" */
export enum Carts_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ServiceModuleId = 'serviceModuleId',
  /** column name */
  SubmittedAt = 'submittedAt',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "carts" */
export type Carts_Set_Input = {
  submittedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Carts_Stddev_Fields = {
  __typename?: 'carts_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "carts" */
export type Carts_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Carts_Stddev_Pop_Fields = {
  __typename?: 'carts_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "carts" */
export type Carts_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Carts_Stddev_Samp_Fields = {
  __typename?: 'carts_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "carts" */
export type Carts_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "carts" */
export type Carts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Carts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Carts_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  serviceModuleId?: InputMaybe<Scalars['bigint']['input']>;
  submittedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Carts_Sum_Fields = {
  __typename?: 'carts_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "carts" */
export type Carts_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** update columns of table "carts" */
export enum Carts_Update_Column {
  /** column name */
  SubmittedAt = 'submittedAt'
}

export type Carts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Carts_Set_Input>;
  /** filter the rows which have to be updated */
  where: Carts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Carts_Var_Pop_Fields = {
  __typename?: 'carts_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "carts" */
export type Carts_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Carts_Var_Samp_Fields = {
  __typename?: 'carts_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "carts" */
export type Carts_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Carts_Variance_Fields = {
  __typename?: 'carts_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "carts" */
export type Carts_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** columns and relationships of "catalogFolderArticles" */
export type CatalogFolderArticles = {
  __typename?: 'catalogFolderArticles';
  /** An object relationship */
  article: Articles;
  articleId: Scalars['bigint']['output'];
  /** An object relationship */
  catalogFolder: CatalogFolders;
  catalogFolderId: Scalars['bigint']['output'];
};

/** aggregated selection of "catalogFolderArticles" */
export type CatalogFolderArticles_Aggregate = {
  __typename?: 'catalogFolderArticles_aggregate';
  aggregate?: Maybe<CatalogFolderArticles_Aggregate_Fields>;
  nodes: Array<CatalogFolderArticles>;
};

export type CatalogFolderArticles_Aggregate_Bool_Exp = {
  count?: InputMaybe<CatalogFolderArticles_Aggregate_Bool_Exp_Count>;
};

export type CatalogFolderArticles_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CatalogFolderArticles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CatalogFolderArticles_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "catalogFolderArticles" */
export type CatalogFolderArticles_Aggregate_Fields = {
  __typename?: 'catalogFolderArticles_aggregate_fields';
  avg?: Maybe<CatalogFolderArticles_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<CatalogFolderArticles_Max_Fields>;
  min?: Maybe<CatalogFolderArticles_Min_Fields>;
  stddev?: Maybe<CatalogFolderArticles_Stddev_Fields>;
  stddev_pop?: Maybe<CatalogFolderArticles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CatalogFolderArticles_Stddev_Samp_Fields>;
  sum?: Maybe<CatalogFolderArticles_Sum_Fields>;
  var_pop?: Maybe<CatalogFolderArticles_Var_Pop_Fields>;
  var_samp?: Maybe<CatalogFolderArticles_Var_Samp_Fields>;
  variance?: Maybe<CatalogFolderArticles_Variance_Fields>;
};


/** aggregate fields of "catalogFolderArticles" */
export type CatalogFolderArticles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CatalogFolderArticles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "catalogFolderArticles" */
export type CatalogFolderArticles_Aggregate_Order_By = {
  avg?: InputMaybe<CatalogFolderArticles_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CatalogFolderArticles_Max_Order_By>;
  min?: InputMaybe<CatalogFolderArticles_Min_Order_By>;
  stddev?: InputMaybe<CatalogFolderArticles_Stddev_Order_By>;
  stddev_pop?: InputMaybe<CatalogFolderArticles_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<CatalogFolderArticles_Stddev_Samp_Order_By>;
  sum?: InputMaybe<CatalogFolderArticles_Sum_Order_By>;
  var_pop?: InputMaybe<CatalogFolderArticles_Var_Pop_Order_By>;
  var_samp?: InputMaybe<CatalogFolderArticles_Var_Samp_Order_By>;
  variance?: InputMaybe<CatalogFolderArticles_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "catalogFolderArticles" */
export type CatalogFolderArticles_Arr_Rel_Insert_Input = {
  data: Array<CatalogFolderArticles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CatalogFolderArticles_On_Conflict>;
};

/** aggregate avg on columns */
export type CatalogFolderArticles_Avg_Fields = {
  __typename?: 'catalogFolderArticles_avg_fields';
  articleId?: Maybe<Scalars['Float']['output']>;
  catalogFolderId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "catalogFolderArticles" */
export type CatalogFolderArticles_Avg_Order_By = {
  articleId?: InputMaybe<Order_By>;
  catalogFolderId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "catalogFolderArticles". All fields are combined with a logical 'AND'. */
export type CatalogFolderArticles_Bool_Exp = {
  _and?: InputMaybe<Array<CatalogFolderArticles_Bool_Exp>>;
  _not?: InputMaybe<CatalogFolderArticles_Bool_Exp>;
  _or?: InputMaybe<Array<CatalogFolderArticles_Bool_Exp>>;
  article?: InputMaybe<Articles_Bool_Exp>;
  articleId?: InputMaybe<Bigint_Comparison_Exp>;
  catalogFolder?: InputMaybe<CatalogFolders_Bool_Exp>;
  catalogFolderId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "catalogFolderArticles" */
export enum CatalogFolderArticles_Constraint {
  /** unique or primary key constraint on columns "articleId", "catalogFolderId" */
  CatalogFolderArticlesPkey = 'catalogFolderArticles_pkey'
}

/** input type for inserting data into table "catalogFolderArticles" */
export type CatalogFolderArticles_Insert_Input = {
  article?: InputMaybe<Articles_Obj_Rel_Insert_Input>;
  articleId?: InputMaybe<Scalars['bigint']['input']>;
  catalogFolder?: InputMaybe<CatalogFolders_Obj_Rel_Insert_Input>;
  catalogFolderId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type CatalogFolderArticles_Max_Fields = {
  __typename?: 'catalogFolderArticles_max_fields';
  articleId?: Maybe<Scalars['bigint']['output']>;
  catalogFolderId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "catalogFolderArticles" */
export type CatalogFolderArticles_Max_Order_By = {
  articleId?: InputMaybe<Order_By>;
  catalogFolderId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CatalogFolderArticles_Min_Fields = {
  __typename?: 'catalogFolderArticles_min_fields';
  articleId?: Maybe<Scalars['bigint']['output']>;
  catalogFolderId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "catalogFolderArticles" */
export type CatalogFolderArticles_Min_Order_By = {
  articleId?: InputMaybe<Order_By>;
  catalogFolderId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "catalogFolderArticles" */
export type CatalogFolderArticles_Mutation_Response = {
  __typename?: 'catalogFolderArticles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CatalogFolderArticles>;
};

/** on_conflict condition type for table "catalogFolderArticles" */
export type CatalogFolderArticles_On_Conflict = {
  constraint: CatalogFolderArticles_Constraint;
  update_columns?: Array<CatalogFolderArticles_Update_Column>;
  where?: InputMaybe<CatalogFolderArticles_Bool_Exp>;
};

/** Ordering options when selecting data from "catalogFolderArticles". */
export type CatalogFolderArticles_Order_By = {
  article?: InputMaybe<Articles_Order_By>;
  articleId?: InputMaybe<Order_By>;
  catalogFolder?: InputMaybe<CatalogFolders_Order_By>;
  catalogFolderId?: InputMaybe<Order_By>;
};

/** select columns of table "catalogFolderArticles" */
export enum CatalogFolderArticles_Select_Column {
  /** column name */
  ArticleId = 'articleId',
  /** column name */
  CatalogFolderId = 'catalogFolderId'
}

/** aggregate stddev on columns */
export type CatalogFolderArticles_Stddev_Fields = {
  __typename?: 'catalogFolderArticles_stddev_fields';
  articleId?: Maybe<Scalars['Float']['output']>;
  catalogFolderId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "catalogFolderArticles" */
export type CatalogFolderArticles_Stddev_Order_By = {
  articleId?: InputMaybe<Order_By>;
  catalogFolderId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type CatalogFolderArticles_Stddev_Pop_Fields = {
  __typename?: 'catalogFolderArticles_stddev_pop_fields';
  articleId?: Maybe<Scalars['Float']['output']>;
  catalogFolderId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "catalogFolderArticles" */
export type CatalogFolderArticles_Stddev_Pop_Order_By = {
  articleId?: InputMaybe<Order_By>;
  catalogFolderId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type CatalogFolderArticles_Stddev_Samp_Fields = {
  __typename?: 'catalogFolderArticles_stddev_samp_fields';
  articleId?: Maybe<Scalars['Float']['output']>;
  catalogFolderId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "catalogFolderArticles" */
export type CatalogFolderArticles_Stddev_Samp_Order_By = {
  articleId?: InputMaybe<Order_By>;
  catalogFolderId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "catalogFolderArticles" */
export type CatalogFolderArticles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CatalogFolderArticles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CatalogFolderArticles_Stream_Cursor_Value_Input = {
  articleId?: InputMaybe<Scalars['bigint']['input']>;
  catalogFolderId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type CatalogFolderArticles_Sum_Fields = {
  __typename?: 'catalogFolderArticles_sum_fields';
  articleId?: Maybe<Scalars['bigint']['output']>;
  catalogFolderId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "catalogFolderArticles" */
export type CatalogFolderArticles_Sum_Order_By = {
  articleId?: InputMaybe<Order_By>;
  catalogFolderId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "catalogFolderArticles" (current role has no relevant permissions) */
export enum CatalogFolderArticles_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type CatalogFolderArticles_Var_Pop_Fields = {
  __typename?: 'catalogFolderArticles_var_pop_fields';
  articleId?: Maybe<Scalars['Float']['output']>;
  catalogFolderId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "catalogFolderArticles" */
export type CatalogFolderArticles_Var_Pop_Order_By = {
  articleId?: InputMaybe<Order_By>;
  catalogFolderId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type CatalogFolderArticles_Var_Samp_Fields = {
  __typename?: 'catalogFolderArticles_var_samp_fields';
  articleId?: Maybe<Scalars['Float']['output']>;
  catalogFolderId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "catalogFolderArticles" */
export type CatalogFolderArticles_Var_Samp_Order_By = {
  articleId?: InputMaybe<Order_By>;
  catalogFolderId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type CatalogFolderArticles_Variance_Fields = {
  __typename?: 'catalogFolderArticles_variance_fields';
  articleId?: Maybe<Scalars['Float']['output']>;
  catalogFolderId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "catalogFolderArticles" */
export type CatalogFolderArticles_Variance_Order_By = {
  articleId?: InputMaybe<Order_By>;
  catalogFolderId?: InputMaybe<Order_By>;
};

/** columns and relationships of "catalogFolders" */
export type CatalogFolders = {
  __typename?: 'catalogFolders';
  /** An array relationship */
  catalogFolderArticles: Array<CatalogFolderArticles>;
  /** An aggregate relationship */
  catalogFolderArticles_aggregate: CatalogFolderArticles_Aggregate;
  /** An array relationship */
  catalogFolders: Array<CatalogFolders>;
  /** An aggregate relationship */
  catalogFolders_aggregate: CatalogFolders_Aggregate;
  catalogId?: Maybe<Scalars['bigint']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  parentFolder?: Maybe<CatalogFolders>;
  parentId?: Maybe<Scalars['bigint']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "catalogFolders" */
export type CatalogFoldersCatalogFolderArticlesArgs = {
  distinct_on?: InputMaybe<Array<CatalogFolderArticles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CatalogFolderArticles_Order_By>>;
  where?: InputMaybe<CatalogFolderArticles_Bool_Exp>;
};


/** columns and relationships of "catalogFolders" */
export type CatalogFoldersCatalogFolderArticles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CatalogFolderArticles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CatalogFolderArticles_Order_By>>;
  where?: InputMaybe<CatalogFolderArticles_Bool_Exp>;
};


/** columns and relationships of "catalogFolders" */
export type CatalogFoldersCatalogFoldersArgs = {
  distinct_on?: InputMaybe<Array<CatalogFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CatalogFolders_Order_By>>;
  where?: InputMaybe<CatalogFolders_Bool_Exp>;
};


/** columns and relationships of "catalogFolders" */
export type CatalogFoldersCatalogFolders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CatalogFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CatalogFolders_Order_By>>;
  where?: InputMaybe<CatalogFolders_Bool_Exp>;
};

/** aggregated selection of "catalogFolders" */
export type CatalogFolders_Aggregate = {
  __typename?: 'catalogFolders_aggregate';
  aggregate?: Maybe<CatalogFolders_Aggregate_Fields>;
  nodes: Array<CatalogFolders>;
};

export type CatalogFolders_Aggregate_Bool_Exp = {
  count?: InputMaybe<CatalogFolders_Aggregate_Bool_Exp_Count>;
};

export type CatalogFolders_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CatalogFolders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CatalogFolders_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "catalogFolders" */
export type CatalogFolders_Aggregate_Fields = {
  __typename?: 'catalogFolders_aggregate_fields';
  avg?: Maybe<CatalogFolders_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<CatalogFolders_Max_Fields>;
  min?: Maybe<CatalogFolders_Min_Fields>;
  stddev?: Maybe<CatalogFolders_Stddev_Fields>;
  stddev_pop?: Maybe<CatalogFolders_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CatalogFolders_Stddev_Samp_Fields>;
  sum?: Maybe<CatalogFolders_Sum_Fields>;
  var_pop?: Maybe<CatalogFolders_Var_Pop_Fields>;
  var_samp?: Maybe<CatalogFolders_Var_Samp_Fields>;
  variance?: Maybe<CatalogFolders_Variance_Fields>;
};


/** aggregate fields of "catalogFolders" */
export type CatalogFolders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CatalogFolders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "catalogFolders" */
export type CatalogFolders_Aggregate_Order_By = {
  avg?: InputMaybe<CatalogFolders_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CatalogFolders_Max_Order_By>;
  min?: InputMaybe<CatalogFolders_Min_Order_By>;
  stddev?: InputMaybe<CatalogFolders_Stddev_Order_By>;
  stddev_pop?: InputMaybe<CatalogFolders_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<CatalogFolders_Stddev_Samp_Order_By>;
  sum?: InputMaybe<CatalogFolders_Sum_Order_By>;
  var_pop?: InputMaybe<CatalogFolders_Var_Pop_Order_By>;
  var_samp?: InputMaybe<CatalogFolders_Var_Samp_Order_By>;
  variance?: InputMaybe<CatalogFolders_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "catalogFolders" */
export type CatalogFolders_Arr_Rel_Insert_Input = {
  data: Array<CatalogFolders_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CatalogFolders_On_Conflict>;
};

/** aggregate avg on columns */
export type CatalogFolders_Avg_Fields = {
  __typename?: 'catalogFolders_avg_fields';
  catalogId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "catalogFolders" */
export type CatalogFolders_Avg_Order_By = {
  catalogId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "catalogFolders". All fields are combined with a logical 'AND'. */
export type CatalogFolders_Bool_Exp = {
  _and?: InputMaybe<Array<CatalogFolders_Bool_Exp>>;
  _not?: InputMaybe<CatalogFolders_Bool_Exp>;
  _or?: InputMaybe<Array<CatalogFolders_Bool_Exp>>;
  catalogFolderArticles?: InputMaybe<CatalogFolderArticles_Bool_Exp>;
  catalogFolderArticles_aggregate?: InputMaybe<CatalogFolderArticles_Aggregate_Bool_Exp>;
  catalogFolders?: InputMaybe<CatalogFolders_Bool_Exp>;
  catalogFolders_aggregate?: InputMaybe<CatalogFolders_Aggregate_Bool_Exp>;
  catalogId?: InputMaybe<Bigint_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  parentFolder?: InputMaybe<CatalogFolders_Bool_Exp>;
  parentId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "catalogFolders" */
export enum CatalogFolders_Constraint {
  /** unique or primary key constraint on columns "id" */
  CatalogFoldersPkey = 'catalogFolders_pkey'
}

/** input type for incrementing numeric columns in table "catalogFolders" */
export type CatalogFolders_Inc_Input = {
  catalogId?: InputMaybe<Scalars['bigint']['input']>;
  parentId?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "catalogFolders" */
export type CatalogFolders_Insert_Input = {
  catalogFolderArticles?: InputMaybe<CatalogFolderArticles_Arr_Rel_Insert_Input>;
  catalogFolders?: InputMaybe<CatalogFolders_Arr_Rel_Insert_Input>;
  catalogId?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentFolder?: InputMaybe<CatalogFolders_Obj_Rel_Insert_Input>;
  parentId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type CatalogFolders_Max_Fields = {
  __typename?: 'catalogFolders_max_fields';
  catalogId?: Maybe<Scalars['bigint']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "catalogFolders" */
export type CatalogFolders_Max_Order_By = {
  catalogId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CatalogFolders_Min_Fields = {
  __typename?: 'catalogFolders_min_fields';
  catalogId?: Maybe<Scalars['bigint']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "catalogFolders" */
export type CatalogFolders_Min_Order_By = {
  catalogId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "catalogFolders" */
export type CatalogFolders_Mutation_Response = {
  __typename?: 'catalogFolders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CatalogFolders>;
};

/** input type for inserting object relation for remote table "catalogFolders" */
export type CatalogFolders_Obj_Rel_Insert_Input = {
  data: CatalogFolders_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<CatalogFolders_On_Conflict>;
};

/** on_conflict condition type for table "catalogFolders" */
export type CatalogFolders_On_Conflict = {
  constraint: CatalogFolders_Constraint;
  update_columns?: Array<CatalogFolders_Update_Column>;
  where?: InputMaybe<CatalogFolders_Bool_Exp>;
};

/** Ordering options when selecting data from "catalogFolders". */
export type CatalogFolders_Order_By = {
  catalogFolderArticles_aggregate?: InputMaybe<CatalogFolderArticles_Aggregate_Order_By>;
  catalogFolders_aggregate?: InputMaybe<CatalogFolders_Aggregate_Order_By>;
  catalogId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parentFolder?: InputMaybe<CatalogFolders_Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: catalogFolders */
export type CatalogFolders_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "catalogFolders" */
export enum CatalogFolders_Select_Column {
  /** column name */
  CatalogId = 'catalogId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "catalogFolders" */
export type CatalogFolders_Set_Input = {
  catalogId?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type CatalogFolders_Stddev_Fields = {
  __typename?: 'catalogFolders_stddev_fields';
  catalogId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "catalogFolders" */
export type CatalogFolders_Stddev_Order_By = {
  catalogId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type CatalogFolders_Stddev_Pop_Fields = {
  __typename?: 'catalogFolders_stddev_pop_fields';
  catalogId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "catalogFolders" */
export type CatalogFolders_Stddev_Pop_Order_By = {
  catalogId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type CatalogFolders_Stddev_Samp_Fields = {
  __typename?: 'catalogFolders_stddev_samp_fields';
  catalogId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "catalogFolders" */
export type CatalogFolders_Stddev_Samp_Order_By = {
  catalogId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "catalogFolders" */
export type CatalogFolders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CatalogFolders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CatalogFolders_Stream_Cursor_Value_Input = {
  catalogId?: InputMaybe<Scalars['bigint']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type CatalogFolders_Sum_Fields = {
  __typename?: 'catalogFolders_sum_fields';
  catalogId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  parentId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "catalogFolders" */
export type CatalogFolders_Sum_Order_By = {
  catalogId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** update columns of table "catalogFolders" */
export enum CatalogFolders_Update_Column {
  /** column name */
  CatalogId = 'catalogId',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parentId'
}

export type CatalogFolders_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CatalogFolders_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CatalogFolders_Set_Input>;
  /** filter the rows which have to be updated */
  where: CatalogFolders_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CatalogFolders_Var_Pop_Fields = {
  __typename?: 'catalogFolders_var_pop_fields';
  catalogId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "catalogFolders" */
export type CatalogFolders_Var_Pop_Order_By = {
  catalogId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type CatalogFolders_Var_Samp_Fields = {
  __typename?: 'catalogFolders_var_samp_fields';
  catalogId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "catalogFolders" */
export type CatalogFolders_Var_Samp_Order_By = {
  catalogId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type CatalogFolders_Variance_Fields = {
  __typename?: 'catalogFolders_variance_fields';
  catalogId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "catalogFolders" */
export type CatalogFolders_Variance_Order_By = {
  catalogId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  ASC = 'ASC',
  /** descending ordering of the cursor */
  DESC = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "eventAttributeGroups" */
export type EventAttributeGroups = {
  __typename?: 'eventAttributeGroups';
  createdAt: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  eventAttributes: Array<EventAttributes>;
  /** An aggregate relationship */
  eventAttributes_aggregate: EventAttributes_Aggregate;
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "eventAttributeGroups" */
export type EventAttributeGroupsEventAttributesArgs = {
  distinct_on?: InputMaybe<Array<EventAttributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributes_Order_By>>;
  where?: InputMaybe<EventAttributes_Bool_Exp>;
};


/** columns and relationships of "eventAttributeGroups" */
export type EventAttributeGroupsEventAttributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAttributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributes_Order_By>>;
  where?: InputMaybe<EventAttributes_Bool_Exp>;
};

/** aggregated selection of "eventAttributeGroups" */
export type EventAttributeGroups_Aggregate = {
  __typename?: 'eventAttributeGroups_aggregate';
  aggregate?: Maybe<EventAttributeGroups_Aggregate_Fields>;
  nodes: Array<EventAttributeGroups>;
};

/** aggregate fields of "eventAttributeGroups" */
export type EventAttributeGroups_Aggregate_Fields = {
  __typename?: 'eventAttributeGroups_aggregate_fields';
  avg?: Maybe<EventAttributeGroups_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EventAttributeGroups_Max_Fields>;
  min?: Maybe<EventAttributeGroups_Min_Fields>;
  stddev?: Maybe<EventAttributeGroups_Stddev_Fields>;
  stddev_pop?: Maybe<EventAttributeGroups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EventAttributeGroups_Stddev_Samp_Fields>;
  sum?: Maybe<EventAttributeGroups_Sum_Fields>;
  var_pop?: Maybe<EventAttributeGroups_Var_Pop_Fields>;
  var_samp?: Maybe<EventAttributeGroups_Var_Samp_Fields>;
  variance?: Maybe<EventAttributeGroups_Variance_Fields>;
};


/** aggregate fields of "eventAttributeGroups" */
export type EventAttributeGroups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EventAttributeGroups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type EventAttributeGroups_Avg_Fields = {
  __typename?: 'eventAttributeGroups_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "eventAttributeGroups". All fields are combined with a logical 'AND'. */
export type EventAttributeGroups_Bool_Exp = {
  _and?: InputMaybe<Array<EventAttributeGroups_Bool_Exp>>;
  _not?: InputMaybe<EventAttributeGroups_Bool_Exp>;
  _or?: InputMaybe<Array<EventAttributeGroups_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  eventAttributes?: InputMaybe<EventAttributes_Bool_Exp>;
  eventAttributes_aggregate?: InputMaybe<EventAttributes_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "eventAttributeGroups" */
export enum EventAttributeGroups_Constraint {
  /** unique or primary key constraint on columns "id" */
  EventAttributeGroupsPkey = 'eventAttributeGroups_pkey'
}

/** input type for incrementing numeric columns in table "eventAttributeGroups" */
export type EventAttributeGroups_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eventAttributeGroups" */
export type EventAttributeGroups_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  eventAttributes?: InputMaybe<EventAttributes_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type EventAttributeGroups_Max_Fields = {
  __typename?: 'eventAttributeGroups_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type EventAttributeGroups_Min_Fields = {
  __typename?: 'eventAttributeGroups_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "eventAttributeGroups" */
export type EventAttributeGroups_Mutation_Response = {
  __typename?: 'eventAttributeGroups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EventAttributeGroups>;
};

/** input type for inserting object relation for remote table "eventAttributeGroups" */
export type EventAttributeGroups_Obj_Rel_Insert_Input = {
  data: EventAttributeGroups_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EventAttributeGroups_On_Conflict>;
};

/** on_conflict condition type for table "eventAttributeGroups" */
export type EventAttributeGroups_On_Conflict = {
  constraint: EventAttributeGroups_Constraint;
  update_columns?: Array<EventAttributeGroups_Update_Column>;
  where?: InputMaybe<EventAttributeGroups_Bool_Exp>;
};

/** Ordering options when selecting data from "eventAttributeGroups". */
export type EventAttributeGroups_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  eventAttributes_aggregate?: InputMaybe<EventAttributes_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eventAttributeGroups */
export type EventAttributeGroups_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "eventAttributeGroups" */
export enum EventAttributeGroups_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "eventAttributeGroups" */
export type EventAttributeGroups_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type EventAttributeGroups_Stddev_Fields = {
  __typename?: 'eventAttributeGroups_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type EventAttributeGroups_Stddev_Pop_Fields = {
  __typename?: 'eventAttributeGroups_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type EventAttributeGroups_Stddev_Samp_Fields = {
  __typename?: 'eventAttributeGroups_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "eventAttributeGroups" */
export type EventAttributeGroups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventAttributeGroups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EventAttributeGroups_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type EventAttributeGroups_Sum_Fields = {
  __typename?: 'eventAttributeGroups_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "eventAttributeGroups" */
export enum EventAttributeGroups_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order'
}

export type EventAttributeGroups_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventAttributeGroups_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventAttributeGroups_Set_Input>;
  /** filter the rows which have to be updated */
  where: EventAttributeGroups_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EventAttributeGroups_Var_Pop_Fields = {
  __typename?: 'eventAttributeGroups_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type EventAttributeGroups_Var_Samp_Fields = {
  __typename?: 'eventAttributeGroups_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type EventAttributeGroups_Variance_Fields = {
  __typename?: 'eventAttributeGroups_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "eventAttributeValueUploadVersions" */
export type EventAttributeValueUploadVersions = {
  __typename?: 'eventAttributeValueUploadVersions';
  /** A computed field, executes function "eventAttributeValueUploadVersions_downloadUrl" */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  eventAttributeValueUpload: EventAttributeValueUploads;
  eventAttributeValueUploadId: Scalars['bigint']['output'];
  /** An object relationship */
  file: Files;
  fileId: Scalars['bigint']['output'];
};

/** aggregated selection of "eventAttributeValueUploadVersions" */
export type EventAttributeValueUploadVersions_Aggregate = {
  __typename?: 'eventAttributeValueUploadVersions_aggregate';
  aggregate?: Maybe<EventAttributeValueUploadVersions_Aggregate_Fields>;
  nodes: Array<EventAttributeValueUploadVersions>;
};

export type EventAttributeValueUploadVersions_Aggregate_Bool_Exp = {
  count?: InputMaybe<EventAttributeValueUploadVersions_Aggregate_Bool_Exp_Count>;
};

export type EventAttributeValueUploadVersions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EventAttributeValueUploadVersions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EventAttributeValueUploadVersions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eventAttributeValueUploadVersions" */
export type EventAttributeValueUploadVersions_Aggregate_Fields = {
  __typename?: 'eventAttributeValueUploadVersions_aggregate_fields';
  avg?: Maybe<EventAttributeValueUploadVersions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EventAttributeValueUploadVersions_Max_Fields>;
  min?: Maybe<EventAttributeValueUploadVersions_Min_Fields>;
  stddev?: Maybe<EventAttributeValueUploadVersions_Stddev_Fields>;
  stddev_pop?: Maybe<EventAttributeValueUploadVersions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EventAttributeValueUploadVersions_Stddev_Samp_Fields>;
  sum?: Maybe<EventAttributeValueUploadVersions_Sum_Fields>;
  var_pop?: Maybe<EventAttributeValueUploadVersions_Var_Pop_Fields>;
  var_samp?: Maybe<EventAttributeValueUploadVersions_Var_Samp_Fields>;
  variance?: Maybe<EventAttributeValueUploadVersions_Variance_Fields>;
};


/** aggregate fields of "eventAttributeValueUploadVersions" */
export type EventAttributeValueUploadVersions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EventAttributeValueUploadVersions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eventAttributeValueUploadVersions" */
export type EventAttributeValueUploadVersions_Aggregate_Order_By = {
  avg?: InputMaybe<EventAttributeValueUploadVersions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EventAttributeValueUploadVersions_Max_Order_By>;
  min?: InputMaybe<EventAttributeValueUploadVersions_Min_Order_By>;
  stddev?: InputMaybe<EventAttributeValueUploadVersions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<EventAttributeValueUploadVersions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<EventAttributeValueUploadVersions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<EventAttributeValueUploadVersions_Sum_Order_By>;
  var_pop?: InputMaybe<EventAttributeValueUploadVersions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<EventAttributeValueUploadVersions_Var_Samp_Order_By>;
  variance?: InputMaybe<EventAttributeValueUploadVersions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eventAttributeValueUploadVersions" */
export type EventAttributeValueUploadVersions_Arr_Rel_Insert_Input = {
  data: Array<EventAttributeValueUploadVersions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventAttributeValueUploadVersions_On_Conflict>;
};

/** aggregate avg on columns */
export type EventAttributeValueUploadVersions_Avg_Fields = {
  __typename?: 'eventAttributeValueUploadVersions_avg_fields';
  eventAttributeValueUploadId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eventAttributeValueUploadVersions" */
export type EventAttributeValueUploadVersions_Avg_Order_By = {
  eventAttributeValueUploadId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eventAttributeValueUploadVersions". All fields are combined with a logical 'AND'. */
export type EventAttributeValueUploadVersions_Bool_Exp = {
  _and?: InputMaybe<Array<EventAttributeValueUploadVersions_Bool_Exp>>;
  _not?: InputMaybe<EventAttributeValueUploadVersions_Bool_Exp>;
  _or?: InputMaybe<Array<EventAttributeValueUploadVersions_Bool_Exp>>;
  downloadUrl?: InputMaybe<String_Comparison_Exp>;
  eventAttributeValueUpload?: InputMaybe<EventAttributeValueUploads_Bool_Exp>;
  eventAttributeValueUploadId?: InputMaybe<Bigint_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "eventAttributeValueUploadVersions" */
export enum EventAttributeValueUploadVersions_Constraint {
  /** unique or primary key constraint on columns "eventAttributeValueUploadId", "fileId" */
  EventAttributeValueUploadVersionsPkey = 'eventAttributeValueUploadVersions_pkey'
}

/** input type for inserting data into table "eventAttributeValueUploadVersions" */
export type EventAttributeValueUploadVersions_Insert_Input = {
  eventAttributeValueUpload?: InputMaybe<EventAttributeValueUploads_Obj_Rel_Insert_Input>;
  eventAttributeValueUploadId?: InputMaybe<Scalars['bigint']['input']>;
  fileId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type EventAttributeValueUploadVersions_Max_Fields = {
  __typename?: 'eventAttributeValueUploadVersions_max_fields';
  /** A computed field, executes function "eventAttributeValueUploadVersions_downloadUrl" */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  eventAttributeValueUploadId?: Maybe<Scalars['bigint']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "eventAttributeValueUploadVersions" */
export type EventAttributeValueUploadVersions_Max_Order_By = {
  eventAttributeValueUploadId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EventAttributeValueUploadVersions_Min_Fields = {
  __typename?: 'eventAttributeValueUploadVersions_min_fields';
  /** A computed field, executes function "eventAttributeValueUploadVersions_downloadUrl" */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  eventAttributeValueUploadId?: Maybe<Scalars['bigint']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "eventAttributeValueUploadVersions" */
export type EventAttributeValueUploadVersions_Min_Order_By = {
  eventAttributeValueUploadId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eventAttributeValueUploadVersions" */
export type EventAttributeValueUploadVersions_Mutation_Response = {
  __typename?: 'eventAttributeValueUploadVersions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EventAttributeValueUploadVersions>;
};

/** on_conflict condition type for table "eventAttributeValueUploadVersions" */
export type EventAttributeValueUploadVersions_On_Conflict = {
  constraint: EventAttributeValueUploadVersions_Constraint;
  update_columns?: Array<EventAttributeValueUploadVersions_Update_Column>;
  where?: InputMaybe<EventAttributeValueUploadVersions_Bool_Exp>;
};

/** Ordering options when selecting data from "eventAttributeValueUploadVersions". */
export type EventAttributeValueUploadVersions_Order_By = {
  downloadUrl?: InputMaybe<Order_By>;
  eventAttributeValueUpload?: InputMaybe<EventAttributeValueUploads_Order_By>;
  eventAttributeValueUploadId?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** select columns of table "eventAttributeValueUploadVersions" */
export enum EventAttributeValueUploadVersions_Select_Column {
  /** column name */
  EventAttributeValueUploadId = 'eventAttributeValueUploadId',
  /** column name */
  FileId = 'fileId'
}

/** aggregate stddev on columns */
export type EventAttributeValueUploadVersions_Stddev_Fields = {
  __typename?: 'eventAttributeValueUploadVersions_stddev_fields';
  eventAttributeValueUploadId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eventAttributeValueUploadVersions" */
export type EventAttributeValueUploadVersions_Stddev_Order_By = {
  eventAttributeValueUploadId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type EventAttributeValueUploadVersions_Stddev_Pop_Fields = {
  __typename?: 'eventAttributeValueUploadVersions_stddev_pop_fields';
  eventAttributeValueUploadId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eventAttributeValueUploadVersions" */
export type EventAttributeValueUploadVersions_Stddev_Pop_Order_By = {
  eventAttributeValueUploadId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type EventAttributeValueUploadVersions_Stddev_Samp_Fields = {
  __typename?: 'eventAttributeValueUploadVersions_stddev_samp_fields';
  eventAttributeValueUploadId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eventAttributeValueUploadVersions" */
export type EventAttributeValueUploadVersions_Stddev_Samp_Order_By = {
  eventAttributeValueUploadId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eventAttributeValueUploadVersions" */
export type EventAttributeValueUploadVersions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventAttributeValueUploadVersions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EventAttributeValueUploadVersions_Stream_Cursor_Value_Input = {
  eventAttributeValueUploadId?: InputMaybe<Scalars['bigint']['input']>;
  fileId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type EventAttributeValueUploadVersions_Sum_Fields = {
  __typename?: 'eventAttributeValueUploadVersions_sum_fields';
  eventAttributeValueUploadId?: Maybe<Scalars['bigint']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "eventAttributeValueUploadVersions" */
export type EventAttributeValueUploadVersions_Sum_Order_By = {
  eventAttributeValueUploadId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "eventAttributeValueUploadVersions" (current role has no relevant permissions) */
export enum EventAttributeValueUploadVersions_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type EventAttributeValueUploadVersions_Var_Pop_Fields = {
  __typename?: 'eventAttributeValueUploadVersions_var_pop_fields';
  eventAttributeValueUploadId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eventAttributeValueUploadVersions" */
export type EventAttributeValueUploadVersions_Var_Pop_Order_By = {
  eventAttributeValueUploadId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type EventAttributeValueUploadVersions_Var_Samp_Fields = {
  __typename?: 'eventAttributeValueUploadVersions_var_samp_fields';
  eventAttributeValueUploadId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eventAttributeValueUploadVersions" */
export type EventAttributeValueUploadVersions_Var_Samp_Order_By = {
  eventAttributeValueUploadId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type EventAttributeValueUploadVersions_Variance_Fields = {
  __typename?: 'eventAttributeValueUploadVersions_variance_fields';
  eventAttributeValueUploadId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eventAttributeValueUploadVersions" */
export type EventAttributeValueUploadVersions_Variance_Order_By = {
  eventAttributeValueUploadId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
};

/** columns and relationships of "eventAttributeValueUploads" */
export type EventAttributeValueUploads = {
  __typename?: 'eventAttributeValueUploads';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  eventAttributeValue: EventAttributeValues;
  eventAttributeValueId: Scalars['bigint']['output'];
  /** An array relationship */
  eventAttributeValueUploadVersions: Array<EventAttributeValueUploadVersions>;
  /** An aggregate relationship */
  eventAttributeValueUploadVersions_aggregate: EventAttributeValueUploadVersions_Aggregate;
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "eventAttributeValueUploads" */
export type EventAttributeValueUploadsEventAttributeValueUploadVersionsArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<EventAttributeValueUploadVersions_Bool_Exp>;
};


/** columns and relationships of "eventAttributeValueUploads" */
export type EventAttributeValueUploadsEventAttributeValueUploadVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<EventAttributeValueUploadVersions_Bool_Exp>;
};

/** aggregated selection of "eventAttributeValueUploads" */
export type EventAttributeValueUploads_Aggregate = {
  __typename?: 'eventAttributeValueUploads_aggregate';
  aggregate?: Maybe<EventAttributeValueUploads_Aggregate_Fields>;
  nodes: Array<EventAttributeValueUploads>;
};

export type EventAttributeValueUploads_Aggregate_Bool_Exp = {
  count?: InputMaybe<EventAttributeValueUploads_Aggregate_Bool_Exp_Count>;
};

export type EventAttributeValueUploads_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EventAttributeValueUploads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EventAttributeValueUploads_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eventAttributeValueUploads" */
export type EventAttributeValueUploads_Aggregate_Fields = {
  __typename?: 'eventAttributeValueUploads_aggregate_fields';
  avg?: Maybe<EventAttributeValueUploads_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EventAttributeValueUploads_Max_Fields>;
  min?: Maybe<EventAttributeValueUploads_Min_Fields>;
  stddev?: Maybe<EventAttributeValueUploads_Stddev_Fields>;
  stddev_pop?: Maybe<EventAttributeValueUploads_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EventAttributeValueUploads_Stddev_Samp_Fields>;
  sum?: Maybe<EventAttributeValueUploads_Sum_Fields>;
  var_pop?: Maybe<EventAttributeValueUploads_Var_Pop_Fields>;
  var_samp?: Maybe<EventAttributeValueUploads_Var_Samp_Fields>;
  variance?: Maybe<EventAttributeValueUploads_Variance_Fields>;
};


/** aggregate fields of "eventAttributeValueUploads" */
export type EventAttributeValueUploads_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EventAttributeValueUploads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eventAttributeValueUploads" */
export type EventAttributeValueUploads_Aggregate_Order_By = {
  avg?: InputMaybe<EventAttributeValueUploads_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EventAttributeValueUploads_Max_Order_By>;
  min?: InputMaybe<EventAttributeValueUploads_Min_Order_By>;
  stddev?: InputMaybe<EventAttributeValueUploads_Stddev_Order_By>;
  stddev_pop?: InputMaybe<EventAttributeValueUploads_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<EventAttributeValueUploads_Stddev_Samp_Order_By>;
  sum?: InputMaybe<EventAttributeValueUploads_Sum_Order_By>;
  var_pop?: InputMaybe<EventAttributeValueUploads_Var_Pop_Order_By>;
  var_samp?: InputMaybe<EventAttributeValueUploads_Var_Samp_Order_By>;
  variance?: InputMaybe<EventAttributeValueUploads_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eventAttributeValueUploads" */
export type EventAttributeValueUploads_Arr_Rel_Insert_Input = {
  data: Array<EventAttributeValueUploads_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventAttributeValueUploads_On_Conflict>;
};

/** aggregate avg on columns */
export type EventAttributeValueUploads_Avg_Fields = {
  __typename?: 'eventAttributeValueUploads_avg_fields';
  eventAttributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eventAttributeValueUploads" */
export type EventAttributeValueUploads_Avg_Order_By = {
  eventAttributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eventAttributeValueUploads". All fields are combined with a logical 'AND'. */
export type EventAttributeValueUploads_Bool_Exp = {
  _and?: InputMaybe<Array<EventAttributeValueUploads_Bool_Exp>>;
  _not?: InputMaybe<EventAttributeValueUploads_Bool_Exp>;
  _or?: InputMaybe<Array<EventAttributeValueUploads_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  eventAttributeValue?: InputMaybe<EventAttributeValues_Bool_Exp>;
  eventAttributeValueId?: InputMaybe<Bigint_Comparison_Exp>;
  eventAttributeValueUploadVersions?: InputMaybe<EventAttributeValueUploadVersions_Bool_Exp>;
  eventAttributeValueUploadVersions_aggregate?: InputMaybe<EventAttributeValueUploadVersions_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "eventAttributeValueUploads" */
export enum EventAttributeValueUploads_Constraint {
  /** unique or primary key constraint on columns "id" */
  EventAttributeValueUploadsPkey = 'eventAttributeValueUploads_pkey'
}

/** input type for inserting data into table "eventAttributeValueUploads" */
export type EventAttributeValueUploads_Insert_Input = {
  eventAttributeValue?: InputMaybe<EventAttributeValues_Obj_Rel_Insert_Input>;
  eventAttributeValueId?: InputMaybe<Scalars['bigint']['input']>;
  eventAttributeValueUploadVersions?: InputMaybe<EventAttributeValueUploadVersions_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EventAttributeValueUploads_Max_Fields = {
  __typename?: 'eventAttributeValueUploads_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  eventAttributeValueId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "eventAttributeValueUploads" */
export type EventAttributeValueUploads_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  eventAttributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EventAttributeValueUploads_Min_Fields = {
  __typename?: 'eventAttributeValueUploads_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  eventAttributeValueId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "eventAttributeValueUploads" */
export type EventAttributeValueUploads_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  eventAttributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eventAttributeValueUploads" */
export type EventAttributeValueUploads_Mutation_Response = {
  __typename?: 'eventAttributeValueUploads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EventAttributeValueUploads>;
};

/** input type for inserting object relation for remote table "eventAttributeValueUploads" */
export type EventAttributeValueUploads_Obj_Rel_Insert_Input = {
  data: EventAttributeValueUploads_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EventAttributeValueUploads_On_Conflict>;
};

/** on_conflict condition type for table "eventAttributeValueUploads" */
export type EventAttributeValueUploads_On_Conflict = {
  constraint: EventAttributeValueUploads_Constraint;
  update_columns?: Array<EventAttributeValueUploads_Update_Column>;
  where?: InputMaybe<EventAttributeValueUploads_Bool_Exp>;
};

/** Ordering options when selecting data from "eventAttributeValueUploads". */
export type EventAttributeValueUploads_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  eventAttributeValue?: InputMaybe<EventAttributeValues_Order_By>;
  eventAttributeValueId?: InputMaybe<Order_By>;
  eventAttributeValueUploadVersions_aggregate?: InputMaybe<EventAttributeValueUploadVersions_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eventAttributeValueUploads */
export type EventAttributeValueUploads_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "eventAttributeValueUploads" */
export enum EventAttributeValueUploads_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EventAttributeValueId = 'eventAttributeValueId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "eventAttributeValueUploads" */
export type EventAttributeValueUploads_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type EventAttributeValueUploads_Stddev_Fields = {
  __typename?: 'eventAttributeValueUploads_stddev_fields';
  eventAttributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eventAttributeValueUploads" */
export type EventAttributeValueUploads_Stddev_Order_By = {
  eventAttributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type EventAttributeValueUploads_Stddev_Pop_Fields = {
  __typename?: 'eventAttributeValueUploads_stddev_pop_fields';
  eventAttributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eventAttributeValueUploads" */
export type EventAttributeValueUploads_Stddev_Pop_Order_By = {
  eventAttributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type EventAttributeValueUploads_Stddev_Samp_Fields = {
  __typename?: 'eventAttributeValueUploads_stddev_samp_fields';
  eventAttributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eventAttributeValueUploads" */
export type EventAttributeValueUploads_Stddev_Samp_Order_By = {
  eventAttributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eventAttributeValueUploads" */
export type EventAttributeValueUploads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventAttributeValueUploads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EventAttributeValueUploads_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  eventAttributeValueId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type EventAttributeValueUploads_Sum_Fields = {
  __typename?: 'eventAttributeValueUploads_sum_fields';
  eventAttributeValueId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "eventAttributeValueUploads" */
export type EventAttributeValueUploads_Sum_Order_By = {
  eventAttributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "eventAttributeValueUploads" */
export enum EventAttributeValueUploads_Update_Column {
  /** column name */
  Name = 'name'
}

export type EventAttributeValueUploads_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventAttributeValueUploads_Set_Input>;
  /** filter the rows which have to be updated */
  where: EventAttributeValueUploads_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EventAttributeValueUploads_Var_Pop_Fields = {
  __typename?: 'eventAttributeValueUploads_var_pop_fields';
  eventAttributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eventAttributeValueUploads" */
export type EventAttributeValueUploads_Var_Pop_Order_By = {
  eventAttributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type EventAttributeValueUploads_Var_Samp_Fields = {
  __typename?: 'eventAttributeValueUploads_var_samp_fields';
  eventAttributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eventAttributeValueUploads" */
export type EventAttributeValueUploads_Var_Samp_Order_By = {
  eventAttributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type EventAttributeValueUploads_Variance_Fields = {
  __typename?: 'eventAttributeValueUploads_variance_fields';
  eventAttributeValueId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eventAttributeValueUploads" */
export type EventAttributeValueUploads_Variance_Order_By = {
  eventAttributeValueId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "eventAttributeValues" */
export type EventAttributeValues = {
  __typename?: 'eventAttributeValues';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  event?: Maybe<Events>;
  /** An object relationship */
  eventAttribute?: Maybe<EventAttributes>;
  eventAttributeId?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  eventAttributeValueUploads: Array<EventAttributeValueUploads>;
  /** An aggregate relationship */
  eventAttributeValueUploads_aggregate: EventAttributeValueUploads_Aggregate;
  eventId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  fullUser?: Maybe<Users>;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  user?: Maybe<AllUsers>;
  value: Scalars['json']['output'];
};


/** columns and relationships of "eventAttributeValues" */
export type EventAttributeValuesEventAttributeValueUploadsArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValueUploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValueUploads_Order_By>>;
  where?: InputMaybe<EventAttributeValueUploads_Bool_Exp>;
};


/** columns and relationships of "eventAttributeValues" */
export type EventAttributeValuesEventAttributeValueUploads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValueUploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValueUploads_Order_By>>;
  where?: InputMaybe<EventAttributeValueUploads_Bool_Exp>;
};


/** columns and relationships of "eventAttributeValues" */
export type EventAttributeValuesNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "eventAttributeValues" */
export type EventAttributeValuesNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "eventAttributeValues" */
export type EventAttributeValuesValueArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "eventAttributeValues" */
export type EventAttributeValues_Aggregate = {
  __typename?: 'eventAttributeValues_aggregate';
  aggregate?: Maybe<EventAttributeValues_Aggregate_Fields>;
  nodes: Array<EventAttributeValues>;
};

export type EventAttributeValues_Aggregate_Bool_Exp = {
  count?: InputMaybe<EventAttributeValues_Aggregate_Bool_Exp_Count>;
};

export type EventAttributeValues_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EventAttributeValues_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EventAttributeValues_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eventAttributeValues" */
export type EventAttributeValues_Aggregate_Fields = {
  __typename?: 'eventAttributeValues_aggregate_fields';
  avg?: Maybe<EventAttributeValues_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EventAttributeValues_Max_Fields>;
  min?: Maybe<EventAttributeValues_Min_Fields>;
  stddev?: Maybe<EventAttributeValues_Stddev_Fields>;
  stddev_pop?: Maybe<EventAttributeValues_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EventAttributeValues_Stddev_Samp_Fields>;
  sum?: Maybe<EventAttributeValues_Sum_Fields>;
  var_pop?: Maybe<EventAttributeValues_Var_Pop_Fields>;
  var_samp?: Maybe<EventAttributeValues_Var_Samp_Fields>;
  variance?: Maybe<EventAttributeValues_Variance_Fields>;
};


/** aggregate fields of "eventAttributeValues" */
export type EventAttributeValues_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EventAttributeValues_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eventAttributeValues" */
export type EventAttributeValues_Aggregate_Order_By = {
  avg?: InputMaybe<EventAttributeValues_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EventAttributeValues_Max_Order_By>;
  min?: InputMaybe<EventAttributeValues_Min_Order_By>;
  stddev?: InputMaybe<EventAttributeValues_Stddev_Order_By>;
  stddev_pop?: InputMaybe<EventAttributeValues_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<EventAttributeValues_Stddev_Samp_Order_By>;
  sum?: InputMaybe<EventAttributeValues_Sum_Order_By>;
  var_pop?: InputMaybe<EventAttributeValues_Var_Pop_Order_By>;
  var_samp?: InputMaybe<EventAttributeValues_Var_Samp_Order_By>;
  variance?: InputMaybe<EventAttributeValues_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eventAttributeValues" */
export type EventAttributeValues_Arr_Rel_Insert_Input = {
  data: Array<EventAttributeValues_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventAttributeValues_On_Conflict>;
};

/** aggregate avg on columns */
export type EventAttributeValues_Avg_Fields = {
  __typename?: 'eventAttributeValues_avg_fields';
  eventAttributeId?: Maybe<Scalars['Float']['output']>;
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eventAttributeValues" */
export type EventAttributeValues_Avg_Order_By = {
  eventAttributeId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eventAttributeValues". All fields are combined with a logical 'AND'. */
export type EventAttributeValues_Bool_Exp = {
  _and?: InputMaybe<Array<EventAttributeValues_Bool_Exp>>;
  _not?: InputMaybe<EventAttributeValues_Bool_Exp>;
  _or?: InputMaybe<Array<EventAttributeValues_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventAttribute?: InputMaybe<EventAttributes_Bool_Exp>;
  eventAttributeId?: InputMaybe<Bigint_Comparison_Exp>;
  eventAttributeValueUploads?: InputMaybe<EventAttributeValueUploads_Bool_Exp>;
  eventAttributeValueUploads_aggregate?: InputMaybe<EventAttributeValueUploads_Aggregate_Bool_Exp>;
  eventId?: InputMaybe<Bigint_Comparison_Exp>;
  fullUser?: InputMaybe<Users_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedBy?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<AllUsers_Bool_Exp>;
  value?: InputMaybe<Json_Comparison_Exp>;
};

/** unique or primary key constraints on table "eventAttributeValues" */
export enum EventAttributeValues_Constraint {
  /** unique or primary key constraint on columns "eventId", "eventAttributeId" */
  EventAttributeValuesEventIdEventAttributeIdKey = 'eventAttributeValues_eventId_eventAttributeId_key',
  /** unique or primary key constraint on columns "id" */
  EventAttributeValuesPkey = 'eventAttributeValues_pkey'
}

/** input type for inserting data into table "eventAttributeValues" */
export type EventAttributeValues_Insert_Input = {
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventAttribute?: InputMaybe<EventAttributes_Obj_Rel_Insert_Input>;
  eventAttributeId?: InputMaybe<Scalars['bigint']['input']>;
  eventAttributeValueUploads?: InputMaybe<EventAttributeValueUploads_Arr_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  fullUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['json']['input']>;
};

/** aggregate max on columns */
export type EventAttributeValues_Max_Fields = {
  __typename?: 'eventAttributeValues_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  eventAttributeId?: Maybe<Scalars['bigint']['output']>;
  eventId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedBy?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "eventAttributeValues" */
export type EventAttributeValues_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  eventAttributeId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EventAttributeValues_Min_Fields = {
  __typename?: 'eventAttributeValues_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  eventAttributeId?: Maybe<Scalars['bigint']['output']>;
  eventId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedBy?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "eventAttributeValues" */
export type EventAttributeValues_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  eventAttributeId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eventAttributeValues" */
export type EventAttributeValues_Mutation_Response = {
  __typename?: 'eventAttributeValues_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EventAttributeValues>;
};

/** input type for inserting object relation for remote table "eventAttributeValues" */
export type EventAttributeValues_Obj_Rel_Insert_Input = {
  data: EventAttributeValues_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EventAttributeValues_On_Conflict>;
};

/** on_conflict condition type for table "eventAttributeValues" */
export type EventAttributeValues_On_Conflict = {
  constraint: EventAttributeValues_Constraint;
  update_columns?: Array<EventAttributeValues_Update_Column>;
  where?: InputMaybe<EventAttributeValues_Bool_Exp>;
};

/** Ordering options when selecting data from "eventAttributeValues". */
export type EventAttributeValues_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  eventAttribute?: InputMaybe<EventAttributes_Order_By>;
  eventAttributeId?: InputMaybe<Order_By>;
  eventAttributeValueUploads_aggregate?: InputMaybe<EventAttributeValueUploads_Aggregate_Order_By>;
  eventId?: InputMaybe<Order_By>;
  fullUser?: InputMaybe<Users_Order_By>;
  id?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  user?: InputMaybe<AllUsers_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eventAttributeValues */
export type EventAttributeValues_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "eventAttributeValues" */
export enum EventAttributeValues_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EventAttributeId = 'eventAttributeId',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "eventAttributeValues" */
export type EventAttributeValues_Set_Input = {
  value?: InputMaybe<Scalars['json']['input']>;
};

/** aggregate stddev on columns */
export type EventAttributeValues_Stddev_Fields = {
  __typename?: 'eventAttributeValues_stddev_fields';
  eventAttributeId?: Maybe<Scalars['Float']['output']>;
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eventAttributeValues" */
export type EventAttributeValues_Stddev_Order_By = {
  eventAttributeId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type EventAttributeValues_Stddev_Pop_Fields = {
  __typename?: 'eventAttributeValues_stddev_pop_fields';
  eventAttributeId?: Maybe<Scalars['Float']['output']>;
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eventAttributeValues" */
export type EventAttributeValues_Stddev_Pop_Order_By = {
  eventAttributeId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type EventAttributeValues_Stddev_Samp_Fields = {
  __typename?: 'eventAttributeValues_stddev_samp_fields';
  eventAttributeId?: Maybe<Scalars['Float']['output']>;
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eventAttributeValues" */
export type EventAttributeValues_Stddev_Samp_Order_By = {
  eventAttributeId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eventAttributeValues" */
export type EventAttributeValues_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventAttributeValues_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EventAttributeValues_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  eventAttributeId?: InputMaybe<Scalars['bigint']['input']>;
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['json']['input']>;
};

/** aggregate sum on columns */
export type EventAttributeValues_Sum_Fields = {
  __typename?: 'eventAttributeValues_sum_fields';
  eventAttributeId?: Maybe<Scalars['bigint']['output']>;
  eventId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updatedBy?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "eventAttributeValues" */
export type EventAttributeValues_Sum_Order_By = {
  eventAttributeId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** update columns of table "eventAttributeValues" */
export enum EventAttributeValues_Update_Column {
  /** column name */
  Value = 'value'
}

export type EventAttributeValues_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventAttributeValues_Set_Input>;
  /** filter the rows which have to be updated */
  where: EventAttributeValues_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EventAttributeValues_Var_Pop_Fields = {
  __typename?: 'eventAttributeValues_var_pop_fields';
  eventAttributeId?: Maybe<Scalars['Float']['output']>;
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eventAttributeValues" */
export type EventAttributeValues_Var_Pop_Order_By = {
  eventAttributeId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type EventAttributeValues_Var_Samp_Fields = {
  __typename?: 'eventAttributeValues_var_samp_fields';
  eventAttributeId?: Maybe<Scalars['Float']['output']>;
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eventAttributeValues" */
export type EventAttributeValues_Var_Samp_Order_By = {
  eventAttributeId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type EventAttributeValues_Variance_Fields = {
  __typename?: 'eventAttributeValues_variance_fields';
  eventAttributeId?: Maybe<Scalars['Float']['output']>;
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eventAttributeValues" */
export type EventAttributeValues_Variance_Order_By = {
  eventAttributeId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** columns and relationships of "eventAttributes" */
export type EventAttributes = {
  __typename?: 'eventAttributes';
  attributeType: AttributeTypes_Enum;
  config: Scalars['json']['output'];
  createdAt: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  eventAttributeGroup: EventAttributeGroups;
  /** An array relationship */
  eventAttributeValues: Array<EventAttributeValues>;
  /** An aggregate relationship */
  eventAttributeValues_aggregate: EventAttributeValues_Aggregate;
  groupId: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "eventAttributes" */
export type EventAttributesConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "eventAttributes" */
export type EventAttributesEventAttributeValuesArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValues_Order_By>>;
  where?: InputMaybe<EventAttributeValues_Bool_Exp>;
};


/** columns and relationships of "eventAttributes" */
export type EventAttributesEventAttributeValues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValues_Order_By>>;
  where?: InputMaybe<EventAttributeValues_Bool_Exp>;
};

/** aggregated selection of "eventAttributes" */
export type EventAttributes_Aggregate = {
  __typename?: 'eventAttributes_aggregate';
  aggregate?: Maybe<EventAttributes_Aggregate_Fields>;
  nodes: Array<EventAttributes>;
};

export type EventAttributes_Aggregate_Bool_Exp = {
  count?: InputMaybe<EventAttributes_Aggregate_Bool_Exp_Count>;
};

export type EventAttributes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EventAttributes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EventAttributes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eventAttributes" */
export type EventAttributes_Aggregate_Fields = {
  __typename?: 'eventAttributes_aggregate_fields';
  avg?: Maybe<EventAttributes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EventAttributes_Max_Fields>;
  min?: Maybe<EventAttributes_Min_Fields>;
  stddev?: Maybe<EventAttributes_Stddev_Fields>;
  stddev_pop?: Maybe<EventAttributes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EventAttributes_Stddev_Samp_Fields>;
  sum?: Maybe<EventAttributes_Sum_Fields>;
  var_pop?: Maybe<EventAttributes_Var_Pop_Fields>;
  var_samp?: Maybe<EventAttributes_Var_Samp_Fields>;
  variance?: Maybe<EventAttributes_Variance_Fields>;
};


/** aggregate fields of "eventAttributes" */
export type EventAttributes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EventAttributes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eventAttributes" */
export type EventAttributes_Aggregate_Order_By = {
  avg?: InputMaybe<EventAttributes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EventAttributes_Max_Order_By>;
  min?: InputMaybe<EventAttributes_Min_Order_By>;
  stddev?: InputMaybe<EventAttributes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<EventAttributes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<EventAttributes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<EventAttributes_Sum_Order_By>;
  var_pop?: InputMaybe<EventAttributes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<EventAttributes_Var_Samp_Order_By>;
  variance?: InputMaybe<EventAttributes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eventAttributes" */
export type EventAttributes_Arr_Rel_Insert_Input = {
  data: Array<EventAttributes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventAttributes_On_Conflict>;
};

/** aggregate avg on columns */
export type EventAttributes_Avg_Fields = {
  __typename?: 'eventAttributes_avg_fields';
  groupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eventAttributes" */
export type EventAttributes_Avg_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eventAttributes". All fields are combined with a logical 'AND'. */
export type EventAttributes_Bool_Exp = {
  _and?: InputMaybe<Array<EventAttributes_Bool_Exp>>;
  _not?: InputMaybe<EventAttributes_Bool_Exp>;
  _or?: InputMaybe<Array<EventAttributes_Bool_Exp>>;
  attributeType?: InputMaybe<AttributeTypes_Enum_Comparison_Exp>;
  config?: InputMaybe<Json_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  eventAttributeGroup?: InputMaybe<EventAttributeGroups_Bool_Exp>;
  eventAttributeValues?: InputMaybe<EventAttributeValues_Bool_Exp>;
  eventAttributeValues_aggregate?: InputMaybe<EventAttributeValues_Aggregate_Bool_Exp>;
  groupId?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "eventAttributes" */
export enum EventAttributes_Constraint {
  /** unique or primary key constraint on columns "id" */
  EventAttributesPkey = 'eventAttributes_pkey',
  /** unique or primary key constraint on columns "slug" */
  EventAttributesSlugKey = 'eventAttributes_slug_key'
}

/** input type for incrementing numeric columns in table "eventAttributes" */
export type EventAttributes_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "eventAttributes" */
export type EventAttributes_Insert_Input = {
  attributeType?: InputMaybe<AttributeTypes_Enum>;
  config?: InputMaybe<Scalars['json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventAttributeGroup?: InputMaybe<EventAttributeGroups_Obj_Rel_Insert_Input>;
  eventAttributeValues?: InputMaybe<EventAttributeValues_Arr_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EventAttributes_Max_Fields = {
  __typename?: 'eventAttributes_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "eventAttributes" */
export type EventAttributes_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EventAttributes_Min_Fields = {
  __typename?: 'eventAttributes_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "eventAttributes" */
export type EventAttributes_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eventAttributes" */
export type EventAttributes_Mutation_Response = {
  __typename?: 'eventAttributes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EventAttributes>;
};

/** input type for inserting object relation for remote table "eventAttributes" */
export type EventAttributes_Obj_Rel_Insert_Input = {
  data: EventAttributes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<EventAttributes_On_Conflict>;
};

/** on_conflict condition type for table "eventAttributes" */
export type EventAttributes_On_Conflict = {
  constraint: EventAttributes_Constraint;
  update_columns?: Array<EventAttributes_Update_Column>;
  where?: InputMaybe<EventAttributes_Bool_Exp>;
};

/** Ordering options when selecting data from "eventAttributes". */
export type EventAttributes_Order_By = {
  attributeType?: InputMaybe<Order_By>;
  config?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  eventAttributeGroup?: InputMaybe<EventAttributeGroups_Order_By>;
  eventAttributeValues_aggregate?: InputMaybe<EventAttributeValues_Aggregate_Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eventAttributes */
export type EventAttributes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "eventAttributes" */
export enum EventAttributes_Select_Column {
  /** column name */
  AttributeType = 'attributeType',
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  Slug = 'slug',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "eventAttributes" */
export type EventAttributes_Set_Input = {
  attributeType?: InputMaybe<AttributeTypes_Enum>;
  config?: InputMaybe<Scalars['json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type EventAttributes_Stddev_Fields = {
  __typename?: 'eventAttributes_stddev_fields';
  groupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eventAttributes" */
export type EventAttributes_Stddev_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type EventAttributes_Stddev_Pop_Fields = {
  __typename?: 'eventAttributes_stddev_pop_fields';
  groupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eventAttributes" */
export type EventAttributes_Stddev_Pop_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type EventAttributes_Stddev_Samp_Fields = {
  __typename?: 'eventAttributes_stddev_samp_fields';
  groupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eventAttributes" */
export type EventAttributes_Stddev_Samp_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eventAttributes" */
export type EventAttributes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventAttributes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EventAttributes_Stream_Cursor_Value_Input = {
  attributeType?: InputMaybe<AttributeTypes_Enum>;
  config?: InputMaybe<Scalars['json']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type EventAttributes_Sum_Fields = {
  __typename?: 'eventAttributes_sum_fields';
  groupId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "eventAttributes" */
export type EventAttributes_Sum_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** update columns of table "eventAttributes" */
export enum EventAttributes_Update_Column {
  /** column name */
  AttributeType = 'attributeType',
  /** column name */
  Config = 'config',
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  Slug = 'slug'
}

export type EventAttributes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EventAttributes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventAttributes_Set_Input>;
  /** filter the rows which have to be updated */
  where: EventAttributes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EventAttributes_Var_Pop_Fields = {
  __typename?: 'eventAttributes_var_pop_fields';
  groupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eventAttributes" */
export type EventAttributes_Var_Pop_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type EventAttributes_Var_Samp_Fields = {
  __typename?: 'eventAttributes_var_samp_fields';
  groupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eventAttributes" */
export type EventAttributes_Var_Samp_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type EventAttributes_Variance_Fields = {
  __typename?: 'eventAttributes_variance_fields';
  groupId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eventAttributes" */
export type EventAttributes_Variance_Order_By = {
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "eventFavourites" */
export type EventFavourites = {
  __typename?: 'eventFavourites';
  /** An object relationship */
  event: Events;
  eventId: Scalars['bigint']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['bigint']['output'];
};

/** aggregated selection of "eventFavourites" */
export type EventFavourites_Aggregate = {
  __typename?: 'eventFavourites_aggregate';
  aggregate?: Maybe<EventFavourites_Aggregate_Fields>;
  nodes: Array<EventFavourites>;
};

export type EventFavourites_Aggregate_Bool_Exp = {
  count?: InputMaybe<EventFavourites_Aggregate_Bool_Exp_Count>;
};

export type EventFavourites_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EventFavourites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EventFavourites_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eventFavourites" */
export type EventFavourites_Aggregate_Fields = {
  __typename?: 'eventFavourites_aggregate_fields';
  avg?: Maybe<EventFavourites_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EventFavourites_Max_Fields>;
  min?: Maybe<EventFavourites_Min_Fields>;
  stddev?: Maybe<EventFavourites_Stddev_Fields>;
  stddev_pop?: Maybe<EventFavourites_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EventFavourites_Stddev_Samp_Fields>;
  sum?: Maybe<EventFavourites_Sum_Fields>;
  var_pop?: Maybe<EventFavourites_Var_Pop_Fields>;
  var_samp?: Maybe<EventFavourites_Var_Samp_Fields>;
  variance?: Maybe<EventFavourites_Variance_Fields>;
};


/** aggregate fields of "eventFavourites" */
export type EventFavourites_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EventFavourites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eventFavourites" */
export type EventFavourites_Aggregate_Order_By = {
  avg?: InputMaybe<EventFavourites_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EventFavourites_Max_Order_By>;
  min?: InputMaybe<EventFavourites_Min_Order_By>;
  stddev?: InputMaybe<EventFavourites_Stddev_Order_By>;
  stddev_pop?: InputMaybe<EventFavourites_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<EventFavourites_Stddev_Samp_Order_By>;
  sum?: InputMaybe<EventFavourites_Sum_Order_By>;
  var_pop?: InputMaybe<EventFavourites_Var_Pop_Order_By>;
  var_samp?: InputMaybe<EventFavourites_Var_Samp_Order_By>;
  variance?: InputMaybe<EventFavourites_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eventFavourites" */
export type EventFavourites_Arr_Rel_Insert_Input = {
  data: Array<EventFavourites_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventFavourites_On_Conflict>;
};

/** aggregate avg on columns */
export type EventFavourites_Avg_Fields = {
  __typename?: 'eventFavourites_avg_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eventFavourites" */
export type EventFavourites_Avg_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eventFavourites". All fields are combined with a logical 'AND'. */
export type EventFavourites_Bool_Exp = {
  _and?: InputMaybe<Array<EventFavourites_Bool_Exp>>;
  _not?: InputMaybe<EventFavourites_Bool_Exp>;
  _or?: InputMaybe<Array<EventFavourites_Bool_Exp>>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "eventFavourites" */
export enum EventFavourites_Constraint {
  /** unique or primary key constraint on columns "userId", "eventId" */
  EventFavouritesPkey = 'eventFavourites_pkey'
}

/** input type for inserting data into table "eventFavourites" */
export type EventFavourites_Insert_Input = {
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type EventFavourites_Max_Fields = {
  __typename?: 'eventFavourites_max_fields';
  eventId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "eventFavourites" */
export type EventFavourites_Max_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EventFavourites_Min_Fields = {
  __typename?: 'eventFavourites_min_fields';
  eventId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "eventFavourites" */
export type EventFavourites_Min_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eventFavourites" */
export type EventFavourites_Mutation_Response = {
  __typename?: 'eventFavourites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EventFavourites>;
};

/** on_conflict condition type for table "eventFavourites" */
export type EventFavourites_On_Conflict = {
  constraint: EventFavourites_Constraint;
  update_columns?: Array<EventFavourites_Update_Column>;
  where?: InputMaybe<EventFavourites_Bool_Exp>;
};

/** Ordering options when selecting data from "eventFavourites". */
export type EventFavourites_Order_By = {
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eventFavourites */
export type EventFavourites_Pk_Columns_Input = {
  eventId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};

/** select columns of table "eventFavourites" */
export enum EventFavourites_Select_Column {
  /** column name */
  EventId = 'eventId',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type EventFavourites_Stddev_Fields = {
  __typename?: 'eventFavourites_stddev_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eventFavourites" */
export type EventFavourites_Stddev_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type EventFavourites_Stddev_Pop_Fields = {
  __typename?: 'eventFavourites_stddev_pop_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eventFavourites" */
export type EventFavourites_Stddev_Pop_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type EventFavourites_Stddev_Samp_Fields = {
  __typename?: 'eventFavourites_stddev_samp_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eventFavourites" */
export type EventFavourites_Stddev_Samp_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eventFavourites" */
export type EventFavourites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventFavourites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EventFavourites_Stream_Cursor_Value_Input = {
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type EventFavourites_Sum_Fields = {
  __typename?: 'eventFavourites_sum_fields';
  eventId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "eventFavourites" */
export type EventFavourites_Sum_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "eventFavourites" (current role has no relevant permissions) */
export enum EventFavourites_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

export type EventFavourites_Updates = {
  /** filter the rows which have to be updated */
  where: EventFavourites_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EventFavourites_Var_Pop_Fields = {
  __typename?: 'eventFavourites_var_pop_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eventFavourites" */
export type EventFavourites_Var_Pop_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type EventFavourites_Var_Samp_Fields = {
  __typename?: 'eventFavourites_var_samp_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eventFavourites" */
export type EventFavourites_Var_Samp_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type EventFavourites_Variance_Fields = {
  __typename?: 'eventFavourites_variance_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eventFavourites" */
export type EventFavourites_Variance_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "eventOrganisers" */
export type EventOrganisers = {
  __typename?: 'eventOrganisers';
  /** An object relationship */
  event: Events;
  eventId: Scalars['bigint']['output'];
  /** An object relationship */
  fullUser: Users;
  /** An object relationship */
  user?: Maybe<AllUsers>;
  userId: Scalars['bigint']['output'];
};

/** aggregated selection of "eventOrganisers" */
export type EventOrganisers_Aggregate = {
  __typename?: 'eventOrganisers_aggregate';
  aggregate?: Maybe<EventOrganisers_Aggregate_Fields>;
  nodes: Array<EventOrganisers>;
};

export type EventOrganisers_Aggregate_Bool_Exp = {
  count?: InputMaybe<EventOrganisers_Aggregate_Bool_Exp_Count>;
};

export type EventOrganisers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EventOrganisers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EventOrganisers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eventOrganisers" */
export type EventOrganisers_Aggregate_Fields = {
  __typename?: 'eventOrganisers_aggregate_fields';
  avg?: Maybe<EventOrganisers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EventOrganisers_Max_Fields>;
  min?: Maybe<EventOrganisers_Min_Fields>;
  stddev?: Maybe<EventOrganisers_Stddev_Fields>;
  stddev_pop?: Maybe<EventOrganisers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EventOrganisers_Stddev_Samp_Fields>;
  sum?: Maybe<EventOrganisers_Sum_Fields>;
  var_pop?: Maybe<EventOrganisers_Var_Pop_Fields>;
  var_samp?: Maybe<EventOrganisers_Var_Samp_Fields>;
  variance?: Maybe<EventOrganisers_Variance_Fields>;
};


/** aggregate fields of "eventOrganisers" */
export type EventOrganisers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EventOrganisers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eventOrganisers" */
export type EventOrganisers_Aggregate_Order_By = {
  avg?: InputMaybe<EventOrganisers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EventOrganisers_Max_Order_By>;
  min?: InputMaybe<EventOrganisers_Min_Order_By>;
  stddev?: InputMaybe<EventOrganisers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<EventOrganisers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<EventOrganisers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<EventOrganisers_Sum_Order_By>;
  var_pop?: InputMaybe<EventOrganisers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<EventOrganisers_Var_Samp_Order_By>;
  variance?: InputMaybe<EventOrganisers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eventOrganisers" */
export type EventOrganisers_Arr_Rel_Insert_Input = {
  data: Array<EventOrganisers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventOrganisers_On_Conflict>;
};

/** aggregate avg on columns */
export type EventOrganisers_Avg_Fields = {
  __typename?: 'eventOrganisers_avg_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eventOrganisers" */
export type EventOrganisers_Avg_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eventOrganisers". All fields are combined with a logical 'AND'. */
export type EventOrganisers_Bool_Exp = {
  _and?: InputMaybe<Array<EventOrganisers_Bool_Exp>>;
  _not?: InputMaybe<EventOrganisers_Bool_Exp>;
  _or?: InputMaybe<Array<EventOrganisers_Bool_Exp>>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Bigint_Comparison_Exp>;
  fullUser?: InputMaybe<Users_Bool_Exp>;
  user?: InputMaybe<AllUsers_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "eventOrganisers" */
export enum EventOrganisers_Constraint {
  /** unique or primary key constraint on columns "userId", "eventId" */
  EventOrganisersPkey = 'eventOrganisers_pkey'
}

/** input type for inserting data into table "eventOrganisers" */
export type EventOrganisers_Insert_Input = {
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  fullUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type EventOrganisers_Max_Fields = {
  __typename?: 'eventOrganisers_max_fields';
  eventId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "eventOrganisers" */
export type EventOrganisers_Max_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EventOrganisers_Min_Fields = {
  __typename?: 'eventOrganisers_min_fields';
  eventId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "eventOrganisers" */
export type EventOrganisers_Min_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eventOrganisers" */
export type EventOrganisers_Mutation_Response = {
  __typename?: 'eventOrganisers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EventOrganisers>;
};

/** on_conflict condition type for table "eventOrganisers" */
export type EventOrganisers_On_Conflict = {
  constraint: EventOrganisers_Constraint;
  update_columns?: Array<EventOrganisers_Update_Column>;
  where?: InputMaybe<EventOrganisers_Bool_Exp>;
};

/** Ordering options when selecting data from "eventOrganisers". */
export type EventOrganisers_Order_By = {
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  fullUser?: InputMaybe<Users_Order_By>;
  user?: InputMaybe<AllUsers_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "eventOrganisers" */
export enum EventOrganisers_Select_Column {
  /** column name */
  EventId = 'eventId',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type EventOrganisers_Stddev_Fields = {
  __typename?: 'eventOrganisers_stddev_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eventOrganisers" */
export type EventOrganisers_Stddev_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type EventOrganisers_Stddev_Pop_Fields = {
  __typename?: 'eventOrganisers_stddev_pop_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eventOrganisers" */
export type EventOrganisers_Stddev_Pop_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type EventOrganisers_Stddev_Samp_Fields = {
  __typename?: 'eventOrganisers_stddev_samp_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eventOrganisers" */
export type EventOrganisers_Stddev_Samp_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eventOrganisers" */
export type EventOrganisers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventOrganisers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EventOrganisers_Stream_Cursor_Value_Input = {
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type EventOrganisers_Sum_Fields = {
  __typename?: 'eventOrganisers_sum_fields';
  eventId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "eventOrganisers" */
export type EventOrganisers_Sum_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "eventOrganisers" (current role has no relevant permissions) */
export enum EventOrganisers_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type EventOrganisers_Var_Pop_Fields = {
  __typename?: 'eventOrganisers_var_pop_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eventOrganisers" */
export type EventOrganisers_Var_Pop_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type EventOrganisers_Var_Samp_Fields = {
  __typename?: 'eventOrganisers_var_samp_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eventOrganisers" */
export type EventOrganisers_Var_Samp_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type EventOrganisers_Variance_Fields = {
  __typename?: 'eventOrganisers_variance_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eventOrganisers" */
export type EventOrganisers_Variance_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "eventRoomWatches" */
export type EventRoomWatches = {
  __typename?: 'eventRoomWatches';
  /** An object relationship */
  event: Events;
  eventId: Scalars['bigint']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['bigint']['output'];
};

/** aggregated selection of "eventRoomWatches" */
export type EventRoomWatches_Aggregate = {
  __typename?: 'eventRoomWatches_aggregate';
  aggregate?: Maybe<EventRoomWatches_Aggregate_Fields>;
  nodes: Array<EventRoomWatches>;
};

export type EventRoomWatches_Aggregate_Bool_Exp = {
  count?: InputMaybe<EventRoomWatches_Aggregate_Bool_Exp_Count>;
};

export type EventRoomWatches_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<EventRoomWatches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EventRoomWatches_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "eventRoomWatches" */
export type EventRoomWatches_Aggregate_Fields = {
  __typename?: 'eventRoomWatches_aggregate_fields';
  avg?: Maybe<EventRoomWatches_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EventRoomWatches_Max_Fields>;
  min?: Maybe<EventRoomWatches_Min_Fields>;
  stddev?: Maybe<EventRoomWatches_Stddev_Fields>;
  stddev_pop?: Maybe<EventRoomWatches_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EventRoomWatches_Stddev_Samp_Fields>;
  sum?: Maybe<EventRoomWatches_Sum_Fields>;
  var_pop?: Maybe<EventRoomWatches_Var_Pop_Fields>;
  var_samp?: Maybe<EventRoomWatches_Var_Samp_Fields>;
  variance?: Maybe<EventRoomWatches_Variance_Fields>;
};


/** aggregate fields of "eventRoomWatches" */
export type EventRoomWatches_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EventRoomWatches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "eventRoomWatches" */
export type EventRoomWatches_Aggregate_Order_By = {
  avg?: InputMaybe<EventRoomWatches_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EventRoomWatches_Max_Order_By>;
  min?: InputMaybe<EventRoomWatches_Min_Order_By>;
  stddev?: InputMaybe<EventRoomWatches_Stddev_Order_By>;
  stddev_pop?: InputMaybe<EventRoomWatches_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<EventRoomWatches_Stddev_Samp_Order_By>;
  sum?: InputMaybe<EventRoomWatches_Sum_Order_By>;
  var_pop?: InputMaybe<EventRoomWatches_Var_Pop_Order_By>;
  var_samp?: InputMaybe<EventRoomWatches_Var_Samp_Order_By>;
  variance?: InputMaybe<EventRoomWatches_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eventRoomWatches" */
export type EventRoomWatches_Arr_Rel_Insert_Input = {
  data: Array<EventRoomWatches_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventRoomWatches_On_Conflict>;
};

/** aggregate avg on columns */
export type EventRoomWatches_Avg_Fields = {
  __typename?: 'eventRoomWatches_avg_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "eventRoomWatches" */
export type EventRoomWatches_Avg_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eventRoomWatches". All fields are combined with a logical 'AND'. */
export type EventRoomWatches_Bool_Exp = {
  _and?: InputMaybe<Array<EventRoomWatches_Bool_Exp>>;
  _not?: InputMaybe<EventRoomWatches_Bool_Exp>;
  _or?: InputMaybe<Array<EventRoomWatches_Bool_Exp>>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "eventRoomWatches" */
export enum EventRoomWatches_Constraint {
  /** unique or primary key constraint on columns "userId", "eventId" */
  EventRoomWatchesPkey = 'eventRoomWatches_pkey'
}

/** input type for inserting data into table "eventRoomWatches" */
export type EventRoomWatches_Insert_Input = {
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type EventRoomWatches_Max_Fields = {
  __typename?: 'eventRoomWatches_max_fields';
  eventId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "eventRoomWatches" */
export type EventRoomWatches_Max_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type EventRoomWatches_Min_Fields = {
  __typename?: 'eventRoomWatches_min_fields';
  eventId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "eventRoomWatches" */
export type EventRoomWatches_Min_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eventRoomWatches" */
export type EventRoomWatches_Mutation_Response = {
  __typename?: 'eventRoomWatches_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EventRoomWatches>;
};

/** on_conflict condition type for table "eventRoomWatches" */
export type EventRoomWatches_On_Conflict = {
  constraint: EventRoomWatches_Constraint;
  update_columns?: Array<EventRoomWatches_Update_Column>;
  where?: InputMaybe<EventRoomWatches_Bool_Exp>;
};

/** Ordering options when selecting data from "eventRoomWatches". */
export type EventRoomWatches_Order_By = {
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eventRoomWatches */
export type EventRoomWatches_Pk_Columns_Input = {
  eventId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};

/** select columns of table "eventRoomWatches" */
export enum EventRoomWatches_Select_Column {
  /** column name */
  EventId = 'eventId',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type EventRoomWatches_Stddev_Fields = {
  __typename?: 'eventRoomWatches_stddev_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "eventRoomWatches" */
export type EventRoomWatches_Stddev_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type EventRoomWatches_Stddev_Pop_Fields = {
  __typename?: 'eventRoomWatches_stddev_pop_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "eventRoomWatches" */
export type EventRoomWatches_Stddev_Pop_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type EventRoomWatches_Stddev_Samp_Fields = {
  __typename?: 'eventRoomWatches_stddev_samp_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "eventRoomWatches" */
export type EventRoomWatches_Stddev_Samp_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eventRoomWatches" */
export type EventRoomWatches_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventRoomWatches_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EventRoomWatches_Stream_Cursor_Value_Input = {
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type EventRoomWatches_Sum_Fields = {
  __typename?: 'eventRoomWatches_sum_fields';
  eventId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "eventRoomWatches" */
export type EventRoomWatches_Sum_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "eventRoomWatches" (current role has no relevant permissions) */
export enum EventRoomWatches_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

export type EventRoomWatches_Updates = {
  /** filter the rows which have to be updated */
  where: EventRoomWatches_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EventRoomWatches_Var_Pop_Fields = {
  __typename?: 'eventRoomWatches_var_pop_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "eventRoomWatches" */
export type EventRoomWatches_Var_Pop_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type EventRoomWatches_Var_Samp_Fields = {
  __typename?: 'eventRoomWatches_var_samp_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "eventRoomWatches" */
export type EventRoomWatches_Var_Samp_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type EventRoomWatches_Variance_Fields = {
  __typename?: 'eventRoomWatches_variance_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "eventRoomWatches" */
export type EventRoomWatches_Variance_Order_By = {
  eventId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "eventRooms" */
export type EventRooms = {
  __typename?: 'eventRooms';
  /** An object relationship */
  event: Events;
  eventId: Scalars['bigint']['output'];
  guestCanEdit: Scalars['Boolean']['output'];
  /** An object relationship */
  room: Rooms;
  roomId: Scalars['bigint']['output'];
};

/** order by aggregate values of table "eventRooms" */
export type EventRooms_Aggregate_Order_By = {
  avg?: InputMaybe<EventRooms_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<EventRooms_Max_Order_By>;
  min?: InputMaybe<EventRooms_Min_Order_By>;
  stddev?: InputMaybe<EventRooms_Stddev_Order_By>;
  stddev_pop?: InputMaybe<EventRooms_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<EventRooms_Stddev_Samp_Order_By>;
  sum?: InputMaybe<EventRooms_Sum_Order_By>;
  var_pop?: InputMaybe<EventRooms_Var_Pop_Order_By>;
  var_samp?: InputMaybe<EventRooms_Var_Samp_Order_By>;
  variance?: InputMaybe<EventRooms_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "eventRooms" */
export type EventRooms_Arr_Rel_Insert_Input = {
  data: Array<EventRooms_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<EventRooms_On_Conflict>;
};

/** order by avg() on columns of table "eventRooms" */
export type EventRooms_Avg_Order_By = {
  eventId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "eventRooms". All fields are combined with a logical 'AND'. */
export type EventRooms_Bool_Exp = {
  _and?: InputMaybe<Array<EventRooms_Bool_Exp>>;
  _not?: InputMaybe<EventRooms_Bool_Exp>;
  _or?: InputMaybe<Array<EventRooms_Bool_Exp>>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Bigint_Comparison_Exp>;
  guestCanEdit?: InputMaybe<Boolean_Comparison_Exp>;
  room?: InputMaybe<Rooms_Bool_Exp>;
  roomId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "eventRooms" */
export enum EventRooms_Constraint {
  /** unique or primary key constraint on columns "eventId", "roomId" */
  EventRoomsPkey = 'eventRooms_pkey'
}

/** input type for inserting data into table "eventRooms" */
export type EventRooms_Insert_Input = {
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  guestCanEdit?: InputMaybe<Scalars['Boolean']['input']>;
  room?: InputMaybe<Rooms_Obj_Rel_Insert_Input>;
  roomId?: InputMaybe<Scalars['bigint']['input']>;
};

/** order by max() on columns of table "eventRooms" */
export type EventRooms_Max_Order_By = {
  eventId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "eventRooms" */
export type EventRooms_Min_Order_By = {
  eventId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "eventRooms" */
export type EventRooms_Mutation_Response = {
  __typename?: 'eventRooms_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EventRooms>;
};

/** on_conflict condition type for table "eventRooms" */
export type EventRooms_On_Conflict = {
  constraint: EventRooms_Constraint;
  update_columns?: Array<EventRooms_Update_Column>;
  where?: InputMaybe<EventRooms_Bool_Exp>;
};

/** Ordering options when selecting data from "eventRooms". */
export type EventRooms_Order_By = {
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  guestCanEdit?: InputMaybe<Order_By>;
  room?: InputMaybe<Rooms_Order_By>;
  roomId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: eventRooms */
export type EventRooms_Pk_Columns_Input = {
  eventId: Scalars['bigint']['input'];
  roomId: Scalars['bigint']['input'];
};

/** select columns of table "eventRooms" */
export enum EventRooms_Select_Column {
  /** column name */
  EventId = 'eventId',
  /** column name */
  GuestCanEdit = 'guestCanEdit',
  /** column name */
  RoomId = 'roomId'
}

/** input type for updating data in table "eventRooms" */
export type EventRooms_Set_Input = {
  guestCanEdit?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by stddev() on columns of table "eventRooms" */
export type EventRooms_Stddev_Order_By = {
  eventId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "eventRooms" */
export type EventRooms_Stddev_Pop_Order_By = {
  eventId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "eventRooms" */
export type EventRooms_Stddev_Samp_Order_By = {
  eventId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "eventRooms" */
export type EventRooms_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventRooms_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EventRooms_Stream_Cursor_Value_Input = {
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  guestCanEdit?: InputMaybe<Scalars['Boolean']['input']>;
  roomId?: InputMaybe<Scalars['bigint']['input']>;
};

/** order by sum() on columns of table "eventRooms" */
export type EventRooms_Sum_Order_By = {
  eventId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
};

/** update columns of table "eventRooms" */
export enum EventRooms_Update_Column {
  /** column name */
  GuestCanEdit = 'guestCanEdit'
}

export type EventRooms_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EventRooms_Set_Input>;
  /** filter the rows which have to be updated */
  where: EventRooms_Bool_Exp;
};

/** order by var_pop() on columns of table "eventRooms" */
export type EventRooms_Var_Pop_Order_By = {
  eventId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "eventRooms" */
export type EventRooms_Var_Samp_Order_By = {
  eventId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "eventRooms" */
export type EventRooms_Variance_Order_By = {
  eventId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
};

/** columns and relationships of "eventTypes" */
export type EventTypes = {
  __typename?: 'eventTypes';
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  events_aggregate: Events_Aggregate;
  name: Scalars['String']['output'];
};


/** columns and relationships of "eventTypes" */
export type EventTypesEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "eventTypes" */
export type EventTypesEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};

/** aggregated selection of "eventTypes" */
export type EventTypes_Aggregate = {
  __typename?: 'eventTypes_aggregate';
  aggregate?: Maybe<EventTypes_Aggregate_Fields>;
  nodes: Array<EventTypes>;
};

/** aggregate fields of "eventTypes" */
export type EventTypes_Aggregate_Fields = {
  __typename?: 'eventTypes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<EventTypes_Max_Fields>;
  min?: Maybe<EventTypes_Min_Fields>;
};


/** aggregate fields of "eventTypes" */
export type EventTypes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EventTypes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "eventTypes". All fields are combined with a logical 'AND'. */
export type EventTypes_Bool_Exp = {
  _and?: InputMaybe<Array<EventTypes_Bool_Exp>>;
  _not?: InputMaybe<EventTypes_Bool_Exp>;
  _or?: InputMaybe<Array<EventTypes_Bool_Exp>>;
  events?: InputMaybe<Events_Bool_Exp>;
  events_aggregate?: InputMaybe<Events_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

export enum EventTypes_Enum {
  CorporateEvent = 'corporateEvent',
  GuestEvent = 'guestEvent',
  SelfOrganisedEvent = 'selfOrganisedEvent'
}

/** Boolean expression to compare columns of type "eventTypes_enum". All fields are combined with logical 'AND'. */
export type EventTypes_Enum_Comparison_Exp = {
  _eq?: InputMaybe<EventTypes_Enum>;
  _in?: InputMaybe<Array<EventTypes_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<EventTypes_Enum>;
  _nin?: InputMaybe<Array<EventTypes_Enum>>;
};

/** aggregate max on columns */
export type EventTypes_Max_Fields = {
  __typename?: 'eventTypes_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type EventTypes_Min_Fields = {
  __typename?: 'eventTypes_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "eventTypes". */
export type EventTypes_Order_By = {
  events_aggregate?: InputMaybe<Events_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "eventTypes" */
export enum EventTypes_Select_Column {
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "eventTypes" */
export type EventTypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EventTypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EventTypes_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "events" */
export type Events = {
  __typename?: 'events';
  config: Scalars['json']['output'];
  createdAt: Scalars['timestamptz']['output'];
  endDate?: Maybe<Scalars['date']['output']>;
  /** An array relationship */
  eventAttributeValues: Array<EventAttributeValues>;
  /** An aggregate relationship */
  eventAttributeValues_aggregate: EventAttributeValues_Aggregate;
  /** An array relationship */
  eventFavourites: Array<EventFavourites>;
  /** An aggregate relationship */
  eventFavourites_aggregate: EventFavourites_Aggregate;
  /** An array relationship */
  eventOrganisers: Array<EventOrganisers>;
  /** An aggregate relationship */
  eventOrganisers_aggregate: EventOrganisers_Aggregate;
  /** An array relationship */
  eventRoomWatches: Array<EventRoomWatches>;
  /** An aggregate relationship */
  eventRoomWatches_aggregate: EventRoomWatches_Aggregate;
  /** An array relationship */
  eventRooms: Array<EventRooms>;
  eventType: EventTypes_Enum;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  events_aggregate: Events_Aggregate;
  guestCanEdit: Scalars['Boolean']['output'];
  guestCanEditRoommatrix: Scalars['Boolean']['output'];
  /** An object relationship */
  guestOrganisation?: Maybe<Organisations>;
  guestOrganisationId?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  isArchived?: Maybe<Scalars['timestamptz']['output']>;
  isCanceled?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "eventsIsFavourite" */
  isFavourite?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  /** An object relationship */
  parentEvent?: Maybe<Events>;
  parentId?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "events_roommatrixWritable" */
  roommatrixWritable?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  rooms: Array<Rooms>;
  /** An aggregate relationship */
  rooms_aggregate: Rooms_Aggregate;
  rubinHashEvent?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  rubinSTAMM?: Maybe<V_Organice_Event_Stamm>;
  /** An array relationship */
  services: Array<Services>;
  /** An aggregate relationship */
  services_aggregate: Services_Aggregate;
  startDate?: Maybe<Scalars['date']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "events" */
export type EventsConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "events" */
export type EventsEventAttributeValuesArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValues_Order_By>>;
  where?: InputMaybe<EventAttributeValues_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEventAttributeValues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValues_Order_By>>;
  where?: InputMaybe<EventAttributeValues_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEventFavouritesArgs = {
  distinct_on?: InputMaybe<Array<EventFavourites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventFavourites_Order_By>>;
  where?: InputMaybe<EventFavourites_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEventFavourites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventFavourites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventFavourites_Order_By>>;
  where?: InputMaybe<EventFavourites_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEventOrganisersArgs = {
  distinct_on?: InputMaybe<Array<EventOrganisers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventOrganisers_Order_By>>;
  where?: InputMaybe<EventOrganisers_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEventOrganisers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventOrganisers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventOrganisers_Order_By>>;
  where?: InputMaybe<EventOrganisers_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEventRoomWatchesArgs = {
  distinct_on?: InputMaybe<Array<EventRoomWatches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventRoomWatches_Order_By>>;
  where?: InputMaybe<EventRoomWatches_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEventRoomWatches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventRoomWatches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventRoomWatches_Order_By>>;
  where?: InputMaybe<EventRoomWatches_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEventRoomsArgs = {
  distinct_on?: InputMaybe<Array<EventRooms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventRooms_Order_By>>;
  where?: InputMaybe<EventRooms_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsRoomsArgs = {
  distinct_on?: InputMaybe<Array<Rooms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rooms_Order_By>>;
  where?: InputMaybe<Rooms_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsRooms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rooms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rooms_Order_By>>;
  where?: InputMaybe<Rooms_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsServicesArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


/** columns and relationships of "events" */
export type EventsServices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};

/** aggregated selection of "events" */
export type Events_Aggregate = {
  __typename?: 'events_aggregate';
  aggregate?: Maybe<Events_Aggregate_Fields>;
  nodes: Array<Events>;
};

export type Events_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Events_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Events_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Events_Aggregate_Bool_Exp_Count>;
};

export type Events_Aggregate_Bool_Exp_Bool_And = {
  arguments: Events_Select_Column_Events_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Events_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Events_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Events_Select_Column_Events_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Events_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Events_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Events_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "events" */
export type Events_Aggregate_Fields = {
  __typename?: 'events_aggregate_fields';
  avg?: Maybe<Events_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Events_Max_Fields>;
  min?: Maybe<Events_Min_Fields>;
  stddev?: Maybe<Events_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Sum_Fields>;
  var_pop?: Maybe<Events_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Var_Samp_Fields>;
  variance?: Maybe<Events_Variance_Fields>;
};


/** aggregate fields of "events" */
export type Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "events" */
export type Events_Aggregate_Order_By = {
  avg?: InputMaybe<Events_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Events_Max_Order_By>;
  min?: InputMaybe<Events_Min_Order_By>;
  stddev?: InputMaybe<Events_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Events_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Events_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Events_Sum_Order_By>;
  var_pop?: InputMaybe<Events_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Events_Var_Samp_Order_By>;
  variance?: InputMaybe<Events_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "events" */
export type Events_Arr_Rel_Insert_Input = {
  data: Array<Events_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Events_On_Conflict>;
};

/** aggregate avg on columns */
export type Events_Avg_Fields = {
  __typename?: 'events_avg_fields';
  guestOrganisationId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "events" */
export type Events_Avg_Order_By = {
  guestOrganisationId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "events". All fields are combined with a logical 'AND'. */
export type Events_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Bool_Exp>>;
  _not?: InputMaybe<Events_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Bool_Exp>>;
  config?: InputMaybe<Json_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  endDate?: InputMaybe<Date_Comparison_Exp>;
  eventAttributeValues?: InputMaybe<EventAttributeValues_Bool_Exp>;
  eventAttributeValues_aggregate?: InputMaybe<EventAttributeValues_Aggregate_Bool_Exp>;
  eventFavourites?: InputMaybe<EventFavourites_Bool_Exp>;
  eventFavourites_aggregate?: InputMaybe<EventFavourites_Aggregate_Bool_Exp>;
  eventOrganisers?: InputMaybe<EventOrganisers_Bool_Exp>;
  eventOrganisers_aggregate?: InputMaybe<EventOrganisers_Aggregate_Bool_Exp>;
  eventRoomWatches?: InputMaybe<EventRoomWatches_Bool_Exp>;
  eventRoomWatches_aggregate?: InputMaybe<EventRoomWatches_Aggregate_Bool_Exp>;
  eventRooms?: InputMaybe<EventRooms_Bool_Exp>;
  eventType?: InputMaybe<EventTypes_Enum_Comparison_Exp>;
  events?: InputMaybe<Events_Bool_Exp>;
  events_aggregate?: InputMaybe<Events_Aggregate_Bool_Exp>;
  guestCanEdit?: InputMaybe<Boolean_Comparison_Exp>;
  guestCanEditRoommatrix?: InputMaybe<Boolean_Comparison_Exp>;
  guestOrganisation?: InputMaybe<Organisations_Bool_Exp>;
  guestOrganisationId?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  isArchived?: InputMaybe<Timestamptz_Comparison_Exp>;
  isCanceled?: InputMaybe<Timestamptz_Comparison_Exp>;
  isFavourite?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Bool_Exp>;
  parentEvent?: InputMaybe<Events_Bool_Exp>;
  parentId?: InputMaybe<Bigint_Comparison_Exp>;
  roommatrixWritable?: InputMaybe<Boolean_Comparison_Exp>;
  rooms?: InputMaybe<Rooms_Bool_Exp>;
  rooms_aggregate?: InputMaybe<Rooms_Aggregate_Bool_Exp>;
  rubinHashEvent?: InputMaybe<String_Comparison_Exp>;
  rubinSTAMM?: InputMaybe<V_Organice_Event_Stamm_Bool_Exp>;
  services?: InputMaybe<Services_Bool_Exp>;
  services_aggregate?: InputMaybe<Services_Aggregate_Bool_Exp>;
  startDate?: InputMaybe<Date_Comparison_Exp>;
  subTitle?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "events" */
export enum Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  EventsPkey = 'events_pkey',
  /** unique or primary key constraint on columns "rubinHashEvent" */
  EventsRubinHashEventKey = 'events_rubinHashEvent_key'
}

/** input type for incrementing numeric columns in table "events" */
export type Events_Inc_Input = {
  guestOrganisationId?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "events" */
export type Events_Insert_Input = {
  config?: InputMaybe<Scalars['json']['input']>;
  endDate?: InputMaybe<Scalars['date']['input']>;
  eventAttributeValues?: InputMaybe<EventAttributeValues_Arr_Rel_Insert_Input>;
  eventFavourites?: InputMaybe<EventFavourites_Arr_Rel_Insert_Input>;
  eventOrganisers?: InputMaybe<EventOrganisers_Arr_Rel_Insert_Input>;
  eventRoomWatches?: InputMaybe<EventRoomWatches_Arr_Rel_Insert_Input>;
  eventRooms?: InputMaybe<EventRooms_Arr_Rel_Insert_Input>;
  eventType?: InputMaybe<EventTypes_Enum>;
  events?: InputMaybe<Events_Arr_Rel_Insert_Input>;
  guestCanEdit?: InputMaybe<Scalars['Boolean']['input']>;
  guestCanEditRoommatrix?: InputMaybe<Scalars['Boolean']['input']>;
  guestOrganisation?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  guestOrganisationId?: InputMaybe<Scalars['bigint']['input']>;
  isArchived?: InputMaybe<Scalars['timestamptz']['input']>;
  isCanceled?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentEvent?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  parentId?: InputMaybe<Scalars['bigint']['input']>;
  rooms?: InputMaybe<Rooms_Arr_Rel_Insert_Input>;
  rubinHashEvent?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Services_Arr_Rel_Insert_Input>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Events_Max_Fields = {
  __typename?: 'events_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  endDate?: Maybe<Scalars['date']['output']>;
  guestOrganisationId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  isArchived?: Maybe<Scalars['timestamptz']['output']>;
  isCanceled?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['bigint']['output']>;
  rubinHashEvent?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['date']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "events" */
export type Events_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  guestOrganisationId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isArchived?: InputMaybe<Order_By>;
  isCanceled?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  rubinHashEvent?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  subTitle?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Events_Min_Fields = {
  __typename?: 'events_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  endDate?: Maybe<Scalars['date']['output']>;
  guestOrganisationId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  isArchived?: Maybe<Scalars['timestamptz']['output']>;
  isCanceled?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['bigint']['output']>;
  rubinHashEvent?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['date']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "events" */
export type Events_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  guestOrganisationId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isArchived?: InputMaybe<Order_By>;
  isCanceled?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  rubinHashEvent?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  subTitle?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "events" */
export type Events_Mutation_Response = {
  __typename?: 'events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Events>;
};

/** input type for inserting object relation for remote table "events" */
export type Events_Obj_Rel_Insert_Input = {
  data: Events_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Events_On_Conflict>;
};

/** on_conflict condition type for table "events" */
export type Events_On_Conflict = {
  constraint: Events_Constraint;
  update_columns?: Array<Events_Update_Column>;
  where?: InputMaybe<Events_Bool_Exp>;
};

/** Ordering options when selecting data from "events". */
export type Events_Order_By = {
  config?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  eventAttributeValues_aggregate?: InputMaybe<EventAttributeValues_Aggregate_Order_By>;
  eventFavourites_aggregate?: InputMaybe<EventFavourites_Aggregate_Order_By>;
  eventOrganisers_aggregate?: InputMaybe<EventOrganisers_Aggregate_Order_By>;
  eventRoomWatches_aggregate?: InputMaybe<EventRoomWatches_Aggregate_Order_By>;
  eventRooms_aggregate?: InputMaybe<EventRooms_Aggregate_Order_By>;
  eventType?: InputMaybe<Order_By>;
  events_aggregate?: InputMaybe<Events_Aggregate_Order_By>;
  guestCanEdit?: InputMaybe<Order_By>;
  guestCanEditRoommatrix?: InputMaybe<Order_By>;
  guestOrganisation?: InputMaybe<Organisations_Order_By>;
  guestOrganisationId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isArchived?: InputMaybe<Order_By>;
  isCanceled?: InputMaybe<Order_By>;
  isFavourite?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  parentEvent?: InputMaybe<Events_Order_By>;
  parentId?: InputMaybe<Order_By>;
  roommatrixWritable?: InputMaybe<Order_By>;
  rooms_aggregate?: InputMaybe<Rooms_Aggregate_Order_By>;
  rubinHashEvent?: InputMaybe<Order_By>;
  rubinSTAMM?: InputMaybe<V_Organice_Event_Stamm_Order_By>;
  services_aggregate?: InputMaybe<Services_Aggregate_Order_By>;
  startDate?: InputMaybe<Order_By>;
  subTitle?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: events */
export type Events_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "events" */
export enum Events_Select_Column {
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  EventType = 'eventType',
  /** column name */
  GuestCanEdit = 'guestCanEdit',
  /** column name */
  GuestCanEditRoommatrix = 'guestCanEditRoommatrix',
  /** column name */
  GuestOrganisationId = 'guestOrganisationId',
  /** column name */
  Id = 'id',
  /** column name */
  IsArchived = 'isArchived',
  /** column name */
  IsCanceled = 'isCanceled',
  /** column name */
  Name = 'name',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  RubinHashEvent = 'rubinHashEvent',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  SubTitle = 'subTitle',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "events_aggregate_bool_exp_bool_and_arguments_columns" columns of table "events" */
export enum Events_Select_Column_Events_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  GuestCanEdit = 'guestCanEdit',
  /** column name */
  GuestCanEditRoommatrix = 'guestCanEditRoommatrix'
}

/** select "events_aggregate_bool_exp_bool_or_arguments_columns" columns of table "events" */
export enum Events_Select_Column_Events_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  GuestCanEdit = 'guestCanEdit',
  /** column name */
  GuestCanEditRoommatrix = 'guestCanEditRoommatrix'
}

/** input type for updating data in table "events" */
export type Events_Set_Input = {
  config?: InputMaybe<Scalars['json']['input']>;
  endDate?: InputMaybe<Scalars['date']['input']>;
  eventType?: InputMaybe<EventTypes_Enum>;
  guestCanEdit?: InputMaybe<Scalars['Boolean']['input']>;
  guestCanEditRoommatrix?: InputMaybe<Scalars['Boolean']['input']>;
  guestOrganisationId?: InputMaybe<Scalars['bigint']['input']>;
  isArchived?: InputMaybe<Scalars['timestamptz']['input']>;
  isCanceled?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rubinHashEvent?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Events_Stddev_Fields = {
  __typename?: 'events_stddev_fields';
  guestOrganisationId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "events" */
export type Events_Stddev_Order_By = {
  guestOrganisationId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Events_Stddev_Pop_Fields = {
  __typename?: 'events_stddev_pop_fields';
  guestOrganisationId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "events" */
export type Events_Stddev_Pop_Order_By = {
  guestOrganisationId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Events_Stddev_Samp_Fields = {
  __typename?: 'events_stddev_samp_fields';
  guestOrganisationId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "events" */
export type Events_Stddev_Samp_Order_By = {
  guestOrganisationId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "events" */
export type Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Stream_Cursor_Value_Input = {
  config?: InputMaybe<Scalars['json']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['date']['input']>;
  eventType?: InputMaybe<EventTypes_Enum>;
  guestCanEdit?: InputMaybe<Scalars['Boolean']['input']>;
  guestCanEditRoommatrix?: InputMaybe<Scalars['Boolean']['input']>;
  guestOrganisationId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  isArchived?: InputMaybe<Scalars['timestamptz']['input']>;
  isCanceled?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['bigint']['input']>;
  rubinHashEvent?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Events_Sum_Fields = {
  __typename?: 'events_sum_fields';
  guestOrganisationId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  parentId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "events" */
export type Events_Sum_Order_By = {
  guestOrganisationId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** update columns of table "events" */
export enum Events_Update_Column {
  /** column name */
  Config = 'config',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  EventType = 'eventType',
  /** column name */
  GuestCanEdit = 'guestCanEdit',
  /** column name */
  GuestCanEditRoommatrix = 'guestCanEditRoommatrix',
  /** column name */
  GuestOrganisationId = 'guestOrganisationId',
  /** column name */
  IsArchived = 'isArchived',
  /** column name */
  IsCanceled = 'isCanceled',
  /** column name */
  Name = 'name',
  /** column name */
  RubinHashEvent = 'rubinHashEvent',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  SubTitle = 'subTitle'
}

export type Events_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Events_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Events_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Events_Var_Pop_Fields = {
  __typename?: 'events_var_pop_fields';
  guestOrganisationId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "events" */
export type Events_Var_Pop_Order_By = {
  guestOrganisationId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Events_Var_Samp_Fields = {
  __typename?: 'events_var_samp_fields';
  guestOrganisationId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "events" */
export type Events_Var_Samp_Order_By = {
  guestOrganisationId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Events_Variance_Fields = {
  __typename?: 'events_variance_fields';
  guestOrganisationId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "events" */
export type Events_Variance_Order_By = {
  guestOrganisationId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** columns and relationships of "fileMasterVersions" */
export type FileMasterVersions = {
  __typename?: 'fileMasterVersions';
  /** A computed field, executes function "fileMasterVersions_downloadUrl" */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  file: Files;
  fileId: Scalars['bigint']['output'];
  /** An object relationship */
  fileMaster: FileMasters;
  fileMasterId: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "fileMasterVersions" */
export type FileMasterVersions_Aggregate = {
  __typename?: 'fileMasterVersions_aggregate';
  aggregate?: Maybe<FileMasterVersions_Aggregate_Fields>;
  nodes: Array<FileMasterVersions>;
};

export type FileMasterVersions_Aggregate_Bool_Exp = {
  count?: InputMaybe<FileMasterVersions_Aggregate_Bool_Exp_Count>;
};

export type FileMasterVersions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<FileMasterVersions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<FileMasterVersions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "fileMasterVersions" */
export type FileMasterVersions_Aggregate_Fields = {
  __typename?: 'fileMasterVersions_aggregate_fields';
  avg?: Maybe<FileMasterVersions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<FileMasterVersions_Max_Fields>;
  min?: Maybe<FileMasterVersions_Min_Fields>;
  stddev?: Maybe<FileMasterVersions_Stddev_Fields>;
  stddev_pop?: Maybe<FileMasterVersions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<FileMasterVersions_Stddev_Samp_Fields>;
  sum?: Maybe<FileMasterVersions_Sum_Fields>;
  var_pop?: Maybe<FileMasterVersions_Var_Pop_Fields>;
  var_samp?: Maybe<FileMasterVersions_Var_Samp_Fields>;
  variance?: Maybe<FileMasterVersions_Variance_Fields>;
};


/** aggregate fields of "fileMasterVersions" */
export type FileMasterVersions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FileMasterVersions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "fileMasterVersions" */
export type FileMasterVersions_Aggregate_Order_By = {
  avg?: InputMaybe<FileMasterVersions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<FileMasterVersions_Max_Order_By>;
  min?: InputMaybe<FileMasterVersions_Min_Order_By>;
  stddev?: InputMaybe<FileMasterVersions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<FileMasterVersions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<FileMasterVersions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<FileMasterVersions_Sum_Order_By>;
  var_pop?: InputMaybe<FileMasterVersions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<FileMasterVersions_Var_Samp_Order_By>;
  variance?: InputMaybe<FileMasterVersions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "fileMasterVersions" */
export type FileMasterVersions_Arr_Rel_Insert_Input = {
  data: Array<FileMasterVersions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<FileMasterVersions_On_Conflict>;
};

/** aggregate avg on columns */
export type FileMasterVersions_Avg_Fields = {
  __typename?: 'fileMasterVersions_avg_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  fileMasterId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "fileMasterVersions" */
export type FileMasterVersions_Avg_Order_By = {
  fileId?: InputMaybe<Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "fileMasterVersions". All fields are combined with a logical 'AND'. */
export type FileMasterVersions_Bool_Exp = {
  _and?: InputMaybe<Array<FileMasterVersions_Bool_Exp>>;
  _not?: InputMaybe<FileMasterVersions_Bool_Exp>;
  _or?: InputMaybe<Array<FileMasterVersions_Bool_Exp>>;
  downloadUrl?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Bigint_Comparison_Exp>;
  fileMaster?: InputMaybe<FileMasters_Bool_Exp>;
  fileMasterId?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "fileMasterVersions" */
export enum FileMasterVersions_Constraint {
  /** unique or primary key constraint on columns "id" */
  FileMasterVersionsPkey = 'fileMasterVersions_pkey'
}

/** input type for inserting data into table "fileMasterVersions" */
export type FileMasterVersions_Insert_Input = {
  fileId?: InputMaybe<Scalars['bigint']['input']>;
  fileMaster?: InputMaybe<FileMasters_Obj_Rel_Insert_Input>;
  fileMasterId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type FileMasterVersions_Max_Fields = {
  __typename?: 'fileMasterVersions_max_fields';
  /** A computed field, executes function "fileMasterVersions_downloadUrl" */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
  fileMasterId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "fileMasterVersions" */
export type FileMasterVersions_Max_Order_By = {
  fileId?: InputMaybe<Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type FileMasterVersions_Min_Fields = {
  __typename?: 'fileMasterVersions_min_fields';
  /** A computed field, executes function "fileMasterVersions_downloadUrl" */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
  fileMasterId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "fileMasterVersions" */
export type FileMasterVersions_Min_Order_By = {
  fileId?: InputMaybe<Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "fileMasterVersions" */
export type FileMasterVersions_Mutation_Response = {
  __typename?: 'fileMasterVersions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<FileMasterVersions>;
};

/** on_conflict condition type for table "fileMasterVersions" */
export type FileMasterVersions_On_Conflict = {
  constraint: FileMasterVersions_Constraint;
  update_columns?: Array<FileMasterVersions_Update_Column>;
  where?: InputMaybe<FileMasterVersions_Bool_Exp>;
};

/** Ordering options when selecting data from "fileMasterVersions". */
export type FileMasterVersions_Order_By = {
  downloadUrl?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
  fileMaster?: InputMaybe<FileMasters_Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "fileMasterVersions" */
export enum FileMasterVersions_Select_Column {
  /** column name */
  FileId = 'fileId',
  /** column name */
  FileMasterId = 'fileMasterId',
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type FileMasterVersions_Stddev_Fields = {
  __typename?: 'fileMasterVersions_stddev_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  fileMasterId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "fileMasterVersions" */
export type FileMasterVersions_Stddev_Order_By = {
  fileId?: InputMaybe<Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type FileMasterVersions_Stddev_Pop_Fields = {
  __typename?: 'fileMasterVersions_stddev_pop_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  fileMasterId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "fileMasterVersions" */
export type FileMasterVersions_Stddev_Pop_Order_By = {
  fileId?: InputMaybe<Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type FileMasterVersions_Stddev_Samp_Fields = {
  __typename?: 'fileMasterVersions_stddev_samp_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  fileMasterId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "fileMasterVersions" */
export type FileMasterVersions_Stddev_Samp_Order_By = {
  fileId?: InputMaybe<Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "fileMasterVersions" */
export type FileMasterVersions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FileMasterVersions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FileMasterVersions_Stream_Cursor_Value_Input = {
  fileId?: InputMaybe<Scalars['bigint']['input']>;
  fileMasterId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type FileMasterVersions_Sum_Fields = {
  __typename?: 'fileMasterVersions_sum_fields';
  fileId?: Maybe<Scalars['bigint']['output']>;
  fileMasterId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "fileMasterVersions" */
export type FileMasterVersions_Sum_Order_By = {
  fileId?: InputMaybe<Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "fileMasterVersions" (current role has no relevant permissions) */
export enum FileMasterVersions_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type FileMasterVersions_Var_Pop_Fields = {
  __typename?: 'fileMasterVersions_var_pop_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  fileMasterId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "fileMasterVersions" */
export type FileMasterVersions_Var_Pop_Order_By = {
  fileId?: InputMaybe<Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type FileMasterVersions_Var_Samp_Fields = {
  __typename?: 'fileMasterVersions_var_samp_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  fileMasterId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "fileMasterVersions" */
export type FileMasterVersions_Var_Samp_Order_By = {
  fileId?: InputMaybe<Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type FileMasterVersions_Variance_Fields = {
  __typename?: 'fileMasterVersions_variance_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  fileMasterId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "fileMasterVersions" */
export type FileMasterVersions_Variance_Order_By = {
  fileId?: InputMaybe<Order_By>;
  fileMasterId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "fileMasters" */
export type FileMasters = {
  __typename?: 'fileMasters';
  /** An array relationship */
  attributes: Array<Attributes>;
  /** An aggregate relationship */
  attributes_aggregate: Attributes_Aggregate;
  childVersionsUpdatedAt: Scalars['timestamptz']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  fileMasterVersions: Array<FileMasterVersions>;
  /** An aggregate relationship */
  fileMasterVersions_aggregate: FileMasterVersions_Aggregate;
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "fileMasters" */
export type FileMastersAttributesArgs = {
  distinct_on?: InputMaybe<Array<Attributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attributes_Order_By>>;
  where?: InputMaybe<Attributes_Bool_Exp>;
};


/** columns and relationships of "fileMasters" */
export type FileMastersAttributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attributes_Order_By>>;
  where?: InputMaybe<Attributes_Bool_Exp>;
};


/** columns and relationships of "fileMasters" */
export type FileMastersFileMasterVersionsArgs = {
  distinct_on?: InputMaybe<Array<FileMasterVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FileMasterVersions_Order_By>>;
  where?: InputMaybe<FileMasterVersions_Bool_Exp>;
};


/** columns and relationships of "fileMasters" */
export type FileMastersFileMasterVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FileMasterVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FileMasterVersions_Order_By>>;
  where?: InputMaybe<FileMasterVersions_Bool_Exp>;
};

/** aggregated selection of "fileMasters" */
export type FileMasters_Aggregate = {
  __typename?: 'fileMasters_aggregate';
  aggregate?: Maybe<FileMasters_Aggregate_Fields>;
  nodes: Array<FileMasters>;
};

/** aggregate fields of "fileMasters" */
export type FileMasters_Aggregate_Fields = {
  __typename?: 'fileMasters_aggregate_fields';
  avg?: Maybe<FileMasters_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<FileMasters_Max_Fields>;
  min?: Maybe<FileMasters_Min_Fields>;
  stddev?: Maybe<FileMasters_Stddev_Fields>;
  stddev_pop?: Maybe<FileMasters_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<FileMasters_Stddev_Samp_Fields>;
  sum?: Maybe<FileMasters_Sum_Fields>;
  var_pop?: Maybe<FileMasters_Var_Pop_Fields>;
  var_samp?: Maybe<FileMasters_Var_Samp_Fields>;
  variance?: Maybe<FileMasters_Variance_Fields>;
};


/** aggregate fields of "fileMasters" */
export type FileMasters_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<FileMasters_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type FileMasters_Avg_Fields = {
  __typename?: 'fileMasters_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "fileMasters". All fields are combined with a logical 'AND'. */
export type FileMasters_Bool_Exp = {
  _and?: InputMaybe<Array<FileMasters_Bool_Exp>>;
  _not?: InputMaybe<FileMasters_Bool_Exp>;
  _or?: InputMaybe<Array<FileMasters_Bool_Exp>>;
  attributes?: InputMaybe<Attributes_Bool_Exp>;
  attributes_aggregate?: InputMaybe<Attributes_Aggregate_Bool_Exp>;
  childVersionsUpdatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  fileMasterVersions?: InputMaybe<FileMasterVersions_Bool_Exp>;
  fileMasterVersions_aggregate?: InputMaybe<FileMasterVersions_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "fileMasters" */
export enum FileMasters_Constraint {
  /** unique or primary key constraint on columns "id" */
  FileMastersPkey = 'fileMasters_pkey'
}

/** input type for inserting data into table "fileMasters" */
export type FileMasters_Insert_Input = {
  attributes?: InputMaybe<Attributes_Arr_Rel_Insert_Input>;
  fileMasterVersions?: InputMaybe<FileMasterVersions_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type FileMasters_Max_Fields = {
  __typename?: 'fileMasters_max_fields';
  childVersionsUpdatedAt?: Maybe<Scalars['timestamptz']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type FileMasters_Min_Fields = {
  __typename?: 'fileMasters_min_fields';
  childVersionsUpdatedAt?: Maybe<Scalars['timestamptz']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "fileMasters" */
export type FileMasters_Mutation_Response = {
  __typename?: 'fileMasters_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<FileMasters>;
};

/** input type for inserting object relation for remote table "fileMasters" */
export type FileMasters_Obj_Rel_Insert_Input = {
  data: FileMasters_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<FileMasters_On_Conflict>;
};

/** on_conflict condition type for table "fileMasters" */
export type FileMasters_On_Conflict = {
  constraint: FileMasters_Constraint;
  update_columns?: Array<FileMasters_Update_Column>;
  where?: InputMaybe<FileMasters_Bool_Exp>;
};

/** Ordering options when selecting data from "fileMasters". */
export type FileMasters_Order_By = {
  attributes_aggregate?: InputMaybe<Attributes_Aggregate_Order_By>;
  childVersionsUpdatedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fileMasterVersions_aggregate?: InputMaybe<FileMasterVersions_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: fileMasters */
export type FileMasters_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "fileMasters" */
export enum FileMasters_Select_Column {
  /** column name */
  ChildVersionsUpdatedAt = 'childVersionsUpdatedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "fileMasters" */
export type FileMasters_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type FileMasters_Stddev_Fields = {
  __typename?: 'fileMasters_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type FileMasters_Stddev_Pop_Fields = {
  __typename?: 'fileMasters_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type FileMasters_Stddev_Samp_Fields = {
  __typename?: 'fileMasters_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "fileMasters" */
export type FileMasters_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: FileMasters_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type FileMasters_Stream_Cursor_Value_Input = {
  childVersionsUpdatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type FileMasters_Sum_Fields = {
  __typename?: 'fileMasters_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "fileMasters" */
export enum FileMasters_Update_Column {
  /** column name */
  Name = 'name'
}

export type FileMasters_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<FileMasters_Set_Input>;
  /** filter the rows which have to be updated */
  where: FileMasters_Bool_Exp;
};

/** aggregate var_pop on columns */
export type FileMasters_Var_Pop_Fields = {
  __typename?: 'fileMasters_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type FileMasters_Var_Samp_Fields = {
  __typename?: 'fileMasters_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type FileMasters_Variance_Fields = {
  __typename?: 'fileMasters_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "files" */
export type Files = {
  __typename?: 'files';
  /** An array relationship */
  attributeFiles: Array<AttributeFiles>;
  /** An aggregate relationship */
  attributeFiles_aggregate: AttributeFiles_Aggregate;
  /** An array relationship */
  attributeValueUploadVersions: Array<AttributeValueUploadVersions>;
  /** An aggregate relationship */
  attributeValueUploadVersions_aggregate: AttributeValueUploadVersions_Aggregate;
  /** An array relationship */
  cartLines: Array<CartLines>;
  /** An aggregate relationship */
  cartLines_aggregate: CartLines_Aggregate;
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  eventAttributeValueUploadVersions: Array<EventAttributeValueUploadVersions>;
  /** An aggregate relationship */
  eventAttributeValueUploadVersions_aggregate: EventAttributeValueUploadVersions_Aggregate;
  extension: Scalars['String']['output'];
  /** An array relationship */
  fileMasterVersions: Array<FileMasterVersions>;
  /** An aggregate relationship */
  fileMasterVersions_aggregate: FileMasterVersions_Aggregate;
  /** An object relationship */
  fullUser?: Maybe<Users>;
  hash: Scalars['bpchar']['output'];
  id: Scalars['bigint']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  /** An array relationship */
  roomAttributeFiles: Array<RoomAttributeFiles>;
  /** An array relationship */
  roomAttributeValueUploadVersions: Array<RoomAttributeValueUploadVersions>;
  /** An aggregate relationship */
  roomAttributeValueUploadVersions_aggregate: RoomAttributeValueUploadVersions_Aggregate;
  size?: Maybe<Scalars['bigint']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  uploadVersions: Array<UploadVersions>;
  /** An aggregate relationship */
  uploadVersions_aggregate: UploadVersions_Aggregate;
  /** An object relationship */
  user?: Maybe<AllUsers>;
  userId?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "files" */
export type FilesAttributeFilesArgs = {
  distinct_on?: InputMaybe<Array<AttributeFiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeFiles_Order_By>>;
  where?: InputMaybe<AttributeFiles_Bool_Exp>;
};


/** columns and relationships of "files" */
export type FilesAttributeFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeFiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeFiles_Order_By>>;
  where?: InputMaybe<AttributeFiles_Bool_Exp>;
};


/** columns and relationships of "files" */
export type FilesAttributeValueUploadVersionsArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<AttributeValueUploadVersions_Bool_Exp>;
};


/** columns and relationships of "files" */
export type FilesAttributeValueUploadVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<AttributeValueUploadVersions_Bool_Exp>;
};


/** columns and relationships of "files" */
export type FilesCartLinesArgs = {
  distinct_on?: InputMaybe<Array<CartLines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CartLines_Order_By>>;
  where?: InputMaybe<CartLines_Bool_Exp>;
};


/** columns and relationships of "files" */
export type FilesCartLines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CartLines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CartLines_Order_By>>;
  where?: InputMaybe<CartLines_Bool_Exp>;
};


/** columns and relationships of "files" */
export type FilesEventAttributeValueUploadVersionsArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<EventAttributeValueUploadVersions_Bool_Exp>;
};


/** columns and relationships of "files" */
export type FilesEventAttributeValueUploadVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<EventAttributeValueUploadVersions_Bool_Exp>;
};


/** columns and relationships of "files" */
export type FilesFileMasterVersionsArgs = {
  distinct_on?: InputMaybe<Array<FileMasterVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FileMasterVersions_Order_By>>;
  where?: InputMaybe<FileMasterVersions_Bool_Exp>;
};


/** columns and relationships of "files" */
export type FilesFileMasterVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FileMasterVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FileMasterVersions_Order_By>>;
  where?: InputMaybe<FileMasterVersions_Bool_Exp>;
};


/** columns and relationships of "files" */
export type FilesNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "files" */
export type FilesNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "files" */
export type FilesRoomAttributeFilesArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeFiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeFiles_Order_By>>;
  where?: InputMaybe<RoomAttributeFiles_Bool_Exp>;
};


/** columns and relationships of "files" */
export type FilesRoomAttributeValueUploadVersionsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<RoomAttributeValueUploadVersions_Bool_Exp>;
};


/** columns and relationships of "files" */
export type FilesRoomAttributeValueUploadVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<RoomAttributeValueUploadVersions_Bool_Exp>;
};


/** columns and relationships of "files" */
export type FilesUploadVersionsArgs = {
  distinct_on?: InputMaybe<Array<UploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UploadVersions_Order_By>>;
  where?: InputMaybe<UploadVersions_Bool_Exp>;
};


/** columns and relationships of "files" */
export type FilesUploadVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UploadVersions_Order_By>>;
  where?: InputMaybe<UploadVersions_Bool_Exp>;
};

/** aggregated selection of "files" */
export type Files_Aggregate = {
  __typename?: 'files_aggregate';
  aggregate?: Maybe<Files_Aggregate_Fields>;
  nodes: Array<Files>;
};

export type Files_Aggregate_Bool_Exp = {
  count?: InputMaybe<Files_Aggregate_Bool_Exp_Count>;
};

export type Files_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "files" */
export type Files_Aggregate_Fields = {
  __typename?: 'files_aggregate_fields';
  avg?: Maybe<Files_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Files_Max_Fields>;
  min?: Maybe<Files_Min_Fields>;
  stddev?: Maybe<Files_Stddev_Fields>;
  stddev_pop?: Maybe<Files_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Files_Stddev_Samp_Fields>;
  sum?: Maybe<Files_Sum_Fields>;
  var_pop?: Maybe<Files_Var_Pop_Fields>;
  var_samp?: Maybe<Files_Var_Samp_Fields>;
  variance?: Maybe<Files_Variance_Fields>;
};


/** aggregate fields of "files" */
export type Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "files" */
export type Files_Aggregate_Order_By = {
  avg?: InputMaybe<Files_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Files_Max_Order_By>;
  min?: InputMaybe<Files_Min_Order_By>;
  stddev?: InputMaybe<Files_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Files_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Files_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Files_Sum_Order_By>;
  var_pop?: InputMaybe<Files_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Files_Var_Samp_Order_By>;
  variance?: InputMaybe<Files_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Files_Avg_Fields = {
  __typename?: 'files_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "files" */
export type Files_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "files". All fields are combined with a logical 'AND'. */
export type Files_Bool_Exp = {
  _and?: InputMaybe<Array<Files_Bool_Exp>>;
  _not?: InputMaybe<Files_Bool_Exp>;
  _or?: InputMaybe<Array<Files_Bool_Exp>>;
  attributeFiles?: InputMaybe<AttributeFiles_Bool_Exp>;
  attributeFiles_aggregate?: InputMaybe<AttributeFiles_Aggregate_Bool_Exp>;
  attributeValueUploadVersions?: InputMaybe<AttributeValueUploadVersions_Bool_Exp>;
  attributeValueUploadVersions_aggregate?: InputMaybe<AttributeValueUploadVersions_Aggregate_Bool_Exp>;
  cartLines?: InputMaybe<CartLines_Bool_Exp>;
  cartLines_aggregate?: InputMaybe<CartLines_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  eventAttributeValueUploadVersions?: InputMaybe<EventAttributeValueUploadVersions_Bool_Exp>;
  eventAttributeValueUploadVersions_aggregate?: InputMaybe<EventAttributeValueUploadVersions_Aggregate_Bool_Exp>;
  extension?: InputMaybe<String_Comparison_Exp>;
  fileMasterVersions?: InputMaybe<FileMasterVersions_Bool_Exp>;
  fileMasterVersions_aggregate?: InputMaybe<FileMasterVersions_Aggregate_Bool_Exp>;
  fullUser?: InputMaybe<Users_Bool_Exp>;
  hash?: InputMaybe<Bpchar_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  mimeType?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Bool_Exp>;
  roomAttributeFiles?: InputMaybe<RoomAttributeFiles_Bool_Exp>;
  roomAttributeValueUploadVersions?: InputMaybe<RoomAttributeValueUploadVersions_Bool_Exp>;
  roomAttributeValueUploadVersions_aggregate?: InputMaybe<RoomAttributeValueUploadVersions_Aggregate_Bool_Exp>;
  size?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploadVersions?: InputMaybe<UploadVersions_Bool_Exp>;
  uploadVersions_aggregate?: InputMaybe<UploadVersions_Aggregate_Bool_Exp>;
  user?: InputMaybe<AllUsers_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "files" */
export type Files_Inc_Input = {
  size?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Files_Max_Fields = {
  __typename?: 'files_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "files" */
export type Files_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  extension?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Files_Min_Fields = {
  __typename?: 'files_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['bpchar']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "files" */
export type Files_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  extension?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "files" */
export type Files_Mutation_Response = {
  __typename?: 'files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Files>;
};

/** Ordering options when selecting data from "files". */
export type Files_Order_By = {
  attributeFiles_aggregate?: InputMaybe<AttributeFiles_Aggregate_Order_By>;
  attributeValueUploadVersions_aggregate?: InputMaybe<AttributeValueUploadVersions_Aggregate_Order_By>;
  cartLines_aggregate?: InputMaybe<CartLines_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  eventAttributeValueUploadVersions_aggregate?: InputMaybe<EventAttributeValueUploadVersions_Aggregate_Order_By>;
  extension?: InputMaybe<Order_By>;
  fileMasterVersions_aggregate?: InputMaybe<FileMasterVersions_Aggregate_Order_By>;
  fullUser?: InputMaybe<Users_Order_By>;
  hash?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimeType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  roomAttributeFiles_aggregate?: InputMaybe<RoomAttributeFiles_Aggregate_Order_By>;
  roomAttributeValueUploadVersions_aggregate?: InputMaybe<RoomAttributeValueUploadVersions_Aggregate_Order_By>;
  size?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadVersions_aggregate?: InputMaybe<UploadVersions_Aggregate_Order_By>;
  user?: InputMaybe<AllUsers_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: files */
export type Files_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "files" */
export enum Files_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Extension = 'extension',
  /** column name */
  Hash = 'hash',
  /** column name */
  Id = 'id',
  /** column name */
  MimeType = 'mimeType',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "files" */
export type Files_Set_Input = {
  extension?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['bpchar']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Files_Stddev_Fields = {
  __typename?: 'files_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "files" */
export type Files_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Files_Stddev_Pop_Fields = {
  __typename?: 'files_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "files" */
export type Files_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Files_Stddev_Samp_Fields = {
  __typename?: 'files_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "files" */
export type Files_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "files" */
export type Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Files_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  hash?: InputMaybe<Scalars['bpchar']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Files_Sum_Fields = {
  __typename?: 'files_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  size?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "files" */
export type Files_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

export type Files_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Files_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Files_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Files_Var_Pop_Fields = {
  __typename?: 'files_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "files" */
export type Files_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Files_Var_Samp_Fields = {
  __typename?: 'files_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "files" */
export type Files_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Files_Variance_Fields = {
  __typename?: 'files_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "files" */
export type Files_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "infoBoxes" */
export type InfoBoxes = {
  __typename?: 'infoBoxes';
  content: Scalars['json']['output'];
  createdAt: Scalars['timestamptz']['output'];
  createdBy?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  createdBy_fullUser?: Maybe<Users>;
  /** An object relationship */
  createdBy_user?: Maybe<AllUsers>;
  id: Scalars['bigint']['output'];
  isInternal: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  updatedBy_fullUser?: Maybe<Users>;
  /** An object relationship */
  updatedBy_user?: Maybe<AllUsers>;
};


/** columns and relationships of "infoBoxes" */
export type InfoBoxesContentArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "infoBoxes" */
export type InfoBoxes_Aggregate = {
  __typename?: 'infoBoxes_aggregate';
  aggregate?: Maybe<InfoBoxes_Aggregate_Fields>;
  nodes: Array<InfoBoxes>;
};

/** aggregate fields of "infoBoxes" */
export type InfoBoxes_Aggregate_Fields = {
  __typename?: 'infoBoxes_aggregate_fields';
  avg?: Maybe<InfoBoxes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<InfoBoxes_Max_Fields>;
  min?: Maybe<InfoBoxes_Min_Fields>;
  stddev?: Maybe<InfoBoxes_Stddev_Fields>;
  stddev_pop?: Maybe<InfoBoxes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<InfoBoxes_Stddev_Samp_Fields>;
  sum?: Maybe<InfoBoxes_Sum_Fields>;
  var_pop?: Maybe<InfoBoxes_Var_Pop_Fields>;
  var_samp?: Maybe<InfoBoxes_Var_Samp_Fields>;
  variance?: Maybe<InfoBoxes_Variance_Fields>;
};


/** aggregate fields of "infoBoxes" */
export type InfoBoxes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<InfoBoxes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type InfoBoxes_Avg_Fields = {
  __typename?: 'infoBoxes_avg_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "infoBoxes". All fields are combined with a logical 'AND'. */
export type InfoBoxes_Bool_Exp = {
  _and?: InputMaybe<Array<InfoBoxes_Bool_Exp>>;
  _not?: InputMaybe<InfoBoxes_Bool_Exp>;
  _or?: InputMaybe<Array<InfoBoxes_Bool_Exp>>;
  content?: InputMaybe<Json_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<Bigint_Comparison_Exp>;
  createdBy_fullUser?: InputMaybe<Users_Bool_Exp>;
  createdBy_user?: InputMaybe<AllUsers_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  isInternal?: InputMaybe<Boolean_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedBy?: InputMaybe<Bigint_Comparison_Exp>;
  updatedBy_fullUser?: InputMaybe<Users_Bool_Exp>;
  updatedBy_user?: InputMaybe<AllUsers_Bool_Exp>;
};

/** unique or primary key constraints on table "infoBoxes" */
export enum InfoBoxes_Constraint {
  /** unique or primary key constraint on columns "id" */
  InfoBoxesPkey = 'infoBoxes_pkey',
  /** unique or primary key constraint on columns "slug" */
  InfoBoxesSlugKey = 'infoBoxes_slug_key'
}

/** input type for inserting data into table "infoBoxes" */
export type InfoBoxes_Insert_Input = {
  content?: InputMaybe<Scalars['json']['input']>;
  createdBy_fullUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedBy_fullUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type InfoBoxes_Max_Fields = {
  __typename?: 'infoBoxes_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedBy?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type InfoBoxes_Min_Fields = {
  __typename?: 'infoBoxes_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedBy?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "infoBoxes" */
export type InfoBoxes_Mutation_Response = {
  __typename?: 'infoBoxes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<InfoBoxes>;
};

/** on_conflict condition type for table "infoBoxes" */
export type InfoBoxes_On_Conflict = {
  constraint: InfoBoxes_Constraint;
  update_columns?: Array<InfoBoxes_Update_Column>;
  where?: InputMaybe<InfoBoxes_Bool_Exp>;
};

/** Ordering options when selecting data from "infoBoxes". */
export type InfoBoxes_Order_By = {
  content?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  createdBy_fullUser?: InputMaybe<Users_Order_By>;
  createdBy_user?: InputMaybe<AllUsers_Order_By>;
  id?: InputMaybe<Order_By>;
  isInternal?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  updatedBy_fullUser?: InputMaybe<Users_Order_By>;
  updatedBy_user?: InputMaybe<AllUsers_Order_By>;
};

/** primary key columns input for table: infoBoxes */
export type InfoBoxes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "infoBoxes" */
export enum InfoBoxes_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  IsInternal = 'isInternal',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "infoBoxes" */
export type InfoBoxes_Set_Input = {
  content?: InputMaybe<Scalars['json']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type InfoBoxes_Stddev_Fields = {
  __typename?: 'infoBoxes_stddev_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type InfoBoxes_Stddev_Pop_Fields = {
  __typename?: 'infoBoxes_stddev_pop_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type InfoBoxes_Stddev_Samp_Fields = {
  __typename?: 'infoBoxes_stddev_samp_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "infoBoxes" */
export type InfoBoxes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: InfoBoxes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type InfoBoxes_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['json']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type InfoBoxes_Sum_Fields = {
  __typename?: 'infoBoxes_sum_fields';
  createdBy?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updatedBy?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "infoBoxes" */
export enum InfoBoxes_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  IsInternal = 'isInternal',
  /** column name */
  Slug = 'slug',
  /** column name */
  Title = 'title'
}

export type InfoBoxes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InfoBoxes_Set_Input>;
  /** filter the rows which have to be updated */
  where: InfoBoxes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type InfoBoxes_Var_Pop_Fields = {
  __typename?: 'infoBoxes_var_pop_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type InfoBoxes_Var_Samp_Fields = {
  __typename?: 'infoBoxes_var_samp_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type InfoBoxes_Variance_Fields = {
  __typename?: 'infoBoxes_variance_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "infoNews" */
export type InfoNews = {
  __typename?: 'infoNews';
  content: Scalars['json']['output'];
  createdAt: Scalars['timestamptz']['output'];
  createdBy?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  createdBy_fullUser?: Maybe<Users>;
  /** An object relationship */
  createdBy_user?: Maybe<AllUsers>;
  date: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  isInternal: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  updatedBy_fullUser?: Maybe<Users>;
  /** An object relationship */
  updatedBy_user?: Maybe<AllUsers>;
};


/** columns and relationships of "infoNews" */
export type InfoNewsContentArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "infoNews" */
export type InfoNews_Aggregate = {
  __typename?: 'infoNews_aggregate';
  aggregate?: Maybe<InfoNews_Aggregate_Fields>;
  nodes: Array<InfoNews>;
};

/** aggregate fields of "infoNews" */
export type InfoNews_Aggregate_Fields = {
  __typename?: 'infoNews_aggregate_fields';
  avg?: Maybe<InfoNews_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<InfoNews_Max_Fields>;
  min?: Maybe<InfoNews_Min_Fields>;
  stddev?: Maybe<InfoNews_Stddev_Fields>;
  stddev_pop?: Maybe<InfoNews_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<InfoNews_Stddev_Samp_Fields>;
  sum?: Maybe<InfoNews_Sum_Fields>;
  var_pop?: Maybe<InfoNews_Var_Pop_Fields>;
  var_samp?: Maybe<InfoNews_Var_Samp_Fields>;
  variance?: Maybe<InfoNews_Variance_Fields>;
};


/** aggregate fields of "infoNews" */
export type InfoNews_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<InfoNews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type InfoNews_Avg_Fields = {
  __typename?: 'infoNews_avg_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "infoNews". All fields are combined with a logical 'AND'. */
export type InfoNews_Bool_Exp = {
  _and?: InputMaybe<Array<InfoNews_Bool_Exp>>;
  _not?: InputMaybe<InfoNews_Bool_Exp>;
  _or?: InputMaybe<Array<InfoNews_Bool_Exp>>;
  content?: InputMaybe<Json_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<Bigint_Comparison_Exp>;
  createdBy_fullUser?: InputMaybe<Users_Bool_Exp>;
  createdBy_user?: InputMaybe<AllUsers_Bool_Exp>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  isInternal?: InputMaybe<Boolean_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedBy?: InputMaybe<Bigint_Comparison_Exp>;
  updatedBy_fullUser?: InputMaybe<Users_Bool_Exp>;
  updatedBy_user?: InputMaybe<AllUsers_Bool_Exp>;
};

/** unique or primary key constraints on table "infoNews" */
export enum InfoNews_Constraint {
  /** unique or primary key constraint on columns "id" */
  InfoNewsPkey = 'infoNews_pkey'
}

/** input type for inserting data into table "infoNews" */
export type InfoNews_Insert_Input = {
  content?: InputMaybe<Scalars['json']['input']>;
  createdBy_fullUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedBy_fullUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type InfoNews_Max_Fields = {
  __typename?: 'infoNews_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['bigint']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedBy?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type InfoNews_Min_Fields = {
  __typename?: 'infoNews_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdBy?: Maybe<Scalars['bigint']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedBy?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "infoNews" */
export type InfoNews_Mutation_Response = {
  __typename?: 'infoNews_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<InfoNews>;
};

/** on_conflict condition type for table "infoNews" */
export type InfoNews_On_Conflict = {
  constraint: InfoNews_Constraint;
  update_columns?: Array<InfoNews_Update_Column>;
  where?: InputMaybe<InfoNews_Bool_Exp>;
};

/** Ordering options when selecting data from "infoNews". */
export type InfoNews_Order_By = {
  content?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  createdBy_fullUser?: InputMaybe<Users_Order_By>;
  createdBy_user?: InputMaybe<AllUsers_Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isInternal?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  updatedBy_fullUser?: InputMaybe<Users_Order_By>;
  updatedBy_user?: InputMaybe<AllUsers_Order_By>;
};

/** primary key columns input for table: infoNews */
export type InfoNews_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "infoNews" */
export enum InfoNews_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  IsInternal = 'isInternal',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy'
}

/** input type for updating data in table "infoNews" */
export type InfoNews_Set_Input = {
  content?: InputMaybe<Scalars['json']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type InfoNews_Stddev_Fields = {
  __typename?: 'infoNews_stddev_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type InfoNews_Stddev_Pop_Fields = {
  __typename?: 'infoNews_stddev_pop_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type InfoNews_Stddev_Samp_Fields = {
  __typename?: 'infoNews_stddev_samp_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "infoNews" */
export type InfoNews_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: InfoNews_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type InfoNews_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['json']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['bigint']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type InfoNews_Sum_Fields = {
  __typename?: 'infoNews_sum_fields';
  createdBy?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updatedBy?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "infoNews" */
export enum InfoNews_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Date = 'date',
  /** column name */
  IsInternal = 'isInternal',
  /** column name */
  Title = 'title'
}

export type InfoNews_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InfoNews_Set_Input>;
  /** filter the rows which have to be updated */
  where: InfoNews_Bool_Exp;
};

/** aggregate var_pop on columns */
export type InfoNews_Var_Pop_Fields = {
  __typename?: 'infoNews_var_pop_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type InfoNews_Var_Samp_Fields = {
  __typename?: 'infoNews_var_samp_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type InfoNews_Variance_Fields = {
  __typename?: 'infoNews_variance_fields';
  createdBy?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "jaggaerBanfs" */
export type JaggaerBanfs = {
  __typename?: 'jaggaerBanfs';
  /** An object relationship */
  event: Events;
  eventId: Scalars['bigint']['output'];
  /** An object relationship */
  fullUser: Users;
  id: Scalars['bigint']['output'];
  jaggaerBanf: Scalars['String']['output'];
  /** An object relationship */
  jaggaerSubmission?: Maybe<JaggaerSubmissions>;
  jaggaerSubmissionId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  user?: Maybe<AllUsers>;
  userId: Scalars['bigint']['output'];
};

/** aggregated selection of "jaggaerBanfs" */
export type JaggaerBanfs_Aggregate = {
  __typename?: 'jaggaerBanfs_aggregate';
  aggregate?: Maybe<JaggaerBanfs_Aggregate_Fields>;
  nodes: Array<JaggaerBanfs>;
};

/** aggregate fields of "jaggaerBanfs" */
export type JaggaerBanfs_Aggregate_Fields = {
  __typename?: 'jaggaerBanfs_aggregate_fields';
  avg?: Maybe<JaggaerBanfs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<JaggaerBanfs_Max_Fields>;
  min?: Maybe<JaggaerBanfs_Min_Fields>;
  stddev?: Maybe<JaggaerBanfs_Stddev_Fields>;
  stddev_pop?: Maybe<JaggaerBanfs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<JaggaerBanfs_Stddev_Samp_Fields>;
  sum?: Maybe<JaggaerBanfs_Sum_Fields>;
  var_pop?: Maybe<JaggaerBanfs_Var_Pop_Fields>;
  var_samp?: Maybe<JaggaerBanfs_Var_Samp_Fields>;
  variance?: Maybe<JaggaerBanfs_Variance_Fields>;
};


/** aggregate fields of "jaggaerBanfs" */
export type JaggaerBanfs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<JaggaerBanfs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type JaggaerBanfs_Avg_Fields = {
  __typename?: 'jaggaerBanfs_avg_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  jaggaerSubmissionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "jaggaerBanfs". All fields are combined with a logical 'AND'. */
export type JaggaerBanfs_Bool_Exp = {
  _and?: InputMaybe<Array<JaggaerBanfs_Bool_Exp>>;
  _not?: InputMaybe<JaggaerBanfs_Bool_Exp>;
  _or?: InputMaybe<Array<JaggaerBanfs_Bool_Exp>>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Bigint_Comparison_Exp>;
  fullUser?: InputMaybe<Users_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  jaggaerBanf?: InputMaybe<String_Comparison_Exp>;
  jaggaerSubmission?: InputMaybe<JaggaerSubmissions_Bool_Exp>;
  jaggaerSubmissionId?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<AllUsers_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "jaggaerBanfs" */
export enum JaggaerBanfs_Constraint {
  /** unique or primary key constraint on columns "jaggaerBanf" */
  JaggaerBanfsJaggaerBanfKey = 'jaggaerBanfs_jaggaerBanf_key',
  /** unique or primary key constraint on columns "jaggaerSubmissionId" */
  JaggaerBanfsJaggaerSubmissionIdKey = 'jaggaerBanfs_jaggaerSubmissionId_key',
  /** unique or primary key constraint on columns "id" */
  JaggaerBanfsPkey = 'jaggaerBanfs_pkey'
}

/** input type for inserting data into table "jaggaerBanfs" */
export type JaggaerBanfs_Insert_Input = {
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  fullUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  jaggaerBanf?: InputMaybe<Scalars['String']['input']>;
  jaggaerSubmission?: InputMaybe<JaggaerSubmissions_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type JaggaerBanfs_Max_Fields = {
  __typename?: 'jaggaerBanfs_max_fields';
  eventId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  jaggaerBanf?: Maybe<Scalars['String']['output']>;
  jaggaerSubmissionId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type JaggaerBanfs_Min_Fields = {
  __typename?: 'jaggaerBanfs_min_fields';
  eventId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  jaggaerBanf?: Maybe<Scalars['String']['output']>;
  jaggaerSubmissionId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "jaggaerBanfs" */
export type JaggaerBanfs_Mutation_Response = {
  __typename?: 'jaggaerBanfs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<JaggaerBanfs>;
};

/** input type for inserting object relation for remote table "jaggaerBanfs" */
export type JaggaerBanfs_Obj_Rel_Insert_Input = {
  data: JaggaerBanfs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<JaggaerBanfs_On_Conflict>;
};

/** on_conflict condition type for table "jaggaerBanfs" */
export type JaggaerBanfs_On_Conflict = {
  constraint: JaggaerBanfs_Constraint;
  update_columns?: Array<JaggaerBanfs_Update_Column>;
  where?: InputMaybe<JaggaerBanfs_Bool_Exp>;
};

/** Ordering options when selecting data from "jaggaerBanfs". */
export type JaggaerBanfs_Order_By = {
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  fullUser?: InputMaybe<Users_Order_By>;
  id?: InputMaybe<Order_By>;
  jaggaerBanf?: InputMaybe<Order_By>;
  jaggaerSubmission?: InputMaybe<JaggaerSubmissions_Order_By>;
  jaggaerSubmissionId?: InputMaybe<Order_By>;
  user?: InputMaybe<AllUsers_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "jaggaerBanfs" */
export enum JaggaerBanfs_Select_Column {
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  JaggaerBanf = 'jaggaerBanf',
  /** column name */
  JaggaerSubmissionId = 'jaggaerSubmissionId',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type JaggaerBanfs_Stddev_Fields = {
  __typename?: 'jaggaerBanfs_stddev_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  jaggaerSubmissionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type JaggaerBanfs_Stddev_Pop_Fields = {
  __typename?: 'jaggaerBanfs_stddev_pop_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  jaggaerSubmissionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type JaggaerBanfs_Stddev_Samp_Fields = {
  __typename?: 'jaggaerBanfs_stddev_samp_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  jaggaerSubmissionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "jaggaerBanfs" */
export type JaggaerBanfs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: JaggaerBanfs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type JaggaerBanfs_Stream_Cursor_Value_Input = {
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  jaggaerBanf?: InputMaybe<Scalars['String']['input']>;
  jaggaerSubmissionId?: InputMaybe<Scalars['bigint']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type JaggaerBanfs_Sum_Fields = {
  __typename?: 'jaggaerBanfs_sum_fields';
  eventId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  jaggaerSubmissionId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** placeholder for update columns of table "jaggaerBanfs" (current role has no relevant permissions) */
export enum JaggaerBanfs_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type JaggaerBanfs_Var_Pop_Fields = {
  __typename?: 'jaggaerBanfs_var_pop_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  jaggaerSubmissionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type JaggaerBanfs_Var_Samp_Fields = {
  __typename?: 'jaggaerBanfs_var_samp_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  jaggaerSubmissionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type JaggaerBanfs_Variance_Fields = {
  __typename?: 'jaggaerBanfs_variance_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  jaggaerSubmissionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "jaggaerSubmissions" */
export type JaggaerSubmissions = {
  __typename?: 'jaggaerSubmissions';
  createdAt: Scalars['timestamptz']['output'];
  data: Scalars['json']['output'];
  /** An object relationship */
  file?: Maybe<Files>;
  fileId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  fullUser: Users;
  id: Scalars['bigint']['output'];
  jaggaerArticleId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  jaggaerBanf?: Maybe<JaggaerBanfs>;
  jaggaerFileId?: Maybe<Scalars['String']['output']>;
  jaggaerRequisitionId?: Maybe<Scalars['String']['output']>;
  lastAttachmentRequestAt?: Maybe<Scalars['timestamptz']['output']>;
  lastAttachmentResponse?: Maybe<Scalars['String']['output']>;
  lastMonitoringRequestAt?: Maybe<Scalars['timestamptz']['output']>;
  lastMonitoringResponse?: Maybe<Scalars['String']['output']>;
  lastQueueRequestAt?: Maybe<Scalars['timestamptz']['output']>;
  lastQueueResponse?: Maybe<Scalars['String']['output']>;
  lastUploadRequestAt?: Maybe<Scalars['timestamptz']['output']>;
  lastUploadResponse?: Maybe<Scalars['String']['output']>;
  nextTryAfter?: Maybe<Scalars['timestamptz']['output']>;
  numAttachmentRequests?: Maybe<Scalars['numeric']['output']>;
  numMonitoringRequests?: Maybe<Scalars['numeric']['output']>;
  numQueueRequests: Scalars['numeric']['output'];
  numUploadRequests: Scalars['numeric']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  uploadVersion?: Maybe<UploadVersions>;
  uploadVersionId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  user?: Maybe<AllUsers>;
  userId: Scalars['bigint']['output'];
};


/** columns and relationships of "jaggaerSubmissions" */
export type JaggaerSubmissionsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "jaggaerSubmissions" */
export type JaggaerSubmissions_Aggregate = {
  __typename?: 'jaggaerSubmissions_aggregate';
  aggregate?: Maybe<JaggaerSubmissions_Aggregate_Fields>;
  nodes: Array<JaggaerSubmissions>;
};

export type JaggaerSubmissions_Aggregate_Bool_Exp = {
  count?: InputMaybe<JaggaerSubmissions_Aggregate_Bool_Exp_Count>;
};

export type JaggaerSubmissions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<JaggaerSubmissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<JaggaerSubmissions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "jaggaerSubmissions" */
export type JaggaerSubmissions_Aggregate_Fields = {
  __typename?: 'jaggaerSubmissions_aggregate_fields';
  avg?: Maybe<JaggaerSubmissions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<JaggaerSubmissions_Max_Fields>;
  min?: Maybe<JaggaerSubmissions_Min_Fields>;
  stddev?: Maybe<JaggaerSubmissions_Stddev_Fields>;
  stddev_pop?: Maybe<JaggaerSubmissions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<JaggaerSubmissions_Stddev_Samp_Fields>;
  sum?: Maybe<JaggaerSubmissions_Sum_Fields>;
  var_pop?: Maybe<JaggaerSubmissions_Var_Pop_Fields>;
  var_samp?: Maybe<JaggaerSubmissions_Var_Samp_Fields>;
  variance?: Maybe<JaggaerSubmissions_Variance_Fields>;
};


/** aggregate fields of "jaggaerSubmissions" */
export type JaggaerSubmissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<JaggaerSubmissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "jaggaerSubmissions" */
export type JaggaerSubmissions_Aggregate_Order_By = {
  avg?: InputMaybe<JaggaerSubmissions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<JaggaerSubmissions_Max_Order_By>;
  min?: InputMaybe<JaggaerSubmissions_Min_Order_By>;
  stddev?: InputMaybe<JaggaerSubmissions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<JaggaerSubmissions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<JaggaerSubmissions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<JaggaerSubmissions_Sum_Order_By>;
  var_pop?: InputMaybe<JaggaerSubmissions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<JaggaerSubmissions_Var_Samp_Order_By>;
  variance?: InputMaybe<JaggaerSubmissions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "jaggaerSubmissions" */
export type JaggaerSubmissions_Arr_Rel_Insert_Input = {
  data: Array<JaggaerSubmissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<JaggaerSubmissions_On_Conflict>;
};

/** aggregate avg on columns */
export type JaggaerSubmissions_Avg_Fields = {
  __typename?: 'jaggaerSubmissions_avg_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  numAttachmentRequests?: Maybe<Scalars['Float']['output']>;
  numMonitoringRequests?: Maybe<Scalars['Float']['output']>;
  numQueueRequests?: Maybe<Scalars['Float']['output']>;
  numUploadRequests?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "jaggaerSubmissions" */
export type JaggaerSubmissions_Avg_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  numAttachmentRequests?: InputMaybe<Order_By>;
  numMonitoringRequests?: InputMaybe<Order_By>;
  numQueueRequests?: InputMaybe<Order_By>;
  numUploadRequests?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "jaggaerSubmissions". All fields are combined with a logical 'AND'. */
export type JaggaerSubmissions_Bool_Exp = {
  _and?: InputMaybe<Array<JaggaerSubmissions_Bool_Exp>>;
  _not?: InputMaybe<JaggaerSubmissions_Bool_Exp>;
  _or?: InputMaybe<Array<JaggaerSubmissions_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Json_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Bigint_Comparison_Exp>;
  fullUser?: InputMaybe<Users_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  jaggaerArticleId?: InputMaybe<String_Comparison_Exp>;
  jaggaerBanf?: InputMaybe<JaggaerBanfs_Bool_Exp>;
  jaggaerFileId?: InputMaybe<String_Comparison_Exp>;
  jaggaerRequisitionId?: InputMaybe<String_Comparison_Exp>;
  lastAttachmentRequestAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  lastAttachmentResponse?: InputMaybe<String_Comparison_Exp>;
  lastMonitoringRequestAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  lastMonitoringResponse?: InputMaybe<String_Comparison_Exp>;
  lastQueueRequestAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  lastQueueResponse?: InputMaybe<String_Comparison_Exp>;
  lastUploadRequestAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  lastUploadResponse?: InputMaybe<String_Comparison_Exp>;
  nextTryAfter?: InputMaybe<Timestamptz_Comparison_Exp>;
  numAttachmentRequests?: InputMaybe<Numeric_Comparison_Exp>;
  numMonitoringRequests?: InputMaybe<Numeric_Comparison_Exp>;
  numQueueRequests?: InputMaybe<Numeric_Comparison_Exp>;
  numUploadRequests?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploadVersion?: InputMaybe<UploadVersions_Bool_Exp>;
  uploadVersionId?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<AllUsers_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "jaggaerSubmissions" */
export enum JaggaerSubmissions_Constraint {
  /** unique or primary key constraint on columns "id" */
  JaggaerSubmissionsPkey = 'jaggaerSubmissions_pkey'
}

/** input type for inserting data into table "jaggaerSubmissions" */
export type JaggaerSubmissions_Insert_Input = {
  data?: InputMaybe<Scalars['json']['input']>;
  fileId?: InputMaybe<Scalars['bigint']['input']>;
  fullUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  jaggaerBanf?: InputMaybe<JaggaerBanfs_Obj_Rel_Insert_Input>;
  uploadVersion?: InputMaybe<UploadVersions_Obj_Rel_Insert_Input>;
  uploadVersionId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type JaggaerSubmissions_Max_Fields = {
  __typename?: 'jaggaerSubmissions_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  jaggaerArticleId?: Maybe<Scalars['String']['output']>;
  jaggaerFileId?: Maybe<Scalars['String']['output']>;
  jaggaerRequisitionId?: Maybe<Scalars['String']['output']>;
  lastAttachmentRequestAt?: Maybe<Scalars['timestamptz']['output']>;
  lastAttachmentResponse?: Maybe<Scalars['String']['output']>;
  lastMonitoringRequestAt?: Maybe<Scalars['timestamptz']['output']>;
  lastMonitoringResponse?: Maybe<Scalars['String']['output']>;
  lastQueueRequestAt?: Maybe<Scalars['timestamptz']['output']>;
  lastQueueResponse?: Maybe<Scalars['String']['output']>;
  lastUploadRequestAt?: Maybe<Scalars['timestamptz']['output']>;
  lastUploadResponse?: Maybe<Scalars['String']['output']>;
  nextTryAfter?: Maybe<Scalars['timestamptz']['output']>;
  numAttachmentRequests?: Maybe<Scalars['numeric']['output']>;
  numMonitoringRequests?: Maybe<Scalars['numeric']['output']>;
  numQueueRequests?: Maybe<Scalars['numeric']['output']>;
  numUploadRequests?: Maybe<Scalars['numeric']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadVersionId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "jaggaerSubmissions" */
export type JaggaerSubmissions_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jaggaerArticleId?: InputMaybe<Order_By>;
  jaggaerFileId?: InputMaybe<Order_By>;
  jaggaerRequisitionId?: InputMaybe<Order_By>;
  lastAttachmentRequestAt?: InputMaybe<Order_By>;
  lastAttachmentResponse?: InputMaybe<Order_By>;
  lastMonitoringRequestAt?: InputMaybe<Order_By>;
  lastMonitoringResponse?: InputMaybe<Order_By>;
  lastQueueRequestAt?: InputMaybe<Order_By>;
  lastQueueResponse?: InputMaybe<Order_By>;
  lastUploadRequestAt?: InputMaybe<Order_By>;
  lastUploadResponse?: InputMaybe<Order_By>;
  nextTryAfter?: InputMaybe<Order_By>;
  numAttachmentRequests?: InputMaybe<Order_By>;
  numMonitoringRequests?: InputMaybe<Order_By>;
  numQueueRequests?: InputMaybe<Order_By>;
  numUploadRequests?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type JaggaerSubmissions_Min_Fields = {
  __typename?: 'jaggaerSubmissions_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  jaggaerArticleId?: Maybe<Scalars['String']['output']>;
  jaggaerFileId?: Maybe<Scalars['String']['output']>;
  jaggaerRequisitionId?: Maybe<Scalars['String']['output']>;
  lastAttachmentRequestAt?: Maybe<Scalars['timestamptz']['output']>;
  lastAttachmentResponse?: Maybe<Scalars['String']['output']>;
  lastMonitoringRequestAt?: Maybe<Scalars['timestamptz']['output']>;
  lastMonitoringResponse?: Maybe<Scalars['String']['output']>;
  lastQueueRequestAt?: Maybe<Scalars['timestamptz']['output']>;
  lastQueueResponse?: Maybe<Scalars['String']['output']>;
  lastUploadRequestAt?: Maybe<Scalars['timestamptz']['output']>;
  lastUploadResponse?: Maybe<Scalars['String']['output']>;
  nextTryAfter?: Maybe<Scalars['timestamptz']['output']>;
  numAttachmentRequests?: Maybe<Scalars['numeric']['output']>;
  numMonitoringRequests?: Maybe<Scalars['numeric']['output']>;
  numQueueRequests?: Maybe<Scalars['numeric']['output']>;
  numUploadRequests?: Maybe<Scalars['numeric']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadVersionId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "jaggaerSubmissions" */
export type JaggaerSubmissions_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jaggaerArticleId?: InputMaybe<Order_By>;
  jaggaerFileId?: InputMaybe<Order_By>;
  jaggaerRequisitionId?: InputMaybe<Order_By>;
  lastAttachmentRequestAt?: InputMaybe<Order_By>;
  lastAttachmentResponse?: InputMaybe<Order_By>;
  lastMonitoringRequestAt?: InputMaybe<Order_By>;
  lastMonitoringResponse?: InputMaybe<Order_By>;
  lastQueueRequestAt?: InputMaybe<Order_By>;
  lastQueueResponse?: InputMaybe<Order_By>;
  lastUploadRequestAt?: InputMaybe<Order_By>;
  lastUploadResponse?: InputMaybe<Order_By>;
  nextTryAfter?: InputMaybe<Order_By>;
  numAttachmentRequests?: InputMaybe<Order_By>;
  numMonitoringRequests?: InputMaybe<Order_By>;
  numQueueRequests?: InputMaybe<Order_By>;
  numUploadRequests?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "jaggaerSubmissions" */
export type JaggaerSubmissions_Mutation_Response = {
  __typename?: 'jaggaerSubmissions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<JaggaerSubmissions>;
};

/** input type for inserting object relation for remote table "jaggaerSubmissions" */
export type JaggaerSubmissions_Obj_Rel_Insert_Input = {
  data: JaggaerSubmissions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<JaggaerSubmissions_On_Conflict>;
};

/** on_conflict condition type for table "jaggaerSubmissions" */
export type JaggaerSubmissions_On_Conflict = {
  constraint: JaggaerSubmissions_Constraint;
  update_columns?: Array<JaggaerSubmissions_Update_Column>;
  where?: InputMaybe<JaggaerSubmissions_Bool_Exp>;
};

/** Ordering options when selecting data from "jaggaerSubmissions". */
export type JaggaerSubmissions_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
  fullUser?: InputMaybe<Users_Order_By>;
  id?: InputMaybe<Order_By>;
  jaggaerArticleId?: InputMaybe<Order_By>;
  jaggaerBanf?: InputMaybe<JaggaerBanfs_Order_By>;
  jaggaerFileId?: InputMaybe<Order_By>;
  jaggaerRequisitionId?: InputMaybe<Order_By>;
  lastAttachmentRequestAt?: InputMaybe<Order_By>;
  lastAttachmentResponse?: InputMaybe<Order_By>;
  lastMonitoringRequestAt?: InputMaybe<Order_By>;
  lastMonitoringResponse?: InputMaybe<Order_By>;
  lastQueueRequestAt?: InputMaybe<Order_By>;
  lastQueueResponse?: InputMaybe<Order_By>;
  lastUploadRequestAt?: InputMaybe<Order_By>;
  lastUploadResponse?: InputMaybe<Order_By>;
  nextTryAfter?: InputMaybe<Order_By>;
  numAttachmentRequests?: InputMaybe<Order_By>;
  numMonitoringRequests?: InputMaybe<Order_By>;
  numQueueRequests?: InputMaybe<Order_By>;
  numUploadRequests?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadVersion?: InputMaybe<UploadVersions_Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  user?: InputMaybe<AllUsers_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "jaggaerSubmissions" */
export enum JaggaerSubmissions_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  JaggaerArticleId = 'jaggaerArticleId',
  /** column name */
  JaggaerFileId = 'jaggaerFileId',
  /** column name */
  JaggaerRequisitionId = 'jaggaerRequisitionId',
  /** column name */
  LastAttachmentRequestAt = 'lastAttachmentRequestAt',
  /** column name */
  LastAttachmentResponse = 'lastAttachmentResponse',
  /** column name */
  LastMonitoringRequestAt = 'lastMonitoringRequestAt',
  /** column name */
  LastMonitoringResponse = 'lastMonitoringResponse',
  /** column name */
  LastQueueRequestAt = 'lastQueueRequestAt',
  /** column name */
  LastQueueResponse = 'lastQueueResponse',
  /** column name */
  LastUploadRequestAt = 'lastUploadRequestAt',
  /** column name */
  LastUploadResponse = 'lastUploadResponse',
  /** column name */
  NextTryAfter = 'nextTryAfter',
  /** column name */
  NumAttachmentRequests = 'numAttachmentRequests',
  /** column name */
  NumMonitoringRequests = 'numMonitoringRequests',
  /** column name */
  NumQueueRequests = 'numQueueRequests',
  /** column name */
  NumUploadRequests = 'numUploadRequests',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadVersionId = 'uploadVersionId',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type JaggaerSubmissions_Stddev_Fields = {
  __typename?: 'jaggaerSubmissions_stddev_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  numAttachmentRequests?: Maybe<Scalars['Float']['output']>;
  numMonitoringRequests?: Maybe<Scalars['Float']['output']>;
  numQueueRequests?: Maybe<Scalars['Float']['output']>;
  numUploadRequests?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "jaggaerSubmissions" */
export type JaggaerSubmissions_Stddev_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  numAttachmentRequests?: InputMaybe<Order_By>;
  numMonitoringRequests?: InputMaybe<Order_By>;
  numQueueRequests?: InputMaybe<Order_By>;
  numUploadRequests?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type JaggaerSubmissions_Stddev_Pop_Fields = {
  __typename?: 'jaggaerSubmissions_stddev_pop_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  numAttachmentRequests?: Maybe<Scalars['Float']['output']>;
  numMonitoringRequests?: Maybe<Scalars['Float']['output']>;
  numQueueRequests?: Maybe<Scalars['Float']['output']>;
  numUploadRequests?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "jaggaerSubmissions" */
export type JaggaerSubmissions_Stddev_Pop_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  numAttachmentRequests?: InputMaybe<Order_By>;
  numMonitoringRequests?: InputMaybe<Order_By>;
  numQueueRequests?: InputMaybe<Order_By>;
  numUploadRequests?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type JaggaerSubmissions_Stddev_Samp_Fields = {
  __typename?: 'jaggaerSubmissions_stddev_samp_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  numAttachmentRequests?: Maybe<Scalars['Float']['output']>;
  numMonitoringRequests?: Maybe<Scalars['Float']['output']>;
  numQueueRequests?: Maybe<Scalars['Float']['output']>;
  numUploadRequests?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "jaggaerSubmissions" */
export type JaggaerSubmissions_Stddev_Samp_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  numAttachmentRequests?: InputMaybe<Order_By>;
  numMonitoringRequests?: InputMaybe<Order_By>;
  numQueueRequests?: InputMaybe<Order_By>;
  numUploadRequests?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "jaggaerSubmissions" */
export type JaggaerSubmissions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: JaggaerSubmissions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type JaggaerSubmissions_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  fileId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  jaggaerArticleId?: InputMaybe<Scalars['String']['input']>;
  jaggaerFileId?: InputMaybe<Scalars['String']['input']>;
  jaggaerRequisitionId?: InputMaybe<Scalars['String']['input']>;
  lastAttachmentRequestAt?: InputMaybe<Scalars['timestamptz']['input']>;
  lastAttachmentResponse?: InputMaybe<Scalars['String']['input']>;
  lastMonitoringRequestAt?: InputMaybe<Scalars['timestamptz']['input']>;
  lastMonitoringResponse?: InputMaybe<Scalars['String']['input']>;
  lastQueueRequestAt?: InputMaybe<Scalars['timestamptz']['input']>;
  lastQueueResponse?: InputMaybe<Scalars['String']['input']>;
  lastUploadRequestAt?: InputMaybe<Scalars['timestamptz']['input']>;
  lastUploadResponse?: InputMaybe<Scalars['String']['input']>;
  nextTryAfter?: InputMaybe<Scalars['timestamptz']['input']>;
  numAttachmentRequests?: InputMaybe<Scalars['numeric']['input']>;
  numMonitoringRequests?: InputMaybe<Scalars['numeric']['input']>;
  numQueueRequests?: InputMaybe<Scalars['numeric']['input']>;
  numUploadRequests?: InputMaybe<Scalars['numeric']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadVersionId?: InputMaybe<Scalars['bigint']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type JaggaerSubmissions_Sum_Fields = {
  __typename?: 'jaggaerSubmissions_sum_fields';
  fileId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  numAttachmentRequests?: Maybe<Scalars['numeric']['output']>;
  numMonitoringRequests?: Maybe<Scalars['numeric']['output']>;
  numQueueRequests?: Maybe<Scalars['numeric']['output']>;
  numUploadRequests?: Maybe<Scalars['numeric']['output']>;
  uploadVersionId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "jaggaerSubmissions" */
export type JaggaerSubmissions_Sum_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  numAttachmentRequests?: InputMaybe<Order_By>;
  numMonitoringRequests?: InputMaybe<Order_By>;
  numQueueRequests?: InputMaybe<Order_By>;
  numUploadRequests?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "jaggaerSubmissions" (current role has no relevant permissions) */
export enum JaggaerSubmissions_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type JaggaerSubmissions_Var_Pop_Fields = {
  __typename?: 'jaggaerSubmissions_var_pop_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  numAttachmentRequests?: Maybe<Scalars['Float']['output']>;
  numMonitoringRequests?: Maybe<Scalars['Float']['output']>;
  numQueueRequests?: Maybe<Scalars['Float']['output']>;
  numUploadRequests?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "jaggaerSubmissions" */
export type JaggaerSubmissions_Var_Pop_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  numAttachmentRequests?: InputMaybe<Order_By>;
  numMonitoringRequests?: InputMaybe<Order_By>;
  numQueueRequests?: InputMaybe<Order_By>;
  numUploadRequests?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type JaggaerSubmissions_Var_Samp_Fields = {
  __typename?: 'jaggaerSubmissions_var_samp_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  numAttachmentRequests?: Maybe<Scalars['Float']['output']>;
  numMonitoringRequests?: Maybe<Scalars['Float']['output']>;
  numQueueRequests?: Maybe<Scalars['Float']['output']>;
  numUploadRequests?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "jaggaerSubmissions" */
export type JaggaerSubmissions_Var_Samp_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  numAttachmentRequests?: InputMaybe<Order_By>;
  numMonitoringRequests?: InputMaybe<Order_By>;
  numQueueRequests?: InputMaybe<Order_By>;
  numUploadRequests?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type JaggaerSubmissions_Variance_Fields = {
  __typename?: 'jaggaerSubmissions_variance_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  numAttachmentRequests?: Maybe<Scalars['Float']['output']>;
  numMonitoringRequests?: Maybe<Scalars['Float']['output']>;
  numQueueRequests?: Maybe<Scalars['Float']['output']>;
  numUploadRequests?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "jaggaerSubmissions" */
export type JaggaerSubmissions_Variance_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  numAttachmentRequests?: InputMaybe<Order_By>;
  numMonitoringRequests?: InputMaybe<Order_By>;
  numQueueRequests?: InputMaybe<Order_By>;
  numUploadRequests?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']['input']>;
  _gt?: InputMaybe<Scalars['json']['input']>;
  _gte?: InputMaybe<Scalars['json']['input']>;
  _in?: InputMaybe<Array<Scalars['json']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['json']['input']>;
  _lte?: InputMaybe<Scalars['json']['input']>;
  _neq?: InputMaybe<Scalars['json']['input']>;
  _nin?: InputMaybe<Array<Scalars['json']['input']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** columns and relationships of "moduleTypes" */
export type ModuleTypes = {
  __typename?: 'moduleTypes';
  name: Scalars['String']['output'];
  /** An array relationship */
  serviceModules: Array<ServiceModules>;
  /** An aggregate relationship */
  serviceModules_aggregate: ServiceModules_Aggregate;
};


/** columns and relationships of "moduleTypes" */
export type ModuleTypesServiceModulesArgs = {
  distinct_on?: InputMaybe<Array<ServiceModules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModules_Order_By>>;
  where?: InputMaybe<ServiceModules_Bool_Exp>;
};


/** columns and relationships of "moduleTypes" */
export type ModuleTypesServiceModules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceModules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModules_Order_By>>;
  where?: InputMaybe<ServiceModules_Bool_Exp>;
};

/** aggregated selection of "moduleTypes" */
export type ModuleTypes_Aggregate = {
  __typename?: 'moduleTypes_aggregate';
  aggregate?: Maybe<ModuleTypes_Aggregate_Fields>;
  nodes: Array<ModuleTypes>;
};

/** aggregate fields of "moduleTypes" */
export type ModuleTypes_Aggregate_Fields = {
  __typename?: 'moduleTypes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ModuleTypes_Max_Fields>;
  min?: Maybe<ModuleTypes_Min_Fields>;
};


/** aggregate fields of "moduleTypes" */
export type ModuleTypes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ModuleTypes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "moduleTypes". All fields are combined with a logical 'AND'. */
export type ModuleTypes_Bool_Exp = {
  _and?: InputMaybe<Array<ModuleTypes_Bool_Exp>>;
  _not?: InputMaybe<ModuleTypes_Bool_Exp>;
  _or?: InputMaybe<Array<ModuleTypes_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  serviceModules?: InputMaybe<ServiceModules_Bool_Exp>;
  serviceModules_aggregate?: InputMaybe<ServiceModules_Aggregate_Bool_Exp>;
};

export enum ModuleTypes_Enum {
  Attributes = 'attributes',
  Permissions = 'permissions',
  Procurement = 'procurement',
  Uploads = 'uploads'
}

/** Boolean expression to compare columns of type "moduleTypes_enum". All fields are combined with logical 'AND'. */
export type ModuleTypes_Enum_Comparison_Exp = {
  _eq?: InputMaybe<ModuleTypes_Enum>;
  _in?: InputMaybe<Array<ModuleTypes_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<ModuleTypes_Enum>;
  _nin?: InputMaybe<Array<ModuleTypes_Enum>>;
};

/** aggregate max on columns */
export type ModuleTypes_Max_Fields = {
  __typename?: 'moduleTypes_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ModuleTypes_Min_Fields = {
  __typename?: 'moduleTypes_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "moduleTypes". */
export type ModuleTypes_Order_By = {
  name?: InputMaybe<Order_By>;
  serviceModules_aggregate?: InputMaybe<ServiceModules_Aggregate_Order_By>;
};

/** select columns of table "moduleTypes" */
export enum ModuleTypes_Select_Column {
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "moduleTypes" */
export type ModuleTypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ModuleTypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ModuleTypes_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "articles" */
  delete_articles?: Maybe<Articles_Mutation_Response>;
  /** delete single row from the table: "articles" */
  delete_articles_by_pk?: Maybe<Articles>;
  /** delete data from the table: "attributeFiles" */
  delete_attributeFiles?: Maybe<AttributeFiles_Mutation_Response>;
  /** delete single row from the table: "attributeFiles" */
  delete_attributeFiles_by_pk?: Maybe<AttributeFiles>;
  /** delete data from the table: "attributeGroups" */
  delete_attributeGroups?: Maybe<AttributeGroups_Mutation_Response>;
  /** delete single row from the table: "attributeGroups" */
  delete_attributeGroups_by_pk?: Maybe<AttributeGroups>;
  /** delete data from the table: "attributeValueComments" */
  delete_attributeValueComments?: Maybe<AttributeValueComments_Mutation_Response>;
  /** delete single row from the table: "attributeValueComments" */
  delete_attributeValueComments_by_pk?: Maybe<AttributeValueComments>;
  /** delete data from the table: "attributeValueGroups" */
  delete_attributeValueGroups?: Maybe<AttributeValueGroups_Mutation_Response>;
  /** delete single row from the table: "attributeValueGroups" */
  delete_attributeValueGroups_by_pk?: Maybe<AttributeValueGroups>;
  /** delete data from the table: "attributeValueUploadVersions" */
  delete_attributeValueUploadVersions?: Maybe<AttributeValueUploadVersions_Mutation_Response>;
  /** delete single row from the table: "attributeValueUploadVersions" */
  delete_attributeValueUploadVersions_by_pk?: Maybe<AttributeValueUploadVersions>;
  /** delete data from the table: "attributeValueUploads" */
  delete_attributeValueUploads?: Maybe<AttributeValueUploads_Mutation_Response>;
  /** delete single row from the table: "attributeValueUploads" */
  delete_attributeValueUploads_by_pk?: Maybe<AttributeValueUploads>;
  /** delete data from the table: "attributeValues" */
  delete_attributeValues?: Maybe<AttributeValues_Mutation_Response>;
  /** delete single row from the table: "attributeValues" */
  delete_attributeValues_by_pk?: Maybe<AttributeValues>;
  /** delete data from the table: "attributes" */
  delete_attributes?: Maybe<Attributes_Mutation_Response>;
  /** delete single row from the table: "attributes" */
  delete_attributes_by_pk?: Maybe<Attributes>;
  /** delete data from the table: "cartLines" */
  delete_cartLines?: Maybe<CartLines_Mutation_Response>;
  /** delete single row from the table: "cartLines" */
  delete_cartLines_by_pk?: Maybe<CartLines>;
  /** delete data from the table: "carts" */
  delete_carts?: Maybe<Carts_Mutation_Response>;
  /** delete single row from the table: "carts" */
  delete_carts_by_pk?: Maybe<Carts>;
  /** delete data from the table: "catalogFolderArticles" */
  delete_catalogFolderArticles?: Maybe<CatalogFolderArticles_Mutation_Response>;
  /** delete single row from the table: "catalogFolderArticles" */
  delete_catalogFolderArticles_by_pk?: Maybe<CatalogFolderArticles>;
  /** delete data from the table: "catalogFolders" */
  delete_catalogFolders?: Maybe<CatalogFolders_Mutation_Response>;
  /** delete single row from the table: "catalogFolders" */
  delete_catalogFolders_by_pk?: Maybe<CatalogFolders>;
  /** delete data from the table: "eventAttributeGroups" */
  delete_eventAttributeGroups?: Maybe<EventAttributeGroups_Mutation_Response>;
  /** delete single row from the table: "eventAttributeGroups" */
  delete_eventAttributeGroups_by_pk?: Maybe<EventAttributeGroups>;
  /** delete data from the table: "eventAttributeValueUploadVersions" */
  delete_eventAttributeValueUploadVersions?: Maybe<EventAttributeValueUploadVersions_Mutation_Response>;
  /** delete single row from the table: "eventAttributeValueUploadVersions" */
  delete_eventAttributeValueUploadVersions_by_pk?: Maybe<EventAttributeValueUploadVersions>;
  /** delete data from the table: "eventAttributeValueUploads" */
  delete_eventAttributeValueUploads?: Maybe<EventAttributeValueUploads_Mutation_Response>;
  /** delete single row from the table: "eventAttributeValueUploads" */
  delete_eventAttributeValueUploads_by_pk?: Maybe<EventAttributeValueUploads>;
  /** delete data from the table: "eventAttributeValues" */
  delete_eventAttributeValues?: Maybe<EventAttributeValues_Mutation_Response>;
  /** delete single row from the table: "eventAttributeValues" */
  delete_eventAttributeValues_by_pk?: Maybe<EventAttributeValues>;
  /** delete data from the table: "eventAttributes" */
  delete_eventAttributes?: Maybe<EventAttributes_Mutation_Response>;
  /** delete single row from the table: "eventAttributes" */
  delete_eventAttributes_by_pk?: Maybe<EventAttributes>;
  /** delete data from the table: "eventFavourites" */
  delete_eventFavourites?: Maybe<EventFavourites_Mutation_Response>;
  /** delete single row from the table: "eventFavourites" */
  delete_eventFavourites_by_pk?: Maybe<EventFavourites>;
  /** delete data from the table: "eventOrganisers" */
  delete_eventOrganisers?: Maybe<EventOrganisers_Mutation_Response>;
  /** delete single row from the table: "eventOrganisers" */
  delete_eventOrganisers_by_pk?: Maybe<EventOrganisers>;
  /** delete data from the table: "eventRoomWatches" */
  delete_eventRoomWatches?: Maybe<EventRoomWatches_Mutation_Response>;
  /** delete single row from the table: "eventRoomWatches" */
  delete_eventRoomWatches_by_pk?: Maybe<EventRoomWatches>;
  /** delete data from the table: "eventRooms" */
  delete_eventRooms?: Maybe<EventRooms_Mutation_Response>;
  /** delete single row from the table: "eventRooms" */
  delete_eventRooms_by_pk?: Maybe<EventRooms>;
  /** delete data from the table: "events" */
  delete_events?: Maybe<Events_Mutation_Response>;
  /** delete single row from the table: "events" */
  delete_events_by_pk?: Maybe<Events>;
  /** delete data from the table: "fileMasterVersions" */
  delete_fileMasterVersions?: Maybe<FileMasterVersions_Mutation_Response>;
  /** delete single row from the table: "fileMasterVersions" */
  delete_fileMasterVersions_by_pk?: Maybe<FileMasterVersions>;
  /** delete data from the table: "fileMasters" */
  delete_fileMasters?: Maybe<FileMasters_Mutation_Response>;
  /** delete single row from the table: "fileMasters" */
  delete_fileMasters_by_pk?: Maybe<FileMasters>;
  /** delete data from the table: "infoBoxes" */
  delete_infoBoxes?: Maybe<InfoBoxes_Mutation_Response>;
  /** delete single row from the table: "infoBoxes" */
  delete_infoBoxes_by_pk?: Maybe<InfoBoxes>;
  /** delete data from the table: "infoNews" */
  delete_infoNews?: Maybe<InfoNews_Mutation_Response>;
  /** delete single row from the table: "infoNews" */
  delete_infoNews_by_pk?: Maybe<InfoNews>;
  /** delete data from the table: "jaggaerBanfs" */
  delete_jaggaerBanfs?: Maybe<JaggaerBanfs_Mutation_Response>;
  /** delete single row from the table: "jaggaerBanfs" */
  delete_jaggaerBanfs_by_pk?: Maybe<JaggaerBanfs>;
  /** delete data from the table: "notificationPreferences" */
  delete_notificationPreferences?: Maybe<NotificationPreferences_Mutation_Response>;
  /** delete single row from the table: "notificationPreferences" */
  delete_notificationPreferences_by_pk?: Maybe<NotificationPreferences>;
  /** delete data from the table: "notificationRoomServiceCategoryPreferences" */
  delete_notificationRoomServiceCategoryPreferences?: Maybe<NotificationRoomServiceCategoryPreferences_Mutation_Response>;
  /** delete single row from the table: "notificationRoomServiceCategoryPreferences" */
  delete_notificationRoomServiceCategoryPreferences_by_pk?: Maybe<NotificationRoomServiceCategoryPreferences>;
  /** delete data from the table: "notificationServicePreferences" */
  delete_notificationServicePreferences?: Maybe<NotificationServicePreferences_Mutation_Response>;
  /** delete single row from the table: "notificationServicePreferences" */
  delete_notificationServicePreferences_by_pk?: Maybe<NotificationServicePreferences>;
  /** delete data from the table: "orders" */
  delete_orders?: Maybe<Orders_Mutation_Response>;
  /** delete single row from the table: "orders" */
  delete_orders_by_pk?: Maybe<Orders>;
  /** delete data from the table: "organisationGroupUsers" */
  delete_organisationGroupUsers?: Maybe<OrganisationGroupUsers_Mutation_Response>;
  /** delete single row from the table: "organisationGroupUsers" */
  delete_organisationGroupUsers_by_pk?: Maybe<OrganisationGroupUsers>;
  /** delete data from the table: "organisationGroups" */
  delete_organisationGroups?: Maybe<OrganisationGroups_Mutation_Response>;
  /** delete single row from the table: "organisationGroups" */
  delete_organisationGroups_by_pk?: Maybe<OrganisationGroups>;
  /** delete data from the table: "organisations" */
  delete_organisations?: Maybe<Organisations_Mutation_Response>;
  /** delete single row from the table: "organisations" */
  delete_organisations_by_pk?: Maybe<Organisations>;
  /** delete data from the table: "roomAttributeFiles" */
  delete_roomAttributeFiles?: Maybe<RoomAttributeFiles_Mutation_Response>;
  /** delete single row from the table: "roomAttributeFiles" */
  delete_roomAttributeFiles_by_pk?: Maybe<RoomAttributeFiles>;
  /** delete data from the table: "roomAttributeGroups" */
  delete_roomAttributeGroups?: Maybe<RoomAttributeGroups_Mutation_Response>;
  /** delete single row from the table: "roomAttributeGroups" */
  delete_roomAttributeGroups_by_pk?: Maybe<RoomAttributeGroups>;
  /** delete data from the table: "roomAttributeValueComments" */
  delete_roomAttributeValueComments?: Maybe<RoomAttributeValueComments_Mutation_Response>;
  /** delete single row from the table: "roomAttributeValueComments" */
  delete_roomAttributeValueComments_by_pk?: Maybe<RoomAttributeValueComments>;
  /** delete data from the table: "roomAttributeValueGroups" */
  delete_roomAttributeValueGroups?: Maybe<RoomAttributeValueGroups_Mutation_Response>;
  /** delete single row from the table: "roomAttributeValueGroups" */
  delete_roomAttributeValueGroups_by_pk?: Maybe<RoomAttributeValueGroups>;
  /** delete data from the table: "roomAttributeValueUploadVersions" */
  delete_roomAttributeValueUploadVersions?: Maybe<RoomAttributeValueUploadVersions_Mutation_Response>;
  /** delete single row from the table: "roomAttributeValueUploadVersions" */
  delete_roomAttributeValueUploadVersions_by_pk?: Maybe<RoomAttributeValueUploadVersions>;
  /** delete data from the table: "roomAttributeValueUploads" */
  delete_roomAttributeValueUploads?: Maybe<RoomAttributeValueUploads_Mutation_Response>;
  /** delete single row from the table: "roomAttributeValueUploads" */
  delete_roomAttributeValueUploads_by_pk?: Maybe<RoomAttributeValueUploads>;
  /** delete data from the table: "roomAttributeValues" */
  delete_roomAttributeValues?: Maybe<RoomAttributeValues_Mutation_Response>;
  /** delete single row from the table: "roomAttributeValues" */
  delete_roomAttributeValues_by_pk?: Maybe<RoomAttributeValues>;
  /** delete data from the table: "roomAttributes" */
  delete_roomAttributes?: Maybe<RoomAttributes_Mutation_Response>;
  /** delete single row from the table: "roomAttributes" */
  delete_roomAttributes_by_pk?: Maybe<RoomAttributes>;
  /** delete data from the table: "roomFolders" */
  delete_roomFolders?: Maybe<RoomFolders_Mutation_Response>;
  /** delete single row from the table: "roomFolders" */
  delete_roomFolders_by_pk?: Maybe<RoomFolders>;
  /** delete data from the table: "roomOccurrences" */
  delete_roomOccurrences?: Maybe<RoomOccurrences_Mutation_Response>;
  /** delete single row from the table: "roomOccurrences" */
  delete_roomOccurrences_by_pk?: Maybe<RoomOccurrences>;
  /** delete data from the table: "roomServiceCategories" */
  delete_roomServiceCategories?: Maybe<RoomServiceCategories_Mutation_Response>;
  /** delete single row from the table: "roomServiceCategories" */
  delete_roomServiceCategories_by_pk?: Maybe<RoomServiceCategories>;
  /** delete data from the table: "roomServiceOccurrences" */
  delete_roomServiceOccurrences?: Maybe<RoomServiceOccurrences_Mutation_Response>;
  /** delete single row from the table: "roomServiceOccurrences" */
  delete_roomServiceOccurrences_by_pk?: Maybe<RoomServiceOccurrences>;
  /** delete data from the table: "roomServiceOrganisationAccesses" */
  delete_roomServiceOrganisationAccesses?: Maybe<RoomServiceOrganisationAccesses_Mutation_Response>;
  /** delete single row from the table: "roomServiceOrganisationAccesses" */
  delete_roomServiceOrganisationAccesses_by_pk?: Maybe<RoomServiceOrganisationAccesses>;
  /** delete data from the table: "roomServices" */
  delete_roomServices?: Maybe<RoomServices_Mutation_Response>;
  /** delete single row from the table: "roomServices" */
  delete_roomServices_by_pk?: Maybe<RoomServices>;
  /** delete data from the table: "rooms" */
  delete_rooms?: Maybe<Rooms_Mutation_Response>;
  /** delete single row from the table: "rooms" */
  delete_rooms_by_pk?: Maybe<Rooms>;
  /** delete data from the table: "serviceBundleServices" */
  delete_serviceBundleServices?: Maybe<ServiceBundleServices_Mutation_Response>;
  /** delete single row from the table: "serviceBundleServices" */
  delete_serviceBundleServices_by_pk?: Maybe<ServiceBundleServices>;
  /** delete data from the table: "serviceBundles" */
  delete_serviceBundles?: Maybe<ServiceBundles_Mutation_Response>;
  /** delete single row from the table: "serviceBundles" */
  delete_serviceBundles_by_pk?: Maybe<ServiceBundles>;
  /** delete data from the table: "serviceFavourites" */
  delete_serviceFavourites?: Maybe<ServiceFavourites_Mutation_Response>;
  /** delete single row from the table: "serviceFavourites" */
  delete_serviceFavourites_by_pk?: Maybe<ServiceFavourites>;
  /** delete data from the table: "serviceModuleAccesses" */
  delete_serviceModuleAccesses?: Maybe<ServiceModuleAccesses_Mutation_Response>;
  /** delete single row from the table: "serviceModuleAccesses" */
  delete_serviceModuleAccesses_by_pk?: Maybe<ServiceModuleAccesses>;
  /** delete data from the table: "serviceModules" */
  delete_serviceModules?: Maybe<ServiceModules_Mutation_Response>;
  /** delete single row from the table: "serviceModules" */
  delete_serviceModules_by_pk?: Maybe<ServiceModules>;
  /** delete data from the table: "serviceOrganisationAccesses" */
  delete_serviceOrganisationAccesses?: Maybe<ServiceOrganisationAccesses_Mutation_Response>;
  /** delete single row from the table: "serviceOrganisationAccesses" */
  delete_serviceOrganisationAccesses_by_pk?: Maybe<ServiceOrganisationAccesses>;
  /** delete data from the table: "services" */
  delete_services?: Maybe<Services_Mutation_Response>;
  /** delete single row from the table: "services" */
  delete_services_by_pk?: Maybe<Services>;
  /** delete data from the table: "uploadComments" */
  delete_uploadComments?: Maybe<UploadComments_Mutation_Response>;
  /** delete single row from the table: "uploadComments" */
  delete_uploadComments_by_pk?: Maybe<UploadComments>;
  /** delete data from the table: "uploadVersions" */
  delete_uploadVersions?: Maybe<UploadVersions_Mutation_Response>;
  /** delete single row from the table: "uploadVersions" */
  delete_uploadVersions_by_pk?: Maybe<UploadVersions>;
  /** delete data from the table: "uploads" */
  delete_uploads?: Maybe<Uploads_Mutation_Response>;
  /** delete single row from the table: "uploads" */
  delete_uploads_by_pk?: Maybe<Uploads>;
  /** delete data from the table: "userAttributeValues" */
  delete_userAttributeValues?: Maybe<UserAttributeValues_Mutation_Response>;
  /** delete single row from the table: "userAttributeValues" */
  delete_userAttributeValues_by_pk?: Maybe<UserAttributeValues>;
  /** delete data from the table: "userAttributes" */
  delete_userAttributes?: Maybe<UserAttributes_Mutation_Response>;
  /** delete single row from the table: "userAttributes" */
  delete_userAttributes_by_pk?: Maybe<UserAttributes>;
  /** delete data from the table: "userDataRoomOccurrences" */
  delete_userDataRoomOccurrences?: Maybe<UserDataRoomOccurrences_Mutation_Response>;
  /** delete single row from the table: "userDataRoomOccurrences" */
  delete_userDataRoomOccurrences_by_pk?: Maybe<UserDataRoomOccurrences>;
  /** delete data from the table: "userDataRoomServiceOccurrences" */
  delete_userDataRoomServiceOccurrences?: Maybe<UserDataRoomServiceOccurrences_Mutation_Response>;
  /** delete single row from the table: "userDataRoomServiceOccurrences" */
  delete_userDataRoomServiceOccurrences_by_pk?: Maybe<UserDataRoomServiceOccurrences>;
  /** delete data from the table: "userDataServices" */
  delete_userDataServices?: Maybe<UserDataServices_Mutation_Response>;
  /** delete single row from the table: "userDataServices" */
  delete_userDataServices_by_pk?: Maybe<UserDataServices>;
  /** delete data from the table: "userRoomServiceOccurrenceLastVisits" */
  delete_userRoomServiceOccurrenceLastVisits?: Maybe<UserRoomServiceOccurrenceLastVisits_Mutation_Response>;
  /** delete single row from the table: "userRoomServiceOccurrenceLastVisits" */
  delete_userRoomServiceOccurrenceLastVisits_by_pk?: Maybe<UserRoomServiceOccurrenceLastVisits>;
  /** delete data from the table: "userServiceModuleLastVisits" */
  delete_userServiceModuleLastVisits?: Maybe<UserServiceModuleLastVisits_Mutation_Response>;
  /** delete single row from the table: "userServiceModuleLastVisits" */
  delete_userServiceModuleLastVisits_by_pk?: Maybe<UserServiceModuleLastVisits>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** insert data into the table: "articles" */
  insert_articles?: Maybe<Articles_Mutation_Response>;
  /** insert a single row into the table: "articles" */
  insert_articles_one?: Maybe<Articles>;
  /** insert data into the table: "attributeFiles" */
  insert_attributeFiles?: Maybe<AttributeFiles_Mutation_Response>;
  /** insert a single row into the table: "attributeFiles" */
  insert_attributeFiles_one?: Maybe<AttributeFiles>;
  /** insert data into the table: "attributeGroups" */
  insert_attributeGroups?: Maybe<AttributeGroups_Mutation_Response>;
  /** insert a single row into the table: "attributeGroups" */
  insert_attributeGroups_one?: Maybe<AttributeGroups>;
  /** insert data into the table: "attributeValueComments" */
  insert_attributeValueComments?: Maybe<AttributeValueComments_Mutation_Response>;
  /** insert a single row into the table: "attributeValueComments" */
  insert_attributeValueComments_one?: Maybe<AttributeValueComments>;
  /** insert data into the table: "attributeValueGroups" */
  insert_attributeValueGroups?: Maybe<AttributeValueGroups_Mutation_Response>;
  /** insert a single row into the table: "attributeValueGroups" */
  insert_attributeValueGroups_one?: Maybe<AttributeValueGroups>;
  /** insert data into the table: "attributeValueUploadVersions" */
  insert_attributeValueUploadVersions?: Maybe<AttributeValueUploadVersions_Mutation_Response>;
  /** insert a single row into the table: "attributeValueUploadVersions" */
  insert_attributeValueUploadVersions_one?: Maybe<AttributeValueUploadVersions>;
  /** insert data into the table: "attributeValueUploads" */
  insert_attributeValueUploads?: Maybe<AttributeValueUploads_Mutation_Response>;
  /** insert a single row into the table: "attributeValueUploads" */
  insert_attributeValueUploads_one?: Maybe<AttributeValueUploads>;
  /** insert data into the table: "attributeValues" */
  insert_attributeValues?: Maybe<AttributeValues_Mutation_Response>;
  /** insert a single row into the table: "attributeValues" */
  insert_attributeValues_one?: Maybe<AttributeValues>;
  /** insert data into the table: "attributes" */
  insert_attributes?: Maybe<Attributes_Mutation_Response>;
  /** insert a single row into the table: "attributes" */
  insert_attributes_one?: Maybe<Attributes>;
  /** insert data into the table: "cartLines" */
  insert_cartLines?: Maybe<CartLines_Mutation_Response>;
  /** insert a single row into the table: "cartLines" */
  insert_cartLines_one?: Maybe<CartLines>;
  /** insert data into the table: "carts" */
  insert_carts?: Maybe<Carts_Mutation_Response>;
  /** insert a single row into the table: "carts" */
  insert_carts_one?: Maybe<Carts>;
  /** insert data into the table: "catalogFolderArticles" */
  insert_catalogFolderArticles?: Maybe<CatalogFolderArticles_Mutation_Response>;
  /** insert a single row into the table: "catalogFolderArticles" */
  insert_catalogFolderArticles_one?: Maybe<CatalogFolderArticles>;
  /** insert data into the table: "catalogFolders" */
  insert_catalogFolders?: Maybe<CatalogFolders_Mutation_Response>;
  /** insert a single row into the table: "catalogFolders" */
  insert_catalogFolders_one?: Maybe<CatalogFolders>;
  /** insert data into the table: "eventAttributeGroups" */
  insert_eventAttributeGroups?: Maybe<EventAttributeGroups_Mutation_Response>;
  /** insert a single row into the table: "eventAttributeGroups" */
  insert_eventAttributeGroups_one?: Maybe<EventAttributeGroups>;
  /** insert data into the table: "eventAttributeValueUploadVersions" */
  insert_eventAttributeValueUploadVersions?: Maybe<EventAttributeValueUploadVersions_Mutation_Response>;
  /** insert a single row into the table: "eventAttributeValueUploadVersions" */
  insert_eventAttributeValueUploadVersions_one?: Maybe<EventAttributeValueUploadVersions>;
  /** insert data into the table: "eventAttributeValueUploads" */
  insert_eventAttributeValueUploads?: Maybe<EventAttributeValueUploads_Mutation_Response>;
  /** insert a single row into the table: "eventAttributeValueUploads" */
  insert_eventAttributeValueUploads_one?: Maybe<EventAttributeValueUploads>;
  /** insert data into the table: "eventAttributeValues" */
  insert_eventAttributeValues?: Maybe<EventAttributeValues_Mutation_Response>;
  /** insert a single row into the table: "eventAttributeValues" */
  insert_eventAttributeValues_one?: Maybe<EventAttributeValues>;
  /** insert data into the table: "eventAttributes" */
  insert_eventAttributes?: Maybe<EventAttributes_Mutation_Response>;
  /** insert a single row into the table: "eventAttributes" */
  insert_eventAttributes_one?: Maybe<EventAttributes>;
  /** insert data into the table: "eventFavourites" */
  insert_eventFavourites?: Maybe<EventFavourites_Mutation_Response>;
  /** insert a single row into the table: "eventFavourites" */
  insert_eventFavourites_one?: Maybe<EventFavourites>;
  /** insert data into the table: "eventOrganisers" */
  insert_eventOrganisers?: Maybe<EventOrganisers_Mutation_Response>;
  /** insert a single row into the table: "eventOrganisers" */
  insert_eventOrganisers_one?: Maybe<EventOrganisers>;
  /** insert data into the table: "eventRoomWatches" */
  insert_eventRoomWatches?: Maybe<EventRoomWatches_Mutation_Response>;
  /** insert a single row into the table: "eventRoomWatches" */
  insert_eventRoomWatches_one?: Maybe<EventRoomWatches>;
  /** insert data into the table: "eventRooms" */
  insert_eventRooms?: Maybe<EventRooms_Mutation_Response>;
  /** insert a single row into the table: "eventRooms" */
  insert_eventRooms_one?: Maybe<EventRooms>;
  /** insert data into the table: "events" */
  insert_events?: Maybe<Events_Mutation_Response>;
  /** insert a single row into the table: "events" */
  insert_events_one?: Maybe<Events>;
  /** insert data into the table: "fileMasterVersions" */
  insert_fileMasterVersions?: Maybe<FileMasterVersions_Mutation_Response>;
  /** insert a single row into the table: "fileMasterVersions" */
  insert_fileMasterVersions_one?: Maybe<FileMasterVersions>;
  /** insert data into the table: "fileMasters" */
  insert_fileMasters?: Maybe<FileMasters_Mutation_Response>;
  /** insert a single row into the table: "fileMasters" */
  insert_fileMasters_one?: Maybe<FileMasters>;
  /** insert data into the table: "infoBoxes" */
  insert_infoBoxes?: Maybe<InfoBoxes_Mutation_Response>;
  /** insert a single row into the table: "infoBoxes" */
  insert_infoBoxes_one?: Maybe<InfoBoxes>;
  /** insert data into the table: "infoNews" */
  insert_infoNews?: Maybe<InfoNews_Mutation_Response>;
  /** insert a single row into the table: "infoNews" */
  insert_infoNews_one?: Maybe<InfoNews>;
  /** insert data into the table: "jaggaerBanfs" */
  insert_jaggaerBanfs?: Maybe<JaggaerBanfs_Mutation_Response>;
  /** insert a single row into the table: "jaggaerBanfs" */
  insert_jaggaerBanfs_one?: Maybe<JaggaerBanfs>;
  /** insert data into the table: "jaggaerSubmissions" */
  insert_jaggaerSubmissions?: Maybe<JaggaerSubmissions_Mutation_Response>;
  /** insert a single row into the table: "jaggaerSubmissions" */
  insert_jaggaerSubmissions_one?: Maybe<JaggaerSubmissions>;
  /** insert data into the table: "news" */
  insert_news?: Maybe<News_Mutation_Response>;
  /** insert a single row into the table: "news" */
  insert_news_one?: Maybe<News>;
  /** insert data into the table: "notificationPreferences" */
  insert_notificationPreferences?: Maybe<NotificationPreferences_Mutation_Response>;
  /** insert a single row into the table: "notificationPreferences" */
  insert_notificationPreferences_one?: Maybe<NotificationPreferences>;
  /** insert data into the table: "notificationRoomServiceCategoryPreferences" */
  insert_notificationRoomServiceCategoryPreferences?: Maybe<NotificationRoomServiceCategoryPreferences_Mutation_Response>;
  /** insert a single row into the table: "notificationRoomServiceCategoryPreferences" */
  insert_notificationRoomServiceCategoryPreferences_one?: Maybe<NotificationRoomServiceCategoryPreferences>;
  /** insert data into the table: "notificationServicePreferences" */
  insert_notificationServicePreferences?: Maybe<NotificationServicePreferences_Mutation_Response>;
  /** insert a single row into the table: "notificationServicePreferences" */
  insert_notificationServicePreferences_one?: Maybe<NotificationServicePreferences>;
  /** insert data into the table: "orders" */
  insert_orders?: Maybe<Orders_Mutation_Response>;
  /** insert a single row into the table: "orders" */
  insert_orders_one?: Maybe<Orders>;
  /** insert data into the table: "organisationGroupUsers" */
  insert_organisationGroupUsers?: Maybe<OrganisationGroupUsers_Mutation_Response>;
  /** insert a single row into the table: "organisationGroupUsers" */
  insert_organisationGroupUsers_one?: Maybe<OrganisationGroupUsers>;
  /** insert data into the table: "organisationGroups" */
  insert_organisationGroups?: Maybe<OrganisationGroups_Mutation_Response>;
  /** insert a single row into the table: "organisationGroups" */
  insert_organisationGroups_one?: Maybe<OrganisationGroups>;
  /** insert data into the table: "organisations" */
  insert_organisations?: Maybe<Organisations_Mutation_Response>;
  /** insert a single row into the table: "organisations" */
  insert_organisations_one?: Maybe<Organisations>;
  /** insert data into the table: "roomAttributeFiles" */
  insert_roomAttributeFiles?: Maybe<RoomAttributeFiles_Mutation_Response>;
  /** insert a single row into the table: "roomAttributeFiles" */
  insert_roomAttributeFiles_one?: Maybe<RoomAttributeFiles>;
  /** insert data into the table: "roomAttributeGroups" */
  insert_roomAttributeGroups?: Maybe<RoomAttributeGroups_Mutation_Response>;
  /** insert a single row into the table: "roomAttributeGroups" */
  insert_roomAttributeGroups_one?: Maybe<RoomAttributeGroups>;
  /** insert data into the table: "roomAttributeValueComments" */
  insert_roomAttributeValueComments?: Maybe<RoomAttributeValueComments_Mutation_Response>;
  /** insert a single row into the table: "roomAttributeValueComments" */
  insert_roomAttributeValueComments_one?: Maybe<RoomAttributeValueComments>;
  /** insert data into the table: "roomAttributeValueGroups" */
  insert_roomAttributeValueGroups?: Maybe<RoomAttributeValueGroups_Mutation_Response>;
  /** insert a single row into the table: "roomAttributeValueGroups" */
  insert_roomAttributeValueGroups_one?: Maybe<RoomAttributeValueGroups>;
  /** insert data into the table: "roomAttributeValueUploadVersions" */
  insert_roomAttributeValueUploadVersions?: Maybe<RoomAttributeValueUploadVersions_Mutation_Response>;
  /** insert a single row into the table: "roomAttributeValueUploadVersions" */
  insert_roomAttributeValueUploadVersions_one?: Maybe<RoomAttributeValueUploadVersions>;
  /** insert data into the table: "roomAttributeValueUploads" */
  insert_roomAttributeValueUploads?: Maybe<RoomAttributeValueUploads_Mutation_Response>;
  /** insert a single row into the table: "roomAttributeValueUploads" */
  insert_roomAttributeValueUploads_one?: Maybe<RoomAttributeValueUploads>;
  /** insert data into the table: "roomAttributeValues" */
  insert_roomAttributeValues?: Maybe<RoomAttributeValues_Mutation_Response>;
  /** insert data into the table: "roomAttributeValues_for_comments" */
  insert_roomAttributeValues_for_comments?: Maybe<RoomAttributeValues_For_Comments_Mutation_Response>;
  /** insert a single row into the table: "roomAttributeValues_for_comments" */
  insert_roomAttributeValues_for_comments_one?: Maybe<RoomAttributeValues_For_Comments>;
  /** insert a single row into the table: "roomAttributeValues" */
  insert_roomAttributeValues_one?: Maybe<RoomAttributeValues>;
  /** insert data into the table: "roomAttributes" */
  insert_roomAttributes?: Maybe<RoomAttributes_Mutation_Response>;
  /** insert a single row into the table: "roomAttributes" */
  insert_roomAttributes_one?: Maybe<RoomAttributes>;
  /** insert data into the table: "roomFolders" */
  insert_roomFolders?: Maybe<RoomFolders_Mutation_Response>;
  /** insert a single row into the table: "roomFolders" */
  insert_roomFolders_one?: Maybe<RoomFolders>;
  /** insert data into the table: "roomOccurrences" */
  insert_roomOccurrences?: Maybe<RoomOccurrences_Mutation_Response>;
  /** insert a single row into the table: "roomOccurrences" */
  insert_roomOccurrences_one?: Maybe<RoomOccurrences>;
  /** insert data into the table: "roomServiceCategories" */
  insert_roomServiceCategories?: Maybe<RoomServiceCategories_Mutation_Response>;
  /** insert a single row into the table: "roomServiceCategories" */
  insert_roomServiceCategories_one?: Maybe<RoomServiceCategories>;
  /** insert data into the table: "roomServiceOccurrences" */
  insert_roomServiceOccurrences?: Maybe<RoomServiceOccurrences_Mutation_Response>;
  /** insert a single row into the table: "roomServiceOccurrences" */
  insert_roomServiceOccurrences_one?: Maybe<RoomServiceOccurrences>;
  /** insert data into the table: "roomServiceOrganisationAccesses" */
  insert_roomServiceOrganisationAccesses?: Maybe<RoomServiceOrganisationAccesses_Mutation_Response>;
  /** insert a single row into the table: "roomServiceOrganisationAccesses" */
  insert_roomServiceOrganisationAccesses_one?: Maybe<RoomServiceOrganisationAccesses>;
  /** insert data into the table: "roomServices" */
  insert_roomServices?: Maybe<RoomServices_Mutation_Response>;
  /** insert a single row into the table: "roomServices" */
  insert_roomServices_one?: Maybe<RoomServices>;
  /** insert data into the table: "rooms" */
  insert_rooms?: Maybe<Rooms_Mutation_Response>;
  /** insert a single row into the table: "rooms" */
  insert_rooms_one?: Maybe<Rooms>;
  /** insert data into the table: "serviceBundleServices" */
  insert_serviceBundleServices?: Maybe<ServiceBundleServices_Mutation_Response>;
  /** insert a single row into the table: "serviceBundleServices" */
  insert_serviceBundleServices_one?: Maybe<ServiceBundleServices>;
  /** insert data into the table: "serviceBundles" */
  insert_serviceBundles?: Maybe<ServiceBundles_Mutation_Response>;
  /** insert a single row into the table: "serviceBundles" */
  insert_serviceBundles_one?: Maybe<ServiceBundles>;
  /** insert data into the table: "serviceFavourites" */
  insert_serviceFavourites?: Maybe<ServiceFavourites_Mutation_Response>;
  /** insert a single row into the table: "serviceFavourites" */
  insert_serviceFavourites_one?: Maybe<ServiceFavourites>;
  /** insert data into the table: "serviceModuleAccesses" */
  insert_serviceModuleAccesses?: Maybe<ServiceModuleAccesses_Mutation_Response>;
  /** insert a single row into the table: "serviceModuleAccesses" */
  insert_serviceModuleAccesses_one?: Maybe<ServiceModuleAccesses>;
  /** insert data into the table: "serviceModules" */
  insert_serviceModules?: Maybe<ServiceModules_Mutation_Response>;
  /** insert a single row into the table: "serviceModules" */
  insert_serviceModules_one?: Maybe<ServiceModules>;
  /** insert data into the table: "serviceOrganisationAccesses" */
  insert_serviceOrganisationAccesses?: Maybe<ServiceOrganisationAccesses_Mutation_Response>;
  /** insert a single row into the table: "serviceOrganisationAccesses" */
  insert_serviceOrganisationAccesses_one?: Maybe<ServiceOrganisationAccesses>;
  /** insert data into the table: "services" */
  insert_services?: Maybe<Services_Mutation_Response>;
  /** insert a single row into the table: "services" */
  insert_services_one?: Maybe<Services>;
  /** insert data into the table: "uploadComments" */
  insert_uploadComments?: Maybe<UploadComments_Mutation_Response>;
  /** insert a single row into the table: "uploadComments" */
  insert_uploadComments_one?: Maybe<UploadComments>;
  /** insert data into the table: "uploadVersions" */
  insert_uploadVersions?: Maybe<UploadVersions_Mutation_Response>;
  /** insert a single row into the table: "uploadVersions" */
  insert_uploadVersions_one?: Maybe<UploadVersions>;
  /** insert data into the table: "uploads" */
  insert_uploads?: Maybe<Uploads_Mutation_Response>;
  /** insert a single row into the table: "uploads" */
  insert_uploads_one?: Maybe<Uploads>;
  /** insert data into the table: "userAttributeValues" */
  insert_userAttributeValues?: Maybe<UserAttributeValues_Mutation_Response>;
  /** insert a single row into the table: "userAttributeValues" */
  insert_userAttributeValues_one?: Maybe<UserAttributeValues>;
  /** insert data into the table: "userAttributes" */
  insert_userAttributes?: Maybe<UserAttributes_Mutation_Response>;
  /** insert a single row into the table: "userAttributes" */
  insert_userAttributes_one?: Maybe<UserAttributes>;
  /** insert data into the table: "userDataRoomOccurrences" */
  insert_userDataRoomOccurrences?: Maybe<UserDataRoomOccurrences_Mutation_Response>;
  /** insert a single row into the table: "userDataRoomOccurrences" */
  insert_userDataRoomOccurrences_one?: Maybe<UserDataRoomOccurrences>;
  /** insert data into the table: "userDataRoomServiceOccurrences" */
  insert_userDataRoomServiceOccurrences?: Maybe<UserDataRoomServiceOccurrences_Mutation_Response>;
  /** insert a single row into the table: "userDataRoomServiceOccurrences" */
  insert_userDataRoomServiceOccurrences_one?: Maybe<UserDataRoomServiceOccurrences>;
  /** insert data into the table: "userDataServices" */
  insert_userDataServices?: Maybe<UserDataServices_Mutation_Response>;
  /** insert a single row into the table: "userDataServices" */
  insert_userDataServices_one?: Maybe<UserDataServices>;
  /** insert data into the table: "userRoomServiceOccurrenceLastVisits" */
  insert_userRoomServiceOccurrenceLastVisits?: Maybe<UserRoomServiceOccurrenceLastVisits_Mutation_Response>;
  /** insert a single row into the table: "userRoomServiceOccurrenceLastVisits" */
  insert_userRoomServiceOccurrenceLastVisits_one?: Maybe<UserRoomServiceOccurrenceLastVisits>;
  /** insert data into the table: "userServiceModuleLastVisits" */
  insert_userServiceModuleLastVisits?: Maybe<UserServiceModuleLastVisits_Mutation_Response>;
  /** insert a single row into the table: "userServiceModuleLastVisits" */
  insert_userServiceModuleLastVisits_one?: Maybe<UserServiceModuleLastVisits>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  login?: Maybe<LoginReturn>;
  logout?: Maybe<LogoutReturn>;
  setPassword?: Maybe<SetPasswordReturn>;
  /** update data of the table: "articles" */
  update_articles?: Maybe<Articles_Mutation_Response>;
  /** update single row of the table: "articles" */
  update_articles_by_pk?: Maybe<Articles>;
  /** update multiples rows of table: "articles" */
  update_articles_many?: Maybe<Array<Maybe<Articles_Mutation_Response>>>;
  /** update data of the table: "attributeGroups" */
  update_attributeGroups?: Maybe<AttributeGroups_Mutation_Response>;
  /** update single row of the table: "attributeGroups" */
  update_attributeGroups_by_pk?: Maybe<AttributeGroups>;
  /** update multiples rows of table: "attributeGroups" */
  update_attributeGroups_many?: Maybe<Array<Maybe<AttributeGroups_Mutation_Response>>>;
  /** update data of the table: "attributeValueComments" */
  update_attributeValueComments?: Maybe<AttributeValueComments_Mutation_Response>;
  /** update single row of the table: "attributeValueComments" */
  update_attributeValueComments_by_pk?: Maybe<AttributeValueComments>;
  /** update multiples rows of table: "attributeValueComments" */
  update_attributeValueComments_many?: Maybe<Array<Maybe<AttributeValueComments_Mutation_Response>>>;
  /** update data of the table: "attributeValueUploads" */
  update_attributeValueUploads?: Maybe<AttributeValueUploads_Mutation_Response>;
  /** update single row of the table: "attributeValueUploads" */
  update_attributeValueUploads_by_pk?: Maybe<AttributeValueUploads>;
  /** update multiples rows of table: "attributeValueUploads" */
  update_attributeValueUploads_many?: Maybe<Array<Maybe<AttributeValueUploads_Mutation_Response>>>;
  /** update data of the table: "attributeValues" */
  update_attributeValues?: Maybe<AttributeValues_Mutation_Response>;
  /** update single row of the table: "attributeValues" */
  update_attributeValues_by_pk?: Maybe<AttributeValues>;
  /** update multiples rows of table: "attributeValues" */
  update_attributeValues_many?: Maybe<Array<Maybe<AttributeValues_Mutation_Response>>>;
  /** update data of the table: "attributes" */
  update_attributes?: Maybe<Attributes_Mutation_Response>;
  /** update single row of the table: "attributes" */
  update_attributes_by_pk?: Maybe<Attributes>;
  /** update multiples rows of table: "attributes" */
  update_attributes_many?: Maybe<Array<Maybe<Attributes_Mutation_Response>>>;
  /** update data of the table: "cartLines" */
  update_cartLines?: Maybe<CartLines_Mutation_Response>;
  /** update single row of the table: "cartLines" */
  update_cartLines_by_pk?: Maybe<CartLines>;
  /** update multiples rows of table: "cartLines" */
  update_cartLines_many?: Maybe<Array<Maybe<CartLines_Mutation_Response>>>;
  /** update data of the table: "carts" */
  update_carts?: Maybe<Carts_Mutation_Response>;
  /** update single row of the table: "carts" */
  update_carts_by_pk?: Maybe<Carts>;
  /** update multiples rows of table: "carts" */
  update_carts_many?: Maybe<Array<Maybe<Carts_Mutation_Response>>>;
  /** update data of the table: "catalogFolders" */
  update_catalogFolders?: Maybe<CatalogFolders_Mutation_Response>;
  /** update single row of the table: "catalogFolders" */
  update_catalogFolders_by_pk?: Maybe<CatalogFolders>;
  /** update multiples rows of table: "catalogFolders" */
  update_catalogFolders_many?: Maybe<Array<Maybe<CatalogFolders_Mutation_Response>>>;
  /** update data of the table: "eventAttributeGroups" */
  update_eventAttributeGroups?: Maybe<EventAttributeGroups_Mutation_Response>;
  /** update single row of the table: "eventAttributeGroups" */
  update_eventAttributeGroups_by_pk?: Maybe<EventAttributeGroups>;
  /** update multiples rows of table: "eventAttributeGroups" */
  update_eventAttributeGroups_many?: Maybe<Array<Maybe<EventAttributeGroups_Mutation_Response>>>;
  /** update data of the table: "eventAttributeValueUploads" */
  update_eventAttributeValueUploads?: Maybe<EventAttributeValueUploads_Mutation_Response>;
  /** update single row of the table: "eventAttributeValueUploads" */
  update_eventAttributeValueUploads_by_pk?: Maybe<EventAttributeValueUploads>;
  /** update multiples rows of table: "eventAttributeValueUploads" */
  update_eventAttributeValueUploads_many?: Maybe<Array<Maybe<EventAttributeValueUploads_Mutation_Response>>>;
  /** update data of the table: "eventAttributeValues" */
  update_eventAttributeValues?: Maybe<EventAttributeValues_Mutation_Response>;
  /** update single row of the table: "eventAttributeValues" */
  update_eventAttributeValues_by_pk?: Maybe<EventAttributeValues>;
  /** update multiples rows of table: "eventAttributeValues" */
  update_eventAttributeValues_many?: Maybe<Array<Maybe<EventAttributeValues_Mutation_Response>>>;
  /** update data of the table: "eventAttributes" */
  update_eventAttributes?: Maybe<EventAttributes_Mutation_Response>;
  /** update single row of the table: "eventAttributes" */
  update_eventAttributes_by_pk?: Maybe<EventAttributes>;
  /** update multiples rows of table: "eventAttributes" */
  update_eventAttributes_many?: Maybe<Array<Maybe<EventAttributes_Mutation_Response>>>;
  /** update data of the table: "eventFavourites" */
  update_eventFavourites?: Maybe<EventFavourites_Mutation_Response>;
  /** update single row of the table: "eventFavourites" */
  update_eventFavourites_by_pk?: Maybe<EventFavourites>;
  /** update multiples rows of table: "eventFavourites" */
  update_eventFavourites_many?: Maybe<Array<Maybe<EventFavourites_Mutation_Response>>>;
  /** update data of the table: "eventRoomWatches" */
  update_eventRoomWatches?: Maybe<EventRoomWatches_Mutation_Response>;
  /** update single row of the table: "eventRoomWatches" */
  update_eventRoomWatches_by_pk?: Maybe<EventRoomWatches>;
  /** update multiples rows of table: "eventRoomWatches" */
  update_eventRoomWatches_many?: Maybe<Array<Maybe<EventRoomWatches_Mutation_Response>>>;
  /** update data of the table: "eventRooms" */
  update_eventRooms?: Maybe<EventRooms_Mutation_Response>;
  /** update single row of the table: "eventRooms" */
  update_eventRooms_by_pk?: Maybe<EventRooms>;
  /** update multiples rows of table: "eventRooms" */
  update_eventRooms_many?: Maybe<Array<Maybe<EventRooms_Mutation_Response>>>;
  /** update data of the table: "events" */
  update_events?: Maybe<Events_Mutation_Response>;
  /** update single row of the table: "events" */
  update_events_by_pk?: Maybe<Events>;
  /** update multiples rows of table: "events" */
  update_events_many?: Maybe<Array<Maybe<Events_Mutation_Response>>>;
  /** update data of the table: "fileMasters" */
  update_fileMasters?: Maybe<FileMasters_Mutation_Response>;
  /** update single row of the table: "fileMasters" */
  update_fileMasters_by_pk?: Maybe<FileMasters>;
  /** update multiples rows of table: "fileMasters" */
  update_fileMasters_many?: Maybe<Array<Maybe<FileMasters_Mutation_Response>>>;
  /** update data of the table: "files" */
  update_files?: Maybe<Files_Mutation_Response>;
  /** update single row of the table: "files" */
  update_files_by_pk?: Maybe<Files>;
  /** update multiples rows of table: "files" */
  update_files_many?: Maybe<Array<Maybe<Files_Mutation_Response>>>;
  /** update data of the table: "infoBoxes" */
  update_infoBoxes?: Maybe<InfoBoxes_Mutation_Response>;
  /** update single row of the table: "infoBoxes" */
  update_infoBoxes_by_pk?: Maybe<InfoBoxes>;
  /** update multiples rows of table: "infoBoxes" */
  update_infoBoxes_many?: Maybe<Array<Maybe<InfoBoxes_Mutation_Response>>>;
  /** update data of the table: "infoNews" */
  update_infoNews?: Maybe<InfoNews_Mutation_Response>;
  /** update single row of the table: "infoNews" */
  update_infoNews_by_pk?: Maybe<InfoNews>;
  /** update multiples rows of table: "infoNews" */
  update_infoNews_many?: Maybe<Array<Maybe<InfoNews_Mutation_Response>>>;
  /** update data of the table: "notificationMessages" */
  update_notificationMessages?: Maybe<NotificationMessages_Mutation_Response>;
  /** update single row of the table: "notificationMessages" */
  update_notificationMessages_by_pk?: Maybe<NotificationMessages>;
  /** update multiples rows of table: "notificationMessages" */
  update_notificationMessages_many?: Maybe<Array<Maybe<NotificationMessages_Mutation_Response>>>;
  /** update data of the table: "notificationPreferences" */
  update_notificationPreferences?: Maybe<NotificationPreferences_Mutation_Response>;
  /** update single row of the table: "notificationPreferences" */
  update_notificationPreferences_by_pk?: Maybe<NotificationPreferences>;
  /** update multiples rows of table: "notificationPreferences" */
  update_notificationPreferences_many?: Maybe<Array<Maybe<NotificationPreferences_Mutation_Response>>>;
  /** update data of the table: "orders" */
  update_orders?: Maybe<Orders_Mutation_Response>;
  /** update single row of the table: "orders" */
  update_orders_by_pk?: Maybe<Orders>;
  /** update multiples rows of table: "orders" */
  update_orders_many?: Maybe<Array<Maybe<Orders_Mutation_Response>>>;
  /** update data of the table: "organisationGroups" */
  update_organisationGroups?: Maybe<OrganisationGroups_Mutation_Response>;
  /** update single row of the table: "organisationGroups" */
  update_organisationGroups_by_pk?: Maybe<OrganisationGroups>;
  /** update multiples rows of table: "organisationGroups" */
  update_organisationGroups_many?: Maybe<Array<Maybe<OrganisationGroups_Mutation_Response>>>;
  /** update data of the table: "organisations" */
  update_organisations?: Maybe<Organisations_Mutation_Response>;
  /** update single row of the table: "organisations" */
  update_organisations_by_pk?: Maybe<Organisations>;
  /** update multiples rows of table: "organisations" */
  update_organisations_many?: Maybe<Array<Maybe<Organisations_Mutation_Response>>>;
  /** update data of the table: "roomAttributeGroups" */
  update_roomAttributeGroups?: Maybe<RoomAttributeGroups_Mutation_Response>;
  /** update single row of the table: "roomAttributeGroups" */
  update_roomAttributeGroups_by_pk?: Maybe<RoomAttributeGroups>;
  /** update multiples rows of table: "roomAttributeGroups" */
  update_roomAttributeGroups_many?: Maybe<Array<Maybe<RoomAttributeGroups_Mutation_Response>>>;
  /** update data of the table: "roomAttributeValueComments" */
  update_roomAttributeValueComments?: Maybe<RoomAttributeValueComments_Mutation_Response>;
  /** update single row of the table: "roomAttributeValueComments" */
  update_roomAttributeValueComments_by_pk?: Maybe<RoomAttributeValueComments>;
  /** update multiples rows of table: "roomAttributeValueComments" */
  update_roomAttributeValueComments_many?: Maybe<Array<Maybe<RoomAttributeValueComments_Mutation_Response>>>;
  /** update data of the table: "roomAttributeValueUploads" */
  update_roomAttributeValueUploads?: Maybe<RoomAttributeValueUploads_Mutation_Response>;
  /** update single row of the table: "roomAttributeValueUploads" */
  update_roomAttributeValueUploads_by_pk?: Maybe<RoomAttributeValueUploads>;
  /** update multiples rows of table: "roomAttributeValueUploads" */
  update_roomAttributeValueUploads_many?: Maybe<Array<Maybe<RoomAttributeValueUploads_Mutation_Response>>>;
  /** update data of the table: "roomAttributeValues" */
  update_roomAttributeValues?: Maybe<RoomAttributeValues_Mutation_Response>;
  /** update single row of the table: "roomAttributeValues" */
  update_roomAttributeValues_by_pk?: Maybe<RoomAttributeValues>;
  /** update multiples rows of table: "roomAttributeValues" */
  update_roomAttributeValues_many?: Maybe<Array<Maybe<RoomAttributeValues_Mutation_Response>>>;
  /** update data of the table: "roomAttributes" */
  update_roomAttributes?: Maybe<RoomAttributes_Mutation_Response>;
  /** update single row of the table: "roomAttributes" */
  update_roomAttributes_by_pk?: Maybe<RoomAttributes>;
  /** update multiples rows of table: "roomAttributes" */
  update_roomAttributes_many?: Maybe<Array<Maybe<RoomAttributes_Mutation_Response>>>;
  /** update data of the table: "roomFolders" */
  update_roomFolders?: Maybe<RoomFolders_Mutation_Response>;
  /** update single row of the table: "roomFolders" */
  update_roomFolders_by_pk?: Maybe<RoomFolders>;
  /** update multiples rows of table: "roomFolders" */
  update_roomFolders_many?: Maybe<Array<Maybe<RoomFolders_Mutation_Response>>>;
  /** update data of the table: "roomOccurrences" */
  update_roomOccurrences?: Maybe<RoomOccurrences_Mutation_Response>;
  /** update single row of the table: "roomOccurrences" */
  update_roomOccurrences_by_pk?: Maybe<RoomOccurrences>;
  /** update multiples rows of table: "roomOccurrences" */
  update_roomOccurrences_many?: Maybe<Array<Maybe<RoomOccurrences_Mutation_Response>>>;
  /** update data of the table: "roomServiceCategories" */
  update_roomServiceCategories?: Maybe<RoomServiceCategories_Mutation_Response>;
  /** update single row of the table: "roomServiceCategories" */
  update_roomServiceCategories_by_pk?: Maybe<RoomServiceCategories>;
  /** update multiples rows of table: "roomServiceCategories" */
  update_roomServiceCategories_many?: Maybe<Array<Maybe<RoomServiceCategories_Mutation_Response>>>;
  /** update data of the table: "roomServiceOccurrences" */
  update_roomServiceOccurrences?: Maybe<RoomServiceOccurrences_Mutation_Response>;
  /** update single row of the table: "roomServiceOccurrences" */
  update_roomServiceOccurrences_by_pk?: Maybe<RoomServiceOccurrences>;
  /** update multiples rows of table: "roomServiceOccurrences" */
  update_roomServiceOccurrences_many?: Maybe<Array<Maybe<RoomServiceOccurrences_Mutation_Response>>>;
  /** update data of the table: "roomServiceOrganisationAccesses" */
  update_roomServiceOrganisationAccesses?: Maybe<RoomServiceOrganisationAccesses_Mutation_Response>;
  /** update single row of the table: "roomServiceOrganisationAccesses" */
  update_roomServiceOrganisationAccesses_by_pk?: Maybe<RoomServiceOrganisationAccesses>;
  /** update multiples rows of table: "roomServiceOrganisationAccesses" */
  update_roomServiceOrganisationAccesses_many?: Maybe<Array<Maybe<RoomServiceOrganisationAccesses_Mutation_Response>>>;
  /** update data of the table: "roomServices" */
  update_roomServices?: Maybe<RoomServices_Mutation_Response>;
  /** update single row of the table: "roomServices" */
  update_roomServices_by_pk?: Maybe<RoomServices>;
  /** update multiples rows of table: "roomServices" */
  update_roomServices_many?: Maybe<Array<Maybe<RoomServices_Mutation_Response>>>;
  /** update data of the table: "rooms" */
  update_rooms?: Maybe<Rooms_Mutation_Response>;
  /** update single row of the table: "rooms" */
  update_rooms_by_pk?: Maybe<Rooms>;
  /** update multiples rows of table: "rooms" */
  update_rooms_many?: Maybe<Array<Maybe<Rooms_Mutation_Response>>>;
  /** update data of the table: "serviceBundles" */
  update_serviceBundles?: Maybe<ServiceBundles_Mutation_Response>;
  /** update single row of the table: "serviceBundles" */
  update_serviceBundles_by_pk?: Maybe<ServiceBundles>;
  /** update multiples rows of table: "serviceBundles" */
  update_serviceBundles_many?: Maybe<Array<Maybe<ServiceBundles_Mutation_Response>>>;
  /** update data of the table: "serviceFavourites" */
  update_serviceFavourites?: Maybe<ServiceFavourites_Mutation_Response>;
  /** update single row of the table: "serviceFavourites" */
  update_serviceFavourites_by_pk?: Maybe<ServiceFavourites>;
  /** update multiples rows of table: "serviceFavourites" */
  update_serviceFavourites_many?: Maybe<Array<Maybe<ServiceFavourites_Mutation_Response>>>;
  /** update data of the table: "serviceModuleAccesses" */
  update_serviceModuleAccesses?: Maybe<ServiceModuleAccesses_Mutation_Response>;
  /** update single row of the table: "serviceModuleAccesses" */
  update_serviceModuleAccesses_by_pk?: Maybe<ServiceModuleAccesses>;
  /** update multiples rows of table: "serviceModuleAccesses" */
  update_serviceModuleAccesses_many?: Maybe<Array<Maybe<ServiceModuleAccesses_Mutation_Response>>>;
  /** update data of the table: "serviceModules" */
  update_serviceModules?: Maybe<ServiceModules_Mutation_Response>;
  /** update single row of the table: "serviceModules" */
  update_serviceModules_by_pk?: Maybe<ServiceModules>;
  /** update multiples rows of table: "serviceModules" */
  update_serviceModules_many?: Maybe<Array<Maybe<ServiceModules_Mutation_Response>>>;
  /** update data of the table: "serviceOrganisationAccesses" */
  update_serviceOrganisationAccesses?: Maybe<ServiceOrganisationAccesses_Mutation_Response>;
  /** update single row of the table: "serviceOrganisationAccesses" */
  update_serviceOrganisationAccesses_by_pk?: Maybe<ServiceOrganisationAccesses>;
  /** update multiples rows of table: "serviceOrganisationAccesses" */
  update_serviceOrganisationAccesses_many?: Maybe<Array<Maybe<ServiceOrganisationAccesses_Mutation_Response>>>;
  /** update data of the table: "services" */
  update_services?: Maybe<Services_Mutation_Response>;
  /** update single row of the table: "services" */
  update_services_by_pk?: Maybe<Services>;
  /** update multiples rows of table: "services" */
  update_services_many?: Maybe<Array<Maybe<Services_Mutation_Response>>>;
  /** update data of the table: "test1" */
  update_test1?: Maybe<Test1_Mutation_Response>;
  /** update multiples rows of table: "test1" */
  update_test1_many?: Maybe<Array<Maybe<Test1_Mutation_Response>>>;
  /** update data of the table: "uploadComments" */
  update_uploadComments?: Maybe<UploadComments_Mutation_Response>;
  /** update single row of the table: "uploadComments" */
  update_uploadComments_by_pk?: Maybe<UploadComments>;
  /** update multiples rows of table: "uploadComments" */
  update_uploadComments_many?: Maybe<Array<Maybe<UploadComments_Mutation_Response>>>;
  /** update data of the table: "uploads" */
  update_uploads?: Maybe<Uploads_Mutation_Response>;
  /** update single row of the table: "uploads" */
  update_uploads_by_pk?: Maybe<Uploads>;
  /** update multiples rows of table: "uploads" */
  update_uploads_many?: Maybe<Array<Maybe<Uploads_Mutation_Response>>>;
  /** update data of the table: "userAttributeValues" */
  update_userAttributeValues?: Maybe<UserAttributeValues_Mutation_Response>;
  /** update single row of the table: "userAttributeValues" */
  update_userAttributeValues_by_pk?: Maybe<UserAttributeValues>;
  /** update multiples rows of table: "userAttributeValues" */
  update_userAttributeValues_many?: Maybe<Array<Maybe<UserAttributeValues_Mutation_Response>>>;
  /** update data of the table: "userAttributes" */
  update_userAttributes?: Maybe<UserAttributes_Mutation_Response>;
  /** update single row of the table: "userAttributes" */
  update_userAttributes_by_pk?: Maybe<UserAttributes>;
  /** update multiples rows of table: "userAttributes" */
  update_userAttributes_many?: Maybe<Array<Maybe<UserAttributes_Mutation_Response>>>;
  /** update data of the table: "userDataRoomOccurrences" */
  update_userDataRoomOccurrences?: Maybe<UserDataRoomOccurrences_Mutation_Response>;
  /** update single row of the table: "userDataRoomOccurrences" */
  update_userDataRoomOccurrences_by_pk?: Maybe<UserDataRoomOccurrences>;
  /** update multiples rows of table: "userDataRoomOccurrences" */
  update_userDataRoomOccurrences_many?: Maybe<Array<Maybe<UserDataRoomOccurrences_Mutation_Response>>>;
  /** update data of the table: "userDataRoomServiceOccurrences" */
  update_userDataRoomServiceOccurrences?: Maybe<UserDataRoomServiceOccurrences_Mutation_Response>;
  /** update single row of the table: "userDataRoomServiceOccurrences" */
  update_userDataRoomServiceOccurrences_by_pk?: Maybe<UserDataRoomServiceOccurrences>;
  /** update multiples rows of table: "userDataRoomServiceOccurrences" */
  update_userDataRoomServiceOccurrences_many?: Maybe<Array<Maybe<UserDataRoomServiceOccurrences_Mutation_Response>>>;
  /** update data of the table: "userDataServices" */
  update_userDataServices?: Maybe<UserDataServices_Mutation_Response>;
  /** update single row of the table: "userDataServices" */
  update_userDataServices_by_pk?: Maybe<UserDataServices>;
  /** update multiples rows of table: "userDataServices" */
  update_userDataServices_many?: Maybe<Array<Maybe<UserDataServices_Mutation_Response>>>;
  /** update data of the table: "userRoomServiceOccurrenceLastVisits" */
  update_userRoomServiceOccurrenceLastVisits?: Maybe<UserRoomServiceOccurrenceLastVisits_Mutation_Response>;
  /** update single row of the table: "userRoomServiceOccurrenceLastVisits" */
  update_userRoomServiceOccurrenceLastVisits_by_pk?: Maybe<UserRoomServiceOccurrenceLastVisits>;
  /** update multiples rows of table: "userRoomServiceOccurrenceLastVisits" */
  update_userRoomServiceOccurrenceLastVisits_many?: Maybe<Array<Maybe<UserRoomServiceOccurrenceLastVisits_Mutation_Response>>>;
  /** update data of the table: "userServiceModuleLastVisits" */
  update_userServiceModuleLastVisits?: Maybe<UserServiceModuleLastVisits_Mutation_Response>;
  /** update single row of the table: "userServiceModuleLastVisits" */
  update_userServiceModuleLastVisits_by_pk?: Maybe<UserServiceModuleLastVisits>;
  /** update multiples rows of table: "userServiceModuleLastVisits" */
  update_userServiceModuleLastVisits_many?: Maybe<Array<Maybe<UserServiceModuleLastVisits_Mutation_Response>>>;
  /** update data of the table: "userSettings" */
  update_userSettings?: Maybe<UserSettings_Mutation_Response>;
  /** update multiples rows of table: "userSettings" */
  update_userSettings_many?: Maybe<Array<Maybe<UserSettings_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_ArticlesArgs = {
  where: Articles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Articles_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AttributeFilesArgs = {
  where: AttributeFiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AttributeFiles_By_PkArgs = {
  attributeId: Scalars['bigint']['input'];
  fileId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AttributeGroupsArgs = {
  where: AttributeGroups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AttributeGroups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AttributeValueCommentsArgs = {
  where: AttributeValueComments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AttributeValueComments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AttributeValueGroupsArgs = {
  where: AttributeValueGroups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AttributeValueGroups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AttributeValueUploadVersionsArgs = {
  where: AttributeValueUploadVersions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AttributeValueUploadVersions_By_PkArgs = {
  attributeValueUploadId: Scalars['bigint']['input'];
  fileId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AttributeValueUploadsArgs = {
  where: AttributeValueUploads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AttributeValueUploads_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AttributeValuesArgs = {
  where: AttributeValues_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AttributeValues_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AttributesArgs = {
  where: Attributes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Attributes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CartLinesArgs = {
  where: CartLines_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CartLines_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CartsArgs = {
  where: Carts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Carts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CatalogFolderArticlesArgs = {
  where: CatalogFolderArticles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CatalogFolderArticles_By_PkArgs = {
  articleId: Scalars['bigint']['input'];
  catalogFolderId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CatalogFoldersArgs = {
  where: CatalogFolders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CatalogFolders_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EventAttributeGroupsArgs = {
  where: EventAttributeGroups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EventAttributeGroups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EventAttributeValueUploadVersionsArgs = {
  where: EventAttributeValueUploadVersions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EventAttributeValueUploadVersions_By_PkArgs = {
  eventAttributeValueUploadId: Scalars['bigint']['input'];
  fileId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EventAttributeValueUploadsArgs = {
  where: EventAttributeValueUploads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EventAttributeValueUploads_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EventAttributeValuesArgs = {
  where: EventAttributeValues_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EventAttributeValues_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EventAttributesArgs = {
  where: EventAttributes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EventAttributes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EventFavouritesArgs = {
  where: EventFavourites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EventFavourites_By_PkArgs = {
  eventId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EventOrganisersArgs = {
  where: EventOrganisers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EventOrganisers_By_PkArgs = {
  eventId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EventRoomWatchesArgs = {
  where: EventRoomWatches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EventRoomWatches_By_PkArgs = {
  eventId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EventRoomsArgs = {
  where: EventRooms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_EventRooms_By_PkArgs = {
  eventId: Scalars['bigint']['input'];
  roomId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EventsArgs = {
  where: Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Events_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FileMasterVersionsArgs = {
  where: FileMasterVersions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_FileMasterVersions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FileMastersArgs = {
  where: FileMasters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_FileMasters_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_InfoBoxesArgs = {
  where: InfoBoxes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_InfoBoxes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_InfoNewsArgs = {
  where: InfoNews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_InfoNews_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_JaggaerBanfsArgs = {
  where: JaggaerBanfs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_JaggaerBanfs_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_NotificationPreferencesArgs = {
  where: NotificationPreferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_NotificationPreferences_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_NotificationRoomServiceCategoryPreferencesArgs = {
  where: NotificationRoomServiceCategoryPreferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_NotificationRoomServiceCategoryPreferences_By_PkArgs = {
  roomServiceCategoryId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_NotificationServicePreferencesArgs = {
  where: NotificationServicePreferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_NotificationServicePreferences_By_PkArgs = {
  serviceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OrdersArgs = {
  where: Orders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Orders_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OrganisationGroupUsersArgs = {
  where: OrganisationGroupUsers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_OrganisationGroupUsers_By_PkArgs = {
  organisationGroupId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OrganisationGroupsArgs = {
  where: OrganisationGroups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_OrganisationGroups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OrganisationsArgs = {
  where: Organisations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisations_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RoomAttributeFilesArgs = {
  where: RoomAttributeFiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_RoomAttributeFiles_By_PkArgs = {
  fileId: Scalars['bigint']['input'];
  roomAttributeId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RoomAttributeGroupsArgs = {
  where: RoomAttributeGroups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_RoomAttributeGroups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RoomAttributeValueCommentsArgs = {
  where: RoomAttributeValueComments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_RoomAttributeValueComments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RoomAttributeValueGroupsArgs = {
  where: RoomAttributeValueGroups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_RoomAttributeValueGroups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RoomAttributeValueUploadVersionsArgs = {
  where: RoomAttributeValueUploadVersions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_RoomAttributeValueUploadVersions_By_PkArgs = {
  fileId: Scalars['bigint']['input'];
  roomAttributeValueUploadId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RoomAttributeValueUploadsArgs = {
  where: RoomAttributeValueUploads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_RoomAttributeValueUploads_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RoomAttributeValuesArgs = {
  where: RoomAttributeValues_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_RoomAttributeValues_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RoomAttributesArgs = {
  where: RoomAttributes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_RoomAttributes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RoomFoldersArgs = {
  where: RoomFolders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_RoomFolders_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RoomOccurrencesArgs = {
  where: RoomOccurrences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_RoomOccurrences_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RoomServiceCategoriesArgs = {
  where: RoomServiceCategories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_RoomServiceCategories_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RoomServiceOccurrencesArgs = {
  where: RoomServiceOccurrences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_RoomServiceOccurrences_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RoomServiceOrganisationAccessesArgs = {
  where: RoomServiceOrganisationAccesses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_RoomServiceOrganisationAccesses_By_PkArgs = {
  eventId: Scalars['bigint']['input'];
  organisationId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RoomServicesArgs = {
  where: RoomServices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_RoomServices_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_RoomsArgs = {
  where: Rooms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Rooms_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServiceBundleServicesArgs = {
  where: ServiceBundleServices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServiceBundleServices_By_PkArgs = {
  serviceBundleId: Scalars['bigint']['input'];
  serviceId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServiceBundlesArgs = {
  where: ServiceBundles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServiceBundles_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServiceFavouritesArgs = {
  where: ServiceFavourites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServiceFavourites_By_PkArgs = {
  serviceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServiceModuleAccessesArgs = {
  where: ServiceModuleAccesses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServiceModuleAccesses_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServiceModulesArgs = {
  where: ServiceModules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServiceModules_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServiceOrganisationAccessesArgs = {
  where: ServiceOrganisationAccesses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ServiceOrganisationAccesses_By_PkArgs = {
  organisationId: Scalars['bigint']['input'];
  serviceId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ServicesArgs = {
  where: Services_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Services_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UploadCommentsArgs = {
  where: UploadComments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UploadComments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UploadVersionsArgs = {
  where: UploadVersions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UploadVersions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UploadsArgs = {
  where: Uploads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Uploads_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserAttributeValuesArgs = {
  where: UserAttributeValues_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserAttributeValues_By_PkArgs = {
  userAttributeId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserAttributesArgs = {
  where: UserAttributes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserAttributes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserDataRoomOccurrencesArgs = {
  where: UserDataRoomOccurrences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserDataRoomOccurrences_By_PkArgs = {
  roomOccurrenceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserDataRoomServiceOccurrencesArgs = {
  where: UserDataRoomServiceOccurrences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserDataRoomServiceOccurrences_By_PkArgs = {
  roomServiceOccurrenceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserDataServicesArgs = {
  where: UserDataServices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserDataServices_By_PkArgs = {
  serviceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserRoomServiceOccurrenceLastVisitsArgs = {
  where: UserRoomServiceOccurrenceLastVisits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserRoomServiceOccurrenceLastVisits_By_PkArgs = {
  roomServiceOccurrenceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserServiceModuleLastVisitsArgs = {
  where: UserServiceModuleLastVisits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UserServiceModuleLastVisits_By_PkArgs = {
  serviceModuleId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootInsert_ArticlesArgs = {
  objects: Array<Articles_Insert_Input>;
  on_conflict?: InputMaybe<Articles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Articles_OneArgs = {
  object: Articles_Insert_Input;
  on_conflict?: InputMaybe<Articles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AttributeFilesArgs = {
  objects: Array<AttributeFiles_Insert_Input>;
  on_conflict?: InputMaybe<AttributeFiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AttributeFiles_OneArgs = {
  object: AttributeFiles_Insert_Input;
  on_conflict?: InputMaybe<AttributeFiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AttributeGroupsArgs = {
  objects: Array<AttributeGroups_Insert_Input>;
  on_conflict?: InputMaybe<AttributeGroups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AttributeGroups_OneArgs = {
  object: AttributeGroups_Insert_Input;
  on_conflict?: InputMaybe<AttributeGroups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AttributeValueCommentsArgs = {
  objects: Array<AttributeValueComments_Insert_Input>;
  on_conflict?: InputMaybe<AttributeValueComments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AttributeValueComments_OneArgs = {
  object: AttributeValueComments_Insert_Input;
  on_conflict?: InputMaybe<AttributeValueComments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AttributeValueGroupsArgs = {
  objects: Array<AttributeValueGroups_Insert_Input>;
  on_conflict?: InputMaybe<AttributeValueGroups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AttributeValueGroups_OneArgs = {
  object: AttributeValueGroups_Insert_Input;
  on_conflict?: InputMaybe<AttributeValueGroups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AttributeValueUploadVersionsArgs = {
  objects: Array<AttributeValueUploadVersions_Insert_Input>;
  on_conflict?: InputMaybe<AttributeValueUploadVersions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AttributeValueUploadVersions_OneArgs = {
  object: AttributeValueUploadVersions_Insert_Input;
  on_conflict?: InputMaybe<AttributeValueUploadVersions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AttributeValueUploadsArgs = {
  objects: Array<AttributeValueUploads_Insert_Input>;
  on_conflict?: InputMaybe<AttributeValueUploads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AttributeValueUploads_OneArgs = {
  object: AttributeValueUploads_Insert_Input;
  on_conflict?: InputMaybe<AttributeValueUploads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AttributeValuesArgs = {
  objects: Array<AttributeValues_Insert_Input>;
  on_conflict?: InputMaybe<AttributeValues_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AttributeValues_OneArgs = {
  object: AttributeValues_Insert_Input;
  on_conflict?: InputMaybe<AttributeValues_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AttributesArgs = {
  objects: Array<Attributes_Insert_Input>;
  on_conflict?: InputMaybe<Attributes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Attributes_OneArgs = {
  object: Attributes_Insert_Input;
  on_conflict?: InputMaybe<Attributes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CartLinesArgs = {
  objects: Array<CartLines_Insert_Input>;
  on_conflict?: InputMaybe<CartLines_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CartLines_OneArgs = {
  object: CartLines_Insert_Input;
  on_conflict?: InputMaybe<CartLines_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CartsArgs = {
  objects: Array<Carts_Insert_Input>;
  on_conflict?: InputMaybe<Carts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Carts_OneArgs = {
  object: Carts_Insert_Input;
  on_conflict?: InputMaybe<Carts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CatalogFolderArticlesArgs = {
  objects: Array<CatalogFolderArticles_Insert_Input>;
  on_conflict?: InputMaybe<CatalogFolderArticles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CatalogFolderArticles_OneArgs = {
  object: CatalogFolderArticles_Insert_Input;
  on_conflict?: InputMaybe<CatalogFolderArticles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CatalogFoldersArgs = {
  objects: Array<CatalogFolders_Insert_Input>;
  on_conflict?: InputMaybe<CatalogFolders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CatalogFolders_OneArgs = {
  object: CatalogFolders_Insert_Input;
  on_conflict?: InputMaybe<CatalogFolders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventAttributeGroupsArgs = {
  objects: Array<EventAttributeGroups_Insert_Input>;
  on_conflict?: InputMaybe<EventAttributeGroups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventAttributeGroups_OneArgs = {
  object: EventAttributeGroups_Insert_Input;
  on_conflict?: InputMaybe<EventAttributeGroups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventAttributeValueUploadVersionsArgs = {
  objects: Array<EventAttributeValueUploadVersions_Insert_Input>;
  on_conflict?: InputMaybe<EventAttributeValueUploadVersions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventAttributeValueUploadVersions_OneArgs = {
  object: EventAttributeValueUploadVersions_Insert_Input;
  on_conflict?: InputMaybe<EventAttributeValueUploadVersions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventAttributeValueUploadsArgs = {
  objects: Array<EventAttributeValueUploads_Insert_Input>;
  on_conflict?: InputMaybe<EventAttributeValueUploads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventAttributeValueUploads_OneArgs = {
  object: EventAttributeValueUploads_Insert_Input;
  on_conflict?: InputMaybe<EventAttributeValueUploads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventAttributeValuesArgs = {
  objects: Array<EventAttributeValues_Insert_Input>;
  on_conflict?: InputMaybe<EventAttributeValues_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventAttributeValues_OneArgs = {
  object: EventAttributeValues_Insert_Input;
  on_conflict?: InputMaybe<EventAttributeValues_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventAttributesArgs = {
  objects: Array<EventAttributes_Insert_Input>;
  on_conflict?: InputMaybe<EventAttributes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventAttributes_OneArgs = {
  object: EventAttributes_Insert_Input;
  on_conflict?: InputMaybe<EventAttributes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventFavouritesArgs = {
  objects: Array<EventFavourites_Insert_Input>;
  on_conflict?: InputMaybe<EventFavourites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventFavourites_OneArgs = {
  object: EventFavourites_Insert_Input;
  on_conflict?: InputMaybe<EventFavourites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventOrganisersArgs = {
  objects: Array<EventOrganisers_Insert_Input>;
  on_conflict?: InputMaybe<EventOrganisers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventOrganisers_OneArgs = {
  object: EventOrganisers_Insert_Input;
  on_conflict?: InputMaybe<EventOrganisers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventRoomWatchesArgs = {
  objects: Array<EventRoomWatches_Insert_Input>;
  on_conflict?: InputMaybe<EventRoomWatches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventRoomWatches_OneArgs = {
  object: EventRoomWatches_Insert_Input;
  on_conflict?: InputMaybe<EventRoomWatches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventRoomsArgs = {
  objects: Array<EventRooms_Insert_Input>;
  on_conflict?: InputMaybe<EventRooms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventRooms_OneArgs = {
  object: EventRooms_Insert_Input;
  on_conflict?: InputMaybe<EventRooms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EventsArgs = {
  objects: Array<Events_Insert_Input>;
  on_conflict?: InputMaybe<Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Events_OneArgs = {
  object: Events_Insert_Input;
  on_conflict?: InputMaybe<Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FileMasterVersionsArgs = {
  objects: Array<FileMasterVersions_Insert_Input>;
  on_conflict?: InputMaybe<FileMasterVersions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FileMasterVersions_OneArgs = {
  object: FileMasterVersions_Insert_Input;
  on_conflict?: InputMaybe<FileMasterVersions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FileMastersArgs = {
  objects: Array<FileMasters_Insert_Input>;
  on_conflict?: InputMaybe<FileMasters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FileMasters_OneArgs = {
  object: FileMasters_Insert_Input;
  on_conflict?: InputMaybe<FileMasters_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InfoBoxesArgs = {
  objects: Array<InfoBoxes_Insert_Input>;
  on_conflict?: InputMaybe<InfoBoxes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InfoBoxes_OneArgs = {
  object: InfoBoxes_Insert_Input;
  on_conflict?: InputMaybe<InfoBoxes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InfoNewsArgs = {
  objects: Array<InfoNews_Insert_Input>;
  on_conflict?: InputMaybe<InfoNews_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InfoNews_OneArgs = {
  object: InfoNews_Insert_Input;
  on_conflict?: InputMaybe<InfoNews_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_JaggaerBanfsArgs = {
  objects: Array<JaggaerBanfs_Insert_Input>;
  on_conflict?: InputMaybe<JaggaerBanfs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_JaggaerBanfs_OneArgs = {
  object: JaggaerBanfs_Insert_Input;
  on_conflict?: InputMaybe<JaggaerBanfs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_JaggaerSubmissionsArgs = {
  objects: Array<JaggaerSubmissions_Insert_Input>;
  on_conflict?: InputMaybe<JaggaerSubmissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_JaggaerSubmissions_OneArgs = {
  object: JaggaerSubmissions_Insert_Input;
  on_conflict?: InputMaybe<JaggaerSubmissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NewsArgs = {
  objects: Array<News_Insert_Input>;
  on_conflict?: InputMaybe<News_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_News_OneArgs = {
  object: News_Insert_Input;
  on_conflict?: InputMaybe<News_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NotificationPreferencesArgs = {
  objects: Array<NotificationPreferences_Insert_Input>;
  on_conflict?: InputMaybe<NotificationPreferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NotificationPreferences_OneArgs = {
  object: NotificationPreferences_Insert_Input;
  on_conflict?: InputMaybe<NotificationPreferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NotificationRoomServiceCategoryPreferencesArgs = {
  objects: Array<NotificationRoomServiceCategoryPreferences_Insert_Input>;
  on_conflict?: InputMaybe<NotificationRoomServiceCategoryPreferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NotificationRoomServiceCategoryPreferences_OneArgs = {
  object: NotificationRoomServiceCategoryPreferences_Insert_Input;
  on_conflict?: InputMaybe<NotificationRoomServiceCategoryPreferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NotificationServicePreferencesArgs = {
  objects: Array<NotificationServicePreferences_Insert_Input>;
  on_conflict?: InputMaybe<NotificationServicePreferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NotificationServicePreferences_OneArgs = {
  object: NotificationServicePreferences_Insert_Input;
  on_conflict?: InputMaybe<NotificationServicePreferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrdersArgs = {
  objects: Array<Orders_Insert_Input>;
  on_conflict?: InputMaybe<Orders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Orders_OneArgs = {
  object: Orders_Insert_Input;
  on_conflict?: InputMaybe<Orders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganisationGroupUsersArgs = {
  objects: Array<OrganisationGroupUsers_Insert_Input>;
  on_conflict?: InputMaybe<OrganisationGroupUsers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganisationGroupUsers_OneArgs = {
  object: OrganisationGroupUsers_Insert_Input;
  on_conflict?: InputMaybe<OrganisationGroupUsers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganisationGroupsArgs = {
  objects: Array<OrganisationGroups_Insert_Input>;
  on_conflict?: InputMaybe<OrganisationGroups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganisationGroups_OneArgs = {
  object: OrganisationGroups_Insert_Input;
  on_conflict?: InputMaybe<OrganisationGroups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganisationsArgs = {
  objects: Array<Organisations_Insert_Input>;
  on_conflict?: InputMaybe<Organisations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisations_OneArgs = {
  object: Organisations_Insert_Input;
  on_conflict?: InputMaybe<Organisations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomAttributeFilesArgs = {
  objects: Array<RoomAttributeFiles_Insert_Input>;
  on_conflict?: InputMaybe<RoomAttributeFiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomAttributeFiles_OneArgs = {
  object: RoomAttributeFiles_Insert_Input;
  on_conflict?: InputMaybe<RoomAttributeFiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomAttributeGroupsArgs = {
  objects: Array<RoomAttributeGroups_Insert_Input>;
  on_conflict?: InputMaybe<RoomAttributeGroups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomAttributeGroups_OneArgs = {
  object: RoomAttributeGroups_Insert_Input;
  on_conflict?: InputMaybe<RoomAttributeGroups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomAttributeValueCommentsArgs = {
  objects: Array<RoomAttributeValueComments_Insert_Input>;
  on_conflict?: InputMaybe<RoomAttributeValueComments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomAttributeValueComments_OneArgs = {
  object: RoomAttributeValueComments_Insert_Input;
  on_conflict?: InputMaybe<RoomAttributeValueComments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomAttributeValueGroupsArgs = {
  objects: Array<RoomAttributeValueGroups_Insert_Input>;
  on_conflict?: InputMaybe<RoomAttributeValueGroups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomAttributeValueGroups_OneArgs = {
  object: RoomAttributeValueGroups_Insert_Input;
  on_conflict?: InputMaybe<RoomAttributeValueGroups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomAttributeValueUploadVersionsArgs = {
  objects: Array<RoomAttributeValueUploadVersions_Insert_Input>;
  on_conflict?: InputMaybe<RoomAttributeValueUploadVersions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomAttributeValueUploadVersions_OneArgs = {
  object: RoomAttributeValueUploadVersions_Insert_Input;
  on_conflict?: InputMaybe<RoomAttributeValueUploadVersions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomAttributeValueUploadsArgs = {
  objects: Array<RoomAttributeValueUploads_Insert_Input>;
  on_conflict?: InputMaybe<RoomAttributeValueUploads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomAttributeValueUploads_OneArgs = {
  object: RoomAttributeValueUploads_Insert_Input;
  on_conflict?: InputMaybe<RoomAttributeValueUploads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomAttributeValuesArgs = {
  objects: Array<RoomAttributeValues_Insert_Input>;
  on_conflict?: InputMaybe<RoomAttributeValues_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomAttributeValues_For_CommentsArgs = {
  objects: Array<RoomAttributeValues_For_Comments_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_RoomAttributeValues_For_Comments_OneArgs = {
  object: RoomAttributeValues_For_Comments_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_RoomAttributeValues_OneArgs = {
  object: RoomAttributeValues_Insert_Input;
  on_conflict?: InputMaybe<RoomAttributeValues_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomAttributesArgs = {
  objects: Array<RoomAttributes_Insert_Input>;
  on_conflict?: InputMaybe<RoomAttributes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomAttributes_OneArgs = {
  object: RoomAttributes_Insert_Input;
  on_conflict?: InputMaybe<RoomAttributes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomFoldersArgs = {
  objects: Array<RoomFolders_Insert_Input>;
  on_conflict?: InputMaybe<RoomFolders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomFolders_OneArgs = {
  object: RoomFolders_Insert_Input;
  on_conflict?: InputMaybe<RoomFolders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomOccurrencesArgs = {
  objects: Array<RoomOccurrences_Insert_Input>;
  on_conflict?: InputMaybe<RoomOccurrences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomOccurrences_OneArgs = {
  object: RoomOccurrences_Insert_Input;
  on_conflict?: InputMaybe<RoomOccurrences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomServiceCategoriesArgs = {
  objects: Array<RoomServiceCategories_Insert_Input>;
  on_conflict?: InputMaybe<RoomServiceCategories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomServiceCategories_OneArgs = {
  object: RoomServiceCategories_Insert_Input;
  on_conflict?: InputMaybe<RoomServiceCategories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomServiceOccurrencesArgs = {
  objects: Array<RoomServiceOccurrences_Insert_Input>;
  on_conflict?: InputMaybe<RoomServiceOccurrences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomServiceOccurrences_OneArgs = {
  object: RoomServiceOccurrences_Insert_Input;
  on_conflict?: InputMaybe<RoomServiceOccurrences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomServiceOrganisationAccessesArgs = {
  objects: Array<RoomServiceOrganisationAccesses_Insert_Input>;
  on_conflict?: InputMaybe<RoomServiceOrganisationAccesses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomServiceOrganisationAccesses_OneArgs = {
  object: RoomServiceOrganisationAccesses_Insert_Input;
  on_conflict?: InputMaybe<RoomServiceOrganisationAccesses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomServicesArgs = {
  objects: Array<RoomServices_Insert_Input>;
  on_conflict?: InputMaybe<RoomServices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomServices_OneArgs = {
  object: RoomServices_Insert_Input;
  on_conflict?: InputMaybe<RoomServices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoomsArgs = {
  objects: Array<Rooms_Insert_Input>;
  on_conflict?: InputMaybe<Rooms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Rooms_OneArgs = {
  object: Rooms_Insert_Input;
  on_conflict?: InputMaybe<Rooms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceBundleServicesArgs = {
  objects: Array<ServiceBundleServices_Insert_Input>;
  on_conflict?: InputMaybe<ServiceBundleServices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceBundleServices_OneArgs = {
  object: ServiceBundleServices_Insert_Input;
  on_conflict?: InputMaybe<ServiceBundleServices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceBundlesArgs = {
  objects: Array<ServiceBundles_Insert_Input>;
  on_conflict?: InputMaybe<ServiceBundles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceBundles_OneArgs = {
  object: ServiceBundles_Insert_Input;
  on_conflict?: InputMaybe<ServiceBundles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceFavouritesArgs = {
  objects: Array<ServiceFavourites_Insert_Input>;
  on_conflict?: InputMaybe<ServiceFavourites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceFavourites_OneArgs = {
  object: ServiceFavourites_Insert_Input;
  on_conflict?: InputMaybe<ServiceFavourites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceModuleAccessesArgs = {
  objects: Array<ServiceModuleAccesses_Insert_Input>;
  on_conflict?: InputMaybe<ServiceModuleAccesses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceModuleAccesses_OneArgs = {
  object: ServiceModuleAccesses_Insert_Input;
  on_conflict?: InputMaybe<ServiceModuleAccesses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceModulesArgs = {
  objects: Array<ServiceModules_Insert_Input>;
  on_conflict?: InputMaybe<ServiceModules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceModules_OneArgs = {
  object: ServiceModules_Insert_Input;
  on_conflict?: InputMaybe<ServiceModules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceOrganisationAccessesArgs = {
  objects: Array<ServiceOrganisationAccesses_Insert_Input>;
  on_conflict?: InputMaybe<ServiceOrganisationAccesses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServiceOrganisationAccesses_OneArgs = {
  object: ServiceOrganisationAccesses_Insert_Input;
  on_conflict?: InputMaybe<ServiceOrganisationAccesses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ServicesArgs = {
  objects: Array<Services_Insert_Input>;
  on_conflict?: InputMaybe<Services_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Services_OneArgs = {
  object: Services_Insert_Input;
  on_conflict?: InputMaybe<Services_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UploadCommentsArgs = {
  objects: Array<UploadComments_Insert_Input>;
  on_conflict?: InputMaybe<UploadComments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UploadComments_OneArgs = {
  object: UploadComments_Insert_Input;
  on_conflict?: InputMaybe<UploadComments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UploadVersionsArgs = {
  objects: Array<UploadVersions_Insert_Input>;
  on_conflict?: InputMaybe<UploadVersions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UploadVersions_OneArgs = {
  object: UploadVersions_Insert_Input;
  on_conflict?: InputMaybe<UploadVersions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UploadsArgs = {
  objects: Array<Uploads_Insert_Input>;
  on_conflict?: InputMaybe<Uploads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Uploads_OneArgs = {
  object: Uploads_Insert_Input;
  on_conflict?: InputMaybe<Uploads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserAttributeValuesArgs = {
  objects: Array<UserAttributeValues_Insert_Input>;
  on_conflict?: InputMaybe<UserAttributeValues_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserAttributeValues_OneArgs = {
  object: UserAttributeValues_Insert_Input;
  on_conflict?: InputMaybe<UserAttributeValues_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserAttributesArgs = {
  objects: Array<UserAttributes_Insert_Input>;
  on_conflict?: InputMaybe<UserAttributes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserAttributes_OneArgs = {
  object: UserAttributes_Insert_Input;
  on_conflict?: InputMaybe<UserAttributes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserDataRoomOccurrencesArgs = {
  objects: Array<UserDataRoomOccurrences_Insert_Input>;
  on_conflict?: InputMaybe<UserDataRoomOccurrences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserDataRoomOccurrences_OneArgs = {
  object: UserDataRoomOccurrences_Insert_Input;
  on_conflict?: InputMaybe<UserDataRoomOccurrences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserDataRoomServiceOccurrencesArgs = {
  objects: Array<UserDataRoomServiceOccurrences_Insert_Input>;
  on_conflict?: InputMaybe<UserDataRoomServiceOccurrences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserDataRoomServiceOccurrences_OneArgs = {
  object: UserDataRoomServiceOccurrences_Insert_Input;
  on_conflict?: InputMaybe<UserDataRoomServiceOccurrences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserDataServicesArgs = {
  objects: Array<UserDataServices_Insert_Input>;
  on_conflict?: InputMaybe<UserDataServices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserDataServices_OneArgs = {
  object: UserDataServices_Insert_Input;
  on_conflict?: InputMaybe<UserDataServices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserRoomServiceOccurrenceLastVisitsArgs = {
  objects: Array<UserRoomServiceOccurrenceLastVisits_Insert_Input>;
  on_conflict?: InputMaybe<UserRoomServiceOccurrenceLastVisits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserRoomServiceOccurrenceLastVisits_OneArgs = {
  object: UserRoomServiceOccurrenceLastVisits_Insert_Input;
  on_conflict?: InputMaybe<UserRoomServiceOccurrenceLastVisits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserServiceModuleLastVisitsArgs = {
  objects: Array<UserServiceModuleLastVisits_Insert_Input>;
  on_conflict?: InputMaybe<UserServiceModuleLastVisits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UserServiceModuleLastVisits_OneArgs = {
  object: UserServiceModuleLastVisits_Insert_Input;
  on_conflict?: InputMaybe<UserServiceModuleLastVisits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSetPasswordArgs = {
  ownPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};


/** mutation root */
export type Mutation_RootUpdate_ArticlesArgs = {
  _inc?: InputMaybe<Articles_Inc_Input>;
  _set?: InputMaybe<Articles_Set_Input>;
  where: Articles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Articles_By_PkArgs = {
  _inc?: InputMaybe<Articles_Inc_Input>;
  _set?: InputMaybe<Articles_Set_Input>;
  pk_columns: Articles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Articles_ManyArgs = {
  updates: Array<Articles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AttributeGroupsArgs = {
  _inc?: InputMaybe<AttributeGroups_Inc_Input>;
  _set?: InputMaybe<AttributeGroups_Set_Input>;
  where: AttributeGroups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_AttributeGroups_By_PkArgs = {
  _inc?: InputMaybe<AttributeGroups_Inc_Input>;
  _set?: InputMaybe<AttributeGroups_Set_Input>;
  pk_columns: AttributeGroups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_AttributeGroups_ManyArgs = {
  updates: Array<AttributeGroups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AttributeValueCommentsArgs = {
  _inc?: InputMaybe<AttributeValueComments_Inc_Input>;
  _set?: InputMaybe<AttributeValueComments_Set_Input>;
  where: AttributeValueComments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_AttributeValueComments_By_PkArgs = {
  _inc?: InputMaybe<AttributeValueComments_Inc_Input>;
  _set?: InputMaybe<AttributeValueComments_Set_Input>;
  pk_columns: AttributeValueComments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_AttributeValueComments_ManyArgs = {
  updates: Array<AttributeValueComments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AttributeValueUploadsArgs = {
  _set?: InputMaybe<AttributeValueUploads_Set_Input>;
  where: AttributeValueUploads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_AttributeValueUploads_By_PkArgs = {
  _set?: InputMaybe<AttributeValueUploads_Set_Input>;
  pk_columns: AttributeValueUploads_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_AttributeValueUploads_ManyArgs = {
  updates: Array<AttributeValueUploads_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AttributeValuesArgs = {
  _inc?: InputMaybe<AttributeValues_Inc_Input>;
  _set?: InputMaybe<AttributeValues_Set_Input>;
  where: AttributeValues_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_AttributeValues_By_PkArgs = {
  _inc?: InputMaybe<AttributeValues_Inc_Input>;
  _set?: InputMaybe<AttributeValues_Set_Input>;
  pk_columns: AttributeValues_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_AttributeValues_ManyArgs = {
  updates: Array<AttributeValues_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AttributesArgs = {
  _inc?: InputMaybe<Attributes_Inc_Input>;
  _set?: InputMaybe<Attributes_Set_Input>;
  where: Attributes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Attributes_By_PkArgs = {
  _inc?: InputMaybe<Attributes_Inc_Input>;
  _set?: InputMaybe<Attributes_Set_Input>;
  pk_columns: Attributes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Attributes_ManyArgs = {
  updates: Array<Attributes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CartLinesArgs = {
  _inc?: InputMaybe<CartLines_Inc_Input>;
  _set?: InputMaybe<CartLines_Set_Input>;
  where: CartLines_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_CartLines_By_PkArgs = {
  _inc?: InputMaybe<CartLines_Inc_Input>;
  _set?: InputMaybe<CartLines_Set_Input>;
  pk_columns: CartLines_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CartLines_ManyArgs = {
  updates: Array<CartLines_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CartsArgs = {
  _set?: InputMaybe<Carts_Set_Input>;
  where: Carts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Carts_By_PkArgs = {
  _set?: InputMaybe<Carts_Set_Input>;
  pk_columns: Carts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Carts_ManyArgs = {
  updates: Array<Carts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CatalogFoldersArgs = {
  _inc?: InputMaybe<CatalogFolders_Inc_Input>;
  _set?: InputMaybe<CatalogFolders_Set_Input>;
  where: CatalogFolders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_CatalogFolders_By_PkArgs = {
  _inc?: InputMaybe<CatalogFolders_Inc_Input>;
  _set?: InputMaybe<CatalogFolders_Set_Input>;
  pk_columns: CatalogFolders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CatalogFolders_ManyArgs = {
  updates: Array<CatalogFolders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventAttributeGroupsArgs = {
  _inc?: InputMaybe<EventAttributeGroups_Inc_Input>;
  _set?: InputMaybe<EventAttributeGroups_Set_Input>;
  where: EventAttributeGroups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EventAttributeGroups_By_PkArgs = {
  _inc?: InputMaybe<EventAttributeGroups_Inc_Input>;
  _set?: InputMaybe<EventAttributeGroups_Set_Input>;
  pk_columns: EventAttributeGroups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EventAttributeGroups_ManyArgs = {
  updates: Array<EventAttributeGroups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventAttributeValueUploadsArgs = {
  _set?: InputMaybe<EventAttributeValueUploads_Set_Input>;
  where: EventAttributeValueUploads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EventAttributeValueUploads_By_PkArgs = {
  _set?: InputMaybe<EventAttributeValueUploads_Set_Input>;
  pk_columns: EventAttributeValueUploads_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EventAttributeValueUploads_ManyArgs = {
  updates: Array<EventAttributeValueUploads_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventAttributeValuesArgs = {
  _set?: InputMaybe<EventAttributeValues_Set_Input>;
  where: EventAttributeValues_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EventAttributeValues_By_PkArgs = {
  _set?: InputMaybe<EventAttributeValues_Set_Input>;
  pk_columns: EventAttributeValues_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EventAttributeValues_ManyArgs = {
  updates: Array<EventAttributeValues_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventAttributesArgs = {
  _inc?: InputMaybe<EventAttributes_Inc_Input>;
  _set?: InputMaybe<EventAttributes_Set_Input>;
  where: EventAttributes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EventAttributes_By_PkArgs = {
  _inc?: InputMaybe<EventAttributes_Inc_Input>;
  _set?: InputMaybe<EventAttributes_Set_Input>;
  pk_columns: EventAttributes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EventAttributes_ManyArgs = {
  updates: Array<EventAttributes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventFavouritesArgs = {
  where: EventFavourites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EventFavourites_By_PkArgs = {
  pk_columns: EventFavourites_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EventFavourites_ManyArgs = {
  updates: Array<EventFavourites_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventRoomWatchesArgs = {
  where: EventRoomWatches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EventRoomWatches_By_PkArgs = {
  pk_columns: EventRoomWatches_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EventRoomWatches_ManyArgs = {
  updates: Array<EventRoomWatches_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventRoomsArgs = {
  _set?: InputMaybe<EventRooms_Set_Input>;
  where: EventRooms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_EventRooms_By_PkArgs = {
  _set?: InputMaybe<EventRooms_Set_Input>;
  pk_columns: EventRooms_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_EventRooms_ManyArgs = {
  updates: Array<EventRooms_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EventsArgs = {
  _inc?: InputMaybe<Events_Inc_Input>;
  _set?: InputMaybe<Events_Set_Input>;
  where: Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Events_By_PkArgs = {
  _inc?: InputMaybe<Events_Inc_Input>;
  _set?: InputMaybe<Events_Set_Input>;
  pk_columns: Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Events_ManyArgs = {
  updates: Array<Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FileMastersArgs = {
  _set?: InputMaybe<FileMasters_Set_Input>;
  where: FileMasters_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_FileMasters_By_PkArgs = {
  _set?: InputMaybe<FileMasters_Set_Input>;
  pk_columns: FileMasters_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_FileMasters_ManyArgs = {
  updates: Array<FileMasters_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FilesArgs = {
  _inc?: InputMaybe<Files_Inc_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Files_By_PkArgs = {
  _inc?: InputMaybe<Files_Inc_Input>;
  _set?: InputMaybe<Files_Set_Input>;
  pk_columns: Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Files_ManyArgs = {
  updates: Array<Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InfoBoxesArgs = {
  _set?: InputMaybe<InfoBoxes_Set_Input>;
  where: InfoBoxes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_InfoBoxes_By_PkArgs = {
  _set?: InputMaybe<InfoBoxes_Set_Input>;
  pk_columns: InfoBoxes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_InfoBoxes_ManyArgs = {
  updates: Array<InfoBoxes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InfoNewsArgs = {
  _set?: InputMaybe<InfoNews_Set_Input>;
  where: InfoNews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_InfoNews_By_PkArgs = {
  _set?: InputMaybe<InfoNews_Set_Input>;
  pk_columns: InfoNews_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_InfoNews_ManyArgs = {
  updates: Array<InfoNews_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationMessagesArgs = {
  _set?: InputMaybe<NotificationMessages_Set_Input>;
  where: NotificationMessages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationMessages_By_PkArgs = {
  _set?: InputMaybe<NotificationMessages_Set_Input>;
  pk_columns: NotificationMessages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationMessages_ManyArgs = {
  updates: Array<NotificationMessages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationPreferencesArgs = {
  where: NotificationPreferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationPreferences_By_PkArgs = {
  pk_columns: NotificationPreferences_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationPreferences_ManyArgs = {
  updates: Array<NotificationPreferences_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrdersArgs = {
  _set?: InputMaybe<Orders_Set_Input>;
  where: Orders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Orders_By_PkArgs = {
  _set?: InputMaybe<Orders_Set_Input>;
  pk_columns: Orders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Orders_ManyArgs = {
  updates: Array<Orders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganisationGroupsArgs = {
  _set?: InputMaybe<OrganisationGroups_Set_Input>;
  where: OrganisationGroups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_OrganisationGroups_By_PkArgs = {
  _set?: InputMaybe<OrganisationGroups_Set_Input>;
  pk_columns: OrganisationGroups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_OrganisationGroups_ManyArgs = {
  updates: Array<OrganisationGroups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganisationsArgs = {
  _set?: InputMaybe<Organisations_Set_Input>;
  where: Organisations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisations_By_PkArgs = {
  _set?: InputMaybe<Organisations_Set_Input>;
  pk_columns: Organisations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisations_ManyArgs = {
  updates: Array<Organisations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RoomAttributeGroupsArgs = {
  _inc?: InputMaybe<RoomAttributeGroups_Inc_Input>;
  _set?: InputMaybe<RoomAttributeGroups_Set_Input>;
  where: RoomAttributeGroups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_RoomAttributeGroups_By_PkArgs = {
  _inc?: InputMaybe<RoomAttributeGroups_Inc_Input>;
  _set?: InputMaybe<RoomAttributeGroups_Set_Input>;
  pk_columns: RoomAttributeGroups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RoomAttributeGroups_ManyArgs = {
  updates: Array<RoomAttributeGroups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RoomAttributeValueCommentsArgs = {
  _inc?: InputMaybe<RoomAttributeValueComments_Inc_Input>;
  _set?: InputMaybe<RoomAttributeValueComments_Set_Input>;
  where: RoomAttributeValueComments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_RoomAttributeValueComments_By_PkArgs = {
  _inc?: InputMaybe<RoomAttributeValueComments_Inc_Input>;
  _set?: InputMaybe<RoomAttributeValueComments_Set_Input>;
  pk_columns: RoomAttributeValueComments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RoomAttributeValueComments_ManyArgs = {
  updates: Array<RoomAttributeValueComments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RoomAttributeValueUploadsArgs = {
  _set?: InputMaybe<RoomAttributeValueUploads_Set_Input>;
  where: RoomAttributeValueUploads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_RoomAttributeValueUploads_By_PkArgs = {
  _set?: InputMaybe<RoomAttributeValueUploads_Set_Input>;
  pk_columns: RoomAttributeValueUploads_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RoomAttributeValueUploads_ManyArgs = {
  updates: Array<RoomAttributeValueUploads_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RoomAttributeValuesArgs = {
  _set?: InputMaybe<RoomAttributeValues_Set_Input>;
  where: RoomAttributeValues_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_RoomAttributeValues_By_PkArgs = {
  _set?: InputMaybe<RoomAttributeValues_Set_Input>;
  pk_columns: RoomAttributeValues_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RoomAttributeValues_ManyArgs = {
  updates: Array<RoomAttributeValues_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RoomAttributesArgs = {
  _inc?: InputMaybe<RoomAttributes_Inc_Input>;
  _set?: InputMaybe<RoomAttributes_Set_Input>;
  where: RoomAttributes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_RoomAttributes_By_PkArgs = {
  _inc?: InputMaybe<RoomAttributes_Inc_Input>;
  _set?: InputMaybe<RoomAttributes_Set_Input>;
  pk_columns: RoomAttributes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RoomAttributes_ManyArgs = {
  updates: Array<RoomAttributes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RoomFoldersArgs = {
  _inc?: InputMaybe<RoomFolders_Inc_Input>;
  _set?: InputMaybe<RoomFolders_Set_Input>;
  where: RoomFolders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_RoomFolders_By_PkArgs = {
  _inc?: InputMaybe<RoomFolders_Inc_Input>;
  _set?: InputMaybe<RoomFolders_Set_Input>;
  pk_columns: RoomFolders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RoomFolders_ManyArgs = {
  updates: Array<RoomFolders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RoomOccurrencesArgs = {
  _inc?: InputMaybe<RoomOccurrences_Inc_Input>;
  _set?: InputMaybe<RoomOccurrences_Set_Input>;
  where: RoomOccurrences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_RoomOccurrences_By_PkArgs = {
  _inc?: InputMaybe<RoomOccurrences_Inc_Input>;
  _set?: InputMaybe<RoomOccurrences_Set_Input>;
  pk_columns: RoomOccurrences_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RoomOccurrences_ManyArgs = {
  updates: Array<RoomOccurrences_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RoomServiceCategoriesArgs = {
  _set?: InputMaybe<RoomServiceCategories_Set_Input>;
  where: RoomServiceCategories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_RoomServiceCategories_By_PkArgs = {
  _set?: InputMaybe<RoomServiceCategories_Set_Input>;
  pk_columns: RoomServiceCategories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RoomServiceCategories_ManyArgs = {
  updates: Array<RoomServiceCategories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RoomServiceOccurrencesArgs = {
  _set?: InputMaybe<RoomServiceOccurrences_Set_Input>;
  where: RoomServiceOccurrences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_RoomServiceOccurrences_By_PkArgs = {
  _set?: InputMaybe<RoomServiceOccurrences_Set_Input>;
  pk_columns: RoomServiceOccurrences_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RoomServiceOccurrences_ManyArgs = {
  updates: Array<RoomServiceOccurrences_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RoomServiceOrganisationAccessesArgs = {
  _set?: InputMaybe<RoomServiceOrganisationAccesses_Set_Input>;
  where: RoomServiceOrganisationAccesses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_RoomServiceOrganisationAccesses_By_PkArgs = {
  _set?: InputMaybe<RoomServiceOrganisationAccesses_Set_Input>;
  pk_columns: RoomServiceOrganisationAccesses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RoomServiceOrganisationAccesses_ManyArgs = {
  updates: Array<RoomServiceOrganisationAccesses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RoomServicesArgs = {
  _inc?: InputMaybe<RoomServices_Inc_Input>;
  _set?: InputMaybe<RoomServices_Set_Input>;
  where: RoomServices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_RoomServices_By_PkArgs = {
  _inc?: InputMaybe<RoomServices_Inc_Input>;
  _set?: InputMaybe<RoomServices_Set_Input>;
  pk_columns: RoomServices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_RoomServices_ManyArgs = {
  updates: Array<RoomServices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RoomsArgs = {
  _inc?: InputMaybe<Rooms_Inc_Input>;
  _set?: InputMaybe<Rooms_Set_Input>;
  where: Rooms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Rooms_By_PkArgs = {
  _inc?: InputMaybe<Rooms_Inc_Input>;
  _set?: InputMaybe<Rooms_Set_Input>;
  pk_columns: Rooms_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Rooms_ManyArgs = {
  updates: Array<Rooms_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceBundlesArgs = {
  _set?: InputMaybe<ServiceBundles_Set_Input>;
  where: ServiceBundles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceBundles_By_PkArgs = {
  _set?: InputMaybe<ServiceBundles_Set_Input>;
  pk_columns: ServiceBundles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceBundles_ManyArgs = {
  updates: Array<ServiceBundles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceFavouritesArgs = {
  where: ServiceFavourites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceFavourites_By_PkArgs = {
  pk_columns: ServiceFavourites_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceFavourites_ManyArgs = {
  updates: Array<ServiceFavourites_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceModuleAccessesArgs = {
  _set?: InputMaybe<ServiceModuleAccesses_Set_Input>;
  where: ServiceModuleAccesses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceModuleAccesses_By_PkArgs = {
  _set?: InputMaybe<ServiceModuleAccesses_Set_Input>;
  pk_columns: ServiceModuleAccesses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceModuleAccesses_ManyArgs = {
  updates: Array<ServiceModuleAccesses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceModulesArgs = {
  _inc?: InputMaybe<ServiceModules_Inc_Input>;
  _set?: InputMaybe<ServiceModules_Set_Input>;
  where: ServiceModules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceModules_By_PkArgs = {
  _inc?: InputMaybe<ServiceModules_Inc_Input>;
  _set?: InputMaybe<ServiceModules_Set_Input>;
  pk_columns: ServiceModules_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceModules_ManyArgs = {
  updates: Array<ServiceModules_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceOrganisationAccessesArgs = {
  _set?: InputMaybe<ServiceOrganisationAccesses_Set_Input>;
  where: ServiceOrganisationAccesses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceOrganisationAccesses_By_PkArgs = {
  _set?: InputMaybe<ServiceOrganisationAccesses_Set_Input>;
  pk_columns: ServiceOrganisationAccesses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ServiceOrganisationAccesses_ManyArgs = {
  updates: Array<ServiceOrganisationAccesses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ServicesArgs = {
  _set?: InputMaybe<Services_Set_Input>;
  where: Services_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Services_By_PkArgs = {
  _set?: InputMaybe<Services_Set_Input>;
  pk_columns: Services_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Services_ManyArgs = {
  updates: Array<Services_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Test1Args = {
  _inc?: InputMaybe<Test1_Inc_Input>;
  _set?: InputMaybe<Test1_Set_Input>;
  where: Test1_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Test1_ManyArgs = {
  updates: Array<Test1_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UploadCommentsArgs = {
  _inc?: InputMaybe<UploadComments_Inc_Input>;
  _set?: InputMaybe<UploadComments_Set_Input>;
  where: UploadComments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UploadComments_By_PkArgs = {
  _inc?: InputMaybe<UploadComments_Inc_Input>;
  _set?: InputMaybe<UploadComments_Set_Input>;
  pk_columns: UploadComments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UploadComments_ManyArgs = {
  updates: Array<UploadComments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UploadsArgs = {
  _set?: InputMaybe<Uploads_Set_Input>;
  where: Uploads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Uploads_By_PkArgs = {
  _set?: InputMaybe<Uploads_Set_Input>;
  pk_columns: Uploads_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Uploads_ManyArgs = {
  updates: Array<Uploads_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserAttributeValuesArgs = {
  _set?: InputMaybe<UserAttributeValues_Set_Input>;
  where: UserAttributeValues_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserAttributeValues_By_PkArgs = {
  _set?: InputMaybe<UserAttributeValues_Set_Input>;
  pk_columns: UserAttributeValues_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserAttributeValues_ManyArgs = {
  updates: Array<UserAttributeValues_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserAttributesArgs = {
  _set?: InputMaybe<UserAttributes_Set_Input>;
  where: UserAttributes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserAttributes_By_PkArgs = {
  _set?: InputMaybe<UserAttributes_Set_Input>;
  pk_columns: UserAttributes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserAttributes_ManyArgs = {
  updates: Array<UserAttributes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserDataRoomOccurrencesArgs = {
  _set?: InputMaybe<UserDataRoomOccurrences_Set_Input>;
  where: UserDataRoomOccurrences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserDataRoomOccurrences_By_PkArgs = {
  _set?: InputMaybe<UserDataRoomOccurrences_Set_Input>;
  pk_columns: UserDataRoomOccurrences_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserDataRoomOccurrences_ManyArgs = {
  updates: Array<UserDataRoomOccurrences_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserDataRoomServiceOccurrencesArgs = {
  _set?: InputMaybe<UserDataRoomServiceOccurrences_Set_Input>;
  where: UserDataRoomServiceOccurrences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserDataRoomServiceOccurrences_By_PkArgs = {
  _set?: InputMaybe<UserDataRoomServiceOccurrences_Set_Input>;
  pk_columns: UserDataRoomServiceOccurrences_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserDataRoomServiceOccurrences_ManyArgs = {
  updates: Array<UserDataRoomServiceOccurrences_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserDataServicesArgs = {
  _set?: InputMaybe<UserDataServices_Set_Input>;
  where: UserDataServices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserDataServices_By_PkArgs = {
  _set?: InputMaybe<UserDataServices_Set_Input>;
  pk_columns: UserDataServices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserDataServices_ManyArgs = {
  updates: Array<UserDataServices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserRoomServiceOccurrenceLastVisitsArgs = {
  _set?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Set_Input>;
  where: UserRoomServiceOccurrenceLastVisits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserRoomServiceOccurrenceLastVisits_By_PkArgs = {
  _set?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Set_Input>;
  pk_columns: UserRoomServiceOccurrenceLastVisits_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserRoomServiceOccurrenceLastVisits_ManyArgs = {
  updates: Array<UserRoomServiceOccurrenceLastVisits_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserServiceModuleLastVisitsArgs = {
  _set?: InputMaybe<UserServiceModuleLastVisits_Set_Input>;
  where: UserServiceModuleLastVisits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserServiceModuleLastVisits_By_PkArgs = {
  _set?: InputMaybe<UserServiceModuleLastVisits_Set_Input>;
  pk_columns: UserServiceModuleLastVisits_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UserServiceModuleLastVisits_ManyArgs = {
  updates: Array<UserServiceModuleLastVisits_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserSettingsArgs = {
  _inc?: InputMaybe<UserSettings_Inc_Input>;
  _set?: InputMaybe<UserSettings_Set_Input>;
  where: UserSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UserSettings_ManyArgs = {
  updates: Array<UserSettings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};

/** columns and relationships of "news" */
export type News = {
  __typename?: 'news';
  content: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  createdBy?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  fullUser?: Maybe<Users>;
  title: Scalars['String']['output'];
  /** An object relationship */
  user?: Maybe<AllUsers>;
};

/** Boolean expression to filter rows from the table "news". All fields are combined with a logical 'AND'. */
export type News_Bool_Exp = {
  _and?: InputMaybe<Array<News_Bool_Exp>>;
  _not?: InputMaybe<News_Bool_Exp>;
  _or?: InputMaybe<Array<News_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<Bigint_Comparison_Exp>;
  fullUser?: InputMaybe<Users_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<AllUsers_Bool_Exp>;
};

/** unique or primary key constraints on table "news" */
export enum News_Constraint {
  /** unique or primary key constraint on columns "isLatest" */
  NewsIsLatestKey = 'news_isLatest_key',
  /** unique or primary key constraint on columns "id" */
  NewsPkey = 'news_pkey'
}

/** input type for inserting data into table "news" */
export type News_Insert_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  fullUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "news" */
export type News_Mutation_Response = {
  __typename?: 'news_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<News>;
};

/** on_conflict condition type for table "news" */
export type News_On_Conflict = {
  constraint: News_Constraint;
  update_columns?: Array<News_Update_Column>;
  where?: InputMaybe<News_Bool_Exp>;
};

/** Ordering options when selecting data from "news". */
export type News_Order_By = {
  content?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  fullUser?: InputMaybe<Users_Order_By>;
  title?: InputMaybe<Order_By>;
  user?: InputMaybe<AllUsers_Order_By>;
};

/** select columns of table "news" */
export enum News_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Title = 'title'
}

/** Streaming cursor of the table "news" */
export type News_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: News_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type News_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Scalars['bigint']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** placeholder for update columns of table "news" (current role has no relevant permissions) */
export enum News_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

/** columns and relationships of "notificationActions" */
export type NotificationActions = {
  __typename?: 'notificationActions';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  notificationPreferences: Array<NotificationPreferences>;
  /** An aggregate relationship */
  notificationPreferences_aggregate: NotificationPreferences_Aggregate;
  /** An object relationship */
  notificationTemplate?: Maybe<NotificationTemplates>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
};


/** columns and relationships of "notificationActions" */
export type NotificationActionsNotificationPreferencesArgs = {
  distinct_on?: InputMaybe<Array<NotificationPreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationPreferences_Order_By>>;
  where?: InputMaybe<NotificationPreferences_Bool_Exp>;
};


/** columns and relationships of "notificationActions" */
export type NotificationActionsNotificationPreferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationPreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationPreferences_Order_By>>;
  where?: InputMaybe<NotificationPreferences_Bool_Exp>;
};


/** columns and relationships of "notificationActions" */
export type NotificationActionsNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "notificationActions" */
export type NotificationActionsNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** aggregated selection of "notificationActions" */
export type NotificationActions_Aggregate = {
  __typename?: 'notificationActions_aggregate';
  aggregate?: Maybe<NotificationActions_Aggregate_Fields>;
  nodes: Array<NotificationActions>;
};

/** aggregate fields of "notificationActions" */
export type NotificationActions_Aggregate_Fields = {
  __typename?: 'notificationActions_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<NotificationActions_Max_Fields>;
  min?: Maybe<NotificationActions_Min_Fields>;
};


/** aggregate fields of "notificationActions" */
export type NotificationActions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationActions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "notificationActions". All fields are combined with a logical 'AND'. */
export type NotificationActions_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationActions_Bool_Exp>>;
  _not?: InputMaybe<NotificationActions_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationActions_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notificationPreferences?: InputMaybe<NotificationPreferences_Bool_Exp>;
  notificationPreferences_aggregate?: InputMaybe<NotificationPreferences_Aggregate_Bool_Exp>;
  notificationTemplate?: InputMaybe<NotificationTemplates_Bool_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Bool_Exp>;
};

export enum NotificationActions_Enum {
  Comment = 'comment',
  CommentAuthoredReply = 'commentAuthoredReply',
  CommentMentionGroup = 'commentMentionGroup',
  CommentMentionOrganisation = 'commentMentionOrganisation',
  CommentMentionUser = 'commentMentionUser',
  EventAttributeValueChange = 'eventAttributeValueChange',
  EventCanceled = 'eventCanceled',
  EventCreated = 'eventCreated',
  EventUncanceled = 'eventUncanceled',
  JaggaerSubmissionFailure = 'jaggaerSubmissionFailure',
  JaggaerSubmissionSuccess = 'jaggaerSubmissionSuccess',
  RoomOccurrenceChange = 'roomOccurrenceChange',
  RoomServiceOccurrenceChange = 'roomServiceOccurrenceChange',
  ServiceModuleChange = 'serviceModuleChange',
  ServiceModulePublish = 'serviceModulePublish'
}

/** Boolean expression to compare columns of type "notificationActions_enum". All fields are combined with logical 'AND'. */
export type NotificationActions_Enum_Comparison_Exp = {
  _eq?: InputMaybe<NotificationActions_Enum>;
  _in?: InputMaybe<Array<NotificationActions_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<NotificationActions_Enum>;
  _nin?: InputMaybe<Array<NotificationActions_Enum>>;
};

/** aggregate max on columns */
export type NotificationActions_Max_Fields = {
  __typename?: 'notificationActions_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type NotificationActions_Min_Fields = {
  __typename?: 'notificationActions_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "notificationActions". */
export type NotificationActions_Order_By = {
  description?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notificationPreferences_aggregate?: InputMaybe<NotificationPreferences_Aggregate_Order_By>;
  notificationTemplate?: InputMaybe<NotificationTemplates_Order_By>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
};

/** select columns of table "notificationActions" */
export enum NotificationActions_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "notificationActions" */
export type NotificationActions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: NotificationActions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationActions_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "notificationCadences" */
export type NotificationCadences = {
  __typename?: 'notificationCadences';
  name: Scalars['String']['output'];
};

/** aggregated selection of "notificationCadences" */
export type NotificationCadences_Aggregate = {
  __typename?: 'notificationCadences_aggregate';
  aggregate?: Maybe<NotificationCadences_Aggregate_Fields>;
  nodes: Array<NotificationCadences>;
};

/** aggregate fields of "notificationCadences" */
export type NotificationCadences_Aggregate_Fields = {
  __typename?: 'notificationCadences_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<NotificationCadences_Max_Fields>;
  min?: Maybe<NotificationCadences_Min_Fields>;
};


/** aggregate fields of "notificationCadences" */
export type NotificationCadences_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationCadences_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "notificationCadences". All fields are combined with a logical 'AND'. */
export type NotificationCadences_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationCadences_Bool_Exp>>;
  _not?: InputMaybe<NotificationCadences_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationCadences_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type NotificationCadences_Max_Fields = {
  __typename?: 'notificationCadences_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type NotificationCadences_Min_Fields = {
  __typename?: 'notificationCadences_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "notificationCadences". */
export type NotificationCadences_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** select columns of table "notificationCadences" */
export enum NotificationCadences_Select_Column {
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "notificationCadences" */
export type NotificationCadences_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: NotificationCadences_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationCadences_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "notificationChannels" */
export type NotificationChannels = {
  __typename?: 'notificationChannels';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  notificationMessages: Array<NotificationMessages>;
  /** An aggregate relationship */
  notificationMessages_aggregate: NotificationMessages_Aggregate;
  /** An array relationship */
  notificationPreferences: Array<NotificationPreferences>;
  /** An aggregate relationship */
  notificationPreferences_aggregate: NotificationPreferences_Aggregate;
};


/** columns and relationships of "notificationChannels" */
export type NotificationChannelsNotificationMessagesArgs = {
  distinct_on?: InputMaybe<Array<NotificationMessages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationMessages_Order_By>>;
  where?: InputMaybe<NotificationMessages_Bool_Exp>;
};


/** columns and relationships of "notificationChannels" */
export type NotificationChannelsNotificationMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationMessages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationMessages_Order_By>>;
  where?: InputMaybe<NotificationMessages_Bool_Exp>;
};


/** columns and relationships of "notificationChannels" */
export type NotificationChannelsNotificationPreferencesArgs = {
  distinct_on?: InputMaybe<Array<NotificationPreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationPreferences_Order_By>>;
  where?: InputMaybe<NotificationPreferences_Bool_Exp>;
};


/** columns and relationships of "notificationChannels" */
export type NotificationChannelsNotificationPreferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationPreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationPreferences_Order_By>>;
  where?: InputMaybe<NotificationPreferences_Bool_Exp>;
};

/** aggregated selection of "notificationChannels" */
export type NotificationChannels_Aggregate = {
  __typename?: 'notificationChannels_aggregate';
  aggregate?: Maybe<NotificationChannels_Aggregate_Fields>;
  nodes: Array<NotificationChannels>;
};

/** aggregate fields of "notificationChannels" */
export type NotificationChannels_Aggregate_Fields = {
  __typename?: 'notificationChannels_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<NotificationChannels_Max_Fields>;
  min?: Maybe<NotificationChannels_Min_Fields>;
};


/** aggregate fields of "notificationChannels" */
export type NotificationChannels_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationChannels_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "notificationChannels". All fields are combined with a logical 'AND'. */
export type NotificationChannels_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationChannels_Bool_Exp>>;
  _not?: InputMaybe<NotificationChannels_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationChannels_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notificationMessages?: InputMaybe<NotificationMessages_Bool_Exp>;
  notificationMessages_aggregate?: InputMaybe<NotificationMessages_Aggregate_Bool_Exp>;
  notificationPreferences?: InputMaybe<NotificationPreferences_Bool_Exp>;
  notificationPreferences_aggregate?: InputMaybe<NotificationPreferences_Aggregate_Bool_Exp>;
};

export enum NotificationChannels_Enum {
  Email = 'email',
  Message = 'message',
  Web = 'web'
}

/** Boolean expression to compare columns of type "notificationChannels_enum". All fields are combined with logical 'AND'. */
export type NotificationChannels_Enum_Comparison_Exp = {
  _eq?: InputMaybe<NotificationChannels_Enum>;
  _in?: InputMaybe<Array<NotificationChannels_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<NotificationChannels_Enum>;
  _nin?: InputMaybe<Array<NotificationChannels_Enum>>;
};

/** aggregate max on columns */
export type NotificationChannels_Max_Fields = {
  __typename?: 'notificationChannels_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type NotificationChannels_Min_Fields = {
  __typename?: 'notificationChannels_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "notificationChannels". */
export type NotificationChannels_Order_By = {
  description?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notificationMessages_aggregate?: InputMaybe<NotificationMessages_Aggregate_Order_By>;
  notificationPreferences_aggregate?: InputMaybe<NotificationPreferences_Aggregate_Order_By>;
};

/** select columns of table "notificationChannels" */
export enum NotificationChannels_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "notificationChannels" */
export type NotificationChannels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: NotificationChannels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationChannels_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "notificationMessages" */
export type NotificationMessages = {
  __typename?: 'notificationMessages';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  notification: Notifications;
  notificationChannel: NotificationChannels_Enum;
  notificationId: Scalars['bigint']['output'];
  readAt?: Maybe<Scalars['timestamptz']['output']>;
  sentAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "notificationMessages" */
export type NotificationMessages_Aggregate = {
  __typename?: 'notificationMessages_aggregate';
  aggregate?: Maybe<NotificationMessages_Aggregate_Fields>;
  nodes: Array<NotificationMessages>;
};

export type NotificationMessages_Aggregate_Bool_Exp = {
  count?: InputMaybe<NotificationMessages_Aggregate_Bool_Exp_Count>;
};

export type NotificationMessages_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<NotificationMessages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<NotificationMessages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "notificationMessages" */
export type NotificationMessages_Aggregate_Fields = {
  __typename?: 'notificationMessages_aggregate_fields';
  avg?: Maybe<NotificationMessages_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<NotificationMessages_Max_Fields>;
  min?: Maybe<NotificationMessages_Min_Fields>;
  stddev?: Maybe<NotificationMessages_Stddev_Fields>;
  stddev_pop?: Maybe<NotificationMessages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<NotificationMessages_Stddev_Samp_Fields>;
  sum?: Maybe<NotificationMessages_Sum_Fields>;
  var_pop?: Maybe<NotificationMessages_Var_Pop_Fields>;
  var_samp?: Maybe<NotificationMessages_Var_Samp_Fields>;
  variance?: Maybe<NotificationMessages_Variance_Fields>;
};


/** aggregate fields of "notificationMessages" */
export type NotificationMessages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationMessages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "notificationMessages" */
export type NotificationMessages_Aggregate_Order_By = {
  avg?: InputMaybe<NotificationMessages_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<NotificationMessages_Max_Order_By>;
  min?: InputMaybe<NotificationMessages_Min_Order_By>;
  stddev?: InputMaybe<NotificationMessages_Stddev_Order_By>;
  stddev_pop?: InputMaybe<NotificationMessages_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<NotificationMessages_Stddev_Samp_Order_By>;
  sum?: InputMaybe<NotificationMessages_Sum_Order_By>;
  var_pop?: InputMaybe<NotificationMessages_Var_Pop_Order_By>;
  var_samp?: InputMaybe<NotificationMessages_Var_Samp_Order_By>;
  variance?: InputMaybe<NotificationMessages_Variance_Order_By>;
};

/** aggregate avg on columns */
export type NotificationMessages_Avg_Fields = {
  __typename?: 'notificationMessages_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  notificationId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "notificationMessages" */
export type NotificationMessages_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  notificationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "notificationMessages". All fields are combined with a logical 'AND'. */
export type NotificationMessages_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationMessages_Bool_Exp>>;
  _not?: InputMaybe<NotificationMessages_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationMessages_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  notification?: InputMaybe<Notifications_Bool_Exp>;
  notificationChannel?: InputMaybe<NotificationChannels_Enum_Comparison_Exp>;
  notificationId?: InputMaybe<Bigint_Comparison_Exp>;
  readAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  sentAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type NotificationMessages_Max_Fields = {
  __typename?: 'notificationMessages_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  notificationId?: Maybe<Scalars['bigint']['output']>;
  readAt?: Maybe<Scalars['timestamptz']['output']>;
  sentAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "notificationMessages" */
export type NotificationMessages_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationId?: InputMaybe<Order_By>;
  readAt?: InputMaybe<Order_By>;
  sentAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type NotificationMessages_Min_Fields = {
  __typename?: 'notificationMessages_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  notificationId?: Maybe<Scalars['bigint']['output']>;
  readAt?: Maybe<Scalars['timestamptz']['output']>;
  sentAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "notificationMessages" */
export type NotificationMessages_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationId?: InputMaybe<Order_By>;
  readAt?: InputMaybe<Order_By>;
  sentAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notificationMessages" */
export type NotificationMessages_Mutation_Response = {
  __typename?: 'notificationMessages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationMessages>;
};

/** Ordering options when selecting data from "notificationMessages". */
export type NotificationMessages_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notification?: InputMaybe<Notifications_Order_By>;
  notificationChannel?: InputMaybe<Order_By>;
  notificationId?: InputMaybe<Order_By>;
  readAt?: InputMaybe<Order_By>;
  sentAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notificationMessages */
export type NotificationMessages_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "notificationMessages" */
export enum NotificationMessages_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationChannel = 'notificationChannel',
  /** column name */
  NotificationId = 'notificationId',
  /** column name */
  ReadAt = 'readAt',
  /** column name */
  SentAt = 'sentAt'
}

/** input type for updating data in table "notificationMessages" */
export type NotificationMessages_Set_Input = {
  readAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type NotificationMessages_Stddev_Fields = {
  __typename?: 'notificationMessages_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  notificationId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "notificationMessages" */
export type NotificationMessages_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  notificationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type NotificationMessages_Stddev_Pop_Fields = {
  __typename?: 'notificationMessages_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  notificationId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "notificationMessages" */
export type NotificationMessages_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  notificationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type NotificationMessages_Stddev_Samp_Fields = {
  __typename?: 'notificationMessages_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  notificationId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "notificationMessages" */
export type NotificationMessages_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  notificationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "notificationMessages" */
export type NotificationMessages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: NotificationMessages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationMessages_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  notificationChannel?: InputMaybe<NotificationChannels_Enum>;
  notificationId?: InputMaybe<Scalars['bigint']['input']>;
  readAt?: InputMaybe<Scalars['timestamptz']['input']>;
  sentAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type NotificationMessages_Sum_Fields = {
  __typename?: 'notificationMessages_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  notificationId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "notificationMessages" */
export type NotificationMessages_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  notificationId?: InputMaybe<Order_By>;
};

export type NotificationMessages_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationMessages_Set_Input>;
  /** filter the rows which have to be updated */
  where: NotificationMessages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type NotificationMessages_Var_Pop_Fields = {
  __typename?: 'notificationMessages_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  notificationId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "notificationMessages" */
export type NotificationMessages_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  notificationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type NotificationMessages_Var_Samp_Fields = {
  __typename?: 'notificationMessages_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  notificationId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "notificationMessages" */
export type NotificationMessages_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  notificationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type NotificationMessages_Variance_Fields = {
  __typename?: 'notificationMessages_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  notificationId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "notificationMessages" */
export type NotificationMessages_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  notificationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "notificationPreferenceStages" */
export type NotificationPreferenceStages = {
  __typename?: 'notificationPreferenceStages';
  name: Scalars['String']['output'];
  /** An array relationship */
  notificationPreferences: Array<NotificationPreferences>;
  /** An aggregate relationship */
  notificationPreferences_aggregate: NotificationPreferences_Aggregate;
};


/** columns and relationships of "notificationPreferenceStages" */
export type NotificationPreferenceStagesNotificationPreferencesArgs = {
  distinct_on?: InputMaybe<Array<NotificationPreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationPreferences_Order_By>>;
  where?: InputMaybe<NotificationPreferences_Bool_Exp>;
};


/** columns and relationships of "notificationPreferenceStages" */
export type NotificationPreferenceStagesNotificationPreferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationPreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationPreferences_Order_By>>;
  where?: InputMaybe<NotificationPreferences_Bool_Exp>;
};

/** aggregated selection of "notificationPreferenceStages" */
export type NotificationPreferenceStages_Aggregate = {
  __typename?: 'notificationPreferenceStages_aggregate';
  aggregate?: Maybe<NotificationPreferenceStages_Aggregate_Fields>;
  nodes: Array<NotificationPreferenceStages>;
};

/** aggregate fields of "notificationPreferenceStages" */
export type NotificationPreferenceStages_Aggregate_Fields = {
  __typename?: 'notificationPreferenceStages_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<NotificationPreferenceStages_Max_Fields>;
  min?: Maybe<NotificationPreferenceStages_Min_Fields>;
};


/** aggregate fields of "notificationPreferenceStages" */
export type NotificationPreferenceStages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationPreferenceStages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "notificationPreferenceStages". All fields are combined with a logical 'AND'. */
export type NotificationPreferenceStages_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationPreferenceStages_Bool_Exp>>;
  _not?: InputMaybe<NotificationPreferenceStages_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationPreferenceStages_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  notificationPreferences?: InputMaybe<NotificationPreferences_Bool_Exp>;
  notificationPreferences_aggregate?: InputMaybe<NotificationPreferences_Aggregate_Bool_Exp>;
};

export enum NotificationPreferenceStages_Enum {
  BuildUp = 'buildUp',
  Event = 'event',
  Organice = 'organice',
  Planning = 'planning'
}

/** Boolean expression to compare columns of type "notificationPreferenceStages_enum". All fields are combined with logical 'AND'. */
export type NotificationPreferenceStages_Enum_Comparison_Exp = {
  _eq?: InputMaybe<NotificationPreferenceStages_Enum>;
  _in?: InputMaybe<Array<NotificationPreferenceStages_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<NotificationPreferenceStages_Enum>;
  _nin?: InputMaybe<Array<NotificationPreferenceStages_Enum>>;
};

/** aggregate max on columns */
export type NotificationPreferenceStages_Max_Fields = {
  __typename?: 'notificationPreferenceStages_max_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type NotificationPreferenceStages_Min_Fields = {
  __typename?: 'notificationPreferenceStages_min_fields';
  name?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "notificationPreferenceStages". */
export type NotificationPreferenceStages_Order_By = {
  name?: InputMaybe<Order_By>;
  notificationPreferences_aggregate?: InputMaybe<NotificationPreferences_Aggregate_Order_By>;
};

/** select columns of table "notificationPreferenceStages" */
export enum NotificationPreferenceStages_Select_Column {
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "notificationPreferenceStages" */
export type NotificationPreferenceStages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: NotificationPreferenceStages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationPreferenceStages_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "notificationPreferences" */
export type NotificationPreferences = {
  __typename?: 'notificationPreferences';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  notificationAction: NotificationActions_Enum;
  notificationChannel: NotificationChannels_Enum;
  notificationPreferenceStage: NotificationPreferenceStages_Enum;
  /** An object relationship */
  user?: Maybe<Users>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** aggregated selection of "notificationPreferences" */
export type NotificationPreferences_Aggregate = {
  __typename?: 'notificationPreferences_aggregate';
  aggregate?: Maybe<NotificationPreferences_Aggregate_Fields>;
  nodes: Array<NotificationPreferences>;
};

export type NotificationPreferences_Aggregate_Bool_Exp = {
  count?: InputMaybe<NotificationPreferences_Aggregate_Bool_Exp_Count>;
};

export type NotificationPreferences_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<NotificationPreferences_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<NotificationPreferences_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "notificationPreferences" */
export type NotificationPreferences_Aggregate_Fields = {
  __typename?: 'notificationPreferences_aggregate_fields';
  avg?: Maybe<NotificationPreferences_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<NotificationPreferences_Max_Fields>;
  min?: Maybe<NotificationPreferences_Min_Fields>;
  stddev?: Maybe<NotificationPreferences_Stddev_Fields>;
  stddev_pop?: Maybe<NotificationPreferences_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<NotificationPreferences_Stddev_Samp_Fields>;
  sum?: Maybe<NotificationPreferences_Sum_Fields>;
  var_pop?: Maybe<NotificationPreferences_Var_Pop_Fields>;
  var_samp?: Maybe<NotificationPreferences_Var_Samp_Fields>;
  variance?: Maybe<NotificationPreferences_Variance_Fields>;
};


/** aggregate fields of "notificationPreferences" */
export type NotificationPreferences_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationPreferences_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "notificationPreferences" */
export type NotificationPreferences_Aggregate_Order_By = {
  avg?: InputMaybe<NotificationPreferences_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<NotificationPreferences_Max_Order_By>;
  min?: InputMaybe<NotificationPreferences_Min_Order_By>;
  stddev?: InputMaybe<NotificationPreferences_Stddev_Order_By>;
  stddev_pop?: InputMaybe<NotificationPreferences_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<NotificationPreferences_Stddev_Samp_Order_By>;
  sum?: InputMaybe<NotificationPreferences_Sum_Order_By>;
  var_pop?: InputMaybe<NotificationPreferences_Var_Pop_Order_By>;
  var_samp?: InputMaybe<NotificationPreferences_Var_Samp_Order_By>;
  variance?: InputMaybe<NotificationPreferences_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "notificationPreferences" */
export type NotificationPreferences_Arr_Rel_Insert_Input = {
  data: Array<NotificationPreferences_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationPreferences_On_Conflict>;
};

/** aggregate avg on columns */
export type NotificationPreferences_Avg_Fields = {
  __typename?: 'notificationPreferences_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "notificationPreferences" */
export type NotificationPreferences_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "notificationPreferences". All fields are combined with a logical 'AND'. */
export type NotificationPreferences_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationPreferences_Bool_Exp>>;
  _not?: InputMaybe<NotificationPreferences_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationPreferences_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  notificationAction?: InputMaybe<NotificationActions_Enum_Comparison_Exp>;
  notificationChannel?: InputMaybe<NotificationChannels_Enum_Comparison_Exp>;
  notificationPreferenceStage?: InputMaybe<NotificationPreferenceStages_Enum_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "notificationPreferences" */
export enum NotificationPreferences_Constraint {
  /** unique or primary key constraint on columns "userId", "notificationAction", "notificationChannel", "notificationPreferenceStage" */
  NotificationPreferencesIdx1 = 'notificationPreferences_idx_1',
  /** unique or primary key constraint on columns "id" */
  NotificationPreferencesPkey = 'notificationPreferences_pkey'
}

/** input type for inserting data into table "notificationPreferences" */
export type NotificationPreferences_Insert_Input = {
  notificationAction?: InputMaybe<NotificationActions_Enum>;
  notificationChannel?: InputMaybe<NotificationChannels_Enum>;
  notificationPreferenceStage?: InputMaybe<NotificationPreferenceStages_Enum>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type NotificationPreferences_Max_Fields = {
  __typename?: 'notificationPreferences_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "notificationPreferences" */
export type NotificationPreferences_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type NotificationPreferences_Min_Fields = {
  __typename?: 'notificationPreferences_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "notificationPreferences" */
export type NotificationPreferences_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notificationPreferences" */
export type NotificationPreferences_Mutation_Response = {
  __typename?: 'notificationPreferences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationPreferences>;
};

/** on_conflict condition type for table "notificationPreferences" */
export type NotificationPreferences_On_Conflict = {
  constraint: NotificationPreferences_Constraint;
  update_columns?: Array<NotificationPreferences_Update_Column>;
  where?: InputMaybe<NotificationPreferences_Bool_Exp>;
};

/** Ordering options when selecting data from "notificationPreferences". */
export type NotificationPreferences_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationAction?: InputMaybe<Order_By>;
  notificationChannel?: InputMaybe<Order_By>;
  notificationPreferenceStage?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notificationPreferences */
export type NotificationPreferences_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "notificationPreferences" */
export enum NotificationPreferences_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationAction = 'notificationAction',
  /** column name */
  NotificationChannel = 'notificationChannel',
  /** column name */
  NotificationPreferenceStage = 'notificationPreferenceStage',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type NotificationPreferences_Stddev_Fields = {
  __typename?: 'notificationPreferences_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "notificationPreferences" */
export type NotificationPreferences_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type NotificationPreferences_Stddev_Pop_Fields = {
  __typename?: 'notificationPreferences_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "notificationPreferences" */
export type NotificationPreferences_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type NotificationPreferences_Stddev_Samp_Fields = {
  __typename?: 'notificationPreferences_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "notificationPreferences" */
export type NotificationPreferences_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "notificationPreferences" */
export type NotificationPreferences_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: NotificationPreferences_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationPreferences_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  notificationAction?: InputMaybe<NotificationActions_Enum>;
  notificationChannel?: InputMaybe<NotificationChannels_Enum>;
  notificationPreferenceStage?: InputMaybe<NotificationPreferenceStages_Enum>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type NotificationPreferences_Sum_Fields = {
  __typename?: 'notificationPreferences_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "notificationPreferences" */
export type NotificationPreferences_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "notificationPreferences" (current role has no relevant permissions) */
export enum NotificationPreferences_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

export type NotificationPreferences_Updates = {
  /** filter the rows which have to be updated */
  where: NotificationPreferences_Bool_Exp;
};

/** aggregate var_pop on columns */
export type NotificationPreferences_Var_Pop_Fields = {
  __typename?: 'notificationPreferences_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "notificationPreferences" */
export type NotificationPreferences_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type NotificationPreferences_Var_Samp_Fields = {
  __typename?: 'notificationPreferences_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "notificationPreferences" */
export type NotificationPreferences_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type NotificationPreferences_Variance_Fields = {
  __typename?: 'notificationPreferences_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "notificationPreferences" */
export type NotificationPreferences_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "notificationRoomServiceCategoryPreferences" */
export type NotificationRoomServiceCategoryPreferences = {
  __typename?: 'notificationRoomServiceCategoryPreferences';
  /** An object relationship */
  roomServiceCategory: RoomServiceCategories;
  roomServiceCategoryId: Scalars['bigint']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['bigint']['output'];
};

/** aggregated selection of "notificationRoomServiceCategoryPreferences" */
export type NotificationRoomServiceCategoryPreferences_Aggregate = {
  __typename?: 'notificationRoomServiceCategoryPreferences_aggregate';
  aggregate?: Maybe<NotificationRoomServiceCategoryPreferences_Aggregate_Fields>;
  nodes: Array<NotificationRoomServiceCategoryPreferences>;
};

/** aggregate fields of "notificationRoomServiceCategoryPreferences" */
export type NotificationRoomServiceCategoryPreferences_Aggregate_Fields = {
  __typename?: 'notificationRoomServiceCategoryPreferences_aggregate_fields';
  avg?: Maybe<NotificationRoomServiceCategoryPreferences_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<NotificationRoomServiceCategoryPreferences_Max_Fields>;
  min?: Maybe<NotificationRoomServiceCategoryPreferences_Min_Fields>;
  stddev?: Maybe<NotificationRoomServiceCategoryPreferences_Stddev_Fields>;
  stddev_pop?: Maybe<NotificationRoomServiceCategoryPreferences_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<NotificationRoomServiceCategoryPreferences_Stddev_Samp_Fields>;
  sum?: Maybe<NotificationRoomServiceCategoryPreferences_Sum_Fields>;
  var_pop?: Maybe<NotificationRoomServiceCategoryPreferences_Var_Pop_Fields>;
  var_samp?: Maybe<NotificationRoomServiceCategoryPreferences_Var_Samp_Fields>;
  variance?: Maybe<NotificationRoomServiceCategoryPreferences_Variance_Fields>;
};


/** aggregate fields of "notificationRoomServiceCategoryPreferences" */
export type NotificationRoomServiceCategoryPreferences_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationRoomServiceCategoryPreferences_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type NotificationRoomServiceCategoryPreferences_Avg_Fields = {
  __typename?: 'notificationRoomServiceCategoryPreferences_avg_fields';
  roomServiceCategoryId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "notificationRoomServiceCategoryPreferences". All fields are combined with a logical 'AND'. */
export type NotificationRoomServiceCategoryPreferences_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationRoomServiceCategoryPreferences_Bool_Exp>>;
  _not?: InputMaybe<NotificationRoomServiceCategoryPreferences_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationRoomServiceCategoryPreferences_Bool_Exp>>;
  roomServiceCategory?: InputMaybe<RoomServiceCategories_Bool_Exp>;
  roomServiceCategoryId?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "notificationRoomServiceCategoryPreferences" */
export enum NotificationRoomServiceCategoryPreferences_Constraint {
  /** unique or primary key constraint on columns "userId", "roomServiceCategoryId" */
  NotificationRoomServiceCategoryPreferencesPkey = 'notificationRoomServiceCategoryPreferences_pkey'
}

/** input type for inserting data into table "notificationRoomServiceCategoryPreferences" */
export type NotificationRoomServiceCategoryPreferences_Insert_Input = {
  roomServiceCategory?: InputMaybe<RoomServiceCategories_Obj_Rel_Insert_Input>;
  roomServiceCategoryId?: InputMaybe<Scalars['bigint']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type NotificationRoomServiceCategoryPreferences_Max_Fields = {
  __typename?: 'notificationRoomServiceCategoryPreferences_max_fields';
  roomServiceCategoryId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type NotificationRoomServiceCategoryPreferences_Min_Fields = {
  __typename?: 'notificationRoomServiceCategoryPreferences_min_fields';
  roomServiceCategoryId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** response of any mutation on the table "notificationRoomServiceCategoryPreferences" */
export type NotificationRoomServiceCategoryPreferences_Mutation_Response = {
  __typename?: 'notificationRoomServiceCategoryPreferences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationRoomServiceCategoryPreferences>;
};

/** on_conflict condition type for table "notificationRoomServiceCategoryPreferences" */
export type NotificationRoomServiceCategoryPreferences_On_Conflict = {
  constraint: NotificationRoomServiceCategoryPreferences_Constraint;
  update_columns?: Array<NotificationRoomServiceCategoryPreferences_Update_Column>;
  where?: InputMaybe<NotificationRoomServiceCategoryPreferences_Bool_Exp>;
};

/** Ordering options when selecting data from "notificationRoomServiceCategoryPreferences". */
export type NotificationRoomServiceCategoryPreferences_Order_By = {
  roomServiceCategory?: InputMaybe<RoomServiceCategories_Order_By>;
  roomServiceCategoryId?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "notificationRoomServiceCategoryPreferences" */
export enum NotificationRoomServiceCategoryPreferences_Select_Column {
  /** column name */
  RoomServiceCategoryId = 'roomServiceCategoryId',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type NotificationRoomServiceCategoryPreferences_Stddev_Fields = {
  __typename?: 'notificationRoomServiceCategoryPreferences_stddev_fields';
  roomServiceCategoryId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type NotificationRoomServiceCategoryPreferences_Stddev_Pop_Fields = {
  __typename?: 'notificationRoomServiceCategoryPreferences_stddev_pop_fields';
  roomServiceCategoryId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type NotificationRoomServiceCategoryPreferences_Stddev_Samp_Fields = {
  __typename?: 'notificationRoomServiceCategoryPreferences_stddev_samp_fields';
  roomServiceCategoryId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "notificationRoomServiceCategoryPreferences" */
export type NotificationRoomServiceCategoryPreferences_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: NotificationRoomServiceCategoryPreferences_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationRoomServiceCategoryPreferences_Stream_Cursor_Value_Input = {
  roomServiceCategoryId?: InputMaybe<Scalars['bigint']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type NotificationRoomServiceCategoryPreferences_Sum_Fields = {
  __typename?: 'notificationRoomServiceCategoryPreferences_sum_fields';
  roomServiceCategoryId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** placeholder for update columns of table "notificationRoomServiceCategoryPreferences" (current role has no relevant permissions) */
export enum NotificationRoomServiceCategoryPreferences_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type NotificationRoomServiceCategoryPreferences_Var_Pop_Fields = {
  __typename?: 'notificationRoomServiceCategoryPreferences_var_pop_fields';
  roomServiceCategoryId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type NotificationRoomServiceCategoryPreferences_Var_Samp_Fields = {
  __typename?: 'notificationRoomServiceCategoryPreferences_var_samp_fields';
  roomServiceCategoryId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type NotificationRoomServiceCategoryPreferences_Variance_Fields = {
  __typename?: 'notificationRoomServiceCategoryPreferences_variance_fields';
  roomServiceCategoryId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "notificationServicePreferences" */
export type NotificationServicePreferences = {
  __typename?: 'notificationServicePreferences';
  /** An object relationship */
  fullService: Services;
  /** An object relationship */
  service?: Maybe<ServiceParents>;
  serviceId: Scalars['bigint']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['bigint']['output'];
};

/** aggregated selection of "notificationServicePreferences" */
export type NotificationServicePreferences_Aggregate = {
  __typename?: 'notificationServicePreferences_aggregate';
  aggregate?: Maybe<NotificationServicePreferences_Aggregate_Fields>;
  nodes: Array<NotificationServicePreferences>;
};

export type NotificationServicePreferences_Aggregate_Bool_Exp = {
  count?: InputMaybe<NotificationServicePreferences_Aggregate_Bool_Exp_Count>;
};

export type NotificationServicePreferences_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<NotificationServicePreferences_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<NotificationServicePreferences_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "notificationServicePreferences" */
export type NotificationServicePreferences_Aggregate_Fields = {
  __typename?: 'notificationServicePreferences_aggregate_fields';
  avg?: Maybe<NotificationServicePreferences_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<NotificationServicePreferences_Max_Fields>;
  min?: Maybe<NotificationServicePreferences_Min_Fields>;
  stddev?: Maybe<NotificationServicePreferences_Stddev_Fields>;
  stddev_pop?: Maybe<NotificationServicePreferences_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<NotificationServicePreferences_Stddev_Samp_Fields>;
  sum?: Maybe<NotificationServicePreferences_Sum_Fields>;
  var_pop?: Maybe<NotificationServicePreferences_Var_Pop_Fields>;
  var_samp?: Maybe<NotificationServicePreferences_Var_Samp_Fields>;
  variance?: Maybe<NotificationServicePreferences_Variance_Fields>;
};


/** aggregate fields of "notificationServicePreferences" */
export type NotificationServicePreferences_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationServicePreferences_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "notificationServicePreferences" */
export type NotificationServicePreferences_Aggregate_Order_By = {
  avg?: InputMaybe<NotificationServicePreferences_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<NotificationServicePreferences_Max_Order_By>;
  min?: InputMaybe<NotificationServicePreferences_Min_Order_By>;
  stddev?: InputMaybe<NotificationServicePreferences_Stddev_Order_By>;
  stddev_pop?: InputMaybe<NotificationServicePreferences_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<NotificationServicePreferences_Stddev_Samp_Order_By>;
  sum?: InputMaybe<NotificationServicePreferences_Sum_Order_By>;
  var_pop?: InputMaybe<NotificationServicePreferences_Var_Pop_Order_By>;
  var_samp?: InputMaybe<NotificationServicePreferences_Var_Samp_Order_By>;
  variance?: InputMaybe<NotificationServicePreferences_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "notificationServicePreferences" */
export type NotificationServicePreferences_Arr_Rel_Insert_Input = {
  data: Array<NotificationServicePreferences_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationServicePreferences_On_Conflict>;
};

/** aggregate avg on columns */
export type NotificationServicePreferences_Avg_Fields = {
  __typename?: 'notificationServicePreferences_avg_fields';
  serviceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "notificationServicePreferences" */
export type NotificationServicePreferences_Avg_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "notificationServicePreferences". All fields are combined with a logical 'AND'. */
export type NotificationServicePreferences_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationServicePreferences_Bool_Exp>>;
  _not?: InputMaybe<NotificationServicePreferences_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationServicePreferences_Bool_Exp>>;
  fullService?: InputMaybe<Services_Bool_Exp>;
  service?: InputMaybe<ServiceParents_Bool_Exp>;
  serviceId?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "notificationServicePreferences" */
export enum NotificationServicePreferences_Constraint {
  /** unique or primary key constraint on columns "userId", "serviceId" */
  NotificationServicePreferencesPkey = 'notificationServicePreferences_pkey'
}

/** input type for inserting data into table "notificationServicePreferences" */
export type NotificationServicePreferences_Insert_Input = {
  fullService?: InputMaybe<Services_Obj_Rel_Insert_Input>;
  serviceId?: InputMaybe<Scalars['bigint']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type NotificationServicePreferences_Max_Fields = {
  __typename?: 'notificationServicePreferences_max_fields';
  serviceId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "notificationServicePreferences" */
export type NotificationServicePreferences_Max_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type NotificationServicePreferences_Min_Fields = {
  __typename?: 'notificationServicePreferences_min_fields';
  serviceId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "notificationServicePreferences" */
export type NotificationServicePreferences_Min_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notificationServicePreferences" */
export type NotificationServicePreferences_Mutation_Response = {
  __typename?: 'notificationServicePreferences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationServicePreferences>;
};

/** on_conflict condition type for table "notificationServicePreferences" */
export type NotificationServicePreferences_On_Conflict = {
  constraint: NotificationServicePreferences_Constraint;
  update_columns?: Array<NotificationServicePreferences_Update_Column>;
  where?: InputMaybe<NotificationServicePreferences_Bool_Exp>;
};

/** Ordering options when selecting data from "notificationServicePreferences". */
export type NotificationServicePreferences_Order_By = {
  fullService?: InputMaybe<Services_Order_By>;
  service?: InputMaybe<ServiceParents_Order_By>;
  serviceId?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "notificationServicePreferences" */
export enum NotificationServicePreferences_Select_Column {
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type NotificationServicePreferences_Stddev_Fields = {
  __typename?: 'notificationServicePreferences_stddev_fields';
  serviceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "notificationServicePreferences" */
export type NotificationServicePreferences_Stddev_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type NotificationServicePreferences_Stddev_Pop_Fields = {
  __typename?: 'notificationServicePreferences_stddev_pop_fields';
  serviceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "notificationServicePreferences" */
export type NotificationServicePreferences_Stddev_Pop_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type NotificationServicePreferences_Stddev_Samp_Fields = {
  __typename?: 'notificationServicePreferences_stddev_samp_fields';
  serviceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "notificationServicePreferences" */
export type NotificationServicePreferences_Stddev_Samp_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "notificationServicePreferences" */
export type NotificationServicePreferences_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: NotificationServicePreferences_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationServicePreferences_Stream_Cursor_Value_Input = {
  serviceId?: InputMaybe<Scalars['bigint']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type NotificationServicePreferences_Sum_Fields = {
  __typename?: 'notificationServicePreferences_sum_fields';
  serviceId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "notificationServicePreferences" */
export type NotificationServicePreferences_Sum_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "notificationServicePreferences" (current role has no relevant permissions) */
export enum NotificationServicePreferences_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type NotificationServicePreferences_Var_Pop_Fields = {
  __typename?: 'notificationServicePreferences_var_pop_fields';
  serviceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "notificationServicePreferences" */
export type NotificationServicePreferences_Var_Pop_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type NotificationServicePreferences_Var_Samp_Fields = {
  __typename?: 'notificationServicePreferences_var_samp_fields';
  serviceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "notificationServicePreferences" */
export type NotificationServicePreferences_Var_Samp_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type NotificationServicePreferences_Variance_Fields = {
  __typename?: 'notificationServicePreferences_variance_fields';
  serviceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "notificationServicePreferences" */
export type NotificationServicePreferences_Variance_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "notificationTemplates" */
export type NotificationTemplates = {
  __typename?: 'notificationTemplates';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  notificationAction: NotificationActions_Enum;
  templateEmail: Scalars['json']['output'];
  templateMessage: Scalars['json']['output'];
  templateWeb: Scalars['json']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "notificationTemplates" */
export type NotificationTemplatesTemplateEmailArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "notificationTemplates" */
export type NotificationTemplatesTemplateMessageArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "notificationTemplates" */
export type NotificationTemplatesTemplateWebArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "notificationTemplates" */
export type NotificationTemplates_Aggregate = {
  __typename?: 'notificationTemplates_aggregate';
  aggregate?: Maybe<NotificationTemplates_Aggregate_Fields>;
  nodes: Array<NotificationTemplates>;
};

/** aggregate fields of "notificationTemplates" */
export type NotificationTemplates_Aggregate_Fields = {
  __typename?: 'notificationTemplates_aggregate_fields';
  avg?: Maybe<NotificationTemplates_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<NotificationTemplates_Max_Fields>;
  min?: Maybe<NotificationTemplates_Min_Fields>;
  stddev?: Maybe<NotificationTemplates_Stddev_Fields>;
  stddev_pop?: Maybe<NotificationTemplates_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<NotificationTemplates_Stddev_Samp_Fields>;
  sum?: Maybe<NotificationTemplates_Sum_Fields>;
  var_pop?: Maybe<NotificationTemplates_Var_Pop_Fields>;
  var_samp?: Maybe<NotificationTemplates_Var_Samp_Fields>;
  variance?: Maybe<NotificationTemplates_Variance_Fields>;
};


/** aggregate fields of "notificationTemplates" */
export type NotificationTemplates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationTemplates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type NotificationTemplates_Avg_Fields = {
  __typename?: 'notificationTemplates_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "notificationTemplates". All fields are combined with a logical 'AND'. */
export type NotificationTemplates_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationTemplates_Bool_Exp>>;
  _not?: InputMaybe<NotificationTemplates_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationTemplates_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  notificationAction?: InputMaybe<NotificationActions_Enum_Comparison_Exp>;
  templateEmail?: InputMaybe<Json_Comparison_Exp>;
  templateMessage?: InputMaybe<Json_Comparison_Exp>;
  templateWeb?: InputMaybe<Json_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type NotificationTemplates_Max_Fields = {
  __typename?: 'notificationTemplates_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type NotificationTemplates_Min_Fields = {
  __typename?: 'notificationTemplates_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "notificationTemplates". */
export type NotificationTemplates_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationAction?: InputMaybe<Order_By>;
  templateEmail?: InputMaybe<Order_By>;
  templateMessage?: InputMaybe<Order_By>;
  templateWeb?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** select columns of table "notificationTemplates" */
export enum NotificationTemplates_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationAction = 'notificationAction',
  /** column name */
  TemplateEmail = 'templateEmail',
  /** column name */
  TemplateMessage = 'templateMessage',
  /** column name */
  TemplateWeb = 'templateWeb',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** aggregate stddev on columns */
export type NotificationTemplates_Stddev_Fields = {
  __typename?: 'notificationTemplates_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type NotificationTemplates_Stddev_Pop_Fields = {
  __typename?: 'notificationTemplates_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type NotificationTemplates_Stddev_Samp_Fields = {
  __typename?: 'notificationTemplates_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "notificationTemplates" */
export type NotificationTemplates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: NotificationTemplates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationTemplates_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  notificationAction?: InputMaybe<NotificationActions_Enum>;
  templateEmail?: InputMaybe<Scalars['json']['input']>;
  templateMessage?: InputMaybe<Scalars['json']['input']>;
  templateWeb?: InputMaybe<Scalars['json']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type NotificationTemplates_Sum_Fields = {
  __typename?: 'notificationTemplates_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type NotificationTemplates_Var_Pop_Fields = {
  __typename?: 'notificationTemplates_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type NotificationTemplates_Var_Samp_Fields = {
  __typename?: 'notificationTemplates_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type NotificationTemplates_Variance_Fields = {
  __typename?: 'notificationTemplates_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "notifications" */
export type Notifications = {
  __typename?: 'notifications';
  /** An object relationship */
  attributeValue?: Maybe<AttributeValues>;
  /** An object relationship */
  attributeValueComment?: Maybe<AttributeValueComments>;
  attributeValueCommentId?: Maybe<Scalars['bigint']['output']>;
  attributeValueId?: Maybe<Scalars['bigint']['output']>;
  authorUserId?: Maybe<Scalars['bigint']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  data: Scalars['json']['output'];
  /** An object relationship */
  event?: Maybe<Events>;
  /** An object relationship */
  eventAttributeValue?: Maybe<EventAttributeValues>;
  eventAttributeValueId?: Maybe<Scalars['bigint']['output']>;
  eventId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  file?: Maybe<Files>;
  fileId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  fullUser?: Maybe<Users>;
  /** An object relationship */
  fullUserByUserid: Users;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  jaggaerSubmission?: Maybe<JaggaerSubmissions>;
  jaggaerSubmissionId?: Maybe<Scalars['bigint']['output']>;
  newerNotificationId?: Maybe<Scalars['bigint']['output']>;
  notificationAction: NotificationActions_Enum;
  /** An array relationship */
  notificationMessages: Array<NotificationMessages>;
  /** An aggregate relationship */
  notificationMessages_aggregate: NotificationMessages_Aggregate;
  readAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  room?: Maybe<Rooms>;
  /** An object relationship */
  roomAttributeValue?: Maybe<RoomAttributeValues>;
  /** An object relationship */
  roomAttributeValueComment?: Maybe<RoomAttributeValueComments>;
  roomAttributeValueCommentId?: Maybe<Scalars['bigint']['output']>;
  roomAttributeValueId?: Maybe<Scalars['bigint']['output']>;
  roomId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  roomService?: Maybe<RoomServices>;
  roomServiceId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  roomServiceOccurrence?: Maybe<RoomServiceOccurrences>;
  roomServiceOccurrenceId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  service?: Maybe<Services>;
  serviceId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  serviceModule?: Maybe<ServiceModules>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  uploadComment?: Maybe<UploadComments>;
  uploadCommentId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  uploadVersion?: Maybe<UploadVersions>;
  uploadVersionId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  user?: Maybe<AllUsers>;
  /** An object relationship */
  userByUserid?: Maybe<AllUsers>;
  userId: Scalars['bigint']['output'];
};


/** columns and relationships of "notifications" */
export type NotificationsDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "notifications" */
export type NotificationsNotificationMessagesArgs = {
  distinct_on?: InputMaybe<Array<NotificationMessages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationMessages_Order_By>>;
  where?: InputMaybe<NotificationMessages_Bool_Exp>;
};


/** columns and relationships of "notifications" */
export type NotificationsNotificationMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationMessages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationMessages_Order_By>>;
  where?: InputMaybe<NotificationMessages_Bool_Exp>;
};

/** aggregated selection of "notifications" */
export type Notifications_Aggregate = {
  __typename?: 'notifications_aggregate';
  aggregate?: Maybe<Notifications_Aggregate_Fields>;
  nodes: Array<Notifications>;
};

export type Notifications_Aggregate_Bool_Exp = {
  count?: InputMaybe<Notifications_Aggregate_Bool_Exp_Count>;
};

export type Notifications_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Notifications_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "notifications" */
export type Notifications_Aggregate_Fields = {
  __typename?: 'notifications_aggregate_fields';
  avg?: Maybe<Notifications_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Notifications_Max_Fields>;
  min?: Maybe<Notifications_Min_Fields>;
  stddev?: Maybe<Notifications_Stddev_Fields>;
  stddev_pop?: Maybe<Notifications_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Notifications_Stddev_Samp_Fields>;
  sum?: Maybe<Notifications_Sum_Fields>;
  var_pop?: Maybe<Notifications_Var_Pop_Fields>;
  var_samp?: Maybe<Notifications_Var_Samp_Fields>;
  variance?: Maybe<Notifications_Variance_Fields>;
};


/** aggregate fields of "notifications" */
export type Notifications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "notifications" */
export type Notifications_Aggregate_Order_By = {
  avg?: InputMaybe<Notifications_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Notifications_Max_Order_By>;
  min?: InputMaybe<Notifications_Min_Order_By>;
  stddev?: InputMaybe<Notifications_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Notifications_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Notifications_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Notifications_Sum_Order_By>;
  var_pop?: InputMaybe<Notifications_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Notifications_Var_Samp_Order_By>;
  variance?: InputMaybe<Notifications_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Notifications_Avg_Fields = {
  __typename?: 'notifications_avg_fields';
  attributeValueCommentId?: Maybe<Scalars['Float']['output']>;
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  authorUserId?: Maybe<Scalars['Float']['output']>;
  eventAttributeValueId?: Maybe<Scalars['Float']['output']>;
  eventId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  jaggaerSubmissionId?: Maybe<Scalars['Float']['output']>;
  newerNotificationId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueCommentId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
  roomId?: Maybe<Scalars['Float']['output']>;
  roomServiceId?: Maybe<Scalars['Float']['output']>;
  roomServiceOccurrenceId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  uploadCommentId?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "notifications" */
export type Notifications_Avg_Order_By = {
  attributeValueCommentId?: InputMaybe<Order_By>;
  attributeValueId?: InputMaybe<Order_By>;
  authorUserId?: InputMaybe<Order_By>;
  eventAttributeValueId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jaggaerSubmissionId?: InputMaybe<Order_By>;
  newerNotificationId?: InputMaybe<Order_By>;
  roomAttributeValueCommentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  uploadCommentId?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "notifications". All fields are combined with a logical 'AND'. */
export type Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Notifications_Bool_Exp>>;
  _not?: InputMaybe<Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Notifications_Bool_Exp>>;
  attributeValue?: InputMaybe<AttributeValues_Bool_Exp>;
  attributeValueComment?: InputMaybe<AttributeValueComments_Bool_Exp>;
  attributeValueCommentId?: InputMaybe<Bigint_Comparison_Exp>;
  attributeValueId?: InputMaybe<Bigint_Comparison_Exp>;
  authorUserId?: InputMaybe<Bigint_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Json_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventAttributeValue?: InputMaybe<EventAttributeValues_Bool_Exp>;
  eventAttributeValueId?: InputMaybe<Bigint_Comparison_Exp>;
  eventId?: InputMaybe<Bigint_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Bigint_Comparison_Exp>;
  fullUser?: InputMaybe<Users_Bool_Exp>;
  fullUserByUserid?: InputMaybe<Users_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  jaggaerSubmission?: InputMaybe<JaggaerSubmissions_Bool_Exp>;
  jaggaerSubmissionId?: InputMaybe<Bigint_Comparison_Exp>;
  newerNotificationId?: InputMaybe<Bigint_Comparison_Exp>;
  notificationAction?: InputMaybe<NotificationActions_Enum_Comparison_Exp>;
  notificationMessages?: InputMaybe<NotificationMessages_Bool_Exp>;
  notificationMessages_aggregate?: InputMaybe<NotificationMessages_Aggregate_Bool_Exp>;
  readAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  room?: InputMaybe<Rooms_Bool_Exp>;
  roomAttributeValue?: InputMaybe<RoomAttributeValues_Bool_Exp>;
  roomAttributeValueComment?: InputMaybe<RoomAttributeValueComments_Bool_Exp>;
  roomAttributeValueCommentId?: InputMaybe<Bigint_Comparison_Exp>;
  roomAttributeValueId?: InputMaybe<Bigint_Comparison_Exp>;
  roomId?: InputMaybe<Bigint_Comparison_Exp>;
  roomService?: InputMaybe<RoomServices_Bool_Exp>;
  roomServiceId?: InputMaybe<Bigint_Comparison_Exp>;
  roomServiceOccurrence?: InputMaybe<RoomServiceOccurrences_Bool_Exp>;
  roomServiceOccurrenceId?: InputMaybe<Bigint_Comparison_Exp>;
  service?: InputMaybe<Services_Bool_Exp>;
  serviceId?: InputMaybe<Bigint_Comparison_Exp>;
  serviceModule?: InputMaybe<ServiceModules_Bool_Exp>;
  serviceModuleId?: InputMaybe<Bigint_Comparison_Exp>;
  uploadComment?: InputMaybe<UploadComments_Bool_Exp>;
  uploadCommentId?: InputMaybe<Bigint_Comparison_Exp>;
  uploadVersion?: InputMaybe<UploadVersions_Bool_Exp>;
  uploadVersionId?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<AllUsers_Bool_Exp>;
  userByUserid?: InputMaybe<AllUsers_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type Notifications_Max_Fields = {
  __typename?: 'notifications_max_fields';
  attributeValueCommentId?: Maybe<Scalars['bigint']['output']>;
  attributeValueId?: Maybe<Scalars['bigint']['output']>;
  authorUserId?: Maybe<Scalars['bigint']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  eventAttributeValueId?: Maybe<Scalars['bigint']['output']>;
  eventId?: Maybe<Scalars['bigint']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  jaggaerSubmissionId?: Maybe<Scalars['bigint']['output']>;
  newerNotificationId?: Maybe<Scalars['bigint']['output']>;
  readAt?: Maybe<Scalars['timestamptz']['output']>;
  roomAttributeValueCommentId?: Maybe<Scalars['bigint']['output']>;
  roomAttributeValueId?: Maybe<Scalars['bigint']['output']>;
  roomId?: Maybe<Scalars['bigint']['output']>;
  roomServiceId?: Maybe<Scalars['bigint']['output']>;
  roomServiceOccurrenceId?: Maybe<Scalars['bigint']['output']>;
  serviceId?: Maybe<Scalars['bigint']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  uploadCommentId?: Maybe<Scalars['bigint']['output']>;
  uploadVersionId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "notifications" */
export type Notifications_Max_Order_By = {
  attributeValueCommentId?: InputMaybe<Order_By>;
  attributeValueId?: InputMaybe<Order_By>;
  authorUserId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  eventAttributeValueId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jaggaerSubmissionId?: InputMaybe<Order_By>;
  newerNotificationId?: InputMaybe<Order_By>;
  readAt?: InputMaybe<Order_By>;
  roomAttributeValueCommentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  uploadCommentId?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Notifications_Min_Fields = {
  __typename?: 'notifications_min_fields';
  attributeValueCommentId?: Maybe<Scalars['bigint']['output']>;
  attributeValueId?: Maybe<Scalars['bigint']['output']>;
  authorUserId?: Maybe<Scalars['bigint']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  eventAttributeValueId?: Maybe<Scalars['bigint']['output']>;
  eventId?: Maybe<Scalars['bigint']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  jaggaerSubmissionId?: Maybe<Scalars['bigint']['output']>;
  newerNotificationId?: Maybe<Scalars['bigint']['output']>;
  readAt?: Maybe<Scalars['timestamptz']['output']>;
  roomAttributeValueCommentId?: Maybe<Scalars['bigint']['output']>;
  roomAttributeValueId?: Maybe<Scalars['bigint']['output']>;
  roomId?: Maybe<Scalars['bigint']['output']>;
  roomServiceId?: Maybe<Scalars['bigint']['output']>;
  roomServiceOccurrenceId?: Maybe<Scalars['bigint']['output']>;
  serviceId?: Maybe<Scalars['bigint']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  uploadCommentId?: Maybe<Scalars['bigint']['output']>;
  uploadVersionId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "notifications" */
export type Notifications_Min_Order_By = {
  attributeValueCommentId?: InputMaybe<Order_By>;
  attributeValueId?: InputMaybe<Order_By>;
  authorUserId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  eventAttributeValueId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jaggaerSubmissionId?: InputMaybe<Order_By>;
  newerNotificationId?: InputMaybe<Order_By>;
  readAt?: InputMaybe<Order_By>;
  roomAttributeValueCommentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  uploadCommentId?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "notifications". */
export type Notifications_Order_By = {
  attributeValue?: InputMaybe<AttributeValues_Order_By>;
  attributeValueComment?: InputMaybe<AttributeValueComments_Order_By>;
  attributeValueCommentId?: InputMaybe<Order_By>;
  attributeValueId?: InputMaybe<Order_By>;
  authorUserId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  eventAttributeValue?: InputMaybe<EventAttributeValues_Order_By>;
  eventAttributeValueId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
  fullUser?: InputMaybe<Users_Order_By>;
  fullUserByUserid?: InputMaybe<Users_Order_By>;
  id?: InputMaybe<Order_By>;
  jaggaerSubmission?: InputMaybe<JaggaerSubmissions_Order_By>;
  jaggaerSubmissionId?: InputMaybe<Order_By>;
  newerNotificationId?: InputMaybe<Order_By>;
  notificationAction?: InputMaybe<Order_By>;
  notificationMessages_aggregate?: InputMaybe<NotificationMessages_Aggregate_Order_By>;
  readAt?: InputMaybe<Order_By>;
  room?: InputMaybe<Rooms_Order_By>;
  roomAttributeValue?: InputMaybe<RoomAttributeValues_Order_By>;
  roomAttributeValueComment?: InputMaybe<RoomAttributeValueComments_Order_By>;
  roomAttributeValueCommentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomService?: InputMaybe<RoomServices_Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
  roomServiceOccurrence?: InputMaybe<RoomServiceOccurrences_Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  service?: InputMaybe<Services_Order_By>;
  serviceId?: InputMaybe<Order_By>;
  serviceModule?: InputMaybe<ServiceModules_Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  uploadComment?: InputMaybe<UploadComments_Order_By>;
  uploadCommentId?: InputMaybe<Order_By>;
  uploadVersion?: InputMaybe<UploadVersions_Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  user?: InputMaybe<AllUsers_Order_By>;
  userByUserid?: InputMaybe<AllUsers_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "notifications" */
export enum Notifications_Select_Column {
  /** column name */
  AttributeValueCommentId = 'attributeValueCommentId',
  /** column name */
  AttributeValueId = 'attributeValueId',
  /** column name */
  AuthorUserId = 'authorUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  EventAttributeValueId = 'eventAttributeValueId',
  /** column name */
  EventId = 'eventId',
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  JaggaerSubmissionId = 'jaggaerSubmissionId',
  /** column name */
  NewerNotificationId = 'newerNotificationId',
  /** column name */
  NotificationAction = 'notificationAction',
  /** column name */
  ReadAt = 'readAt',
  /** column name */
  RoomAttributeValueCommentId = 'roomAttributeValueCommentId',
  /** column name */
  RoomAttributeValueId = 'roomAttributeValueId',
  /** column name */
  RoomId = 'roomId',
  /** column name */
  RoomServiceId = 'roomServiceId',
  /** column name */
  RoomServiceOccurrenceId = 'roomServiceOccurrenceId',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  ServiceModuleId = 'serviceModuleId',
  /** column name */
  UploadCommentId = 'uploadCommentId',
  /** column name */
  UploadVersionId = 'uploadVersionId',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type Notifications_Stddev_Fields = {
  __typename?: 'notifications_stddev_fields';
  attributeValueCommentId?: Maybe<Scalars['Float']['output']>;
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  authorUserId?: Maybe<Scalars['Float']['output']>;
  eventAttributeValueId?: Maybe<Scalars['Float']['output']>;
  eventId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  jaggaerSubmissionId?: Maybe<Scalars['Float']['output']>;
  newerNotificationId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueCommentId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
  roomId?: Maybe<Scalars['Float']['output']>;
  roomServiceId?: Maybe<Scalars['Float']['output']>;
  roomServiceOccurrenceId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  uploadCommentId?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "notifications" */
export type Notifications_Stddev_Order_By = {
  attributeValueCommentId?: InputMaybe<Order_By>;
  attributeValueId?: InputMaybe<Order_By>;
  authorUserId?: InputMaybe<Order_By>;
  eventAttributeValueId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jaggaerSubmissionId?: InputMaybe<Order_By>;
  newerNotificationId?: InputMaybe<Order_By>;
  roomAttributeValueCommentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  uploadCommentId?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Notifications_Stddev_Pop_Fields = {
  __typename?: 'notifications_stddev_pop_fields';
  attributeValueCommentId?: Maybe<Scalars['Float']['output']>;
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  authorUserId?: Maybe<Scalars['Float']['output']>;
  eventAttributeValueId?: Maybe<Scalars['Float']['output']>;
  eventId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  jaggaerSubmissionId?: Maybe<Scalars['Float']['output']>;
  newerNotificationId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueCommentId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
  roomId?: Maybe<Scalars['Float']['output']>;
  roomServiceId?: Maybe<Scalars['Float']['output']>;
  roomServiceOccurrenceId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  uploadCommentId?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "notifications" */
export type Notifications_Stddev_Pop_Order_By = {
  attributeValueCommentId?: InputMaybe<Order_By>;
  attributeValueId?: InputMaybe<Order_By>;
  authorUserId?: InputMaybe<Order_By>;
  eventAttributeValueId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jaggaerSubmissionId?: InputMaybe<Order_By>;
  newerNotificationId?: InputMaybe<Order_By>;
  roomAttributeValueCommentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  uploadCommentId?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Notifications_Stddev_Samp_Fields = {
  __typename?: 'notifications_stddev_samp_fields';
  attributeValueCommentId?: Maybe<Scalars['Float']['output']>;
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  authorUserId?: Maybe<Scalars['Float']['output']>;
  eventAttributeValueId?: Maybe<Scalars['Float']['output']>;
  eventId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  jaggaerSubmissionId?: Maybe<Scalars['Float']['output']>;
  newerNotificationId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueCommentId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
  roomId?: Maybe<Scalars['Float']['output']>;
  roomServiceId?: Maybe<Scalars['Float']['output']>;
  roomServiceOccurrenceId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  uploadCommentId?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "notifications" */
export type Notifications_Stddev_Samp_Order_By = {
  attributeValueCommentId?: InputMaybe<Order_By>;
  attributeValueId?: InputMaybe<Order_By>;
  authorUserId?: InputMaybe<Order_By>;
  eventAttributeValueId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jaggaerSubmissionId?: InputMaybe<Order_By>;
  newerNotificationId?: InputMaybe<Order_By>;
  roomAttributeValueCommentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  uploadCommentId?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "notifications" */
export type Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notifications_Stream_Cursor_Value_Input = {
  attributeValueCommentId?: InputMaybe<Scalars['bigint']['input']>;
  attributeValueId?: InputMaybe<Scalars['bigint']['input']>;
  authorUserId?: InputMaybe<Scalars['bigint']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['json']['input']>;
  eventAttributeValueId?: InputMaybe<Scalars['bigint']['input']>;
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  fileId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  jaggaerSubmissionId?: InputMaybe<Scalars['bigint']['input']>;
  newerNotificationId?: InputMaybe<Scalars['bigint']['input']>;
  notificationAction?: InputMaybe<NotificationActions_Enum>;
  readAt?: InputMaybe<Scalars['timestamptz']['input']>;
  roomAttributeValueCommentId?: InputMaybe<Scalars['bigint']['input']>;
  roomAttributeValueId?: InputMaybe<Scalars['bigint']['input']>;
  roomId?: InputMaybe<Scalars['bigint']['input']>;
  roomServiceId?: InputMaybe<Scalars['bigint']['input']>;
  roomServiceOccurrenceId?: InputMaybe<Scalars['bigint']['input']>;
  serviceId?: InputMaybe<Scalars['bigint']['input']>;
  serviceModuleId?: InputMaybe<Scalars['bigint']['input']>;
  uploadCommentId?: InputMaybe<Scalars['bigint']['input']>;
  uploadVersionId?: InputMaybe<Scalars['bigint']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type Notifications_Sum_Fields = {
  __typename?: 'notifications_sum_fields';
  attributeValueCommentId?: Maybe<Scalars['bigint']['output']>;
  attributeValueId?: Maybe<Scalars['bigint']['output']>;
  authorUserId?: Maybe<Scalars['bigint']['output']>;
  eventAttributeValueId?: Maybe<Scalars['bigint']['output']>;
  eventId?: Maybe<Scalars['bigint']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  jaggaerSubmissionId?: Maybe<Scalars['bigint']['output']>;
  newerNotificationId?: Maybe<Scalars['bigint']['output']>;
  roomAttributeValueCommentId?: Maybe<Scalars['bigint']['output']>;
  roomAttributeValueId?: Maybe<Scalars['bigint']['output']>;
  roomId?: Maybe<Scalars['bigint']['output']>;
  roomServiceId?: Maybe<Scalars['bigint']['output']>;
  roomServiceOccurrenceId?: Maybe<Scalars['bigint']['output']>;
  serviceId?: Maybe<Scalars['bigint']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  uploadCommentId?: Maybe<Scalars['bigint']['output']>;
  uploadVersionId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "notifications" */
export type Notifications_Sum_Order_By = {
  attributeValueCommentId?: InputMaybe<Order_By>;
  attributeValueId?: InputMaybe<Order_By>;
  authorUserId?: InputMaybe<Order_By>;
  eventAttributeValueId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jaggaerSubmissionId?: InputMaybe<Order_By>;
  newerNotificationId?: InputMaybe<Order_By>;
  roomAttributeValueCommentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  uploadCommentId?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Notifications_Var_Pop_Fields = {
  __typename?: 'notifications_var_pop_fields';
  attributeValueCommentId?: Maybe<Scalars['Float']['output']>;
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  authorUserId?: Maybe<Scalars['Float']['output']>;
  eventAttributeValueId?: Maybe<Scalars['Float']['output']>;
  eventId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  jaggaerSubmissionId?: Maybe<Scalars['Float']['output']>;
  newerNotificationId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueCommentId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
  roomId?: Maybe<Scalars['Float']['output']>;
  roomServiceId?: Maybe<Scalars['Float']['output']>;
  roomServiceOccurrenceId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  uploadCommentId?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "notifications" */
export type Notifications_Var_Pop_Order_By = {
  attributeValueCommentId?: InputMaybe<Order_By>;
  attributeValueId?: InputMaybe<Order_By>;
  authorUserId?: InputMaybe<Order_By>;
  eventAttributeValueId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jaggaerSubmissionId?: InputMaybe<Order_By>;
  newerNotificationId?: InputMaybe<Order_By>;
  roomAttributeValueCommentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  uploadCommentId?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Notifications_Var_Samp_Fields = {
  __typename?: 'notifications_var_samp_fields';
  attributeValueCommentId?: Maybe<Scalars['Float']['output']>;
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  authorUserId?: Maybe<Scalars['Float']['output']>;
  eventAttributeValueId?: Maybe<Scalars['Float']['output']>;
  eventId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  jaggaerSubmissionId?: Maybe<Scalars['Float']['output']>;
  newerNotificationId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueCommentId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
  roomId?: Maybe<Scalars['Float']['output']>;
  roomServiceId?: Maybe<Scalars['Float']['output']>;
  roomServiceOccurrenceId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  uploadCommentId?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "notifications" */
export type Notifications_Var_Samp_Order_By = {
  attributeValueCommentId?: InputMaybe<Order_By>;
  attributeValueId?: InputMaybe<Order_By>;
  authorUserId?: InputMaybe<Order_By>;
  eventAttributeValueId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jaggaerSubmissionId?: InputMaybe<Order_By>;
  newerNotificationId?: InputMaybe<Order_By>;
  roomAttributeValueCommentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  uploadCommentId?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Notifications_Variance_Fields = {
  __typename?: 'notifications_variance_fields';
  attributeValueCommentId?: Maybe<Scalars['Float']['output']>;
  attributeValueId?: Maybe<Scalars['Float']['output']>;
  authorUserId?: Maybe<Scalars['Float']['output']>;
  eventAttributeValueId?: Maybe<Scalars['Float']['output']>;
  eventId?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  jaggaerSubmissionId?: Maybe<Scalars['Float']['output']>;
  newerNotificationId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueCommentId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
  roomId?: Maybe<Scalars['Float']['output']>;
  roomServiceId?: Maybe<Scalars['Float']['output']>;
  roomServiceOccurrenceId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  uploadCommentId?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "notifications" */
export type Notifications_Variance_Order_By = {
  attributeValueCommentId?: InputMaybe<Order_By>;
  attributeValueId?: InputMaybe<Order_By>;
  authorUserId?: InputMaybe<Order_By>;
  eventAttributeValueId?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jaggaerSubmissionId?: InputMaybe<Order_By>;
  newerNotificationId?: InputMaybe<Order_By>;
  roomAttributeValueCommentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  uploadCommentId?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "orders" */
export type Orders = {
  __typename?: 'orders';
  createdAt: Scalars['timestamptz']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  serviceModule: ServiceModules;
  serviceModuleId: Scalars['bigint']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "orders" */
export type Orders_Aggregate = {
  __typename?: 'orders_aggregate';
  aggregate?: Maybe<Orders_Aggregate_Fields>;
  nodes: Array<Orders>;
};

export type Orders_Aggregate_Bool_Exp = {
  count?: InputMaybe<Orders_Aggregate_Bool_Exp_Count>;
};

export type Orders_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Orders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Orders_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "orders" */
export type Orders_Aggregate_Fields = {
  __typename?: 'orders_aggregate_fields';
  avg?: Maybe<Orders_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Orders_Max_Fields>;
  min?: Maybe<Orders_Min_Fields>;
  stddev?: Maybe<Orders_Stddev_Fields>;
  stddev_pop?: Maybe<Orders_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Orders_Stddev_Samp_Fields>;
  sum?: Maybe<Orders_Sum_Fields>;
  var_pop?: Maybe<Orders_Var_Pop_Fields>;
  var_samp?: Maybe<Orders_Var_Samp_Fields>;
  variance?: Maybe<Orders_Variance_Fields>;
};


/** aggregate fields of "orders" */
export type Orders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Orders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "orders" */
export type Orders_Aggregate_Order_By = {
  avg?: InputMaybe<Orders_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Orders_Max_Order_By>;
  min?: InputMaybe<Orders_Min_Order_By>;
  stddev?: InputMaybe<Orders_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Orders_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Orders_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Orders_Sum_Order_By>;
  var_pop?: InputMaybe<Orders_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Orders_Var_Samp_Order_By>;
  variance?: InputMaybe<Orders_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "orders" */
export type Orders_Arr_Rel_Insert_Input = {
  data: Array<Orders_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Orders_On_Conflict>;
};

/** aggregate avg on columns */
export type Orders_Avg_Fields = {
  __typename?: 'orders_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "orders" */
export type Orders_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "orders". All fields are combined with a logical 'AND'. */
export type Orders_Bool_Exp = {
  _and?: InputMaybe<Array<Orders_Bool_Exp>>;
  _not?: InputMaybe<Orders_Bool_Exp>;
  _or?: InputMaybe<Array<Orders_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  externalId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  serviceModule?: InputMaybe<ServiceModules_Bool_Exp>;
  serviceModuleId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "orders" */
export enum Orders_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrdersPkey = 'orders_pkey'
}

/** input type for inserting data into table "orders" */
export type Orders_Insert_Input = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  serviceModule?: InputMaybe<ServiceModules_Obj_Rel_Insert_Input>;
  serviceModuleId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type Orders_Max_Fields = {
  __typename?: 'orders_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "orders" */
export type Orders_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  externalId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Orders_Min_Fields = {
  __typename?: 'orders_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "orders" */
export type Orders_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  externalId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "orders" */
export type Orders_Mutation_Response = {
  __typename?: 'orders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Orders>;
};

/** on_conflict condition type for table "orders" */
export type Orders_On_Conflict = {
  constraint: Orders_Constraint;
  update_columns?: Array<Orders_Update_Column>;
  where?: InputMaybe<Orders_Bool_Exp>;
};

/** Ordering options when selecting data from "orders". */
export type Orders_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  externalId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  serviceModule?: InputMaybe<ServiceModules_Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: orders */
export type Orders_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "orders" */
export enum Orders_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExternalId = 'externalId',
  /** column name */
  Id = 'id',
  /** column name */
  ServiceModuleId = 'serviceModuleId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "orders" */
export type Orders_Set_Input = {
  externalId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Orders_Stddev_Fields = {
  __typename?: 'orders_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "orders" */
export type Orders_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Orders_Stddev_Pop_Fields = {
  __typename?: 'orders_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "orders" */
export type Orders_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Orders_Stddev_Samp_Fields = {
  __typename?: 'orders_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "orders" */
export type Orders_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "orders" */
export type Orders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Orders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Orders_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  serviceModuleId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Orders_Sum_Fields = {
  __typename?: 'orders_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "orders" */
export type Orders_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** update columns of table "orders" */
export enum Orders_Update_Column {
  /** column name */
  ExternalId = 'externalId'
}

export type Orders_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Orders_Set_Input>;
  /** filter the rows which have to be updated */
  where: Orders_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Orders_Var_Pop_Fields = {
  __typename?: 'orders_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "orders" */
export type Orders_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Orders_Var_Samp_Fields = {
  __typename?: 'orders_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "orders" */
export type Orders_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Orders_Variance_Fields = {
  __typename?: 'orders_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "orders" */
export type Orders_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** columns and relationships of "organisationGroupUsers" */
export type OrganisationGroupUsers = {
  __typename?: 'organisationGroupUsers';
  /** An object relationship */
  organisationGroup: OrganisationGroups;
  organisationGroupId: Scalars['bigint']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['bigint']['output'];
};

/** aggregated selection of "organisationGroupUsers" */
export type OrganisationGroupUsers_Aggregate = {
  __typename?: 'organisationGroupUsers_aggregate';
  aggregate?: Maybe<OrganisationGroupUsers_Aggregate_Fields>;
  nodes: Array<OrganisationGroupUsers>;
};

export type OrganisationGroupUsers_Aggregate_Bool_Exp = {
  count?: InputMaybe<OrganisationGroupUsers_Aggregate_Bool_Exp_Count>;
};

export type OrganisationGroupUsers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<OrganisationGroupUsers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationGroupUsers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organisationGroupUsers" */
export type OrganisationGroupUsers_Aggregate_Fields = {
  __typename?: 'organisationGroupUsers_aggregate_fields';
  avg?: Maybe<OrganisationGroupUsers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<OrganisationGroupUsers_Max_Fields>;
  min?: Maybe<OrganisationGroupUsers_Min_Fields>;
  stddev?: Maybe<OrganisationGroupUsers_Stddev_Fields>;
  stddev_pop?: Maybe<OrganisationGroupUsers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<OrganisationGroupUsers_Stddev_Samp_Fields>;
  sum?: Maybe<OrganisationGroupUsers_Sum_Fields>;
  var_pop?: Maybe<OrganisationGroupUsers_Var_Pop_Fields>;
  var_samp?: Maybe<OrganisationGroupUsers_Var_Samp_Fields>;
  variance?: Maybe<OrganisationGroupUsers_Variance_Fields>;
};


/** aggregate fields of "organisationGroupUsers" */
export type OrganisationGroupUsers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<OrganisationGroupUsers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organisationGroupUsers" */
export type OrganisationGroupUsers_Aggregate_Order_By = {
  avg?: InputMaybe<OrganisationGroupUsers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<OrganisationGroupUsers_Max_Order_By>;
  min?: InputMaybe<OrganisationGroupUsers_Min_Order_By>;
  stddev?: InputMaybe<OrganisationGroupUsers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<OrganisationGroupUsers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<OrganisationGroupUsers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<OrganisationGroupUsers_Sum_Order_By>;
  var_pop?: InputMaybe<OrganisationGroupUsers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<OrganisationGroupUsers_Var_Samp_Order_By>;
  variance?: InputMaybe<OrganisationGroupUsers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organisationGroupUsers" */
export type OrganisationGroupUsers_Arr_Rel_Insert_Input = {
  data: Array<OrganisationGroupUsers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationGroupUsers_On_Conflict>;
};

/** aggregate avg on columns */
export type OrganisationGroupUsers_Avg_Fields = {
  __typename?: 'organisationGroupUsers_avg_fields';
  organisationGroupId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "organisationGroupUsers" */
export type OrganisationGroupUsers_Avg_Order_By = {
  organisationGroupId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organisationGroupUsers". All fields are combined with a logical 'AND'. */
export type OrganisationGroupUsers_Bool_Exp = {
  _and?: InputMaybe<Array<OrganisationGroupUsers_Bool_Exp>>;
  _not?: InputMaybe<OrganisationGroupUsers_Bool_Exp>;
  _or?: InputMaybe<Array<OrganisationGroupUsers_Bool_Exp>>;
  organisationGroup?: InputMaybe<OrganisationGroups_Bool_Exp>;
  organisationGroupId?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisationGroupUsers" */
export enum OrganisationGroupUsers_Constraint {
  /** unique or primary key constraint on columns "userId", "organisationGroupId" */
  OrganisationGroupUsersPkey = 'organisationGroupUsers_pkey'
}

/** input type for inserting data into table "organisationGroupUsers" */
export type OrganisationGroupUsers_Insert_Input = {
  organisationGroup?: InputMaybe<OrganisationGroups_Obj_Rel_Insert_Input>;
  organisationGroupId?: InputMaybe<Scalars['bigint']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type OrganisationGroupUsers_Max_Fields = {
  __typename?: 'organisationGroupUsers_max_fields';
  organisationGroupId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "organisationGroupUsers" */
export type OrganisationGroupUsers_Max_Order_By = {
  organisationGroupId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type OrganisationGroupUsers_Min_Fields = {
  __typename?: 'organisationGroupUsers_min_fields';
  organisationGroupId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "organisationGroupUsers" */
export type OrganisationGroupUsers_Min_Order_By = {
  organisationGroupId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organisationGroupUsers" */
export type OrganisationGroupUsers_Mutation_Response = {
  __typename?: 'organisationGroupUsers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationGroupUsers>;
};

/** on_conflict condition type for table "organisationGroupUsers" */
export type OrganisationGroupUsers_On_Conflict = {
  constraint: OrganisationGroupUsers_Constraint;
  update_columns?: Array<OrganisationGroupUsers_Update_Column>;
  where?: InputMaybe<OrganisationGroupUsers_Bool_Exp>;
};

/** Ordering options when selecting data from "organisationGroupUsers". */
export type OrganisationGroupUsers_Order_By = {
  organisationGroup?: InputMaybe<OrganisationGroups_Order_By>;
  organisationGroupId?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "organisationGroupUsers" */
export enum OrganisationGroupUsers_Select_Column {
  /** column name */
  OrganisationGroupId = 'organisationGroupId',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type OrganisationGroupUsers_Stddev_Fields = {
  __typename?: 'organisationGroupUsers_stddev_fields';
  organisationGroupId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "organisationGroupUsers" */
export type OrganisationGroupUsers_Stddev_Order_By = {
  organisationGroupId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type OrganisationGroupUsers_Stddev_Pop_Fields = {
  __typename?: 'organisationGroupUsers_stddev_pop_fields';
  organisationGroupId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "organisationGroupUsers" */
export type OrganisationGroupUsers_Stddev_Pop_Order_By = {
  organisationGroupId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type OrganisationGroupUsers_Stddev_Samp_Fields = {
  __typename?: 'organisationGroupUsers_stddev_samp_fields';
  organisationGroupId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "organisationGroupUsers" */
export type OrganisationGroupUsers_Stddev_Samp_Order_By = {
  organisationGroupId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organisationGroupUsers" */
export type OrganisationGroupUsers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: OrganisationGroupUsers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganisationGroupUsers_Stream_Cursor_Value_Input = {
  organisationGroupId?: InputMaybe<Scalars['bigint']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type OrganisationGroupUsers_Sum_Fields = {
  __typename?: 'organisationGroupUsers_sum_fields';
  organisationGroupId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "organisationGroupUsers" */
export type OrganisationGroupUsers_Sum_Order_By = {
  organisationGroupId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "organisationGroupUsers" (current role has no relevant permissions) */
export enum OrganisationGroupUsers_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type OrganisationGroupUsers_Var_Pop_Fields = {
  __typename?: 'organisationGroupUsers_var_pop_fields';
  organisationGroupId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "organisationGroupUsers" */
export type OrganisationGroupUsers_Var_Pop_Order_By = {
  organisationGroupId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type OrganisationGroupUsers_Var_Samp_Fields = {
  __typename?: 'organisationGroupUsers_var_samp_fields';
  organisationGroupId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "organisationGroupUsers" */
export type OrganisationGroupUsers_Var_Samp_Order_By = {
  organisationGroupId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type OrganisationGroupUsers_Variance_Fields = {
  __typename?: 'organisationGroupUsers_variance_fields';
  organisationGroupId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "organisationGroupUsers" */
export type OrganisationGroupUsers_Variance_Order_By = {
  organisationGroupId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "organisationGroups" */
export type OrganisationGroups = {
  __typename?: 'organisationGroups';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isOrgaAdmin: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organisation?: Maybe<Organisations>;
  /** An array relationship */
  organisationGroupUsers: Array<OrganisationGroupUsers>;
  /** An aggregate relationship */
  organisationGroupUsers_aggregate: OrganisationGroupUsers_Aggregate;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "organisationGroups" */
export type OrganisationGroupsOrganisationGroupUsersArgs = {
  distinct_on?: InputMaybe<Array<OrganisationGroupUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<OrganisationGroupUsers_Order_By>>;
  where?: InputMaybe<OrganisationGroupUsers_Bool_Exp>;
};


/** columns and relationships of "organisationGroups" */
export type OrganisationGroupsOrganisationGroupUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganisationGroupUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<OrganisationGroupUsers_Order_By>>;
  where?: InputMaybe<OrganisationGroupUsers_Bool_Exp>;
};

/** aggregated selection of "organisationGroups" */
export type OrganisationGroups_Aggregate = {
  __typename?: 'organisationGroups_aggregate';
  aggregate?: Maybe<OrganisationGroups_Aggregate_Fields>;
  nodes: Array<OrganisationGroups>;
};

export type OrganisationGroups_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<OrganisationGroups_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<OrganisationGroups_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<OrganisationGroups_Aggregate_Bool_Exp_Count>;
};

export type OrganisationGroups_Aggregate_Bool_Exp_Bool_And = {
  arguments: OrganisationGroups_Select_Column_OrganisationGroups_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationGroups_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type OrganisationGroups_Aggregate_Bool_Exp_Bool_Or = {
  arguments: OrganisationGroups_Select_Column_OrganisationGroups_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationGroups_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type OrganisationGroups_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<OrganisationGroups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OrganisationGroups_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organisationGroups" */
export type OrganisationGroups_Aggregate_Fields = {
  __typename?: 'organisationGroups_aggregate_fields';
  avg?: Maybe<OrganisationGroups_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<OrganisationGroups_Max_Fields>;
  min?: Maybe<OrganisationGroups_Min_Fields>;
  stddev?: Maybe<OrganisationGroups_Stddev_Fields>;
  stddev_pop?: Maybe<OrganisationGroups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<OrganisationGroups_Stddev_Samp_Fields>;
  sum?: Maybe<OrganisationGroups_Sum_Fields>;
  var_pop?: Maybe<OrganisationGroups_Var_Pop_Fields>;
  var_samp?: Maybe<OrganisationGroups_Var_Samp_Fields>;
  variance?: Maybe<OrganisationGroups_Variance_Fields>;
};


/** aggregate fields of "organisationGroups" */
export type OrganisationGroups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<OrganisationGroups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "organisationGroups" */
export type OrganisationGroups_Aggregate_Order_By = {
  avg?: InputMaybe<OrganisationGroups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<OrganisationGroups_Max_Order_By>;
  min?: InputMaybe<OrganisationGroups_Min_Order_By>;
  stddev?: InputMaybe<OrganisationGroups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<OrganisationGroups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<OrganisationGroups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<OrganisationGroups_Sum_Order_By>;
  var_pop?: InputMaybe<OrganisationGroups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<OrganisationGroups_Var_Samp_Order_By>;
  variance?: InputMaybe<OrganisationGroups_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organisationGroups" */
export type OrganisationGroups_Arr_Rel_Insert_Input = {
  data: Array<OrganisationGroups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationGroups_On_Conflict>;
};

/** aggregate avg on columns */
export type OrganisationGroups_Avg_Fields = {
  __typename?: 'organisationGroups_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "organisationGroups" */
export type OrganisationGroups_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organisationGroups". All fields are combined with a logical 'AND'. */
export type OrganisationGroups_Bool_Exp = {
  _and?: InputMaybe<Array<OrganisationGroups_Bool_Exp>>;
  _not?: InputMaybe<OrganisationGroups_Bool_Exp>;
  _or?: InputMaybe<Array<OrganisationGroups_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  isAdmin?: InputMaybe<Boolean_Comparison_Exp>;
  isOrgaAdmin?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisationGroupUsers?: InputMaybe<OrganisationGroupUsers_Bool_Exp>;
  organisationGroupUsers_aggregate?: InputMaybe<OrganisationGroupUsers_Aggregate_Bool_Exp>;
  organisationId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisationGroups" */
export enum OrganisationGroups_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganisationGroupsPkey = 'organisationGroups_pkey'
}

/** input type for inserting data into table "organisationGroups" */
export type OrganisationGroups_Insert_Input = {
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isOrgaAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  organisationGroupUsers?: InputMaybe<OrganisationGroupUsers_Arr_Rel_Insert_Input>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type OrganisationGroups_Max_Fields = {
  __typename?: 'organisationGroups_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "organisationGroups" */
export type OrganisationGroups_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type OrganisationGroups_Min_Fields = {
  __typename?: 'organisationGroups_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "organisationGroups" */
export type OrganisationGroups_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organisationGroups" */
export type OrganisationGroups_Mutation_Response = {
  __typename?: 'organisationGroups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganisationGroups>;
};

/** input type for inserting object relation for remote table "organisationGroups" */
export type OrganisationGroups_Obj_Rel_Insert_Input = {
  data: OrganisationGroups_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<OrganisationGroups_On_Conflict>;
};

/** on_conflict condition type for table "organisationGroups" */
export type OrganisationGroups_On_Conflict = {
  constraint: OrganisationGroups_Constraint;
  update_columns?: Array<OrganisationGroups_Update_Column>;
  where?: InputMaybe<OrganisationGroups_Bool_Exp>;
};

/** Ordering options when selecting data from "organisationGroups". */
export type OrganisationGroups_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isAdmin?: InputMaybe<Order_By>;
  isOrgaAdmin?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisations_Order_By>;
  organisationGroupUsers_aggregate?: InputMaybe<OrganisationGroupUsers_Aggregate_Order_By>;
  organisationId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisationGroups */
export type OrganisationGroups_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "organisationGroups" */
export enum OrganisationGroups_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsAdmin = 'isAdmin',
  /** column name */
  IsOrgaAdmin = 'isOrgaAdmin',
  /** column name */
  Name = 'name',
  /** column name */
  OrganisationId = 'organisationId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "organisationGroups_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organisationGroups" */
export enum OrganisationGroups_Select_Column_OrganisationGroups_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsAdmin = 'isAdmin',
  /** column name */
  IsOrgaAdmin = 'isOrgaAdmin'
}

/** select "organisationGroups_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organisationGroups" */
export enum OrganisationGroups_Select_Column_OrganisationGroups_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsAdmin = 'isAdmin',
  /** column name */
  IsOrgaAdmin = 'isOrgaAdmin'
}

/** input type for updating data in table "organisationGroups" */
export type OrganisationGroups_Set_Input = {
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isOrgaAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type OrganisationGroups_Stddev_Fields = {
  __typename?: 'organisationGroups_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "organisationGroups" */
export type OrganisationGroups_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type OrganisationGroups_Stddev_Pop_Fields = {
  __typename?: 'organisationGroups_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "organisationGroups" */
export type OrganisationGroups_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type OrganisationGroups_Stddev_Samp_Fields = {
  __typename?: 'organisationGroups_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "organisationGroups" */
export type OrganisationGroups_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organisationGroups" */
export type OrganisationGroups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: OrganisationGroups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganisationGroups_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isOrgaAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type OrganisationGroups_Sum_Fields = {
  __typename?: 'organisationGroups_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "organisationGroups" */
export type OrganisationGroups_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
};

/** update columns of table "organisationGroups" */
export enum OrganisationGroups_Update_Column {
  /** column name */
  IsAdmin = 'isAdmin',
  /** column name */
  IsOrgaAdmin = 'isOrgaAdmin',
  /** column name */
  Name = 'name'
}

export type OrganisationGroups_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganisationGroups_Set_Input>;
  /** filter the rows which have to be updated */
  where: OrganisationGroups_Bool_Exp;
};

/** aggregate var_pop on columns */
export type OrganisationGroups_Var_Pop_Fields = {
  __typename?: 'organisationGroups_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "organisationGroups" */
export type OrganisationGroups_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type OrganisationGroups_Var_Samp_Fields = {
  __typename?: 'organisationGroups_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "organisationGroups" */
export type OrganisationGroups_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type OrganisationGroups_Variance_Fields = {
  __typename?: 'organisationGroups_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "organisationGroups" */
export type OrganisationGroups_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
};

/** columns and relationships of "organisations" */
export type Organisations = {
  __typename?: 'organisations';
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  guestEvents: Array<Events>;
  /** An aggregate relationship */
  guestEvents_aggregate: Events_Aggregate;
  id: Scalars['bigint']['output'];
  isDisabled?: Maybe<Scalars['timestamptz']['output']>;
  isGuestOrga: Scalars['Boolean']['output'];
  /** A computed field, executes function "organisations_isMentionable" */
  isMentionable?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  organisationGroups: Array<OrganisationGroups>;
  /** An aggregate relationship */
  organisationGroups_aggregate: OrganisationGroups_Aggregate;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
};


/** columns and relationships of "organisations" */
export type OrganisationsGuestEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsGuestEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsOrganisationGroupsArgs = {
  distinct_on?: InputMaybe<Array<OrganisationGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<OrganisationGroups_Order_By>>;
  where?: InputMaybe<OrganisationGroups_Bool_Exp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsOrganisationGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganisationGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<OrganisationGroups_Order_By>>;
  where?: InputMaybe<OrganisationGroups_Bool_Exp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "organisations" */
export type OrganisationsUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** aggregated selection of "organisations" */
export type Organisations_Aggregate = {
  __typename?: 'organisations_aggregate';
  aggregate?: Maybe<Organisations_Aggregate_Fields>;
  nodes: Array<Organisations>;
};

/** aggregate fields of "organisations" */
export type Organisations_Aggregate_Fields = {
  __typename?: 'organisations_aggregate_fields';
  avg?: Maybe<Organisations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organisations_Max_Fields>;
  min?: Maybe<Organisations_Min_Fields>;
  stddev?: Maybe<Organisations_Stddev_Fields>;
  stddev_pop?: Maybe<Organisations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisations_Stddev_Samp_Fields>;
  sum?: Maybe<Organisations_Sum_Fields>;
  var_pop?: Maybe<Organisations_Var_Pop_Fields>;
  var_samp?: Maybe<Organisations_Var_Samp_Fields>;
  variance?: Maybe<Organisations_Variance_Fields>;
};


/** aggregate fields of "organisations" */
export type Organisations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Organisations_Avg_Fields = {
  __typename?: 'organisations_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "organisations". All fields are combined with a logical 'AND'. */
export type Organisations_Bool_Exp = {
  _and?: InputMaybe<Array<Organisations_Bool_Exp>>;
  _not?: InputMaybe<Organisations_Bool_Exp>;
  _or?: InputMaybe<Array<Organisations_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  guestEvents?: InputMaybe<Events_Bool_Exp>;
  guestEvents_aggregate?: InputMaybe<Events_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  isDisabled?: InputMaybe<Timestamptz_Comparison_Exp>;
  isGuestOrga?: InputMaybe<Boolean_Comparison_Exp>;
  isMentionable?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisationGroups?: InputMaybe<OrganisationGroups_Bool_Exp>;
  organisationGroups_aggregate?: InputMaybe<OrganisationGroups_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  users?: InputMaybe<Users_Bool_Exp>;
  users_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "organisations" */
export enum Organisations_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganisationsPkey = 'organisations_pkey'
}

/** input type for inserting data into table "organisations" */
export type Organisations_Insert_Input = {
  guestEvents?: InputMaybe<Events_Arr_Rel_Insert_Input>;
  isDisabled?: InputMaybe<Scalars['timestamptz']['input']>;
  isGuestOrga?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationGroups?: InputMaybe<OrganisationGroups_Arr_Rel_Insert_Input>;
  users?: InputMaybe<Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Organisations_Max_Fields = {
  __typename?: 'organisations_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  isDisabled?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Organisations_Min_Fields = {
  __typename?: 'organisations_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  isDisabled?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "organisations" */
export type Organisations_Mutation_Response = {
  __typename?: 'organisations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisations>;
};

/** input type for inserting object relation for remote table "organisations" */
export type Organisations_Obj_Rel_Insert_Input = {
  data: Organisations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organisations_On_Conflict>;
};

/** on_conflict condition type for table "organisations" */
export type Organisations_On_Conflict = {
  constraint: Organisations_Constraint;
  update_columns?: Array<Organisations_Update_Column>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};

/** Ordering options when selecting data from "organisations". */
export type Organisations_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  guestEvents_aggregate?: InputMaybe<Events_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  isDisabled?: InputMaybe<Order_By>;
  isGuestOrga?: InputMaybe<Order_By>;
  isMentionable?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisationGroups_aggregate?: InputMaybe<OrganisationGroups_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
};

/** primary key columns input for table: organisations */
export type Organisations_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "organisations" */
export enum Organisations_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsDisabled = 'isDisabled',
  /** column name */
  IsGuestOrga = 'isGuestOrga',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "organisations" */
export type Organisations_Set_Input = {
  isDisabled?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Organisations_Stddev_Fields = {
  __typename?: 'organisations_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Organisations_Stddev_Pop_Fields = {
  __typename?: 'organisations_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Organisations_Stddev_Samp_Fields = {
  __typename?: 'organisations_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "organisations" */
export type Organisations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisations_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  isDisabled?: InputMaybe<Scalars['timestamptz']['input']>;
  isGuestOrga?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Organisations_Sum_Fields = {
  __typename?: 'organisations_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "organisations" */
export enum Organisations_Update_Column {
  /** column name */
  IsDisabled = 'isDisabled',
  /** column name */
  Name = 'name'
}

export type Organisations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organisations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organisations_Var_Pop_Fields = {
  __typename?: 'organisations_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Organisations_Var_Samp_Fields = {
  __typename?: 'organisations_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Organisations_Variance_Fields = {
  __typename?: 'organisations_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "V_ORGANICE_EVENT_RAUMBUCHUNG" */
  V_ORGANICE_EVENT_RAUMBUCHUNG: Array<V_Organice_Event_Raumbuchung>;
  /** fetch aggregated fields from the table: "V_ORGANICE_EVENT_RAUMBUCHUNG" */
  V_ORGANICE_EVENT_RAUMBUCHUNG_aggregate: V_Organice_Event_Raumbuchung_Aggregate;
  /** fetch data from the table: "V_ORGANICE_EVENT_RAUMBUCHUNG" using primary key columns */
  V_ORGANICE_EVENT_RAUMBUCHUNG_by_pk?: Maybe<V_Organice_Event_Raumbuchung>;
  /** fetch data from the table: "V_ORGANICE_EVENT_STAMM" */
  V_ORGANICE_EVENT_STAMM: Array<V_Organice_Event_Stamm>;
  /** fetch aggregated fields from the table: "V_ORGANICE_EVENT_STAMM" */
  V_ORGANICE_EVENT_STAMM_aggregate: V_Organice_Event_Stamm_Aggregate;
  /** fetch data from the table: "V_ORGANICE_EVENT_STAMM" using primary key columns */
  V_ORGANICE_EVENT_STAMM_by_pk?: Maybe<V_Organice_Event_Stamm>;
  /** fetch data from the table: "allUsers" */
  allUsers: Array<AllUsers>;
  /** fetch aggregated fields from the table: "allUsers" */
  allUsers_aggregate: AllUsers_Aggregate;
  /** fetch data from the table: "articles" */
  articles: Array<Articles>;
  /** fetch aggregated fields from the table: "articles" */
  articles_aggregate: Articles_Aggregate;
  /** fetch data from the table: "articles" using primary key columns */
  articles_by_pk?: Maybe<Articles>;
  /** An array relationship */
  attributeFiles: Array<AttributeFiles>;
  /** An aggregate relationship */
  attributeFiles_aggregate: AttributeFiles_Aggregate;
  /** fetch data from the table: "attributeFiles" using primary key columns */
  attributeFiles_by_pk?: Maybe<AttributeFiles>;
  /** An array relationship */
  attributeGroups: Array<AttributeGroups>;
  /** An aggregate relationship */
  attributeGroups_aggregate: AttributeGroups_Aggregate;
  /** fetch data from the table: "attributeGroups" using primary key columns */
  attributeGroups_by_pk?: Maybe<AttributeGroups>;
  /** fetch data from the table: "attributeTypes" */
  attributeTypes: Array<AttributeTypes>;
  /** fetch aggregated fields from the table: "attributeTypes" */
  attributeTypes_aggregate: AttributeTypes_Aggregate;
  /** fetch data from the table: "attributeTypes" using primary key columns */
  attributeTypes_by_pk?: Maybe<AttributeTypes>;
  /** fetch data from the table: "attributeValueComments" */
  attributeValueComments: Array<AttributeValueComments>;
  /** fetch aggregated fields from the table: "attributeValueComments" */
  attributeValueComments_aggregate: AttributeValueComments_Aggregate;
  /** fetch data from the table: "attributeValueComments" using primary key columns */
  attributeValueComments_by_pk?: Maybe<AttributeValueComments>;
  /** An array relationship */
  attributeValueGroups: Array<AttributeValueGroups>;
  /** An aggregate relationship */
  attributeValueGroups_aggregate: AttributeValueGroups_Aggregate;
  /** fetch data from the table: "attributeValueGroups" using primary key columns */
  attributeValueGroups_by_pk?: Maybe<AttributeValueGroups>;
  /** An array relationship */
  attributeValueUploadVersions: Array<AttributeValueUploadVersions>;
  /** An aggregate relationship */
  attributeValueUploadVersions_aggregate: AttributeValueUploadVersions_Aggregate;
  /** fetch data from the table: "attributeValueUploadVersions" using primary key columns */
  attributeValueUploadVersions_by_pk?: Maybe<AttributeValueUploadVersions>;
  /** An array relationship */
  attributeValueUploads: Array<AttributeValueUploads>;
  /** An aggregate relationship */
  attributeValueUploads_aggregate: AttributeValueUploads_Aggregate;
  /** fetch data from the table: "attributeValueUploads" using primary key columns */
  attributeValueUploads_by_pk?: Maybe<AttributeValueUploads>;
  /** An array relationship */
  attributeValues: Array<AttributeValues>;
  /** An aggregate relationship */
  attributeValues_aggregate: AttributeValues_Aggregate;
  /** fetch data from the table: "attributeValues" using primary key columns */
  attributeValues_by_pk?: Maybe<AttributeValues>;
  /** An array relationship */
  attributes: Array<Attributes>;
  /** An aggregate relationship */
  attributes_aggregate: Attributes_Aggregate;
  /** fetch data from the table: "attributes" using primary key columns */
  attributes_by_pk?: Maybe<Attributes>;
  /** An array relationship */
  cartLines: Array<CartLines>;
  /** An aggregate relationship */
  cartLines_aggregate: CartLines_Aggregate;
  /** fetch data from the table: "cartLines" using primary key columns */
  cartLines_by_pk?: Maybe<CartLines>;
  /** An array relationship */
  carts: Array<Carts>;
  /** An aggregate relationship */
  carts_aggregate: Carts_Aggregate;
  /** fetch data from the table: "carts" using primary key columns */
  carts_by_pk?: Maybe<Carts>;
  /** An array relationship */
  catalogFolderArticles: Array<CatalogFolderArticles>;
  /** An aggregate relationship */
  catalogFolderArticles_aggregate: CatalogFolderArticles_Aggregate;
  /** fetch data from the table: "catalogFolderArticles" using primary key columns */
  catalogFolderArticles_by_pk?: Maybe<CatalogFolderArticles>;
  /** An array relationship */
  catalogFolders: Array<CatalogFolders>;
  /** An aggregate relationship */
  catalogFolders_aggregate: CatalogFolders_Aggregate;
  /** fetch data from the table: "catalogFolders" using primary key columns */
  catalogFolders_by_pk?: Maybe<CatalogFolders>;
  /** execute function "currentUser" which returns "users" */
  currentUser?: Maybe<Users>;
  /** execute function "currentUser" and query aggregates on result of table type "users" */
  currentUser_aggregate: Users_Aggregate;
  /** fetch data from the table: "eventAttributeGroups" */
  eventAttributeGroups: Array<EventAttributeGroups>;
  /** fetch aggregated fields from the table: "eventAttributeGroups" */
  eventAttributeGroups_aggregate: EventAttributeGroups_Aggregate;
  /** fetch data from the table: "eventAttributeGroups" using primary key columns */
  eventAttributeGroups_by_pk?: Maybe<EventAttributeGroups>;
  /** An array relationship */
  eventAttributeValueUploadVersions: Array<EventAttributeValueUploadVersions>;
  /** An aggregate relationship */
  eventAttributeValueUploadVersions_aggregate: EventAttributeValueUploadVersions_Aggregate;
  /** fetch data from the table: "eventAttributeValueUploadVersions" using primary key columns */
  eventAttributeValueUploadVersions_by_pk?: Maybe<EventAttributeValueUploadVersions>;
  /** An array relationship */
  eventAttributeValueUploads: Array<EventAttributeValueUploads>;
  /** An aggregate relationship */
  eventAttributeValueUploads_aggregate: EventAttributeValueUploads_Aggregate;
  /** fetch data from the table: "eventAttributeValueUploads" using primary key columns */
  eventAttributeValueUploads_by_pk?: Maybe<EventAttributeValueUploads>;
  /** An array relationship */
  eventAttributeValues: Array<EventAttributeValues>;
  /** An aggregate relationship */
  eventAttributeValues_aggregate: EventAttributeValues_Aggregate;
  /** fetch data from the table: "eventAttributeValues" using primary key columns */
  eventAttributeValues_by_pk?: Maybe<EventAttributeValues>;
  /** An array relationship */
  eventAttributes: Array<EventAttributes>;
  /** An aggregate relationship */
  eventAttributes_aggregate: EventAttributes_Aggregate;
  /** fetch data from the table: "eventAttributes" using primary key columns */
  eventAttributes_by_pk?: Maybe<EventAttributes>;
  /** An array relationship */
  eventFavourites: Array<EventFavourites>;
  /** An aggregate relationship */
  eventFavourites_aggregate: EventFavourites_Aggregate;
  /** fetch data from the table: "eventFavourites" using primary key columns */
  eventFavourites_by_pk?: Maybe<EventFavourites>;
  /** An array relationship */
  eventOrganisers: Array<EventOrganisers>;
  /** An aggregate relationship */
  eventOrganisers_aggregate: EventOrganisers_Aggregate;
  /** fetch data from the table: "eventOrganisers" using primary key columns */
  eventOrganisers_by_pk?: Maybe<EventOrganisers>;
  /** An array relationship */
  eventRoomWatches: Array<EventRoomWatches>;
  /** An aggregate relationship */
  eventRoomWatches_aggregate: EventRoomWatches_Aggregate;
  /** fetch data from the table: "eventRoomWatches" using primary key columns */
  eventRoomWatches_by_pk?: Maybe<EventRoomWatches>;
  /** An array relationship */
  eventRooms: Array<EventRooms>;
  /** fetch data from the table: "eventRooms" using primary key columns */
  eventRooms_by_pk?: Maybe<EventRooms>;
  /** fetch data from the table: "eventTypes" */
  eventTypes: Array<EventTypes>;
  /** fetch aggregated fields from the table: "eventTypes" */
  eventTypes_aggregate: EventTypes_Aggregate;
  /** fetch data from the table: "eventTypes" using primary key columns */
  eventTypes_by_pk?: Maybe<EventTypes>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  events_aggregate: Events_Aggregate;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: Maybe<Events>;
  /** An array relationship */
  fileMasterVersions: Array<FileMasterVersions>;
  /** An aggregate relationship */
  fileMasterVersions_aggregate: FileMasterVersions_Aggregate;
  /** fetch data from the table: "fileMasterVersions" using primary key columns */
  fileMasterVersions_by_pk?: Maybe<FileMasterVersions>;
  /** fetch data from the table: "fileMasters" */
  fileMasters: Array<FileMasters>;
  /** fetch aggregated fields from the table: "fileMasters" */
  fileMasters_aggregate: FileMasters_Aggregate;
  /** fetch data from the table: "fileMasters" using primary key columns */
  fileMasters_by_pk?: Maybe<FileMasters>;
  /** An array relationship */
  files: Array<Files>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: Maybe<Files>;
  /** fetch data from the table: "infoBoxes" */
  infoBoxes: Array<InfoBoxes>;
  /** fetch aggregated fields from the table: "infoBoxes" */
  infoBoxes_aggregate: InfoBoxes_Aggregate;
  /** fetch data from the table: "infoBoxes" using primary key columns */
  infoBoxes_by_pk?: Maybe<InfoBoxes>;
  /** fetch data from the table: "infoNews" */
  infoNews: Array<InfoNews>;
  /** fetch aggregated fields from the table: "infoNews" */
  infoNews_aggregate: InfoNews_Aggregate;
  /** fetch data from the table: "infoNews" using primary key columns */
  infoNews_by_pk?: Maybe<InfoNews>;
  /** fetch data from the table: "jaggaerBanfs" */
  jaggaerBanfs: Array<JaggaerBanfs>;
  /** fetch aggregated fields from the table: "jaggaerBanfs" */
  jaggaerBanfs_aggregate: JaggaerBanfs_Aggregate;
  /** fetch data from the table: "jaggaerBanfs" using primary key columns */
  jaggaerBanfs_by_pk?: Maybe<JaggaerBanfs>;
  /** An array relationship */
  jaggaerSubmissions: Array<JaggaerSubmissions>;
  /** An aggregate relationship */
  jaggaerSubmissions_aggregate: JaggaerSubmissions_Aggregate;
  /** fetch data from the table: "jaggaerSubmissions" using primary key columns */
  jaggaerSubmissions_by_pk?: Maybe<JaggaerSubmissions>;
  /** fetch data from the table: "moduleTypes" */
  moduleTypes: Array<ModuleTypes>;
  /** fetch aggregated fields from the table: "moduleTypes" */
  moduleTypes_aggregate: ModuleTypes_Aggregate;
  /** fetch data from the table: "moduleTypes" using primary key columns */
  moduleTypes_by_pk?: Maybe<ModuleTypes>;
  /** fetch data from the table: "news" */
  news: Array<News>;
  /** fetch data from the table: "notificationActions" */
  notificationActions: Array<NotificationActions>;
  /** fetch aggregated fields from the table: "notificationActions" */
  notificationActions_aggregate: NotificationActions_Aggregate;
  /** fetch data from the table: "notificationActions" using primary key columns */
  notificationActions_by_pk?: Maybe<NotificationActions>;
  /** fetch data from the table: "notificationCadences" */
  notificationCadences: Array<NotificationCadences>;
  /** fetch aggregated fields from the table: "notificationCadences" */
  notificationCadences_aggregate: NotificationCadences_Aggregate;
  /** fetch data from the table: "notificationCadences" using primary key columns */
  notificationCadences_by_pk?: Maybe<NotificationCadences>;
  /** fetch data from the table: "notificationChannels" */
  notificationChannels: Array<NotificationChannels>;
  /** fetch aggregated fields from the table: "notificationChannels" */
  notificationChannels_aggregate: NotificationChannels_Aggregate;
  /** fetch data from the table: "notificationChannels" using primary key columns */
  notificationChannels_by_pk?: Maybe<NotificationChannels>;
  /** An array relationship */
  notificationMessages: Array<NotificationMessages>;
  /** An aggregate relationship */
  notificationMessages_aggregate: NotificationMessages_Aggregate;
  /** fetch data from the table: "notificationMessages" using primary key columns */
  notificationMessages_by_pk?: Maybe<NotificationMessages>;
  /** fetch data from the table: "notificationPreferenceStages" */
  notificationPreferenceStages: Array<NotificationPreferenceStages>;
  /** fetch aggregated fields from the table: "notificationPreferenceStages" */
  notificationPreferenceStages_aggregate: NotificationPreferenceStages_Aggregate;
  /** fetch data from the table: "notificationPreferenceStages" using primary key columns */
  notificationPreferenceStages_by_pk?: Maybe<NotificationPreferenceStages>;
  /** An array relationship */
  notificationPreferences: Array<NotificationPreferences>;
  /** An aggregate relationship */
  notificationPreferences_aggregate: NotificationPreferences_Aggregate;
  /** fetch data from the table: "notificationPreferences" using primary key columns */
  notificationPreferences_by_pk?: Maybe<NotificationPreferences>;
  /** fetch data from the table: "notificationRoomServiceCategoryPreferences" */
  notificationRoomServiceCategoryPreferences: Array<NotificationRoomServiceCategoryPreferences>;
  /** fetch aggregated fields from the table: "notificationRoomServiceCategoryPreferences" */
  notificationRoomServiceCategoryPreferences_aggregate: NotificationRoomServiceCategoryPreferences_Aggregate;
  /** fetch data from the table: "notificationRoomServiceCategoryPreferences" using primary key columns */
  notificationRoomServiceCategoryPreferences_by_pk?: Maybe<NotificationRoomServiceCategoryPreferences>;
  /** An array relationship */
  notificationServicePreferences: Array<NotificationServicePreferences>;
  /** An aggregate relationship */
  notificationServicePreferences_aggregate: NotificationServicePreferences_Aggregate;
  /** fetch data from the table: "notificationServicePreferences" using primary key columns */
  notificationServicePreferences_by_pk?: Maybe<NotificationServicePreferences>;
  /** fetch data from the table: "notificationTemplates" */
  notificationTemplates: Array<NotificationTemplates>;
  /** fetch aggregated fields from the table: "notificationTemplates" */
  notificationTemplates_aggregate: NotificationTemplates_Aggregate;
  /** fetch data from the table: "notificationTemplates" using primary key columns */
  notificationTemplates_by_pk?: Maybe<NotificationTemplates>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** An array relationship */
  orders: Array<Orders>;
  /** An aggregate relationship */
  orders_aggregate: Orders_Aggregate;
  /** fetch data from the table: "orders" using primary key columns */
  orders_by_pk?: Maybe<Orders>;
  /** An array relationship */
  organisationGroupUsers: Array<OrganisationGroupUsers>;
  /** An aggregate relationship */
  organisationGroupUsers_aggregate: OrganisationGroupUsers_Aggregate;
  /** fetch data from the table: "organisationGroupUsers" using primary key columns */
  organisationGroupUsers_by_pk?: Maybe<OrganisationGroupUsers>;
  /** An array relationship */
  organisationGroups: Array<OrganisationGroups>;
  /** An aggregate relationship */
  organisationGroups_aggregate: OrganisationGroups_Aggregate;
  /** fetch data from the table: "organisationGroups" using primary key columns */
  organisationGroups_by_pk?: Maybe<OrganisationGroups>;
  /** fetch data from the table: "organisations" */
  organisations: Array<Organisations>;
  /** fetch aggregated fields from the table: "organisations" */
  organisations_aggregate: Organisations_Aggregate;
  /** fetch data from the table: "organisations" using primary key columns */
  organisations_by_pk?: Maybe<Organisations>;
  /** An array relationship */
  roomAttributeFiles: Array<RoomAttributeFiles>;
  /** fetch data from the table: "roomAttributeFiles" using primary key columns */
  roomAttributeFiles_by_pk?: Maybe<RoomAttributeFiles>;
  /** An array relationship */
  roomAttributeGroups: Array<RoomAttributeGroups>;
  /** fetch data from the table: "roomAttributeGroups" using primary key columns */
  roomAttributeGroups_by_pk?: Maybe<RoomAttributeGroups>;
  /** fetch data from the table: "roomAttributeValueComments" */
  roomAttributeValueComments: Array<RoomAttributeValueComments>;
  /** fetch aggregated fields from the table: "roomAttributeValueComments" */
  roomAttributeValueComments_aggregate: RoomAttributeValueComments_Aggregate;
  /** fetch data from the table: "roomAttributeValueComments" using primary key columns */
  roomAttributeValueComments_by_pk?: Maybe<RoomAttributeValueComments>;
  /** An array relationship */
  roomAttributeValueGroups: Array<RoomAttributeValueGroups>;
  /** fetch data from the table: "roomAttributeValueGroups" using primary key columns */
  roomAttributeValueGroups_by_pk?: Maybe<RoomAttributeValueGroups>;
  /** An array relationship */
  roomAttributeValueUploadVersions: Array<RoomAttributeValueUploadVersions>;
  /** An aggregate relationship */
  roomAttributeValueUploadVersions_aggregate: RoomAttributeValueUploadVersions_Aggregate;
  /** fetch data from the table: "roomAttributeValueUploadVersions" using primary key columns */
  roomAttributeValueUploadVersions_by_pk?: Maybe<RoomAttributeValueUploadVersions>;
  /** An array relationship */
  roomAttributeValueUploads: Array<RoomAttributeValueUploads>;
  /** An aggregate relationship */
  roomAttributeValueUploads_aggregate: RoomAttributeValueUploads_Aggregate;
  /** fetch data from the table: "roomAttributeValueUploads" using primary key columns */
  roomAttributeValueUploads_by_pk?: Maybe<RoomAttributeValueUploads>;
  /** An array relationship */
  roomAttributeValues: Array<RoomAttributeValues>;
  /** fetch data from the table: "roomAttributeValues" using primary key columns */
  roomAttributeValues_by_pk?: Maybe<RoomAttributeValues>;
  /** fetch data from the table: "roomAttributeValues_for_comments" */
  roomAttributeValues_for_comments: Array<RoomAttributeValues_For_Comments>;
  /** An array relationship */
  roomAttributes: Array<RoomAttributes>;
  /** fetch data from the table: "roomAttributes" using primary key columns */
  roomAttributes_by_pk?: Maybe<RoomAttributes>;
  /** fetch data from the table: "roomChanges" */
  roomChanges: Array<RoomChanges>;
  /** fetch aggregated fields from the table: "roomChanges" */
  roomChanges_aggregate: RoomChanges_Aggregate;
  /** fetch data from the table: "roomChanges" using primary key columns */
  roomChanges_by_pk?: Maybe<RoomChanges>;
  /** fetch data from the table: "roomFolders" */
  roomFolders: Array<RoomFolders>;
  /** fetch data from the table: "roomFolders" using primary key columns */
  roomFolders_by_pk?: Maybe<RoomFolders>;
  /** fetch data from the table: "roomOccurrence_intersections" */
  roomOccurrence_intersections: Array<RoomOccurrence_Intersections>;
  /** fetch data from the table: "roomOccurrences" */
  roomOccurrences: Array<RoomOccurrences>;
  /** fetch data from the table: "roomOccurrences" using primary key columns */
  roomOccurrences_by_pk?: Maybe<RoomOccurrences>;
  /** fetch data from the table: "roomServiceCategories" */
  roomServiceCategories: Array<RoomServiceCategories>;
  /** fetch aggregated fields from the table: "roomServiceCategories" */
  roomServiceCategories_aggregate: RoomServiceCategories_Aggregate;
  /** fetch data from the table: "roomServiceCategories" using primary key columns */
  roomServiceCategories_by_pk?: Maybe<RoomServiceCategories>;
  /** An array relationship */
  roomServiceOccurrences: Array<RoomServiceOccurrences>;
  /** fetch data from the table: "roomServiceOccurrences" using primary key columns */
  roomServiceOccurrences_by_pk?: Maybe<RoomServiceOccurrences>;
  /** fetch data from the table: "roomServiceOrganisationAccesses" */
  roomServiceOrganisationAccesses: Array<RoomServiceOrganisationAccesses>;
  /** fetch aggregated fields from the table: "roomServiceOrganisationAccesses" */
  roomServiceOrganisationAccesses_aggregate: RoomServiceOrganisationAccesses_Aggregate;
  /** fetch data from the table: "roomServiceOrganisationAccesses" using primary key columns */
  roomServiceOrganisationAccesses_by_pk?: Maybe<RoomServiceOrganisationAccesses>;
  /** An array relationship */
  roomServices: Array<RoomServices>;
  /** fetch data from the table: "roomServices" using primary key columns */
  roomServices_by_pk?: Maybe<RoomServices>;
  /** An array relationship */
  rooms: Array<Rooms>;
  /** An aggregate relationship */
  rooms_aggregate: Rooms_Aggregate;
  /** fetch data from the table: "rooms" using primary key columns */
  rooms_by_pk?: Maybe<Rooms>;
  /** An array relationship */
  serviceBundleServices: Array<ServiceBundleServices>;
  /** An aggregate relationship */
  serviceBundleServices_aggregate: ServiceBundleServices_Aggregate;
  /** fetch data from the table: "serviceBundleServices" using primary key columns */
  serviceBundleServices_by_pk?: Maybe<ServiceBundleServices>;
  /** fetch data from the table: "serviceBundles" */
  serviceBundles: Array<ServiceBundles>;
  /** fetch aggregated fields from the table: "serviceBundles" */
  serviceBundles_aggregate: ServiceBundles_Aggregate;
  /** fetch data from the table: "serviceBundles" using primary key columns */
  serviceBundles_by_pk?: Maybe<ServiceBundles>;
  /** An array relationship */
  serviceFavourites: Array<ServiceFavourites>;
  /** An aggregate relationship */
  serviceFavourites_aggregate: ServiceFavourites_Aggregate;
  /** fetch data from the table: "serviceFavourites" using primary key columns */
  serviceFavourites_by_pk?: Maybe<ServiceFavourites>;
  /** An array relationship */
  serviceModuleAccesses: Array<ServiceModuleAccesses>;
  /** An aggregate relationship */
  serviceModuleAccesses_aggregate: ServiceModuleAccesses_Aggregate;
  /** fetch data from the table: "serviceModuleAccesses" using primary key columns */
  serviceModuleAccesses_by_pk?: Maybe<ServiceModuleAccesses>;
  /** fetch data from the table: "serviceModuleChanges" */
  serviceModuleChanges: Array<ServiceModuleChanges>;
  /** fetch aggregated fields from the table: "serviceModuleChanges" */
  serviceModuleChanges_aggregate: ServiceModuleChanges_Aggregate;
  /** fetch data from the table: "serviceModuleChanges" using primary key columns */
  serviceModuleChanges_by_pk?: Maybe<ServiceModuleChanges>;
  /** fetch data from the table: "serviceModuleChanges_grouped" */
  serviceModuleChanges_grouped: Array<ServiceModuleChanges_Grouped>;
  /** fetch aggregated fields from the table: "serviceModuleChanges_grouped" */
  serviceModuleChanges_grouped_aggregate: ServiceModuleChanges_Grouped_Aggregate;
  /** An array relationship */
  serviceModules: Array<ServiceModules>;
  /** An aggregate relationship */
  serviceModules_aggregate: ServiceModules_Aggregate;
  /** fetch data from the table: "serviceModules" using primary key columns */
  serviceModules_by_pk?: Maybe<ServiceModules>;
  /** fetch data from the table: "serviceOrganisationAccesses" */
  serviceOrganisationAccesses: Array<ServiceOrganisationAccesses>;
  /** fetch aggregated fields from the table: "serviceOrganisationAccesses" */
  serviceOrganisationAccesses_aggregate: ServiceOrganisationAccesses_Aggregate;
  /** fetch data from the table: "serviceOrganisationAccesses" using primary key columns */
  serviceOrganisationAccesses_by_pk?: Maybe<ServiceOrganisationAccesses>;
  /** fetch data from the table: "serviceParents" */
  serviceParents: Array<ServiceParents>;
  /** fetch aggregated fields from the table: "serviceParents" */
  serviceParents_aggregate: ServiceParents_Aggregate;
  /** fetch data from the table: "serviceTags" */
  serviceTags: Array<ServiceTags>;
  /** An array relationship */
  services: Array<Services>;
  /** An aggregate relationship */
  services_aggregate: Services_Aggregate;
  /** fetch data from the table: "services" using primary key columns */
  services_by_pk?: Maybe<Services>;
  /** fetch data from the table: "test1" */
  test1: Array<Test1>;
  /** fetch data from the table: "uploadComments" */
  uploadComments: Array<UploadComments>;
  /** fetch aggregated fields from the table: "uploadComments" */
  uploadComments_aggregate: UploadComments_Aggregate;
  /** fetch data from the table: "uploadComments" using primary key columns */
  uploadComments_by_pk?: Maybe<UploadComments>;
  /** An array relationship */
  uploadVersions: Array<UploadVersions>;
  /** An aggregate relationship */
  uploadVersions_aggregate: UploadVersions_Aggregate;
  /** fetch data from the table: "uploadVersions" using primary key columns */
  uploadVersions_by_pk?: Maybe<UploadVersions>;
  /** An array relationship */
  uploads: Array<Uploads>;
  /** An aggregate relationship */
  uploads_aggregate: Uploads_Aggregate;
  /** fetch data from the table: "uploads" using primary key columns */
  uploads_by_pk?: Maybe<Uploads>;
  /** An array relationship */
  userAttributeValues: Array<UserAttributeValues>;
  /** An aggregate relationship */
  userAttributeValues_aggregate: UserAttributeValues_Aggregate;
  /** fetch data from the table: "userAttributeValues" using primary key columns */
  userAttributeValues_by_pk?: Maybe<UserAttributeValues>;
  /** fetch data from the table: "userAttributes" */
  userAttributes: Array<UserAttributes>;
  /** fetch aggregated fields from the table: "userAttributes" */
  userAttributes_aggregate: UserAttributes_Aggregate;
  /** fetch data from the table: "userAttributes" using primary key columns */
  userAttributes_by_pk?: Maybe<UserAttributes>;
  /** fetch data from the table: "userDataRoomOccurrences" */
  userDataRoomOccurrences: Array<UserDataRoomOccurrences>;
  /** fetch data from the table: "userDataRoomOccurrences" using primary key columns */
  userDataRoomOccurrences_by_pk?: Maybe<UserDataRoomOccurrences>;
  /** fetch data from the table: "userDataRoomServiceOccurrences" */
  userDataRoomServiceOccurrences: Array<UserDataRoomServiceOccurrences>;
  /** fetch data from the table: "userDataRoomServiceOccurrences" using primary key columns */
  userDataRoomServiceOccurrences_by_pk?: Maybe<UserDataRoomServiceOccurrences>;
  /** fetch data from the table: "userDataServices" */
  userDataServices: Array<UserDataServices>;
  /** fetch data from the table: "userDataServices" using primary key columns */
  userDataServices_by_pk?: Maybe<UserDataServices>;
  /** fetch data from the table: "userRoomServiceOccurrenceLastVisits" */
  userRoomServiceOccurrenceLastVisits: Array<UserRoomServiceOccurrenceLastVisits>;
  /** fetch aggregated fields from the table: "userRoomServiceOccurrenceLastVisits" */
  userRoomServiceOccurrenceLastVisits_aggregate: UserRoomServiceOccurrenceLastVisits_Aggregate;
  /** fetch data from the table: "userRoomServiceOccurrenceLastVisits" using primary key columns */
  userRoomServiceOccurrenceLastVisits_by_pk?: Maybe<UserRoomServiceOccurrenceLastVisits>;
  /** fetch data from the table: "userServiceModuleLastVisits" */
  userServiceModuleLastVisits: Array<UserServiceModuleLastVisits>;
  /** fetch aggregated fields from the table: "userServiceModuleLastVisits" */
  userServiceModuleLastVisits_aggregate: UserServiceModuleLastVisits_Aggregate;
  /** fetch data from the table: "userServiceModuleLastVisits" using primary key columns */
  userServiceModuleLastVisits_by_pk?: Maybe<UserServiceModuleLastVisits>;
  /** fetch data from the table: "userSettings" */
  userSettings: Array<UserSettings>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


export type Query_RootV_Organice_Event_RaumbuchungArgs = {
  distinct_on?: InputMaybe<Array<V_Organice_Event_Raumbuchung_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<V_Organice_Event_Raumbuchung_Order_By>>;
  where?: InputMaybe<V_Organice_Event_Raumbuchung_Bool_Exp>;
};


export type Query_RootV_Organice_Event_Raumbuchung_AggregateArgs = {
  distinct_on?: InputMaybe<Array<V_Organice_Event_Raumbuchung_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<V_Organice_Event_Raumbuchung_Order_By>>;
  where?: InputMaybe<V_Organice_Event_Raumbuchung_Bool_Exp>;
};


export type Query_RootV_Organice_Event_Raumbuchung_By_PkArgs = {
  ID_Raumbuchung: Scalars['numeric']['input'];
};


export type Query_RootV_Organice_Event_StammArgs = {
  distinct_on?: InputMaybe<Array<V_Organice_Event_Stamm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<V_Organice_Event_Stamm_Order_By>>;
  where?: InputMaybe<V_Organice_Event_Stamm_Bool_Exp>;
};


export type Query_RootV_Organice_Event_Stamm_AggregateArgs = {
  distinct_on?: InputMaybe<Array<V_Organice_Event_Stamm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<V_Organice_Event_Stamm_Order_By>>;
  where?: InputMaybe<V_Organice_Event_Stamm_Bool_Exp>;
};


export type Query_RootV_Organice_Event_Stamm_By_PkArgs = {
  T_HASH_Event: Scalars['bpchar']['input'];
};


export type Query_RootAllUsersArgs = {
  distinct_on?: InputMaybe<Array<AllUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AllUsers_Order_By>>;
  where?: InputMaybe<AllUsers_Bool_Exp>;
};


export type Query_RootAllUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AllUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AllUsers_Order_By>>;
  where?: InputMaybe<AllUsers_Bool_Exp>;
};


export type Query_RootArticlesArgs = {
  distinct_on?: InputMaybe<Array<Articles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Articles_Order_By>>;
  where?: InputMaybe<Articles_Bool_Exp>;
};


export type Query_RootArticles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Articles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Articles_Order_By>>;
  where?: InputMaybe<Articles_Bool_Exp>;
};


export type Query_RootArticles_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAttributeFilesArgs = {
  distinct_on?: InputMaybe<Array<AttributeFiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeFiles_Order_By>>;
  where?: InputMaybe<AttributeFiles_Bool_Exp>;
};


export type Query_RootAttributeFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeFiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeFiles_Order_By>>;
  where?: InputMaybe<AttributeFiles_Bool_Exp>;
};


export type Query_RootAttributeFiles_By_PkArgs = {
  attributeId: Scalars['bigint']['input'];
  fileId: Scalars['bigint']['input'];
};


export type Query_RootAttributeGroupsArgs = {
  distinct_on?: InputMaybe<Array<AttributeGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeGroups_Order_By>>;
  where?: InputMaybe<AttributeGroups_Bool_Exp>;
};


export type Query_RootAttributeGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeGroups_Order_By>>;
  where?: InputMaybe<AttributeGroups_Bool_Exp>;
};


export type Query_RootAttributeGroups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAttributeTypesArgs = {
  distinct_on?: InputMaybe<Array<AttributeTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeTypes_Order_By>>;
  where?: InputMaybe<AttributeTypes_Bool_Exp>;
};


export type Query_RootAttributeTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeTypes_Order_By>>;
  where?: InputMaybe<AttributeTypes_Bool_Exp>;
};


export type Query_RootAttributeTypes_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootAttributeValueCommentsArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueComments_Order_By>>;
  where?: InputMaybe<AttributeValueComments_Bool_Exp>;
};


export type Query_RootAttributeValueComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueComments_Order_By>>;
  where?: InputMaybe<AttributeValueComments_Bool_Exp>;
};


export type Query_RootAttributeValueComments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAttributeValueGroupsArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueGroups_Order_By>>;
  where?: InputMaybe<AttributeValueGroups_Bool_Exp>;
};


export type Query_RootAttributeValueGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueGroups_Order_By>>;
  where?: InputMaybe<AttributeValueGroups_Bool_Exp>;
};


export type Query_RootAttributeValueGroups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAttributeValueUploadVersionsArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<AttributeValueUploadVersions_Bool_Exp>;
};


export type Query_RootAttributeValueUploadVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<AttributeValueUploadVersions_Bool_Exp>;
};


export type Query_RootAttributeValueUploadVersions_By_PkArgs = {
  attributeValueUploadId: Scalars['bigint']['input'];
  fileId: Scalars['bigint']['input'];
};


export type Query_RootAttributeValueUploadsArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueUploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueUploads_Order_By>>;
  where?: InputMaybe<AttributeValueUploads_Bool_Exp>;
};


export type Query_RootAttributeValueUploads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueUploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueUploads_Order_By>>;
  where?: InputMaybe<AttributeValueUploads_Bool_Exp>;
};


export type Query_RootAttributeValueUploads_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAttributeValuesArgs = {
  distinct_on?: InputMaybe<Array<AttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValues_Order_By>>;
  where?: InputMaybe<AttributeValues_Bool_Exp>;
};


export type Query_RootAttributeValues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValues_Order_By>>;
  where?: InputMaybe<AttributeValues_Bool_Exp>;
};


export type Query_RootAttributeValues_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootAttributesArgs = {
  distinct_on?: InputMaybe<Array<Attributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attributes_Order_By>>;
  where?: InputMaybe<Attributes_Bool_Exp>;
};


export type Query_RootAttributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attributes_Order_By>>;
  where?: InputMaybe<Attributes_Bool_Exp>;
};


export type Query_RootAttributes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootCartLinesArgs = {
  distinct_on?: InputMaybe<Array<CartLines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CartLines_Order_By>>;
  where?: InputMaybe<CartLines_Bool_Exp>;
};


export type Query_RootCartLines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CartLines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CartLines_Order_By>>;
  where?: InputMaybe<CartLines_Bool_Exp>;
};


export type Query_RootCartLines_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootCartsArgs = {
  distinct_on?: InputMaybe<Array<Carts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Carts_Order_By>>;
  where?: InputMaybe<Carts_Bool_Exp>;
};


export type Query_RootCarts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Carts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Carts_Order_By>>;
  where?: InputMaybe<Carts_Bool_Exp>;
};


export type Query_RootCarts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootCatalogFolderArticlesArgs = {
  distinct_on?: InputMaybe<Array<CatalogFolderArticles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CatalogFolderArticles_Order_By>>;
  where?: InputMaybe<CatalogFolderArticles_Bool_Exp>;
};


export type Query_RootCatalogFolderArticles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CatalogFolderArticles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CatalogFolderArticles_Order_By>>;
  where?: InputMaybe<CatalogFolderArticles_Bool_Exp>;
};


export type Query_RootCatalogFolderArticles_By_PkArgs = {
  articleId: Scalars['bigint']['input'];
  catalogFolderId: Scalars['bigint']['input'];
};


export type Query_RootCatalogFoldersArgs = {
  distinct_on?: InputMaybe<Array<CatalogFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CatalogFolders_Order_By>>;
  where?: InputMaybe<CatalogFolders_Bool_Exp>;
};


export type Query_RootCatalogFolders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CatalogFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CatalogFolders_Order_By>>;
  where?: InputMaybe<CatalogFolders_Bool_Exp>;
};


export type Query_RootCatalogFolders_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootCurrentUserArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootCurrentUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootEventAttributeGroupsArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeGroups_Order_By>>;
  where?: InputMaybe<EventAttributeGroups_Bool_Exp>;
};


export type Query_RootEventAttributeGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeGroups_Order_By>>;
  where?: InputMaybe<EventAttributeGroups_Bool_Exp>;
};


export type Query_RootEventAttributeGroups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootEventAttributeValueUploadVersionsArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<EventAttributeValueUploadVersions_Bool_Exp>;
};


export type Query_RootEventAttributeValueUploadVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<EventAttributeValueUploadVersions_Bool_Exp>;
};


export type Query_RootEventAttributeValueUploadVersions_By_PkArgs = {
  eventAttributeValueUploadId: Scalars['bigint']['input'];
  fileId: Scalars['bigint']['input'];
};


export type Query_RootEventAttributeValueUploadsArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValueUploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValueUploads_Order_By>>;
  where?: InputMaybe<EventAttributeValueUploads_Bool_Exp>;
};


export type Query_RootEventAttributeValueUploads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValueUploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValueUploads_Order_By>>;
  where?: InputMaybe<EventAttributeValueUploads_Bool_Exp>;
};


export type Query_RootEventAttributeValueUploads_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootEventAttributeValuesArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValues_Order_By>>;
  where?: InputMaybe<EventAttributeValues_Bool_Exp>;
};


export type Query_RootEventAttributeValues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValues_Order_By>>;
  where?: InputMaybe<EventAttributeValues_Bool_Exp>;
};


export type Query_RootEventAttributeValues_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootEventAttributesArgs = {
  distinct_on?: InputMaybe<Array<EventAttributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributes_Order_By>>;
  where?: InputMaybe<EventAttributes_Bool_Exp>;
};


export type Query_RootEventAttributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAttributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributes_Order_By>>;
  where?: InputMaybe<EventAttributes_Bool_Exp>;
};


export type Query_RootEventAttributes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootEventFavouritesArgs = {
  distinct_on?: InputMaybe<Array<EventFavourites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventFavourites_Order_By>>;
  where?: InputMaybe<EventFavourites_Bool_Exp>;
};


export type Query_RootEventFavourites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventFavourites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventFavourites_Order_By>>;
  where?: InputMaybe<EventFavourites_Bool_Exp>;
};


export type Query_RootEventFavourites_By_PkArgs = {
  eventId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Query_RootEventOrganisersArgs = {
  distinct_on?: InputMaybe<Array<EventOrganisers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventOrganisers_Order_By>>;
  where?: InputMaybe<EventOrganisers_Bool_Exp>;
};


export type Query_RootEventOrganisers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventOrganisers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventOrganisers_Order_By>>;
  where?: InputMaybe<EventOrganisers_Bool_Exp>;
};


export type Query_RootEventOrganisers_By_PkArgs = {
  eventId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Query_RootEventRoomWatchesArgs = {
  distinct_on?: InputMaybe<Array<EventRoomWatches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventRoomWatches_Order_By>>;
  where?: InputMaybe<EventRoomWatches_Bool_Exp>;
};


export type Query_RootEventRoomWatches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventRoomWatches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventRoomWatches_Order_By>>;
  where?: InputMaybe<EventRoomWatches_Bool_Exp>;
};


export type Query_RootEventRoomWatches_By_PkArgs = {
  eventId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Query_RootEventRoomsArgs = {
  distinct_on?: InputMaybe<Array<EventRooms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventRooms_Order_By>>;
  where?: InputMaybe<EventRooms_Bool_Exp>;
};


export type Query_RootEventRooms_By_PkArgs = {
  eventId: Scalars['bigint']['input'];
  roomId: Scalars['bigint']['input'];
};


export type Query_RootEventTypesArgs = {
  distinct_on?: InputMaybe<Array<EventTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventTypes_Order_By>>;
  where?: InputMaybe<EventTypes_Bool_Exp>;
};


export type Query_RootEventTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventTypes_Order_By>>;
  where?: InputMaybe<EventTypes_Bool_Exp>;
};


export type Query_RootEventTypes_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Query_RootEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Query_RootEvents_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFileMasterVersionsArgs = {
  distinct_on?: InputMaybe<Array<FileMasterVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FileMasterVersions_Order_By>>;
  where?: InputMaybe<FileMasterVersions_Bool_Exp>;
};


export type Query_RootFileMasterVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FileMasterVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FileMasterVersions_Order_By>>;
  where?: InputMaybe<FileMasterVersions_Bool_Exp>;
};


export type Query_RootFileMasterVersions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFileMastersArgs = {
  distinct_on?: InputMaybe<Array<FileMasters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FileMasters_Order_By>>;
  where?: InputMaybe<FileMasters_Bool_Exp>;
};


export type Query_RootFileMasters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FileMasters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FileMasters_Order_By>>;
  where?: InputMaybe<FileMasters_Bool_Exp>;
};


export type Query_RootFileMasters_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFiles_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootInfoBoxesArgs = {
  distinct_on?: InputMaybe<Array<InfoBoxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InfoBoxes_Order_By>>;
  where?: InputMaybe<InfoBoxes_Bool_Exp>;
};


export type Query_RootInfoBoxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<InfoBoxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InfoBoxes_Order_By>>;
  where?: InputMaybe<InfoBoxes_Bool_Exp>;
};


export type Query_RootInfoBoxes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootInfoNewsArgs = {
  distinct_on?: InputMaybe<Array<InfoNews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InfoNews_Order_By>>;
  where?: InputMaybe<InfoNews_Bool_Exp>;
};


export type Query_RootInfoNews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<InfoNews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InfoNews_Order_By>>;
  where?: InputMaybe<InfoNews_Bool_Exp>;
};


export type Query_RootInfoNews_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootJaggaerBanfsArgs = {
  distinct_on?: InputMaybe<Array<JaggaerBanfs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<JaggaerBanfs_Order_By>>;
  where?: InputMaybe<JaggaerBanfs_Bool_Exp>;
};


export type Query_RootJaggaerBanfs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<JaggaerBanfs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<JaggaerBanfs_Order_By>>;
  where?: InputMaybe<JaggaerBanfs_Bool_Exp>;
};


export type Query_RootJaggaerBanfs_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootJaggaerSubmissionsArgs = {
  distinct_on?: InputMaybe<Array<JaggaerSubmissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<JaggaerSubmissions_Order_By>>;
  where?: InputMaybe<JaggaerSubmissions_Bool_Exp>;
};


export type Query_RootJaggaerSubmissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<JaggaerSubmissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<JaggaerSubmissions_Order_By>>;
  where?: InputMaybe<JaggaerSubmissions_Bool_Exp>;
};


export type Query_RootJaggaerSubmissions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootModuleTypesArgs = {
  distinct_on?: InputMaybe<Array<ModuleTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ModuleTypes_Order_By>>;
  where?: InputMaybe<ModuleTypes_Bool_Exp>;
};


export type Query_RootModuleTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ModuleTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ModuleTypes_Order_By>>;
  where?: InputMaybe<ModuleTypes_Bool_Exp>;
};


export type Query_RootModuleTypes_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootNewsArgs = {
  distinct_on?: InputMaybe<Array<News_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<News_Order_By>>;
  where?: InputMaybe<News_Bool_Exp>;
};


export type Query_RootNotificationActionsArgs = {
  distinct_on?: InputMaybe<Array<NotificationActions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationActions_Order_By>>;
  where?: InputMaybe<NotificationActions_Bool_Exp>;
};


export type Query_RootNotificationActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationActions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationActions_Order_By>>;
  where?: InputMaybe<NotificationActions_Bool_Exp>;
};


export type Query_RootNotificationActions_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootNotificationCadencesArgs = {
  distinct_on?: InputMaybe<Array<NotificationCadences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationCadences_Order_By>>;
  where?: InputMaybe<NotificationCadences_Bool_Exp>;
};


export type Query_RootNotificationCadences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationCadences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationCadences_Order_By>>;
  where?: InputMaybe<NotificationCadences_Bool_Exp>;
};


export type Query_RootNotificationCadences_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootNotificationChannelsArgs = {
  distinct_on?: InputMaybe<Array<NotificationChannels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationChannels_Order_By>>;
  where?: InputMaybe<NotificationChannels_Bool_Exp>;
};


export type Query_RootNotificationChannels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationChannels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationChannels_Order_By>>;
  where?: InputMaybe<NotificationChannels_Bool_Exp>;
};


export type Query_RootNotificationChannels_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootNotificationMessagesArgs = {
  distinct_on?: InputMaybe<Array<NotificationMessages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationMessages_Order_By>>;
  where?: InputMaybe<NotificationMessages_Bool_Exp>;
};


export type Query_RootNotificationMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationMessages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationMessages_Order_By>>;
  where?: InputMaybe<NotificationMessages_Bool_Exp>;
};


export type Query_RootNotificationMessages_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNotificationPreferenceStagesArgs = {
  distinct_on?: InputMaybe<Array<NotificationPreferenceStages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationPreferenceStages_Order_By>>;
  where?: InputMaybe<NotificationPreferenceStages_Bool_Exp>;
};


export type Query_RootNotificationPreferenceStages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationPreferenceStages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationPreferenceStages_Order_By>>;
  where?: InputMaybe<NotificationPreferenceStages_Bool_Exp>;
};


export type Query_RootNotificationPreferenceStages_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootNotificationPreferencesArgs = {
  distinct_on?: InputMaybe<Array<NotificationPreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationPreferences_Order_By>>;
  where?: InputMaybe<NotificationPreferences_Bool_Exp>;
};


export type Query_RootNotificationPreferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationPreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationPreferences_Order_By>>;
  where?: InputMaybe<NotificationPreferences_Bool_Exp>;
};


export type Query_RootNotificationPreferences_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNotificationRoomServiceCategoryPreferencesArgs = {
  distinct_on?: InputMaybe<Array<NotificationRoomServiceCategoryPreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationRoomServiceCategoryPreferences_Order_By>>;
  where?: InputMaybe<NotificationRoomServiceCategoryPreferences_Bool_Exp>;
};


export type Query_RootNotificationRoomServiceCategoryPreferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationRoomServiceCategoryPreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationRoomServiceCategoryPreferences_Order_By>>;
  where?: InputMaybe<NotificationRoomServiceCategoryPreferences_Bool_Exp>;
};


export type Query_RootNotificationRoomServiceCategoryPreferences_By_PkArgs = {
  roomServiceCategoryId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Query_RootNotificationServicePreferencesArgs = {
  distinct_on?: InputMaybe<Array<NotificationServicePreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationServicePreferences_Order_By>>;
  where?: InputMaybe<NotificationServicePreferences_Bool_Exp>;
};


export type Query_RootNotificationServicePreferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationServicePreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationServicePreferences_Order_By>>;
  where?: InputMaybe<NotificationServicePreferences_Bool_Exp>;
};


export type Query_RootNotificationServicePreferences_By_PkArgs = {
  serviceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Query_RootNotificationTemplatesArgs = {
  distinct_on?: InputMaybe<Array<NotificationTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationTemplates_Order_By>>;
  where?: InputMaybe<NotificationTemplates_Bool_Exp>;
};


export type Query_RootNotificationTemplates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationTemplates_Order_By>>;
  where?: InputMaybe<NotificationTemplates_Bool_Exp>;
};


export type Query_RootNotificationTemplates_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Query_RootNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Query_RootNotifications_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootOrdersArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Query_RootOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Query_RootOrders_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootOrganisationGroupUsersArgs = {
  distinct_on?: InputMaybe<Array<OrganisationGroupUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<OrganisationGroupUsers_Order_By>>;
  where?: InputMaybe<OrganisationGroupUsers_Bool_Exp>;
};


export type Query_RootOrganisationGroupUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganisationGroupUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<OrganisationGroupUsers_Order_By>>;
  where?: InputMaybe<OrganisationGroupUsers_Bool_Exp>;
};


export type Query_RootOrganisationGroupUsers_By_PkArgs = {
  organisationGroupId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Query_RootOrganisationGroupsArgs = {
  distinct_on?: InputMaybe<Array<OrganisationGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<OrganisationGroups_Order_By>>;
  where?: InputMaybe<OrganisationGroups_Bool_Exp>;
};


export type Query_RootOrganisationGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganisationGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<OrganisationGroups_Order_By>>;
  where?: InputMaybe<OrganisationGroups_Bool_Exp>;
};


export type Query_RootOrganisationGroups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootOrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisations_Order_By>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Query_RootOrganisations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisations_Order_By>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Query_RootOrganisations_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootRoomAttributeFilesArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeFiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeFiles_Order_By>>;
  where?: InputMaybe<RoomAttributeFiles_Bool_Exp>;
};


export type Query_RootRoomAttributeFiles_By_PkArgs = {
  fileId: Scalars['bigint']['input'];
  roomAttributeId: Scalars['bigint']['input'];
};


export type Query_RootRoomAttributeGroupsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeGroups_Order_By>>;
  where?: InputMaybe<RoomAttributeGroups_Bool_Exp>;
};


export type Query_RootRoomAttributeGroups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootRoomAttributeValueCommentsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueComments_Order_By>>;
  where?: InputMaybe<RoomAttributeValueComments_Bool_Exp>;
};


export type Query_RootRoomAttributeValueComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueComments_Order_By>>;
  where?: InputMaybe<RoomAttributeValueComments_Bool_Exp>;
};


export type Query_RootRoomAttributeValueComments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootRoomAttributeValueGroupsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueGroups_Order_By>>;
  where?: InputMaybe<RoomAttributeValueGroups_Bool_Exp>;
};


export type Query_RootRoomAttributeValueGroups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootRoomAttributeValueUploadVersionsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<RoomAttributeValueUploadVersions_Bool_Exp>;
};


export type Query_RootRoomAttributeValueUploadVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<RoomAttributeValueUploadVersions_Bool_Exp>;
};


export type Query_RootRoomAttributeValueUploadVersions_By_PkArgs = {
  fileId: Scalars['bigint']['input'];
  roomAttributeValueUploadId: Scalars['bigint']['input'];
};


export type Query_RootRoomAttributeValueUploadsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueUploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueUploads_Order_By>>;
  where?: InputMaybe<RoomAttributeValueUploads_Bool_Exp>;
};


export type Query_RootRoomAttributeValueUploads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueUploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueUploads_Order_By>>;
  where?: InputMaybe<RoomAttributeValueUploads_Bool_Exp>;
};


export type Query_RootRoomAttributeValueUploads_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootRoomAttributeValuesArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValues_Order_By>>;
  where?: InputMaybe<RoomAttributeValues_Bool_Exp>;
};


export type Query_RootRoomAttributeValues_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootRoomAttributeValues_For_CommentsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValues_For_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValues_For_Comments_Order_By>>;
  where?: InputMaybe<RoomAttributeValues_For_Comments_Bool_Exp>;
};


export type Query_RootRoomAttributesArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributes_Order_By>>;
  where?: InputMaybe<RoomAttributes_Bool_Exp>;
};


export type Query_RootRoomAttributes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootRoomChangesArgs = {
  distinct_on?: InputMaybe<Array<RoomChanges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomChanges_Order_By>>;
  where?: InputMaybe<RoomChanges_Bool_Exp>;
};


export type Query_RootRoomChanges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoomChanges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomChanges_Order_By>>;
  where?: InputMaybe<RoomChanges_Bool_Exp>;
};


export type Query_RootRoomChanges_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootRoomFoldersArgs = {
  distinct_on?: InputMaybe<Array<RoomFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomFolders_Order_By>>;
  where?: InputMaybe<RoomFolders_Bool_Exp>;
};


export type Query_RootRoomFolders_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootRoomOccurrence_IntersectionsArgs = {
  distinct_on?: InputMaybe<Array<RoomOccurrence_Intersections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomOccurrence_Intersections_Order_By>>;
  where?: InputMaybe<RoomOccurrence_Intersections_Bool_Exp>;
};


export type Query_RootRoomOccurrencesArgs = {
  distinct_on?: InputMaybe<Array<RoomOccurrences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomOccurrences_Order_By>>;
  where?: InputMaybe<RoomOccurrences_Bool_Exp>;
};


export type Query_RootRoomOccurrences_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootRoomServiceCategoriesArgs = {
  distinct_on?: InputMaybe<Array<RoomServiceCategories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomServiceCategories_Order_By>>;
  where?: InputMaybe<RoomServiceCategories_Bool_Exp>;
};


export type Query_RootRoomServiceCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoomServiceCategories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomServiceCategories_Order_By>>;
  where?: InputMaybe<RoomServiceCategories_Bool_Exp>;
};


export type Query_RootRoomServiceCategories_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootRoomServiceOccurrencesArgs = {
  distinct_on?: InputMaybe<Array<RoomServiceOccurrences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomServiceOccurrences_Order_By>>;
  where?: InputMaybe<RoomServiceOccurrences_Bool_Exp>;
};


export type Query_RootRoomServiceOccurrences_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootRoomServiceOrganisationAccessesArgs = {
  distinct_on?: InputMaybe<Array<RoomServiceOrganisationAccesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomServiceOrganisationAccesses_Order_By>>;
  where?: InputMaybe<RoomServiceOrganisationAccesses_Bool_Exp>;
};


export type Query_RootRoomServiceOrganisationAccesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoomServiceOrganisationAccesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomServiceOrganisationAccesses_Order_By>>;
  where?: InputMaybe<RoomServiceOrganisationAccesses_Bool_Exp>;
};


export type Query_RootRoomServiceOrganisationAccesses_By_PkArgs = {
  eventId: Scalars['bigint']['input'];
  organisationId: Scalars['bigint']['input'];
};


export type Query_RootRoomServicesArgs = {
  distinct_on?: InputMaybe<Array<RoomServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomServices_Order_By>>;
  where?: InputMaybe<RoomServices_Bool_Exp>;
};


export type Query_RootRoomServices_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootRoomsArgs = {
  distinct_on?: InputMaybe<Array<Rooms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rooms_Order_By>>;
  where?: InputMaybe<Rooms_Bool_Exp>;
};


export type Query_RootRooms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rooms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rooms_Order_By>>;
  where?: InputMaybe<Rooms_Bool_Exp>;
};


export type Query_RootRooms_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootServiceBundleServicesArgs = {
  distinct_on?: InputMaybe<Array<ServiceBundleServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceBundleServices_Order_By>>;
  where?: InputMaybe<ServiceBundleServices_Bool_Exp>;
};


export type Query_RootServiceBundleServices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceBundleServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceBundleServices_Order_By>>;
  where?: InputMaybe<ServiceBundleServices_Bool_Exp>;
};


export type Query_RootServiceBundleServices_By_PkArgs = {
  serviceBundleId: Scalars['bigint']['input'];
  serviceId: Scalars['bigint']['input'];
};


export type Query_RootServiceBundlesArgs = {
  distinct_on?: InputMaybe<Array<ServiceBundles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceBundles_Order_By>>;
  where?: InputMaybe<ServiceBundles_Bool_Exp>;
};


export type Query_RootServiceBundles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceBundles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceBundles_Order_By>>;
  where?: InputMaybe<ServiceBundles_Bool_Exp>;
};


export type Query_RootServiceBundles_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootServiceFavouritesArgs = {
  distinct_on?: InputMaybe<Array<ServiceFavourites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceFavourites_Order_By>>;
  where?: InputMaybe<ServiceFavourites_Bool_Exp>;
};


export type Query_RootServiceFavourites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceFavourites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceFavourites_Order_By>>;
  where?: InputMaybe<ServiceFavourites_Bool_Exp>;
};


export type Query_RootServiceFavourites_By_PkArgs = {
  serviceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Query_RootServiceModuleAccessesArgs = {
  distinct_on?: InputMaybe<Array<ServiceModuleAccesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModuleAccesses_Order_By>>;
  where?: InputMaybe<ServiceModuleAccesses_Bool_Exp>;
};


export type Query_RootServiceModuleAccesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceModuleAccesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModuleAccesses_Order_By>>;
  where?: InputMaybe<ServiceModuleAccesses_Bool_Exp>;
};


export type Query_RootServiceModuleAccesses_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootServiceModuleChangesArgs = {
  distinct_on?: InputMaybe<Array<ServiceModuleChanges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModuleChanges_Order_By>>;
  where?: InputMaybe<ServiceModuleChanges_Bool_Exp>;
};


export type Query_RootServiceModuleChanges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceModuleChanges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModuleChanges_Order_By>>;
  where?: InputMaybe<ServiceModuleChanges_Bool_Exp>;
};


export type Query_RootServiceModuleChanges_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootServiceModuleChanges_GroupedArgs = {
  distinct_on?: InputMaybe<Array<ServiceModuleChanges_Grouped_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModuleChanges_Grouped_Order_By>>;
  where?: InputMaybe<ServiceModuleChanges_Grouped_Bool_Exp>;
};


export type Query_RootServiceModuleChanges_Grouped_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceModuleChanges_Grouped_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModuleChanges_Grouped_Order_By>>;
  where?: InputMaybe<ServiceModuleChanges_Grouped_Bool_Exp>;
};


export type Query_RootServiceModulesArgs = {
  distinct_on?: InputMaybe<Array<ServiceModules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModules_Order_By>>;
  where?: InputMaybe<ServiceModules_Bool_Exp>;
};


export type Query_RootServiceModules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceModules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModules_Order_By>>;
  where?: InputMaybe<ServiceModules_Bool_Exp>;
};


export type Query_RootServiceModules_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootServiceOrganisationAccessesArgs = {
  distinct_on?: InputMaybe<Array<ServiceOrganisationAccesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOrganisationAccesses_Order_By>>;
  where?: InputMaybe<ServiceOrganisationAccesses_Bool_Exp>;
};


export type Query_RootServiceOrganisationAccesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOrganisationAccesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOrganisationAccesses_Order_By>>;
  where?: InputMaybe<ServiceOrganisationAccesses_Bool_Exp>;
};


export type Query_RootServiceOrganisationAccesses_By_PkArgs = {
  organisationId: Scalars['bigint']['input'];
  serviceId: Scalars['bigint']['input'];
};


export type Query_RootServiceParentsArgs = {
  distinct_on?: InputMaybe<Array<ServiceParents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceParents_Order_By>>;
  where?: InputMaybe<ServiceParents_Bool_Exp>;
};


export type Query_RootServiceParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceParents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceParents_Order_By>>;
  where?: InputMaybe<ServiceParents_Bool_Exp>;
};


export type Query_RootServiceTagsArgs = {
  distinct_on?: InputMaybe<Array<ServiceTags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceTags_Order_By>>;
  where?: InputMaybe<ServiceTags_Bool_Exp>;
};


export type Query_RootServicesArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


export type Query_RootServices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


export type Query_RootServices_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTest1Args = {
  distinct_on?: InputMaybe<Array<Test1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test1_Order_By>>;
  where?: InputMaybe<Test1_Bool_Exp>;
};


export type Query_RootUploadCommentsArgs = {
  distinct_on?: InputMaybe<Array<UploadComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UploadComments_Order_By>>;
  where?: InputMaybe<UploadComments_Bool_Exp>;
};


export type Query_RootUploadComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UploadComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UploadComments_Order_By>>;
  where?: InputMaybe<UploadComments_Bool_Exp>;
};


export type Query_RootUploadComments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUploadVersionsArgs = {
  distinct_on?: InputMaybe<Array<UploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UploadVersions_Order_By>>;
  where?: InputMaybe<UploadVersions_Bool_Exp>;
};


export type Query_RootUploadVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UploadVersions_Order_By>>;
  where?: InputMaybe<UploadVersions_Bool_Exp>;
};


export type Query_RootUploadVersions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUploadsArgs = {
  distinct_on?: InputMaybe<Array<Uploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uploads_Order_By>>;
  where?: InputMaybe<Uploads_Bool_Exp>;
};


export type Query_RootUploads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uploads_Order_By>>;
  where?: InputMaybe<Uploads_Bool_Exp>;
};


export type Query_RootUploads_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUserAttributeValuesArgs = {
  distinct_on?: InputMaybe<Array<UserAttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserAttributeValues_Order_By>>;
  where?: InputMaybe<UserAttributeValues_Bool_Exp>;
};


export type Query_RootUserAttributeValues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserAttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserAttributeValues_Order_By>>;
  where?: InputMaybe<UserAttributeValues_Bool_Exp>;
};


export type Query_RootUserAttributeValues_By_PkArgs = {
  userAttributeId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Query_RootUserAttributesArgs = {
  distinct_on?: InputMaybe<Array<UserAttributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserAttributes_Order_By>>;
  where?: InputMaybe<UserAttributes_Bool_Exp>;
};


export type Query_RootUserAttributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserAttributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserAttributes_Order_By>>;
  where?: InputMaybe<UserAttributes_Bool_Exp>;
};


export type Query_RootUserAttributes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Query_RootUserDataRoomOccurrencesArgs = {
  distinct_on?: InputMaybe<Array<UserDataRoomOccurrences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserDataRoomOccurrences_Order_By>>;
  where?: InputMaybe<UserDataRoomOccurrences_Bool_Exp>;
};


export type Query_RootUserDataRoomOccurrences_By_PkArgs = {
  roomOccurrenceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Query_RootUserDataRoomServiceOccurrencesArgs = {
  distinct_on?: InputMaybe<Array<UserDataRoomServiceOccurrences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserDataRoomServiceOccurrences_Order_By>>;
  where?: InputMaybe<UserDataRoomServiceOccurrences_Bool_Exp>;
};


export type Query_RootUserDataRoomServiceOccurrences_By_PkArgs = {
  roomServiceOccurrenceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Query_RootUserDataServicesArgs = {
  distinct_on?: InputMaybe<Array<UserDataServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserDataServices_Order_By>>;
  where?: InputMaybe<UserDataServices_Bool_Exp>;
};


export type Query_RootUserDataServices_By_PkArgs = {
  serviceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Query_RootUserRoomServiceOccurrenceLastVisitsArgs = {
  distinct_on?: InputMaybe<Array<UserRoomServiceOccurrenceLastVisits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoomServiceOccurrenceLastVisits_Order_By>>;
  where?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Bool_Exp>;
};


export type Query_RootUserRoomServiceOccurrenceLastVisits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRoomServiceOccurrenceLastVisits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoomServiceOccurrenceLastVisits_Order_By>>;
  where?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Bool_Exp>;
};


export type Query_RootUserRoomServiceOccurrenceLastVisits_By_PkArgs = {
  roomServiceOccurrenceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Query_RootUserServiceModuleLastVisitsArgs = {
  distinct_on?: InputMaybe<Array<UserServiceModuleLastVisits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserServiceModuleLastVisits_Order_By>>;
  where?: InputMaybe<UserServiceModuleLastVisits_Bool_Exp>;
};


export type Query_RootUserServiceModuleLastVisits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserServiceModuleLastVisits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserServiceModuleLastVisits_Order_By>>;
  where?: InputMaybe<UserServiceModuleLastVisits_Bool_Exp>;
};


export type Query_RootUserServiceModuleLastVisits_By_PkArgs = {
  serviceModuleId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Query_RootUserSettingsArgs = {
  distinct_on?: InputMaybe<Array<UserSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserSettings_Order_By>>;
  where?: InputMaybe<UserSettings_Bool_Exp>;
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['bigint']['input'];
};

/** columns and relationships of "roomAttributeFiles" */
export type RoomAttributeFiles = {
  __typename?: 'roomAttributeFiles';
  /** A computed field, executes function "roomAttributeFiles_downloadUrl" */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  file: Files;
  fileId: Scalars['bigint']['output'];
  /** An object relationship */
  roomAttribute: RoomAttributes;
  roomAttributeId: Scalars['bigint']['output'];
};

/** order by aggregate values of table "roomAttributeFiles" */
export type RoomAttributeFiles_Aggregate_Order_By = {
  avg?: InputMaybe<RoomAttributeFiles_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RoomAttributeFiles_Max_Order_By>;
  min?: InputMaybe<RoomAttributeFiles_Min_Order_By>;
  stddev?: InputMaybe<RoomAttributeFiles_Stddev_Order_By>;
  stddev_pop?: InputMaybe<RoomAttributeFiles_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<RoomAttributeFiles_Stddev_Samp_Order_By>;
  sum?: InputMaybe<RoomAttributeFiles_Sum_Order_By>;
  var_pop?: InputMaybe<RoomAttributeFiles_Var_Pop_Order_By>;
  var_samp?: InputMaybe<RoomAttributeFiles_Var_Samp_Order_By>;
  variance?: InputMaybe<RoomAttributeFiles_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "roomAttributeFiles" */
export type RoomAttributeFiles_Arr_Rel_Insert_Input = {
  data: Array<RoomAttributeFiles_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomAttributeFiles_On_Conflict>;
};

/** order by avg() on columns of table "roomAttributeFiles" */
export type RoomAttributeFiles_Avg_Order_By = {
  fileId?: InputMaybe<Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "roomAttributeFiles". All fields are combined with a logical 'AND'. */
export type RoomAttributeFiles_Bool_Exp = {
  _and?: InputMaybe<Array<RoomAttributeFiles_Bool_Exp>>;
  _not?: InputMaybe<RoomAttributeFiles_Bool_Exp>;
  _or?: InputMaybe<Array<RoomAttributeFiles_Bool_Exp>>;
  downloadUrl?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Bigint_Comparison_Exp>;
  roomAttribute?: InputMaybe<RoomAttributes_Bool_Exp>;
  roomAttributeId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "roomAttributeFiles" */
export enum RoomAttributeFiles_Constraint {
  /** unique or primary key constraint on columns "fileId", "roomAttributeId" */
  RoomAttributeFilesPkey = 'roomAttributeFiles_pkey'
}

/** input type for inserting data into table "roomAttributeFiles" */
export type RoomAttributeFiles_Insert_Input = {
  fileId?: InputMaybe<Scalars['bigint']['input']>;
  roomAttribute?: InputMaybe<RoomAttributes_Obj_Rel_Insert_Input>;
  roomAttributeId?: InputMaybe<Scalars['bigint']['input']>;
};

/** order by max() on columns of table "roomAttributeFiles" */
export type RoomAttributeFiles_Max_Order_By = {
  fileId?: InputMaybe<Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "roomAttributeFiles" */
export type RoomAttributeFiles_Min_Order_By = {
  fileId?: InputMaybe<Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "roomAttributeFiles" */
export type RoomAttributeFiles_Mutation_Response = {
  __typename?: 'roomAttributeFiles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RoomAttributeFiles>;
};

/** on_conflict condition type for table "roomAttributeFiles" */
export type RoomAttributeFiles_On_Conflict = {
  constraint: RoomAttributeFiles_Constraint;
  update_columns?: Array<RoomAttributeFiles_Update_Column>;
  where?: InputMaybe<RoomAttributeFiles_Bool_Exp>;
};

/** Ordering options when selecting data from "roomAttributeFiles". */
export type RoomAttributeFiles_Order_By = {
  downloadUrl?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
  roomAttribute?: InputMaybe<RoomAttributes_Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
};

/** select columns of table "roomAttributeFiles" */
export enum RoomAttributeFiles_Select_Column {
  /** column name */
  FileId = 'fileId',
  /** column name */
  RoomAttributeId = 'roomAttributeId'
}

/** order by stddev() on columns of table "roomAttributeFiles" */
export type RoomAttributeFiles_Stddev_Order_By = {
  fileId?: InputMaybe<Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "roomAttributeFiles" */
export type RoomAttributeFiles_Stddev_Pop_Order_By = {
  fileId?: InputMaybe<Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "roomAttributeFiles" */
export type RoomAttributeFiles_Stddev_Samp_Order_By = {
  fileId?: InputMaybe<Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "roomAttributeFiles" */
export type RoomAttributeFiles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RoomAttributeFiles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoomAttributeFiles_Stream_Cursor_Value_Input = {
  fileId?: InputMaybe<Scalars['bigint']['input']>;
  roomAttributeId?: InputMaybe<Scalars['bigint']['input']>;
};

/** order by sum() on columns of table "roomAttributeFiles" */
export type RoomAttributeFiles_Sum_Order_By = {
  fileId?: InputMaybe<Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "roomAttributeFiles" (current role has no relevant permissions) */
export enum RoomAttributeFiles_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "roomAttributeFiles" */
export type RoomAttributeFiles_Var_Pop_Order_By = {
  fileId?: InputMaybe<Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "roomAttributeFiles" */
export type RoomAttributeFiles_Var_Samp_Order_By = {
  fileId?: InputMaybe<Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "roomAttributeFiles" */
export type RoomAttributeFiles_Variance_Order_By = {
  fileId?: InputMaybe<Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "roomAttributeGroups" */
export type RoomAttributeGroups = {
  __typename?: 'roomAttributeGroups';
  createdAt: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  /** An array relationship */
  roomAttributeValueGroups: Array<RoomAttributeValueGroups>;
  /** An array relationship */
  roomAttributes: Array<RoomAttributes>;
  /** An object relationship */
  roomService: RoomServices;
  roomServiceId: Scalars['bigint']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  valuesRepeatable: Scalars['Boolean']['output'];
};


/** columns and relationships of "roomAttributeGroups" */
export type RoomAttributeGroupsRoomAttributeValueGroupsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueGroups_Order_By>>;
  where?: InputMaybe<RoomAttributeValueGroups_Bool_Exp>;
};


/** columns and relationships of "roomAttributeGroups" */
export type RoomAttributeGroupsRoomAttributesArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributes_Order_By>>;
  where?: InputMaybe<RoomAttributes_Bool_Exp>;
};

/** order by aggregate values of table "roomAttributeGroups" */
export type RoomAttributeGroups_Aggregate_Order_By = {
  avg?: InputMaybe<RoomAttributeGroups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RoomAttributeGroups_Max_Order_By>;
  min?: InputMaybe<RoomAttributeGroups_Min_Order_By>;
  stddev?: InputMaybe<RoomAttributeGroups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<RoomAttributeGroups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<RoomAttributeGroups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<RoomAttributeGroups_Sum_Order_By>;
  var_pop?: InputMaybe<RoomAttributeGroups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<RoomAttributeGroups_Var_Samp_Order_By>;
  variance?: InputMaybe<RoomAttributeGroups_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "roomAttributeGroups" */
export type RoomAttributeGroups_Arr_Rel_Insert_Input = {
  data: Array<RoomAttributeGroups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomAttributeGroups_On_Conflict>;
};

/** order by avg() on columns of table "roomAttributeGroups" */
export type RoomAttributeGroups_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "roomAttributeGroups". All fields are combined with a logical 'AND'. */
export type RoomAttributeGroups_Bool_Exp = {
  _and?: InputMaybe<Array<RoomAttributeGroups_Bool_Exp>>;
  _not?: InputMaybe<RoomAttributeGroups_Bool_Exp>;
  _or?: InputMaybe<Array<RoomAttributeGroups_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  roomAttributeValueGroups?: InputMaybe<RoomAttributeValueGroups_Bool_Exp>;
  roomAttributes?: InputMaybe<RoomAttributes_Bool_Exp>;
  roomService?: InputMaybe<RoomServices_Bool_Exp>;
  roomServiceId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  valuesRepeatable?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "roomAttributeGroups" */
export enum RoomAttributeGroups_Constraint {
  /** unique or primary key constraint on columns "id" */
  RoomAttributeGroupsPkey = 'roomAttributeGroups_pkey'
}

/** input type for incrementing numeric columns in table "roomAttributeGroups" */
export type RoomAttributeGroups_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "roomAttributeGroups" */
export type RoomAttributeGroups_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  roomAttributeValueGroups?: InputMaybe<RoomAttributeValueGroups_Arr_Rel_Insert_Input>;
  roomAttributes?: InputMaybe<RoomAttributes_Arr_Rel_Insert_Input>;
  roomService?: InputMaybe<RoomServices_Obj_Rel_Insert_Input>;
  roomServiceId?: InputMaybe<Scalars['bigint']['input']>;
  valuesRepeatable?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by max() on columns of table "roomAttributeGroups" */
export type RoomAttributeGroups_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "roomAttributeGroups" */
export type RoomAttributeGroups_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "roomAttributeGroups" */
export type RoomAttributeGroups_Mutation_Response = {
  __typename?: 'roomAttributeGroups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RoomAttributeGroups>;
};

/** input type for inserting object relation for remote table "roomAttributeGroups" */
export type RoomAttributeGroups_Obj_Rel_Insert_Input = {
  data: RoomAttributeGroups_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomAttributeGroups_On_Conflict>;
};

/** on_conflict condition type for table "roomAttributeGroups" */
export type RoomAttributeGroups_On_Conflict = {
  constraint: RoomAttributeGroups_Constraint;
  update_columns?: Array<RoomAttributeGroups_Update_Column>;
  where?: InputMaybe<RoomAttributeGroups_Bool_Exp>;
};

/** Ordering options when selecting data from "roomAttributeGroups". */
export type RoomAttributeGroups_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomAttributeValueGroups_aggregate?: InputMaybe<RoomAttributeValueGroups_Aggregate_Order_By>;
  roomAttributes_aggregate?: InputMaybe<RoomAttributes_Aggregate_Order_By>;
  roomService?: InputMaybe<RoomServices_Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  valuesRepeatable?: InputMaybe<Order_By>;
};

/** primary key columns input for table: roomAttributeGroups */
export type RoomAttributeGroups_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "roomAttributeGroups" */
export enum RoomAttributeGroups_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  RoomServiceId = 'roomServiceId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ValuesRepeatable = 'valuesRepeatable'
}

/** input type for updating data in table "roomAttributeGroups" */
export type RoomAttributeGroups_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  valuesRepeatable?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by stddev() on columns of table "roomAttributeGroups" */
export type RoomAttributeGroups_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "roomAttributeGroups" */
export type RoomAttributeGroups_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "roomAttributeGroups" */
export type RoomAttributeGroups_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "roomAttributeGroups" */
export type RoomAttributeGroups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RoomAttributeGroups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoomAttributeGroups_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  roomServiceId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  valuesRepeatable?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by sum() on columns of table "roomAttributeGroups" */
export type RoomAttributeGroups_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
};

/** update columns of table "roomAttributeGroups" */
export enum RoomAttributeGroups_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ValuesRepeatable = 'valuesRepeatable'
}

export type RoomAttributeGroups_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RoomAttributeGroups_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RoomAttributeGroups_Set_Input>;
  /** filter the rows which have to be updated */
  where: RoomAttributeGroups_Bool_Exp;
};

/** order by var_pop() on columns of table "roomAttributeGroups" */
export type RoomAttributeGroups_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "roomAttributeGroups" */
export type RoomAttributeGroups_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "roomAttributeGroups" */
export type RoomAttributeGroups_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
};

/** columns and relationships of "roomAttributeValueComments" */
export type RoomAttributeValueComments = {
  __typename?: 'roomAttributeValueComments';
  comment: Scalars['String']['output'];
  /** An array relationship */
  comments: Array<RoomAttributeValueComments>;
  /** An aggregate relationship */
  comments_aggregate: RoomAttributeValueComments_Aggregate;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  fullUser: Users;
  id: Scalars['bigint']['output'];
  isDone?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  /** An object relationship */
  organisation?: Maybe<Organisations>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  parentComment?: Maybe<RoomAttributeValueComments>;
  parentId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  roomAttributeValue: RoomAttributeValues;
  roomAttributeValueId: Scalars['bigint']['output'];
  /** An object relationship */
  roomAttributeValue_for_comments?: Maybe<RoomAttributeValues_For_Comments>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<AllUsers>;
  userId: Scalars['bigint']['output'];
};


/** columns and relationships of "roomAttributeValueComments" */
export type RoomAttributeValueCommentsCommentsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueComments_Order_By>>;
  where?: InputMaybe<RoomAttributeValueComments_Bool_Exp>;
};


/** columns and relationships of "roomAttributeValueComments" */
export type RoomAttributeValueCommentsComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueComments_Order_By>>;
  where?: InputMaybe<RoomAttributeValueComments_Bool_Exp>;
};


/** columns and relationships of "roomAttributeValueComments" */
export type RoomAttributeValueCommentsNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "roomAttributeValueComments" */
export type RoomAttributeValueCommentsNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** aggregated selection of "roomAttributeValueComments" */
export type RoomAttributeValueComments_Aggregate = {
  __typename?: 'roomAttributeValueComments_aggregate';
  aggregate?: Maybe<RoomAttributeValueComments_Aggregate_Fields>;
  nodes: Array<RoomAttributeValueComments>;
};

export type RoomAttributeValueComments_Aggregate_Bool_Exp = {
  count?: InputMaybe<RoomAttributeValueComments_Aggregate_Bool_Exp_Count>;
};

export type RoomAttributeValueComments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<RoomAttributeValueComments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RoomAttributeValueComments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "roomAttributeValueComments" */
export type RoomAttributeValueComments_Aggregate_Fields = {
  __typename?: 'roomAttributeValueComments_aggregate_fields';
  avg?: Maybe<RoomAttributeValueComments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RoomAttributeValueComments_Max_Fields>;
  min?: Maybe<RoomAttributeValueComments_Min_Fields>;
  stddev?: Maybe<RoomAttributeValueComments_Stddev_Fields>;
  stddev_pop?: Maybe<RoomAttributeValueComments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RoomAttributeValueComments_Stddev_Samp_Fields>;
  sum?: Maybe<RoomAttributeValueComments_Sum_Fields>;
  var_pop?: Maybe<RoomAttributeValueComments_Var_Pop_Fields>;
  var_samp?: Maybe<RoomAttributeValueComments_Var_Samp_Fields>;
  variance?: Maybe<RoomAttributeValueComments_Variance_Fields>;
};


/** aggregate fields of "roomAttributeValueComments" */
export type RoomAttributeValueComments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RoomAttributeValueComments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "roomAttributeValueComments" */
export type RoomAttributeValueComments_Aggregate_Order_By = {
  avg?: InputMaybe<RoomAttributeValueComments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RoomAttributeValueComments_Max_Order_By>;
  min?: InputMaybe<RoomAttributeValueComments_Min_Order_By>;
  stddev?: InputMaybe<RoomAttributeValueComments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<RoomAttributeValueComments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<RoomAttributeValueComments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<RoomAttributeValueComments_Sum_Order_By>;
  var_pop?: InputMaybe<RoomAttributeValueComments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<RoomAttributeValueComments_Var_Samp_Order_By>;
  variance?: InputMaybe<RoomAttributeValueComments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "roomAttributeValueComments" */
export type RoomAttributeValueComments_Arr_Rel_Insert_Input = {
  data: Array<RoomAttributeValueComments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomAttributeValueComments_On_Conflict>;
};

/** aggregate avg on columns */
export type RoomAttributeValueComments_Avg_Fields = {
  __typename?: 'roomAttributeValueComments_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "roomAttributeValueComments" */
export type RoomAttributeValueComments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "roomAttributeValueComments". All fields are combined with a logical 'AND'. */
export type RoomAttributeValueComments_Bool_Exp = {
  _and?: InputMaybe<Array<RoomAttributeValueComments_Bool_Exp>>;
  _not?: InputMaybe<RoomAttributeValueComments_Bool_Exp>;
  _or?: InputMaybe<Array<RoomAttributeValueComments_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<RoomAttributeValueComments_Bool_Exp>;
  comments_aggregate?: InputMaybe<RoomAttributeValueComments_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  fullUser?: InputMaybe<Users_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  isDone?: InputMaybe<Timestamptz_Comparison_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Bool_Exp>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisationId?: InputMaybe<Bigint_Comparison_Exp>;
  parentComment?: InputMaybe<RoomAttributeValueComments_Bool_Exp>;
  parentId?: InputMaybe<Bigint_Comparison_Exp>;
  roomAttributeValue?: InputMaybe<RoomAttributeValues_Bool_Exp>;
  roomAttributeValueId?: InputMaybe<Bigint_Comparison_Exp>;
  roomAttributeValue_for_comments?: InputMaybe<RoomAttributeValues_For_Comments_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<AllUsers_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "roomAttributeValueComments" */
export enum RoomAttributeValueComments_Constraint {
  /** unique or primary key constraint on columns "id" */
  RoomAttributeValueCommentsPkey = 'roomAttributeValueComments_pkey'
}

/** input type for incrementing numeric columns in table "roomAttributeValueComments" */
export type RoomAttributeValueComments_Inc_Input = {
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "roomAttributeValueComments" */
export type RoomAttributeValueComments_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<RoomAttributeValueComments_Arr_Rel_Insert_Input>;
  fullUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  isDone?: InputMaybe<Scalars['timestamptz']['input']>;
  organisation?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
  parentComment?: InputMaybe<RoomAttributeValueComments_Obj_Rel_Insert_Input>;
  parentId?: InputMaybe<Scalars['bigint']['input']>;
  roomAttributeValue?: InputMaybe<RoomAttributeValues_Obj_Rel_Insert_Input>;
  roomAttributeValueId?: InputMaybe<Scalars['bigint']['input']>;
  roomAttributeValue_for_comments?: InputMaybe<RoomAttributeValues_For_Comments_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type RoomAttributeValueComments_Max_Fields = {
  __typename?: 'roomAttributeValueComments_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  isDone?: Maybe<Scalars['timestamptz']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  parentId?: Maybe<Scalars['bigint']['output']>;
  roomAttributeValueId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "roomAttributeValueComments" */
export type RoomAttributeValueComments_Max_Order_By = {
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDone?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type RoomAttributeValueComments_Min_Fields = {
  __typename?: 'roomAttributeValueComments_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  isDone?: Maybe<Scalars['timestamptz']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  parentId?: Maybe<Scalars['bigint']['output']>;
  roomAttributeValueId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "roomAttributeValueComments" */
export type RoomAttributeValueComments_Min_Order_By = {
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDone?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "roomAttributeValueComments" */
export type RoomAttributeValueComments_Mutation_Response = {
  __typename?: 'roomAttributeValueComments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RoomAttributeValueComments>;
};

/** input type for inserting object relation for remote table "roomAttributeValueComments" */
export type RoomAttributeValueComments_Obj_Rel_Insert_Input = {
  data: RoomAttributeValueComments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomAttributeValueComments_On_Conflict>;
};

/** on_conflict condition type for table "roomAttributeValueComments" */
export type RoomAttributeValueComments_On_Conflict = {
  constraint: RoomAttributeValueComments_Constraint;
  update_columns?: Array<RoomAttributeValueComments_Update_Column>;
  where?: InputMaybe<RoomAttributeValueComments_Bool_Exp>;
};

/** Ordering options when selecting data from "roomAttributeValueComments". */
export type RoomAttributeValueComments_Order_By = {
  comment?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<RoomAttributeValueComments_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fullUser?: InputMaybe<Users_Order_By>;
  id?: InputMaybe<Order_By>;
  isDone?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  organisation?: InputMaybe<Organisations_Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentComment?: InputMaybe<RoomAttributeValueComments_Order_By>;
  parentId?: InputMaybe<Order_By>;
  roomAttributeValue?: InputMaybe<RoomAttributeValues_Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  roomAttributeValue_for_comments?: InputMaybe<RoomAttributeValues_For_Comments_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<AllUsers_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: roomAttributeValueComments */
export type RoomAttributeValueComments_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "roomAttributeValueComments" */
export enum RoomAttributeValueComments_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsDone = 'isDone',
  /** column name */
  OrganisationId = 'organisationId',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  RoomAttributeValueId = 'roomAttributeValueId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "roomAttributeValueComments" */
export type RoomAttributeValueComments_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  isDone?: InputMaybe<Scalars['timestamptz']['input']>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type RoomAttributeValueComments_Stddev_Fields = {
  __typename?: 'roomAttributeValueComments_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "roomAttributeValueComments" */
export type RoomAttributeValueComments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type RoomAttributeValueComments_Stddev_Pop_Fields = {
  __typename?: 'roomAttributeValueComments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "roomAttributeValueComments" */
export type RoomAttributeValueComments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type RoomAttributeValueComments_Stddev_Samp_Fields = {
  __typename?: 'roomAttributeValueComments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "roomAttributeValueComments" */
export type RoomAttributeValueComments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "roomAttributeValueComments" */
export type RoomAttributeValueComments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RoomAttributeValueComments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoomAttributeValueComments_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  isDone?: InputMaybe<Scalars['timestamptz']['input']>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
  parentId?: InputMaybe<Scalars['bigint']['input']>;
  roomAttributeValueId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type RoomAttributeValueComments_Sum_Fields = {
  __typename?: 'roomAttributeValueComments_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  parentId?: Maybe<Scalars['bigint']['output']>;
  roomAttributeValueId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "roomAttributeValueComments" */
export type RoomAttributeValueComments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "roomAttributeValueComments" */
export enum RoomAttributeValueComments_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  IsDone = 'isDone',
  /** column name */
  OrganisationId = 'organisationId'
}

export type RoomAttributeValueComments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RoomAttributeValueComments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RoomAttributeValueComments_Set_Input>;
  /** filter the rows which have to be updated */
  where: RoomAttributeValueComments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type RoomAttributeValueComments_Var_Pop_Fields = {
  __typename?: 'roomAttributeValueComments_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "roomAttributeValueComments" */
export type RoomAttributeValueComments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type RoomAttributeValueComments_Var_Samp_Fields = {
  __typename?: 'roomAttributeValueComments_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "roomAttributeValueComments" */
export type RoomAttributeValueComments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type RoomAttributeValueComments_Variance_Fields = {
  __typename?: 'roomAttributeValueComments_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "roomAttributeValueComments" */
export type RoomAttributeValueComments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "roomAttributeValueGroups" */
export type RoomAttributeValueGroups = {
  __typename?: 'roomAttributeValueGroups';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  roomAttributeGroup: RoomAttributeGroups;
  roomAttributeGroupId: Scalars['bigint']['output'];
  /** An array relationship */
  roomAttributeValues: Array<RoomAttributeValues>;
  /** An object relationship */
  roomServiceOccurrence: RoomServiceOccurrences;
  roomServiceOccurrenceId: Scalars['bigint']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "roomAttributeValueGroups" */
export type RoomAttributeValueGroupsRoomAttributeValuesArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValues_Order_By>>;
  where?: InputMaybe<RoomAttributeValues_Bool_Exp>;
};

/** order by aggregate values of table "roomAttributeValueGroups" */
export type RoomAttributeValueGroups_Aggregate_Order_By = {
  avg?: InputMaybe<RoomAttributeValueGroups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RoomAttributeValueGroups_Max_Order_By>;
  min?: InputMaybe<RoomAttributeValueGroups_Min_Order_By>;
  stddev?: InputMaybe<RoomAttributeValueGroups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<RoomAttributeValueGroups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<RoomAttributeValueGroups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<RoomAttributeValueGroups_Sum_Order_By>;
  var_pop?: InputMaybe<RoomAttributeValueGroups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<RoomAttributeValueGroups_Var_Samp_Order_By>;
  variance?: InputMaybe<RoomAttributeValueGroups_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "roomAttributeValueGroups" */
export type RoomAttributeValueGroups_Arr_Rel_Insert_Input = {
  data: Array<RoomAttributeValueGroups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomAttributeValueGroups_On_Conflict>;
};

/** order by avg() on columns of table "roomAttributeValueGroups" */
export type RoomAttributeValueGroups_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "roomAttributeValueGroups". All fields are combined with a logical 'AND'. */
export type RoomAttributeValueGroups_Bool_Exp = {
  _and?: InputMaybe<Array<RoomAttributeValueGroups_Bool_Exp>>;
  _not?: InputMaybe<RoomAttributeValueGroups_Bool_Exp>;
  _or?: InputMaybe<Array<RoomAttributeValueGroups_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  roomAttributeGroup?: InputMaybe<RoomAttributeGroups_Bool_Exp>;
  roomAttributeGroupId?: InputMaybe<Bigint_Comparison_Exp>;
  roomAttributeValues?: InputMaybe<RoomAttributeValues_Bool_Exp>;
  roomServiceOccurrence?: InputMaybe<RoomServiceOccurrences_Bool_Exp>;
  roomServiceOccurrenceId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "roomAttributeValueGroups" */
export enum RoomAttributeValueGroups_Constraint {
  /** unique or primary key constraint on columns "id" */
  RoomAttributeValueGroupsPkey = 'roomAttributeValueGroups_pkey'
}

/** input type for inserting data into table "roomAttributeValueGroups" */
export type RoomAttributeValueGroups_Insert_Input = {
  roomAttributeGroup?: InputMaybe<RoomAttributeGroups_Obj_Rel_Insert_Input>;
  roomAttributeGroupId?: InputMaybe<Scalars['bigint']['input']>;
  roomAttributeValues?: InputMaybe<RoomAttributeValues_Arr_Rel_Insert_Input>;
  roomServiceOccurrence?: InputMaybe<RoomServiceOccurrences_Obj_Rel_Insert_Input>;
  roomServiceOccurrenceId?: InputMaybe<Scalars['bigint']['input']>;
};

/** order by max() on columns of table "roomAttributeValueGroups" */
export type RoomAttributeValueGroups_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "roomAttributeValueGroups" */
export type RoomAttributeValueGroups_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "roomAttributeValueGroups" */
export type RoomAttributeValueGroups_Mutation_Response = {
  __typename?: 'roomAttributeValueGroups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RoomAttributeValueGroups>;
};

/** input type for inserting object relation for remote table "roomAttributeValueGroups" */
export type RoomAttributeValueGroups_Obj_Rel_Insert_Input = {
  data: RoomAttributeValueGroups_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomAttributeValueGroups_On_Conflict>;
};

/** on_conflict condition type for table "roomAttributeValueGroups" */
export type RoomAttributeValueGroups_On_Conflict = {
  constraint: RoomAttributeValueGroups_Constraint;
  update_columns?: Array<RoomAttributeValueGroups_Update_Column>;
  where?: InputMaybe<RoomAttributeValueGroups_Bool_Exp>;
};

/** Ordering options when selecting data from "roomAttributeValueGroups". */
export type RoomAttributeValueGroups_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roomAttributeGroup?: InputMaybe<RoomAttributeGroups_Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
  roomAttributeValues_aggregate?: InputMaybe<RoomAttributeValues_Aggregate_Order_By>;
  roomServiceOccurrence?: InputMaybe<RoomServiceOccurrences_Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** select columns of table "roomAttributeValueGroups" */
export enum RoomAttributeValueGroups_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  RoomAttributeGroupId = 'roomAttributeGroupId',
  /** column name */
  RoomServiceOccurrenceId = 'roomServiceOccurrenceId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** order by stddev() on columns of table "roomAttributeValueGroups" */
export type RoomAttributeValueGroups_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "roomAttributeValueGroups" */
export type RoomAttributeValueGroups_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "roomAttributeValueGroups" */
export type RoomAttributeValueGroups_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "roomAttributeValueGroups" */
export type RoomAttributeValueGroups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RoomAttributeValueGroups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoomAttributeValueGroups_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  roomAttributeGroupId?: InputMaybe<Scalars['bigint']['input']>;
  roomServiceOccurrenceId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "roomAttributeValueGroups" */
export type RoomAttributeValueGroups_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "roomAttributeValueGroups" (current role has no relevant permissions) */
export enum RoomAttributeValueGroups_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "roomAttributeValueGroups" */
export type RoomAttributeValueGroups_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "roomAttributeValueGroups" */
export type RoomAttributeValueGroups_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "roomAttributeValueGroups" */
export type RoomAttributeValueGroups_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
};

/** columns and relationships of "roomAttributeValueUploadVersions" */
export type RoomAttributeValueUploadVersions = {
  __typename?: 'roomAttributeValueUploadVersions';
  /** A computed field, executes function "roomAttributeValueUploadVersions_downloadUrl" */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  file: Files;
  fileId: Scalars['bigint']['output'];
  /** An object relationship */
  roomAttributeValueUpload: RoomAttributeValueUploads;
  roomAttributeValueUploadId: Scalars['bigint']['output'];
};

/** aggregated selection of "roomAttributeValueUploadVersions" */
export type RoomAttributeValueUploadVersions_Aggregate = {
  __typename?: 'roomAttributeValueUploadVersions_aggregate';
  aggregate?: Maybe<RoomAttributeValueUploadVersions_Aggregate_Fields>;
  nodes: Array<RoomAttributeValueUploadVersions>;
};

export type RoomAttributeValueUploadVersions_Aggregate_Bool_Exp = {
  count?: InputMaybe<RoomAttributeValueUploadVersions_Aggregate_Bool_Exp_Count>;
};

export type RoomAttributeValueUploadVersions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<RoomAttributeValueUploadVersions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RoomAttributeValueUploadVersions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "roomAttributeValueUploadVersions" */
export type RoomAttributeValueUploadVersions_Aggregate_Fields = {
  __typename?: 'roomAttributeValueUploadVersions_aggregate_fields';
  avg?: Maybe<RoomAttributeValueUploadVersions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RoomAttributeValueUploadVersions_Max_Fields>;
  min?: Maybe<RoomAttributeValueUploadVersions_Min_Fields>;
  stddev?: Maybe<RoomAttributeValueUploadVersions_Stddev_Fields>;
  stddev_pop?: Maybe<RoomAttributeValueUploadVersions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RoomAttributeValueUploadVersions_Stddev_Samp_Fields>;
  sum?: Maybe<RoomAttributeValueUploadVersions_Sum_Fields>;
  var_pop?: Maybe<RoomAttributeValueUploadVersions_Var_Pop_Fields>;
  var_samp?: Maybe<RoomAttributeValueUploadVersions_Var_Samp_Fields>;
  variance?: Maybe<RoomAttributeValueUploadVersions_Variance_Fields>;
};


/** aggregate fields of "roomAttributeValueUploadVersions" */
export type RoomAttributeValueUploadVersions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RoomAttributeValueUploadVersions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "roomAttributeValueUploadVersions" */
export type RoomAttributeValueUploadVersions_Aggregate_Order_By = {
  avg?: InputMaybe<RoomAttributeValueUploadVersions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RoomAttributeValueUploadVersions_Max_Order_By>;
  min?: InputMaybe<RoomAttributeValueUploadVersions_Min_Order_By>;
  stddev?: InputMaybe<RoomAttributeValueUploadVersions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<RoomAttributeValueUploadVersions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<RoomAttributeValueUploadVersions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<RoomAttributeValueUploadVersions_Sum_Order_By>;
  var_pop?: InputMaybe<RoomAttributeValueUploadVersions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<RoomAttributeValueUploadVersions_Var_Samp_Order_By>;
  variance?: InputMaybe<RoomAttributeValueUploadVersions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "roomAttributeValueUploadVersions" */
export type RoomAttributeValueUploadVersions_Arr_Rel_Insert_Input = {
  data: Array<RoomAttributeValueUploadVersions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomAttributeValueUploadVersions_On_Conflict>;
};

/** aggregate avg on columns */
export type RoomAttributeValueUploadVersions_Avg_Fields = {
  __typename?: 'roomAttributeValueUploadVersions_avg_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueUploadId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "roomAttributeValueUploadVersions" */
export type RoomAttributeValueUploadVersions_Avg_Order_By = {
  fileId?: InputMaybe<Order_By>;
  roomAttributeValueUploadId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "roomAttributeValueUploadVersions". All fields are combined with a logical 'AND'. */
export type RoomAttributeValueUploadVersions_Bool_Exp = {
  _and?: InputMaybe<Array<RoomAttributeValueUploadVersions_Bool_Exp>>;
  _not?: InputMaybe<RoomAttributeValueUploadVersions_Bool_Exp>;
  _or?: InputMaybe<Array<RoomAttributeValueUploadVersions_Bool_Exp>>;
  downloadUrl?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Bigint_Comparison_Exp>;
  roomAttributeValueUpload?: InputMaybe<RoomAttributeValueUploads_Bool_Exp>;
  roomAttributeValueUploadId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "roomAttributeValueUploadVersions" */
export enum RoomAttributeValueUploadVersions_Constraint {
  /** unique or primary key constraint on columns "roomAttributeValueUploadId", "fileId" */
  RoomAttributeValueUploadVersionsPkey = 'roomAttributeValueUploadVersions_pkey'
}

/** input type for inserting data into table "roomAttributeValueUploadVersions" */
export type RoomAttributeValueUploadVersions_Insert_Input = {
  fileId?: InputMaybe<Scalars['bigint']['input']>;
  roomAttributeValueUpload?: InputMaybe<RoomAttributeValueUploads_Obj_Rel_Insert_Input>;
  roomAttributeValueUploadId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type RoomAttributeValueUploadVersions_Max_Fields = {
  __typename?: 'roomAttributeValueUploadVersions_max_fields';
  /** A computed field, executes function "roomAttributeValueUploadVersions_downloadUrl" */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
  roomAttributeValueUploadId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "roomAttributeValueUploadVersions" */
export type RoomAttributeValueUploadVersions_Max_Order_By = {
  fileId?: InputMaybe<Order_By>;
  roomAttributeValueUploadId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type RoomAttributeValueUploadVersions_Min_Fields = {
  __typename?: 'roomAttributeValueUploadVersions_min_fields';
  /** A computed field, executes function "roomAttributeValueUploadVersions_downloadUrl" */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
  roomAttributeValueUploadId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "roomAttributeValueUploadVersions" */
export type RoomAttributeValueUploadVersions_Min_Order_By = {
  fileId?: InputMaybe<Order_By>;
  roomAttributeValueUploadId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "roomAttributeValueUploadVersions" */
export type RoomAttributeValueUploadVersions_Mutation_Response = {
  __typename?: 'roomAttributeValueUploadVersions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RoomAttributeValueUploadVersions>;
};

/** on_conflict condition type for table "roomAttributeValueUploadVersions" */
export type RoomAttributeValueUploadVersions_On_Conflict = {
  constraint: RoomAttributeValueUploadVersions_Constraint;
  update_columns?: Array<RoomAttributeValueUploadVersions_Update_Column>;
  where?: InputMaybe<RoomAttributeValueUploadVersions_Bool_Exp>;
};

/** Ordering options when selecting data from "roomAttributeValueUploadVersions". */
export type RoomAttributeValueUploadVersions_Order_By = {
  downloadUrl?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
  roomAttributeValueUpload?: InputMaybe<RoomAttributeValueUploads_Order_By>;
  roomAttributeValueUploadId?: InputMaybe<Order_By>;
};

/** select columns of table "roomAttributeValueUploadVersions" */
export enum RoomAttributeValueUploadVersions_Select_Column {
  /** column name */
  FileId = 'fileId',
  /** column name */
  RoomAttributeValueUploadId = 'roomAttributeValueUploadId'
}

/** aggregate stddev on columns */
export type RoomAttributeValueUploadVersions_Stddev_Fields = {
  __typename?: 'roomAttributeValueUploadVersions_stddev_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueUploadId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "roomAttributeValueUploadVersions" */
export type RoomAttributeValueUploadVersions_Stddev_Order_By = {
  fileId?: InputMaybe<Order_By>;
  roomAttributeValueUploadId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type RoomAttributeValueUploadVersions_Stddev_Pop_Fields = {
  __typename?: 'roomAttributeValueUploadVersions_stddev_pop_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueUploadId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "roomAttributeValueUploadVersions" */
export type RoomAttributeValueUploadVersions_Stddev_Pop_Order_By = {
  fileId?: InputMaybe<Order_By>;
  roomAttributeValueUploadId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type RoomAttributeValueUploadVersions_Stddev_Samp_Fields = {
  __typename?: 'roomAttributeValueUploadVersions_stddev_samp_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueUploadId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "roomAttributeValueUploadVersions" */
export type RoomAttributeValueUploadVersions_Stddev_Samp_Order_By = {
  fileId?: InputMaybe<Order_By>;
  roomAttributeValueUploadId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "roomAttributeValueUploadVersions" */
export type RoomAttributeValueUploadVersions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RoomAttributeValueUploadVersions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoomAttributeValueUploadVersions_Stream_Cursor_Value_Input = {
  fileId?: InputMaybe<Scalars['bigint']['input']>;
  roomAttributeValueUploadId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type RoomAttributeValueUploadVersions_Sum_Fields = {
  __typename?: 'roomAttributeValueUploadVersions_sum_fields';
  fileId?: Maybe<Scalars['bigint']['output']>;
  roomAttributeValueUploadId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "roomAttributeValueUploadVersions" */
export type RoomAttributeValueUploadVersions_Sum_Order_By = {
  fileId?: InputMaybe<Order_By>;
  roomAttributeValueUploadId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "roomAttributeValueUploadVersions" (current role has no relevant permissions) */
export enum RoomAttributeValueUploadVersions_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type RoomAttributeValueUploadVersions_Var_Pop_Fields = {
  __typename?: 'roomAttributeValueUploadVersions_var_pop_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueUploadId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "roomAttributeValueUploadVersions" */
export type RoomAttributeValueUploadVersions_Var_Pop_Order_By = {
  fileId?: InputMaybe<Order_By>;
  roomAttributeValueUploadId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type RoomAttributeValueUploadVersions_Var_Samp_Fields = {
  __typename?: 'roomAttributeValueUploadVersions_var_samp_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueUploadId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "roomAttributeValueUploadVersions" */
export type RoomAttributeValueUploadVersions_Var_Samp_Order_By = {
  fileId?: InputMaybe<Order_By>;
  roomAttributeValueUploadId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type RoomAttributeValueUploadVersions_Variance_Fields = {
  __typename?: 'roomAttributeValueUploadVersions_variance_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueUploadId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "roomAttributeValueUploadVersions" */
export type RoomAttributeValueUploadVersions_Variance_Order_By = {
  fileId?: InputMaybe<Order_By>;
  roomAttributeValueUploadId?: InputMaybe<Order_By>;
};

/** columns and relationships of "roomAttributeValueUploads" */
export type RoomAttributeValueUploads = {
  __typename?: 'roomAttributeValueUploads';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  roomAttributeValue: RoomAttributeValues;
  roomAttributeValueId: Scalars['bigint']['output'];
  /** An array relationship */
  roomAttributeValueUploadVersions: Array<RoomAttributeValueUploadVersions>;
  /** An aggregate relationship */
  roomAttributeValueUploadVersions_aggregate: RoomAttributeValueUploadVersions_Aggregate;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "roomAttributeValueUploads" */
export type RoomAttributeValueUploadsRoomAttributeValueUploadVersionsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<RoomAttributeValueUploadVersions_Bool_Exp>;
};


/** columns and relationships of "roomAttributeValueUploads" */
export type RoomAttributeValueUploadsRoomAttributeValueUploadVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<RoomAttributeValueUploadVersions_Bool_Exp>;
};

/** aggregated selection of "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_Aggregate = {
  __typename?: 'roomAttributeValueUploads_aggregate';
  aggregate?: Maybe<RoomAttributeValueUploads_Aggregate_Fields>;
  nodes: Array<RoomAttributeValueUploads>;
};

export type RoomAttributeValueUploads_Aggregate_Bool_Exp = {
  count?: InputMaybe<RoomAttributeValueUploads_Aggregate_Bool_Exp_Count>;
};

export type RoomAttributeValueUploads_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<RoomAttributeValueUploads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RoomAttributeValueUploads_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_Aggregate_Fields = {
  __typename?: 'roomAttributeValueUploads_aggregate_fields';
  avg?: Maybe<RoomAttributeValueUploads_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RoomAttributeValueUploads_Max_Fields>;
  min?: Maybe<RoomAttributeValueUploads_Min_Fields>;
  stddev?: Maybe<RoomAttributeValueUploads_Stddev_Fields>;
  stddev_pop?: Maybe<RoomAttributeValueUploads_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RoomAttributeValueUploads_Stddev_Samp_Fields>;
  sum?: Maybe<RoomAttributeValueUploads_Sum_Fields>;
  var_pop?: Maybe<RoomAttributeValueUploads_Var_Pop_Fields>;
  var_samp?: Maybe<RoomAttributeValueUploads_Var_Samp_Fields>;
  variance?: Maybe<RoomAttributeValueUploads_Variance_Fields>;
};


/** aggregate fields of "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RoomAttributeValueUploads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_Aggregate_Order_By = {
  avg?: InputMaybe<RoomAttributeValueUploads_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RoomAttributeValueUploads_Max_Order_By>;
  min?: InputMaybe<RoomAttributeValueUploads_Min_Order_By>;
  stddev?: InputMaybe<RoomAttributeValueUploads_Stddev_Order_By>;
  stddev_pop?: InputMaybe<RoomAttributeValueUploads_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<RoomAttributeValueUploads_Stddev_Samp_Order_By>;
  sum?: InputMaybe<RoomAttributeValueUploads_Sum_Order_By>;
  var_pop?: InputMaybe<RoomAttributeValueUploads_Var_Pop_Order_By>;
  var_samp?: InputMaybe<RoomAttributeValueUploads_Var_Samp_Order_By>;
  variance?: InputMaybe<RoomAttributeValueUploads_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_Arr_Rel_Insert_Input = {
  data: Array<RoomAttributeValueUploads_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomAttributeValueUploads_On_Conflict>;
};

/** aggregate avg on columns */
export type RoomAttributeValueUploads_Avg_Fields = {
  __typename?: 'roomAttributeValueUploads_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "roomAttributeValueUploads". All fields are combined with a logical 'AND'. */
export type RoomAttributeValueUploads_Bool_Exp = {
  _and?: InputMaybe<Array<RoomAttributeValueUploads_Bool_Exp>>;
  _not?: InputMaybe<RoomAttributeValueUploads_Bool_Exp>;
  _or?: InputMaybe<Array<RoomAttributeValueUploads_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  roomAttributeValue?: InputMaybe<RoomAttributeValues_Bool_Exp>;
  roomAttributeValueId?: InputMaybe<Bigint_Comparison_Exp>;
  roomAttributeValueUploadVersions?: InputMaybe<RoomAttributeValueUploadVersions_Bool_Exp>;
  roomAttributeValueUploadVersions_aggregate?: InputMaybe<RoomAttributeValueUploadVersions_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "roomAttributeValueUploads" */
export enum RoomAttributeValueUploads_Constraint {
  /** unique or primary key constraint on columns "id" */
  RoomAttributeValueUploadsPkey = 'roomAttributeValueUploads_pkey'
}

/** input type for inserting data into table "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  roomAttributeValue?: InputMaybe<RoomAttributeValues_Obj_Rel_Insert_Input>;
  roomAttributeValueId?: InputMaybe<Scalars['bigint']['input']>;
  roomAttributeValueUploadVersions?: InputMaybe<RoomAttributeValueUploadVersions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type RoomAttributeValueUploads_Max_Fields = {
  __typename?: 'roomAttributeValueUploads_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  roomAttributeValueId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type RoomAttributeValueUploads_Min_Fields = {
  __typename?: 'roomAttributeValueUploads_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  roomAttributeValueId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_Mutation_Response = {
  __typename?: 'roomAttributeValueUploads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RoomAttributeValueUploads>;
};

/** input type for inserting object relation for remote table "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_Obj_Rel_Insert_Input = {
  data: RoomAttributeValueUploads_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomAttributeValueUploads_On_Conflict>;
};

/** on_conflict condition type for table "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_On_Conflict = {
  constraint: RoomAttributeValueUploads_Constraint;
  update_columns?: Array<RoomAttributeValueUploads_Update_Column>;
  where?: InputMaybe<RoomAttributeValueUploads_Bool_Exp>;
};

/** Ordering options when selecting data from "roomAttributeValueUploads". */
export type RoomAttributeValueUploads_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  roomAttributeValue?: InputMaybe<RoomAttributeValues_Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
  roomAttributeValueUploadVersions_aggregate?: InputMaybe<RoomAttributeValueUploadVersions_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: roomAttributeValueUploads */
export type RoomAttributeValueUploads_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "roomAttributeValueUploads" */
export enum RoomAttributeValueUploads_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  RoomAttributeValueId = 'roomAttributeValueId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type RoomAttributeValueUploads_Stddev_Fields = {
  __typename?: 'roomAttributeValueUploads_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type RoomAttributeValueUploads_Stddev_Pop_Fields = {
  __typename?: 'roomAttributeValueUploads_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type RoomAttributeValueUploads_Stddev_Samp_Fields = {
  __typename?: 'roomAttributeValueUploads_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RoomAttributeValueUploads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoomAttributeValueUploads_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roomAttributeValueId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type RoomAttributeValueUploads_Sum_Fields = {
  __typename?: 'roomAttributeValueUploads_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  roomAttributeValueId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
};

/** update columns of table "roomAttributeValueUploads" */
export enum RoomAttributeValueUploads_Update_Column {
  /** column name */
  Name = 'name'
}

export type RoomAttributeValueUploads_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RoomAttributeValueUploads_Set_Input>;
  /** filter the rows which have to be updated */
  where: RoomAttributeValueUploads_Bool_Exp;
};

/** aggregate var_pop on columns */
export type RoomAttributeValueUploads_Var_Pop_Fields = {
  __typename?: 'roomAttributeValueUploads_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type RoomAttributeValueUploads_Var_Samp_Fields = {
  __typename?: 'roomAttributeValueUploads_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type RoomAttributeValueUploads_Variance_Fields = {
  __typename?: 'roomAttributeValueUploads_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  roomAttributeValueId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "roomAttributeValueUploads" */
export type RoomAttributeValueUploads_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeValueId?: InputMaybe<Order_By>;
};

/** columns and relationships of "roomAttributeValues" */
export type RoomAttributeValues = {
  __typename?: 'roomAttributeValues';
  /** An array relationship */
  comments: Array<RoomAttributeValueComments>;
  /** An aggregate relationship */
  comments_aggregate: RoomAttributeValueComments_Aggregate;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  fullUser?: Maybe<Users>;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  /** An object relationship */
  roomAttribute: RoomAttributes;
  roomAttributeId: Scalars['bigint']['output'];
  /** An object relationship */
  roomAttributeValueGroup: RoomAttributeValueGroups;
  roomAttributeValueGroupId: Scalars['bigint']['output'];
  /** An array relationship */
  roomAttributeValueUploads: Array<RoomAttributeValueUploads>;
  /** An aggregate relationship */
  roomAttributeValueUploads_aggregate: RoomAttributeValueUploads_Aggregate;
  updatedAt: Scalars['timestamptz']['output'];
  updatedBy?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  user?: Maybe<AllUsers>;
  value: Scalars['json']['output'];
};


/** columns and relationships of "roomAttributeValues" */
export type RoomAttributeValuesCommentsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueComments_Order_By>>;
  where?: InputMaybe<RoomAttributeValueComments_Bool_Exp>;
};


/** columns and relationships of "roomAttributeValues" */
export type RoomAttributeValuesComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueComments_Order_By>>;
  where?: InputMaybe<RoomAttributeValueComments_Bool_Exp>;
};


/** columns and relationships of "roomAttributeValues" */
export type RoomAttributeValuesNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "roomAttributeValues" */
export type RoomAttributeValuesNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "roomAttributeValues" */
export type RoomAttributeValuesRoomAttributeValueUploadsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueUploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueUploads_Order_By>>;
  where?: InputMaybe<RoomAttributeValueUploads_Bool_Exp>;
};


/** columns and relationships of "roomAttributeValues" */
export type RoomAttributeValuesRoomAttributeValueUploads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueUploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueUploads_Order_By>>;
  where?: InputMaybe<RoomAttributeValueUploads_Bool_Exp>;
};


/** columns and relationships of "roomAttributeValues" */
export type RoomAttributeValuesValueArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "roomAttributeValues" */
export type RoomAttributeValues_Aggregate_Order_By = {
  avg?: InputMaybe<RoomAttributeValues_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RoomAttributeValues_Max_Order_By>;
  min?: InputMaybe<RoomAttributeValues_Min_Order_By>;
  stddev?: InputMaybe<RoomAttributeValues_Stddev_Order_By>;
  stddev_pop?: InputMaybe<RoomAttributeValues_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<RoomAttributeValues_Stddev_Samp_Order_By>;
  sum?: InputMaybe<RoomAttributeValues_Sum_Order_By>;
  var_pop?: InputMaybe<RoomAttributeValues_Var_Pop_Order_By>;
  var_samp?: InputMaybe<RoomAttributeValues_Var_Samp_Order_By>;
  variance?: InputMaybe<RoomAttributeValues_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "roomAttributeValues" */
export type RoomAttributeValues_Arr_Rel_Insert_Input = {
  data: Array<RoomAttributeValues_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomAttributeValues_On_Conflict>;
};

/** order by avg() on columns of table "roomAttributeValues" */
export type RoomAttributeValues_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
  roomAttributeValueGroupId?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "roomAttributeValues". All fields are combined with a logical 'AND'. */
export type RoomAttributeValues_Bool_Exp = {
  _and?: InputMaybe<Array<RoomAttributeValues_Bool_Exp>>;
  _not?: InputMaybe<RoomAttributeValues_Bool_Exp>;
  _or?: InputMaybe<Array<RoomAttributeValues_Bool_Exp>>;
  comments?: InputMaybe<RoomAttributeValueComments_Bool_Exp>;
  comments_aggregate?: InputMaybe<RoomAttributeValueComments_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  fullUser?: InputMaybe<Users_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Bool_Exp>;
  roomAttribute?: InputMaybe<RoomAttributes_Bool_Exp>;
  roomAttributeId?: InputMaybe<Bigint_Comparison_Exp>;
  roomAttributeValueGroup?: InputMaybe<RoomAttributeValueGroups_Bool_Exp>;
  roomAttributeValueGroupId?: InputMaybe<Bigint_Comparison_Exp>;
  roomAttributeValueUploads?: InputMaybe<RoomAttributeValueUploads_Bool_Exp>;
  roomAttributeValueUploads_aggregate?: InputMaybe<RoomAttributeValueUploads_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedBy?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<AllUsers_Bool_Exp>;
  value?: InputMaybe<Json_Comparison_Exp>;
};

/** unique or primary key constraints on table "roomAttributeValues" */
export enum RoomAttributeValues_Constraint {
  /** unique or primary key constraint on columns "id" */
  RoomAttributeValuesPkey = 'roomAttributeValues_pkey',
  /** unique or primary key constraint on columns "roomAttributeValueGroupId", "roomAttributeId" */
  RoomAttributeValuesRoomAttributeIdRoomAttributeValueGroupKey = 'roomAttributeValues_roomAttributeId_roomAttributeValueGroup_key'
}

/** columns and relationships of "roomAttributeValues_for_comments" */
export type RoomAttributeValues_For_Comments = {
  __typename?: 'roomAttributeValues_for_comments';
  /** An array relationship */
  comments: Array<RoomAttributeValueComments>;
  /** An aggregate relationship */
  comments_aggregate: RoomAttributeValueComments_Aggregate;
  id?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  roomAttributeValueGroup?: Maybe<RoomAttributeValueGroups>;
};


/** columns and relationships of "roomAttributeValues_for_comments" */
export type RoomAttributeValues_For_CommentsCommentsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueComments_Order_By>>;
  where?: InputMaybe<RoomAttributeValueComments_Bool_Exp>;
};


/** columns and relationships of "roomAttributeValues_for_comments" */
export type RoomAttributeValues_For_CommentsComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueComments_Order_By>>;
  where?: InputMaybe<RoomAttributeValueComments_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "roomAttributeValues_for_comments". All fields are combined with a logical 'AND'. */
export type RoomAttributeValues_For_Comments_Bool_Exp = {
  _and?: InputMaybe<Array<RoomAttributeValues_For_Comments_Bool_Exp>>;
  _not?: InputMaybe<RoomAttributeValues_For_Comments_Bool_Exp>;
  _or?: InputMaybe<Array<RoomAttributeValues_For_Comments_Bool_Exp>>;
  comments?: InputMaybe<RoomAttributeValueComments_Bool_Exp>;
  comments_aggregate?: InputMaybe<RoomAttributeValueComments_Aggregate_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  roomAttributeValueGroup?: InputMaybe<RoomAttributeValueGroups_Bool_Exp>;
};

/** input type for inserting data into table "roomAttributeValues_for_comments" */
export type RoomAttributeValues_For_Comments_Insert_Input = {
  comments?: InputMaybe<RoomAttributeValueComments_Arr_Rel_Insert_Input>;
  roomAttributeId?: InputMaybe<Scalars['bigint']['input']>;
  roomAttributeValueGroup?: InputMaybe<RoomAttributeValueGroups_Obj_Rel_Insert_Input>;
  roomAttributeValueGroupId?: InputMaybe<Scalars['bigint']['input']>;
};

/** response of any mutation on the table "roomAttributeValues_for_comments" */
export type RoomAttributeValues_For_Comments_Mutation_Response = {
  __typename?: 'roomAttributeValues_for_comments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RoomAttributeValues_For_Comments>;
};

/** input type for inserting object relation for remote table "roomAttributeValues_for_comments" */
export type RoomAttributeValues_For_Comments_Obj_Rel_Insert_Input = {
  data: RoomAttributeValues_For_Comments_Insert_Input;
};

/** Ordering options when selecting data from "roomAttributeValues_for_comments". */
export type RoomAttributeValues_For_Comments_Order_By = {
  comments_aggregate?: InputMaybe<RoomAttributeValueComments_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  roomAttributeValueGroup?: InputMaybe<RoomAttributeValueGroups_Order_By>;
};

/** select columns of table "roomAttributeValues_for_comments" */
export enum RoomAttributeValues_For_Comments_Select_Column {
  /** column name */
  Id = 'id'
}

/** Streaming cursor of the table "roomAttributeValues_for_comments" */
export type RoomAttributeValues_For_Comments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RoomAttributeValues_For_Comments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoomAttributeValues_For_Comments_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "roomAttributeValues" */
export type RoomAttributeValues_Insert_Input = {
  comments?: InputMaybe<RoomAttributeValueComments_Arr_Rel_Insert_Input>;
  fullUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  roomAttribute?: InputMaybe<RoomAttributes_Obj_Rel_Insert_Input>;
  roomAttributeId?: InputMaybe<Scalars['bigint']['input']>;
  roomAttributeValueGroup?: InputMaybe<RoomAttributeValueGroups_Obj_Rel_Insert_Input>;
  roomAttributeValueGroupId?: InputMaybe<Scalars['bigint']['input']>;
  roomAttributeValueUploads?: InputMaybe<RoomAttributeValueUploads_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['json']['input']>;
};

/** order by max() on columns of table "roomAttributeValues" */
export type RoomAttributeValues_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
  roomAttributeValueGroupId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "roomAttributeValues" */
export type RoomAttributeValues_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
  roomAttributeValueGroupId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "roomAttributeValues" */
export type RoomAttributeValues_Mutation_Response = {
  __typename?: 'roomAttributeValues_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RoomAttributeValues>;
};

/** input type for inserting object relation for remote table "roomAttributeValues" */
export type RoomAttributeValues_Obj_Rel_Insert_Input = {
  data: RoomAttributeValues_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomAttributeValues_On_Conflict>;
};

/** on_conflict condition type for table "roomAttributeValues" */
export type RoomAttributeValues_On_Conflict = {
  constraint: RoomAttributeValues_Constraint;
  update_columns?: Array<RoomAttributeValues_Update_Column>;
  where?: InputMaybe<RoomAttributeValues_Bool_Exp>;
};

/** Ordering options when selecting data from "roomAttributeValues". */
export type RoomAttributeValues_Order_By = {
  comments_aggregate?: InputMaybe<RoomAttributeValueComments_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fullUser?: InputMaybe<Users_Order_By>;
  id?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  roomAttribute?: InputMaybe<RoomAttributes_Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
  roomAttributeValueGroup?: InputMaybe<RoomAttributeValueGroups_Order_By>;
  roomAttributeValueGroupId?: InputMaybe<Order_By>;
  roomAttributeValueUploads_aggregate?: InputMaybe<RoomAttributeValueUploads_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
  user?: InputMaybe<AllUsers_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: roomAttributeValues */
export type RoomAttributeValues_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "roomAttributeValues" */
export enum RoomAttributeValues_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  RoomAttributeId = 'roomAttributeId',
  /** column name */
  RoomAttributeValueGroupId = 'roomAttributeValueGroupId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedBy = 'updatedBy',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "roomAttributeValues" */
export type RoomAttributeValues_Set_Input = {
  value?: InputMaybe<Scalars['json']['input']>;
};

/** order by stddev() on columns of table "roomAttributeValues" */
export type RoomAttributeValues_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
  roomAttributeValueGroupId?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "roomAttributeValues" */
export type RoomAttributeValues_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
  roomAttributeValueGroupId?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "roomAttributeValues" */
export type RoomAttributeValues_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
  roomAttributeValueGroupId?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "roomAttributeValues" */
export type RoomAttributeValues_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RoomAttributeValues_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoomAttributeValues_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  roomAttributeId?: InputMaybe<Scalars['bigint']['input']>;
  roomAttributeValueGroupId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedBy?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['json']['input']>;
};

/** order by sum() on columns of table "roomAttributeValues" */
export type RoomAttributeValues_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
  roomAttributeValueGroupId?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** update columns of table "roomAttributeValues" */
export enum RoomAttributeValues_Update_Column {
  /** column name */
  Value = 'value'
}

export type RoomAttributeValues_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RoomAttributeValues_Set_Input>;
  /** filter the rows which have to be updated */
  where: RoomAttributeValues_Bool_Exp;
};

/** order by var_pop() on columns of table "roomAttributeValues" */
export type RoomAttributeValues_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
  roomAttributeValueGroupId?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "roomAttributeValues" */
export type RoomAttributeValues_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
  roomAttributeValueGroupId?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "roomAttributeValues" */
export type RoomAttributeValues_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  roomAttributeId?: InputMaybe<Order_By>;
  roomAttributeValueGroupId?: InputMaybe<Order_By>;
  updatedBy?: InputMaybe<Order_By>;
};

/** columns and relationships of "roomAttributes" */
export type RoomAttributes = {
  __typename?: 'roomAttributes';
  attributeType: AttributeTypes_Enum;
  config: Scalars['json']['output'];
  createdAt: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  /** An array relationship */
  roomAttributeFiles: Array<RoomAttributeFiles>;
  /** An object relationship */
  roomAttributeGroup: RoomAttributeGroups;
  roomAttributeGroupId: Scalars['bigint']['output'];
  /** An array relationship */
  roomAttributeValues: Array<RoomAttributeValues>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "roomAttributes" */
export type RoomAttributesConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "roomAttributes" */
export type RoomAttributesRoomAttributeFilesArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeFiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeFiles_Order_By>>;
  where?: InputMaybe<RoomAttributeFiles_Bool_Exp>;
};


/** columns and relationships of "roomAttributes" */
export type RoomAttributesRoomAttributeValuesArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValues_Order_By>>;
  where?: InputMaybe<RoomAttributeValues_Bool_Exp>;
};

/** order by aggregate values of table "roomAttributes" */
export type RoomAttributes_Aggregate_Order_By = {
  avg?: InputMaybe<RoomAttributes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RoomAttributes_Max_Order_By>;
  min?: InputMaybe<RoomAttributes_Min_Order_By>;
  stddev?: InputMaybe<RoomAttributes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<RoomAttributes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<RoomAttributes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<RoomAttributes_Sum_Order_By>;
  var_pop?: InputMaybe<RoomAttributes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<RoomAttributes_Var_Samp_Order_By>;
  variance?: InputMaybe<RoomAttributes_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "roomAttributes" */
export type RoomAttributes_Arr_Rel_Insert_Input = {
  data: Array<RoomAttributes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomAttributes_On_Conflict>;
};

/** order by avg() on columns of table "roomAttributes" */
export type RoomAttributes_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "roomAttributes". All fields are combined with a logical 'AND'. */
export type RoomAttributes_Bool_Exp = {
  _and?: InputMaybe<Array<RoomAttributes_Bool_Exp>>;
  _not?: InputMaybe<RoomAttributes_Bool_Exp>;
  _or?: InputMaybe<Array<RoomAttributes_Bool_Exp>>;
  attributeType?: InputMaybe<AttributeTypes_Enum_Comparison_Exp>;
  config?: InputMaybe<Json_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  roomAttributeFiles?: InputMaybe<RoomAttributeFiles_Bool_Exp>;
  roomAttributeGroup?: InputMaybe<RoomAttributeGroups_Bool_Exp>;
  roomAttributeGroupId?: InputMaybe<Bigint_Comparison_Exp>;
  roomAttributeValues?: InputMaybe<RoomAttributeValues_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "roomAttributes" */
export enum RoomAttributes_Constraint {
  /** unique or primary key constraint on columns "id" */
  RoomAttributesPkey = 'roomAttributes_pkey'
}

/** input type for incrementing numeric columns in table "roomAttributes" */
export type RoomAttributes_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "roomAttributes" */
export type RoomAttributes_Insert_Input = {
  attributeType?: InputMaybe<AttributeTypes_Enum>;
  config?: InputMaybe<Scalars['json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  roomAttributeFiles?: InputMaybe<RoomAttributeFiles_Arr_Rel_Insert_Input>;
  roomAttributeGroup?: InputMaybe<RoomAttributeGroups_Obj_Rel_Insert_Input>;
  roomAttributeGroupId?: InputMaybe<Scalars['bigint']['input']>;
  roomAttributeValues?: InputMaybe<RoomAttributeValues_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "roomAttributes" */
export type RoomAttributes_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "roomAttributes" */
export type RoomAttributes_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "roomAttributes" */
export type RoomAttributes_Mutation_Response = {
  __typename?: 'roomAttributes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RoomAttributes>;
};

/** input type for inserting object relation for remote table "roomAttributes" */
export type RoomAttributes_Obj_Rel_Insert_Input = {
  data: RoomAttributes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomAttributes_On_Conflict>;
};

/** on_conflict condition type for table "roomAttributes" */
export type RoomAttributes_On_Conflict = {
  constraint: RoomAttributes_Constraint;
  update_columns?: Array<RoomAttributes_Update_Column>;
  where?: InputMaybe<RoomAttributes_Bool_Exp>;
};

/** Ordering options when selecting data from "roomAttributes". */
export type RoomAttributes_Order_By = {
  attributeType?: InputMaybe<Order_By>;
  config?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomAttributeFiles_aggregate?: InputMaybe<RoomAttributeFiles_Aggregate_Order_By>;
  roomAttributeGroup?: InputMaybe<RoomAttributeGroups_Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
  roomAttributeValues_aggregate?: InputMaybe<RoomAttributeValues_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: roomAttributes */
export type RoomAttributes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "roomAttributes" */
export enum RoomAttributes_Select_Column {
  /** column name */
  AttributeType = 'attributeType',
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  RoomAttributeGroupId = 'roomAttributeGroupId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "roomAttributes" */
export type RoomAttributes_Set_Input = {
  attributeType?: InputMaybe<AttributeTypes_Enum>;
  config?: InputMaybe<Scalars['json']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** order by stddev() on columns of table "roomAttributes" */
export type RoomAttributes_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "roomAttributes" */
export type RoomAttributes_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "roomAttributes" */
export type RoomAttributes_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "roomAttributes" */
export type RoomAttributes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RoomAttributes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoomAttributes_Stream_Cursor_Value_Input = {
  attributeType?: InputMaybe<AttributeTypes_Enum>;
  config?: InputMaybe<Scalars['json']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  roomAttributeGroupId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "roomAttributes" */
export type RoomAttributes_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
};

/** update columns of table "roomAttributes" */
export enum RoomAttributes_Update_Column {
  /** column name */
  AttributeType = 'attributeType',
  /** column name */
  Config = 'config',
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order'
}

export type RoomAttributes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RoomAttributes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RoomAttributes_Set_Input>;
  /** filter the rows which have to be updated */
  where: RoomAttributes_Bool_Exp;
};

/** order by var_pop() on columns of table "roomAttributes" */
export type RoomAttributes_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "roomAttributes" */
export type RoomAttributes_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "roomAttributes" */
export type RoomAttributes_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomAttributeGroupId?: InputMaybe<Order_By>;
};

/** columns and relationships of "roomChanges" */
export type RoomChanges = {
  __typename?: 'roomChanges';
  createdAt: Scalars['timestamptz']['output'];
  displayData: Scalars['jsonb']['output'];
  /** An object relationship */
  event: Events;
  eventId: Scalars['bigint']['output'];
  /** An object relationship */
  fullUser?: Maybe<Users>;
  id: Scalars['bigint']['output'];
  op: Scalars['String']['output'];
  /** An object relationship */
  room: Rooms;
  roomId: Scalars['bigint']['output'];
  /** An object relationship */
  roomService?: Maybe<RoomServices>;
  roomServiceId?: Maybe<Scalars['bigint']['output']>;
  table: Scalars['String']['output'];
  /** An object relationship */
  user?: Maybe<AllUsers>;
  userId?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "roomChanges" */
export type RoomChangesDisplayDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "roomChanges" */
export type RoomChanges_Aggregate = {
  __typename?: 'roomChanges_aggregate';
  aggregate?: Maybe<RoomChanges_Aggregate_Fields>;
  nodes: Array<RoomChanges>;
};

/** aggregate fields of "roomChanges" */
export type RoomChanges_Aggregate_Fields = {
  __typename?: 'roomChanges_aggregate_fields';
  avg?: Maybe<RoomChanges_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RoomChanges_Max_Fields>;
  min?: Maybe<RoomChanges_Min_Fields>;
  stddev?: Maybe<RoomChanges_Stddev_Fields>;
  stddev_pop?: Maybe<RoomChanges_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RoomChanges_Stddev_Samp_Fields>;
  sum?: Maybe<RoomChanges_Sum_Fields>;
  var_pop?: Maybe<RoomChanges_Var_Pop_Fields>;
  var_samp?: Maybe<RoomChanges_Var_Samp_Fields>;
  variance?: Maybe<RoomChanges_Variance_Fields>;
};


/** aggregate fields of "roomChanges" */
export type RoomChanges_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RoomChanges_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type RoomChanges_Avg_Fields = {
  __typename?: 'roomChanges_avg_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  roomId?: Maybe<Scalars['Float']['output']>;
  roomServiceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "roomChanges". All fields are combined with a logical 'AND'. */
export type RoomChanges_Bool_Exp = {
  _and?: InputMaybe<Array<RoomChanges_Bool_Exp>>;
  _not?: InputMaybe<RoomChanges_Bool_Exp>;
  _or?: InputMaybe<Array<RoomChanges_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  displayData?: InputMaybe<Jsonb_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Bigint_Comparison_Exp>;
  fullUser?: InputMaybe<Users_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  op?: InputMaybe<String_Comparison_Exp>;
  room?: InputMaybe<Rooms_Bool_Exp>;
  roomId?: InputMaybe<Bigint_Comparison_Exp>;
  roomService?: InputMaybe<RoomServices_Bool_Exp>;
  roomServiceId?: InputMaybe<Bigint_Comparison_Exp>;
  table?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<AllUsers_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type RoomChanges_Max_Fields = {
  __typename?: 'roomChanges_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  eventId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  op?: Maybe<Scalars['String']['output']>;
  roomId?: Maybe<Scalars['bigint']['output']>;
  roomServiceId?: Maybe<Scalars['bigint']['output']>;
  table?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type RoomChanges_Min_Fields = {
  __typename?: 'roomChanges_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  eventId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  op?: Maybe<Scalars['String']['output']>;
  roomId?: Maybe<Scalars['bigint']['output']>;
  roomServiceId?: Maybe<Scalars['bigint']['output']>;
  table?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "roomChanges". */
export type RoomChanges_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  displayData?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  fullUser?: InputMaybe<Users_Order_By>;
  id?: InputMaybe<Order_By>;
  op?: InputMaybe<Order_By>;
  room?: InputMaybe<Rooms_Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomService?: InputMaybe<RoomServices_Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
  table?: InputMaybe<Order_By>;
  user?: InputMaybe<AllUsers_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "roomChanges" */
export enum RoomChanges_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DisplayData = 'displayData',
  /** column name */
  EventId = 'eventId',
  /** column name */
  Id = 'id',
  /** column name */
  Op = 'op',
  /** column name */
  RoomId = 'roomId',
  /** column name */
  RoomServiceId = 'roomServiceId',
  /** column name */
  Table = 'table',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type RoomChanges_Stddev_Fields = {
  __typename?: 'roomChanges_stddev_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  roomId?: Maybe<Scalars['Float']['output']>;
  roomServiceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type RoomChanges_Stddev_Pop_Fields = {
  __typename?: 'roomChanges_stddev_pop_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  roomId?: Maybe<Scalars['Float']['output']>;
  roomServiceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type RoomChanges_Stddev_Samp_Fields = {
  __typename?: 'roomChanges_stddev_samp_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  roomId?: Maybe<Scalars['Float']['output']>;
  roomServiceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "roomChanges" */
export type RoomChanges_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RoomChanges_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoomChanges_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  displayData?: InputMaybe<Scalars['jsonb']['input']>;
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  op?: InputMaybe<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['bigint']['input']>;
  roomServiceId?: InputMaybe<Scalars['bigint']['input']>;
  table?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type RoomChanges_Sum_Fields = {
  __typename?: 'roomChanges_sum_fields';
  eventId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  roomId?: Maybe<Scalars['bigint']['output']>;
  roomServiceId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type RoomChanges_Var_Pop_Fields = {
  __typename?: 'roomChanges_var_pop_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  roomId?: Maybe<Scalars['Float']['output']>;
  roomServiceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type RoomChanges_Var_Samp_Fields = {
  __typename?: 'roomChanges_var_samp_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  roomId?: Maybe<Scalars['Float']['output']>;
  roomServiceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RoomChanges_Variance_Fields = {
  __typename?: 'roomChanges_variance_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  roomId?: Maybe<Scalars['Float']['output']>;
  roomServiceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "roomFolders" */
export type RoomFolders = {
  __typename?: 'roomFolders';
  /** An array relationship */
  childFolders: Array<RoomFolders>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  /** An object relationship */
  parentFolder?: Maybe<RoomFolders>;
  parentId?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  rooms: Array<Rooms>;
  /** An aggregate relationship */
  rooms_aggregate: Rooms_Aggregate;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "roomFolders" */
export type RoomFoldersChildFoldersArgs = {
  distinct_on?: InputMaybe<Array<RoomFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomFolders_Order_By>>;
  where?: InputMaybe<RoomFolders_Bool_Exp>;
};


/** columns and relationships of "roomFolders" */
export type RoomFoldersRoomsArgs = {
  distinct_on?: InputMaybe<Array<Rooms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rooms_Order_By>>;
  where?: InputMaybe<Rooms_Bool_Exp>;
};


/** columns and relationships of "roomFolders" */
export type RoomFoldersRooms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rooms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rooms_Order_By>>;
  where?: InputMaybe<Rooms_Bool_Exp>;
};

/** order by aggregate values of table "roomFolders" */
export type RoomFolders_Aggregate_Order_By = {
  avg?: InputMaybe<RoomFolders_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RoomFolders_Max_Order_By>;
  min?: InputMaybe<RoomFolders_Min_Order_By>;
  stddev?: InputMaybe<RoomFolders_Stddev_Order_By>;
  stddev_pop?: InputMaybe<RoomFolders_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<RoomFolders_Stddev_Samp_Order_By>;
  sum?: InputMaybe<RoomFolders_Sum_Order_By>;
  var_pop?: InputMaybe<RoomFolders_Var_Pop_Order_By>;
  var_samp?: InputMaybe<RoomFolders_Var_Samp_Order_By>;
  variance?: InputMaybe<RoomFolders_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "roomFolders" */
export type RoomFolders_Arr_Rel_Insert_Input = {
  data: Array<RoomFolders_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomFolders_On_Conflict>;
};

/** order by avg() on columns of table "roomFolders" */
export type RoomFolders_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "roomFolders". All fields are combined with a logical 'AND'. */
export type RoomFolders_Bool_Exp = {
  _and?: InputMaybe<Array<RoomFolders_Bool_Exp>>;
  _not?: InputMaybe<RoomFolders_Bool_Exp>;
  _or?: InputMaybe<Array<RoomFolders_Bool_Exp>>;
  childFolders?: InputMaybe<RoomFolders_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  parentFolder?: InputMaybe<RoomFolders_Bool_Exp>;
  parentId?: InputMaybe<Bigint_Comparison_Exp>;
  rooms?: InputMaybe<Rooms_Bool_Exp>;
  rooms_aggregate?: InputMaybe<Rooms_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "roomFolders" */
export enum RoomFolders_Constraint {
  /** unique or primary key constraint on columns "id" */
  RoomFoldersPkey = 'roomFolders_pkey'
}

/** input type for incrementing numeric columns in table "roomFolders" */
export type RoomFolders_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "roomFolders" */
export type RoomFolders_Insert_Input = {
  childFolders?: InputMaybe<RoomFolders_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentFolder?: InputMaybe<RoomFolders_Obj_Rel_Insert_Input>;
  parentId?: InputMaybe<Scalars['bigint']['input']>;
  rooms?: InputMaybe<Rooms_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "roomFolders" */
export type RoomFolders_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "roomFolders" */
export type RoomFolders_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "roomFolders" */
export type RoomFolders_Mutation_Response = {
  __typename?: 'roomFolders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RoomFolders>;
};

/** input type for inserting object relation for remote table "roomFolders" */
export type RoomFolders_Obj_Rel_Insert_Input = {
  data: RoomFolders_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomFolders_On_Conflict>;
};

/** on_conflict condition type for table "roomFolders" */
export type RoomFolders_On_Conflict = {
  constraint: RoomFolders_Constraint;
  update_columns?: Array<RoomFolders_Update_Column>;
  where?: InputMaybe<RoomFolders_Bool_Exp>;
};

/** Ordering options when selecting data from "roomFolders". */
export type RoomFolders_Order_By = {
  childFolders_aggregate?: InputMaybe<RoomFolders_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parentFolder?: InputMaybe<RoomFolders_Order_By>;
  parentId?: InputMaybe<Order_By>;
  rooms_aggregate?: InputMaybe<Rooms_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: roomFolders */
export type RoomFolders_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "roomFolders" */
export enum RoomFolders_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "roomFolders" */
export type RoomFolders_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['bigint']['input']>;
};

/** order by stddev() on columns of table "roomFolders" */
export type RoomFolders_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "roomFolders" */
export type RoomFolders_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "roomFolders" */
export type RoomFolders_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "roomFolders" */
export type RoomFolders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RoomFolders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoomFolders_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "roomFolders" */
export type RoomFolders_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** update columns of table "roomFolders" */
export enum RoomFolders_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  ParentId = 'parentId'
}

export type RoomFolders_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RoomFolders_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RoomFolders_Set_Input>;
  /** filter the rows which have to be updated */
  where: RoomFolders_Bool_Exp;
};

/** order by var_pop() on columns of table "roomFolders" */
export type RoomFolders_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "roomFolders" */
export type RoomFolders_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "roomFolders" */
export type RoomFolders_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
};

/** columns and relationships of "roomOccurrence_intersections" */
export type RoomOccurrence_Intersections = {
  __typename?: 'roomOccurrence_intersections';
  _id?: Maybe<Scalars['bigint']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  endDate?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  event?: Maybe<Events>;
  eventId?: Maybe<Scalars['bigint']['output']>;
  fromRoomOccurrenceId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  room?: Maybe<Rooms>;
  roomId?: Maybe<Scalars['bigint']['output']>;
  startDate?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  wantAirConditioning?: Maybe<Scalars['Boolean']['output']>;
};

/** Boolean expression to filter rows from the table "roomOccurrence_intersections". All fields are combined with a logical 'AND'. */
export type RoomOccurrence_Intersections_Bool_Exp = {
  _and?: InputMaybe<Array<RoomOccurrence_Intersections_Bool_Exp>>;
  _id?: InputMaybe<Bigint_Comparison_Exp>;
  _not?: InputMaybe<RoomOccurrence_Intersections_Bool_Exp>;
  _or?: InputMaybe<Array<RoomOccurrence_Intersections_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  endDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Bigint_Comparison_Exp>;
  fromRoomOccurrenceId?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  isDraft?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  room?: InputMaybe<Rooms_Bool_Exp>;
  roomId?: InputMaybe<Bigint_Comparison_Exp>;
  startDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  wantAirConditioning?: InputMaybe<Boolean_Comparison_Exp>;
};

/** Ordering options when selecting data from "roomOccurrence_intersections". */
export type RoomOccurrence_Intersections_Order_By = {
  _id?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  fromRoomOccurrenceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDraft?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  room?: InputMaybe<Rooms_Order_By>;
  roomId?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  wantAirConditioning?: InputMaybe<Order_By>;
};

/** select columns of table "roomOccurrence_intersections" */
export enum RoomOccurrence_Intersections_Select_Column {
  /** column name */
  InternalId = '_id',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  EventId = 'eventId',
  /** column name */
  FromRoomOccurrenceId = 'fromRoomOccurrenceId',
  /** column name */
  Id = 'id',
  /** column name */
  IsDraft = 'isDraft',
  /** column name */
  Name = 'name',
  /** column name */
  RoomId = 'roomId',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WantAirConditioning = 'wantAirConditioning'
}

/** Streaming cursor of the table "roomOccurrence_intersections" */
export type RoomOccurrence_Intersections_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RoomOccurrence_Intersections_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoomOccurrence_Intersections_Stream_Cursor_Value_Input = {
  _id?: InputMaybe<Scalars['bigint']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  fromRoomOccurrenceId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['bigint']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  wantAirConditioning?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "roomOccurrences" */
export type RoomOccurrences = {
  __typename?: 'roomOccurrences';
  createdAt: Scalars['timestamptz']['output'];
  endDate: Scalars['timestamptz']['output'];
  /** An object relationship */
  event: Events;
  eventId: Scalars['bigint']['output'];
  /** An object relationship */
  fromRoomOccurrence?: Maybe<RoomOccurrences>;
  fromRoomOccurrenceId?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "roomOccurrences_guestCanEdit" */
  guestCanEdit?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['bigint']['output'];
  isDraft: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  room: Rooms;
  roomId: Scalars['bigint']['output'];
  startDate: Scalars['timestamptz']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userData: Array<UserDataRoomOccurrences>;
  wantAirConditioning: Scalars['Boolean']['output'];
};


/** columns and relationships of "roomOccurrences" */
export type RoomOccurrencesUserDataArgs = {
  distinct_on?: InputMaybe<Array<UserDataRoomOccurrences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserDataRoomOccurrences_Order_By>>;
  where?: InputMaybe<UserDataRoomOccurrences_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "roomOccurrences". All fields are combined with a logical 'AND'. */
export type RoomOccurrences_Bool_Exp = {
  _and?: InputMaybe<Array<RoomOccurrences_Bool_Exp>>;
  _not?: InputMaybe<RoomOccurrences_Bool_Exp>;
  _or?: InputMaybe<Array<RoomOccurrences_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  endDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Bigint_Comparison_Exp>;
  fromRoomOccurrence?: InputMaybe<RoomOccurrences_Bool_Exp>;
  fromRoomOccurrenceId?: InputMaybe<Bigint_Comparison_Exp>;
  guestCanEdit?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  isDraft?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  room?: InputMaybe<Rooms_Bool_Exp>;
  roomId?: InputMaybe<Bigint_Comparison_Exp>;
  startDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userData?: InputMaybe<UserDataRoomOccurrences_Bool_Exp>;
  wantAirConditioning?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "roomOccurrences" */
export enum RoomOccurrences_Constraint {
  /** unique or primary key constraint on columns "id" */
  RoomOccurrencesPkey = 'roomOccurrences_pkey'
}

/** input type for incrementing numeric columns in table "roomOccurrences" */
export type RoomOccurrences_Inc_Input = {
  roomId?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "roomOccurrences" */
export type RoomOccurrences_Insert_Input = {
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  fromRoomOccurrence?: InputMaybe<RoomOccurrences_Obj_Rel_Insert_Input>;
  fromRoomOccurrenceId?: InputMaybe<Scalars['bigint']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  room?: InputMaybe<Rooms_Obj_Rel_Insert_Input>;
  roomId?: InputMaybe<Scalars['bigint']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  userData?: InputMaybe<UserDataRoomOccurrences_Arr_Rel_Insert_Input>;
  wantAirConditioning?: InputMaybe<Scalars['Boolean']['input']>;
};

/** response of any mutation on the table "roomOccurrences" */
export type RoomOccurrences_Mutation_Response = {
  __typename?: 'roomOccurrences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RoomOccurrences>;
};

/** input type for inserting object relation for remote table "roomOccurrences" */
export type RoomOccurrences_Obj_Rel_Insert_Input = {
  data: RoomOccurrences_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomOccurrences_On_Conflict>;
};

/** on_conflict condition type for table "roomOccurrences" */
export type RoomOccurrences_On_Conflict = {
  constraint: RoomOccurrences_Constraint;
  update_columns?: Array<RoomOccurrences_Update_Column>;
  where?: InputMaybe<RoomOccurrences_Bool_Exp>;
};

/** Ordering options when selecting data from "roomOccurrences". */
export type RoomOccurrences_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  fromRoomOccurrence?: InputMaybe<RoomOccurrences_Order_By>;
  fromRoomOccurrenceId?: InputMaybe<Order_By>;
  guestCanEdit?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDraft?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  room?: InputMaybe<Rooms_Order_By>;
  roomId?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userData_aggregate?: InputMaybe<UserDataRoomOccurrences_Aggregate_Order_By>;
  wantAirConditioning?: InputMaybe<Order_By>;
};

/** primary key columns input for table: roomOccurrences */
export type RoomOccurrences_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "roomOccurrences" */
export enum RoomOccurrences_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  EventId = 'eventId',
  /** column name */
  FromRoomOccurrenceId = 'fromRoomOccurrenceId',
  /** column name */
  Id = 'id',
  /** column name */
  IsDraft = 'isDraft',
  /** column name */
  Name = 'name',
  /** column name */
  RoomId = 'roomId',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  WantAirConditioning = 'wantAirConditioning'
}

/** input type for updating data in table "roomOccurrences" */
export type RoomOccurrences_Set_Input = {
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['bigint']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  wantAirConditioning?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "roomOccurrences" */
export type RoomOccurrences_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RoomOccurrences_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoomOccurrences_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  fromRoomOccurrenceId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roomId?: InputMaybe<Scalars['bigint']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  wantAirConditioning?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "roomOccurrences" */
export enum RoomOccurrences_Update_Column {
  /** column name */
  EndDate = 'endDate',
  /** column name */
  IsDraft = 'isDraft',
  /** column name */
  Name = 'name',
  /** column name */
  RoomId = 'roomId',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  WantAirConditioning = 'wantAirConditioning'
}

export type RoomOccurrences_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RoomOccurrences_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RoomOccurrences_Set_Input>;
  /** filter the rows which have to be updated */
  where: RoomOccurrences_Bool_Exp;
};

/** columns and relationships of "roomServiceCategories" */
export type RoomServiceCategories = {
  __typename?: 'roomServiceCategories';
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  roomServices: Array<RoomServices>;
};


/** columns and relationships of "roomServiceCategories" */
export type RoomServiceCategoriesRoomServicesArgs = {
  distinct_on?: InputMaybe<Array<RoomServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomServices_Order_By>>;
  where?: InputMaybe<RoomServices_Bool_Exp>;
};

/** aggregated selection of "roomServiceCategories" */
export type RoomServiceCategories_Aggregate = {
  __typename?: 'roomServiceCategories_aggregate';
  aggregate?: Maybe<RoomServiceCategories_Aggregate_Fields>;
  nodes: Array<RoomServiceCategories>;
};

/** aggregate fields of "roomServiceCategories" */
export type RoomServiceCategories_Aggregate_Fields = {
  __typename?: 'roomServiceCategories_aggregate_fields';
  avg?: Maybe<RoomServiceCategories_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RoomServiceCategories_Max_Fields>;
  min?: Maybe<RoomServiceCategories_Min_Fields>;
  stddev?: Maybe<RoomServiceCategories_Stddev_Fields>;
  stddev_pop?: Maybe<RoomServiceCategories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RoomServiceCategories_Stddev_Samp_Fields>;
  sum?: Maybe<RoomServiceCategories_Sum_Fields>;
  var_pop?: Maybe<RoomServiceCategories_Var_Pop_Fields>;
  var_samp?: Maybe<RoomServiceCategories_Var_Samp_Fields>;
  variance?: Maybe<RoomServiceCategories_Variance_Fields>;
};


/** aggregate fields of "roomServiceCategories" */
export type RoomServiceCategories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RoomServiceCategories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type RoomServiceCategories_Avg_Fields = {
  __typename?: 'roomServiceCategories_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "roomServiceCategories". All fields are combined with a logical 'AND'. */
export type RoomServiceCategories_Bool_Exp = {
  _and?: InputMaybe<Array<RoomServiceCategories_Bool_Exp>>;
  _not?: InputMaybe<RoomServiceCategories_Bool_Exp>;
  _or?: InputMaybe<Array<RoomServiceCategories_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  roomServices?: InputMaybe<RoomServices_Bool_Exp>;
};

/** unique or primary key constraints on table "roomServiceCategories" */
export enum RoomServiceCategories_Constraint {
  /** unique or primary key constraint on columns "id" */
  RoomServiceCategoriesPkey = 'roomServiceCategories_pkey'
}

/** input type for inserting data into table "roomServiceCategories" */
export type RoomServiceCategories_Insert_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  roomServices?: InputMaybe<RoomServices_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type RoomServiceCategories_Max_Fields = {
  __typename?: 'roomServiceCategories_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type RoomServiceCategories_Min_Fields = {
  __typename?: 'roomServiceCategories_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "roomServiceCategories" */
export type RoomServiceCategories_Mutation_Response = {
  __typename?: 'roomServiceCategories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RoomServiceCategories>;
};

/** input type for inserting object relation for remote table "roomServiceCategories" */
export type RoomServiceCategories_Obj_Rel_Insert_Input = {
  data: RoomServiceCategories_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomServiceCategories_On_Conflict>;
};

/** on_conflict condition type for table "roomServiceCategories" */
export type RoomServiceCategories_On_Conflict = {
  constraint: RoomServiceCategories_Constraint;
  update_columns?: Array<RoomServiceCategories_Update_Column>;
  where?: InputMaybe<RoomServiceCategories_Bool_Exp>;
};

/** Ordering options when selecting data from "roomServiceCategories". */
export type RoomServiceCategories_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  roomServices_aggregate?: InputMaybe<RoomServices_Aggregate_Order_By>;
};

/** primary key columns input for table: roomServiceCategories */
export type RoomServiceCategories_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "roomServiceCategories" */
export enum RoomServiceCategories_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "roomServiceCategories" */
export type RoomServiceCategories_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type RoomServiceCategories_Stddev_Fields = {
  __typename?: 'roomServiceCategories_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type RoomServiceCategories_Stddev_Pop_Fields = {
  __typename?: 'roomServiceCategories_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type RoomServiceCategories_Stddev_Samp_Fields = {
  __typename?: 'roomServiceCategories_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "roomServiceCategories" */
export type RoomServiceCategories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RoomServiceCategories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoomServiceCategories_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type RoomServiceCategories_Sum_Fields = {
  __typename?: 'roomServiceCategories_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "roomServiceCategories" */
export enum RoomServiceCategories_Update_Column {
  /** column name */
  Name = 'name'
}

export type RoomServiceCategories_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RoomServiceCategories_Set_Input>;
  /** filter the rows which have to be updated */
  where: RoomServiceCategories_Bool_Exp;
};

/** aggregate var_pop on columns */
export type RoomServiceCategories_Var_Pop_Fields = {
  __typename?: 'roomServiceCategories_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type RoomServiceCategories_Var_Samp_Fields = {
  __typename?: 'roomServiceCategories_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RoomServiceCategories_Variance_Fields = {
  __typename?: 'roomServiceCategories_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "roomServiceOccurrences" */
export type RoomServiceOccurrences = {
  __typename?: 'roomServiceOccurrences';
  childValuesUpdatedAt: Scalars['timestamptz']['output'];
  createdAt: Scalars['timestamptz']['output'];
  endDate: Scalars['timestamptz']['output'];
  /** An object relationship */
  event: Events;
  eventId: Scalars['bigint']['output'];
  /** An object relationship */
  fromRoomServiceOccurrence?: Maybe<RoomServiceOccurrences>;
  fromRoomServiceOccurrenceId?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "roomServiceOccurrences_guestCanEdit" */
  guestCanEdit?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "roomServiceOccurrences_hasChanges" */
  hasChanges?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['bigint']['output'];
  isDraft: Scalars['Boolean']['output'];
  /** An array relationship */
  lastVisits: Array<UserRoomServiceOccurrenceLastVisits>;
  /** An aggregate relationship */
  lastVisits_aggregate: UserRoomServiceOccurrenceLastVisits_Aggregate;
  name: Scalars['String']['output'];
  /** An array relationship */
  roomAttributeValueGroups: Array<RoomAttributeValueGroups>;
  /** An object relationship */
  roomService: RoomServices;
  roomServiceId: Scalars['bigint']['output'];
  startDate: Scalars['timestamptz']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userData: Array<UserDataRoomServiceOccurrences>;
};


/** columns and relationships of "roomServiceOccurrences" */
export type RoomServiceOccurrencesLastVisitsArgs = {
  distinct_on?: InputMaybe<Array<UserRoomServiceOccurrenceLastVisits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoomServiceOccurrenceLastVisits_Order_By>>;
  where?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Bool_Exp>;
};


/** columns and relationships of "roomServiceOccurrences" */
export type RoomServiceOccurrencesLastVisits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRoomServiceOccurrenceLastVisits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoomServiceOccurrenceLastVisits_Order_By>>;
  where?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Bool_Exp>;
};


/** columns and relationships of "roomServiceOccurrences" */
export type RoomServiceOccurrencesRoomAttributeValueGroupsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueGroups_Order_By>>;
  where?: InputMaybe<RoomAttributeValueGroups_Bool_Exp>;
};


/** columns and relationships of "roomServiceOccurrences" */
export type RoomServiceOccurrencesUserDataArgs = {
  distinct_on?: InputMaybe<Array<UserDataRoomServiceOccurrences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserDataRoomServiceOccurrences_Order_By>>;
  where?: InputMaybe<UserDataRoomServiceOccurrences_Bool_Exp>;
};

/** order by aggregate values of table "roomServiceOccurrences" */
export type RoomServiceOccurrences_Aggregate_Order_By = {
  avg?: InputMaybe<RoomServiceOccurrences_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RoomServiceOccurrences_Max_Order_By>;
  min?: InputMaybe<RoomServiceOccurrences_Min_Order_By>;
  stddev?: InputMaybe<RoomServiceOccurrences_Stddev_Order_By>;
  stddev_pop?: InputMaybe<RoomServiceOccurrences_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<RoomServiceOccurrences_Stddev_Samp_Order_By>;
  sum?: InputMaybe<RoomServiceOccurrences_Sum_Order_By>;
  var_pop?: InputMaybe<RoomServiceOccurrences_Var_Pop_Order_By>;
  var_samp?: InputMaybe<RoomServiceOccurrences_Var_Samp_Order_By>;
  variance?: InputMaybe<RoomServiceOccurrences_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "roomServiceOccurrences" */
export type RoomServiceOccurrences_Arr_Rel_Insert_Input = {
  data: Array<RoomServiceOccurrences_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomServiceOccurrences_On_Conflict>;
};

/** order by avg() on columns of table "roomServiceOccurrences" */
export type RoomServiceOccurrences_Avg_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromRoomServiceOccurrenceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "roomServiceOccurrences". All fields are combined with a logical 'AND'. */
export type RoomServiceOccurrences_Bool_Exp = {
  _and?: InputMaybe<Array<RoomServiceOccurrences_Bool_Exp>>;
  _not?: InputMaybe<RoomServiceOccurrences_Bool_Exp>;
  _or?: InputMaybe<Array<RoomServiceOccurrences_Bool_Exp>>;
  childValuesUpdatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  endDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Bigint_Comparison_Exp>;
  fromRoomServiceOccurrence?: InputMaybe<RoomServiceOccurrences_Bool_Exp>;
  fromRoomServiceOccurrenceId?: InputMaybe<Bigint_Comparison_Exp>;
  guestCanEdit?: InputMaybe<Boolean_Comparison_Exp>;
  hasChanges?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  isDraft?: InputMaybe<Boolean_Comparison_Exp>;
  lastVisits?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Bool_Exp>;
  lastVisits_aggregate?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  roomAttributeValueGroups?: InputMaybe<RoomAttributeValueGroups_Bool_Exp>;
  roomService?: InputMaybe<RoomServices_Bool_Exp>;
  roomServiceId?: InputMaybe<Bigint_Comparison_Exp>;
  startDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userData?: InputMaybe<UserDataRoomServiceOccurrences_Bool_Exp>;
};

/** unique or primary key constraints on table "roomServiceOccurrences" */
export enum RoomServiceOccurrences_Constraint {
  /** unique or primary key constraint on columns "id" */
  RoomServiceOccurrencesPkey = 'roomServiceOccurrences_pkey'
}

/** input type for inserting data into table "roomServiceOccurrences" */
export type RoomServiceOccurrences_Insert_Input = {
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  fromRoomServiceOccurrence?: InputMaybe<RoomServiceOccurrences_Obj_Rel_Insert_Input>;
  fromRoomServiceOccurrenceId?: InputMaybe<Scalars['bigint']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  lastVisits?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  roomAttributeValueGroups?: InputMaybe<RoomAttributeValueGroups_Arr_Rel_Insert_Input>;
  roomService?: InputMaybe<RoomServices_Obj_Rel_Insert_Input>;
  roomServiceId?: InputMaybe<Scalars['bigint']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  userData?: InputMaybe<UserDataRoomServiceOccurrences_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "roomServiceOccurrences" */
export type RoomServiceOccurrences_Max_Order_By = {
  childValuesUpdatedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  fromRoomServiceOccurrenceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "roomServiceOccurrences" */
export type RoomServiceOccurrences_Min_Order_By = {
  childValuesUpdatedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  fromRoomServiceOccurrenceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "roomServiceOccurrences" */
export type RoomServiceOccurrences_Mutation_Response = {
  __typename?: 'roomServiceOccurrences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RoomServiceOccurrences>;
};

/** input type for inserting object relation for remote table "roomServiceOccurrences" */
export type RoomServiceOccurrences_Obj_Rel_Insert_Input = {
  data: RoomServiceOccurrences_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomServiceOccurrences_On_Conflict>;
};

/** on_conflict condition type for table "roomServiceOccurrences" */
export type RoomServiceOccurrences_On_Conflict = {
  constraint: RoomServiceOccurrences_Constraint;
  update_columns?: Array<RoomServiceOccurrences_Update_Column>;
  where?: InputMaybe<RoomServiceOccurrences_Bool_Exp>;
};

/** Ordering options when selecting data from "roomServiceOccurrences". */
export type RoomServiceOccurrences_Order_By = {
  childValuesUpdatedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  fromRoomServiceOccurrence?: InputMaybe<RoomServiceOccurrences_Order_By>;
  fromRoomServiceOccurrenceId?: InputMaybe<Order_By>;
  guestCanEdit?: InputMaybe<Order_By>;
  hasChanges?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDraft?: InputMaybe<Order_By>;
  lastVisits_aggregate?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  roomAttributeValueGroups_aggregate?: InputMaybe<RoomAttributeValueGroups_Aggregate_Order_By>;
  roomService?: InputMaybe<RoomServices_Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userData_aggregate?: InputMaybe<UserDataRoomServiceOccurrences_Aggregate_Order_By>;
};

/** primary key columns input for table: roomServiceOccurrences */
export type RoomServiceOccurrences_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "roomServiceOccurrences" */
export enum RoomServiceOccurrences_Select_Column {
  /** column name */
  ChildValuesUpdatedAt = 'childValuesUpdatedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  EventId = 'eventId',
  /** column name */
  FromRoomServiceOccurrenceId = 'fromRoomServiceOccurrenceId',
  /** column name */
  Id = 'id',
  /** column name */
  IsDraft = 'isDraft',
  /** column name */
  Name = 'name',
  /** column name */
  RoomServiceId = 'roomServiceId',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "roomServiceOccurrences" */
export type RoomServiceOccurrences_Set_Input = {
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "roomServiceOccurrences" */
export type RoomServiceOccurrences_Stddev_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromRoomServiceOccurrenceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "roomServiceOccurrences" */
export type RoomServiceOccurrences_Stddev_Pop_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromRoomServiceOccurrenceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "roomServiceOccurrences" */
export type RoomServiceOccurrences_Stddev_Samp_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromRoomServiceOccurrenceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "roomServiceOccurrences" */
export type RoomServiceOccurrences_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RoomServiceOccurrences_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoomServiceOccurrences_Stream_Cursor_Value_Input = {
  childValuesUpdatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  fromRoomServiceOccurrenceId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roomServiceId?: InputMaybe<Scalars['bigint']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "roomServiceOccurrences" */
export type RoomServiceOccurrences_Sum_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromRoomServiceOccurrenceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
};

/** update columns of table "roomServiceOccurrences" */
export enum RoomServiceOccurrences_Update_Column {
  /** column name */
  EndDate = 'endDate',
  /** column name */
  IsDraft = 'isDraft',
  /** column name */
  Name = 'name',
  /** column name */
  StartDate = 'startDate'
}

export type RoomServiceOccurrences_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RoomServiceOccurrences_Set_Input>;
  /** filter the rows which have to be updated */
  where: RoomServiceOccurrences_Bool_Exp;
};

/** order by var_pop() on columns of table "roomServiceOccurrences" */
export type RoomServiceOccurrences_Var_Pop_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromRoomServiceOccurrenceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "roomServiceOccurrences" */
export type RoomServiceOccurrences_Var_Samp_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromRoomServiceOccurrenceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "roomServiceOccurrences" */
export type RoomServiceOccurrences_Variance_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromRoomServiceOccurrenceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  roomServiceId?: InputMaybe<Order_By>;
};

/** columns and relationships of "roomServiceOrganisationAccesses" */
export type RoomServiceOrganisationAccesses = {
  __typename?: 'roomServiceOrganisationAccesses';
  /** An object relationship */
  event: Events;
  eventId: Scalars['bigint']['output'];
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['bigint']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "roomServiceOrganisationAccesses" */
export type RoomServiceOrganisationAccesses_Aggregate = {
  __typename?: 'roomServiceOrganisationAccesses_aggregate';
  aggregate?: Maybe<RoomServiceOrganisationAccesses_Aggregate_Fields>;
  nodes: Array<RoomServiceOrganisationAccesses>;
};

/** aggregate fields of "roomServiceOrganisationAccesses" */
export type RoomServiceOrganisationAccesses_Aggregate_Fields = {
  __typename?: 'roomServiceOrganisationAccesses_aggregate_fields';
  avg?: Maybe<RoomServiceOrganisationAccesses_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RoomServiceOrganisationAccesses_Max_Fields>;
  min?: Maybe<RoomServiceOrganisationAccesses_Min_Fields>;
  stddev?: Maybe<RoomServiceOrganisationAccesses_Stddev_Fields>;
  stddev_pop?: Maybe<RoomServiceOrganisationAccesses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RoomServiceOrganisationAccesses_Stddev_Samp_Fields>;
  sum?: Maybe<RoomServiceOrganisationAccesses_Sum_Fields>;
  var_pop?: Maybe<RoomServiceOrganisationAccesses_Var_Pop_Fields>;
  var_samp?: Maybe<RoomServiceOrganisationAccesses_Var_Samp_Fields>;
  variance?: Maybe<RoomServiceOrganisationAccesses_Variance_Fields>;
};


/** aggregate fields of "roomServiceOrganisationAccesses" */
export type RoomServiceOrganisationAccesses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RoomServiceOrganisationAccesses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type RoomServiceOrganisationAccesses_Avg_Fields = {
  __typename?: 'roomServiceOrganisationAccesses_avg_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "roomServiceOrganisationAccesses". All fields are combined with a logical 'AND'. */
export type RoomServiceOrganisationAccesses_Bool_Exp = {
  _and?: InputMaybe<Array<RoomServiceOrganisationAccesses_Bool_Exp>>;
  _not?: InputMaybe<RoomServiceOrganisationAccesses_Bool_Exp>;
  _or?: InputMaybe<Array<RoomServiceOrganisationAccesses_Bool_Exp>>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Bigint_Comparison_Exp>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisationId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "roomServiceOrganisationAccesses" */
export enum RoomServiceOrganisationAccesses_Constraint {
  /** unique or primary key constraint on columns "eventId", "organisationId" */
  RoomServiceOrganisationAccessesPkey = 'roomServiceOrganisationAccesses_pkey'
}

/** input type for inserting data into table "roomServiceOrganisationAccesses" */
export type RoomServiceOrganisationAccesses_Insert_Input = {
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  organisation?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type RoomServiceOrganisationAccesses_Max_Fields = {
  __typename?: 'roomServiceOrganisationAccesses_max_fields';
  eventId?: Maybe<Scalars['bigint']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type RoomServiceOrganisationAccesses_Min_Fields = {
  __typename?: 'roomServiceOrganisationAccesses_min_fields';
  eventId?: Maybe<Scalars['bigint']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "roomServiceOrganisationAccesses" */
export type RoomServiceOrganisationAccesses_Mutation_Response = {
  __typename?: 'roomServiceOrganisationAccesses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RoomServiceOrganisationAccesses>;
};

/** on_conflict condition type for table "roomServiceOrganisationAccesses" */
export type RoomServiceOrganisationAccesses_On_Conflict = {
  constraint: RoomServiceOrganisationAccesses_Constraint;
  update_columns?: Array<RoomServiceOrganisationAccesses_Update_Column>;
  where?: InputMaybe<RoomServiceOrganisationAccesses_Bool_Exp>;
};

/** Ordering options when selecting data from "roomServiceOrganisationAccesses". */
export type RoomServiceOrganisationAccesses_Order_By = {
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisations_Order_By>;
  organisationId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: roomServiceOrganisationAccesses */
export type RoomServiceOrganisationAccesses_Pk_Columns_Input = {
  eventId: Scalars['bigint']['input'];
  organisationId: Scalars['bigint']['input'];
};

/** select columns of table "roomServiceOrganisationAccesses" */
export enum RoomServiceOrganisationAccesses_Select_Column {
  /** column name */
  EventId = 'eventId',
  /** column name */
  OrganisationId = 'organisationId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "roomServiceOrganisationAccesses" */
export type RoomServiceOrganisationAccesses_Set_Input = {
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type RoomServiceOrganisationAccesses_Stddev_Fields = {
  __typename?: 'roomServiceOrganisationAccesses_stddev_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type RoomServiceOrganisationAccesses_Stddev_Pop_Fields = {
  __typename?: 'roomServiceOrganisationAccesses_stddev_pop_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type RoomServiceOrganisationAccesses_Stddev_Samp_Fields = {
  __typename?: 'roomServiceOrganisationAccesses_stddev_samp_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "roomServiceOrganisationAccesses" */
export type RoomServiceOrganisationAccesses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RoomServiceOrganisationAccesses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoomServiceOrganisationAccesses_Stream_Cursor_Value_Input = {
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type RoomServiceOrganisationAccesses_Sum_Fields = {
  __typename?: 'roomServiceOrganisationAccesses_sum_fields';
  eventId?: Maybe<Scalars['bigint']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "roomServiceOrganisationAccesses" */
export enum RoomServiceOrganisationAccesses_Update_Column {
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type RoomServiceOrganisationAccesses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RoomServiceOrganisationAccesses_Set_Input>;
  /** filter the rows which have to be updated */
  where: RoomServiceOrganisationAccesses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type RoomServiceOrganisationAccesses_Var_Pop_Fields = {
  __typename?: 'roomServiceOrganisationAccesses_var_pop_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type RoomServiceOrganisationAccesses_Var_Samp_Fields = {
  __typename?: 'roomServiceOrganisationAccesses_var_samp_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RoomServiceOrganisationAccesses_Variance_Fields = {
  __typename?: 'roomServiceOrganisationAccesses_variance_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "roomServices" */
export type RoomServices = {
  __typename?: 'roomServices';
  createdAt: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fromRoomServiceId?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  room: Rooms;
  /** An array relationship */
  roomAttributeGroups: Array<RoomAttributeGroups>;
  roomId: Scalars['bigint']['output'];
  /** An object relationship */
  roomServiceCategory?: Maybe<RoomServiceCategories>;
  roomServiceCategoryId?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  roomServiceOccurrences: Array<RoomServiceOccurrences>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "roomServices" */
export type RoomServicesRoomAttributeGroupsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeGroups_Order_By>>;
  where?: InputMaybe<RoomAttributeGroups_Bool_Exp>;
};


/** columns and relationships of "roomServices" */
export type RoomServicesRoomServiceOccurrencesArgs = {
  distinct_on?: InputMaybe<Array<RoomServiceOccurrences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomServiceOccurrences_Order_By>>;
  where?: InputMaybe<RoomServiceOccurrences_Bool_Exp>;
};

/** order by aggregate values of table "roomServices" */
export type RoomServices_Aggregate_Order_By = {
  avg?: InputMaybe<RoomServices_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RoomServices_Max_Order_By>;
  min?: InputMaybe<RoomServices_Min_Order_By>;
  stddev?: InputMaybe<RoomServices_Stddev_Order_By>;
  stddev_pop?: InputMaybe<RoomServices_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<RoomServices_Stddev_Samp_Order_By>;
  sum?: InputMaybe<RoomServices_Sum_Order_By>;
  var_pop?: InputMaybe<RoomServices_Var_Pop_Order_By>;
  var_samp?: InputMaybe<RoomServices_Var_Samp_Order_By>;
  variance?: InputMaybe<RoomServices_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "roomServices" */
export type RoomServices_Arr_Rel_Insert_Input = {
  data: Array<RoomServices_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomServices_On_Conflict>;
};

/** order by avg() on columns of table "roomServices" */
export type RoomServices_Avg_Order_By = {
  fromRoomServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceCategoryId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "roomServices". All fields are combined with a logical 'AND'. */
export type RoomServices_Bool_Exp = {
  _and?: InputMaybe<Array<RoomServices_Bool_Exp>>;
  _not?: InputMaybe<RoomServices_Bool_Exp>;
  _or?: InputMaybe<Array<RoomServices_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  fromRoomServiceId?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  room?: InputMaybe<Rooms_Bool_Exp>;
  roomAttributeGroups?: InputMaybe<RoomAttributeGroups_Bool_Exp>;
  roomId?: InputMaybe<Bigint_Comparison_Exp>;
  roomServiceCategory?: InputMaybe<RoomServiceCategories_Bool_Exp>;
  roomServiceCategoryId?: InputMaybe<Bigint_Comparison_Exp>;
  roomServiceOccurrences?: InputMaybe<RoomServiceOccurrences_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "roomServices" */
export enum RoomServices_Constraint {
  /** unique or primary key constraint on columns "id" */
  RoomServicesPkey = 'roomServices_pkey'
}

/** input type for incrementing numeric columns in table "roomServices" */
export type RoomServices_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
  roomServiceCategoryId?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "roomServices" */
export type RoomServices_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  room?: InputMaybe<Rooms_Obj_Rel_Insert_Input>;
  roomAttributeGroups?: InputMaybe<RoomAttributeGroups_Arr_Rel_Insert_Input>;
  roomId?: InputMaybe<Scalars['bigint']['input']>;
  roomServiceCategory?: InputMaybe<RoomServiceCategories_Obj_Rel_Insert_Input>;
  roomServiceCategoryId?: InputMaybe<Scalars['bigint']['input']>;
  roomServiceOccurrences?: InputMaybe<RoomServiceOccurrences_Arr_Rel_Insert_Input>;
};

/** order by max() on columns of table "roomServices" */
export type RoomServices_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  fromRoomServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceCategoryId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "roomServices" */
export type RoomServices_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  fromRoomServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceCategoryId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "roomServices" */
export type RoomServices_Mutation_Response = {
  __typename?: 'roomServices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RoomServices>;
};

/** input type for inserting object relation for remote table "roomServices" */
export type RoomServices_Obj_Rel_Insert_Input = {
  data: RoomServices_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<RoomServices_On_Conflict>;
};

/** on_conflict condition type for table "roomServices" */
export type RoomServices_On_Conflict = {
  constraint: RoomServices_Constraint;
  update_columns?: Array<RoomServices_Update_Column>;
  where?: InputMaybe<RoomServices_Bool_Exp>;
};

/** Ordering options when selecting data from "roomServices". */
export type RoomServices_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  fromRoomServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  room?: InputMaybe<Rooms_Order_By>;
  roomAttributeGroups_aggregate?: InputMaybe<RoomAttributeGroups_Aggregate_Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceCategory?: InputMaybe<RoomServiceCategories_Order_By>;
  roomServiceCategoryId?: InputMaybe<Order_By>;
  roomServiceOccurrences_aggregate?: InputMaybe<RoomServiceOccurrences_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: roomServices */
export type RoomServices_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "roomServices" */
export enum RoomServices_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  FromRoomServiceId = 'fromRoomServiceId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  RoomId = 'roomId',
  /** column name */
  RoomServiceCategoryId = 'roomServiceCategoryId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "roomServices" */
export type RoomServices_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  roomServiceCategoryId?: InputMaybe<Scalars['bigint']['input']>;
};

/** order by stddev() on columns of table "roomServices" */
export type RoomServices_Stddev_Order_By = {
  fromRoomServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceCategoryId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "roomServices" */
export type RoomServices_Stddev_Pop_Order_By = {
  fromRoomServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceCategoryId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "roomServices" */
export type RoomServices_Stddev_Samp_Order_By = {
  fromRoomServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceCategoryId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "roomServices" */
export type RoomServices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RoomServices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RoomServices_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fromRoomServiceId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  roomId?: InputMaybe<Scalars['bigint']['input']>;
  roomServiceCategoryId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "roomServices" */
export type RoomServices_Sum_Order_By = {
  fromRoomServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceCategoryId?: InputMaybe<Order_By>;
};

/** update columns of table "roomServices" */
export enum RoomServices_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  RoomServiceCategoryId = 'roomServiceCategoryId'
}

export type RoomServices_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RoomServices_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RoomServices_Set_Input>;
  /** filter the rows which have to be updated */
  where: RoomServices_Bool_Exp;
};

/** order by var_pop() on columns of table "roomServices" */
export type RoomServices_Var_Pop_Order_By = {
  fromRoomServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceCategoryId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "roomServices" */
export type RoomServices_Var_Samp_Order_By = {
  fromRoomServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceCategoryId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "roomServices" */
export type RoomServices_Variance_Order_By = {
  fromRoomServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomId?: InputMaybe<Order_By>;
  roomServiceCategoryId?: InputMaybe<Order_By>;
};

/** columns and relationships of "rooms" */
export type Rooms = {
  __typename?: 'rooms';
  createdAt: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  event?: Maybe<Events>;
  eventId?: Maybe<Scalars['bigint']['output']>;
  externalReference: Scalars['String']['output'];
  fromRoomId?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  /** An object relationship */
  roomFolder?: Maybe<RoomFolders>;
  roomFolderId?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  roomServices: Array<RoomServices>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "rooms" */
export type RoomsRoomServicesArgs = {
  distinct_on?: InputMaybe<Array<RoomServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomServices_Order_By>>;
  where?: InputMaybe<RoomServices_Bool_Exp>;
};

/** aggregated selection of "rooms" */
export type Rooms_Aggregate = {
  __typename?: 'rooms_aggregate';
  aggregate?: Maybe<Rooms_Aggregate_Fields>;
  nodes: Array<Rooms>;
};

export type Rooms_Aggregate_Bool_Exp = {
  count?: InputMaybe<Rooms_Aggregate_Bool_Exp_Count>;
};

export type Rooms_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Rooms_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Rooms_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "rooms" */
export type Rooms_Aggregate_Fields = {
  __typename?: 'rooms_aggregate_fields';
  avg?: Maybe<Rooms_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Rooms_Max_Fields>;
  min?: Maybe<Rooms_Min_Fields>;
  stddev?: Maybe<Rooms_Stddev_Fields>;
  stddev_pop?: Maybe<Rooms_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Rooms_Stddev_Samp_Fields>;
  sum?: Maybe<Rooms_Sum_Fields>;
  var_pop?: Maybe<Rooms_Var_Pop_Fields>;
  var_samp?: Maybe<Rooms_Var_Samp_Fields>;
  variance?: Maybe<Rooms_Variance_Fields>;
};


/** aggregate fields of "rooms" */
export type Rooms_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rooms_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "rooms" */
export type Rooms_Aggregate_Order_By = {
  avg?: InputMaybe<Rooms_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Rooms_Max_Order_By>;
  min?: InputMaybe<Rooms_Min_Order_By>;
  stddev?: InputMaybe<Rooms_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Rooms_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Rooms_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Rooms_Sum_Order_By>;
  var_pop?: InputMaybe<Rooms_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Rooms_Var_Samp_Order_By>;
  variance?: InputMaybe<Rooms_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "rooms" */
export type Rooms_Arr_Rel_Insert_Input = {
  data: Array<Rooms_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Rooms_On_Conflict>;
};

/** aggregate avg on columns */
export type Rooms_Avg_Fields = {
  __typename?: 'rooms_avg_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  fromRoomId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  roomFolderId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "rooms" */
export type Rooms_Avg_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromRoomId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomFolderId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "rooms". All fields are combined with a logical 'AND'. */
export type Rooms_Bool_Exp = {
  _and?: InputMaybe<Array<Rooms_Bool_Exp>>;
  _not?: InputMaybe<Rooms_Bool_Exp>;
  _or?: InputMaybe<Array<Rooms_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Bigint_Comparison_Exp>;
  externalReference?: InputMaybe<String_Comparison_Exp>;
  fromRoomId?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  roomFolder?: InputMaybe<RoomFolders_Bool_Exp>;
  roomFolderId?: InputMaybe<Bigint_Comparison_Exp>;
  roomServices?: InputMaybe<RoomServices_Bool_Exp>;
  shortDescription?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "rooms" */
export enum Rooms_Constraint {
  /** unique or primary key constraint on columns "id" */
  RoomsPkey = 'rooms_pkey'
}

/** input type for incrementing numeric columns in table "rooms" */
export type Rooms_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
  roomFolderId?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "rooms" */
export type Rooms_Insert_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  fromRoomId?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  roomFolder?: InputMaybe<RoomFolders_Obj_Rel_Insert_Input>;
  roomFolderId?: InputMaybe<Scalars['bigint']['input']>;
  roomServices?: InputMaybe<RoomServices_Arr_Rel_Insert_Input>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Rooms_Max_Fields = {
  __typename?: 'rooms_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['bigint']['output']>;
  externalReference?: Maybe<Scalars['String']['output']>;
  fromRoomId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  roomFolderId?: Maybe<Scalars['bigint']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "rooms" */
export type Rooms_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  externalReference?: InputMaybe<Order_By>;
  fromRoomId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomFolderId?: InputMaybe<Order_By>;
  shortDescription?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Rooms_Min_Fields = {
  __typename?: 'rooms_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['bigint']['output']>;
  externalReference?: Maybe<Scalars['String']['output']>;
  fromRoomId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  roomFolderId?: Maybe<Scalars['bigint']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "rooms" */
export type Rooms_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  externalReference?: InputMaybe<Order_By>;
  fromRoomId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomFolderId?: InputMaybe<Order_By>;
  shortDescription?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "rooms" */
export type Rooms_Mutation_Response = {
  __typename?: 'rooms_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Rooms>;
};

/** input type for inserting object relation for remote table "rooms" */
export type Rooms_Obj_Rel_Insert_Input = {
  data: Rooms_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Rooms_On_Conflict>;
};

/** on_conflict condition type for table "rooms" */
export type Rooms_On_Conflict = {
  constraint: Rooms_Constraint;
  update_columns?: Array<Rooms_Update_Column>;
  where?: InputMaybe<Rooms_Bool_Exp>;
};

/** Ordering options when selecting data from "rooms". */
export type Rooms_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  externalReference?: InputMaybe<Order_By>;
  fromRoomId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomFolder?: InputMaybe<RoomFolders_Order_By>;
  roomFolderId?: InputMaybe<Order_By>;
  roomServices_aggregate?: InputMaybe<RoomServices_Aggregate_Order_By>;
  shortDescription?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rooms */
export type Rooms_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "rooms" */
export enum Rooms_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EventId = 'eventId',
  /** column name */
  ExternalReference = 'externalReference',
  /** column name */
  FromRoomId = 'fromRoomId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  RoomFolderId = 'roomFolderId',
  /** column name */
  ShortDescription = 'shortDescription',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "rooms" */
export type Rooms_Set_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  roomFolderId?: InputMaybe<Scalars['bigint']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Rooms_Stddev_Fields = {
  __typename?: 'rooms_stddev_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  fromRoomId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  roomFolderId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "rooms" */
export type Rooms_Stddev_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromRoomId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomFolderId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Rooms_Stddev_Pop_Fields = {
  __typename?: 'rooms_stddev_pop_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  fromRoomId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  roomFolderId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "rooms" */
export type Rooms_Stddev_Pop_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromRoomId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomFolderId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Rooms_Stddev_Samp_Fields = {
  __typename?: 'rooms_stddev_samp_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  fromRoomId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  roomFolderId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "rooms" */
export type Rooms_Stddev_Samp_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromRoomId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomFolderId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "rooms" */
export type Rooms_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rooms_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rooms_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  externalReference?: InputMaybe<Scalars['String']['input']>;
  fromRoomId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  roomFolderId?: InputMaybe<Scalars['bigint']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Rooms_Sum_Fields = {
  __typename?: 'rooms_sum_fields';
  eventId?: Maybe<Scalars['bigint']['output']>;
  fromRoomId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  roomFolderId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "rooms" */
export type Rooms_Sum_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromRoomId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomFolderId?: InputMaybe<Order_By>;
};

/** update columns of table "rooms" */
export enum Rooms_Update_Column {
  /** column name */
  Description = 'description',
  /** column name */
  ExternalReference = 'externalReference',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  RoomFolderId = 'roomFolderId',
  /** column name */
  ShortDescription = 'shortDescription'
}

export type Rooms_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rooms_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rooms_Set_Input>;
  /** filter the rows which have to be updated */
  where: Rooms_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Rooms_Var_Pop_Fields = {
  __typename?: 'rooms_var_pop_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  fromRoomId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  roomFolderId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "rooms" */
export type Rooms_Var_Pop_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromRoomId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomFolderId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Rooms_Var_Samp_Fields = {
  __typename?: 'rooms_var_samp_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  fromRoomId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  roomFolderId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "rooms" */
export type Rooms_Var_Samp_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromRoomId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomFolderId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Rooms_Variance_Fields = {
  __typename?: 'rooms_variance_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  fromRoomId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  roomFolderId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "rooms" */
export type Rooms_Variance_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromRoomId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  roomFolderId?: InputMaybe<Order_By>;
};

/** columns and relationships of "serviceBundleServices" */
export type ServiceBundleServices = {
  __typename?: 'serviceBundleServices';
  /** An object relationship */
  service: Services;
  /** An object relationship */
  serviceBundle: ServiceBundles;
  serviceBundleId: Scalars['bigint']['output'];
  serviceId: Scalars['bigint']['output'];
};

/** aggregated selection of "serviceBundleServices" */
export type ServiceBundleServices_Aggregate = {
  __typename?: 'serviceBundleServices_aggregate';
  aggregate?: Maybe<ServiceBundleServices_Aggregate_Fields>;
  nodes: Array<ServiceBundleServices>;
};

export type ServiceBundleServices_Aggregate_Bool_Exp = {
  count?: InputMaybe<ServiceBundleServices_Aggregate_Bool_Exp_Count>;
};

export type ServiceBundleServices_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ServiceBundleServices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceBundleServices_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "serviceBundleServices" */
export type ServiceBundleServices_Aggregate_Fields = {
  __typename?: 'serviceBundleServices_aggregate_fields';
  avg?: Maybe<ServiceBundleServices_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ServiceBundleServices_Max_Fields>;
  min?: Maybe<ServiceBundleServices_Min_Fields>;
  stddev?: Maybe<ServiceBundleServices_Stddev_Fields>;
  stddev_pop?: Maybe<ServiceBundleServices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ServiceBundleServices_Stddev_Samp_Fields>;
  sum?: Maybe<ServiceBundleServices_Sum_Fields>;
  var_pop?: Maybe<ServiceBundleServices_Var_Pop_Fields>;
  var_samp?: Maybe<ServiceBundleServices_Var_Samp_Fields>;
  variance?: Maybe<ServiceBundleServices_Variance_Fields>;
};


/** aggregate fields of "serviceBundleServices" */
export type ServiceBundleServices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServiceBundleServices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "serviceBundleServices" */
export type ServiceBundleServices_Aggregate_Order_By = {
  avg?: InputMaybe<ServiceBundleServices_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ServiceBundleServices_Max_Order_By>;
  min?: InputMaybe<ServiceBundleServices_Min_Order_By>;
  stddev?: InputMaybe<ServiceBundleServices_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ServiceBundleServices_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ServiceBundleServices_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ServiceBundleServices_Sum_Order_By>;
  var_pop?: InputMaybe<ServiceBundleServices_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ServiceBundleServices_Var_Samp_Order_By>;
  variance?: InputMaybe<ServiceBundleServices_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "serviceBundleServices" */
export type ServiceBundleServices_Arr_Rel_Insert_Input = {
  data: Array<ServiceBundleServices_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceBundleServices_On_Conflict>;
};

/** aggregate avg on columns */
export type ServiceBundleServices_Avg_Fields = {
  __typename?: 'serviceBundleServices_avg_fields';
  serviceBundleId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "serviceBundleServices" */
export type ServiceBundleServices_Avg_Order_By = {
  serviceBundleId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "serviceBundleServices". All fields are combined with a logical 'AND'. */
export type ServiceBundleServices_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceBundleServices_Bool_Exp>>;
  _not?: InputMaybe<ServiceBundleServices_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceBundleServices_Bool_Exp>>;
  service?: InputMaybe<Services_Bool_Exp>;
  serviceBundle?: InputMaybe<ServiceBundles_Bool_Exp>;
  serviceBundleId?: InputMaybe<Bigint_Comparison_Exp>;
  serviceId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "serviceBundleServices" */
export enum ServiceBundleServices_Constraint {
  /** unique or primary key constraint on columns "serviceId", "serviceBundleId" */
  ServiceBundleServicesPkey = 'serviceBundleServices_pkey'
}

/** input type for inserting data into table "serviceBundleServices" */
export type ServiceBundleServices_Insert_Input = {
  service?: InputMaybe<Services_Obj_Rel_Insert_Input>;
  serviceBundle?: InputMaybe<ServiceBundles_Obj_Rel_Insert_Input>;
  serviceBundleId?: InputMaybe<Scalars['bigint']['input']>;
  serviceId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type ServiceBundleServices_Max_Fields = {
  __typename?: 'serviceBundleServices_max_fields';
  serviceBundleId?: Maybe<Scalars['bigint']['output']>;
  serviceId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "serviceBundleServices" */
export type ServiceBundleServices_Max_Order_By = {
  serviceBundleId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ServiceBundleServices_Min_Fields = {
  __typename?: 'serviceBundleServices_min_fields';
  serviceBundleId?: Maybe<Scalars['bigint']['output']>;
  serviceId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "serviceBundleServices" */
export type ServiceBundleServices_Min_Order_By = {
  serviceBundleId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "serviceBundleServices" */
export type ServiceBundleServices_Mutation_Response = {
  __typename?: 'serviceBundleServices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ServiceBundleServices>;
};

/** on_conflict condition type for table "serviceBundleServices" */
export type ServiceBundleServices_On_Conflict = {
  constraint: ServiceBundleServices_Constraint;
  update_columns?: Array<ServiceBundleServices_Update_Column>;
  where?: InputMaybe<ServiceBundleServices_Bool_Exp>;
};

/** Ordering options when selecting data from "serviceBundleServices". */
export type ServiceBundleServices_Order_By = {
  service?: InputMaybe<Services_Order_By>;
  serviceBundle?: InputMaybe<ServiceBundles_Order_By>;
  serviceBundleId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** select columns of table "serviceBundleServices" */
export enum ServiceBundleServices_Select_Column {
  /** column name */
  ServiceBundleId = 'serviceBundleId',
  /** column name */
  ServiceId = 'serviceId'
}

/** aggregate stddev on columns */
export type ServiceBundleServices_Stddev_Fields = {
  __typename?: 'serviceBundleServices_stddev_fields';
  serviceBundleId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "serviceBundleServices" */
export type ServiceBundleServices_Stddev_Order_By = {
  serviceBundleId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ServiceBundleServices_Stddev_Pop_Fields = {
  __typename?: 'serviceBundleServices_stddev_pop_fields';
  serviceBundleId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "serviceBundleServices" */
export type ServiceBundleServices_Stddev_Pop_Order_By = {
  serviceBundleId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ServiceBundleServices_Stddev_Samp_Fields = {
  __typename?: 'serviceBundleServices_stddev_samp_fields';
  serviceBundleId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "serviceBundleServices" */
export type ServiceBundleServices_Stddev_Samp_Order_By = {
  serviceBundleId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "serviceBundleServices" */
export type ServiceBundleServices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceBundleServices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceBundleServices_Stream_Cursor_Value_Input = {
  serviceBundleId?: InputMaybe<Scalars['bigint']['input']>;
  serviceId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type ServiceBundleServices_Sum_Fields = {
  __typename?: 'serviceBundleServices_sum_fields';
  serviceBundleId?: Maybe<Scalars['bigint']['output']>;
  serviceId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "serviceBundleServices" */
export type ServiceBundleServices_Sum_Order_By = {
  serviceBundleId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "serviceBundleServices" (current role has no relevant permissions) */
export enum ServiceBundleServices_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type ServiceBundleServices_Var_Pop_Fields = {
  __typename?: 'serviceBundleServices_var_pop_fields';
  serviceBundleId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "serviceBundleServices" */
export type ServiceBundleServices_Var_Pop_Order_By = {
  serviceBundleId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ServiceBundleServices_Var_Samp_Fields = {
  __typename?: 'serviceBundleServices_var_samp_fields';
  serviceBundleId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "serviceBundleServices" */
export type ServiceBundleServices_Var_Samp_Order_By = {
  serviceBundleId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ServiceBundleServices_Variance_Fields = {
  __typename?: 'serviceBundleServices_variance_fields';
  serviceBundleId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "serviceBundleServices" */
export type ServiceBundleServices_Variance_Order_By = {
  serviceBundleId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** columns and relationships of "serviceBundles" */
export type ServiceBundles = {
  __typename?: 'serviceBundles';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  serviceBundleServices: Array<ServiceBundleServices>;
  /** An aggregate relationship */
  serviceBundleServices_aggregate: ServiceBundleServices_Aggregate;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "serviceBundles" */
export type ServiceBundlesServiceBundleServicesArgs = {
  distinct_on?: InputMaybe<Array<ServiceBundleServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceBundleServices_Order_By>>;
  where?: InputMaybe<ServiceBundleServices_Bool_Exp>;
};


/** columns and relationships of "serviceBundles" */
export type ServiceBundlesServiceBundleServices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceBundleServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceBundleServices_Order_By>>;
  where?: InputMaybe<ServiceBundleServices_Bool_Exp>;
};

/** aggregated selection of "serviceBundles" */
export type ServiceBundles_Aggregate = {
  __typename?: 'serviceBundles_aggregate';
  aggregate?: Maybe<ServiceBundles_Aggregate_Fields>;
  nodes: Array<ServiceBundles>;
};

/** aggregate fields of "serviceBundles" */
export type ServiceBundles_Aggregate_Fields = {
  __typename?: 'serviceBundles_aggregate_fields';
  avg?: Maybe<ServiceBundles_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ServiceBundles_Max_Fields>;
  min?: Maybe<ServiceBundles_Min_Fields>;
  stddev?: Maybe<ServiceBundles_Stddev_Fields>;
  stddev_pop?: Maybe<ServiceBundles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ServiceBundles_Stddev_Samp_Fields>;
  sum?: Maybe<ServiceBundles_Sum_Fields>;
  var_pop?: Maybe<ServiceBundles_Var_Pop_Fields>;
  var_samp?: Maybe<ServiceBundles_Var_Samp_Fields>;
  variance?: Maybe<ServiceBundles_Variance_Fields>;
};


/** aggregate fields of "serviceBundles" */
export type ServiceBundles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServiceBundles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ServiceBundles_Avg_Fields = {
  __typename?: 'serviceBundles_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "serviceBundles". All fields are combined with a logical 'AND'. */
export type ServiceBundles_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceBundles_Bool_Exp>>;
  _not?: InputMaybe<ServiceBundles_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceBundles_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  serviceBundleServices?: InputMaybe<ServiceBundleServices_Bool_Exp>;
  serviceBundleServices_aggregate?: InputMaybe<ServiceBundleServices_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "serviceBundles" */
export enum ServiceBundles_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServiceBundlesPkey = 'serviceBundles_pkey'
}

/** input type for inserting data into table "serviceBundles" */
export type ServiceBundles_Insert_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serviceBundleServices?: InputMaybe<ServiceBundleServices_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type ServiceBundles_Max_Fields = {
  __typename?: 'serviceBundles_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type ServiceBundles_Min_Fields = {
  __typename?: 'serviceBundles_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "serviceBundles" */
export type ServiceBundles_Mutation_Response = {
  __typename?: 'serviceBundles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ServiceBundles>;
};

/** input type for inserting object relation for remote table "serviceBundles" */
export type ServiceBundles_Obj_Rel_Insert_Input = {
  data: ServiceBundles_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceBundles_On_Conflict>;
};

/** on_conflict condition type for table "serviceBundles" */
export type ServiceBundles_On_Conflict = {
  constraint: ServiceBundles_Constraint;
  update_columns?: Array<ServiceBundles_Update_Column>;
  where?: InputMaybe<ServiceBundles_Bool_Exp>;
};

/** Ordering options when selecting data from "serviceBundles". */
export type ServiceBundles_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  serviceBundleServices_aggregate?: InputMaybe<ServiceBundleServices_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: serviceBundles */
export type ServiceBundles_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "serviceBundles" */
export enum ServiceBundles_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "serviceBundles" */
export type ServiceBundles_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type ServiceBundles_Stddev_Fields = {
  __typename?: 'serviceBundles_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ServiceBundles_Stddev_Pop_Fields = {
  __typename?: 'serviceBundles_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ServiceBundles_Stddev_Samp_Fields = {
  __typename?: 'serviceBundles_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "serviceBundles" */
export type ServiceBundles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceBundles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceBundles_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type ServiceBundles_Sum_Fields = {
  __typename?: 'serviceBundles_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "serviceBundles" */
export enum ServiceBundles_Update_Column {
  /** column name */
  Name = 'name'
}

export type ServiceBundles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ServiceBundles_Set_Input>;
  /** filter the rows which have to be updated */
  where: ServiceBundles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ServiceBundles_Var_Pop_Fields = {
  __typename?: 'serviceBundles_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ServiceBundles_Var_Samp_Fields = {
  __typename?: 'serviceBundles_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ServiceBundles_Variance_Fields = {
  __typename?: 'serviceBundles_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "serviceFavourites" */
export type ServiceFavourites = {
  __typename?: 'serviceFavourites';
  /** An object relationship */
  service: Services;
  serviceId: Scalars['bigint']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['bigint']['output'];
};

/** aggregated selection of "serviceFavourites" */
export type ServiceFavourites_Aggregate = {
  __typename?: 'serviceFavourites_aggregate';
  aggregate?: Maybe<ServiceFavourites_Aggregate_Fields>;
  nodes: Array<ServiceFavourites>;
};

export type ServiceFavourites_Aggregate_Bool_Exp = {
  count?: InputMaybe<ServiceFavourites_Aggregate_Bool_Exp_Count>;
};

export type ServiceFavourites_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ServiceFavourites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceFavourites_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "serviceFavourites" */
export type ServiceFavourites_Aggregate_Fields = {
  __typename?: 'serviceFavourites_aggregate_fields';
  avg?: Maybe<ServiceFavourites_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ServiceFavourites_Max_Fields>;
  min?: Maybe<ServiceFavourites_Min_Fields>;
  stddev?: Maybe<ServiceFavourites_Stddev_Fields>;
  stddev_pop?: Maybe<ServiceFavourites_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ServiceFavourites_Stddev_Samp_Fields>;
  sum?: Maybe<ServiceFavourites_Sum_Fields>;
  var_pop?: Maybe<ServiceFavourites_Var_Pop_Fields>;
  var_samp?: Maybe<ServiceFavourites_Var_Samp_Fields>;
  variance?: Maybe<ServiceFavourites_Variance_Fields>;
};


/** aggregate fields of "serviceFavourites" */
export type ServiceFavourites_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServiceFavourites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "serviceFavourites" */
export type ServiceFavourites_Aggregate_Order_By = {
  avg?: InputMaybe<ServiceFavourites_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ServiceFavourites_Max_Order_By>;
  min?: InputMaybe<ServiceFavourites_Min_Order_By>;
  stddev?: InputMaybe<ServiceFavourites_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ServiceFavourites_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ServiceFavourites_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ServiceFavourites_Sum_Order_By>;
  var_pop?: InputMaybe<ServiceFavourites_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ServiceFavourites_Var_Samp_Order_By>;
  variance?: InputMaybe<ServiceFavourites_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "serviceFavourites" */
export type ServiceFavourites_Arr_Rel_Insert_Input = {
  data: Array<ServiceFavourites_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceFavourites_On_Conflict>;
};

/** aggregate avg on columns */
export type ServiceFavourites_Avg_Fields = {
  __typename?: 'serviceFavourites_avg_fields';
  serviceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "serviceFavourites" */
export type ServiceFavourites_Avg_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "serviceFavourites". All fields are combined with a logical 'AND'. */
export type ServiceFavourites_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceFavourites_Bool_Exp>>;
  _not?: InputMaybe<ServiceFavourites_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceFavourites_Bool_Exp>>;
  service?: InputMaybe<Services_Bool_Exp>;
  serviceId?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "serviceFavourites" */
export enum ServiceFavourites_Constraint {
  /** unique or primary key constraint on columns "userId", "serviceId" */
  ServiceFavouritesPkey = 'serviceFavourites_pkey'
}

/** input type for inserting data into table "serviceFavourites" */
export type ServiceFavourites_Insert_Input = {
  service?: InputMaybe<Services_Obj_Rel_Insert_Input>;
  serviceId?: InputMaybe<Scalars['bigint']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type ServiceFavourites_Max_Fields = {
  __typename?: 'serviceFavourites_max_fields';
  serviceId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "serviceFavourites" */
export type ServiceFavourites_Max_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ServiceFavourites_Min_Fields = {
  __typename?: 'serviceFavourites_min_fields';
  serviceId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "serviceFavourites" */
export type ServiceFavourites_Min_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "serviceFavourites" */
export type ServiceFavourites_Mutation_Response = {
  __typename?: 'serviceFavourites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ServiceFavourites>;
};

/** on_conflict condition type for table "serviceFavourites" */
export type ServiceFavourites_On_Conflict = {
  constraint: ServiceFavourites_Constraint;
  update_columns?: Array<ServiceFavourites_Update_Column>;
  where?: InputMaybe<ServiceFavourites_Bool_Exp>;
};

/** Ordering options when selecting data from "serviceFavourites". */
export type ServiceFavourites_Order_By = {
  service?: InputMaybe<Services_Order_By>;
  serviceId?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: serviceFavourites */
export type ServiceFavourites_Pk_Columns_Input = {
  serviceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};

/** select columns of table "serviceFavourites" */
export enum ServiceFavourites_Select_Column {
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type ServiceFavourites_Stddev_Fields = {
  __typename?: 'serviceFavourites_stddev_fields';
  serviceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "serviceFavourites" */
export type ServiceFavourites_Stddev_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ServiceFavourites_Stddev_Pop_Fields = {
  __typename?: 'serviceFavourites_stddev_pop_fields';
  serviceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "serviceFavourites" */
export type ServiceFavourites_Stddev_Pop_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ServiceFavourites_Stddev_Samp_Fields = {
  __typename?: 'serviceFavourites_stddev_samp_fields';
  serviceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "serviceFavourites" */
export type ServiceFavourites_Stddev_Samp_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "serviceFavourites" */
export type ServiceFavourites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceFavourites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceFavourites_Stream_Cursor_Value_Input = {
  serviceId?: InputMaybe<Scalars['bigint']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type ServiceFavourites_Sum_Fields = {
  __typename?: 'serviceFavourites_sum_fields';
  serviceId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "serviceFavourites" */
export type ServiceFavourites_Sum_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "serviceFavourites" (current role has no relevant permissions) */
export enum ServiceFavourites_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

export type ServiceFavourites_Updates = {
  /** filter the rows which have to be updated */
  where: ServiceFavourites_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ServiceFavourites_Var_Pop_Fields = {
  __typename?: 'serviceFavourites_var_pop_fields';
  serviceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "serviceFavourites" */
export type ServiceFavourites_Var_Pop_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ServiceFavourites_Var_Samp_Fields = {
  __typename?: 'serviceFavourites_var_samp_fields';
  serviceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "serviceFavourites" */
export type ServiceFavourites_Var_Samp_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ServiceFavourites_Variance_Fields = {
  __typename?: 'serviceFavourites_variance_fields';
  serviceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "serviceFavourites" */
export type ServiceFavourites_Variance_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "serviceModuleAccesses" */
export type ServiceModuleAccesses = {
  __typename?: 'serviceModuleAccesses';
  createdAt: Scalars['timestamptz']['output'];
  guestUsers: Scalars['Boolean']['output'];
  id: Scalars['bigint']['output'];
  /** An object relationship */
  organisationGroup?: Maybe<OrganisationGroups>;
  organisationGroupId?: Maybe<Scalars['bigint']['output']>;
  /** An array relationship */
  organisationGroupUsers: Array<OrganisationGroupUsers>;
  /** An aggregate relationship */
  organisationGroupUsers_aggregate: OrganisationGroupUsers_Aggregate;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  serviceModule: ServiceModules;
  serviceModuleId: Scalars['bigint']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  writable: Scalars['Boolean']['output'];
};


/** columns and relationships of "serviceModuleAccesses" */
export type ServiceModuleAccessesOrganisationGroupUsersArgs = {
  distinct_on?: InputMaybe<Array<OrganisationGroupUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<OrganisationGroupUsers_Order_By>>;
  where?: InputMaybe<OrganisationGroupUsers_Bool_Exp>;
};


/** columns and relationships of "serviceModuleAccesses" */
export type ServiceModuleAccessesOrganisationGroupUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganisationGroupUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<OrganisationGroupUsers_Order_By>>;
  where?: InputMaybe<OrganisationGroupUsers_Bool_Exp>;
};

/** aggregated selection of "serviceModuleAccesses" */
export type ServiceModuleAccesses_Aggregate = {
  __typename?: 'serviceModuleAccesses_aggregate';
  aggregate?: Maybe<ServiceModuleAccesses_Aggregate_Fields>;
  nodes: Array<ServiceModuleAccesses>;
};

export type ServiceModuleAccesses_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<ServiceModuleAccesses_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ServiceModuleAccesses_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<ServiceModuleAccesses_Aggregate_Bool_Exp_Count>;
};

export type ServiceModuleAccesses_Aggregate_Bool_Exp_Bool_And = {
  arguments: ServiceModuleAccesses_Select_Column_ServiceModuleAccesses_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceModuleAccesses_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ServiceModuleAccesses_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ServiceModuleAccesses_Select_Column_ServiceModuleAccesses_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceModuleAccesses_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ServiceModuleAccesses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ServiceModuleAccesses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceModuleAccesses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "serviceModuleAccesses" */
export type ServiceModuleAccesses_Aggregate_Fields = {
  __typename?: 'serviceModuleAccesses_aggregate_fields';
  avg?: Maybe<ServiceModuleAccesses_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ServiceModuleAccesses_Max_Fields>;
  min?: Maybe<ServiceModuleAccesses_Min_Fields>;
  stddev?: Maybe<ServiceModuleAccesses_Stddev_Fields>;
  stddev_pop?: Maybe<ServiceModuleAccesses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ServiceModuleAccesses_Stddev_Samp_Fields>;
  sum?: Maybe<ServiceModuleAccesses_Sum_Fields>;
  var_pop?: Maybe<ServiceModuleAccesses_Var_Pop_Fields>;
  var_samp?: Maybe<ServiceModuleAccesses_Var_Samp_Fields>;
  variance?: Maybe<ServiceModuleAccesses_Variance_Fields>;
};


/** aggregate fields of "serviceModuleAccesses" */
export type ServiceModuleAccesses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServiceModuleAccesses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "serviceModuleAccesses" */
export type ServiceModuleAccesses_Aggregate_Order_By = {
  avg?: InputMaybe<ServiceModuleAccesses_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ServiceModuleAccesses_Max_Order_By>;
  min?: InputMaybe<ServiceModuleAccesses_Min_Order_By>;
  stddev?: InputMaybe<ServiceModuleAccesses_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ServiceModuleAccesses_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ServiceModuleAccesses_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ServiceModuleAccesses_Sum_Order_By>;
  var_pop?: InputMaybe<ServiceModuleAccesses_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ServiceModuleAccesses_Var_Samp_Order_By>;
  variance?: InputMaybe<ServiceModuleAccesses_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "serviceModuleAccesses" */
export type ServiceModuleAccesses_Arr_Rel_Insert_Input = {
  data: Array<ServiceModuleAccesses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceModuleAccesses_On_Conflict>;
};

/** aggregate avg on columns */
export type ServiceModuleAccesses_Avg_Fields = {
  __typename?: 'serviceModuleAccesses_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationGroupId?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "serviceModuleAccesses" */
export type ServiceModuleAccesses_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationGroupId?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "serviceModuleAccesses". All fields are combined with a logical 'AND'. */
export type ServiceModuleAccesses_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceModuleAccesses_Bool_Exp>>;
  _not?: InputMaybe<ServiceModuleAccesses_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceModuleAccesses_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  guestUsers?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  organisationGroup?: InputMaybe<OrganisationGroups_Bool_Exp>;
  organisationGroupId?: InputMaybe<Bigint_Comparison_Exp>;
  organisationGroupUsers?: InputMaybe<OrganisationGroupUsers_Bool_Exp>;
  organisationGroupUsers_aggregate?: InputMaybe<OrganisationGroupUsers_Aggregate_Bool_Exp>;
  organisationId?: InputMaybe<Bigint_Comparison_Exp>;
  serviceModule?: InputMaybe<ServiceModules_Bool_Exp>;
  serviceModuleId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  writable?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "serviceModuleAccesses" */
export enum ServiceModuleAccesses_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServiceModuleAccessesPkey = 'serviceModuleAccesses_pkey',
  /** unique or primary key constraint on columns "organisationId", "serviceModuleId", "organisationGroupId" */
  ServiceModuleAccessesServiceModuleIdOrganisationIdOrganiKey = 'serviceModuleAccesses_serviceModuleId_organisationId_organi_key'
}

/** input type for inserting data into table "serviceModuleAccesses" */
export type ServiceModuleAccesses_Insert_Input = {
  guestUsers?: InputMaybe<Scalars['Boolean']['input']>;
  organisationGroup?: InputMaybe<OrganisationGroups_Obj_Rel_Insert_Input>;
  organisationGroupId?: InputMaybe<Scalars['bigint']['input']>;
  organisationGroupUsers?: InputMaybe<OrganisationGroupUsers_Arr_Rel_Insert_Input>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
  serviceModule?: InputMaybe<ServiceModules_Obj_Rel_Insert_Input>;
  serviceModuleId?: InputMaybe<Scalars['bigint']['input']>;
  writable?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type ServiceModuleAccesses_Max_Fields = {
  __typename?: 'serviceModuleAccesses_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  organisationGroupId?: Maybe<Scalars['bigint']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "serviceModuleAccesses" */
export type ServiceModuleAccesses_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisationGroupId?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ServiceModuleAccesses_Min_Fields = {
  __typename?: 'serviceModuleAccesses_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  organisationGroupId?: Maybe<Scalars['bigint']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "serviceModuleAccesses" */
export type ServiceModuleAccesses_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisationGroupId?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "serviceModuleAccesses" */
export type ServiceModuleAccesses_Mutation_Response = {
  __typename?: 'serviceModuleAccesses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ServiceModuleAccesses>;
};

/** on_conflict condition type for table "serviceModuleAccesses" */
export type ServiceModuleAccesses_On_Conflict = {
  constraint: ServiceModuleAccesses_Constraint;
  update_columns?: Array<ServiceModuleAccesses_Update_Column>;
  where?: InputMaybe<ServiceModuleAccesses_Bool_Exp>;
};

/** Ordering options when selecting data from "serviceModuleAccesses". */
export type ServiceModuleAccesses_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  guestUsers?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisationGroup?: InputMaybe<OrganisationGroups_Order_By>;
  organisationGroupId?: InputMaybe<Order_By>;
  organisationGroupUsers_aggregate?: InputMaybe<OrganisationGroupUsers_Aggregate_Order_By>;
  organisationId?: InputMaybe<Order_By>;
  serviceModule?: InputMaybe<ServiceModules_Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  writable?: InputMaybe<Order_By>;
};

/** primary key columns input for table: serviceModuleAccesses */
export type ServiceModuleAccesses_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "serviceModuleAccesses" */
export enum ServiceModuleAccesses_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GuestUsers = 'guestUsers',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationGroupId = 'organisationGroupId',
  /** column name */
  OrganisationId = 'organisationId',
  /** column name */
  ServiceModuleId = 'serviceModuleId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Writable = 'writable'
}

/** select "serviceModuleAccesses_aggregate_bool_exp_bool_and_arguments_columns" columns of table "serviceModuleAccesses" */
export enum ServiceModuleAccesses_Select_Column_ServiceModuleAccesses_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  GuestUsers = 'guestUsers',
  /** column name */
  Writable = 'writable'
}

/** select "serviceModuleAccesses_aggregate_bool_exp_bool_or_arguments_columns" columns of table "serviceModuleAccesses" */
export enum ServiceModuleAccesses_Select_Column_ServiceModuleAccesses_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  GuestUsers = 'guestUsers',
  /** column name */
  Writable = 'writable'
}

/** input type for updating data in table "serviceModuleAccesses" */
export type ServiceModuleAccesses_Set_Input = {
  writable?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type ServiceModuleAccesses_Stddev_Fields = {
  __typename?: 'serviceModuleAccesses_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationGroupId?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "serviceModuleAccesses" */
export type ServiceModuleAccesses_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationGroupId?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ServiceModuleAccesses_Stddev_Pop_Fields = {
  __typename?: 'serviceModuleAccesses_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationGroupId?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "serviceModuleAccesses" */
export type ServiceModuleAccesses_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationGroupId?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ServiceModuleAccesses_Stddev_Samp_Fields = {
  __typename?: 'serviceModuleAccesses_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationGroupId?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "serviceModuleAccesses" */
export type ServiceModuleAccesses_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationGroupId?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "serviceModuleAccesses" */
export type ServiceModuleAccesses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceModuleAccesses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceModuleAccesses_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  guestUsers?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  organisationGroupId?: InputMaybe<Scalars['bigint']['input']>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
  serviceModuleId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  writable?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type ServiceModuleAccesses_Sum_Fields = {
  __typename?: 'serviceModuleAccesses_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  organisationGroupId?: Maybe<Scalars['bigint']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "serviceModuleAccesses" */
export type ServiceModuleAccesses_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationGroupId?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** update columns of table "serviceModuleAccesses" */
export enum ServiceModuleAccesses_Update_Column {
  /** column name */
  Writable = 'writable'
}

export type ServiceModuleAccesses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ServiceModuleAccesses_Set_Input>;
  /** filter the rows which have to be updated */
  where: ServiceModuleAccesses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ServiceModuleAccesses_Var_Pop_Fields = {
  __typename?: 'serviceModuleAccesses_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationGroupId?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "serviceModuleAccesses" */
export type ServiceModuleAccesses_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationGroupId?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ServiceModuleAccesses_Var_Samp_Fields = {
  __typename?: 'serviceModuleAccesses_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationGroupId?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "serviceModuleAccesses" */
export type ServiceModuleAccesses_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationGroupId?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ServiceModuleAccesses_Variance_Fields = {
  __typename?: 'serviceModuleAccesses_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationGroupId?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "serviceModuleAccesses" */
export type ServiceModuleAccesses_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationGroupId?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** columns and relationships of "serviceModuleChanges" */
export type ServiceModuleChanges = {
  __typename?: 'serviceModuleChanges';
  createdAt: Scalars['timestamptz']['output'];
  displayData: Scalars['jsonb']['output'];
  /** An object relationship */
  fullUser?: Maybe<Users>;
  id: Scalars['bigint']['output'];
  op: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
  /** An object relationship */
  serviceModule: ServiceModules;
  serviceModuleId: Scalars['bigint']['output'];
  table: Scalars['String']['output'];
  /** An object relationship */
  user?: Maybe<AllUsers>;
  userId?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "serviceModuleChanges" */
export type ServiceModuleChangesDisplayDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "serviceModuleChanges" */
export type ServiceModuleChanges_Aggregate = {
  __typename?: 'serviceModuleChanges_aggregate';
  aggregate?: Maybe<ServiceModuleChanges_Aggregate_Fields>;
  nodes: Array<ServiceModuleChanges>;
};

/** aggregate fields of "serviceModuleChanges" */
export type ServiceModuleChanges_Aggregate_Fields = {
  __typename?: 'serviceModuleChanges_aggregate_fields';
  avg?: Maybe<ServiceModuleChanges_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ServiceModuleChanges_Max_Fields>;
  min?: Maybe<ServiceModuleChanges_Min_Fields>;
  stddev?: Maybe<ServiceModuleChanges_Stddev_Fields>;
  stddev_pop?: Maybe<ServiceModuleChanges_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ServiceModuleChanges_Stddev_Samp_Fields>;
  sum?: Maybe<ServiceModuleChanges_Sum_Fields>;
  var_pop?: Maybe<ServiceModuleChanges_Var_Pop_Fields>;
  var_samp?: Maybe<ServiceModuleChanges_Var_Samp_Fields>;
  variance?: Maybe<ServiceModuleChanges_Variance_Fields>;
};


/** aggregate fields of "serviceModuleChanges" */
export type ServiceModuleChanges_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServiceModuleChanges_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ServiceModuleChanges_Avg_Fields = {
  __typename?: 'serviceModuleChanges_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "serviceModuleChanges". All fields are combined with a logical 'AND'. */
export type ServiceModuleChanges_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceModuleChanges_Bool_Exp>>;
  _not?: InputMaybe<ServiceModuleChanges_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceModuleChanges_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  displayData?: InputMaybe<Jsonb_Comparison_Exp>;
  fullUser?: InputMaybe<Users_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  op?: InputMaybe<String_Comparison_Exp>;
  published?: InputMaybe<Boolean_Comparison_Exp>;
  serviceModule?: InputMaybe<ServiceModules_Bool_Exp>;
  serviceModuleId?: InputMaybe<Bigint_Comparison_Exp>;
  table?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<AllUsers_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** columns and relationships of "serviceModuleChanges_grouped" */
export type ServiceModuleChanges_Grouped = {
  __typename?: 'serviceModuleChanges_grouped';
  changes?: Maybe<Scalars['json']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  fullUser?: Maybe<Users>;
  /** An object relationship */
  serviceModule?: Maybe<ServiceModules>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  user?: Maybe<AllUsers>;
  userId?: Maybe<Scalars['bigint']['output']>;
};


/** columns and relationships of "serviceModuleChanges_grouped" */
export type ServiceModuleChanges_GroupedChangesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "serviceModuleChanges_grouped" */
export type ServiceModuleChanges_Grouped_Aggregate = {
  __typename?: 'serviceModuleChanges_grouped_aggregate';
  aggregate?: Maybe<ServiceModuleChanges_Grouped_Aggregate_Fields>;
  nodes: Array<ServiceModuleChanges_Grouped>;
};

/** aggregate fields of "serviceModuleChanges_grouped" */
export type ServiceModuleChanges_Grouped_Aggregate_Fields = {
  __typename?: 'serviceModuleChanges_grouped_aggregate_fields';
  avg?: Maybe<ServiceModuleChanges_Grouped_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ServiceModuleChanges_Grouped_Max_Fields>;
  min?: Maybe<ServiceModuleChanges_Grouped_Min_Fields>;
  stddev?: Maybe<ServiceModuleChanges_Grouped_Stddev_Fields>;
  stddev_pop?: Maybe<ServiceModuleChanges_Grouped_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ServiceModuleChanges_Grouped_Stddev_Samp_Fields>;
  sum?: Maybe<ServiceModuleChanges_Grouped_Sum_Fields>;
  var_pop?: Maybe<ServiceModuleChanges_Grouped_Var_Pop_Fields>;
  var_samp?: Maybe<ServiceModuleChanges_Grouped_Var_Samp_Fields>;
  variance?: Maybe<ServiceModuleChanges_Grouped_Variance_Fields>;
};


/** aggregate fields of "serviceModuleChanges_grouped" */
export type ServiceModuleChanges_Grouped_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServiceModuleChanges_Grouped_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ServiceModuleChanges_Grouped_Avg_Fields = {
  __typename?: 'serviceModuleChanges_grouped_avg_fields';
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "serviceModuleChanges_grouped". All fields are combined with a logical 'AND'. */
export type ServiceModuleChanges_Grouped_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceModuleChanges_Grouped_Bool_Exp>>;
  _not?: InputMaybe<ServiceModuleChanges_Grouped_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceModuleChanges_Grouped_Bool_Exp>>;
  changes?: InputMaybe<Json_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  fullUser?: InputMaybe<Users_Bool_Exp>;
  serviceModule?: InputMaybe<ServiceModules_Bool_Exp>;
  serviceModuleId?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<AllUsers_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** aggregate max on columns */
export type ServiceModuleChanges_Grouped_Max_Fields = {
  __typename?: 'serviceModuleChanges_grouped_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type ServiceModuleChanges_Grouped_Min_Fields = {
  __typename?: 'serviceModuleChanges_grouped_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "serviceModuleChanges_grouped". */
export type ServiceModuleChanges_Grouped_Order_By = {
  changes?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fullUser?: InputMaybe<Users_Order_By>;
  serviceModule?: InputMaybe<ServiceModules_Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  user?: InputMaybe<AllUsers_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "serviceModuleChanges_grouped" */
export enum ServiceModuleChanges_Grouped_Select_Column {
  /** column name */
  Changes = 'changes',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ServiceModuleId = 'serviceModuleId',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type ServiceModuleChanges_Grouped_Stddev_Fields = {
  __typename?: 'serviceModuleChanges_grouped_stddev_fields';
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ServiceModuleChanges_Grouped_Stddev_Pop_Fields = {
  __typename?: 'serviceModuleChanges_grouped_stddev_pop_fields';
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ServiceModuleChanges_Grouped_Stddev_Samp_Fields = {
  __typename?: 'serviceModuleChanges_grouped_stddev_samp_fields';
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "serviceModuleChanges_grouped" */
export type ServiceModuleChanges_Grouped_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceModuleChanges_Grouped_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceModuleChanges_Grouped_Stream_Cursor_Value_Input = {
  changes?: InputMaybe<Scalars['json']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  serviceModuleId?: InputMaybe<Scalars['bigint']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type ServiceModuleChanges_Grouped_Sum_Fields = {
  __typename?: 'serviceModuleChanges_grouped_sum_fields';
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type ServiceModuleChanges_Grouped_Var_Pop_Fields = {
  __typename?: 'serviceModuleChanges_grouped_var_pop_fields';
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ServiceModuleChanges_Grouped_Var_Samp_Fields = {
  __typename?: 'serviceModuleChanges_grouped_var_samp_fields';
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ServiceModuleChanges_Grouped_Variance_Fields = {
  __typename?: 'serviceModuleChanges_grouped_variance_fields';
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type ServiceModuleChanges_Max_Fields = {
  __typename?: 'serviceModuleChanges_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  op?: Maybe<Scalars['String']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  table?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate min on columns */
export type ServiceModuleChanges_Min_Fields = {
  __typename?: 'serviceModuleChanges_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  op?: Maybe<Scalars['String']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  table?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** Ordering options when selecting data from "serviceModuleChanges". */
export type ServiceModuleChanges_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  displayData?: InputMaybe<Order_By>;
  fullUser?: InputMaybe<Users_Order_By>;
  id?: InputMaybe<Order_By>;
  op?: InputMaybe<Order_By>;
  published?: InputMaybe<Order_By>;
  serviceModule?: InputMaybe<ServiceModules_Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  table?: InputMaybe<Order_By>;
  user?: InputMaybe<AllUsers_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** select columns of table "serviceModuleChanges" */
export enum ServiceModuleChanges_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DisplayData = 'displayData',
  /** column name */
  Id = 'id',
  /** column name */
  Op = 'op',
  /** column name */
  Published = 'published',
  /** column name */
  ServiceModuleId = 'serviceModuleId',
  /** column name */
  Table = 'table',
  /** column name */
  UserId = 'userId'
}

/** aggregate stddev on columns */
export type ServiceModuleChanges_Stddev_Fields = {
  __typename?: 'serviceModuleChanges_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ServiceModuleChanges_Stddev_Pop_Fields = {
  __typename?: 'serviceModuleChanges_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ServiceModuleChanges_Stddev_Samp_Fields = {
  __typename?: 'serviceModuleChanges_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "serviceModuleChanges" */
export type ServiceModuleChanges_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceModuleChanges_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceModuleChanges_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  displayData?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  op?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  serviceModuleId?: InputMaybe<Scalars['bigint']['input']>;
  table?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type ServiceModuleChanges_Sum_Fields = {
  __typename?: 'serviceModuleChanges_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type ServiceModuleChanges_Var_Pop_Fields = {
  __typename?: 'serviceModuleChanges_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ServiceModuleChanges_Var_Samp_Fields = {
  __typename?: 'serviceModuleChanges_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ServiceModuleChanges_Variance_Fields = {
  __typename?: 'serviceModuleChanges_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "serviceModules" */
export type ServiceModules = {
  __typename?: 'serviceModules';
  /** An array relationship */
  attributeGroups: Array<AttributeGroups>;
  /** An aggregate relationship */
  attributeGroups_aggregate: AttributeGroups_Aggregate;
  /** An array relationship */
  carts: Array<Carts>;
  /** An aggregate relationship */
  carts_aggregate: Carts_Aggregate;
  childValuesUpdatedAt: Scalars['timestamptz']['output'];
  config: Scalars['json']['output'];
  createdAt: Scalars['timestamptz']['output'];
  fromServiceModuleId?: Maybe<Scalars['bigint']['output']>;
  /** A computed field, executes function "serviceModules_guestCanRead" */
  guestCanRead?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "serviceModules_hasChanges" */
  hasChanges?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['bigint']['output'];
  /** An array relationship */
  lastVisits: Array<UserServiceModuleLastVisits>;
  /** An aggregate relationship */
  lastVisits_aggregate: UserServiceModuleLastVisits_Aggregate;
  moduleType: ModuleTypes_Enum;
  name: Scalars['String']['output'];
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  order: Scalars['Int']['output'];
  /** An array relationship */
  orders: Array<Orders>;
  /** An aggregate relationship */
  orders_aggregate: Orders_Aggregate;
  published?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  service: Services;
  serviceId: Scalars['bigint']['output'];
  /** An array relationship */
  serviceModuleAccesses: Array<ServiceModuleAccesses>;
  /** An aggregate relationship */
  serviceModuleAccesses_aggregate: ServiceModuleAccesses_Aggregate;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  uploads: Array<Uploads>;
  /** An aggregate relationship */
  uploads_aggregate: Uploads_Aggregate;
  /** A computed field, executes function "serviceModules_writable" */
  writable?: Maybe<Scalars['Boolean']['output']>;
};


/** columns and relationships of "serviceModules" */
export type ServiceModulesAttributeGroupsArgs = {
  distinct_on?: InputMaybe<Array<AttributeGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeGroups_Order_By>>;
  where?: InputMaybe<AttributeGroups_Bool_Exp>;
};


/** columns and relationships of "serviceModules" */
export type ServiceModulesAttributeGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeGroups_Order_By>>;
  where?: InputMaybe<AttributeGroups_Bool_Exp>;
};


/** columns and relationships of "serviceModules" */
export type ServiceModulesCartsArgs = {
  distinct_on?: InputMaybe<Array<Carts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Carts_Order_By>>;
  where?: InputMaybe<Carts_Bool_Exp>;
};


/** columns and relationships of "serviceModules" */
export type ServiceModulesCarts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Carts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Carts_Order_By>>;
  where?: InputMaybe<Carts_Bool_Exp>;
};


/** columns and relationships of "serviceModules" */
export type ServiceModulesConfigArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "serviceModules" */
export type ServiceModulesLastVisitsArgs = {
  distinct_on?: InputMaybe<Array<UserServiceModuleLastVisits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserServiceModuleLastVisits_Order_By>>;
  where?: InputMaybe<UserServiceModuleLastVisits_Bool_Exp>;
};


/** columns and relationships of "serviceModules" */
export type ServiceModulesLastVisits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserServiceModuleLastVisits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserServiceModuleLastVisits_Order_By>>;
  where?: InputMaybe<UserServiceModuleLastVisits_Bool_Exp>;
};


/** columns and relationships of "serviceModules" */
export type ServiceModulesNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "serviceModules" */
export type ServiceModulesNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "serviceModules" */
export type ServiceModulesOrdersArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "serviceModules" */
export type ServiceModulesOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


/** columns and relationships of "serviceModules" */
export type ServiceModulesServiceModuleAccessesArgs = {
  distinct_on?: InputMaybe<Array<ServiceModuleAccesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModuleAccesses_Order_By>>;
  where?: InputMaybe<ServiceModuleAccesses_Bool_Exp>;
};


/** columns and relationships of "serviceModules" */
export type ServiceModulesServiceModuleAccesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceModuleAccesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModuleAccesses_Order_By>>;
  where?: InputMaybe<ServiceModuleAccesses_Bool_Exp>;
};


/** columns and relationships of "serviceModules" */
export type ServiceModulesUploadsArgs = {
  distinct_on?: InputMaybe<Array<Uploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uploads_Order_By>>;
  where?: InputMaybe<Uploads_Bool_Exp>;
};


/** columns and relationships of "serviceModules" */
export type ServiceModulesUploads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uploads_Order_By>>;
  where?: InputMaybe<Uploads_Bool_Exp>;
};

/** aggregated selection of "serviceModules" */
export type ServiceModules_Aggregate = {
  __typename?: 'serviceModules_aggregate';
  aggregate?: Maybe<ServiceModules_Aggregate_Fields>;
  nodes: Array<ServiceModules>;
};

export type ServiceModules_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<ServiceModules_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<ServiceModules_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<ServiceModules_Aggregate_Bool_Exp_Count>;
};

export type ServiceModules_Aggregate_Bool_Exp_Bool_And = {
  arguments: ServiceModules_Select_Column_ServiceModules_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceModules_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ServiceModules_Aggregate_Bool_Exp_Bool_Or = {
  arguments: ServiceModules_Select_Column_ServiceModules_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceModules_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type ServiceModules_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ServiceModules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceModules_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "serviceModules" */
export type ServiceModules_Aggregate_Fields = {
  __typename?: 'serviceModules_aggregate_fields';
  avg?: Maybe<ServiceModules_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ServiceModules_Max_Fields>;
  min?: Maybe<ServiceModules_Min_Fields>;
  stddev?: Maybe<ServiceModules_Stddev_Fields>;
  stddev_pop?: Maybe<ServiceModules_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ServiceModules_Stddev_Samp_Fields>;
  sum?: Maybe<ServiceModules_Sum_Fields>;
  var_pop?: Maybe<ServiceModules_Var_Pop_Fields>;
  var_samp?: Maybe<ServiceModules_Var_Samp_Fields>;
  variance?: Maybe<ServiceModules_Variance_Fields>;
};


/** aggregate fields of "serviceModules" */
export type ServiceModules_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServiceModules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "serviceModules" */
export type ServiceModules_Aggregate_Order_By = {
  avg?: InputMaybe<ServiceModules_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ServiceModules_Max_Order_By>;
  min?: InputMaybe<ServiceModules_Min_Order_By>;
  stddev?: InputMaybe<ServiceModules_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ServiceModules_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ServiceModules_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ServiceModules_Sum_Order_By>;
  var_pop?: InputMaybe<ServiceModules_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ServiceModules_Var_Samp_Order_By>;
  variance?: InputMaybe<ServiceModules_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "serviceModules" */
export type ServiceModules_Arr_Rel_Insert_Input = {
  data: Array<ServiceModules_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceModules_On_Conflict>;
};

/** aggregate avg on columns */
export type ServiceModules_Avg_Fields = {
  __typename?: 'serviceModules_avg_fields';
  fromServiceModuleId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "serviceModules" */
export type ServiceModules_Avg_Order_By = {
  fromServiceModuleId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "serviceModules". All fields are combined with a logical 'AND'. */
export type ServiceModules_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceModules_Bool_Exp>>;
  _not?: InputMaybe<ServiceModules_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceModules_Bool_Exp>>;
  attributeGroups?: InputMaybe<AttributeGroups_Bool_Exp>;
  attributeGroups_aggregate?: InputMaybe<AttributeGroups_Aggregate_Bool_Exp>;
  carts?: InputMaybe<Carts_Bool_Exp>;
  carts_aggregate?: InputMaybe<Carts_Aggregate_Bool_Exp>;
  childValuesUpdatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  config?: InputMaybe<Json_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  fromServiceModuleId?: InputMaybe<Bigint_Comparison_Exp>;
  guestCanRead?: InputMaybe<Boolean_Comparison_Exp>;
  hasChanges?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  lastVisits?: InputMaybe<UserServiceModuleLastVisits_Bool_Exp>;
  lastVisits_aggregate?: InputMaybe<UserServiceModuleLastVisits_Aggregate_Bool_Exp>;
  moduleType?: InputMaybe<ModuleTypes_Enum_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Bool_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  orders?: InputMaybe<Orders_Bool_Exp>;
  orders_aggregate?: InputMaybe<Orders_Aggregate_Bool_Exp>;
  published?: InputMaybe<Boolean_Comparison_Exp>;
  service?: InputMaybe<Services_Bool_Exp>;
  serviceId?: InputMaybe<Bigint_Comparison_Exp>;
  serviceModuleAccesses?: InputMaybe<ServiceModuleAccesses_Bool_Exp>;
  serviceModuleAccesses_aggregate?: InputMaybe<ServiceModuleAccesses_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploads?: InputMaybe<Uploads_Bool_Exp>;
  uploads_aggregate?: InputMaybe<Uploads_Aggregate_Bool_Exp>;
  writable?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "serviceModules" */
export enum ServiceModules_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServiceModulesPkey = 'serviceModules_pkey'
}

/** input type for incrementing numeric columns in table "serviceModules" */
export type ServiceModules_Inc_Input = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "serviceModules" */
export type ServiceModules_Insert_Input = {
  attributeGroups?: InputMaybe<AttributeGroups_Arr_Rel_Insert_Input>;
  carts?: InputMaybe<Carts_Arr_Rel_Insert_Input>;
  config?: InputMaybe<Scalars['json']['input']>;
  lastVisits?: InputMaybe<UserServiceModuleLastVisits_Arr_Rel_Insert_Input>;
  moduleType?: InputMaybe<ModuleTypes_Enum>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  orders?: InputMaybe<Orders_Arr_Rel_Insert_Input>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  service?: InputMaybe<Services_Obj_Rel_Insert_Input>;
  serviceId?: InputMaybe<Scalars['bigint']['input']>;
  serviceModuleAccesses?: InputMaybe<ServiceModuleAccesses_Arr_Rel_Insert_Input>;
  uploads?: InputMaybe<Uploads_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type ServiceModules_Max_Fields = {
  __typename?: 'serviceModules_max_fields';
  childValuesUpdatedAt?: Maybe<Scalars['timestamptz']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fromServiceModuleId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  serviceId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "serviceModules" */
export type ServiceModules_Max_Order_By = {
  childValuesUpdatedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fromServiceModuleId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ServiceModules_Min_Fields = {
  __typename?: 'serviceModules_min_fields';
  childValuesUpdatedAt?: Maybe<Scalars['timestamptz']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fromServiceModuleId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  serviceId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "serviceModules" */
export type ServiceModules_Min_Order_By = {
  childValuesUpdatedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fromServiceModuleId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "serviceModules" */
export type ServiceModules_Mutation_Response = {
  __typename?: 'serviceModules_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ServiceModules>;
};

/** input type for inserting object relation for remote table "serviceModules" */
export type ServiceModules_Obj_Rel_Insert_Input = {
  data: ServiceModules_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceModules_On_Conflict>;
};

/** on_conflict condition type for table "serviceModules" */
export type ServiceModules_On_Conflict = {
  constraint: ServiceModules_Constraint;
  update_columns?: Array<ServiceModules_Update_Column>;
  where?: InputMaybe<ServiceModules_Bool_Exp>;
};

/** Ordering options when selecting data from "serviceModules". */
export type ServiceModules_Order_By = {
  attributeGroups_aggregate?: InputMaybe<AttributeGroups_Aggregate_Order_By>;
  carts_aggregate?: InputMaybe<Carts_Aggregate_Order_By>;
  childValuesUpdatedAt?: InputMaybe<Order_By>;
  config?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fromServiceModuleId?: InputMaybe<Order_By>;
  guestCanRead?: InputMaybe<Order_By>;
  hasChanges?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastVisits_aggregate?: InputMaybe<UserServiceModuleLastVisits_Aggregate_Order_By>;
  moduleType?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  order?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Orders_Aggregate_Order_By>;
  published?: InputMaybe<Order_By>;
  service?: InputMaybe<Services_Order_By>;
  serviceId?: InputMaybe<Order_By>;
  serviceModuleAccesses_aggregate?: InputMaybe<ServiceModuleAccesses_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploads_aggregate?: InputMaybe<Uploads_Aggregate_Order_By>;
  writable?: InputMaybe<Order_By>;
};

/** primary key columns input for table: serviceModules */
export type ServiceModules_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "serviceModules" */
export enum ServiceModules_Select_Column {
  /** column name */
  ChildValuesUpdatedAt = 'childValuesUpdatedAt',
  /** column name */
  Config = 'config',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  FromServiceModuleId = 'fromServiceModuleId',
  /** column name */
  Id = 'id',
  /** column name */
  ModuleType = 'moduleType',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  Published = 'published',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "serviceModules_aggregate_bool_exp_bool_and_arguments_columns" columns of table "serviceModules" */
export enum ServiceModules_Select_Column_ServiceModules_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Published = 'published'
}

/** select "serviceModules_aggregate_bool_exp_bool_or_arguments_columns" columns of table "serviceModules" */
export enum ServiceModules_Select_Column_ServiceModules_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Published = 'published'
}

/** input type for updating data in table "serviceModules" */
export type ServiceModules_Set_Input = {
  config?: InputMaybe<Scalars['json']['input']>;
  moduleType?: InputMaybe<ModuleTypes_Enum>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type ServiceModules_Stddev_Fields = {
  __typename?: 'serviceModules_stddev_fields';
  fromServiceModuleId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "serviceModules" */
export type ServiceModules_Stddev_Order_By = {
  fromServiceModuleId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ServiceModules_Stddev_Pop_Fields = {
  __typename?: 'serviceModules_stddev_pop_fields';
  fromServiceModuleId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "serviceModules" */
export type ServiceModules_Stddev_Pop_Order_By = {
  fromServiceModuleId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ServiceModules_Stddev_Samp_Fields = {
  __typename?: 'serviceModules_stddev_samp_fields';
  fromServiceModuleId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "serviceModules" */
export type ServiceModules_Stddev_Samp_Order_By = {
  fromServiceModuleId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "serviceModules" */
export type ServiceModules_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceModules_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceModules_Stream_Cursor_Value_Input = {
  childValuesUpdatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  config?: InputMaybe<Scalars['json']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fromServiceModuleId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  moduleType?: InputMaybe<ModuleTypes_Enum>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type ServiceModules_Sum_Fields = {
  __typename?: 'serviceModules_sum_fields';
  fromServiceModuleId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  serviceId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "serviceModules" */
export type ServiceModules_Sum_Order_By = {
  fromServiceModuleId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** update columns of table "serviceModules" */
export enum ServiceModules_Update_Column {
  /** column name */
  Config = 'config',
  /** column name */
  ModuleType = 'moduleType',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  Published = 'published'
}

export type ServiceModules_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ServiceModules_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ServiceModules_Set_Input>;
  /** filter the rows which have to be updated */
  where: ServiceModules_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ServiceModules_Var_Pop_Fields = {
  __typename?: 'serviceModules_var_pop_fields';
  fromServiceModuleId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "serviceModules" */
export type ServiceModules_Var_Pop_Order_By = {
  fromServiceModuleId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ServiceModules_Var_Samp_Fields = {
  __typename?: 'serviceModules_var_samp_fields';
  fromServiceModuleId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "serviceModules" */
export type ServiceModules_Var_Samp_Order_By = {
  fromServiceModuleId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ServiceModules_Variance_Fields = {
  __typename?: 'serviceModules_variance_fields';
  fromServiceModuleId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "serviceModules" */
export type ServiceModules_Variance_Order_By = {
  fromServiceModuleId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** columns and relationships of "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses = {
  __typename?: 'serviceOrganisationAccesses';
  /** An object relationship */
  organisation: Organisations;
  organisationId: Scalars['bigint']['output'];
  /** An object relationship */
  service: Services;
  serviceId: Scalars['bigint']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses_Aggregate = {
  __typename?: 'serviceOrganisationAccesses_aggregate';
  aggregate?: Maybe<ServiceOrganisationAccesses_Aggregate_Fields>;
  nodes: Array<ServiceOrganisationAccesses>;
};

export type ServiceOrganisationAccesses_Aggregate_Bool_Exp = {
  count?: InputMaybe<ServiceOrganisationAccesses_Aggregate_Bool_Exp_Count>;
};

export type ServiceOrganisationAccesses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ServiceOrganisationAccesses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ServiceOrganisationAccesses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses_Aggregate_Fields = {
  __typename?: 'serviceOrganisationAccesses_aggregate_fields';
  avg?: Maybe<ServiceOrganisationAccesses_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ServiceOrganisationAccesses_Max_Fields>;
  min?: Maybe<ServiceOrganisationAccesses_Min_Fields>;
  stddev?: Maybe<ServiceOrganisationAccesses_Stddev_Fields>;
  stddev_pop?: Maybe<ServiceOrganisationAccesses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ServiceOrganisationAccesses_Stddev_Samp_Fields>;
  sum?: Maybe<ServiceOrganisationAccesses_Sum_Fields>;
  var_pop?: Maybe<ServiceOrganisationAccesses_Var_Pop_Fields>;
  var_samp?: Maybe<ServiceOrganisationAccesses_Var_Samp_Fields>;
  variance?: Maybe<ServiceOrganisationAccesses_Variance_Fields>;
};


/** aggregate fields of "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServiceOrganisationAccesses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses_Aggregate_Order_By = {
  avg?: InputMaybe<ServiceOrganisationAccesses_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ServiceOrganisationAccesses_Max_Order_By>;
  min?: InputMaybe<ServiceOrganisationAccesses_Min_Order_By>;
  stddev?: InputMaybe<ServiceOrganisationAccesses_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ServiceOrganisationAccesses_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ServiceOrganisationAccesses_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ServiceOrganisationAccesses_Sum_Order_By>;
  var_pop?: InputMaybe<ServiceOrganisationAccesses_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ServiceOrganisationAccesses_Var_Samp_Order_By>;
  variance?: InputMaybe<ServiceOrganisationAccesses_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses_Arr_Rel_Insert_Input = {
  data: Array<ServiceOrganisationAccesses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ServiceOrganisationAccesses_On_Conflict>;
};

/** aggregate avg on columns */
export type ServiceOrganisationAccesses_Avg_Fields = {
  __typename?: 'serviceOrganisationAccesses_avg_fields';
  organisationId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses_Avg_Order_By = {
  organisationId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "serviceOrganisationAccesses". All fields are combined with a logical 'AND'. */
export type ServiceOrganisationAccesses_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceOrganisationAccesses_Bool_Exp>>;
  _not?: InputMaybe<ServiceOrganisationAccesses_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceOrganisationAccesses_Bool_Exp>>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisationId?: InputMaybe<Bigint_Comparison_Exp>;
  service?: InputMaybe<Services_Bool_Exp>;
  serviceId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "serviceOrganisationAccesses" */
export enum ServiceOrganisationAccesses_Constraint {
  /** unique or primary key constraint on columns "organisationId", "serviceId" */
  ServiceOrganisationAccessesPkey = 'serviceOrganisationAccesses_pkey'
}

/** input type for inserting data into table "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses_Insert_Input = {
  organisation?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  service?: InputMaybe<Services_Obj_Rel_Insert_Input>;
  serviceId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type ServiceOrganisationAccesses_Max_Fields = {
  __typename?: 'serviceOrganisationAccesses_max_fields';
  organisationId?: Maybe<Scalars['bigint']['output']>;
  serviceId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses_Max_Order_By = {
  organisationId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ServiceOrganisationAccesses_Min_Fields = {
  __typename?: 'serviceOrganisationAccesses_min_fields';
  organisationId?: Maybe<Scalars['bigint']['output']>;
  serviceId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses_Min_Order_By = {
  organisationId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses_Mutation_Response = {
  __typename?: 'serviceOrganisationAccesses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ServiceOrganisationAccesses>;
};

/** on_conflict condition type for table "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses_On_Conflict = {
  constraint: ServiceOrganisationAccesses_Constraint;
  update_columns?: Array<ServiceOrganisationAccesses_Update_Column>;
  where?: InputMaybe<ServiceOrganisationAccesses_Bool_Exp>;
};

/** Ordering options when selecting data from "serviceOrganisationAccesses". */
export type ServiceOrganisationAccesses_Order_By = {
  organisation?: InputMaybe<Organisations_Order_By>;
  organisationId?: InputMaybe<Order_By>;
  service?: InputMaybe<Services_Order_By>;
  serviceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: serviceOrganisationAccesses */
export type ServiceOrganisationAccesses_Pk_Columns_Input = {
  organisationId: Scalars['bigint']['input'];
  serviceId: Scalars['bigint']['input'];
};

/** select columns of table "serviceOrganisationAccesses" */
export enum ServiceOrganisationAccesses_Select_Column {
  /** column name */
  OrganisationId = 'organisationId',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses_Set_Input = {
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type ServiceOrganisationAccesses_Stddev_Fields = {
  __typename?: 'serviceOrganisationAccesses_stddev_fields';
  organisationId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses_Stddev_Order_By = {
  organisationId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ServiceOrganisationAccesses_Stddev_Pop_Fields = {
  __typename?: 'serviceOrganisationAccesses_stddev_pop_fields';
  organisationId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses_Stddev_Pop_Order_By = {
  organisationId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ServiceOrganisationAccesses_Stddev_Samp_Fields = {
  __typename?: 'serviceOrganisationAccesses_stddev_samp_fields';
  organisationId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses_Stddev_Samp_Order_By = {
  organisationId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceOrganisationAccesses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceOrganisationAccesses_Stream_Cursor_Value_Input = {
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
  serviceId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type ServiceOrganisationAccesses_Sum_Fields = {
  __typename?: 'serviceOrganisationAccesses_sum_fields';
  organisationId?: Maybe<Scalars['bigint']['output']>;
  serviceId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses_Sum_Order_By = {
  organisationId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** update columns of table "serviceOrganisationAccesses" */
export enum ServiceOrganisationAccesses_Update_Column {
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ServiceOrganisationAccesses_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ServiceOrganisationAccesses_Set_Input>;
  /** filter the rows which have to be updated */
  where: ServiceOrganisationAccesses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ServiceOrganisationAccesses_Var_Pop_Fields = {
  __typename?: 'serviceOrganisationAccesses_var_pop_fields';
  organisationId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses_Var_Pop_Order_By = {
  organisationId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ServiceOrganisationAccesses_Var_Samp_Fields = {
  __typename?: 'serviceOrganisationAccesses_var_samp_fields';
  organisationId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses_Var_Samp_Order_By = {
  organisationId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ServiceOrganisationAccesses_Variance_Fields = {
  __typename?: 'serviceOrganisationAccesses_variance_fields';
  organisationId?: Maybe<Scalars['Float']['output']>;
  serviceId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "serviceOrganisationAccesses" */
export type ServiceOrganisationAccesses_Variance_Order_By = {
  organisationId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
};

/** columns and relationships of "serviceParents" */
export type ServiceParents = {
  __typename?: 'serviceParents';
  id?: Maybe<Scalars['bigint']['output']>;
  isArchived?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "serviceParents" */
export type ServiceParents_Aggregate = {
  __typename?: 'serviceParents_aggregate';
  aggregate?: Maybe<ServiceParents_Aggregate_Fields>;
  nodes: Array<ServiceParents>;
};

/** aggregate fields of "serviceParents" */
export type ServiceParents_Aggregate_Fields = {
  __typename?: 'serviceParents_aggregate_fields';
  avg?: Maybe<ServiceParents_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ServiceParents_Max_Fields>;
  min?: Maybe<ServiceParents_Min_Fields>;
  stddev?: Maybe<ServiceParents_Stddev_Fields>;
  stddev_pop?: Maybe<ServiceParents_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ServiceParents_Stddev_Samp_Fields>;
  sum?: Maybe<ServiceParents_Sum_Fields>;
  var_pop?: Maybe<ServiceParents_Var_Pop_Fields>;
  var_samp?: Maybe<ServiceParents_Var_Samp_Fields>;
  variance?: Maybe<ServiceParents_Variance_Fields>;
};


/** aggregate fields of "serviceParents" */
export type ServiceParents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ServiceParents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ServiceParents_Avg_Fields = {
  __typename?: 'serviceParents_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "serviceParents". All fields are combined with a logical 'AND'. */
export type ServiceParents_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceParents_Bool_Exp>>;
  _not?: InputMaybe<ServiceParents_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceParents_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  isArchived?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type ServiceParents_Max_Fields = {
  __typename?: 'serviceParents_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  isArchived?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ServiceParents_Min_Fields = {
  __typename?: 'serviceParents_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  isArchived?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "serviceParents". */
export type ServiceParents_Order_By = {
  id?: InputMaybe<Order_By>;
  isArchived?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "serviceParents" */
export enum ServiceParents_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsArchived = 'isArchived',
  /** column name */
  Name = 'name'
}

/** aggregate stddev on columns */
export type ServiceParents_Stddev_Fields = {
  __typename?: 'serviceParents_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ServiceParents_Stddev_Pop_Fields = {
  __typename?: 'serviceParents_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ServiceParents_Stddev_Samp_Fields = {
  __typename?: 'serviceParents_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "serviceParents" */
export type ServiceParents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceParents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceParents_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  isArchived?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type ServiceParents_Sum_Fields = {
  __typename?: 'serviceParents_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type ServiceParents_Var_Pop_Fields = {
  __typename?: 'serviceParents_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ServiceParents_Var_Samp_Fields = {
  __typename?: 'serviceParents_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ServiceParents_Variance_Fields = {
  __typename?: 'serviceParents_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "serviceTags" */
export type ServiceTags = {
  __typename?: 'serviceTags';
  category?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "serviceTags". All fields are combined with a logical 'AND'. */
export type ServiceTags_Bool_Exp = {
  _and?: InputMaybe<Array<ServiceTags_Bool_Exp>>;
  _not?: InputMaybe<ServiceTags_Bool_Exp>;
  _or?: InputMaybe<Array<ServiceTags_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "serviceTags". */
export type ServiceTags_Order_By = {
  category?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "serviceTags" */
export enum ServiceTags_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "serviceTags" */
export type ServiceTags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ServiceTags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ServiceTags_Stream_Cursor_Value_Input = {
  category?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "services" */
export type Services = {
  __typename?: 'services';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  event?: Maybe<Events>;
  eventId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  fromService?: Maybe<Services>;
  fromServiceId?: Maybe<Scalars['bigint']['output']>;
  id: Scalars['bigint']['output'];
  /** A computed field, executes function "servicesIsFavourite" */
  isFavourite?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  /** An array relationship */
  organisationAccesses: Array<ServiceOrganisationAccesses>;
  /** An aggregate relationship */
  organisationAccesses_aggregate: ServiceOrganisationAccesses_Aggregate;
  /** An array relationship */
  serviceBundleServices: Array<ServiceBundleServices>;
  /** An aggregate relationship */
  serviceBundleServices_aggregate: ServiceBundleServices_Aggregate;
  /** An array relationship */
  serviceModules: Array<ServiceModules>;
  /** An aggregate relationship */
  serviceModules_aggregate: ServiceModules_Aggregate;
  /** An array relationship */
  servicesFrom: Array<Services>;
  /** An aggregate relationship */
  servicesFrom_aggregate: Services_Aggregate;
  tags: Scalars['json']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userData: Array<UserDataServices>;
};


/** columns and relationships of "services" */
export type ServicesNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesOrganisationAccessesArgs = {
  distinct_on?: InputMaybe<Array<ServiceOrganisationAccesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOrganisationAccesses_Order_By>>;
  where?: InputMaybe<ServiceOrganisationAccesses_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesOrganisationAccesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOrganisationAccesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOrganisationAccesses_Order_By>>;
  where?: InputMaybe<ServiceOrganisationAccesses_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesServiceBundleServicesArgs = {
  distinct_on?: InputMaybe<Array<ServiceBundleServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceBundleServices_Order_By>>;
  where?: InputMaybe<ServiceBundleServices_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesServiceBundleServices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceBundleServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceBundleServices_Order_By>>;
  where?: InputMaybe<ServiceBundleServices_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesServiceModulesArgs = {
  distinct_on?: InputMaybe<Array<ServiceModules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModules_Order_By>>;
  where?: InputMaybe<ServiceModules_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesServiceModules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceModules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModules_Order_By>>;
  where?: InputMaybe<ServiceModules_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesServicesFromArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesServicesFrom_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


/** columns and relationships of "services" */
export type ServicesTagsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "services" */
export type ServicesUserDataArgs = {
  distinct_on?: InputMaybe<Array<UserDataServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserDataServices_Order_By>>;
  where?: InputMaybe<UserDataServices_Bool_Exp>;
};

/** aggregated selection of "services" */
export type Services_Aggregate = {
  __typename?: 'services_aggregate';
  aggregate?: Maybe<Services_Aggregate_Fields>;
  nodes: Array<Services>;
};

export type Services_Aggregate_Bool_Exp = {
  count?: InputMaybe<Services_Aggregate_Bool_Exp_Count>;
};

export type Services_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Services_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Services_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "services" */
export type Services_Aggregate_Fields = {
  __typename?: 'services_aggregate_fields';
  avg?: Maybe<Services_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Services_Max_Fields>;
  min?: Maybe<Services_Min_Fields>;
  stddev?: Maybe<Services_Stddev_Fields>;
  stddev_pop?: Maybe<Services_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Services_Stddev_Samp_Fields>;
  sum?: Maybe<Services_Sum_Fields>;
  var_pop?: Maybe<Services_Var_Pop_Fields>;
  var_samp?: Maybe<Services_Var_Samp_Fields>;
  variance?: Maybe<Services_Variance_Fields>;
};


/** aggregate fields of "services" */
export type Services_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Services_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "services" */
export type Services_Aggregate_Order_By = {
  avg?: InputMaybe<Services_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Services_Max_Order_By>;
  min?: InputMaybe<Services_Min_Order_By>;
  stddev?: InputMaybe<Services_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Services_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Services_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Services_Sum_Order_By>;
  var_pop?: InputMaybe<Services_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Services_Var_Samp_Order_By>;
  variance?: InputMaybe<Services_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "services" */
export type Services_Arr_Rel_Insert_Input = {
  data: Array<Services_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Services_On_Conflict>;
};

/** aggregate avg on columns */
export type Services_Avg_Fields = {
  __typename?: 'services_avg_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  fromServiceId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "services" */
export type Services_Avg_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "services". All fields are combined with a logical 'AND'. */
export type Services_Bool_Exp = {
  _and?: InputMaybe<Array<Services_Bool_Exp>>;
  _not?: InputMaybe<Services_Bool_Exp>;
  _or?: InputMaybe<Array<Services_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  event?: InputMaybe<Events_Bool_Exp>;
  eventId?: InputMaybe<Bigint_Comparison_Exp>;
  fromService?: InputMaybe<Services_Bool_Exp>;
  fromServiceId?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  isFavourite?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Bool_Exp>;
  organisationAccesses?: InputMaybe<ServiceOrganisationAccesses_Bool_Exp>;
  organisationAccesses_aggregate?: InputMaybe<ServiceOrganisationAccesses_Aggregate_Bool_Exp>;
  serviceBundleServices?: InputMaybe<ServiceBundleServices_Bool_Exp>;
  serviceBundleServices_aggregate?: InputMaybe<ServiceBundleServices_Aggregate_Bool_Exp>;
  serviceModules?: InputMaybe<ServiceModules_Bool_Exp>;
  serviceModules_aggregate?: InputMaybe<ServiceModules_Aggregate_Bool_Exp>;
  servicesFrom?: InputMaybe<Services_Bool_Exp>;
  servicesFrom_aggregate?: InputMaybe<Services_Aggregate_Bool_Exp>;
  tags?: InputMaybe<Json_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userData?: InputMaybe<UserDataServices_Bool_Exp>;
};

/** unique or primary key constraints on table "services" */
export enum Services_Constraint {
  /** unique or primary key constraint on columns "eventId", "fromServiceId" */
  ServicesIdx1 = 'services_idx_1',
  /** unique or primary key constraint on columns "id" */
  ServicesPkey = 'services_pkey'
}

/** input type for inserting data into table "services" */
export type Services_Insert_Input = {
  event?: InputMaybe<Events_Obj_Rel_Insert_Input>;
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  fromService?: InputMaybe<Services_Obj_Rel_Insert_Input>;
  fromServiceId?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationAccesses?: InputMaybe<ServiceOrganisationAccesses_Arr_Rel_Insert_Input>;
  serviceBundleServices?: InputMaybe<ServiceBundleServices_Arr_Rel_Insert_Input>;
  serviceModules?: InputMaybe<ServiceModules_Arr_Rel_Insert_Input>;
  servicesFrom?: InputMaybe<Services_Arr_Rel_Insert_Input>;
  tags?: InputMaybe<Scalars['json']['input']>;
  userData?: InputMaybe<UserDataServices_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Services_Max_Fields = {
  __typename?: 'services_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  eventId?: Maybe<Scalars['bigint']['output']>;
  fromServiceId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "services" */
export type Services_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  fromServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Services_Min_Fields = {
  __typename?: 'services_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  eventId?: Maybe<Scalars['bigint']['output']>;
  fromServiceId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "services" */
export type Services_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  eventId?: InputMaybe<Order_By>;
  fromServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "services" */
export type Services_Mutation_Response = {
  __typename?: 'services_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Services>;
};

/** input type for inserting object relation for remote table "services" */
export type Services_Obj_Rel_Insert_Input = {
  data: Services_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Services_On_Conflict>;
};

/** on_conflict condition type for table "services" */
export type Services_On_Conflict = {
  constraint: Services_Constraint;
  update_columns?: Array<Services_Update_Column>;
  where?: InputMaybe<Services_Bool_Exp>;
};

/** Ordering options when selecting data from "services". */
export type Services_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  event?: InputMaybe<Events_Order_By>;
  eventId?: InputMaybe<Order_By>;
  fromService?: InputMaybe<Services_Order_By>;
  fromServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isFavourite?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  organisationAccesses_aggregate?: InputMaybe<ServiceOrganisationAccesses_Aggregate_Order_By>;
  serviceBundleServices_aggregate?: InputMaybe<ServiceBundleServices_Aggregate_Order_By>;
  serviceModules_aggregate?: InputMaybe<ServiceModules_Aggregate_Order_By>;
  servicesFrom_aggregate?: InputMaybe<Services_Aggregate_Order_By>;
  tags?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userData_aggregate?: InputMaybe<UserDataServices_Aggregate_Order_By>;
};

/** primary key columns input for table: services */
export type Services_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "services" */
export enum Services_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EventId = 'eventId',
  /** column name */
  FromServiceId = 'fromServiceId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "services" */
export type Services_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['json']['input']>;
};

/** aggregate stddev on columns */
export type Services_Stddev_Fields = {
  __typename?: 'services_stddev_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  fromServiceId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "services" */
export type Services_Stddev_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Services_Stddev_Pop_Fields = {
  __typename?: 'services_stddev_pop_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  fromServiceId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "services" */
export type Services_Stddev_Pop_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Services_Stddev_Samp_Fields = {
  __typename?: 'services_stddev_samp_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  fromServiceId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "services" */
export type Services_Stddev_Samp_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "services" */
export type Services_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Services_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Services_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  eventId?: InputMaybe<Scalars['bigint']['input']>;
  fromServiceId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['json']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Services_Sum_Fields = {
  __typename?: 'services_sum_fields';
  eventId?: Maybe<Scalars['bigint']['output']>;
  fromServiceId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "services" */
export type Services_Sum_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "services" */
export enum Services_Update_Column {
  /** column name */
  Name = 'name',
  /** column name */
  Tags = 'tags'
}

export type Services_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Services_Set_Input>;
  /** filter the rows which have to be updated */
  where: Services_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Services_Var_Pop_Fields = {
  __typename?: 'services_var_pop_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  fromServiceId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "services" */
export type Services_Var_Pop_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Services_Var_Samp_Fields = {
  __typename?: 'services_var_samp_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  fromServiceId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "services" */
export type Services_Var_Samp_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Services_Variance_Fields = {
  __typename?: 'services_variance_fields';
  eventId?: Maybe<Scalars['Float']['output']>;
  fromServiceId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "services" */
export type Services_Variance_Order_By = {
  eventId?: InputMaybe<Order_By>;
  fromServiceId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "V_ORGANICE_EVENT_RAUMBUCHUNG" */
  V_ORGANICE_EVENT_RAUMBUCHUNG: Array<V_Organice_Event_Raumbuchung>;
  /** fetch aggregated fields from the table: "V_ORGANICE_EVENT_RAUMBUCHUNG" */
  V_ORGANICE_EVENT_RAUMBUCHUNG_aggregate: V_Organice_Event_Raumbuchung_Aggregate;
  /** fetch data from the table: "V_ORGANICE_EVENT_RAUMBUCHUNG" using primary key columns */
  V_ORGANICE_EVENT_RAUMBUCHUNG_by_pk?: Maybe<V_Organice_Event_Raumbuchung>;
  /** fetch data from the table in a streaming manner: "V_ORGANICE_EVENT_RAUMBUCHUNG" */
  V_ORGANICE_EVENT_RAUMBUCHUNG_stream: Array<V_Organice_Event_Raumbuchung>;
  /** fetch data from the table: "V_ORGANICE_EVENT_STAMM" */
  V_ORGANICE_EVENT_STAMM: Array<V_Organice_Event_Stamm>;
  /** fetch aggregated fields from the table: "V_ORGANICE_EVENT_STAMM" */
  V_ORGANICE_EVENT_STAMM_aggregate: V_Organice_Event_Stamm_Aggregate;
  /** fetch data from the table: "V_ORGANICE_EVENT_STAMM" using primary key columns */
  V_ORGANICE_EVENT_STAMM_by_pk?: Maybe<V_Organice_Event_Stamm>;
  /** fetch data from the table in a streaming manner: "V_ORGANICE_EVENT_STAMM" */
  V_ORGANICE_EVENT_STAMM_stream: Array<V_Organice_Event_Stamm>;
  /** fetch data from the table: "allUsers" */
  allUsers: Array<AllUsers>;
  /** fetch aggregated fields from the table: "allUsers" */
  allUsers_aggregate: AllUsers_Aggregate;
  /** fetch data from the table in a streaming manner: "allUsers" */
  allUsers_stream: Array<AllUsers>;
  /** fetch data from the table: "articles" */
  articles: Array<Articles>;
  /** fetch aggregated fields from the table: "articles" */
  articles_aggregate: Articles_Aggregate;
  /** fetch data from the table: "articles" using primary key columns */
  articles_by_pk?: Maybe<Articles>;
  /** fetch data from the table in a streaming manner: "articles" */
  articles_stream: Array<Articles>;
  /** An array relationship */
  attributeFiles: Array<AttributeFiles>;
  /** An aggregate relationship */
  attributeFiles_aggregate: AttributeFiles_Aggregate;
  /** fetch data from the table: "attributeFiles" using primary key columns */
  attributeFiles_by_pk?: Maybe<AttributeFiles>;
  /** fetch data from the table in a streaming manner: "attributeFiles" */
  attributeFiles_stream: Array<AttributeFiles>;
  /** An array relationship */
  attributeGroups: Array<AttributeGroups>;
  /** An aggregate relationship */
  attributeGroups_aggregate: AttributeGroups_Aggregate;
  /** fetch data from the table: "attributeGroups" using primary key columns */
  attributeGroups_by_pk?: Maybe<AttributeGroups>;
  /** fetch data from the table in a streaming manner: "attributeGroups" */
  attributeGroups_stream: Array<AttributeGroups>;
  /** fetch data from the table: "attributeTypes" */
  attributeTypes: Array<AttributeTypes>;
  /** fetch aggregated fields from the table: "attributeTypes" */
  attributeTypes_aggregate: AttributeTypes_Aggregate;
  /** fetch data from the table: "attributeTypes" using primary key columns */
  attributeTypes_by_pk?: Maybe<AttributeTypes>;
  /** fetch data from the table in a streaming manner: "attributeTypes" */
  attributeTypes_stream: Array<AttributeTypes>;
  /** fetch data from the table: "attributeValueComments" */
  attributeValueComments: Array<AttributeValueComments>;
  /** fetch aggregated fields from the table: "attributeValueComments" */
  attributeValueComments_aggregate: AttributeValueComments_Aggregate;
  /** fetch data from the table: "attributeValueComments" using primary key columns */
  attributeValueComments_by_pk?: Maybe<AttributeValueComments>;
  /** fetch data from the table in a streaming manner: "attributeValueComments" */
  attributeValueComments_stream: Array<AttributeValueComments>;
  /** An array relationship */
  attributeValueGroups: Array<AttributeValueGroups>;
  /** An aggregate relationship */
  attributeValueGroups_aggregate: AttributeValueGroups_Aggregate;
  /** fetch data from the table: "attributeValueGroups" using primary key columns */
  attributeValueGroups_by_pk?: Maybe<AttributeValueGroups>;
  /** fetch data from the table in a streaming manner: "attributeValueGroups" */
  attributeValueGroups_stream: Array<AttributeValueGroups>;
  /** An array relationship */
  attributeValueUploadVersions: Array<AttributeValueUploadVersions>;
  /** An aggregate relationship */
  attributeValueUploadVersions_aggregate: AttributeValueUploadVersions_Aggregate;
  /** fetch data from the table: "attributeValueUploadVersions" using primary key columns */
  attributeValueUploadVersions_by_pk?: Maybe<AttributeValueUploadVersions>;
  /** fetch data from the table in a streaming manner: "attributeValueUploadVersions" */
  attributeValueUploadVersions_stream: Array<AttributeValueUploadVersions>;
  /** An array relationship */
  attributeValueUploads: Array<AttributeValueUploads>;
  /** An aggregate relationship */
  attributeValueUploads_aggregate: AttributeValueUploads_Aggregate;
  /** fetch data from the table: "attributeValueUploads" using primary key columns */
  attributeValueUploads_by_pk?: Maybe<AttributeValueUploads>;
  /** fetch data from the table in a streaming manner: "attributeValueUploads" */
  attributeValueUploads_stream: Array<AttributeValueUploads>;
  /** An array relationship */
  attributeValues: Array<AttributeValues>;
  /** An aggregate relationship */
  attributeValues_aggregate: AttributeValues_Aggregate;
  /** fetch data from the table: "attributeValues" using primary key columns */
  attributeValues_by_pk?: Maybe<AttributeValues>;
  /** fetch data from the table in a streaming manner: "attributeValues" */
  attributeValues_stream: Array<AttributeValues>;
  /** An array relationship */
  attributes: Array<Attributes>;
  /** An aggregate relationship */
  attributes_aggregate: Attributes_Aggregate;
  /** fetch data from the table: "attributes" using primary key columns */
  attributes_by_pk?: Maybe<Attributes>;
  /** fetch data from the table in a streaming manner: "attributes" */
  attributes_stream: Array<Attributes>;
  /** An array relationship */
  cartLines: Array<CartLines>;
  /** An aggregate relationship */
  cartLines_aggregate: CartLines_Aggregate;
  /** fetch data from the table: "cartLines" using primary key columns */
  cartLines_by_pk?: Maybe<CartLines>;
  /** fetch data from the table in a streaming manner: "cartLines" */
  cartLines_stream: Array<CartLines>;
  /** An array relationship */
  carts: Array<Carts>;
  /** An aggregate relationship */
  carts_aggregate: Carts_Aggregate;
  /** fetch data from the table: "carts" using primary key columns */
  carts_by_pk?: Maybe<Carts>;
  /** fetch data from the table in a streaming manner: "carts" */
  carts_stream: Array<Carts>;
  /** An array relationship */
  catalogFolderArticles: Array<CatalogFolderArticles>;
  /** An aggregate relationship */
  catalogFolderArticles_aggregate: CatalogFolderArticles_Aggregate;
  /** fetch data from the table: "catalogFolderArticles" using primary key columns */
  catalogFolderArticles_by_pk?: Maybe<CatalogFolderArticles>;
  /** fetch data from the table in a streaming manner: "catalogFolderArticles" */
  catalogFolderArticles_stream: Array<CatalogFolderArticles>;
  /** An array relationship */
  catalogFolders: Array<CatalogFolders>;
  /** An aggregate relationship */
  catalogFolders_aggregate: CatalogFolders_Aggregate;
  /** fetch data from the table: "catalogFolders" using primary key columns */
  catalogFolders_by_pk?: Maybe<CatalogFolders>;
  /** fetch data from the table in a streaming manner: "catalogFolders" */
  catalogFolders_stream: Array<CatalogFolders>;
  /** execute function "currentUser" which returns "users" */
  currentUser?: Maybe<Users>;
  /** execute function "currentUser" and query aggregates on result of table type "users" */
  currentUser_aggregate: Users_Aggregate;
  /** fetch data from the table: "eventAttributeGroups" */
  eventAttributeGroups: Array<EventAttributeGroups>;
  /** fetch aggregated fields from the table: "eventAttributeGroups" */
  eventAttributeGroups_aggregate: EventAttributeGroups_Aggregate;
  /** fetch data from the table: "eventAttributeGroups" using primary key columns */
  eventAttributeGroups_by_pk?: Maybe<EventAttributeGroups>;
  /** fetch data from the table in a streaming manner: "eventAttributeGroups" */
  eventAttributeGroups_stream: Array<EventAttributeGroups>;
  /** An array relationship */
  eventAttributeValueUploadVersions: Array<EventAttributeValueUploadVersions>;
  /** An aggregate relationship */
  eventAttributeValueUploadVersions_aggregate: EventAttributeValueUploadVersions_Aggregate;
  /** fetch data from the table: "eventAttributeValueUploadVersions" using primary key columns */
  eventAttributeValueUploadVersions_by_pk?: Maybe<EventAttributeValueUploadVersions>;
  /** fetch data from the table in a streaming manner: "eventAttributeValueUploadVersions" */
  eventAttributeValueUploadVersions_stream: Array<EventAttributeValueUploadVersions>;
  /** An array relationship */
  eventAttributeValueUploads: Array<EventAttributeValueUploads>;
  /** An aggregate relationship */
  eventAttributeValueUploads_aggregate: EventAttributeValueUploads_Aggregate;
  /** fetch data from the table: "eventAttributeValueUploads" using primary key columns */
  eventAttributeValueUploads_by_pk?: Maybe<EventAttributeValueUploads>;
  /** fetch data from the table in a streaming manner: "eventAttributeValueUploads" */
  eventAttributeValueUploads_stream: Array<EventAttributeValueUploads>;
  /** An array relationship */
  eventAttributeValues: Array<EventAttributeValues>;
  /** An aggregate relationship */
  eventAttributeValues_aggregate: EventAttributeValues_Aggregate;
  /** fetch data from the table: "eventAttributeValues" using primary key columns */
  eventAttributeValues_by_pk?: Maybe<EventAttributeValues>;
  /** fetch data from the table in a streaming manner: "eventAttributeValues" */
  eventAttributeValues_stream: Array<EventAttributeValues>;
  /** An array relationship */
  eventAttributes: Array<EventAttributes>;
  /** An aggregate relationship */
  eventAttributes_aggregate: EventAttributes_Aggregate;
  /** fetch data from the table: "eventAttributes" using primary key columns */
  eventAttributes_by_pk?: Maybe<EventAttributes>;
  /** fetch data from the table in a streaming manner: "eventAttributes" */
  eventAttributes_stream: Array<EventAttributes>;
  /** An array relationship */
  eventFavourites: Array<EventFavourites>;
  /** An aggregate relationship */
  eventFavourites_aggregate: EventFavourites_Aggregate;
  /** fetch data from the table: "eventFavourites" using primary key columns */
  eventFavourites_by_pk?: Maybe<EventFavourites>;
  /** fetch data from the table in a streaming manner: "eventFavourites" */
  eventFavourites_stream: Array<EventFavourites>;
  /** An array relationship */
  eventOrganisers: Array<EventOrganisers>;
  /** An aggregate relationship */
  eventOrganisers_aggregate: EventOrganisers_Aggregate;
  /** fetch data from the table: "eventOrganisers" using primary key columns */
  eventOrganisers_by_pk?: Maybe<EventOrganisers>;
  /** fetch data from the table in a streaming manner: "eventOrganisers" */
  eventOrganisers_stream: Array<EventOrganisers>;
  /** An array relationship */
  eventRoomWatches: Array<EventRoomWatches>;
  /** An aggregate relationship */
  eventRoomWatches_aggregate: EventRoomWatches_Aggregate;
  /** fetch data from the table: "eventRoomWatches" using primary key columns */
  eventRoomWatches_by_pk?: Maybe<EventRoomWatches>;
  /** fetch data from the table in a streaming manner: "eventRoomWatches" */
  eventRoomWatches_stream: Array<EventRoomWatches>;
  /** An array relationship */
  eventRooms: Array<EventRooms>;
  /** fetch data from the table: "eventRooms" using primary key columns */
  eventRooms_by_pk?: Maybe<EventRooms>;
  /** fetch data from the table in a streaming manner: "eventRooms" */
  eventRooms_stream: Array<EventRooms>;
  /** fetch data from the table: "eventTypes" */
  eventTypes: Array<EventTypes>;
  /** fetch aggregated fields from the table: "eventTypes" */
  eventTypes_aggregate: EventTypes_Aggregate;
  /** fetch data from the table: "eventTypes" using primary key columns */
  eventTypes_by_pk?: Maybe<EventTypes>;
  /** fetch data from the table in a streaming manner: "eventTypes" */
  eventTypes_stream: Array<EventTypes>;
  /** An array relationship */
  events: Array<Events>;
  /** An aggregate relationship */
  events_aggregate: Events_Aggregate;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: Maybe<Events>;
  /** fetch data from the table in a streaming manner: "events" */
  events_stream: Array<Events>;
  /** An array relationship */
  fileMasterVersions: Array<FileMasterVersions>;
  /** An aggregate relationship */
  fileMasterVersions_aggregate: FileMasterVersions_Aggregate;
  /** fetch data from the table: "fileMasterVersions" using primary key columns */
  fileMasterVersions_by_pk?: Maybe<FileMasterVersions>;
  /** fetch data from the table in a streaming manner: "fileMasterVersions" */
  fileMasterVersions_stream: Array<FileMasterVersions>;
  /** fetch data from the table: "fileMasters" */
  fileMasters: Array<FileMasters>;
  /** fetch aggregated fields from the table: "fileMasters" */
  fileMasters_aggregate: FileMasters_Aggregate;
  /** fetch data from the table: "fileMasters" using primary key columns */
  fileMasters_by_pk?: Maybe<FileMasters>;
  /** fetch data from the table in a streaming manner: "fileMasters" */
  fileMasters_stream: Array<FileMasters>;
  /** An array relationship */
  files: Array<Files>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: Maybe<Files>;
  /** fetch data from the table in a streaming manner: "files" */
  files_stream: Array<Files>;
  /** fetch data from the table: "infoBoxes" */
  infoBoxes: Array<InfoBoxes>;
  /** fetch aggregated fields from the table: "infoBoxes" */
  infoBoxes_aggregate: InfoBoxes_Aggregate;
  /** fetch data from the table: "infoBoxes" using primary key columns */
  infoBoxes_by_pk?: Maybe<InfoBoxes>;
  /** fetch data from the table in a streaming manner: "infoBoxes" */
  infoBoxes_stream: Array<InfoBoxes>;
  /** fetch data from the table: "infoNews" */
  infoNews: Array<InfoNews>;
  /** fetch aggregated fields from the table: "infoNews" */
  infoNews_aggregate: InfoNews_Aggregate;
  /** fetch data from the table: "infoNews" using primary key columns */
  infoNews_by_pk?: Maybe<InfoNews>;
  /** fetch data from the table in a streaming manner: "infoNews" */
  infoNews_stream: Array<InfoNews>;
  /** fetch data from the table: "jaggaerBanfs" */
  jaggaerBanfs: Array<JaggaerBanfs>;
  /** fetch aggregated fields from the table: "jaggaerBanfs" */
  jaggaerBanfs_aggregate: JaggaerBanfs_Aggregate;
  /** fetch data from the table: "jaggaerBanfs" using primary key columns */
  jaggaerBanfs_by_pk?: Maybe<JaggaerBanfs>;
  /** fetch data from the table in a streaming manner: "jaggaerBanfs" */
  jaggaerBanfs_stream: Array<JaggaerBanfs>;
  /** An array relationship */
  jaggaerSubmissions: Array<JaggaerSubmissions>;
  /** An aggregate relationship */
  jaggaerSubmissions_aggregate: JaggaerSubmissions_Aggregate;
  /** fetch data from the table: "jaggaerSubmissions" using primary key columns */
  jaggaerSubmissions_by_pk?: Maybe<JaggaerSubmissions>;
  /** fetch data from the table in a streaming manner: "jaggaerSubmissions" */
  jaggaerSubmissions_stream: Array<JaggaerSubmissions>;
  /** fetch data from the table: "moduleTypes" */
  moduleTypes: Array<ModuleTypes>;
  /** fetch aggregated fields from the table: "moduleTypes" */
  moduleTypes_aggregate: ModuleTypes_Aggregate;
  /** fetch data from the table: "moduleTypes" using primary key columns */
  moduleTypes_by_pk?: Maybe<ModuleTypes>;
  /** fetch data from the table in a streaming manner: "moduleTypes" */
  moduleTypes_stream: Array<ModuleTypes>;
  /** fetch data from the table: "news" */
  news: Array<News>;
  /** fetch data from the table in a streaming manner: "news" */
  news_stream: Array<News>;
  /** fetch data from the table: "notificationActions" */
  notificationActions: Array<NotificationActions>;
  /** fetch aggregated fields from the table: "notificationActions" */
  notificationActions_aggregate: NotificationActions_Aggregate;
  /** fetch data from the table: "notificationActions" using primary key columns */
  notificationActions_by_pk?: Maybe<NotificationActions>;
  /** fetch data from the table in a streaming manner: "notificationActions" */
  notificationActions_stream: Array<NotificationActions>;
  /** fetch data from the table: "notificationCadences" */
  notificationCadences: Array<NotificationCadences>;
  /** fetch aggregated fields from the table: "notificationCadences" */
  notificationCadences_aggregate: NotificationCadences_Aggregate;
  /** fetch data from the table: "notificationCadences" using primary key columns */
  notificationCadences_by_pk?: Maybe<NotificationCadences>;
  /** fetch data from the table in a streaming manner: "notificationCadences" */
  notificationCadences_stream: Array<NotificationCadences>;
  /** fetch data from the table: "notificationChannels" */
  notificationChannels: Array<NotificationChannels>;
  /** fetch aggregated fields from the table: "notificationChannels" */
  notificationChannels_aggregate: NotificationChannels_Aggregate;
  /** fetch data from the table: "notificationChannels" using primary key columns */
  notificationChannels_by_pk?: Maybe<NotificationChannels>;
  /** fetch data from the table in a streaming manner: "notificationChannels" */
  notificationChannels_stream: Array<NotificationChannels>;
  /** An array relationship */
  notificationMessages: Array<NotificationMessages>;
  /** An aggregate relationship */
  notificationMessages_aggregate: NotificationMessages_Aggregate;
  /** fetch data from the table: "notificationMessages" using primary key columns */
  notificationMessages_by_pk?: Maybe<NotificationMessages>;
  /** fetch data from the table in a streaming manner: "notificationMessages" */
  notificationMessages_stream: Array<NotificationMessages>;
  /** fetch data from the table: "notificationPreferenceStages" */
  notificationPreferenceStages: Array<NotificationPreferenceStages>;
  /** fetch aggregated fields from the table: "notificationPreferenceStages" */
  notificationPreferenceStages_aggregate: NotificationPreferenceStages_Aggregate;
  /** fetch data from the table: "notificationPreferenceStages" using primary key columns */
  notificationPreferenceStages_by_pk?: Maybe<NotificationPreferenceStages>;
  /** fetch data from the table in a streaming manner: "notificationPreferenceStages" */
  notificationPreferenceStages_stream: Array<NotificationPreferenceStages>;
  /** An array relationship */
  notificationPreferences: Array<NotificationPreferences>;
  /** An aggregate relationship */
  notificationPreferences_aggregate: NotificationPreferences_Aggregate;
  /** fetch data from the table: "notificationPreferences" using primary key columns */
  notificationPreferences_by_pk?: Maybe<NotificationPreferences>;
  /** fetch data from the table in a streaming manner: "notificationPreferences" */
  notificationPreferences_stream: Array<NotificationPreferences>;
  /** fetch data from the table: "notificationRoomServiceCategoryPreferences" */
  notificationRoomServiceCategoryPreferences: Array<NotificationRoomServiceCategoryPreferences>;
  /** fetch aggregated fields from the table: "notificationRoomServiceCategoryPreferences" */
  notificationRoomServiceCategoryPreferences_aggregate: NotificationRoomServiceCategoryPreferences_Aggregate;
  /** fetch data from the table: "notificationRoomServiceCategoryPreferences" using primary key columns */
  notificationRoomServiceCategoryPreferences_by_pk?: Maybe<NotificationRoomServiceCategoryPreferences>;
  /** fetch data from the table in a streaming manner: "notificationRoomServiceCategoryPreferences" */
  notificationRoomServiceCategoryPreferences_stream: Array<NotificationRoomServiceCategoryPreferences>;
  /** An array relationship */
  notificationServicePreferences: Array<NotificationServicePreferences>;
  /** An aggregate relationship */
  notificationServicePreferences_aggregate: NotificationServicePreferences_Aggregate;
  /** fetch data from the table: "notificationServicePreferences" using primary key columns */
  notificationServicePreferences_by_pk?: Maybe<NotificationServicePreferences>;
  /** fetch data from the table in a streaming manner: "notificationServicePreferences" */
  notificationServicePreferences_stream: Array<NotificationServicePreferences>;
  /** fetch data from the table: "notificationTemplates" */
  notificationTemplates: Array<NotificationTemplates>;
  /** fetch aggregated fields from the table: "notificationTemplates" */
  notificationTemplates_aggregate: NotificationTemplates_Aggregate;
  /** fetch data from the table: "notificationTemplates" using primary key columns */
  notificationTemplates_by_pk?: Maybe<NotificationTemplates>;
  /** fetch data from the table in a streaming manner: "notificationTemplates" */
  notificationTemplates_stream: Array<NotificationTemplates>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** fetch data from the table in a streaming manner: "notifications" */
  notifications_stream: Array<Notifications>;
  /** An array relationship */
  orders: Array<Orders>;
  /** An aggregate relationship */
  orders_aggregate: Orders_Aggregate;
  /** fetch data from the table: "orders" using primary key columns */
  orders_by_pk?: Maybe<Orders>;
  /** fetch data from the table in a streaming manner: "orders" */
  orders_stream: Array<Orders>;
  /** An array relationship */
  organisationGroupUsers: Array<OrganisationGroupUsers>;
  /** An aggregate relationship */
  organisationGroupUsers_aggregate: OrganisationGroupUsers_Aggregate;
  /** fetch data from the table: "organisationGroupUsers" using primary key columns */
  organisationGroupUsers_by_pk?: Maybe<OrganisationGroupUsers>;
  /** fetch data from the table in a streaming manner: "organisationGroupUsers" */
  organisationGroupUsers_stream: Array<OrganisationGroupUsers>;
  /** An array relationship */
  organisationGroups: Array<OrganisationGroups>;
  /** An aggregate relationship */
  organisationGroups_aggregate: OrganisationGroups_Aggregate;
  /** fetch data from the table: "organisationGroups" using primary key columns */
  organisationGroups_by_pk?: Maybe<OrganisationGroups>;
  /** fetch data from the table in a streaming manner: "organisationGroups" */
  organisationGroups_stream: Array<OrganisationGroups>;
  /** fetch data from the table: "organisations" */
  organisations: Array<Organisations>;
  /** fetch aggregated fields from the table: "organisations" */
  organisations_aggregate: Organisations_Aggregate;
  /** fetch data from the table: "organisations" using primary key columns */
  organisations_by_pk?: Maybe<Organisations>;
  /** fetch data from the table in a streaming manner: "organisations" */
  organisations_stream: Array<Organisations>;
  /** An array relationship */
  roomAttributeFiles: Array<RoomAttributeFiles>;
  /** fetch data from the table: "roomAttributeFiles" using primary key columns */
  roomAttributeFiles_by_pk?: Maybe<RoomAttributeFiles>;
  /** fetch data from the table in a streaming manner: "roomAttributeFiles" */
  roomAttributeFiles_stream: Array<RoomAttributeFiles>;
  /** An array relationship */
  roomAttributeGroups: Array<RoomAttributeGroups>;
  /** fetch data from the table: "roomAttributeGroups" using primary key columns */
  roomAttributeGroups_by_pk?: Maybe<RoomAttributeGroups>;
  /** fetch data from the table in a streaming manner: "roomAttributeGroups" */
  roomAttributeGroups_stream: Array<RoomAttributeGroups>;
  /** fetch data from the table: "roomAttributeValueComments" */
  roomAttributeValueComments: Array<RoomAttributeValueComments>;
  /** fetch aggregated fields from the table: "roomAttributeValueComments" */
  roomAttributeValueComments_aggregate: RoomAttributeValueComments_Aggregate;
  /** fetch data from the table: "roomAttributeValueComments" using primary key columns */
  roomAttributeValueComments_by_pk?: Maybe<RoomAttributeValueComments>;
  /** fetch data from the table in a streaming manner: "roomAttributeValueComments" */
  roomAttributeValueComments_stream: Array<RoomAttributeValueComments>;
  /** An array relationship */
  roomAttributeValueGroups: Array<RoomAttributeValueGroups>;
  /** fetch data from the table: "roomAttributeValueGroups" using primary key columns */
  roomAttributeValueGroups_by_pk?: Maybe<RoomAttributeValueGroups>;
  /** fetch data from the table in a streaming manner: "roomAttributeValueGroups" */
  roomAttributeValueGroups_stream: Array<RoomAttributeValueGroups>;
  /** An array relationship */
  roomAttributeValueUploadVersions: Array<RoomAttributeValueUploadVersions>;
  /** An aggregate relationship */
  roomAttributeValueUploadVersions_aggregate: RoomAttributeValueUploadVersions_Aggregate;
  /** fetch data from the table: "roomAttributeValueUploadVersions" using primary key columns */
  roomAttributeValueUploadVersions_by_pk?: Maybe<RoomAttributeValueUploadVersions>;
  /** fetch data from the table in a streaming manner: "roomAttributeValueUploadVersions" */
  roomAttributeValueUploadVersions_stream: Array<RoomAttributeValueUploadVersions>;
  /** An array relationship */
  roomAttributeValueUploads: Array<RoomAttributeValueUploads>;
  /** An aggregate relationship */
  roomAttributeValueUploads_aggregate: RoomAttributeValueUploads_Aggregate;
  /** fetch data from the table: "roomAttributeValueUploads" using primary key columns */
  roomAttributeValueUploads_by_pk?: Maybe<RoomAttributeValueUploads>;
  /** fetch data from the table in a streaming manner: "roomAttributeValueUploads" */
  roomAttributeValueUploads_stream: Array<RoomAttributeValueUploads>;
  /** An array relationship */
  roomAttributeValues: Array<RoomAttributeValues>;
  /** fetch data from the table: "roomAttributeValues" using primary key columns */
  roomAttributeValues_by_pk?: Maybe<RoomAttributeValues>;
  /** fetch data from the table: "roomAttributeValues_for_comments" */
  roomAttributeValues_for_comments: Array<RoomAttributeValues_For_Comments>;
  /** fetch data from the table in a streaming manner: "roomAttributeValues_for_comments" */
  roomAttributeValues_for_comments_stream: Array<RoomAttributeValues_For_Comments>;
  /** fetch data from the table in a streaming manner: "roomAttributeValues" */
  roomAttributeValues_stream: Array<RoomAttributeValues>;
  /** An array relationship */
  roomAttributes: Array<RoomAttributes>;
  /** fetch data from the table: "roomAttributes" using primary key columns */
  roomAttributes_by_pk?: Maybe<RoomAttributes>;
  /** fetch data from the table in a streaming manner: "roomAttributes" */
  roomAttributes_stream: Array<RoomAttributes>;
  /** fetch data from the table: "roomChanges" */
  roomChanges: Array<RoomChanges>;
  /** fetch aggregated fields from the table: "roomChanges" */
  roomChanges_aggregate: RoomChanges_Aggregate;
  /** fetch data from the table: "roomChanges" using primary key columns */
  roomChanges_by_pk?: Maybe<RoomChanges>;
  /** fetch data from the table in a streaming manner: "roomChanges" */
  roomChanges_stream: Array<RoomChanges>;
  /** fetch data from the table: "roomFolders" */
  roomFolders: Array<RoomFolders>;
  /** fetch data from the table: "roomFolders" using primary key columns */
  roomFolders_by_pk?: Maybe<RoomFolders>;
  /** fetch data from the table in a streaming manner: "roomFolders" */
  roomFolders_stream: Array<RoomFolders>;
  /** fetch data from the table: "roomOccurrence_intersections" */
  roomOccurrence_intersections: Array<RoomOccurrence_Intersections>;
  /** fetch data from the table in a streaming manner: "roomOccurrence_intersections" */
  roomOccurrence_intersections_stream: Array<RoomOccurrence_Intersections>;
  /** fetch data from the table: "roomOccurrences" */
  roomOccurrences: Array<RoomOccurrences>;
  /** fetch data from the table: "roomOccurrences" using primary key columns */
  roomOccurrences_by_pk?: Maybe<RoomOccurrences>;
  /** fetch data from the table in a streaming manner: "roomOccurrences" */
  roomOccurrences_stream: Array<RoomOccurrences>;
  /** fetch data from the table: "roomServiceCategories" */
  roomServiceCategories: Array<RoomServiceCategories>;
  /** fetch aggregated fields from the table: "roomServiceCategories" */
  roomServiceCategories_aggregate: RoomServiceCategories_Aggregate;
  /** fetch data from the table: "roomServiceCategories" using primary key columns */
  roomServiceCategories_by_pk?: Maybe<RoomServiceCategories>;
  /** fetch data from the table in a streaming manner: "roomServiceCategories" */
  roomServiceCategories_stream: Array<RoomServiceCategories>;
  /** An array relationship */
  roomServiceOccurrences: Array<RoomServiceOccurrences>;
  /** fetch data from the table: "roomServiceOccurrences" using primary key columns */
  roomServiceOccurrences_by_pk?: Maybe<RoomServiceOccurrences>;
  /** fetch data from the table in a streaming manner: "roomServiceOccurrences" */
  roomServiceOccurrences_stream: Array<RoomServiceOccurrences>;
  /** fetch data from the table: "roomServiceOrganisationAccesses" */
  roomServiceOrganisationAccesses: Array<RoomServiceOrganisationAccesses>;
  /** fetch aggregated fields from the table: "roomServiceOrganisationAccesses" */
  roomServiceOrganisationAccesses_aggregate: RoomServiceOrganisationAccesses_Aggregate;
  /** fetch data from the table: "roomServiceOrganisationAccesses" using primary key columns */
  roomServiceOrganisationAccesses_by_pk?: Maybe<RoomServiceOrganisationAccesses>;
  /** fetch data from the table in a streaming manner: "roomServiceOrganisationAccesses" */
  roomServiceOrganisationAccesses_stream: Array<RoomServiceOrganisationAccesses>;
  /** An array relationship */
  roomServices: Array<RoomServices>;
  /** fetch data from the table: "roomServices" using primary key columns */
  roomServices_by_pk?: Maybe<RoomServices>;
  /** fetch data from the table in a streaming manner: "roomServices" */
  roomServices_stream: Array<RoomServices>;
  /** An array relationship */
  rooms: Array<Rooms>;
  /** An aggregate relationship */
  rooms_aggregate: Rooms_Aggregate;
  /** fetch data from the table: "rooms" using primary key columns */
  rooms_by_pk?: Maybe<Rooms>;
  /** fetch data from the table in a streaming manner: "rooms" */
  rooms_stream: Array<Rooms>;
  /** An array relationship */
  serviceBundleServices: Array<ServiceBundleServices>;
  /** An aggregate relationship */
  serviceBundleServices_aggregate: ServiceBundleServices_Aggregate;
  /** fetch data from the table: "serviceBundleServices" using primary key columns */
  serviceBundleServices_by_pk?: Maybe<ServiceBundleServices>;
  /** fetch data from the table in a streaming manner: "serviceBundleServices" */
  serviceBundleServices_stream: Array<ServiceBundleServices>;
  /** fetch data from the table: "serviceBundles" */
  serviceBundles: Array<ServiceBundles>;
  /** fetch aggregated fields from the table: "serviceBundles" */
  serviceBundles_aggregate: ServiceBundles_Aggregate;
  /** fetch data from the table: "serviceBundles" using primary key columns */
  serviceBundles_by_pk?: Maybe<ServiceBundles>;
  /** fetch data from the table in a streaming manner: "serviceBundles" */
  serviceBundles_stream: Array<ServiceBundles>;
  /** An array relationship */
  serviceFavourites: Array<ServiceFavourites>;
  /** An aggregate relationship */
  serviceFavourites_aggregate: ServiceFavourites_Aggregate;
  /** fetch data from the table: "serviceFavourites" using primary key columns */
  serviceFavourites_by_pk?: Maybe<ServiceFavourites>;
  /** fetch data from the table in a streaming manner: "serviceFavourites" */
  serviceFavourites_stream: Array<ServiceFavourites>;
  /** An array relationship */
  serviceModuleAccesses: Array<ServiceModuleAccesses>;
  /** An aggregate relationship */
  serviceModuleAccesses_aggregate: ServiceModuleAccesses_Aggregate;
  /** fetch data from the table: "serviceModuleAccesses" using primary key columns */
  serviceModuleAccesses_by_pk?: Maybe<ServiceModuleAccesses>;
  /** fetch data from the table in a streaming manner: "serviceModuleAccesses" */
  serviceModuleAccesses_stream: Array<ServiceModuleAccesses>;
  /** fetch data from the table: "serviceModuleChanges" */
  serviceModuleChanges: Array<ServiceModuleChanges>;
  /** fetch aggregated fields from the table: "serviceModuleChanges" */
  serviceModuleChanges_aggregate: ServiceModuleChanges_Aggregate;
  /** fetch data from the table: "serviceModuleChanges" using primary key columns */
  serviceModuleChanges_by_pk?: Maybe<ServiceModuleChanges>;
  /** fetch data from the table: "serviceModuleChanges_grouped" */
  serviceModuleChanges_grouped: Array<ServiceModuleChanges_Grouped>;
  /** fetch aggregated fields from the table: "serviceModuleChanges_grouped" */
  serviceModuleChanges_grouped_aggregate: ServiceModuleChanges_Grouped_Aggregate;
  /** fetch data from the table in a streaming manner: "serviceModuleChanges_grouped" */
  serviceModuleChanges_grouped_stream: Array<ServiceModuleChanges_Grouped>;
  /** fetch data from the table in a streaming manner: "serviceModuleChanges" */
  serviceModuleChanges_stream: Array<ServiceModuleChanges>;
  /** An array relationship */
  serviceModules: Array<ServiceModules>;
  /** An aggregate relationship */
  serviceModules_aggregate: ServiceModules_Aggregate;
  /** fetch data from the table: "serviceModules" using primary key columns */
  serviceModules_by_pk?: Maybe<ServiceModules>;
  /** fetch data from the table in a streaming manner: "serviceModules" */
  serviceModules_stream: Array<ServiceModules>;
  /** fetch data from the table: "serviceOrganisationAccesses" */
  serviceOrganisationAccesses: Array<ServiceOrganisationAccesses>;
  /** fetch aggregated fields from the table: "serviceOrganisationAccesses" */
  serviceOrganisationAccesses_aggregate: ServiceOrganisationAccesses_Aggregate;
  /** fetch data from the table: "serviceOrganisationAccesses" using primary key columns */
  serviceOrganisationAccesses_by_pk?: Maybe<ServiceOrganisationAccesses>;
  /** fetch data from the table in a streaming manner: "serviceOrganisationAccesses" */
  serviceOrganisationAccesses_stream: Array<ServiceOrganisationAccesses>;
  /** fetch data from the table: "serviceParents" */
  serviceParents: Array<ServiceParents>;
  /** fetch aggregated fields from the table: "serviceParents" */
  serviceParents_aggregate: ServiceParents_Aggregate;
  /** fetch data from the table in a streaming manner: "serviceParents" */
  serviceParents_stream: Array<ServiceParents>;
  /** fetch data from the table: "serviceTags" */
  serviceTags: Array<ServiceTags>;
  /** fetch data from the table in a streaming manner: "serviceTags" */
  serviceTags_stream: Array<ServiceTags>;
  /** An array relationship */
  services: Array<Services>;
  /** An aggregate relationship */
  services_aggregate: Services_Aggregate;
  /** fetch data from the table: "services" using primary key columns */
  services_by_pk?: Maybe<Services>;
  /** fetch data from the table in a streaming manner: "services" */
  services_stream: Array<Services>;
  /** fetch data from the table: "test1" */
  test1: Array<Test1>;
  /** fetch data from the table in a streaming manner: "test1" */
  test1_stream: Array<Test1>;
  /** fetch data from the table: "uploadComments" */
  uploadComments: Array<UploadComments>;
  /** fetch aggregated fields from the table: "uploadComments" */
  uploadComments_aggregate: UploadComments_Aggregate;
  /** fetch data from the table: "uploadComments" using primary key columns */
  uploadComments_by_pk?: Maybe<UploadComments>;
  /** fetch data from the table in a streaming manner: "uploadComments" */
  uploadComments_stream: Array<UploadComments>;
  /** An array relationship */
  uploadVersions: Array<UploadVersions>;
  /** An aggregate relationship */
  uploadVersions_aggregate: UploadVersions_Aggregate;
  /** fetch data from the table: "uploadVersions" using primary key columns */
  uploadVersions_by_pk?: Maybe<UploadVersions>;
  /** fetch data from the table in a streaming manner: "uploadVersions" */
  uploadVersions_stream: Array<UploadVersions>;
  /** An array relationship */
  uploads: Array<Uploads>;
  /** An aggregate relationship */
  uploads_aggregate: Uploads_Aggregate;
  /** fetch data from the table: "uploads" using primary key columns */
  uploads_by_pk?: Maybe<Uploads>;
  /** fetch data from the table in a streaming manner: "uploads" */
  uploads_stream: Array<Uploads>;
  /** An array relationship */
  userAttributeValues: Array<UserAttributeValues>;
  /** An aggregate relationship */
  userAttributeValues_aggregate: UserAttributeValues_Aggregate;
  /** fetch data from the table: "userAttributeValues" using primary key columns */
  userAttributeValues_by_pk?: Maybe<UserAttributeValues>;
  /** fetch data from the table in a streaming manner: "userAttributeValues" */
  userAttributeValues_stream: Array<UserAttributeValues>;
  /** fetch data from the table: "userAttributes" */
  userAttributes: Array<UserAttributes>;
  /** fetch aggregated fields from the table: "userAttributes" */
  userAttributes_aggregate: UserAttributes_Aggregate;
  /** fetch data from the table: "userAttributes" using primary key columns */
  userAttributes_by_pk?: Maybe<UserAttributes>;
  /** fetch data from the table in a streaming manner: "userAttributes" */
  userAttributes_stream: Array<UserAttributes>;
  /** fetch data from the table: "userDataRoomOccurrences" */
  userDataRoomOccurrences: Array<UserDataRoomOccurrences>;
  /** fetch data from the table: "userDataRoomOccurrences" using primary key columns */
  userDataRoomOccurrences_by_pk?: Maybe<UserDataRoomOccurrences>;
  /** fetch data from the table in a streaming manner: "userDataRoomOccurrences" */
  userDataRoomOccurrences_stream: Array<UserDataRoomOccurrences>;
  /** fetch data from the table: "userDataRoomServiceOccurrences" */
  userDataRoomServiceOccurrences: Array<UserDataRoomServiceOccurrences>;
  /** fetch data from the table: "userDataRoomServiceOccurrences" using primary key columns */
  userDataRoomServiceOccurrences_by_pk?: Maybe<UserDataRoomServiceOccurrences>;
  /** fetch data from the table in a streaming manner: "userDataRoomServiceOccurrences" */
  userDataRoomServiceOccurrences_stream: Array<UserDataRoomServiceOccurrences>;
  /** fetch data from the table: "userDataServices" */
  userDataServices: Array<UserDataServices>;
  /** fetch data from the table: "userDataServices" using primary key columns */
  userDataServices_by_pk?: Maybe<UserDataServices>;
  /** fetch data from the table in a streaming manner: "userDataServices" */
  userDataServices_stream: Array<UserDataServices>;
  /** fetch data from the table: "userRoomServiceOccurrenceLastVisits" */
  userRoomServiceOccurrenceLastVisits: Array<UserRoomServiceOccurrenceLastVisits>;
  /** fetch aggregated fields from the table: "userRoomServiceOccurrenceLastVisits" */
  userRoomServiceOccurrenceLastVisits_aggregate: UserRoomServiceOccurrenceLastVisits_Aggregate;
  /** fetch data from the table: "userRoomServiceOccurrenceLastVisits" using primary key columns */
  userRoomServiceOccurrenceLastVisits_by_pk?: Maybe<UserRoomServiceOccurrenceLastVisits>;
  /** fetch data from the table in a streaming manner: "userRoomServiceOccurrenceLastVisits" */
  userRoomServiceOccurrenceLastVisits_stream: Array<UserRoomServiceOccurrenceLastVisits>;
  /** fetch data from the table: "userServiceModuleLastVisits" */
  userServiceModuleLastVisits: Array<UserServiceModuleLastVisits>;
  /** fetch aggregated fields from the table: "userServiceModuleLastVisits" */
  userServiceModuleLastVisits_aggregate: UserServiceModuleLastVisits_Aggregate;
  /** fetch data from the table: "userServiceModuleLastVisits" using primary key columns */
  userServiceModuleLastVisits_by_pk?: Maybe<UserServiceModuleLastVisits>;
  /** fetch data from the table in a streaming manner: "userServiceModuleLastVisits" */
  userServiceModuleLastVisits_stream: Array<UserServiceModuleLastVisits>;
  /** fetch data from the table: "userSettings" */
  userSettings: Array<UserSettings>;
  /** fetch data from the table in a streaming manner: "userSettings" */
  userSettings_stream: Array<UserSettings>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
};


export type Subscription_RootV_Organice_Event_RaumbuchungArgs = {
  distinct_on?: InputMaybe<Array<V_Organice_Event_Raumbuchung_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<V_Organice_Event_Raumbuchung_Order_By>>;
  where?: InputMaybe<V_Organice_Event_Raumbuchung_Bool_Exp>;
};


export type Subscription_RootV_Organice_Event_Raumbuchung_AggregateArgs = {
  distinct_on?: InputMaybe<Array<V_Organice_Event_Raumbuchung_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<V_Organice_Event_Raumbuchung_Order_By>>;
  where?: InputMaybe<V_Organice_Event_Raumbuchung_Bool_Exp>;
};


export type Subscription_RootV_Organice_Event_Raumbuchung_By_PkArgs = {
  ID_Raumbuchung: Scalars['numeric']['input'];
};


export type Subscription_RootV_Organice_Event_Raumbuchung_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<V_Organice_Event_Raumbuchung_Stream_Cursor_Input>>;
  where?: InputMaybe<V_Organice_Event_Raumbuchung_Bool_Exp>;
};


export type Subscription_RootV_Organice_Event_StammArgs = {
  distinct_on?: InputMaybe<Array<V_Organice_Event_Stamm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<V_Organice_Event_Stamm_Order_By>>;
  where?: InputMaybe<V_Organice_Event_Stamm_Bool_Exp>;
};


export type Subscription_RootV_Organice_Event_Stamm_AggregateArgs = {
  distinct_on?: InputMaybe<Array<V_Organice_Event_Stamm_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<V_Organice_Event_Stamm_Order_By>>;
  where?: InputMaybe<V_Organice_Event_Stamm_Bool_Exp>;
};


export type Subscription_RootV_Organice_Event_Stamm_By_PkArgs = {
  T_HASH_Event: Scalars['bpchar']['input'];
};


export type Subscription_RootV_Organice_Event_Stamm_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<V_Organice_Event_Stamm_Stream_Cursor_Input>>;
  where?: InputMaybe<V_Organice_Event_Stamm_Bool_Exp>;
};


export type Subscription_RootAllUsersArgs = {
  distinct_on?: InputMaybe<Array<AllUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AllUsers_Order_By>>;
  where?: InputMaybe<AllUsers_Bool_Exp>;
};


export type Subscription_RootAllUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AllUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AllUsers_Order_By>>;
  where?: InputMaybe<AllUsers_Bool_Exp>;
};


export type Subscription_RootAllUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AllUsers_Stream_Cursor_Input>>;
  where?: InputMaybe<AllUsers_Bool_Exp>;
};


export type Subscription_RootArticlesArgs = {
  distinct_on?: InputMaybe<Array<Articles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Articles_Order_By>>;
  where?: InputMaybe<Articles_Bool_Exp>;
};


export type Subscription_RootArticles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Articles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Articles_Order_By>>;
  where?: InputMaybe<Articles_Bool_Exp>;
};


export type Subscription_RootArticles_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootArticles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Articles_Stream_Cursor_Input>>;
  where?: InputMaybe<Articles_Bool_Exp>;
};


export type Subscription_RootAttributeFilesArgs = {
  distinct_on?: InputMaybe<Array<AttributeFiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeFiles_Order_By>>;
  where?: InputMaybe<AttributeFiles_Bool_Exp>;
};


export type Subscription_RootAttributeFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeFiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeFiles_Order_By>>;
  where?: InputMaybe<AttributeFiles_Bool_Exp>;
};


export type Subscription_RootAttributeFiles_By_PkArgs = {
  attributeId: Scalars['bigint']['input'];
  fileId: Scalars['bigint']['input'];
};


export type Subscription_RootAttributeFiles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AttributeFiles_Stream_Cursor_Input>>;
  where?: InputMaybe<AttributeFiles_Bool_Exp>;
};


export type Subscription_RootAttributeGroupsArgs = {
  distinct_on?: InputMaybe<Array<AttributeGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeGroups_Order_By>>;
  where?: InputMaybe<AttributeGroups_Bool_Exp>;
};


export type Subscription_RootAttributeGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeGroups_Order_By>>;
  where?: InputMaybe<AttributeGroups_Bool_Exp>;
};


export type Subscription_RootAttributeGroups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAttributeGroups_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AttributeGroups_Stream_Cursor_Input>>;
  where?: InputMaybe<AttributeGroups_Bool_Exp>;
};


export type Subscription_RootAttributeTypesArgs = {
  distinct_on?: InputMaybe<Array<AttributeTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeTypes_Order_By>>;
  where?: InputMaybe<AttributeTypes_Bool_Exp>;
};


export type Subscription_RootAttributeTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeTypes_Order_By>>;
  where?: InputMaybe<AttributeTypes_Bool_Exp>;
};


export type Subscription_RootAttributeTypes_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootAttributeTypes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AttributeTypes_Stream_Cursor_Input>>;
  where?: InputMaybe<AttributeTypes_Bool_Exp>;
};


export type Subscription_RootAttributeValueCommentsArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueComments_Order_By>>;
  where?: InputMaybe<AttributeValueComments_Bool_Exp>;
};


export type Subscription_RootAttributeValueComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueComments_Order_By>>;
  where?: InputMaybe<AttributeValueComments_Bool_Exp>;
};


export type Subscription_RootAttributeValueComments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAttributeValueComments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AttributeValueComments_Stream_Cursor_Input>>;
  where?: InputMaybe<AttributeValueComments_Bool_Exp>;
};


export type Subscription_RootAttributeValueGroupsArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueGroups_Order_By>>;
  where?: InputMaybe<AttributeValueGroups_Bool_Exp>;
};


export type Subscription_RootAttributeValueGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueGroups_Order_By>>;
  where?: InputMaybe<AttributeValueGroups_Bool_Exp>;
};


export type Subscription_RootAttributeValueGroups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAttributeValueGroups_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AttributeValueGroups_Stream_Cursor_Input>>;
  where?: InputMaybe<AttributeValueGroups_Bool_Exp>;
};


export type Subscription_RootAttributeValueUploadVersionsArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<AttributeValueUploadVersions_Bool_Exp>;
};


export type Subscription_RootAttributeValueUploadVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<AttributeValueUploadVersions_Bool_Exp>;
};


export type Subscription_RootAttributeValueUploadVersions_By_PkArgs = {
  attributeValueUploadId: Scalars['bigint']['input'];
  fileId: Scalars['bigint']['input'];
};


export type Subscription_RootAttributeValueUploadVersions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AttributeValueUploadVersions_Stream_Cursor_Input>>;
  where?: InputMaybe<AttributeValueUploadVersions_Bool_Exp>;
};


export type Subscription_RootAttributeValueUploadsArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueUploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueUploads_Order_By>>;
  where?: InputMaybe<AttributeValueUploads_Bool_Exp>;
};


export type Subscription_RootAttributeValueUploads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeValueUploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValueUploads_Order_By>>;
  where?: InputMaybe<AttributeValueUploads_Bool_Exp>;
};


export type Subscription_RootAttributeValueUploads_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAttributeValueUploads_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AttributeValueUploads_Stream_Cursor_Input>>;
  where?: InputMaybe<AttributeValueUploads_Bool_Exp>;
};


export type Subscription_RootAttributeValuesArgs = {
  distinct_on?: InputMaybe<Array<AttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValues_Order_By>>;
  where?: InputMaybe<AttributeValues_Bool_Exp>;
};


export type Subscription_RootAttributeValues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttributeValues_Order_By>>;
  where?: InputMaybe<AttributeValues_Bool_Exp>;
};


export type Subscription_RootAttributeValues_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAttributeValues_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AttributeValues_Stream_Cursor_Input>>;
  where?: InputMaybe<AttributeValues_Bool_Exp>;
};


export type Subscription_RootAttributesArgs = {
  distinct_on?: InputMaybe<Array<Attributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attributes_Order_By>>;
  where?: InputMaybe<Attributes_Bool_Exp>;
};


export type Subscription_RootAttributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Attributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attributes_Order_By>>;
  where?: InputMaybe<Attributes_Bool_Exp>;
};


export type Subscription_RootAttributes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootAttributes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Attributes_Stream_Cursor_Input>>;
  where?: InputMaybe<Attributes_Bool_Exp>;
};


export type Subscription_RootCartLinesArgs = {
  distinct_on?: InputMaybe<Array<CartLines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CartLines_Order_By>>;
  where?: InputMaybe<CartLines_Bool_Exp>;
};


export type Subscription_RootCartLines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CartLines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CartLines_Order_By>>;
  where?: InputMaybe<CartLines_Bool_Exp>;
};


export type Subscription_RootCartLines_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootCartLines_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CartLines_Stream_Cursor_Input>>;
  where?: InputMaybe<CartLines_Bool_Exp>;
};


export type Subscription_RootCartsArgs = {
  distinct_on?: InputMaybe<Array<Carts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Carts_Order_By>>;
  where?: InputMaybe<Carts_Bool_Exp>;
};


export type Subscription_RootCarts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Carts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Carts_Order_By>>;
  where?: InputMaybe<Carts_Bool_Exp>;
};


export type Subscription_RootCarts_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootCarts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Carts_Stream_Cursor_Input>>;
  where?: InputMaybe<Carts_Bool_Exp>;
};


export type Subscription_RootCatalogFolderArticlesArgs = {
  distinct_on?: InputMaybe<Array<CatalogFolderArticles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CatalogFolderArticles_Order_By>>;
  where?: InputMaybe<CatalogFolderArticles_Bool_Exp>;
};


export type Subscription_RootCatalogFolderArticles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CatalogFolderArticles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CatalogFolderArticles_Order_By>>;
  where?: InputMaybe<CatalogFolderArticles_Bool_Exp>;
};


export type Subscription_RootCatalogFolderArticles_By_PkArgs = {
  articleId: Scalars['bigint']['input'];
  catalogFolderId: Scalars['bigint']['input'];
};


export type Subscription_RootCatalogFolderArticles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CatalogFolderArticles_Stream_Cursor_Input>>;
  where?: InputMaybe<CatalogFolderArticles_Bool_Exp>;
};


export type Subscription_RootCatalogFoldersArgs = {
  distinct_on?: InputMaybe<Array<CatalogFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CatalogFolders_Order_By>>;
  where?: InputMaybe<CatalogFolders_Bool_Exp>;
};


export type Subscription_RootCatalogFolders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CatalogFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CatalogFolders_Order_By>>;
  where?: InputMaybe<CatalogFolders_Bool_Exp>;
};


export type Subscription_RootCatalogFolders_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootCatalogFolders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CatalogFolders_Stream_Cursor_Input>>;
  where?: InputMaybe<CatalogFolders_Bool_Exp>;
};


export type Subscription_RootCurrentUserArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootCurrentUser_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootEventAttributeGroupsArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeGroups_Order_By>>;
  where?: InputMaybe<EventAttributeGroups_Bool_Exp>;
};


export type Subscription_RootEventAttributeGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeGroups_Order_By>>;
  where?: InputMaybe<EventAttributeGroups_Bool_Exp>;
};


export type Subscription_RootEventAttributeGroups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootEventAttributeGroups_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EventAttributeGroups_Stream_Cursor_Input>>;
  where?: InputMaybe<EventAttributeGroups_Bool_Exp>;
};


export type Subscription_RootEventAttributeValueUploadVersionsArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<EventAttributeValueUploadVersions_Bool_Exp>;
};


export type Subscription_RootEventAttributeValueUploadVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<EventAttributeValueUploadVersions_Bool_Exp>;
};


export type Subscription_RootEventAttributeValueUploadVersions_By_PkArgs = {
  eventAttributeValueUploadId: Scalars['bigint']['input'];
  fileId: Scalars['bigint']['input'];
};


export type Subscription_RootEventAttributeValueUploadVersions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EventAttributeValueUploadVersions_Stream_Cursor_Input>>;
  where?: InputMaybe<EventAttributeValueUploadVersions_Bool_Exp>;
};


export type Subscription_RootEventAttributeValueUploadsArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValueUploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValueUploads_Order_By>>;
  where?: InputMaybe<EventAttributeValueUploads_Bool_Exp>;
};


export type Subscription_RootEventAttributeValueUploads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValueUploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValueUploads_Order_By>>;
  where?: InputMaybe<EventAttributeValueUploads_Bool_Exp>;
};


export type Subscription_RootEventAttributeValueUploads_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootEventAttributeValueUploads_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EventAttributeValueUploads_Stream_Cursor_Input>>;
  where?: InputMaybe<EventAttributeValueUploads_Bool_Exp>;
};


export type Subscription_RootEventAttributeValuesArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValues_Order_By>>;
  where?: InputMaybe<EventAttributeValues_Bool_Exp>;
};


export type Subscription_RootEventAttributeValues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributeValues_Order_By>>;
  where?: InputMaybe<EventAttributeValues_Bool_Exp>;
};


export type Subscription_RootEventAttributeValues_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootEventAttributeValues_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EventAttributeValues_Stream_Cursor_Input>>;
  where?: InputMaybe<EventAttributeValues_Bool_Exp>;
};


export type Subscription_RootEventAttributesArgs = {
  distinct_on?: InputMaybe<Array<EventAttributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributes_Order_By>>;
  where?: InputMaybe<EventAttributes_Bool_Exp>;
};


export type Subscription_RootEventAttributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventAttributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventAttributes_Order_By>>;
  where?: InputMaybe<EventAttributes_Bool_Exp>;
};


export type Subscription_RootEventAttributes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootEventAttributes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EventAttributes_Stream_Cursor_Input>>;
  where?: InputMaybe<EventAttributes_Bool_Exp>;
};


export type Subscription_RootEventFavouritesArgs = {
  distinct_on?: InputMaybe<Array<EventFavourites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventFavourites_Order_By>>;
  where?: InputMaybe<EventFavourites_Bool_Exp>;
};


export type Subscription_RootEventFavourites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventFavourites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventFavourites_Order_By>>;
  where?: InputMaybe<EventFavourites_Bool_Exp>;
};


export type Subscription_RootEventFavourites_By_PkArgs = {
  eventId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Subscription_RootEventFavourites_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EventFavourites_Stream_Cursor_Input>>;
  where?: InputMaybe<EventFavourites_Bool_Exp>;
};


export type Subscription_RootEventOrganisersArgs = {
  distinct_on?: InputMaybe<Array<EventOrganisers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventOrganisers_Order_By>>;
  where?: InputMaybe<EventOrganisers_Bool_Exp>;
};


export type Subscription_RootEventOrganisers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventOrganisers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventOrganisers_Order_By>>;
  where?: InputMaybe<EventOrganisers_Bool_Exp>;
};


export type Subscription_RootEventOrganisers_By_PkArgs = {
  eventId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Subscription_RootEventOrganisers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EventOrganisers_Stream_Cursor_Input>>;
  where?: InputMaybe<EventOrganisers_Bool_Exp>;
};


export type Subscription_RootEventRoomWatchesArgs = {
  distinct_on?: InputMaybe<Array<EventRoomWatches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventRoomWatches_Order_By>>;
  where?: InputMaybe<EventRoomWatches_Bool_Exp>;
};


export type Subscription_RootEventRoomWatches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventRoomWatches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventRoomWatches_Order_By>>;
  where?: InputMaybe<EventRoomWatches_Bool_Exp>;
};


export type Subscription_RootEventRoomWatches_By_PkArgs = {
  eventId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Subscription_RootEventRoomWatches_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EventRoomWatches_Stream_Cursor_Input>>;
  where?: InputMaybe<EventRoomWatches_Bool_Exp>;
};


export type Subscription_RootEventRoomsArgs = {
  distinct_on?: InputMaybe<Array<EventRooms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventRooms_Order_By>>;
  where?: InputMaybe<EventRooms_Bool_Exp>;
};


export type Subscription_RootEventRooms_By_PkArgs = {
  eventId: Scalars['bigint']['input'];
  roomId: Scalars['bigint']['input'];
};


export type Subscription_RootEventRooms_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EventRooms_Stream_Cursor_Input>>;
  where?: InputMaybe<EventRooms_Bool_Exp>;
};


export type Subscription_RootEventTypesArgs = {
  distinct_on?: InputMaybe<Array<EventTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventTypes_Order_By>>;
  where?: InputMaybe<EventTypes_Bool_Exp>;
};


export type Subscription_RootEventTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventTypes_Order_By>>;
  where?: InputMaybe<EventTypes_Bool_Exp>;
};


export type Subscription_RootEventTypes_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootEventTypes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EventTypes_Stream_Cursor_Input>>;
  where?: InputMaybe<EventTypes_Bool_Exp>;
};


export type Subscription_RootEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootEvents_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootEvents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootFileMasterVersionsArgs = {
  distinct_on?: InputMaybe<Array<FileMasterVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FileMasterVersions_Order_By>>;
  where?: InputMaybe<FileMasterVersions_Bool_Exp>;
};


export type Subscription_RootFileMasterVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FileMasterVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FileMasterVersions_Order_By>>;
  where?: InputMaybe<FileMasterVersions_Bool_Exp>;
};


export type Subscription_RootFileMasterVersions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFileMasterVersions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<FileMasterVersions_Stream_Cursor_Input>>;
  where?: InputMaybe<FileMasterVersions_Bool_Exp>;
};


export type Subscription_RootFileMastersArgs = {
  distinct_on?: InputMaybe<Array<FileMasters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FileMasters_Order_By>>;
  where?: InputMaybe<FileMasters_Bool_Exp>;
};


export type Subscription_RootFileMasters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<FileMasters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<FileMasters_Order_By>>;
  where?: InputMaybe<FileMasters_Bool_Exp>;
};


export type Subscription_RootFileMasters_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFileMasters_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<FileMasters_Stream_Cursor_Input>>;
  where?: InputMaybe<FileMasters_Bool_Exp>;
};


export type Subscription_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootFiles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootInfoBoxesArgs = {
  distinct_on?: InputMaybe<Array<InfoBoxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InfoBoxes_Order_By>>;
  where?: InputMaybe<InfoBoxes_Bool_Exp>;
};


export type Subscription_RootInfoBoxes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<InfoBoxes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InfoBoxes_Order_By>>;
  where?: InputMaybe<InfoBoxes_Bool_Exp>;
};


export type Subscription_RootInfoBoxes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootInfoBoxes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<InfoBoxes_Stream_Cursor_Input>>;
  where?: InputMaybe<InfoBoxes_Bool_Exp>;
};


export type Subscription_RootInfoNewsArgs = {
  distinct_on?: InputMaybe<Array<InfoNews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InfoNews_Order_By>>;
  where?: InputMaybe<InfoNews_Bool_Exp>;
};


export type Subscription_RootInfoNews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<InfoNews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InfoNews_Order_By>>;
  where?: InputMaybe<InfoNews_Bool_Exp>;
};


export type Subscription_RootInfoNews_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootInfoNews_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<InfoNews_Stream_Cursor_Input>>;
  where?: InputMaybe<InfoNews_Bool_Exp>;
};


export type Subscription_RootJaggaerBanfsArgs = {
  distinct_on?: InputMaybe<Array<JaggaerBanfs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<JaggaerBanfs_Order_By>>;
  where?: InputMaybe<JaggaerBanfs_Bool_Exp>;
};


export type Subscription_RootJaggaerBanfs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<JaggaerBanfs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<JaggaerBanfs_Order_By>>;
  where?: InputMaybe<JaggaerBanfs_Bool_Exp>;
};


export type Subscription_RootJaggaerBanfs_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootJaggaerBanfs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<JaggaerBanfs_Stream_Cursor_Input>>;
  where?: InputMaybe<JaggaerBanfs_Bool_Exp>;
};


export type Subscription_RootJaggaerSubmissionsArgs = {
  distinct_on?: InputMaybe<Array<JaggaerSubmissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<JaggaerSubmissions_Order_By>>;
  where?: InputMaybe<JaggaerSubmissions_Bool_Exp>;
};


export type Subscription_RootJaggaerSubmissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<JaggaerSubmissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<JaggaerSubmissions_Order_By>>;
  where?: InputMaybe<JaggaerSubmissions_Bool_Exp>;
};


export type Subscription_RootJaggaerSubmissions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootJaggaerSubmissions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<JaggaerSubmissions_Stream_Cursor_Input>>;
  where?: InputMaybe<JaggaerSubmissions_Bool_Exp>;
};


export type Subscription_RootModuleTypesArgs = {
  distinct_on?: InputMaybe<Array<ModuleTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ModuleTypes_Order_By>>;
  where?: InputMaybe<ModuleTypes_Bool_Exp>;
};


export type Subscription_RootModuleTypes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ModuleTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ModuleTypes_Order_By>>;
  where?: InputMaybe<ModuleTypes_Bool_Exp>;
};


export type Subscription_RootModuleTypes_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootModuleTypes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ModuleTypes_Stream_Cursor_Input>>;
  where?: InputMaybe<ModuleTypes_Bool_Exp>;
};


export type Subscription_RootNewsArgs = {
  distinct_on?: InputMaybe<Array<News_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<News_Order_By>>;
  where?: InputMaybe<News_Bool_Exp>;
};


export type Subscription_RootNews_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<News_Stream_Cursor_Input>>;
  where?: InputMaybe<News_Bool_Exp>;
};


export type Subscription_RootNotificationActionsArgs = {
  distinct_on?: InputMaybe<Array<NotificationActions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationActions_Order_By>>;
  where?: InputMaybe<NotificationActions_Bool_Exp>;
};


export type Subscription_RootNotificationActions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationActions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationActions_Order_By>>;
  where?: InputMaybe<NotificationActions_Bool_Exp>;
};


export type Subscription_RootNotificationActions_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootNotificationActions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<NotificationActions_Stream_Cursor_Input>>;
  where?: InputMaybe<NotificationActions_Bool_Exp>;
};


export type Subscription_RootNotificationCadencesArgs = {
  distinct_on?: InputMaybe<Array<NotificationCadences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationCadences_Order_By>>;
  where?: InputMaybe<NotificationCadences_Bool_Exp>;
};


export type Subscription_RootNotificationCadences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationCadences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationCadences_Order_By>>;
  where?: InputMaybe<NotificationCadences_Bool_Exp>;
};


export type Subscription_RootNotificationCadences_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootNotificationCadences_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<NotificationCadences_Stream_Cursor_Input>>;
  where?: InputMaybe<NotificationCadences_Bool_Exp>;
};


export type Subscription_RootNotificationChannelsArgs = {
  distinct_on?: InputMaybe<Array<NotificationChannels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationChannels_Order_By>>;
  where?: InputMaybe<NotificationChannels_Bool_Exp>;
};


export type Subscription_RootNotificationChannels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationChannels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationChannels_Order_By>>;
  where?: InputMaybe<NotificationChannels_Bool_Exp>;
};


export type Subscription_RootNotificationChannels_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootNotificationChannels_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<NotificationChannels_Stream_Cursor_Input>>;
  where?: InputMaybe<NotificationChannels_Bool_Exp>;
};


export type Subscription_RootNotificationMessagesArgs = {
  distinct_on?: InputMaybe<Array<NotificationMessages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationMessages_Order_By>>;
  where?: InputMaybe<NotificationMessages_Bool_Exp>;
};


export type Subscription_RootNotificationMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationMessages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationMessages_Order_By>>;
  where?: InputMaybe<NotificationMessages_Bool_Exp>;
};


export type Subscription_RootNotificationMessages_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNotificationMessages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<NotificationMessages_Stream_Cursor_Input>>;
  where?: InputMaybe<NotificationMessages_Bool_Exp>;
};


export type Subscription_RootNotificationPreferenceStagesArgs = {
  distinct_on?: InputMaybe<Array<NotificationPreferenceStages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationPreferenceStages_Order_By>>;
  where?: InputMaybe<NotificationPreferenceStages_Bool_Exp>;
};


export type Subscription_RootNotificationPreferenceStages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationPreferenceStages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationPreferenceStages_Order_By>>;
  where?: InputMaybe<NotificationPreferenceStages_Bool_Exp>;
};


export type Subscription_RootNotificationPreferenceStages_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootNotificationPreferenceStages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<NotificationPreferenceStages_Stream_Cursor_Input>>;
  where?: InputMaybe<NotificationPreferenceStages_Bool_Exp>;
};


export type Subscription_RootNotificationPreferencesArgs = {
  distinct_on?: InputMaybe<Array<NotificationPreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationPreferences_Order_By>>;
  where?: InputMaybe<NotificationPreferences_Bool_Exp>;
};


export type Subscription_RootNotificationPreferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationPreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationPreferences_Order_By>>;
  where?: InputMaybe<NotificationPreferences_Bool_Exp>;
};


export type Subscription_RootNotificationPreferences_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNotificationPreferences_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<NotificationPreferences_Stream_Cursor_Input>>;
  where?: InputMaybe<NotificationPreferences_Bool_Exp>;
};


export type Subscription_RootNotificationRoomServiceCategoryPreferencesArgs = {
  distinct_on?: InputMaybe<Array<NotificationRoomServiceCategoryPreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationRoomServiceCategoryPreferences_Order_By>>;
  where?: InputMaybe<NotificationRoomServiceCategoryPreferences_Bool_Exp>;
};


export type Subscription_RootNotificationRoomServiceCategoryPreferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationRoomServiceCategoryPreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationRoomServiceCategoryPreferences_Order_By>>;
  where?: InputMaybe<NotificationRoomServiceCategoryPreferences_Bool_Exp>;
};


export type Subscription_RootNotificationRoomServiceCategoryPreferences_By_PkArgs = {
  roomServiceCategoryId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Subscription_RootNotificationRoomServiceCategoryPreferences_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<NotificationRoomServiceCategoryPreferences_Stream_Cursor_Input>>;
  where?: InputMaybe<NotificationRoomServiceCategoryPreferences_Bool_Exp>;
};


export type Subscription_RootNotificationServicePreferencesArgs = {
  distinct_on?: InputMaybe<Array<NotificationServicePreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationServicePreferences_Order_By>>;
  where?: InputMaybe<NotificationServicePreferences_Bool_Exp>;
};


export type Subscription_RootNotificationServicePreferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationServicePreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationServicePreferences_Order_By>>;
  where?: InputMaybe<NotificationServicePreferences_Bool_Exp>;
};


export type Subscription_RootNotificationServicePreferences_By_PkArgs = {
  serviceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Subscription_RootNotificationServicePreferences_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<NotificationServicePreferences_Stream_Cursor_Input>>;
  where?: InputMaybe<NotificationServicePreferences_Bool_Exp>;
};


export type Subscription_RootNotificationTemplatesArgs = {
  distinct_on?: InputMaybe<Array<NotificationTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationTemplates_Order_By>>;
  where?: InputMaybe<NotificationTemplates_Bool_Exp>;
};


export type Subscription_RootNotificationTemplates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationTemplates_Order_By>>;
  where?: InputMaybe<NotificationTemplates_Bool_Exp>;
};


export type Subscription_RootNotificationTemplates_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNotificationTemplates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<NotificationTemplates_Stream_Cursor_Input>>;
  where?: InputMaybe<NotificationTemplates_Bool_Exp>;
};


export type Subscription_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNotifications_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootNotifications_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Notifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootOrdersArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Subscription_RootOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Orders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Orders_Order_By>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Subscription_RootOrders_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootOrders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Orders_Stream_Cursor_Input>>;
  where?: InputMaybe<Orders_Bool_Exp>;
};


export type Subscription_RootOrganisationGroupUsersArgs = {
  distinct_on?: InputMaybe<Array<OrganisationGroupUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<OrganisationGroupUsers_Order_By>>;
  where?: InputMaybe<OrganisationGroupUsers_Bool_Exp>;
};


export type Subscription_RootOrganisationGroupUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganisationGroupUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<OrganisationGroupUsers_Order_By>>;
  where?: InputMaybe<OrganisationGroupUsers_Bool_Exp>;
};


export type Subscription_RootOrganisationGroupUsers_By_PkArgs = {
  organisationGroupId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Subscription_RootOrganisationGroupUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<OrganisationGroupUsers_Stream_Cursor_Input>>;
  where?: InputMaybe<OrganisationGroupUsers_Bool_Exp>;
};


export type Subscription_RootOrganisationGroupsArgs = {
  distinct_on?: InputMaybe<Array<OrganisationGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<OrganisationGroups_Order_By>>;
  where?: InputMaybe<OrganisationGroups_Bool_Exp>;
};


export type Subscription_RootOrganisationGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganisationGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<OrganisationGroups_Order_By>>;
  where?: InputMaybe<OrganisationGroups_Bool_Exp>;
};


export type Subscription_RootOrganisationGroups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootOrganisationGroups_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<OrganisationGroups_Stream_Cursor_Input>>;
  where?: InputMaybe<OrganisationGroups_Bool_Exp>;
};


export type Subscription_RootOrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisations_Order_By>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Subscription_RootOrganisations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisations_Order_By>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Subscription_RootOrganisations_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootOrganisations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organisations_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Subscription_RootRoomAttributeFilesArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeFiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeFiles_Order_By>>;
  where?: InputMaybe<RoomAttributeFiles_Bool_Exp>;
};


export type Subscription_RootRoomAttributeFiles_By_PkArgs = {
  fileId: Scalars['bigint']['input'];
  roomAttributeId: Scalars['bigint']['input'];
};


export type Subscription_RootRoomAttributeFiles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RoomAttributeFiles_Stream_Cursor_Input>>;
  where?: InputMaybe<RoomAttributeFiles_Bool_Exp>;
};


export type Subscription_RootRoomAttributeGroupsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeGroups_Order_By>>;
  where?: InputMaybe<RoomAttributeGroups_Bool_Exp>;
};


export type Subscription_RootRoomAttributeGroups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootRoomAttributeGroups_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RoomAttributeGroups_Stream_Cursor_Input>>;
  where?: InputMaybe<RoomAttributeGroups_Bool_Exp>;
};


export type Subscription_RootRoomAttributeValueCommentsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueComments_Order_By>>;
  where?: InputMaybe<RoomAttributeValueComments_Bool_Exp>;
};


export type Subscription_RootRoomAttributeValueComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueComments_Order_By>>;
  where?: InputMaybe<RoomAttributeValueComments_Bool_Exp>;
};


export type Subscription_RootRoomAttributeValueComments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootRoomAttributeValueComments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RoomAttributeValueComments_Stream_Cursor_Input>>;
  where?: InputMaybe<RoomAttributeValueComments_Bool_Exp>;
};


export type Subscription_RootRoomAttributeValueGroupsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueGroups_Order_By>>;
  where?: InputMaybe<RoomAttributeValueGroups_Bool_Exp>;
};


export type Subscription_RootRoomAttributeValueGroups_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootRoomAttributeValueGroups_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RoomAttributeValueGroups_Stream_Cursor_Input>>;
  where?: InputMaybe<RoomAttributeValueGroups_Bool_Exp>;
};


export type Subscription_RootRoomAttributeValueUploadVersionsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<RoomAttributeValueUploadVersions_Bool_Exp>;
};


export type Subscription_RootRoomAttributeValueUploadVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueUploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueUploadVersions_Order_By>>;
  where?: InputMaybe<RoomAttributeValueUploadVersions_Bool_Exp>;
};


export type Subscription_RootRoomAttributeValueUploadVersions_By_PkArgs = {
  fileId: Scalars['bigint']['input'];
  roomAttributeValueUploadId: Scalars['bigint']['input'];
};


export type Subscription_RootRoomAttributeValueUploadVersions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RoomAttributeValueUploadVersions_Stream_Cursor_Input>>;
  where?: InputMaybe<RoomAttributeValueUploadVersions_Bool_Exp>;
};


export type Subscription_RootRoomAttributeValueUploadsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueUploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueUploads_Order_By>>;
  where?: InputMaybe<RoomAttributeValueUploads_Bool_Exp>;
};


export type Subscription_RootRoomAttributeValueUploads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValueUploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValueUploads_Order_By>>;
  where?: InputMaybe<RoomAttributeValueUploads_Bool_Exp>;
};


export type Subscription_RootRoomAttributeValueUploads_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootRoomAttributeValueUploads_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RoomAttributeValueUploads_Stream_Cursor_Input>>;
  where?: InputMaybe<RoomAttributeValueUploads_Bool_Exp>;
};


export type Subscription_RootRoomAttributeValuesArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValues_Order_By>>;
  where?: InputMaybe<RoomAttributeValues_Bool_Exp>;
};


export type Subscription_RootRoomAttributeValues_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootRoomAttributeValues_For_CommentsArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributeValues_For_Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributeValues_For_Comments_Order_By>>;
  where?: InputMaybe<RoomAttributeValues_For_Comments_Bool_Exp>;
};


export type Subscription_RootRoomAttributeValues_For_Comments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RoomAttributeValues_For_Comments_Stream_Cursor_Input>>;
  where?: InputMaybe<RoomAttributeValues_For_Comments_Bool_Exp>;
};


export type Subscription_RootRoomAttributeValues_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RoomAttributeValues_Stream_Cursor_Input>>;
  where?: InputMaybe<RoomAttributeValues_Bool_Exp>;
};


export type Subscription_RootRoomAttributesArgs = {
  distinct_on?: InputMaybe<Array<RoomAttributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomAttributes_Order_By>>;
  where?: InputMaybe<RoomAttributes_Bool_Exp>;
};


export type Subscription_RootRoomAttributes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootRoomAttributes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RoomAttributes_Stream_Cursor_Input>>;
  where?: InputMaybe<RoomAttributes_Bool_Exp>;
};


export type Subscription_RootRoomChangesArgs = {
  distinct_on?: InputMaybe<Array<RoomChanges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomChanges_Order_By>>;
  where?: InputMaybe<RoomChanges_Bool_Exp>;
};


export type Subscription_RootRoomChanges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoomChanges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomChanges_Order_By>>;
  where?: InputMaybe<RoomChanges_Bool_Exp>;
};


export type Subscription_RootRoomChanges_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootRoomChanges_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RoomChanges_Stream_Cursor_Input>>;
  where?: InputMaybe<RoomChanges_Bool_Exp>;
};


export type Subscription_RootRoomFoldersArgs = {
  distinct_on?: InputMaybe<Array<RoomFolders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomFolders_Order_By>>;
  where?: InputMaybe<RoomFolders_Bool_Exp>;
};


export type Subscription_RootRoomFolders_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootRoomFolders_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RoomFolders_Stream_Cursor_Input>>;
  where?: InputMaybe<RoomFolders_Bool_Exp>;
};


export type Subscription_RootRoomOccurrence_IntersectionsArgs = {
  distinct_on?: InputMaybe<Array<RoomOccurrence_Intersections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomOccurrence_Intersections_Order_By>>;
  where?: InputMaybe<RoomOccurrence_Intersections_Bool_Exp>;
};


export type Subscription_RootRoomOccurrence_Intersections_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RoomOccurrence_Intersections_Stream_Cursor_Input>>;
  where?: InputMaybe<RoomOccurrence_Intersections_Bool_Exp>;
};


export type Subscription_RootRoomOccurrencesArgs = {
  distinct_on?: InputMaybe<Array<RoomOccurrences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomOccurrences_Order_By>>;
  where?: InputMaybe<RoomOccurrences_Bool_Exp>;
};


export type Subscription_RootRoomOccurrences_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootRoomOccurrences_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RoomOccurrences_Stream_Cursor_Input>>;
  where?: InputMaybe<RoomOccurrences_Bool_Exp>;
};


export type Subscription_RootRoomServiceCategoriesArgs = {
  distinct_on?: InputMaybe<Array<RoomServiceCategories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomServiceCategories_Order_By>>;
  where?: InputMaybe<RoomServiceCategories_Bool_Exp>;
};


export type Subscription_RootRoomServiceCategories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoomServiceCategories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomServiceCategories_Order_By>>;
  where?: InputMaybe<RoomServiceCategories_Bool_Exp>;
};


export type Subscription_RootRoomServiceCategories_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootRoomServiceCategories_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RoomServiceCategories_Stream_Cursor_Input>>;
  where?: InputMaybe<RoomServiceCategories_Bool_Exp>;
};


export type Subscription_RootRoomServiceOccurrencesArgs = {
  distinct_on?: InputMaybe<Array<RoomServiceOccurrences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomServiceOccurrences_Order_By>>;
  where?: InputMaybe<RoomServiceOccurrences_Bool_Exp>;
};


export type Subscription_RootRoomServiceOccurrences_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootRoomServiceOccurrences_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RoomServiceOccurrences_Stream_Cursor_Input>>;
  where?: InputMaybe<RoomServiceOccurrences_Bool_Exp>;
};


export type Subscription_RootRoomServiceOrganisationAccessesArgs = {
  distinct_on?: InputMaybe<Array<RoomServiceOrganisationAccesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomServiceOrganisationAccesses_Order_By>>;
  where?: InputMaybe<RoomServiceOrganisationAccesses_Bool_Exp>;
};


export type Subscription_RootRoomServiceOrganisationAccesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RoomServiceOrganisationAccesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomServiceOrganisationAccesses_Order_By>>;
  where?: InputMaybe<RoomServiceOrganisationAccesses_Bool_Exp>;
};


export type Subscription_RootRoomServiceOrganisationAccesses_By_PkArgs = {
  eventId: Scalars['bigint']['input'];
  organisationId: Scalars['bigint']['input'];
};


export type Subscription_RootRoomServiceOrganisationAccesses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RoomServiceOrganisationAccesses_Stream_Cursor_Input>>;
  where?: InputMaybe<RoomServiceOrganisationAccesses_Bool_Exp>;
};


export type Subscription_RootRoomServicesArgs = {
  distinct_on?: InputMaybe<Array<RoomServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<RoomServices_Order_By>>;
  where?: InputMaybe<RoomServices_Bool_Exp>;
};


export type Subscription_RootRoomServices_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootRoomServices_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RoomServices_Stream_Cursor_Input>>;
  where?: InputMaybe<RoomServices_Bool_Exp>;
};


export type Subscription_RootRoomsArgs = {
  distinct_on?: InputMaybe<Array<Rooms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rooms_Order_By>>;
  where?: InputMaybe<Rooms_Bool_Exp>;
};


export type Subscription_RootRooms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Rooms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Rooms_Order_By>>;
  where?: InputMaybe<Rooms_Bool_Exp>;
};


export type Subscription_RootRooms_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootRooms_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Rooms_Stream_Cursor_Input>>;
  where?: InputMaybe<Rooms_Bool_Exp>;
};


export type Subscription_RootServiceBundleServicesArgs = {
  distinct_on?: InputMaybe<Array<ServiceBundleServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceBundleServices_Order_By>>;
  where?: InputMaybe<ServiceBundleServices_Bool_Exp>;
};


export type Subscription_RootServiceBundleServices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceBundleServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceBundleServices_Order_By>>;
  where?: InputMaybe<ServiceBundleServices_Bool_Exp>;
};


export type Subscription_RootServiceBundleServices_By_PkArgs = {
  serviceBundleId: Scalars['bigint']['input'];
  serviceId: Scalars['bigint']['input'];
};


export type Subscription_RootServiceBundleServices_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServiceBundleServices_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceBundleServices_Bool_Exp>;
};


export type Subscription_RootServiceBundlesArgs = {
  distinct_on?: InputMaybe<Array<ServiceBundles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceBundles_Order_By>>;
  where?: InputMaybe<ServiceBundles_Bool_Exp>;
};


export type Subscription_RootServiceBundles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceBundles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceBundles_Order_By>>;
  where?: InputMaybe<ServiceBundles_Bool_Exp>;
};


export type Subscription_RootServiceBundles_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootServiceBundles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServiceBundles_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceBundles_Bool_Exp>;
};


export type Subscription_RootServiceFavouritesArgs = {
  distinct_on?: InputMaybe<Array<ServiceFavourites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceFavourites_Order_By>>;
  where?: InputMaybe<ServiceFavourites_Bool_Exp>;
};


export type Subscription_RootServiceFavourites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceFavourites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceFavourites_Order_By>>;
  where?: InputMaybe<ServiceFavourites_Bool_Exp>;
};


export type Subscription_RootServiceFavourites_By_PkArgs = {
  serviceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Subscription_RootServiceFavourites_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServiceFavourites_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceFavourites_Bool_Exp>;
};


export type Subscription_RootServiceModuleAccessesArgs = {
  distinct_on?: InputMaybe<Array<ServiceModuleAccesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModuleAccesses_Order_By>>;
  where?: InputMaybe<ServiceModuleAccesses_Bool_Exp>;
};


export type Subscription_RootServiceModuleAccesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceModuleAccesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModuleAccesses_Order_By>>;
  where?: InputMaybe<ServiceModuleAccesses_Bool_Exp>;
};


export type Subscription_RootServiceModuleAccesses_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootServiceModuleAccesses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServiceModuleAccesses_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceModuleAccesses_Bool_Exp>;
};


export type Subscription_RootServiceModuleChangesArgs = {
  distinct_on?: InputMaybe<Array<ServiceModuleChanges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModuleChanges_Order_By>>;
  where?: InputMaybe<ServiceModuleChanges_Bool_Exp>;
};


export type Subscription_RootServiceModuleChanges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceModuleChanges_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModuleChanges_Order_By>>;
  where?: InputMaybe<ServiceModuleChanges_Bool_Exp>;
};


export type Subscription_RootServiceModuleChanges_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootServiceModuleChanges_GroupedArgs = {
  distinct_on?: InputMaybe<Array<ServiceModuleChanges_Grouped_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModuleChanges_Grouped_Order_By>>;
  where?: InputMaybe<ServiceModuleChanges_Grouped_Bool_Exp>;
};


export type Subscription_RootServiceModuleChanges_Grouped_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceModuleChanges_Grouped_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModuleChanges_Grouped_Order_By>>;
  where?: InputMaybe<ServiceModuleChanges_Grouped_Bool_Exp>;
};


export type Subscription_RootServiceModuleChanges_Grouped_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServiceModuleChanges_Grouped_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceModuleChanges_Grouped_Bool_Exp>;
};


export type Subscription_RootServiceModuleChanges_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServiceModuleChanges_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceModuleChanges_Bool_Exp>;
};


export type Subscription_RootServiceModulesArgs = {
  distinct_on?: InputMaybe<Array<ServiceModules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModules_Order_By>>;
  where?: InputMaybe<ServiceModules_Bool_Exp>;
};


export type Subscription_RootServiceModules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceModules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceModules_Order_By>>;
  where?: InputMaybe<ServiceModules_Bool_Exp>;
};


export type Subscription_RootServiceModules_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootServiceModules_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServiceModules_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceModules_Bool_Exp>;
};


export type Subscription_RootServiceOrganisationAccessesArgs = {
  distinct_on?: InputMaybe<Array<ServiceOrganisationAccesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOrganisationAccesses_Order_By>>;
  where?: InputMaybe<ServiceOrganisationAccesses_Bool_Exp>;
};


export type Subscription_RootServiceOrganisationAccesses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceOrganisationAccesses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceOrganisationAccesses_Order_By>>;
  where?: InputMaybe<ServiceOrganisationAccesses_Bool_Exp>;
};


export type Subscription_RootServiceOrganisationAccesses_By_PkArgs = {
  organisationId: Scalars['bigint']['input'];
  serviceId: Scalars['bigint']['input'];
};


export type Subscription_RootServiceOrganisationAccesses_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServiceOrganisationAccesses_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceOrganisationAccesses_Bool_Exp>;
};


export type Subscription_RootServiceParentsArgs = {
  distinct_on?: InputMaybe<Array<ServiceParents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceParents_Order_By>>;
  where?: InputMaybe<ServiceParents_Bool_Exp>;
};


export type Subscription_RootServiceParents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceParents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceParents_Order_By>>;
  where?: InputMaybe<ServiceParents_Bool_Exp>;
};


export type Subscription_RootServiceParents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServiceParents_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceParents_Bool_Exp>;
};


export type Subscription_RootServiceTagsArgs = {
  distinct_on?: InputMaybe<Array<ServiceTags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceTags_Order_By>>;
  where?: InputMaybe<ServiceTags_Bool_Exp>;
};


export type Subscription_RootServiceTags_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ServiceTags_Stream_Cursor_Input>>;
  where?: InputMaybe<ServiceTags_Bool_Exp>;
};


export type Subscription_RootServicesArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


export type Subscription_RootServices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


export type Subscription_RootServices_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootServices_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Services_Stream_Cursor_Input>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


export type Subscription_RootTest1Args = {
  distinct_on?: InputMaybe<Array<Test1_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Test1_Order_By>>;
  where?: InputMaybe<Test1_Bool_Exp>;
};


export type Subscription_RootTest1_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Test1_Stream_Cursor_Input>>;
  where?: InputMaybe<Test1_Bool_Exp>;
};


export type Subscription_RootUploadCommentsArgs = {
  distinct_on?: InputMaybe<Array<UploadComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UploadComments_Order_By>>;
  where?: InputMaybe<UploadComments_Bool_Exp>;
};


export type Subscription_RootUploadComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UploadComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UploadComments_Order_By>>;
  where?: InputMaybe<UploadComments_Bool_Exp>;
};


export type Subscription_RootUploadComments_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUploadComments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UploadComments_Stream_Cursor_Input>>;
  where?: InputMaybe<UploadComments_Bool_Exp>;
};


export type Subscription_RootUploadVersionsArgs = {
  distinct_on?: InputMaybe<Array<UploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UploadVersions_Order_By>>;
  where?: InputMaybe<UploadVersions_Bool_Exp>;
};


export type Subscription_RootUploadVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UploadVersions_Order_By>>;
  where?: InputMaybe<UploadVersions_Bool_Exp>;
};


export type Subscription_RootUploadVersions_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUploadVersions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UploadVersions_Stream_Cursor_Input>>;
  where?: InputMaybe<UploadVersions_Bool_Exp>;
};


export type Subscription_RootUploadsArgs = {
  distinct_on?: InputMaybe<Array<Uploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uploads_Order_By>>;
  where?: InputMaybe<Uploads_Bool_Exp>;
};


export type Subscription_RootUploads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Uploads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Uploads_Order_By>>;
  where?: InputMaybe<Uploads_Bool_Exp>;
};


export type Subscription_RootUploads_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUploads_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Uploads_Stream_Cursor_Input>>;
  where?: InputMaybe<Uploads_Bool_Exp>;
};


export type Subscription_RootUserAttributeValuesArgs = {
  distinct_on?: InputMaybe<Array<UserAttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserAttributeValues_Order_By>>;
  where?: InputMaybe<UserAttributeValues_Bool_Exp>;
};


export type Subscription_RootUserAttributeValues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserAttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserAttributeValues_Order_By>>;
  where?: InputMaybe<UserAttributeValues_Bool_Exp>;
};


export type Subscription_RootUserAttributeValues_By_PkArgs = {
  userAttributeId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Subscription_RootUserAttributeValues_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserAttributeValues_Stream_Cursor_Input>>;
  where?: InputMaybe<UserAttributeValues_Bool_Exp>;
};


export type Subscription_RootUserAttributesArgs = {
  distinct_on?: InputMaybe<Array<UserAttributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserAttributes_Order_By>>;
  where?: InputMaybe<UserAttributes_Bool_Exp>;
};


export type Subscription_RootUserAttributes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserAttributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserAttributes_Order_By>>;
  where?: InputMaybe<UserAttributes_Bool_Exp>;
};


export type Subscription_RootUserAttributes_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUserAttributes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserAttributes_Stream_Cursor_Input>>;
  where?: InputMaybe<UserAttributes_Bool_Exp>;
};


export type Subscription_RootUserDataRoomOccurrencesArgs = {
  distinct_on?: InputMaybe<Array<UserDataRoomOccurrences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserDataRoomOccurrences_Order_By>>;
  where?: InputMaybe<UserDataRoomOccurrences_Bool_Exp>;
};


export type Subscription_RootUserDataRoomOccurrences_By_PkArgs = {
  roomOccurrenceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Subscription_RootUserDataRoomOccurrences_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserDataRoomOccurrences_Stream_Cursor_Input>>;
  where?: InputMaybe<UserDataRoomOccurrences_Bool_Exp>;
};


export type Subscription_RootUserDataRoomServiceOccurrencesArgs = {
  distinct_on?: InputMaybe<Array<UserDataRoomServiceOccurrences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserDataRoomServiceOccurrences_Order_By>>;
  where?: InputMaybe<UserDataRoomServiceOccurrences_Bool_Exp>;
};


export type Subscription_RootUserDataRoomServiceOccurrences_By_PkArgs = {
  roomServiceOccurrenceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Subscription_RootUserDataRoomServiceOccurrences_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserDataRoomServiceOccurrences_Stream_Cursor_Input>>;
  where?: InputMaybe<UserDataRoomServiceOccurrences_Bool_Exp>;
};


export type Subscription_RootUserDataServicesArgs = {
  distinct_on?: InputMaybe<Array<UserDataServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserDataServices_Order_By>>;
  where?: InputMaybe<UserDataServices_Bool_Exp>;
};


export type Subscription_RootUserDataServices_By_PkArgs = {
  serviceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Subscription_RootUserDataServices_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserDataServices_Stream_Cursor_Input>>;
  where?: InputMaybe<UserDataServices_Bool_Exp>;
};


export type Subscription_RootUserRoomServiceOccurrenceLastVisitsArgs = {
  distinct_on?: InputMaybe<Array<UserRoomServiceOccurrenceLastVisits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoomServiceOccurrenceLastVisits_Order_By>>;
  where?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Bool_Exp>;
};


export type Subscription_RootUserRoomServiceOccurrenceLastVisits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserRoomServiceOccurrenceLastVisits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRoomServiceOccurrenceLastVisits_Order_By>>;
  where?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Bool_Exp>;
};


export type Subscription_RootUserRoomServiceOccurrenceLastVisits_By_PkArgs = {
  roomServiceOccurrenceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Subscription_RootUserRoomServiceOccurrenceLastVisits_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserRoomServiceOccurrenceLastVisits_Stream_Cursor_Input>>;
  where?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Bool_Exp>;
};


export type Subscription_RootUserServiceModuleLastVisitsArgs = {
  distinct_on?: InputMaybe<Array<UserServiceModuleLastVisits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserServiceModuleLastVisits_Order_By>>;
  where?: InputMaybe<UserServiceModuleLastVisits_Bool_Exp>;
};


export type Subscription_RootUserServiceModuleLastVisits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserServiceModuleLastVisits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserServiceModuleLastVisits_Order_By>>;
  where?: InputMaybe<UserServiceModuleLastVisits_Bool_Exp>;
};


export type Subscription_RootUserServiceModuleLastVisits_By_PkArgs = {
  serviceModuleId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};


export type Subscription_RootUserServiceModuleLastVisits_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserServiceModuleLastVisits_Stream_Cursor_Input>>;
  where?: InputMaybe<UserServiceModuleLastVisits_Bool_Exp>;
};


export type Subscription_RootUserSettingsArgs = {
  distinct_on?: InputMaybe<Array<UserSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserSettings_Order_By>>;
  where?: InputMaybe<UserSettings_Bool_Exp>;
};


export type Subscription_RootUserSettings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserSettings_Stream_Cursor_Input>>;
  where?: InputMaybe<UserSettings_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** columns and relationships of "test1" */
export type Test1 = {
  __typename?: 'test1';
  x1: Scalars['bigint']['output'];
  x2?: Maybe<Scalars['bigint']['output']>;
};

/** Boolean expression to filter rows from the table "test1". All fields are combined with a logical 'AND'. */
export type Test1_Bool_Exp = {
  _and?: InputMaybe<Array<Test1_Bool_Exp>>;
  _not?: InputMaybe<Test1_Bool_Exp>;
  _or?: InputMaybe<Array<Test1_Bool_Exp>>;
  x1?: InputMaybe<Bigint_Comparison_Exp>;
  x2?: InputMaybe<Bigint_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "test1" */
export type Test1_Inc_Input = {
  x1?: InputMaybe<Scalars['bigint']['input']>;
  x2?: InputMaybe<Scalars['bigint']['input']>;
};

/** response of any mutation on the table "test1" */
export type Test1_Mutation_Response = {
  __typename?: 'test1_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Test1>;
};

/** Ordering options when selecting data from "test1". */
export type Test1_Order_By = {
  x1?: InputMaybe<Order_By>;
  x2?: InputMaybe<Order_By>;
};

/** select columns of table "test1" */
export enum Test1_Select_Column {
  /** column name */
  X1 = 'x1',
  /** column name */
  X2 = 'x2'
}

/** input type for updating data in table "test1" */
export type Test1_Set_Input = {
  x1?: InputMaybe<Scalars['bigint']['input']>;
  x2?: InputMaybe<Scalars['bigint']['input']>;
};

/** Streaming cursor of the table "test1" */
export type Test1_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Test1_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Test1_Stream_Cursor_Value_Input = {
  x1?: InputMaybe<Scalars['bigint']['input']>;
  x2?: InputMaybe<Scalars['bigint']['input']>;
};

export type Test1_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Test1_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Test1_Set_Input>;
  /** filter the rows which have to be updated */
  where: Test1_Bool_Exp;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "uploadComments" */
export type UploadComments = {
  __typename?: 'uploadComments';
  comment: Scalars['String']['output'];
  /** An array relationship */
  comments: Array<UploadComments>;
  /** An aggregate relationship */
  comments_aggregate: UploadComments_Aggregate;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  fullUser: Users;
  id: Scalars['bigint']['output'];
  isDone?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  /** An object relationship */
  organisation?: Maybe<Organisations>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  parentComment?: Maybe<UploadComments>;
  parentId?: Maybe<Scalars['bigint']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  upload: Uploads;
  uploadId: Scalars['bigint']['output'];
  /** An object relationship */
  uploadVersion: UploadVersions;
  uploadVersionId: Scalars['bigint']['output'];
  /** An object relationship */
  user?: Maybe<AllUsers>;
  userId: Scalars['bigint']['output'];
};


/** columns and relationships of "uploadComments" */
export type UploadCommentsCommentsArgs = {
  distinct_on?: InputMaybe<Array<UploadComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UploadComments_Order_By>>;
  where?: InputMaybe<UploadComments_Bool_Exp>;
};


/** columns and relationships of "uploadComments" */
export type UploadCommentsComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UploadComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UploadComments_Order_By>>;
  where?: InputMaybe<UploadComments_Bool_Exp>;
};


/** columns and relationships of "uploadComments" */
export type UploadCommentsNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "uploadComments" */
export type UploadCommentsNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** aggregated selection of "uploadComments" */
export type UploadComments_Aggregate = {
  __typename?: 'uploadComments_aggregate';
  aggregate?: Maybe<UploadComments_Aggregate_Fields>;
  nodes: Array<UploadComments>;
};

export type UploadComments_Aggregate_Bool_Exp = {
  count?: InputMaybe<UploadComments_Aggregate_Bool_Exp_Count>;
};

export type UploadComments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<UploadComments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UploadComments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uploadComments" */
export type UploadComments_Aggregate_Fields = {
  __typename?: 'uploadComments_aggregate_fields';
  avg?: Maybe<UploadComments_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<UploadComments_Max_Fields>;
  min?: Maybe<UploadComments_Min_Fields>;
  stddev?: Maybe<UploadComments_Stddev_Fields>;
  stddev_pop?: Maybe<UploadComments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UploadComments_Stddev_Samp_Fields>;
  sum?: Maybe<UploadComments_Sum_Fields>;
  var_pop?: Maybe<UploadComments_Var_Pop_Fields>;
  var_samp?: Maybe<UploadComments_Var_Samp_Fields>;
  variance?: Maybe<UploadComments_Variance_Fields>;
};


/** aggregate fields of "uploadComments" */
export type UploadComments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UploadComments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uploadComments" */
export type UploadComments_Aggregate_Order_By = {
  avg?: InputMaybe<UploadComments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UploadComments_Max_Order_By>;
  min?: InputMaybe<UploadComments_Min_Order_By>;
  stddev?: InputMaybe<UploadComments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UploadComments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UploadComments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UploadComments_Sum_Order_By>;
  var_pop?: InputMaybe<UploadComments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UploadComments_Var_Samp_Order_By>;
  variance?: InputMaybe<UploadComments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uploadComments" */
export type UploadComments_Arr_Rel_Insert_Input = {
  data: Array<UploadComments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UploadComments_On_Conflict>;
};

/** aggregate avg on columns */
export type UploadComments_Avg_Fields = {
  __typename?: 'uploadComments_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uploadComments" */
export type UploadComments_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  uploadId?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uploadComments". All fields are combined with a logical 'AND'. */
export type UploadComments_Bool_Exp = {
  _and?: InputMaybe<Array<UploadComments_Bool_Exp>>;
  _not?: InputMaybe<UploadComments_Bool_Exp>;
  _or?: InputMaybe<Array<UploadComments_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<UploadComments_Bool_Exp>;
  comments_aggregate?: InputMaybe<UploadComments_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  fullUser?: InputMaybe<Users_Bool_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  isDone?: InputMaybe<Timestamptz_Comparison_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Bool_Exp>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisationId?: InputMaybe<Bigint_Comparison_Exp>;
  parentComment?: InputMaybe<UploadComments_Bool_Exp>;
  parentId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  upload?: InputMaybe<Uploads_Bool_Exp>;
  uploadId?: InputMaybe<Bigint_Comparison_Exp>;
  uploadVersion?: InputMaybe<UploadVersions_Bool_Exp>;
  uploadVersionId?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<AllUsers_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uploadComments" */
export enum UploadComments_Constraint {
  /** unique or primary key constraint on columns "id" */
  UploadCommentsPkey = 'uploadComments_pkey'
}

/** input type for incrementing numeric columns in table "uploadComments" */
export type UploadComments_Inc_Input = {
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "uploadComments" */
export type UploadComments_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<UploadComments_Arr_Rel_Insert_Input>;
  fullUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  isDone?: InputMaybe<Scalars['timestamptz']['input']>;
  organisation?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
  parentComment?: InputMaybe<UploadComments_Obj_Rel_Insert_Input>;
  parentId?: InputMaybe<Scalars['bigint']['input']>;
  upload?: InputMaybe<Uploads_Obj_Rel_Insert_Input>;
  uploadId?: InputMaybe<Scalars['bigint']['input']>;
  uploadVersion?: InputMaybe<UploadVersions_Obj_Rel_Insert_Input>;
  uploadVersionId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type UploadComments_Max_Fields = {
  __typename?: 'uploadComments_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  isDone?: Maybe<Scalars['timestamptz']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  parentId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadId?: Maybe<Scalars['bigint']['output']>;
  uploadVersionId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "uploadComments" */
export type UploadComments_Max_Order_By = {
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDone?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadId?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UploadComments_Min_Fields = {
  __typename?: 'uploadComments_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  isDone?: Maybe<Scalars['timestamptz']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  parentId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadId?: Maybe<Scalars['bigint']['output']>;
  uploadVersionId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "uploadComments" */
export type UploadComments_Min_Order_By = {
  comment?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDone?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadId?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uploadComments" */
export type UploadComments_Mutation_Response = {
  __typename?: 'uploadComments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UploadComments>;
};

/** input type for inserting object relation for remote table "uploadComments" */
export type UploadComments_Obj_Rel_Insert_Input = {
  data: UploadComments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<UploadComments_On_Conflict>;
};

/** on_conflict condition type for table "uploadComments" */
export type UploadComments_On_Conflict = {
  constraint: UploadComments_Constraint;
  update_columns?: Array<UploadComments_Update_Column>;
  where?: InputMaybe<UploadComments_Bool_Exp>;
};

/** Ordering options when selecting data from "uploadComments". */
export type UploadComments_Order_By = {
  comment?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<UploadComments_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  fullUser?: InputMaybe<Users_Order_By>;
  id?: InputMaybe<Order_By>;
  isDone?: InputMaybe<Order_By>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  organisation?: InputMaybe<Organisations_Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentComment?: InputMaybe<UploadComments_Order_By>;
  parentId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  upload?: InputMaybe<Uploads_Order_By>;
  uploadId?: InputMaybe<Order_By>;
  uploadVersion?: InputMaybe<UploadVersions_Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  user?: InputMaybe<AllUsers_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: uploadComments */
export type UploadComments_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uploadComments" */
export enum UploadComments_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsDone = 'isDone',
  /** column name */
  OrganisationId = 'organisationId',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadId = 'uploadId',
  /** column name */
  UploadVersionId = 'uploadVersionId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "uploadComments" */
export type UploadComments_Set_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  isDone?: InputMaybe<Scalars['timestamptz']['input']>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type UploadComments_Stddev_Fields = {
  __typename?: 'uploadComments_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uploadComments" */
export type UploadComments_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  uploadId?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type UploadComments_Stddev_Pop_Fields = {
  __typename?: 'uploadComments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uploadComments" */
export type UploadComments_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  uploadId?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type UploadComments_Stddev_Samp_Fields = {
  __typename?: 'uploadComments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uploadComments" */
export type UploadComments_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  uploadId?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uploadComments" */
export type UploadComments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UploadComments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UploadComments_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  isDone?: InputMaybe<Scalars['timestamptz']['input']>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
  parentId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadId?: InputMaybe<Scalars['bigint']['input']>;
  uploadVersionId?: InputMaybe<Scalars['bigint']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type UploadComments_Sum_Fields = {
  __typename?: 'uploadComments_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  parentId?: Maybe<Scalars['bigint']['output']>;
  uploadId?: Maybe<Scalars['bigint']['output']>;
  uploadVersionId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "uploadComments" */
export type UploadComments_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  uploadId?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "uploadComments" */
export enum UploadComments_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  IsDone = 'isDone',
  /** column name */
  OrganisationId = 'organisationId'
}

export type UploadComments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UploadComments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UploadComments_Set_Input>;
  /** filter the rows which have to be updated */
  where: UploadComments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type UploadComments_Var_Pop_Fields = {
  __typename?: 'uploadComments_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uploadComments" */
export type UploadComments_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  uploadId?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type UploadComments_Var_Samp_Fields = {
  __typename?: 'uploadComments_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uploadComments" */
export type UploadComments_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  uploadId?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type UploadComments_Variance_Fields = {
  __typename?: 'uploadComments_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  parentId?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['Float']['output']>;
  uploadVersionId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uploadComments" */
export type UploadComments_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  uploadId?: InputMaybe<Order_By>;
  uploadVersionId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "uploadVersions" */
export type UploadVersions = {
  __typename?: 'uploadVersions';
  /** An array relationship */
  comments: Array<UploadComments>;
  /** An aggregate relationship */
  comments_aggregate: UploadComments_Aggregate;
  /** A computed field, executes function "uploadVersions_downloadUrl" */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  file: Files;
  fileId: Scalars['bigint']['output'];
  id: Scalars['bigint']['output'];
  /** An array relationship */
  jaggaerSubmissions: Array<JaggaerSubmissions>;
  /** An aggregate relationship */
  jaggaerSubmissions_aggregate: JaggaerSubmissions_Aggregate;
  /** An object relationship */
  upload: Uploads;
  uploadId: Scalars['bigint']['output'];
};


/** columns and relationships of "uploadVersions" */
export type UploadVersionsCommentsArgs = {
  distinct_on?: InputMaybe<Array<UploadComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UploadComments_Order_By>>;
  where?: InputMaybe<UploadComments_Bool_Exp>;
};


/** columns and relationships of "uploadVersions" */
export type UploadVersionsComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UploadComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UploadComments_Order_By>>;
  where?: InputMaybe<UploadComments_Bool_Exp>;
};


/** columns and relationships of "uploadVersions" */
export type UploadVersionsJaggaerSubmissionsArgs = {
  distinct_on?: InputMaybe<Array<JaggaerSubmissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<JaggaerSubmissions_Order_By>>;
  where?: InputMaybe<JaggaerSubmissions_Bool_Exp>;
};


/** columns and relationships of "uploadVersions" */
export type UploadVersionsJaggaerSubmissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<JaggaerSubmissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<JaggaerSubmissions_Order_By>>;
  where?: InputMaybe<JaggaerSubmissions_Bool_Exp>;
};

/** aggregated selection of "uploadVersions" */
export type UploadVersions_Aggregate = {
  __typename?: 'uploadVersions_aggregate';
  aggregate?: Maybe<UploadVersions_Aggregate_Fields>;
  nodes: Array<UploadVersions>;
};

export type UploadVersions_Aggregate_Bool_Exp = {
  count?: InputMaybe<UploadVersions_Aggregate_Bool_Exp_Count>;
};

export type UploadVersions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<UploadVersions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UploadVersions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uploadVersions" */
export type UploadVersions_Aggregate_Fields = {
  __typename?: 'uploadVersions_aggregate_fields';
  avg?: Maybe<UploadVersions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<UploadVersions_Max_Fields>;
  min?: Maybe<UploadVersions_Min_Fields>;
  stddev?: Maybe<UploadVersions_Stddev_Fields>;
  stddev_pop?: Maybe<UploadVersions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UploadVersions_Stddev_Samp_Fields>;
  sum?: Maybe<UploadVersions_Sum_Fields>;
  var_pop?: Maybe<UploadVersions_Var_Pop_Fields>;
  var_samp?: Maybe<UploadVersions_Var_Samp_Fields>;
  variance?: Maybe<UploadVersions_Variance_Fields>;
};


/** aggregate fields of "uploadVersions" */
export type UploadVersions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UploadVersions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uploadVersions" */
export type UploadVersions_Aggregate_Order_By = {
  avg?: InputMaybe<UploadVersions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UploadVersions_Max_Order_By>;
  min?: InputMaybe<UploadVersions_Min_Order_By>;
  stddev?: InputMaybe<UploadVersions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UploadVersions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UploadVersions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UploadVersions_Sum_Order_By>;
  var_pop?: InputMaybe<UploadVersions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UploadVersions_Var_Samp_Order_By>;
  variance?: InputMaybe<UploadVersions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uploadVersions" */
export type UploadVersions_Arr_Rel_Insert_Input = {
  data: Array<UploadVersions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UploadVersions_On_Conflict>;
};

/** aggregate avg on columns */
export type UploadVersions_Avg_Fields = {
  __typename?: 'uploadVersions_avg_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uploadVersions" */
export type UploadVersions_Avg_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uploadId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uploadVersions". All fields are combined with a logical 'AND'. */
export type UploadVersions_Bool_Exp = {
  _and?: InputMaybe<Array<UploadVersions_Bool_Exp>>;
  _not?: InputMaybe<UploadVersions_Bool_Exp>;
  _or?: InputMaybe<Array<UploadVersions_Bool_Exp>>;
  comments?: InputMaybe<UploadComments_Bool_Exp>;
  comments_aggregate?: InputMaybe<UploadComments_Aggregate_Bool_Exp>;
  downloadUrl?: InputMaybe<String_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  fileId?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  jaggaerSubmissions?: InputMaybe<JaggaerSubmissions_Bool_Exp>;
  jaggaerSubmissions_aggregate?: InputMaybe<JaggaerSubmissions_Aggregate_Bool_Exp>;
  upload?: InputMaybe<Uploads_Bool_Exp>;
  uploadId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "uploadVersions" */
export enum UploadVersions_Constraint {
  /** unique or primary key constraint on columns "id" */
  UploadVersionsPkey = 'uploadVersions_pkey'
}

/** input type for inserting data into table "uploadVersions" */
export type UploadVersions_Insert_Input = {
  comments?: InputMaybe<UploadComments_Arr_Rel_Insert_Input>;
  fileId?: InputMaybe<Scalars['bigint']['input']>;
  jaggaerSubmissions?: InputMaybe<JaggaerSubmissions_Arr_Rel_Insert_Input>;
  upload?: InputMaybe<Uploads_Obj_Rel_Insert_Input>;
  uploadId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type UploadVersions_Max_Fields = {
  __typename?: 'uploadVersions_max_fields';
  /** A computed field, executes function "uploadVersions_downloadUrl" */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  uploadId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "uploadVersions" */
export type UploadVersions_Max_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uploadId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UploadVersions_Min_Fields = {
  __typename?: 'uploadVersions_min_fields';
  /** A computed field, executes function "uploadVersions_downloadUrl" */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  uploadId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "uploadVersions" */
export type UploadVersions_Min_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uploadId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uploadVersions" */
export type UploadVersions_Mutation_Response = {
  __typename?: 'uploadVersions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UploadVersions>;
};

/** input type for inserting object relation for remote table "uploadVersions" */
export type UploadVersions_Obj_Rel_Insert_Input = {
  data: UploadVersions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<UploadVersions_On_Conflict>;
};

/** on_conflict condition type for table "uploadVersions" */
export type UploadVersions_On_Conflict = {
  constraint: UploadVersions_Constraint;
  update_columns?: Array<UploadVersions_Update_Column>;
  where?: InputMaybe<UploadVersions_Bool_Exp>;
};

/** Ordering options when selecting data from "uploadVersions". */
export type UploadVersions_Order_By = {
  comments_aggregate?: InputMaybe<UploadComments_Aggregate_Order_By>;
  downloadUrl?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jaggaerSubmissions_aggregate?: InputMaybe<JaggaerSubmissions_Aggregate_Order_By>;
  upload?: InputMaybe<Uploads_Order_By>;
  uploadId?: InputMaybe<Order_By>;
};

/** select columns of table "uploadVersions" */
export enum UploadVersions_Select_Column {
  /** column name */
  FileId = 'fileId',
  /** column name */
  Id = 'id',
  /** column name */
  UploadId = 'uploadId'
}

/** aggregate stddev on columns */
export type UploadVersions_Stddev_Fields = {
  __typename?: 'uploadVersions_stddev_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uploadVersions" */
export type UploadVersions_Stddev_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uploadId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type UploadVersions_Stddev_Pop_Fields = {
  __typename?: 'uploadVersions_stddev_pop_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uploadVersions" */
export type UploadVersions_Stddev_Pop_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uploadId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type UploadVersions_Stddev_Samp_Fields = {
  __typename?: 'uploadVersions_stddev_samp_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uploadVersions" */
export type UploadVersions_Stddev_Samp_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uploadId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uploadVersions" */
export type UploadVersions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UploadVersions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UploadVersions_Stream_Cursor_Value_Input = {
  fileId?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  uploadId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type UploadVersions_Sum_Fields = {
  __typename?: 'uploadVersions_sum_fields';
  fileId?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  uploadId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "uploadVersions" */
export type UploadVersions_Sum_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uploadId?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "uploadVersions" (current role has no relevant permissions) */
export enum UploadVersions_Update_Column {
  /** placeholder (do not use) */
  PLACEHOLDER = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type UploadVersions_Var_Pop_Fields = {
  __typename?: 'uploadVersions_var_pop_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uploadVersions" */
export type UploadVersions_Var_Pop_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uploadId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type UploadVersions_Var_Samp_Fields = {
  __typename?: 'uploadVersions_var_samp_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uploadVersions" */
export type UploadVersions_Var_Samp_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uploadId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type UploadVersions_Variance_Fields = {
  __typename?: 'uploadVersions_variance_fields';
  fileId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uploadVersions" */
export type UploadVersions_Variance_Order_By = {
  fileId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  uploadId?: InputMaybe<Order_By>;
};

/** columns and relationships of "uploads" */
export type Uploads = {
  __typename?: 'uploads';
  /** An array relationship */
  comments: Array<UploadComments>;
  /** An aggregate relationship */
  comments_aggregate: UploadComments_Aggregate;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['bigint']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  serviceModule: ServiceModules;
  serviceModuleId: Scalars['bigint']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  uploadVersions: Array<UploadVersions>;
  /** An aggregate relationship */
  uploadVersions_aggregate: UploadVersions_Aggregate;
};


/** columns and relationships of "uploads" */
export type UploadsCommentsArgs = {
  distinct_on?: InputMaybe<Array<UploadComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UploadComments_Order_By>>;
  where?: InputMaybe<UploadComments_Bool_Exp>;
};


/** columns and relationships of "uploads" */
export type UploadsComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UploadComments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UploadComments_Order_By>>;
  where?: InputMaybe<UploadComments_Bool_Exp>;
};


/** columns and relationships of "uploads" */
export type UploadsUploadVersionsArgs = {
  distinct_on?: InputMaybe<Array<UploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UploadVersions_Order_By>>;
  where?: InputMaybe<UploadVersions_Bool_Exp>;
};


/** columns and relationships of "uploads" */
export type UploadsUploadVersions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UploadVersions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UploadVersions_Order_By>>;
  where?: InputMaybe<UploadVersions_Bool_Exp>;
};

/** aggregated selection of "uploads" */
export type Uploads_Aggregate = {
  __typename?: 'uploads_aggregate';
  aggregate?: Maybe<Uploads_Aggregate_Fields>;
  nodes: Array<Uploads>;
};

export type Uploads_Aggregate_Bool_Exp = {
  count?: InputMaybe<Uploads_Aggregate_Bool_Exp_Count>;
};

export type Uploads_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Uploads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Uploads_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "uploads" */
export type Uploads_Aggregate_Fields = {
  __typename?: 'uploads_aggregate_fields';
  avg?: Maybe<Uploads_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Uploads_Max_Fields>;
  min?: Maybe<Uploads_Min_Fields>;
  stddev?: Maybe<Uploads_Stddev_Fields>;
  stddev_pop?: Maybe<Uploads_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Uploads_Stddev_Samp_Fields>;
  sum?: Maybe<Uploads_Sum_Fields>;
  var_pop?: Maybe<Uploads_Var_Pop_Fields>;
  var_samp?: Maybe<Uploads_Var_Samp_Fields>;
  variance?: Maybe<Uploads_Variance_Fields>;
};


/** aggregate fields of "uploads" */
export type Uploads_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Uploads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "uploads" */
export type Uploads_Aggregate_Order_By = {
  avg?: InputMaybe<Uploads_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Uploads_Max_Order_By>;
  min?: InputMaybe<Uploads_Min_Order_By>;
  stddev?: InputMaybe<Uploads_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Uploads_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Uploads_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Uploads_Sum_Order_By>;
  var_pop?: InputMaybe<Uploads_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Uploads_Var_Samp_Order_By>;
  variance?: InputMaybe<Uploads_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "uploads" */
export type Uploads_Arr_Rel_Insert_Input = {
  data: Array<Uploads_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Uploads_On_Conflict>;
};

/** aggregate avg on columns */
export type Uploads_Avg_Fields = {
  __typename?: 'uploads_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "uploads" */
export type Uploads_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "uploads". All fields are combined with a logical 'AND'. */
export type Uploads_Bool_Exp = {
  _and?: InputMaybe<Array<Uploads_Bool_Exp>>;
  _not?: InputMaybe<Uploads_Bool_Exp>;
  _or?: InputMaybe<Array<Uploads_Bool_Exp>>;
  comments?: InputMaybe<UploadComments_Bool_Exp>;
  comments_aggregate?: InputMaybe<UploadComments_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  serviceModule?: InputMaybe<ServiceModules_Bool_Exp>;
  serviceModuleId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploadVersions?: InputMaybe<UploadVersions_Bool_Exp>;
  uploadVersions_aggregate?: InputMaybe<UploadVersions_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "uploads" */
export enum Uploads_Constraint {
  /** unique or primary key constraint on columns "id" */
  UploadsPkey = 'uploads_pkey'
}

/** input type for inserting data into table "uploads" */
export type Uploads_Insert_Input = {
  comments?: InputMaybe<UploadComments_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
  serviceModule?: InputMaybe<ServiceModules_Obj_Rel_Insert_Input>;
  serviceModuleId?: InputMaybe<Scalars['bigint']['input']>;
  uploadVersions?: InputMaybe<UploadVersions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Uploads_Max_Fields = {
  __typename?: 'uploads_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "uploads" */
export type Uploads_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Uploads_Min_Fields = {
  __typename?: 'uploads_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "uploads" */
export type Uploads_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "uploads" */
export type Uploads_Mutation_Response = {
  __typename?: 'uploads_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Uploads>;
};

/** input type for inserting object relation for remote table "uploads" */
export type Uploads_Obj_Rel_Insert_Input = {
  data: Uploads_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Uploads_On_Conflict>;
};

/** on_conflict condition type for table "uploads" */
export type Uploads_On_Conflict = {
  constraint: Uploads_Constraint;
  update_columns?: Array<Uploads_Update_Column>;
  where?: InputMaybe<Uploads_Bool_Exp>;
};

/** Ordering options when selecting data from "uploads". */
export type Uploads_Order_By = {
  comments_aggregate?: InputMaybe<UploadComments_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  serviceModule?: InputMaybe<ServiceModules_Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadVersions_aggregate?: InputMaybe<UploadVersions_Aggregate_Order_By>;
};

/** primary key columns input for table: uploads */
export type Uploads_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "uploads" */
export enum Uploads_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ServiceModuleId = 'serviceModuleId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "uploads" */
export type Uploads_Set_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Uploads_Stddev_Fields = {
  __typename?: 'uploads_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "uploads" */
export type Uploads_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Uploads_Stddev_Pop_Fields = {
  __typename?: 'uploads_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "uploads" */
export type Uploads_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Uploads_Stddev_Samp_Fields = {
  __typename?: 'uploads_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "uploads" */
export type Uploads_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "uploads" */
export type Uploads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Uploads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Uploads_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serviceModuleId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Uploads_Sum_Fields = {
  __typename?: 'uploads_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "uploads" */
export type Uploads_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** update columns of table "uploads" */
export enum Uploads_Update_Column {
  /** column name */
  Name = 'name'
}

export type Uploads_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Uploads_Set_Input>;
  /** filter the rows which have to be updated */
  where: Uploads_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Uploads_Var_Pop_Fields = {
  __typename?: 'uploads_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "uploads" */
export type Uploads_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Uploads_Var_Samp_Fields = {
  __typename?: 'uploads_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "uploads" */
export type Uploads_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Uploads_Variance_Fields = {
  __typename?: 'uploads_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "uploads" */
export type Uploads_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
};

/** columns and relationships of "userAttributeValues" */
export type UserAttributeValues = {
  __typename?: 'userAttributeValues';
  createdAt: Scalars['timestamptz']['output'];
  imported: Scalars['Boolean']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  /** An object relationship */
  userAttribute: UserAttributes;
  userAttributeId: Scalars['bigint']['output'];
  userId: Scalars['bigint']['output'];
  value: Scalars['json']['output'];
};


/** columns and relationships of "userAttributeValues" */
export type UserAttributeValuesValueArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "userAttributeValues" */
export type UserAttributeValues_Aggregate = {
  __typename?: 'userAttributeValues_aggregate';
  aggregate?: Maybe<UserAttributeValues_Aggregate_Fields>;
  nodes: Array<UserAttributeValues>;
};

export type UserAttributeValues_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<UserAttributeValues_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<UserAttributeValues_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<UserAttributeValues_Aggregate_Bool_Exp_Count>;
};

export type UserAttributeValues_Aggregate_Bool_Exp_Bool_And = {
  arguments: UserAttributeValues_Select_Column_UserAttributeValues_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UserAttributeValues_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type UserAttributeValues_Aggregate_Bool_Exp_Bool_Or = {
  arguments: UserAttributeValues_Select_Column_UserAttributeValues_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UserAttributeValues_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type UserAttributeValues_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<UserAttributeValues_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UserAttributeValues_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "userAttributeValues" */
export type UserAttributeValues_Aggregate_Fields = {
  __typename?: 'userAttributeValues_aggregate_fields';
  avg?: Maybe<UserAttributeValues_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<UserAttributeValues_Max_Fields>;
  min?: Maybe<UserAttributeValues_Min_Fields>;
  stddev?: Maybe<UserAttributeValues_Stddev_Fields>;
  stddev_pop?: Maybe<UserAttributeValues_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UserAttributeValues_Stddev_Samp_Fields>;
  sum?: Maybe<UserAttributeValues_Sum_Fields>;
  var_pop?: Maybe<UserAttributeValues_Var_Pop_Fields>;
  var_samp?: Maybe<UserAttributeValues_Var_Samp_Fields>;
  variance?: Maybe<UserAttributeValues_Variance_Fields>;
};


/** aggregate fields of "userAttributeValues" */
export type UserAttributeValues_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserAttributeValues_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "userAttributeValues" */
export type UserAttributeValues_Aggregate_Order_By = {
  avg?: InputMaybe<UserAttributeValues_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserAttributeValues_Max_Order_By>;
  min?: InputMaybe<UserAttributeValues_Min_Order_By>;
  stddev?: InputMaybe<UserAttributeValues_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UserAttributeValues_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UserAttributeValues_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UserAttributeValues_Sum_Order_By>;
  var_pop?: InputMaybe<UserAttributeValues_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UserAttributeValues_Var_Samp_Order_By>;
  variance?: InputMaybe<UserAttributeValues_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "userAttributeValues" */
export type UserAttributeValues_Arr_Rel_Insert_Input = {
  data: Array<UserAttributeValues_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserAttributeValues_On_Conflict>;
};

/** aggregate avg on columns */
export type UserAttributeValues_Avg_Fields = {
  __typename?: 'userAttributeValues_avg_fields';
  userAttributeId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "userAttributeValues" */
export type UserAttributeValues_Avg_Order_By = {
  userAttributeId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "userAttributeValues". All fields are combined with a logical 'AND'. */
export type UserAttributeValues_Bool_Exp = {
  _and?: InputMaybe<Array<UserAttributeValues_Bool_Exp>>;
  _not?: InputMaybe<UserAttributeValues_Bool_Exp>;
  _or?: InputMaybe<Array<UserAttributeValues_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  imported?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userAttribute?: InputMaybe<UserAttributes_Bool_Exp>;
  userAttributeId?: InputMaybe<Bigint_Comparison_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
  value?: InputMaybe<Json_Comparison_Exp>;
};

/** unique or primary key constraints on table "userAttributeValues" */
export enum UserAttributeValues_Constraint {
  /** unique or primary key constraint on columns "userId", "userAttributeId" */
  UserAttributeValuesPkey = 'userAttributeValues_pkey'
}

/** input type for inserting data into table "userAttributeValues" */
export type UserAttributeValues_Insert_Input = {
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userAttribute?: InputMaybe<UserAttributes_Obj_Rel_Insert_Input>;
  userAttributeId?: InputMaybe<Scalars['bigint']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['json']['input']>;
};

/** aggregate max on columns */
export type UserAttributeValues_Max_Fields = {
  __typename?: 'userAttributeValues_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userAttributeId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "userAttributeValues" */
export type UserAttributeValues_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userAttributeId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UserAttributeValues_Min_Fields = {
  __typename?: 'userAttributeValues_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userAttributeId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "userAttributeValues" */
export type UserAttributeValues_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userAttributeId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "userAttributeValues" */
export type UserAttributeValues_Mutation_Response = {
  __typename?: 'userAttributeValues_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserAttributeValues>;
};

/** on_conflict condition type for table "userAttributeValues" */
export type UserAttributeValues_On_Conflict = {
  constraint: UserAttributeValues_Constraint;
  update_columns?: Array<UserAttributeValues_Update_Column>;
  where?: InputMaybe<UserAttributeValues_Bool_Exp>;
};

/** Ordering options when selecting data from "userAttributeValues". */
export type UserAttributeValues_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  imported?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userAttribute?: InputMaybe<UserAttributes_Order_By>;
  userAttributeId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: userAttributeValues */
export type UserAttributeValues_Pk_Columns_Input = {
  userAttributeId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};

/** select columns of table "userAttributeValues" */
export enum UserAttributeValues_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Imported = 'imported',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserAttributeId = 'userAttributeId',
  /** column name */
  UserId = 'userId',
  /** column name */
  Value = 'value'
}

/** select "userAttributeValues_aggregate_bool_exp_bool_and_arguments_columns" columns of table "userAttributeValues" */
export enum UserAttributeValues_Select_Column_UserAttributeValues_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Imported = 'imported'
}

/** select "userAttributeValues_aggregate_bool_exp_bool_or_arguments_columns" columns of table "userAttributeValues" */
export enum UserAttributeValues_Select_Column_UserAttributeValues_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Imported = 'imported'
}

/** input type for updating data in table "userAttributeValues" */
export type UserAttributeValues_Set_Input = {
  value?: InputMaybe<Scalars['json']['input']>;
};

/** aggregate stddev on columns */
export type UserAttributeValues_Stddev_Fields = {
  __typename?: 'userAttributeValues_stddev_fields';
  userAttributeId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "userAttributeValues" */
export type UserAttributeValues_Stddev_Order_By = {
  userAttributeId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type UserAttributeValues_Stddev_Pop_Fields = {
  __typename?: 'userAttributeValues_stddev_pop_fields';
  userAttributeId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "userAttributeValues" */
export type UserAttributeValues_Stddev_Pop_Order_By = {
  userAttributeId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type UserAttributeValues_Stddev_Samp_Fields = {
  __typename?: 'userAttributeValues_stddev_samp_fields';
  userAttributeId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "userAttributeValues" */
export type UserAttributeValues_Stddev_Samp_Order_By = {
  userAttributeId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "userAttributeValues" */
export type UserAttributeValues_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserAttributeValues_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserAttributeValues_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  imported?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userAttributeId?: InputMaybe<Scalars['bigint']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
  value?: InputMaybe<Scalars['json']['input']>;
};

/** aggregate sum on columns */
export type UserAttributeValues_Sum_Fields = {
  __typename?: 'userAttributeValues_sum_fields';
  userAttributeId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "userAttributeValues" */
export type UserAttributeValues_Sum_Order_By = {
  userAttributeId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "userAttributeValues" */
export enum UserAttributeValues_Update_Column {
  /** column name */
  Value = 'value'
}

export type UserAttributeValues_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserAttributeValues_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserAttributeValues_Bool_Exp;
};

/** aggregate var_pop on columns */
export type UserAttributeValues_Var_Pop_Fields = {
  __typename?: 'userAttributeValues_var_pop_fields';
  userAttributeId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "userAttributeValues" */
export type UserAttributeValues_Var_Pop_Order_By = {
  userAttributeId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type UserAttributeValues_Var_Samp_Fields = {
  __typename?: 'userAttributeValues_var_samp_fields';
  userAttributeId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "userAttributeValues" */
export type UserAttributeValues_Var_Samp_Order_By = {
  userAttributeId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type UserAttributeValues_Variance_Fields = {
  __typename?: 'userAttributeValues_variance_fields';
  userAttributeId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "userAttributeValues" */
export type UserAttributeValues_Variance_Order_By = {
  userAttributeId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "userAttributes" */
export type UserAttributes = {
  __typename?: 'userAttributes';
  id: Scalars['bigint']['output'];
  isVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  userAttributeValues: Array<UserAttributeValues>;
  /** An aggregate relationship */
  userAttributeValues_aggregate: UserAttributeValues_Aggregate;
};


/** columns and relationships of "userAttributes" */
export type UserAttributesUserAttributeValuesArgs = {
  distinct_on?: InputMaybe<Array<UserAttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserAttributeValues_Order_By>>;
  where?: InputMaybe<UserAttributeValues_Bool_Exp>;
};


/** columns and relationships of "userAttributes" */
export type UserAttributesUserAttributeValues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserAttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserAttributeValues_Order_By>>;
  where?: InputMaybe<UserAttributeValues_Bool_Exp>;
};

/** aggregated selection of "userAttributes" */
export type UserAttributes_Aggregate = {
  __typename?: 'userAttributes_aggregate';
  aggregate?: Maybe<UserAttributes_Aggregate_Fields>;
  nodes: Array<UserAttributes>;
};

/** aggregate fields of "userAttributes" */
export type UserAttributes_Aggregate_Fields = {
  __typename?: 'userAttributes_aggregate_fields';
  avg?: Maybe<UserAttributes_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<UserAttributes_Max_Fields>;
  min?: Maybe<UserAttributes_Min_Fields>;
  stddev?: Maybe<UserAttributes_Stddev_Fields>;
  stddev_pop?: Maybe<UserAttributes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UserAttributes_Stddev_Samp_Fields>;
  sum?: Maybe<UserAttributes_Sum_Fields>;
  var_pop?: Maybe<UserAttributes_Var_Pop_Fields>;
  var_samp?: Maybe<UserAttributes_Var_Samp_Fields>;
  variance?: Maybe<UserAttributes_Variance_Fields>;
};


/** aggregate fields of "userAttributes" */
export type UserAttributes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserAttributes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type UserAttributes_Avg_Fields = {
  __typename?: 'userAttributes_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "userAttributes". All fields are combined with a logical 'AND'. */
export type UserAttributes_Bool_Exp = {
  _and?: InputMaybe<Array<UserAttributes_Bool_Exp>>;
  _not?: InputMaybe<UserAttributes_Bool_Exp>;
  _or?: InputMaybe<Array<UserAttributes_Bool_Exp>>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  isVisible?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  userAttributeValues?: InputMaybe<UserAttributeValues_Bool_Exp>;
  userAttributeValues_aggregate?: InputMaybe<UserAttributeValues_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "userAttributes" */
export enum UserAttributes_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserAttributesPkey = 'userAttributes_pkey',
  /** unique or primary key constraint on columns "slug" */
  UserAttributesSlugKey = 'userAttributes_slug_key'
}

/** input type for inserting data into table "userAttributes" */
export type UserAttributes_Insert_Input = {
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  userAttributeValues?: InputMaybe<UserAttributeValues_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type UserAttributes_Max_Fields = {
  __typename?: 'userAttributes_max_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type UserAttributes_Min_Fields = {
  __typename?: 'userAttributes_min_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "userAttributes" */
export type UserAttributes_Mutation_Response = {
  __typename?: 'userAttributes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserAttributes>;
};

/** input type for inserting object relation for remote table "userAttributes" */
export type UserAttributes_Obj_Rel_Insert_Input = {
  data: UserAttributes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<UserAttributes_On_Conflict>;
};

/** on_conflict condition type for table "userAttributes" */
export type UserAttributes_On_Conflict = {
  constraint: UserAttributes_Constraint;
  update_columns?: Array<UserAttributes_Update_Column>;
  where?: InputMaybe<UserAttributes_Bool_Exp>;
};

/** Ordering options when selecting data from "userAttributes". */
export type UserAttributes_Order_By = {
  id?: InputMaybe<Order_By>;
  isVisible?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  userAttributeValues_aggregate?: InputMaybe<UserAttributeValues_Aggregate_Order_By>;
};

/** primary key columns input for table: userAttributes */
export type UserAttributes_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "userAttributes" */
export enum UserAttributes_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  IsVisible = 'isVisible',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug'
}

/** input type for updating data in table "userAttributes" */
export type UserAttributes_Set_Input = {
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type UserAttributes_Stddev_Fields = {
  __typename?: 'userAttributes_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type UserAttributes_Stddev_Pop_Fields = {
  __typename?: 'userAttributes_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type UserAttributes_Stddev_Samp_Fields = {
  __typename?: 'userAttributes_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "userAttributes" */
export type UserAttributes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserAttributes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserAttributes_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type UserAttributes_Sum_Fields = {
  __typename?: 'userAttributes_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** update columns of table "userAttributes" */
export enum UserAttributes_Update_Column {
  /** column name */
  IsVisible = 'isVisible',
  /** column name */
  Name = 'name',
  /** column name */
  Slug = 'slug'
}

export type UserAttributes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserAttributes_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserAttributes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type UserAttributes_Var_Pop_Fields = {
  __typename?: 'userAttributes_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type UserAttributes_Var_Samp_Fields = {
  __typename?: 'userAttributes_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type UserAttributes_Variance_Fields = {
  __typename?: 'userAttributes_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "userDataRoomOccurrences" */
export type UserDataRoomOccurrences = {
  __typename?: 'userDataRoomOccurrences';
  data: Scalars['json']['output'];
  /** An object relationship */
  roomOccurrence: RoomOccurrences;
  roomOccurrenceId: Scalars['bigint']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['bigint']['output'];
};


/** columns and relationships of "userDataRoomOccurrences" */
export type UserDataRoomOccurrencesDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "userDataRoomOccurrences" */
export type UserDataRoomOccurrences_Aggregate_Order_By = {
  avg?: InputMaybe<UserDataRoomOccurrences_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserDataRoomOccurrences_Max_Order_By>;
  min?: InputMaybe<UserDataRoomOccurrences_Min_Order_By>;
  stddev?: InputMaybe<UserDataRoomOccurrences_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UserDataRoomOccurrences_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UserDataRoomOccurrences_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UserDataRoomOccurrences_Sum_Order_By>;
  var_pop?: InputMaybe<UserDataRoomOccurrences_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UserDataRoomOccurrences_Var_Samp_Order_By>;
  variance?: InputMaybe<UserDataRoomOccurrences_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "userDataRoomOccurrences" */
export type UserDataRoomOccurrences_Arr_Rel_Insert_Input = {
  data: Array<UserDataRoomOccurrences_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserDataRoomOccurrences_On_Conflict>;
};

/** order by avg() on columns of table "userDataRoomOccurrences" */
export type UserDataRoomOccurrences_Avg_Order_By = {
  roomOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "userDataRoomOccurrences". All fields are combined with a logical 'AND'. */
export type UserDataRoomOccurrences_Bool_Exp = {
  _and?: InputMaybe<Array<UserDataRoomOccurrences_Bool_Exp>>;
  _not?: InputMaybe<UserDataRoomOccurrences_Bool_Exp>;
  _or?: InputMaybe<Array<UserDataRoomOccurrences_Bool_Exp>>;
  data?: InputMaybe<Json_Comparison_Exp>;
  roomOccurrence?: InputMaybe<RoomOccurrences_Bool_Exp>;
  roomOccurrenceId?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "userDataRoomOccurrences" */
export enum UserDataRoomOccurrences_Constraint {
  /** unique or primary key constraint on columns "userId", "roomOccurrenceId" */
  UserDataRoomOccurrencesPkey = 'userDataRoomOccurrences_pkey'
}

/** input type for inserting data into table "userDataRoomOccurrences" */
export type UserDataRoomOccurrences_Insert_Input = {
  data?: InputMaybe<Scalars['json']['input']>;
  roomOccurrence?: InputMaybe<RoomOccurrences_Obj_Rel_Insert_Input>;
  roomOccurrenceId?: InputMaybe<Scalars['bigint']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "userDataRoomOccurrences" */
export type UserDataRoomOccurrences_Max_Order_By = {
  roomOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "userDataRoomOccurrences" */
export type UserDataRoomOccurrences_Min_Order_By = {
  roomOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "userDataRoomOccurrences" */
export type UserDataRoomOccurrences_Mutation_Response = {
  __typename?: 'userDataRoomOccurrences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserDataRoomOccurrences>;
};

/** on_conflict condition type for table "userDataRoomOccurrences" */
export type UserDataRoomOccurrences_On_Conflict = {
  constraint: UserDataRoomOccurrences_Constraint;
  update_columns?: Array<UserDataRoomOccurrences_Update_Column>;
  where?: InputMaybe<UserDataRoomOccurrences_Bool_Exp>;
};

/** Ordering options when selecting data from "userDataRoomOccurrences". */
export type UserDataRoomOccurrences_Order_By = {
  data?: InputMaybe<Order_By>;
  roomOccurrence?: InputMaybe<RoomOccurrences_Order_By>;
  roomOccurrenceId?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: userDataRoomOccurrences */
export type UserDataRoomOccurrences_Pk_Columns_Input = {
  roomOccurrenceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};

/** select columns of table "userDataRoomOccurrences" */
export enum UserDataRoomOccurrences_Select_Column {
  /** column name */
  Data = 'data',
  /** column name */
  RoomOccurrenceId = 'roomOccurrenceId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "userDataRoomOccurrences" */
export type UserDataRoomOccurrences_Set_Input = {
  data?: InputMaybe<Scalars['json']['input']>;
};

/** order by stddev() on columns of table "userDataRoomOccurrences" */
export type UserDataRoomOccurrences_Stddev_Order_By = {
  roomOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "userDataRoomOccurrences" */
export type UserDataRoomOccurrences_Stddev_Pop_Order_By = {
  roomOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "userDataRoomOccurrences" */
export type UserDataRoomOccurrences_Stddev_Samp_Order_By = {
  roomOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "userDataRoomOccurrences" */
export type UserDataRoomOccurrences_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserDataRoomOccurrences_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserDataRoomOccurrences_Stream_Cursor_Value_Input = {
  data?: InputMaybe<Scalars['json']['input']>;
  roomOccurrenceId?: InputMaybe<Scalars['bigint']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** order by sum() on columns of table "userDataRoomOccurrences" */
export type UserDataRoomOccurrences_Sum_Order_By = {
  roomOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "userDataRoomOccurrences" */
export enum UserDataRoomOccurrences_Update_Column {
  /** column name */
  Data = 'data'
}

export type UserDataRoomOccurrences_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserDataRoomOccurrences_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserDataRoomOccurrences_Bool_Exp;
};

/** order by var_pop() on columns of table "userDataRoomOccurrences" */
export type UserDataRoomOccurrences_Var_Pop_Order_By = {
  roomOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "userDataRoomOccurrences" */
export type UserDataRoomOccurrences_Var_Samp_Order_By = {
  roomOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "userDataRoomOccurrences" */
export type UserDataRoomOccurrences_Variance_Order_By = {
  roomOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "userDataRoomServiceOccurrences" */
export type UserDataRoomServiceOccurrences = {
  __typename?: 'userDataRoomServiceOccurrences';
  data: Scalars['json']['output'];
  /** An object relationship */
  roomServiceOccurrence: RoomServiceOccurrences;
  roomServiceOccurrenceId: Scalars['bigint']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['bigint']['output'];
};


/** columns and relationships of "userDataRoomServiceOccurrences" */
export type UserDataRoomServiceOccurrencesDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "userDataRoomServiceOccurrences" */
export type UserDataRoomServiceOccurrences_Aggregate_Order_By = {
  avg?: InputMaybe<UserDataRoomServiceOccurrences_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserDataRoomServiceOccurrences_Max_Order_By>;
  min?: InputMaybe<UserDataRoomServiceOccurrences_Min_Order_By>;
  stddev?: InputMaybe<UserDataRoomServiceOccurrences_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UserDataRoomServiceOccurrences_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UserDataRoomServiceOccurrences_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UserDataRoomServiceOccurrences_Sum_Order_By>;
  var_pop?: InputMaybe<UserDataRoomServiceOccurrences_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UserDataRoomServiceOccurrences_Var_Samp_Order_By>;
  variance?: InputMaybe<UserDataRoomServiceOccurrences_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "userDataRoomServiceOccurrences" */
export type UserDataRoomServiceOccurrences_Arr_Rel_Insert_Input = {
  data: Array<UserDataRoomServiceOccurrences_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserDataRoomServiceOccurrences_On_Conflict>;
};

/** order by avg() on columns of table "userDataRoomServiceOccurrences" */
export type UserDataRoomServiceOccurrences_Avg_Order_By = {
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "userDataRoomServiceOccurrences". All fields are combined with a logical 'AND'. */
export type UserDataRoomServiceOccurrences_Bool_Exp = {
  _and?: InputMaybe<Array<UserDataRoomServiceOccurrences_Bool_Exp>>;
  _not?: InputMaybe<UserDataRoomServiceOccurrences_Bool_Exp>;
  _or?: InputMaybe<Array<UserDataRoomServiceOccurrences_Bool_Exp>>;
  data?: InputMaybe<Json_Comparison_Exp>;
  roomServiceOccurrence?: InputMaybe<RoomServiceOccurrences_Bool_Exp>;
  roomServiceOccurrenceId?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "userDataRoomServiceOccurrences" */
export enum UserDataRoomServiceOccurrences_Constraint {
  /** unique or primary key constraint on columns "userId", "roomServiceOccurrenceId" */
  UserDataRoomServiceOccurrencesPkey = 'userDataRoomServiceOccurrences_pkey'
}

/** input type for inserting data into table "userDataRoomServiceOccurrences" */
export type UserDataRoomServiceOccurrences_Insert_Input = {
  data?: InputMaybe<Scalars['json']['input']>;
  roomServiceOccurrence?: InputMaybe<RoomServiceOccurrences_Obj_Rel_Insert_Input>;
  roomServiceOccurrenceId?: InputMaybe<Scalars['bigint']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "userDataRoomServiceOccurrences" */
export type UserDataRoomServiceOccurrences_Max_Order_By = {
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "userDataRoomServiceOccurrences" */
export type UserDataRoomServiceOccurrences_Min_Order_By = {
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "userDataRoomServiceOccurrences" */
export type UserDataRoomServiceOccurrences_Mutation_Response = {
  __typename?: 'userDataRoomServiceOccurrences_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserDataRoomServiceOccurrences>;
};

/** on_conflict condition type for table "userDataRoomServiceOccurrences" */
export type UserDataRoomServiceOccurrences_On_Conflict = {
  constraint: UserDataRoomServiceOccurrences_Constraint;
  update_columns?: Array<UserDataRoomServiceOccurrences_Update_Column>;
  where?: InputMaybe<UserDataRoomServiceOccurrences_Bool_Exp>;
};

/** Ordering options when selecting data from "userDataRoomServiceOccurrences". */
export type UserDataRoomServiceOccurrences_Order_By = {
  data?: InputMaybe<Order_By>;
  roomServiceOccurrence?: InputMaybe<RoomServiceOccurrences_Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: userDataRoomServiceOccurrences */
export type UserDataRoomServiceOccurrences_Pk_Columns_Input = {
  roomServiceOccurrenceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};

/** select columns of table "userDataRoomServiceOccurrences" */
export enum UserDataRoomServiceOccurrences_Select_Column {
  /** column name */
  Data = 'data',
  /** column name */
  RoomServiceOccurrenceId = 'roomServiceOccurrenceId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "userDataRoomServiceOccurrences" */
export type UserDataRoomServiceOccurrences_Set_Input = {
  data?: InputMaybe<Scalars['json']['input']>;
};

/** order by stddev() on columns of table "userDataRoomServiceOccurrences" */
export type UserDataRoomServiceOccurrences_Stddev_Order_By = {
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "userDataRoomServiceOccurrences" */
export type UserDataRoomServiceOccurrences_Stddev_Pop_Order_By = {
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "userDataRoomServiceOccurrences" */
export type UserDataRoomServiceOccurrences_Stddev_Samp_Order_By = {
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "userDataRoomServiceOccurrences" */
export type UserDataRoomServiceOccurrences_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserDataRoomServiceOccurrences_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserDataRoomServiceOccurrences_Stream_Cursor_Value_Input = {
  data?: InputMaybe<Scalars['json']['input']>;
  roomServiceOccurrenceId?: InputMaybe<Scalars['bigint']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** order by sum() on columns of table "userDataRoomServiceOccurrences" */
export type UserDataRoomServiceOccurrences_Sum_Order_By = {
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "userDataRoomServiceOccurrences" */
export enum UserDataRoomServiceOccurrences_Update_Column {
  /** column name */
  Data = 'data'
}

export type UserDataRoomServiceOccurrences_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserDataRoomServiceOccurrences_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserDataRoomServiceOccurrences_Bool_Exp;
};

/** order by var_pop() on columns of table "userDataRoomServiceOccurrences" */
export type UserDataRoomServiceOccurrences_Var_Pop_Order_By = {
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "userDataRoomServiceOccurrences" */
export type UserDataRoomServiceOccurrences_Var_Samp_Order_By = {
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "userDataRoomServiceOccurrences" */
export type UserDataRoomServiceOccurrences_Variance_Order_By = {
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "userDataServices" */
export type UserDataServices = {
  __typename?: 'userDataServices';
  data: Scalars['json']['output'];
  /** An object relationship */
  service: Services;
  serviceId: Scalars['bigint']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['bigint']['output'];
};


/** columns and relationships of "userDataServices" */
export type UserDataServicesDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "userDataServices" */
export type UserDataServices_Aggregate_Order_By = {
  avg?: InputMaybe<UserDataServices_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserDataServices_Max_Order_By>;
  min?: InputMaybe<UserDataServices_Min_Order_By>;
  stddev?: InputMaybe<UserDataServices_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UserDataServices_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UserDataServices_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UserDataServices_Sum_Order_By>;
  var_pop?: InputMaybe<UserDataServices_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UserDataServices_Var_Samp_Order_By>;
  variance?: InputMaybe<UserDataServices_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "userDataServices" */
export type UserDataServices_Arr_Rel_Insert_Input = {
  data: Array<UserDataServices_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserDataServices_On_Conflict>;
};

/** order by avg() on columns of table "userDataServices" */
export type UserDataServices_Avg_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "userDataServices". All fields are combined with a logical 'AND'. */
export type UserDataServices_Bool_Exp = {
  _and?: InputMaybe<Array<UserDataServices_Bool_Exp>>;
  _not?: InputMaybe<UserDataServices_Bool_Exp>;
  _or?: InputMaybe<Array<UserDataServices_Bool_Exp>>;
  data?: InputMaybe<Json_Comparison_Exp>;
  service?: InputMaybe<Services_Bool_Exp>;
  serviceId?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "userDataServices" */
export enum UserDataServices_Constraint {
  /** unique or primary key constraint on columns "userId", "serviceId" */
  UserDataServicesPkey = 'userDataServices_pkey'
}

/** input type for inserting data into table "userDataServices" */
export type UserDataServices_Insert_Input = {
  data?: InputMaybe<Scalars['json']['input']>;
  service?: InputMaybe<Services_Obj_Rel_Insert_Input>;
  serviceId?: InputMaybe<Scalars['bigint']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "userDataServices" */
export type UserDataServices_Max_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "userDataServices" */
export type UserDataServices_Min_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "userDataServices" */
export type UserDataServices_Mutation_Response = {
  __typename?: 'userDataServices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserDataServices>;
};

/** on_conflict condition type for table "userDataServices" */
export type UserDataServices_On_Conflict = {
  constraint: UserDataServices_Constraint;
  update_columns?: Array<UserDataServices_Update_Column>;
  where?: InputMaybe<UserDataServices_Bool_Exp>;
};

/** Ordering options when selecting data from "userDataServices". */
export type UserDataServices_Order_By = {
  data?: InputMaybe<Order_By>;
  service?: InputMaybe<Services_Order_By>;
  serviceId?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: userDataServices */
export type UserDataServices_Pk_Columns_Input = {
  serviceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};

/** select columns of table "userDataServices" */
export enum UserDataServices_Select_Column {
  /** column name */
  Data = 'data',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "userDataServices" */
export type UserDataServices_Set_Input = {
  data?: InputMaybe<Scalars['json']['input']>;
};

/** order by stddev() on columns of table "userDataServices" */
export type UserDataServices_Stddev_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "userDataServices" */
export type UserDataServices_Stddev_Pop_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "userDataServices" */
export type UserDataServices_Stddev_Samp_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "userDataServices" */
export type UserDataServices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserDataServices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserDataServices_Stream_Cursor_Value_Input = {
  data?: InputMaybe<Scalars['json']['input']>;
  serviceId?: InputMaybe<Scalars['bigint']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** order by sum() on columns of table "userDataServices" */
export type UserDataServices_Sum_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "userDataServices" */
export enum UserDataServices_Update_Column {
  /** column name */
  Data = 'data'
}

export type UserDataServices_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserDataServices_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserDataServices_Bool_Exp;
};

/** order by var_pop() on columns of table "userDataServices" */
export type UserDataServices_Var_Pop_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "userDataServices" */
export type UserDataServices_Var_Samp_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "userDataServices" */
export type UserDataServices_Variance_Order_By = {
  serviceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits = {
  __typename?: 'userRoomServiceOccurrenceLastVisits';
  /** An object relationship */
  roomServiceOccurrence: RoomServiceOccurrences;
  roomServiceOccurrenceId: Scalars['bigint']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userId: Scalars['bigint']['output'];
};

/** aggregated selection of "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits_Aggregate = {
  __typename?: 'userRoomServiceOccurrenceLastVisits_aggregate';
  aggregate?: Maybe<UserRoomServiceOccurrenceLastVisits_Aggregate_Fields>;
  nodes: Array<UserRoomServiceOccurrenceLastVisits>;
};

export type UserRoomServiceOccurrenceLastVisits_Aggregate_Bool_Exp = {
  count?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Aggregate_Bool_Exp_Count>;
};

export type UserRoomServiceOccurrenceLastVisits_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<UserRoomServiceOccurrenceLastVisits_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits_Aggregate_Fields = {
  __typename?: 'userRoomServiceOccurrenceLastVisits_aggregate_fields';
  avg?: Maybe<UserRoomServiceOccurrenceLastVisits_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<UserRoomServiceOccurrenceLastVisits_Max_Fields>;
  min?: Maybe<UserRoomServiceOccurrenceLastVisits_Min_Fields>;
  stddev?: Maybe<UserRoomServiceOccurrenceLastVisits_Stddev_Fields>;
  stddev_pop?: Maybe<UserRoomServiceOccurrenceLastVisits_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UserRoomServiceOccurrenceLastVisits_Stddev_Samp_Fields>;
  sum?: Maybe<UserRoomServiceOccurrenceLastVisits_Sum_Fields>;
  var_pop?: Maybe<UserRoomServiceOccurrenceLastVisits_Var_Pop_Fields>;
  var_samp?: Maybe<UserRoomServiceOccurrenceLastVisits_Var_Samp_Fields>;
  variance?: Maybe<UserRoomServiceOccurrenceLastVisits_Variance_Fields>;
};


/** aggregate fields of "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserRoomServiceOccurrenceLastVisits_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits_Aggregate_Order_By = {
  avg?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Max_Order_By>;
  min?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Min_Order_By>;
  stddev?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Sum_Order_By>;
  var_pop?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Var_Samp_Order_By>;
  variance?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits_Arr_Rel_Insert_Input = {
  data: Array<UserRoomServiceOccurrenceLastVisits_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserRoomServiceOccurrenceLastVisits_On_Conflict>;
};

/** aggregate avg on columns */
export type UserRoomServiceOccurrenceLastVisits_Avg_Fields = {
  __typename?: 'userRoomServiceOccurrenceLastVisits_avg_fields';
  roomServiceOccurrenceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits_Avg_Order_By = {
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "userRoomServiceOccurrenceLastVisits". All fields are combined with a logical 'AND'. */
export type UserRoomServiceOccurrenceLastVisits_Bool_Exp = {
  _and?: InputMaybe<Array<UserRoomServiceOccurrenceLastVisits_Bool_Exp>>;
  _not?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Bool_Exp>;
  _or?: InputMaybe<Array<UserRoomServiceOccurrenceLastVisits_Bool_Exp>>;
  roomServiceOccurrence?: InputMaybe<RoomServiceOccurrences_Bool_Exp>;
  roomServiceOccurrenceId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "userRoomServiceOccurrenceLastVisits" */
export enum UserRoomServiceOccurrenceLastVisits_Constraint {
  /** unique or primary key constraint on columns "userId", "roomServiceOccurrenceId" */
  UserRoomServiceOccurrenceLastVisitsPkey = 'userRoomServiceOccurrenceLastVisits_pkey'
}

/** input type for inserting data into table "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits_Insert_Input = {
  roomServiceOccurrence?: InputMaybe<RoomServiceOccurrences_Obj_Rel_Insert_Input>;
  roomServiceOccurrenceId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type UserRoomServiceOccurrenceLastVisits_Max_Fields = {
  __typename?: 'userRoomServiceOccurrenceLastVisits_max_fields';
  roomServiceOccurrenceId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits_Max_Order_By = {
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UserRoomServiceOccurrenceLastVisits_Min_Fields = {
  __typename?: 'userRoomServiceOccurrenceLastVisits_min_fields';
  roomServiceOccurrenceId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits_Min_Order_By = {
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits_Mutation_Response = {
  __typename?: 'userRoomServiceOccurrenceLastVisits_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserRoomServiceOccurrenceLastVisits>;
};

/** on_conflict condition type for table "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits_On_Conflict = {
  constraint: UserRoomServiceOccurrenceLastVisits_Constraint;
  update_columns?: Array<UserRoomServiceOccurrenceLastVisits_Update_Column>;
  where?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Bool_Exp>;
};

/** Ordering options when selecting data from "userRoomServiceOccurrenceLastVisits". */
export type UserRoomServiceOccurrenceLastVisits_Order_By = {
  roomServiceOccurrence?: InputMaybe<RoomServiceOccurrences_Order_By>;
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: userRoomServiceOccurrenceLastVisits */
export type UserRoomServiceOccurrenceLastVisits_Pk_Columns_Input = {
  roomServiceOccurrenceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};

/** select columns of table "userRoomServiceOccurrenceLastVisits" */
export enum UserRoomServiceOccurrenceLastVisits_Select_Column {
  /** column name */
  RoomServiceOccurrenceId = 'roomServiceOccurrenceId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits_Set_Input = {
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type UserRoomServiceOccurrenceLastVisits_Stddev_Fields = {
  __typename?: 'userRoomServiceOccurrenceLastVisits_stddev_fields';
  roomServiceOccurrenceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits_Stddev_Order_By = {
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type UserRoomServiceOccurrenceLastVisits_Stddev_Pop_Fields = {
  __typename?: 'userRoomServiceOccurrenceLastVisits_stddev_pop_fields';
  roomServiceOccurrenceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits_Stddev_Pop_Order_By = {
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type UserRoomServiceOccurrenceLastVisits_Stddev_Samp_Fields = {
  __typename?: 'userRoomServiceOccurrenceLastVisits_stddev_samp_fields';
  roomServiceOccurrenceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits_Stddev_Samp_Order_By = {
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserRoomServiceOccurrenceLastVisits_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserRoomServiceOccurrenceLastVisits_Stream_Cursor_Value_Input = {
  roomServiceOccurrenceId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type UserRoomServiceOccurrenceLastVisits_Sum_Fields = {
  __typename?: 'userRoomServiceOccurrenceLastVisits_sum_fields';
  roomServiceOccurrenceId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits_Sum_Order_By = {
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "userRoomServiceOccurrenceLastVisits" */
export enum UserRoomServiceOccurrenceLastVisits_Update_Column {
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type UserRoomServiceOccurrenceLastVisits_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserRoomServiceOccurrenceLastVisits_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserRoomServiceOccurrenceLastVisits_Bool_Exp;
};

/** aggregate var_pop on columns */
export type UserRoomServiceOccurrenceLastVisits_Var_Pop_Fields = {
  __typename?: 'userRoomServiceOccurrenceLastVisits_var_pop_fields';
  roomServiceOccurrenceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits_Var_Pop_Order_By = {
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type UserRoomServiceOccurrenceLastVisits_Var_Samp_Fields = {
  __typename?: 'userRoomServiceOccurrenceLastVisits_var_samp_fields';
  roomServiceOccurrenceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits_Var_Samp_Order_By = {
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type UserRoomServiceOccurrenceLastVisits_Variance_Fields = {
  __typename?: 'userRoomServiceOccurrenceLastVisits_variance_fields';
  roomServiceOccurrenceId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "userRoomServiceOccurrenceLastVisits" */
export type UserRoomServiceOccurrenceLastVisits_Variance_Order_By = {
  roomServiceOccurrenceId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits = {
  __typename?: 'userServiceModuleLastVisits';
  /** An object relationship */
  serviceModule: ServiceModules;
  serviceModuleId: Scalars['bigint']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userId: Scalars['bigint']['output'];
};

/** aggregated selection of "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits_Aggregate = {
  __typename?: 'userServiceModuleLastVisits_aggregate';
  aggregate?: Maybe<UserServiceModuleLastVisits_Aggregate_Fields>;
  nodes: Array<UserServiceModuleLastVisits>;
};

export type UserServiceModuleLastVisits_Aggregate_Bool_Exp = {
  count?: InputMaybe<UserServiceModuleLastVisits_Aggregate_Bool_Exp_Count>;
};

export type UserServiceModuleLastVisits_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<UserServiceModuleLastVisits_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UserServiceModuleLastVisits_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits_Aggregate_Fields = {
  __typename?: 'userServiceModuleLastVisits_aggregate_fields';
  avg?: Maybe<UserServiceModuleLastVisits_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<UserServiceModuleLastVisits_Max_Fields>;
  min?: Maybe<UserServiceModuleLastVisits_Min_Fields>;
  stddev?: Maybe<UserServiceModuleLastVisits_Stddev_Fields>;
  stddev_pop?: Maybe<UserServiceModuleLastVisits_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UserServiceModuleLastVisits_Stddev_Samp_Fields>;
  sum?: Maybe<UserServiceModuleLastVisits_Sum_Fields>;
  var_pop?: Maybe<UserServiceModuleLastVisits_Var_Pop_Fields>;
  var_samp?: Maybe<UserServiceModuleLastVisits_Var_Samp_Fields>;
  variance?: Maybe<UserServiceModuleLastVisits_Variance_Fields>;
};


/** aggregate fields of "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserServiceModuleLastVisits_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits_Aggregate_Order_By = {
  avg?: InputMaybe<UserServiceModuleLastVisits_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UserServiceModuleLastVisits_Max_Order_By>;
  min?: InputMaybe<UserServiceModuleLastVisits_Min_Order_By>;
  stddev?: InputMaybe<UserServiceModuleLastVisits_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UserServiceModuleLastVisits_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UserServiceModuleLastVisits_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UserServiceModuleLastVisits_Sum_Order_By>;
  var_pop?: InputMaybe<UserServiceModuleLastVisits_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UserServiceModuleLastVisits_Var_Samp_Order_By>;
  variance?: InputMaybe<UserServiceModuleLastVisits_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits_Arr_Rel_Insert_Input = {
  data: Array<UserServiceModuleLastVisits_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserServiceModuleLastVisits_On_Conflict>;
};

/** aggregate avg on columns */
export type UserServiceModuleLastVisits_Avg_Fields = {
  __typename?: 'userServiceModuleLastVisits_avg_fields';
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits_Avg_Order_By = {
  serviceModuleId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "userServiceModuleLastVisits". All fields are combined with a logical 'AND'. */
export type UserServiceModuleLastVisits_Bool_Exp = {
  _and?: InputMaybe<Array<UserServiceModuleLastVisits_Bool_Exp>>;
  _not?: InputMaybe<UserServiceModuleLastVisits_Bool_Exp>;
  _or?: InputMaybe<Array<UserServiceModuleLastVisits_Bool_Exp>>;
  serviceModule?: InputMaybe<ServiceModules_Bool_Exp>;
  serviceModuleId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userId?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "userServiceModuleLastVisits" */
export enum UserServiceModuleLastVisits_Constraint {
  /** unique or primary key constraint on columns "userId", "serviceModuleId" */
  UserServiceModuleLastVisitsPkey = 'userServiceModuleLastVisits_pkey'
}

/** input type for inserting data into table "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits_Insert_Input = {
  serviceModule?: InputMaybe<ServiceModules_Obj_Rel_Insert_Input>;
  serviceModuleId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type UserServiceModuleLastVisits_Max_Fields = {
  __typename?: 'userServiceModuleLastVisits_max_fields';
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits_Max_Order_By = {
  serviceModuleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UserServiceModuleLastVisits_Min_Fields = {
  __typename?: 'userServiceModuleLastVisits_min_fields';
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits_Min_Order_By = {
  serviceModuleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits_Mutation_Response = {
  __typename?: 'userServiceModuleLastVisits_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserServiceModuleLastVisits>;
};

/** on_conflict condition type for table "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits_On_Conflict = {
  constraint: UserServiceModuleLastVisits_Constraint;
  update_columns?: Array<UserServiceModuleLastVisits_Update_Column>;
  where?: InputMaybe<UserServiceModuleLastVisits_Bool_Exp>;
};

/** Ordering options when selecting data from "userServiceModuleLastVisits". */
export type UserServiceModuleLastVisits_Order_By = {
  serviceModule?: InputMaybe<ServiceModules_Order_By>;
  serviceModuleId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: userServiceModuleLastVisits */
export type UserServiceModuleLastVisits_Pk_Columns_Input = {
  serviceModuleId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
};

/** select columns of table "userServiceModuleLastVisits" */
export enum UserServiceModuleLastVisits_Select_Column {
  /** column name */
  ServiceModuleId = 'serviceModuleId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits_Set_Input = {
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type UserServiceModuleLastVisits_Stddev_Fields = {
  __typename?: 'userServiceModuleLastVisits_stddev_fields';
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits_Stddev_Order_By = {
  serviceModuleId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type UserServiceModuleLastVisits_Stddev_Pop_Fields = {
  __typename?: 'userServiceModuleLastVisits_stddev_pop_fields';
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits_Stddev_Pop_Order_By = {
  serviceModuleId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type UserServiceModuleLastVisits_Stddev_Samp_Fields = {
  __typename?: 'userServiceModuleLastVisits_stddev_samp_fields';
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits_Stddev_Samp_Order_By = {
  serviceModuleId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserServiceModuleLastVisits_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserServiceModuleLastVisits_Stream_Cursor_Value_Input = {
  serviceModuleId?: InputMaybe<Scalars['bigint']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type UserServiceModuleLastVisits_Sum_Fields = {
  __typename?: 'userServiceModuleLastVisits_sum_fields';
  serviceModuleId?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits_Sum_Order_By = {
  serviceModuleId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** update columns of table "userServiceModuleLastVisits" */
export enum UserServiceModuleLastVisits_Update_Column {
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type UserServiceModuleLastVisits_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserServiceModuleLastVisits_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserServiceModuleLastVisits_Bool_Exp;
};

/** aggregate var_pop on columns */
export type UserServiceModuleLastVisits_Var_Pop_Fields = {
  __typename?: 'userServiceModuleLastVisits_var_pop_fields';
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits_Var_Pop_Order_By = {
  serviceModuleId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type UserServiceModuleLastVisits_Var_Samp_Fields = {
  __typename?: 'userServiceModuleLastVisits_var_samp_fields';
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits_Var_Samp_Order_By = {
  serviceModuleId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type UserServiceModuleLastVisits_Variance_Fields = {
  __typename?: 'userServiceModuleLastVisits_variance_fields';
  serviceModuleId?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "userServiceModuleLastVisits" */
export type UserServiceModuleLastVisits_Variance_Order_By = {
  serviceModuleId?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** columns and relationships of "userSettings" */
export type UserSettings = {
  __typename?: 'userSettings';
  agreementVersion?: Maybe<Scalars['bigint']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  mailNotificationCadence?: Maybe<Scalars['String']['output']>;
  notificationForOrganisation?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  wantRoomOccurrenceNotifications?: Maybe<Scalars['Boolean']['output']>;
};

/** Boolean expression to filter rows from the table "userSettings". All fields are combined with a logical 'AND'. */
export type UserSettings_Bool_Exp = {
  _and?: InputMaybe<Array<UserSettings_Bool_Exp>>;
  _not?: InputMaybe<UserSettings_Bool_Exp>;
  _or?: InputMaybe<Array<UserSettings_Bool_Exp>>;
  agreementVersion?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  mailNotificationCadence?: InputMaybe<String_Comparison_Exp>;
  notificationForOrganisation?: InputMaybe<Boolean_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  wantRoomOccurrenceNotifications?: InputMaybe<Boolean_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "userSettings" */
export type UserSettings_Inc_Input = {
  agreementVersion?: InputMaybe<Scalars['bigint']['input']>;
};

/** response of any mutation on the table "userSettings" */
export type UserSettings_Mutation_Response = {
  __typename?: 'userSettings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserSettings>;
};

/** Ordering options when selecting data from "userSettings". */
export type UserSettings_Order_By = {
  agreementVersion?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mailNotificationCadence?: InputMaybe<Order_By>;
  notificationForOrganisation?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  wantRoomOccurrenceNotifications?: InputMaybe<Order_By>;
};

/** select columns of table "userSettings" */
export enum UserSettings_Select_Column {
  /** column name */
  AgreementVersion = 'agreementVersion',
  /** column name */
  Id = 'id',
  /** column name */
  MailNotificationCadence = 'mailNotificationCadence',
  /** column name */
  NotificationForOrganisation = 'notificationForOrganisation',
  /** column name */
  WantRoomOccurrenceNotifications = 'wantRoomOccurrenceNotifications'
}

/** input type for updating data in table "userSettings" */
export type UserSettings_Set_Input = {
  agreementVersion?: InputMaybe<Scalars['bigint']['input']>;
  mailNotificationCadence?: InputMaybe<Scalars['String']['input']>;
  notificationForOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  wantRoomOccurrenceNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "userSettings" */
export type UserSettings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserSettings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserSettings_Stream_Cursor_Value_Input = {
  agreementVersion?: InputMaybe<Scalars['bigint']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  mailNotificationCadence?: InputMaybe<Scalars['String']['input']>;
  notificationForOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  wantRoomOccurrenceNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserSettings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserSettings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserSettings_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserSettings_Bool_Exp;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  agreementVersion: Scalars['bigint']['output'];
  createdAt: Scalars['timestamptz']['output'];
  email: Scalars['String']['output'];
  /** An array relationship */
  eventFavourites: Array<EventFavourites>;
  /** An aggregate relationship */
  eventFavourites_aggregate: EventFavourites_Aggregate;
  /** An array relationship */
  eventOrganisers: Array<EventOrganisers>;
  /** An aggregate relationship */
  eventOrganisers_aggregate: EventOrganisers_Aggregate;
  /** An array relationship */
  eventRoomWatches: Array<EventRoomWatches>;
  /** An aggregate relationship */
  eventRoomWatches_aggregate: EventRoomWatches_Aggregate;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  failedLoginCount: Scalars['Int']['output'];
  /** An array relationship */
  files: Array<Files>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate;
  firstName?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "users_hasPassword" */
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['bigint']['output'];
  /** A computed field, executes function "users_isAdmin" */
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isDisabled?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "users_isOrgaAdmin" */
  isOrgaAdmin?: Maybe<Scalars['Boolean']['output']>;
  jaggaerUsername: Scalars['String']['output'];
  lastLoginAt?: Maybe<Scalars['timestamptz']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastRequestAt?: Maybe<Scalars['timestamptz']['output']>;
  ldapDN?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  notificationPreferences: Array<NotificationPreferences>;
  /** An aggregate relationship */
  notificationPreferences_aggregate: NotificationPreferences_Aggregate;
  /** An array relationship */
  notificationServicePreferences: Array<NotificationServicePreferences>;
  /** An aggregate relationship */
  notificationServicePreferences_aggregate: NotificationServicePreferences_Aggregate;
  /** An array relationship */
  notifications: Array<Notifications>;
  /** An array relationship */
  notificationsByUserid: Array<Notifications>;
  /** An aggregate relationship */
  notificationsByUserid_aggregate: Notifications_Aggregate;
  /** An aggregate relationship */
  notifications_aggregate: Notifications_Aggregate;
  /** An object relationship */
  organisation: Organisations;
  /** An array relationship */
  organisationGroupUsers: Array<OrganisationGroupUsers>;
  /** An aggregate relationship */
  organisationGroupUsers_aggregate: OrganisationGroupUsers_Aggregate;
  organisationId: Scalars['bigint']['output'];
  /** An array relationship */
  serviceFavourites: Array<ServiceFavourites>;
  /** An aggregate relationship */
  serviceFavourites_aggregate: ServiceFavourites_Aggregate;
  /** An object relationship */
  settings?: Maybe<UserSettings>;
  successfulLoginCount: Scalars['Int']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userAttributeValues: Array<UserAttributeValues>;
  /** An aggregate relationship */
  userAttributeValues_aggregate: UserAttributeValues_Aggregate;
};


/** columns and relationships of "users" */
export type UsersEventFavouritesArgs = {
  distinct_on?: InputMaybe<Array<EventFavourites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventFavourites_Order_By>>;
  where?: InputMaybe<EventFavourites_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersEventFavourites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventFavourites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventFavourites_Order_By>>;
  where?: InputMaybe<EventFavourites_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersEventOrganisersArgs = {
  distinct_on?: InputMaybe<Array<EventOrganisers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventOrganisers_Order_By>>;
  where?: InputMaybe<EventOrganisers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersEventOrganisers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventOrganisers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventOrganisers_Order_By>>;
  where?: InputMaybe<EventOrganisers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersEventRoomWatchesArgs = {
  distinct_on?: InputMaybe<Array<EventRoomWatches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventRoomWatches_Order_By>>;
  where?: InputMaybe<EventRoomWatches_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersEventRoomWatches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<EventRoomWatches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EventRoomWatches_Order_By>>;
  where?: InputMaybe<EventRoomWatches_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersFiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNotificationPreferencesArgs = {
  distinct_on?: InputMaybe<Array<NotificationPreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationPreferences_Order_By>>;
  where?: InputMaybe<NotificationPreferences_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNotificationPreferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationPreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationPreferences_Order_By>>;
  where?: InputMaybe<NotificationPreferences_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNotificationServicePreferencesArgs = {
  distinct_on?: InputMaybe<Array<NotificationServicePreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationServicePreferences_Order_By>>;
  where?: InputMaybe<NotificationServicePreferences_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNotificationServicePreferences_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationServicePreferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NotificationServicePreferences_Order_By>>;
  where?: InputMaybe<NotificationServicePreferences_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNotificationsByUseridArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNotificationsByUserid_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersOrganisationGroupUsersArgs = {
  distinct_on?: InputMaybe<Array<OrganisationGroupUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<OrganisationGroupUsers_Order_By>>;
  where?: InputMaybe<OrganisationGroupUsers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersOrganisationGroupUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<OrganisationGroupUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<OrganisationGroupUsers_Order_By>>;
  where?: InputMaybe<OrganisationGroupUsers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersServiceFavouritesArgs = {
  distinct_on?: InputMaybe<Array<ServiceFavourites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceFavourites_Order_By>>;
  where?: InputMaybe<ServiceFavourites_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersServiceFavourites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ServiceFavourites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ServiceFavourites_Order_By>>;
  where?: InputMaybe<ServiceFavourites_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUserAttributeValuesArgs = {
  distinct_on?: InputMaybe<Array<UserAttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserAttributeValues_Order_By>>;
  where?: InputMaybe<UserAttributeValues_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUserAttributeValues_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UserAttributeValues_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserAttributeValues_Order_By>>;
  where?: InputMaybe<UserAttributeValues_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

export type Users_Aggregate_Bool_Exp = {
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>;
};

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  avg?: InputMaybe<Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
  stddev?: InputMaybe<Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Users_Sum_Order_By>;
  var_pop?: InputMaybe<Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  agreementVersion?: Maybe<Scalars['Float']['output']>;
  failedLoginCount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  successfulLoginCount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "users" */
export type Users_Avg_Order_By = {
  agreementVersion?: InputMaybe<Order_By>;
  failedLoginCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  successfulLoginCount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  agreementVersion?: InputMaybe<Bigint_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  eventFavourites?: InputMaybe<EventFavourites_Bool_Exp>;
  eventFavourites_aggregate?: InputMaybe<EventFavourites_Aggregate_Bool_Exp>;
  eventOrganisers?: InputMaybe<EventOrganisers_Bool_Exp>;
  eventOrganisers_aggregate?: InputMaybe<EventOrganisers_Aggregate_Bool_Exp>;
  eventRoomWatches?: InputMaybe<EventRoomWatches_Bool_Exp>;
  eventRoomWatches_aggregate?: InputMaybe<EventRoomWatches_Aggregate_Bool_Exp>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  failedLoginCount?: InputMaybe<Int_Comparison_Exp>;
  files?: InputMaybe<Files_Bool_Exp>;
  files_aggregate?: InputMaybe<Files_Aggregate_Bool_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  hasPassword?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Bigint_Comparison_Exp>;
  isAdmin?: InputMaybe<Boolean_Comparison_Exp>;
  isDisabled?: InputMaybe<Timestamptz_Comparison_Exp>;
  isOrgaAdmin?: InputMaybe<Boolean_Comparison_Exp>;
  jaggaerUsername?: InputMaybe<String_Comparison_Exp>;
  lastLoginAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  lastRequestAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  ldapDN?: InputMaybe<String_Comparison_Exp>;
  notificationPreferences?: InputMaybe<NotificationPreferences_Bool_Exp>;
  notificationPreferences_aggregate?: InputMaybe<NotificationPreferences_Aggregate_Bool_Exp>;
  notificationServicePreferences?: InputMaybe<NotificationServicePreferences_Bool_Exp>;
  notificationServicePreferences_aggregate?: InputMaybe<NotificationServicePreferences_Aggregate_Bool_Exp>;
  notifications?: InputMaybe<Notifications_Bool_Exp>;
  notificationsByUserid?: InputMaybe<Notifications_Bool_Exp>;
  notificationsByUserid_aggregate?: InputMaybe<Notifications_Aggregate_Bool_Exp>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Bool_Exp>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisationGroupUsers?: InputMaybe<OrganisationGroupUsers_Bool_Exp>;
  organisationGroupUsers_aggregate?: InputMaybe<OrganisationGroupUsers_Aggregate_Bool_Exp>;
  organisationId?: InputMaybe<Bigint_Comparison_Exp>;
  serviceFavourites?: InputMaybe<ServiceFavourites_Bool_Exp>;
  serviceFavourites_aggregate?: InputMaybe<ServiceFavourites_Aggregate_Bool_Exp>;
  settings?: InputMaybe<UserSettings_Bool_Exp>;
  successfulLoginCount?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  userAttributeValues?: InputMaybe<UserAttributeValues_Bool_Exp>;
  userAttributeValues_aggregate?: InputMaybe<UserAttributeValues_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint on columns "ldapDN" */
  UsersLdapDNKey = 'users_ldapDN_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  failedLoginCount?: InputMaybe<Scalars['Int']['input']>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  email?: InputMaybe<Scalars['String']['input']>;
  eventFavourites?: InputMaybe<EventFavourites_Arr_Rel_Insert_Input>;
  eventOrganisers?: InputMaybe<EventOrganisers_Arr_Rel_Insert_Input>;
  eventRoomWatches?: InputMaybe<EventRoomWatches_Arr_Rel_Insert_Input>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['timestamptz']['input']>;
  jaggaerUsername?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  ldapDN?: InputMaybe<Scalars['String']['input']>;
  notificationPreferences?: InputMaybe<NotificationPreferences_Arr_Rel_Insert_Input>;
  notificationServicePreferences?: InputMaybe<NotificationServicePreferences_Arr_Rel_Insert_Input>;
  organisation?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  organisationGroupUsers?: InputMaybe<OrganisationGroupUsers_Arr_Rel_Insert_Input>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
  serviceFavourites?: InputMaybe<ServiceFavourites_Arr_Rel_Insert_Input>;
  userAttributeValues?: InputMaybe<UserAttributeValues_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  agreementVersion?: Maybe<Scalars['bigint']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  failedLoginCount?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  isDisabled?: Maybe<Scalars['timestamptz']['output']>;
  jaggaerUsername?: Maybe<Scalars['String']['output']>;
  lastLoginAt?: Maybe<Scalars['timestamptz']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastRequestAt?: Maybe<Scalars['timestamptz']['output']>;
  ldapDN?: Maybe<Scalars['String']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  successfulLoginCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  agreementVersion?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  failedLoginCount?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDisabled?: InputMaybe<Order_By>;
  jaggaerUsername?: InputMaybe<Order_By>;
  lastLoginAt?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  lastRequestAt?: InputMaybe<Order_By>;
  ldapDN?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  successfulLoginCount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  agreementVersion?: Maybe<Scalars['bigint']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  failedLoginCount?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  isDisabled?: Maybe<Scalars['timestamptz']['output']>;
  jaggaerUsername?: Maybe<Scalars['String']['output']>;
  lastLoginAt?: Maybe<Scalars['timestamptz']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastRequestAt?: Maybe<Scalars['timestamptz']['output']>;
  ldapDN?: Maybe<Scalars['String']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  successfulLoginCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  agreementVersion?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  failedLoginCount?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isDisabled?: InputMaybe<Order_By>;
  jaggaerUsername?: InputMaybe<Order_By>;
  lastLoginAt?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  lastRequestAt?: InputMaybe<Order_By>;
  ldapDN?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  successfulLoginCount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  agreementVersion?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  eventFavourites_aggregate?: InputMaybe<EventFavourites_Aggregate_Order_By>;
  eventOrganisers_aggregate?: InputMaybe<EventOrganisers_Aggregate_Order_By>;
  eventRoomWatches_aggregate?: InputMaybe<EventRoomWatches_Aggregate_Order_By>;
  expiresAt?: InputMaybe<Order_By>;
  failedLoginCount?: InputMaybe<Order_By>;
  files_aggregate?: InputMaybe<Files_Aggregate_Order_By>;
  firstName?: InputMaybe<Order_By>;
  hasPassword?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isAdmin?: InputMaybe<Order_By>;
  isDisabled?: InputMaybe<Order_By>;
  isOrgaAdmin?: InputMaybe<Order_By>;
  jaggaerUsername?: InputMaybe<Order_By>;
  lastLoginAt?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  lastRequestAt?: InputMaybe<Order_By>;
  ldapDN?: InputMaybe<Order_By>;
  notificationPreferences_aggregate?: InputMaybe<NotificationPreferences_Aggregate_Order_By>;
  notificationServicePreferences_aggregate?: InputMaybe<NotificationServicePreferences_Aggregate_Order_By>;
  notificationsByUserid_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  notifications_aggregate?: InputMaybe<Notifications_Aggregate_Order_By>;
  organisation?: InputMaybe<Organisations_Order_By>;
  organisationGroupUsers_aggregate?: InputMaybe<OrganisationGroupUsers_Aggregate_Order_By>;
  organisationId?: InputMaybe<Order_By>;
  serviceFavourites_aggregate?: InputMaybe<ServiceFavourites_Aggregate_Order_By>;
  settings?: InputMaybe<UserSettings_Order_By>;
  successfulLoginCount?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userAttributeValues_aggregate?: InputMaybe<UserAttributeValues_Aggregate_Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  AgreementVersion = 'agreementVersion',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  FailedLoginCount = 'failedLoginCount',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  IsDisabled = 'isDisabled',
  /** column name */
  JaggaerUsername = 'jaggaerUsername',
  /** column name */
  LastLoginAt = 'lastLoginAt',
  /** column name */
  LastName = 'lastName',
  /** column name */
  LastRequestAt = 'lastRequestAt',
  /** column name */
  LdapDN = 'ldapDN',
  /** column name */
  OrganisationId = 'organisationId',
  /** column name */
  SuccessfulLoginCount = 'successfulLoginCount',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  email?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  failedLoginCount?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isDisabled?: InputMaybe<Scalars['timestamptz']['input']>;
  jaggaerUsername?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  ldapDN?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  agreementVersion?: Maybe<Scalars['Float']['output']>;
  failedLoginCount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  successfulLoginCount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "users" */
export type Users_Stddev_Order_By = {
  agreementVersion?: InputMaybe<Order_By>;
  failedLoginCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  successfulLoginCount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  agreementVersion?: Maybe<Scalars['Float']['output']>;
  failedLoginCount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  successfulLoginCount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "users" */
export type Users_Stddev_Pop_Order_By = {
  agreementVersion?: InputMaybe<Order_By>;
  failedLoginCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  successfulLoginCount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  agreementVersion?: Maybe<Scalars['Float']['output']>;
  failedLoginCount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  successfulLoginCount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "users" */
export type Users_Stddev_Samp_Order_By = {
  agreementVersion?: InputMaybe<Order_By>;
  failedLoginCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  successfulLoginCount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  agreementVersion?: InputMaybe<Scalars['bigint']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  failedLoginCount?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  isDisabled?: InputMaybe<Scalars['timestamptz']['input']>;
  jaggaerUsername?: InputMaybe<Scalars['String']['input']>;
  lastLoginAt?: InputMaybe<Scalars['timestamptz']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastRequestAt?: InputMaybe<Scalars['timestamptz']['input']>;
  ldapDN?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
  successfulLoginCount?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  agreementVersion?: Maybe<Scalars['bigint']['output']>;
  failedLoginCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  organisationId?: Maybe<Scalars['bigint']['output']>;
  successfulLoginCount?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "users" */
export type Users_Sum_Order_By = {
  agreementVersion?: InputMaybe<Order_By>;
  failedLoginCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  successfulLoginCount?: InputMaybe<Order_By>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  Email = 'email',
  /** column name */
  ExpiresAt = 'expiresAt',
  /** column name */
  FailedLoginCount = 'failedLoginCount',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  IsDisabled = 'isDisabled',
  /** column name */
  JaggaerUsername = 'jaggaerUsername',
  /** column name */
  LastName = 'lastName',
  /** column name */
  LdapDN = 'ldapDN',
  /** column name */
  OrganisationId = 'organisationId'
}

export type Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  agreementVersion?: Maybe<Scalars['Float']['output']>;
  failedLoginCount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  successfulLoginCount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "users" */
export type Users_Var_Pop_Order_By = {
  agreementVersion?: InputMaybe<Order_By>;
  failedLoginCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  successfulLoginCount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  agreementVersion?: Maybe<Scalars['Float']['output']>;
  failedLoginCount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  successfulLoginCount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "users" */
export type Users_Var_Samp_Order_By = {
  agreementVersion?: InputMaybe<Order_By>;
  failedLoginCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  successfulLoginCount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  agreementVersion?: Maybe<Scalars['Float']['output']>;
  failedLoginCount?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  organisationId?: Maybe<Scalars['Float']['output']>;
  successfulLoginCount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "users" */
export type Users_Variance_Order_By = {
  agreementVersion?: InputMaybe<Order_By>;
  failedLoginCount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisationId?: InputMaybe<Order_By>;
  successfulLoginCount?: InputMaybe<Order_By>;
};

export type GetUserQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type GetUserQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: any, firstName?: string | null, lastName?: string | null, email: string, userAttributeValues: Array<{ __typename?: 'userAttributeValues', value: any, userAttribute: { __typename?: 'userAttributes', name: string } }>, organisation: { __typename?: 'organisations', name: string } } | null };

export type GetVisibleUserByIdQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type GetVisibleUserByIdQuery = { __typename?: 'query_root', allUsers: Array<{ __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null, attributes?: any | null, publicEmail?: string | null, isDisabled?: boolean | null, organisation?: { __typename?: 'organisations', name: string } | null }> };

export type GetInfoBoxeBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  userIsAdmin?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetInfoBoxeBySlugQuery = { __typename?: 'query_root', infoBoxes: Array<{ __typename?: 'infoBoxes', id: any, content: any, isInternal?: boolean, slug: string, title: string }> };

export type UpsertInfoBoxMutationVariables = Exact<{
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
  isInternal: Scalars['Boolean']['input'];
  content: Scalars['json']['input'];
}>;


export type UpsertInfoBoxMutation = { __typename?: 'mutation_root', insert_infoBoxes_one?: { __typename?: 'infoBoxes', id: any, slug: string, title: string, content: any, isInternal: boolean } | null };

export type DeleteInfoNewsEntryByIdMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteInfoNewsEntryByIdMutation = { __typename?: 'mutation_root', delete_infoNews_by_pk?: { __typename?: 'infoNews', id: any } | null };

export type InsertInfoNewsEntryMutationVariables = Exact<{
  object: InfoNews_Insert_Input;
}>;


export type InsertInfoNewsEntryMutation = { __typename?: 'mutation_root', insert_infoNews_one?: { __typename?: 'infoNews', id: any, title: string, content: any, date: any, isInternal: boolean } | null };

export type UpdateInfoNewsEntryByIdMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  title: Scalars['String']['input'];
  content: Scalars['json']['input'];
  date: Scalars['timestamptz']['input'];
  isInternal: Scalars['Boolean']['input'];
}>;


export type UpdateInfoNewsEntryByIdMutation = { __typename?: 'mutation_root', update_infoNews_by_pk?: { __typename?: 'infoNews', id: any, title: string, content: any, date: any, isInternal: boolean } | null };

export type GetInfoNewsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<InfoNews_Bool_Exp>;
  userIsAdmin?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetInfoNewsQuery = { __typename?: 'query_root', infoNews: Array<{ __typename?: 'infoNews', id: any, date: any, title: string, content: any, isInternal?: boolean }> };

export type GetEventsAutocompleteQueryVariables = Exact<{
  searchString: Scalars['String']['input'];
  currentEventId: Scalars['bigint']['input'];
}>;


export type GetEventsAutocompleteQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'events', id: any, name: string, startDate?: any | null, endDate?: any | null }> };

export type FetchRoomMatrixForImportByEventIdQueryVariables = Exact<{
  eventId: Scalars['bigint']['input'];
}>;


export type FetchRoomMatrixForImportByEventIdQuery = { __typename?: 'query_root', events_by_pk?: { __typename?: 'events', id: any, startDate?: any | null, endDate?: any | null, name: string, eventRooms: Array<{ __typename?: 'eventRooms', roomId: any, guestCanEdit: boolean, room: { __typename?: 'rooms', id: any, name: string, shortDescription?: string | null, description?: string | null, eventId?: any | null, fromRoomId?: any | null, roomFolderId?: any | null, roomServices: Array<{ __typename?: 'roomServices', id: any, name: string, fromRoomServiceId?: any | null, roomServiceOccurrences: Array<{ __typename?: 'roomServiceOccurrences', id: any, createdAt: any, startDate: any, endDate: any, name: string, eventId: any, fromRoomServiceOccurrenceId?: any | null }> }> } }> } | null, roomOccurrences: Array<{ __typename?: 'roomOccurrences', id: any, createdAt: any, startDate: any, endDate: any, name: string, fromRoomOccurrenceId?: any | null, room: { __typename?: 'rooms', id: any, name: string, shortDescription?: string | null, description?: string | null, eventId?: any | null, fromRoomId?: any | null, roomFolderId?: any | null } }> };

export type CopyEventRoomsMutationVariables = Exact<{
  objects: Array<EventRooms_Insert_Input> | EventRooms_Insert_Input;
}>;


export type CopyEventRoomsMutation = { __typename?: 'mutation_root', insert_eventRooms?: { __typename?: 'eventRooms_mutation_response', returning: Array<{ __typename?: 'eventRooms', eventId: any, roomId: any, guestCanEdit: boolean, room: { __typename?: 'rooms', id: any, name: string, description?: string | null, shortDescription?: string | null, fromRoomId?: any | null, eventId?: any | null } }> } | null };

export type CopyMatrixOccurrencesMutationVariables = Exact<{
  eventRooms: Array<EventRooms_Insert_Input> | EventRooms_Insert_Input;
  roomOccurrences: Array<RoomOccurrences_Insert_Input> | RoomOccurrences_Insert_Input;
  roomServiceOccurrences: Array<RoomServiceOccurrences_Insert_Input> | RoomServiceOccurrences_Insert_Input;
}>;


export type CopyMatrixOccurrencesMutation = { __typename?: 'mutation_root', insert_eventRooms?: { __typename?: 'eventRooms_mutation_response', returning: Array<{ __typename?: 'eventRooms', roomId: any, eventId: any, guestCanEdit: boolean }> } | null, insert_roomOccurrences?: { __typename?: 'roomOccurrences_mutation_response', returning: Array<{ __typename?: 'roomOccurrences', id: any, startDate: any, endDate: any, name: string, room: { __typename?: 'rooms', id: any, name: string, shortDescription?: string | null, description?: string | null, eventId?: any | null, fromRoomId?: any | null, roomFolderId?: any | null } }> } | null, insert_roomServiceOccurrences?: { __typename?: 'roomServiceOccurrences_mutation_response', returning: Array<{ __typename?: 'roomServiceOccurrences', id: any, startDate: any, endDate: any, name: string, eventId: any, roomService: { __typename?: 'roomServices', id: any, roomId: any, order?: number | null } }> } | null };

export type GetServiceOrganisationAccessesQueryVariables = Exact<{
  serviceIdFilter?: InputMaybe<Bigint_Comparison_Exp>;
}>;


export type GetServiceOrganisationAccessesQuery = { __typename?: 'query_root', serviceOrganisationAccesses: Array<{ __typename?: 'serviceOrganisationAccesses', updatedAt: any, organisation: { __typename?: 'organisations', id: any, name: string } }> };

export type GetRoomServiceOrganisationAccessesQueryVariables = Exact<{
  eventId?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type GetRoomServiceOrganisationAccessesQuery = { __typename?: 'query_root', roomServiceOrganisationAccesses: Array<{ __typename?: 'roomServiceOrganisationAccesses', updatedAt: any, organisation: { __typename?: 'organisations', id: any, name: string } }> };

export type GetAllOrganisationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllOrganisationsQuery = { __typename?: 'query_root', organisations: Array<{ __typename?: 'organisations', id: any, name: string }> };

export type InsertServiceOrganisationAccessesMutationVariables = Exact<{
  serviceAccessObjects: Array<ServiceOrganisationAccesses_Insert_Input> | ServiceOrganisationAccesses_Insert_Input;
}>;


export type InsertServiceOrganisationAccessesMutation = { __typename?: 'mutation_root', insert_serviceOrganisationAccesses?: { __typename?: 'serviceOrganisationAccesses_mutation_response', returning: Array<{ __typename?: 'serviceOrganisationAccesses', organisationId: any, serviceId: any, updatedAt: any }> } | null };

export type InsertRoomMatrixOrganisationAccessesMutationVariables = Exact<{
  eventId?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type InsertRoomMatrixOrganisationAccessesMutation = { __typename?: 'mutation_root', insert_roomServiceOrganisationAccesses_one?: { __typename?: 'roomServiceOrganisationAccesses', organisationId: any, eventId: any, updatedAt: any } | null };

export type SetUsersLastServiceModuleVisitMutationVariables = Exact<{
  serviceModuleId: Scalars['bigint']['input'];
}>;


export type SetUsersLastServiceModuleVisitMutation = { __typename?: 'mutation_root', insert_userServiceModuleLastVisits_one?: { __typename?: 'userServiceModuleLastVisits', serviceModuleId: any, serviceModule: { __typename?: 'serviceModules', id: any, hasChanges?: boolean | null, lastVisits: Array<{ __typename?: 'userServiceModuleLastVisits', userId: any, updatedAt: any }>, service: { __typename?: 'services', id: any, serviceModules_aggregate: { __typename?: 'serviceModules_aggregate', aggregate?: { __typename?: 'serviceModules_aggregate_fields', count: number } | null }, serviceModules: Array<{ __typename?: 'serviceModules', id: any, hasChanges?: boolean | null }> } } } | null };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'mutation_root', login?: { __typename?: 'LoginReturn', email: string, firstName: string, lastName: string, needsAgreement: boolean } | null };

export type SetAgreementMutationVariables = Exact<{
  version: Scalars['bigint']['input'];
}>;


export type SetAgreementMutation = { __typename?: 'mutation_root', update_userSettings?: { __typename?: 'userSettings_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'userSettings', id?: any | null, agreementVersion?: any | null }> } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'mutation_root', logout?: { __typename?: 'LogoutReturn', logout: boolean } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'query_root', currentUser?: { __typename?: 'users', id: any, email: string, firstName?: string | null, lastName?: string | null, organisationId: any, isAdmin?: boolean | null, isOrgaAdmin?: boolean | null, agreementVersion: any, jaggaerUsername: string, ldapDN?: string | null, organisation: { __typename?: 'organisations', id: any, name: string, isGuestOrga: boolean }, organisationGroupUsers: Array<{ __typename?: 'organisationGroupUsers', organisationGroup: { __typename?: 'organisationGroups', id: any, name: string } }>, userAttributeValues: Array<{ __typename?: 'userAttributeValues', imported: boolean, value: any, userAttribute: { __typename?: 'userAttributes', id: any, name: string } }> } | null };

export type ServiceBundleByIdQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type ServiceBundleByIdQuery = { __typename?: 'query_root', serviceBundles_by_pk?: { __typename?: 'serviceBundles', id: any, name: string, createdAt: any, serviceBundleServices: Array<{ __typename?: 'serviceBundleServices', service: { __typename?: 'services', name: string, id: any, updatedAt: any, createdAt: any } }> } | null };

export type ServiceBundleListQueryVariables = Exact<{
  serviceBundlesOrder?: InputMaybe<Array<ServiceBundles_Order_By> | ServiceBundles_Order_By>;
}>;


export type ServiceBundleListQuery = { __typename?: 'query_root', serviceBundles: Array<{ __typename?: 'serviceBundles', id: any, name: string, serviceBundleServices: Array<{ __typename?: 'serviceBundleServices', service: { __typename?: 'services', id: any, name: string, tags: any } }> }> };

export type BundleListQueryVariables = Exact<{
  where?: InputMaybe<ServiceBundles_Bool_Exp>;
  order_by?: InputMaybe<Array<ServiceBundles_Order_By> | ServiceBundles_Order_By>;
}>;


export type BundleListQuery = { __typename?: 'query_root', serviceBundles: Array<{ __typename?: 'serviceBundles', id: any, name: string, updatedAt: any, createdAt: any }> };

export type DeleteBundleMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteBundleMutation = { __typename?: 'mutation_root', delete_serviceBundles_by_pk?: { __typename?: 'serviceBundles', id: any } | null };

export type InsertBundleMutationVariables = Exact<{
  object: ServiceBundles_Insert_Input;
}>;


export type InsertBundleMutation = { __typename?: 'mutation_root', insert_serviceBundles_one?: { __typename?: 'serviceBundles', id: any, name: string, updatedAt: any, createdAt: any } | null };

export type UpdateBundleMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  object: ServiceBundles_Insert_Input;
}>;


export type UpdateBundleMutation = { __typename?: 'mutation_root', delete_serviceBundles_by_pk?: { __typename?: 'serviceBundles', id: any } | null, insert_serviceBundles_one?: { __typename?: 'serviceBundles', id: any, name: string, updatedAt: any, createdAt: any } | null };

export type AddAttributeValueCommentMutationVariables = Exact<{
  input: AttributeValueComments_Insert_Input;
}>;


export type AddAttributeValueCommentMutation = { __typename?: 'mutation_root', insert_attributeValueComments_one?: { __typename?: 'attributeValueComments', id: any, attributeValueId: any, parentId?: any | null, createdAt: any, updatedAt: any, isDone?: any | null, comment: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null, comments: Array<{ __typename?: 'attributeValueComments', id: any, createdAt: any, updatedAt: any, comment: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }> } | null };

export type AddUploadCommentMutationVariables = Exact<{
  input: UploadComments_Insert_Input;
}>;


export type AddUploadCommentMutation = { __typename?: 'mutation_root', insert_uploadComments_one?: { __typename?: 'uploadComments', id: any, parentId?: any | null, createdAt: any, updatedAt: any, isDone?: any | null, comment: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null, comments: Array<{ __typename?: 'uploadComments', id: any, createdAt: any, updatedAt: any, comment: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }> } | null };

export type AddRoomAttributeValueCommentMutationVariables = Exact<{
  input: RoomAttributeValueComments_Insert_Input;
}>;


export type AddRoomAttributeValueCommentMutation = { __typename?: 'mutation_root', insert_roomAttributeValueComments_one?: { __typename?: 'roomAttributeValueComments', id: any, roomAttributeValueId: any, parentId?: any | null, createdAt: any, updatedAt: any, isDone?: any | null, comment: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null, comments: Array<{ __typename?: 'roomAttributeValueComments', id: any, createdAt: any, updatedAt: any, comment: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }> } | null };

export type ArchiveAttributeValueCommentMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  isDone?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type ArchiveAttributeValueCommentMutation = { __typename?: 'mutation_root', update_attributeValueComments_by_pk?: { __typename?: 'attributeValueComments', id: any, isDone?: any | null, organisationId?: any | null } | null };

export type ArchiveUploadCommentMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  isDone?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type ArchiveUploadCommentMutation = { __typename?: 'mutation_root', update_uploadComments_by_pk?: { __typename?: 'uploadComments', id: any, isDone?: any | null, organisationId?: any | null } | null };

export type ArchiveRoomAttributeValueCommentMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  isDone?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type ArchiveRoomAttributeValueCommentMutation = { __typename?: 'mutation_root', update_roomAttributeValueComments_by_pk?: { __typename?: 'roomAttributeValueComments', id: any, isDone?: any | null, organisationId?: any | null } | null };

export type CommentMentionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CommentMentionsQuery = { __typename?: 'query_root', allUsers: Array<{ __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null, organisationId?: any | null, organisation?: { __typename?: 'organisations', isGuestOrga: boolean } | null }>, events: Array<{ __typename?: 'events', id: any, name: string }>, organisations: Array<{ __typename?: 'organisations', id: any, name: string, isGuestOrga: boolean }> };

export type AttributeValueCommentsByReferenceQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type AttributeValueCommentsByReferenceQuery = { __typename?: 'query_root', attributeValueComments: Array<{ __typename?: 'attributeValueComments', id: any, createdAt: any, updatedAt: any, organisationId?: any | null, isDone?: any | null, comment: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null, comments: Array<{ __typename?: 'attributeValueComments', id: any, createdAt: any, updatedAt: any, organisationId?: any | null, comment: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }> }> };

export type UploadCommentsByReferenceQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type UploadCommentsByReferenceQuery = { __typename?: 'query_root', uploadComments: Array<{ __typename?: 'uploadComments', id: any, createdAt: any, updatedAt: any, organisationId?: any | null, isDone?: any | null, comment: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null, comments: Array<{ __typename?: 'uploadComments', id: any, createdAt: any, updatedAt: any, organisationId?: any | null, comment: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }> }> };

export type AttributeValueCommentsByReferencePollingSubscriptionVariables = Exact<{
  where?: InputMaybe<AttributeValueComments_Bool_Exp>;
}>;


export type AttributeValueCommentsByReferencePollingSubscription = { __typename?: 'subscription_root', attributeValueComments: Array<{ __typename?: 'attributeValueComments', id: any, createdAt: any, updatedAt: any, organisationId?: any | null, isDone?: any | null, comment: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null, comments: Array<{ __typename?: 'attributeValueComments', id: any, createdAt: any, updatedAt: any, organisationId?: any | null, comment: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }> }> };

export type UploadCommentsByReferencePollingSubscriptionVariables = Exact<{
  where?: InputMaybe<UploadComments_Bool_Exp>;
}>;


export type UploadCommentsByReferencePollingSubscription = { __typename?: 'subscription_root', uploadComments: Array<{ __typename?: 'uploadComments', id: any, createdAt: any, updatedAt: any, organisationId?: any | null, isDone?: any | null, comment: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null, comments: Array<{ __typename?: 'uploadComments', id: any, createdAt: any, updatedAt: any, organisationId?: any | null, comment: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }> }> };

export type RoomAttributeValueCommentsByReferencePollingSubscriptionVariables = Exact<{
  where?: InputMaybe<RoomAttributeValueComments_Bool_Exp>;
}>;


export type RoomAttributeValueCommentsByReferencePollingSubscription = { __typename?: 'subscription_root', roomAttributeValueComments: Array<{ __typename?: 'roomAttributeValueComments', id: any, createdAt: any, updatedAt: any, organisationId?: any | null, isDone?: any | null, comment: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null, comments: Array<{ __typename?: 'roomAttributeValueComments', id: any, createdAt: any, updatedAt: any, organisationId?: any | null, comment: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }> }> };

export type DeleteAttributeValueCommentMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteAttributeValueCommentMutation = { __typename?: 'mutation_root', delete_attributeValueComments_by_pk?: { __typename?: 'attributeValueComments', id: any } | null };

export type DeleteUploadCommentMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteUploadCommentMutation = { __typename?: 'mutation_root', delete_uploadComments_by_pk?: { __typename?: 'uploadComments', id: any } | null };

export type DeleteRoomAttributeValueCommentMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteRoomAttributeValueCommentMutation = { __typename?: 'mutation_root', delete_roomAttributeValueComments_by_pk?: { __typename?: 'roomAttributeValueComments', id: any } | null };

export type IsPublicAttributeValueCommentMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type IsPublicAttributeValueCommentMutation = { __typename?: 'mutation_root', update_attributeValueComments_by_pk?: { __typename?: 'attributeValueComments', id: any, isDone?: any | null, organisationId?: any | null } | null };

export type IsPublicUploadCommentMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type IsPublicUploadCommentMutation = { __typename?: 'mutation_root', update_uploadComments_by_pk?: { __typename?: 'uploadComments', id: any, isDone?: any | null, organisationId?: any | null } | null };

export type IsPublicRoomAttributeValueCommentMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type IsPublicRoomAttributeValueCommentMutation = { __typename?: 'mutation_root', update_roomAttributeValueComments_by_pk?: { __typename?: 'roomAttributeValueComments', id: any, isDone?: any | null, organisationId?: any | null } | null };

export type UpdateAttributeValueCommentMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  object?: InputMaybe<AttributeValueComments_Set_Input>;
}>;


export type UpdateAttributeValueCommentMutation = { __typename?: 'mutation_root', update_attributeValueComments_by_pk?: { __typename?: 'attributeValueComments', id: any, isDone?: any | null, comment: string, parentId?: any | null, attributeValueId: any } | null };

export type UpdateUploadCommentMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  object?: InputMaybe<UploadComments_Set_Input>;
}>;


export type UpdateUploadCommentMutation = { __typename?: 'mutation_root', update_uploadComments_by_pk?: { __typename?: 'uploadComments', id: any, isDone?: any | null, comment: string, parentId?: any | null, uploadId: any, uploadVersionId: any } | null };

export type UpdateRoomAttributeValueCommentMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  object?: InputMaybe<RoomAttributeValueComments_Set_Input>;
}>;


export type UpdateRoomAttributeValueCommentMutation = { __typename?: 'mutation_root', update_roomAttributeValueComments_by_pk?: { __typename?: 'roomAttributeValueComments', id: any, isDone?: any | null, comment: string, parentId?: any | null, roomAttributeValueId: any } | null };

export type CreateEventMutationVariables = Exact<{
  object: Events_Insert_Input;
}>;


export type CreateEventMutation = { __typename?: 'mutation_root', insert_events_one?: { __typename?: 'events', id: any, name: string, subTitle?: string | null, startDate?: any | null, endDate?: any | null, eventType: EventTypes_Enum, isArchived?: any | null, isCanceled?: any | null, parentId?: any | null, guestCanEdit: boolean, guestCanEditRoommatrix: boolean, guestOrganisationId?: any | null, rubinHashEvent?: string | null, guestOrganisation?: { __typename?: 'organisations', name: string } | null, services: Array<{ __typename?: 'services', id: any, name: string }>, eventOrganisers: Array<{ __typename?: 'eventOrganisers', user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }> } | null };

export type DeleteEventMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteEventMutation = { __typename?: 'mutation_root', delete_events_by_pk?: { __typename?: 'events', id: any } | null };

export type GetEventAttributeGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEventAttributeGroupsQuery = { __typename?: 'query_root', eventAttributeGroups: Array<{ __typename?: 'eventAttributeGroups', id: any, name: string, order: number, eventAttributes: Array<{ __typename?: 'eventAttributes', id: any, slug?: string | null, attributeType: AttributeTypes_Enum, description?: string | null, name: string, config: any, order: number }> }> };

export type EventByIdDetailedQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
  where?: InputMaybe<Services_Bool_Exp>;
}>;


export type EventByIdDetailedQuery = { __typename?: 'query_root', events_by_pk?: { __typename?: 'events', id: any, name: string, subTitle?: string | null, startDate?: any | null, endDate?: any | null, eventType: EventTypes_Enum, isArchived?: any | null, isCanceled?: any | null, parentId?: any | null, services: Array<{ __typename?: 'services', id: any, name: string, tags: any, updatedAt: any, createdAt: any, serviceModules_aggregate: { __typename?: 'serviceModules_aggregate', aggregate?: { __typename?: 'serviceModules_aggregate_fields', count: number } | null }, serviceModules: Array<{ __typename?: 'serviceModules', id: any, name: string, published?: boolean | null, order: number, config: any, moduleType: ModuleTypes_Enum, hasChanges?: boolean | null, lastVisits: Array<{ __typename?: 'userServiceModuleLastVisits', userId: any, updatedAt: any }>, attributeGroups: Array<{ __typename?: 'attributeGroups', id: any, order: number, description?: string | null, name: string, valuesRepeatable: boolean, attributeValueGroups: Array<{ __typename?: 'attributeValueGroups', id: any, attributeValues: Array<{ __typename?: 'attributeValues', id: any, value: any, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null, organisation?: { __typename?: 'organisations', id: any, name: string } | null } | null, attributeValueUploads: Array<{ __typename?: 'attributeValueUploads', id: any, name: string, attributeValueUploadVersions: Array<{ __typename?: 'attributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> }>, comments_aggregate: { __typename?: 'attributeValueComments_aggregate', aggregate?: { __typename?: 'attributeValueComments_aggregate_fields', count: number } | null }, attribute: { __typename?: 'attributes', id: any, attributeType: AttributeTypes_Enum, config: any, name: string, description?: string | null, order: number, attributeFiles: Array<{ __typename?: 'attributeFiles', downloadUrl?: string | null, file: { __typename?: 'files', id: any, size?: any | null, name: string, extension: string } }> } }> }>, attributes: Array<{ __typename?: 'attributes', attributeType: AttributeTypes_Enum, config: any, createdAt: any, description?: string | null, id: any, name: string, updatedAt: any, attributeValues: Array<{ __typename?: 'attributeValues', id: any, updatedAt: any, value: any, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null, organisation?: { __typename?: 'organisations', id: any, name: string } | null } | null, comments_aggregate: { __typename?: 'attributeValueComments_aggregate', aggregate?: { __typename?: 'attributeValueComments_aggregate_fields', count: number } | null } }> }> }>, uploads: Array<{ __typename?: 'uploads', id: any }> }> }>, eventOrganisers: Array<{ __typename?: 'eventOrganisers', user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }>, events: Array<{ __typename?: 'events', id: any, name: string, subTitle?: string | null }>, eventAttributeValues: Array<{ __typename?: 'eventAttributeValues', id: any, value: any, eventAttributeId?: any | null, eventAttributeValueUploads: Array<{ __typename?: 'eventAttributeValueUploads', id: any, name: string, eventAttributeValueUploadVersions: Array<{ __typename?: 'eventAttributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> }>, eventAttribute?: { __typename?: 'eventAttributes', id: any, slug?: string | null, attributeType: AttributeTypes_Enum, config: any, eventAttributeGroup: { __typename?: 'eventAttributeGroups', id: any } } | null }>, parentEvent?: { __typename?: 'events', id: any, name: string } | null } | null };

export type EventByIdQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
  fetchRubin?: InputMaybe<Scalars['Boolean']['input']>;
  fetchLastUpdatedInfo?: InputMaybe<Scalars['Boolean']['input']>;
  fetchGuestCanRead?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EventByIdQuery = { __typename?: 'query_root', events_by_pk?: { __typename?: 'events', id: any, name: string, subTitle?: string | null, startDate?: any | null, endDate?: any | null, eventType: EventTypes_Enum, isArchived?: any | null, isCanceled?: any | null, parentId?: any | null, guestCanEdit: boolean, guestCanEditRoommatrix: boolean, roommatrixWritable?: boolean | null, guestOrganisationId?: any | null, rubinHashEvent?: string | null, guestOrganisation?: { __typename?: 'organisations', name: string } | null, services: Array<{ __typename?: 'services', id: any, name: string, tags: any, fromServiceId?: any | null, eventId?: any | null, updatedAt: any, isFavourite?: boolean | null, userData: Array<{ __typename?: 'userDataServices', data: any }>, serviceModules_aggregate: { __typename?: 'serviceModules_aggregate', aggregate?: { __typename?: 'serviceModules_aggregate_fields', count: number } | null }, serviceModules: Array<{ __typename?: 'serviceModules', id: any, updatedAt: any, published?: boolean | null, config: any, hasChanges?: boolean | null, guestCanRead?: boolean | null, lastVisits: Array<{ __typename?: 'userServiceModuleLastVisits', userId: any, updatedAt: any }>, attributeGroups: Array<{ __typename?: 'attributeGroups', id: any, updatedAt: any, attributes: Array<{ __typename?: 'attributes', id: any, updatedAt: any, attributeValues: Array<{ __typename?: 'attributeValues', id: any, createdAt: any, updatedAt: any, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }> }> }>, uploads: Array<{ __typename?: 'uploads', updatedAt: any }> }> }>, eventOrganisers: Array<{ __typename?: 'eventOrganisers', user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }>, events: Array<{ __typename?: 'events', id: any, name: string, subTitle?: string | null }>, eventAttributeValues: Array<{ __typename?: 'eventAttributeValues', id: any, eventAttributeId?: any | null, value: any, createdAt: any, updatedAt: any, updatedBy?: any | null, eventAttributeValueUploads: Array<{ __typename?: 'eventAttributeValueUploads', id: any, name: string, eventAttributeValueUploadVersions: Array<{ __typename?: 'eventAttributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> }>, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null, eventAttribute?: { __typename?: 'eventAttributes', id: any, slug?: string | null, attributeType: AttributeTypes_Enum, config: any, name: string, order: number, eventAttributeGroup: { __typename?: 'eventAttributeGroups', id: any, name: string, order: number } } | null }>, parentEvent?: { __typename?: 'events', id: any, name: string } | null, rubinSTAMM?: { __typename?: 'V_ORGANICE_EVENT_STAMM', Titel?: string | null, ID_Rubin?: any | null, T_HASH_Event: any, Startdatum?: any | null, Enddatum?: any | null } | null } | null };

export type SetEventFavouriteMutationVariables = Exact<{
  eventId: Scalars['bigint']['input'];
}>;


export type SetEventFavouriteMutation = { __typename?: 'mutation_root', insert_eventFavourites_one?: { __typename?: 'eventFavourites', eventId: any, userId: any } | null };

export type UnsetEventFavouriteMutationVariables = Exact<{
  eventId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
}>;


export type UnsetEventFavouriteMutation = { __typename?: 'mutation_root', delete_eventFavourites_by_pk?: { __typename?: 'eventFavourites', eventId: any, userId: any } | null };

export type EventListQueryVariables = Exact<{
  where?: InputMaybe<Events_Bool_Exp>;
  order_by?: InputMaybe<Array<Events_Order_By> | Events_Order_By>;
  whereEventAttribute?: InputMaybe<EventAttributeValues_Bool_Exp>;
}>;


export type EventListQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'events', id: any, name: string, subTitle?: string | null, startDate?: any | null, endDate?: any | null, eventType: EventTypes_Enum, isArchived?: any | null, isCanceled?: any | null, parentId?: any | null, isFavourite?: boolean | null, guestCanEdit: boolean, guestOrganisationId?: any | null, guestCanEditRoommatrix: boolean, guestOrganisation?: { __typename?: 'organisations', name: string } | null, eventOrganisers: Array<{ __typename?: 'eventOrganisers', user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }>, events: Array<{ __typename?: 'events', id: any, name: string, subTitle?: string | null, parentId?: any | null, isFavourite?: boolean | null, startDate?: any | null, endDate?: any | null, eventAttributeValues: Array<{ __typename?: 'eventAttributeValues', value: any, eventAttribute?: { __typename?: 'eventAttributes', name: string, id: any, slug?: string | null } | null }> }>, eventAttributeValues: Array<{ __typename?: 'eventAttributeValues', value: any, eventAttribute?: { __typename?: 'eventAttributes', name: string, id: any, slug?: string | null } | null }> }> };

export type EventListWithRubinQueryVariables = Exact<{
  where?: InputMaybe<Events_Bool_Exp>;
  order_by?: InputMaybe<Array<Events_Order_By> | Events_Order_By>;
  whereEventAttribute?: InputMaybe<EventAttributeValues_Bool_Exp>;
}>;


export type EventListWithRubinQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'events', id: any, name: string, rubinHashEvent?: string | null, rubinSTAMM?: { __typename?: 'V_ORGANICE_EVENT_STAMM', Titel?: string | null, ID_Rubin?: any | null, T_HASH_Event: any, Startdatum?: any | null, Enddatum?: any | null } | null }> };

export type EventListExportQueryVariables = Exact<{
  where?: InputMaybe<Events_Bool_Exp>;
  order_by?: InputMaybe<Array<Events_Order_By> | Events_Order_By>;
  whereEventAttribute?: InputMaybe<EventAttributeValues_Bool_Exp>;
}>;


export type EventListExportQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'events', id: any, name: string, subTitle?: string | null, startDate?: any | null, endDate?: any | null, eventType: EventTypes_Enum, isArchived?: any | null, isCanceled?: any | null, parentId?: any | null, isFavourite?: boolean | null, services: Array<{ __typename?: 'services', id: any, name: string, serviceModules: Array<{ __typename?: 'serviceModules', id: any, name: string }> }>, events: Array<{ __typename?: 'events', id: any, name: string, subTitle?: string | null, parentId?: any | null, isFavourite?: boolean | null, startDate?: any | null, endDate?: any | null, eventAttributeValues: Array<{ __typename?: 'eventAttributeValues', value: any, eventAttribute?: { __typename?: 'eventAttributes', name: string, id: any } | null }> }> }> };

export type GetEventsInDateRangeQueryVariables = Exact<{
  startDate: Scalars['date']['input'];
  endDate: Scalars['date']['input'];
}>;


export type GetEventsInDateRangeQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'events', id: any, name: string, startDate?: any | null, endDate?: any | null, eventRooms: Array<{ __typename?: 'eventRooms', roomId: any, guestCanEdit: boolean, room: { __typename?: 'rooms', id: any, name: string, order: number, roomServices: Array<{ __typename?: 'roomServices', id: any, name: string, order?: number | null, description?: string | null }> } }>, eventAttributeValues: Array<{ __typename?: 'eventAttributeValues', id: any, value: any, createdAt: any, updatedAt: any, eventAttribute?: { __typename?: 'eventAttributes', id: any, attributeType: AttributeTypes_Enum, config: any, name: string, order: number, eventAttributeGroup: { __typename?: 'eventAttributeGroups', id: any, name: string, order: number } } | null }> }> };

export type GetEventsByOccurencesInRangeQueryVariables = Exact<{
  startDate: Scalars['timestamptz']['input'];
  endDate: Scalars['timestamptz']['input'];
}>;


export type GetEventsByOccurencesInRangeQuery = { __typename?: 'query_root', roomOccurrences: Array<{ __typename?: 'roomOccurrences', event: { __typename?: 'events', id: any, name: string, startDate?: any | null, endDate?: any | null, eventRooms: Array<{ __typename?: 'eventRooms', roomId: any, guestCanEdit: boolean, room: { __typename?: 'rooms', id: any, name: string, order: number, roomServices: Array<{ __typename?: 'roomServices', id: any, name: string, order?: number | null, description?: string | null }> } }>, eventAttributeValues: Array<{ __typename?: 'eventAttributeValues', id: any, value: any, createdAt: any, updatedAt: any, eventAttribute?: { __typename?: 'eventAttributes', id: any, attributeType: AttributeTypes_Enum, config: any, name: string, order: number, eventAttributeGroup: { __typename?: 'eventAttributeGroups', id: any, name: string, order: number } } | null }> } }>, roomServiceOccurrences: Array<{ __typename?: 'roomServiceOccurrences', event: { __typename?: 'events', id: any, name: string, startDate?: any | null, endDate?: any | null, eventRooms: Array<{ __typename?: 'eventRooms', roomId: any, guestCanEdit: boolean, room: { __typename?: 'rooms', id: any, name: string, order: number, roomServices: Array<{ __typename?: 'roomServices', id: any, name: string, order?: number | null, description?: string | null }> } }>, eventAttributeValues: Array<{ __typename?: 'eventAttributeValues', id: any, value: any, createdAt: any, updatedAt: any, eventAttribute?: { __typename?: 'eventAttributes', id: any, attributeType: AttributeTypes_Enum, config: any, name: string, order: number, eventAttributeGroup: { __typename?: 'eventAttributeGroups', id: any, name: string, order: number } } | null }> } }> };

export type GetEventConfigQueryVariables = Exact<{
  eventId: Scalars['bigint']['input'];
}>;


export type GetEventConfigQuery = { __typename?: 'query_root', events_by_pk?: { __typename?: 'events', id: any, name: string, config: any } | null };

export type GetMultipleEventConfigsQueryVariables = Exact<{
  eventIds: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
}>;


export type GetMultipleEventConfigsQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'events', id: any, name: string, config: any }> };

export type UpdateEventConfigMutationVariables = Exact<{
  eventId: Scalars['bigint']['input'];
  eventConfigUpdate: Scalars['json']['input'];
}>;


export type UpdateEventConfigMutation = { __typename?: 'mutation_root', update_events_by_pk?: { __typename?: 'events', id: any, config: any } | null };

export type UpdateEventMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  _set?: InputMaybe<Events_Set_Input>;
  eventAttributesToUpsert: Array<EventAttributeValues_Insert_Input> | EventAttributeValues_Insert_Input;
  eventAttributesToDelete: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
  eventAttributeValueUploadsToInsert: Array<EventAttributeValueUploads_Insert_Input> | EventAttributeValueUploads_Insert_Input;
  eventAttributeValueUploadVersionsToInsert: Array<EventAttributeValueUploadVersions_Insert_Input> | EventAttributeValueUploadVersions_Insert_Input;
  eventAttributeValueUploadVersionsToDelete: Array<EventAttributeValueUploadVersions_Bool_Exp> | EventAttributeValueUploadVersions_Bool_Exp;
  eventAttributeValueUploadsToDelete: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
}>;


export type UpdateEventMutation = { __typename?: 'mutation_root', delete_eventAttributeValueUploadVersions?: { __typename?: 'eventAttributeValueUploadVersions_mutation_response', affected_rows: number } | null, delete_eventAttributeValueUploads?: { __typename?: 'eventAttributeValueUploads_mutation_response', affected_rows: number } | null, insert_eventAttributeValues?: { __typename?: 'eventAttributeValues_mutation_response', returning: Array<{ __typename?: 'eventAttributeValues', id: any, value: any, eventAttributeId?: any | null }> } | null, insert_eventAttributeValueUploads?: { __typename?: 'eventAttributeValueUploads_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'eventAttributeValueUploads', id: any, eventAttributeValueId: any, eventAttributeValueUploadVersions: Array<{ __typename?: 'eventAttributeValueUploadVersions', eventAttributeValueUploadId: any, fileId: any }> }> } | null, insert_eventAttributeValueUploadVersions?: { __typename?: 'eventAttributeValueUploadVersions_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'eventAttributeValueUploadVersions', eventAttributeValueUploadId: any, fileId: any }> } | null, delete_eventAttributeValues?: { __typename?: 'eventAttributeValues_mutation_response', affected_rows: number } | null, update_events_by_pk?: { __typename?: 'events', id: any, name: string, subTitle?: string | null, startDate?: any | null, endDate?: any | null, eventType: EventTypes_Enum, isArchived?: any | null, isCanceled?: any | null, parentId?: any | null, guestCanEdit: boolean, guestCanEditRoommatrix: boolean, guestOrganisationId?: any | null, rubinHashEvent?: string | null, guestOrganisation?: { __typename?: 'organisations', name: string } | null, services: Array<{ __typename?: 'services', id: any, name: string }>, eventOrganisers: Array<{ __typename?: 'eventOrganisers', user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }>, events: Array<{ __typename?: 'events', id: any, name: string, subTitle?: string | null, rubinHashEvent?: string | null }>, eventAttributeValues: Array<{ __typename?: 'eventAttributeValues', id: any, eventAttributeId?: any | null, value: any, eventAttributeValueUploads: Array<{ __typename?: 'eventAttributeValueUploads', id: any, name: string, eventAttributeValueUploadVersions: Array<{ __typename?: 'eventAttributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> }>, eventAttribute?: { __typename?: 'eventAttributes', id: any, attributeType: AttributeTypes_Enum, eventAttributeGroup: { __typename?: 'eventAttributeGroups', id: any } } | null }>, rubinSTAMM?: { __typename?: 'V_ORGANICE_EVENT_STAMM', Titel?: string | null, ID_Rubin?: any | null, T_HASH_Event: any, Startdatum?: any | null, Enddatum?: any | null } | null } | null };

export type UpdateEventWithOrganisersMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  _set?: InputMaybe<Events_Set_Input>;
  organisers: Array<EventOrganisers_Insert_Input> | EventOrganisers_Insert_Input;
  eventAttributesToUpsert: Array<EventAttributeValues_Insert_Input> | EventAttributeValues_Insert_Input;
  eventAttributesToDelete: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
  eventAttributeValueUploadsToInsert: Array<EventAttributeValueUploads_Insert_Input> | EventAttributeValueUploads_Insert_Input;
  eventAttributeValueUploadVersionsToInsert: Array<EventAttributeValueUploadVersions_Insert_Input> | EventAttributeValueUploadVersions_Insert_Input;
  eventAttributeValueUploadVersionsToDelete: Array<EventAttributeValueUploadVersions_Bool_Exp> | EventAttributeValueUploadVersions_Bool_Exp;
  eventAttributeValueUploadsToDelete: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
}>;


export type UpdateEventWithOrganisersMutation = { __typename?: 'mutation_root', delete_eventOrganisers?: { __typename?: 'eventOrganisers_mutation_response', affected_rows: number } | null, insert_eventOrganisers?: { __typename?: 'eventOrganisers_mutation_response', affected_rows: number } | null, delete_eventAttributeValueUploadVersions?: { __typename?: 'eventAttributeValueUploadVersions_mutation_response', affected_rows: number } | null, delete_eventAttributeValueUploads?: { __typename?: 'eventAttributeValueUploads_mutation_response', affected_rows: number } | null, insert_eventAttributeValues?: { __typename?: 'eventAttributeValues_mutation_response', returning: Array<{ __typename?: 'eventAttributeValues', id: any, value: any, eventAttributeId?: any | null }> } | null, insert_eventAttributeValueUploads?: { __typename?: 'eventAttributeValueUploads_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'eventAttributeValueUploads', id: any, eventAttributeValueId: any, eventAttributeValueUploadVersions: Array<{ __typename?: 'eventAttributeValueUploadVersions', eventAttributeValueUploadId: any, fileId: any }> }> } | null, insert_eventAttributeValueUploadVersions?: { __typename?: 'eventAttributeValueUploadVersions_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'eventAttributeValueUploadVersions', eventAttributeValueUploadId: any, fileId: any }> } | null, delete_eventAttributeValues?: { __typename?: 'eventAttributeValues_mutation_response', affected_rows: number } | null, update_events_by_pk?: { __typename?: 'events', id: any, name: string, subTitle?: string | null, startDate?: any | null, endDate?: any | null, eventType: EventTypes_Enum, isArchived?: any | null, isCanceled?: any | null, parentId?: any | null, guestCanEdit: boolean, guestCanEditRoommatrix: boolean, guestOrganisationId?: any | null, rubinHashEvent?: string | null, guestOrganisation?: { __typename?: 'organisations', name: string } | null, services: Array<{ __typename?: 'services', id: any, name: string }>, eventOrganisers: Array<{ __typename?: 'eventOrganisers', user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }>, events: Array<{ __typename?: 'events', id: any, name: string, subTitle?: string | null, rubinHashEvent?: string | null }>, eventAttributeValues: Array<{ __typename?: 'eventAttributeValues', id: any, eventAttributeId?: any | null, value: any, eventAttributeValueUploads: Array<{ __typename?: 'eventAttributeValueUploads', id: any, name: string, eventAttributeValueUploadVersions: Array<{ __typename?: 'eventAttributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> }>, eventAttribute?: { __typename?: 'eventAttributes', id: any, attributeType: AttributeTypes_Enum, eventAttributeGroup: { __typename?: 'eventAttributeGroups', id: any } } | null }>, rubinSTAMM?: { __typename?: 'V_ORGANICE_EVENT_STAMM', Titel?: string | null, ID_Rubin?: any | null, T_HASH_Event: any, Startdatum?: any | null, Enddatum?: any | null } | null } | null };

export type UpdateGuestCanEditRoommatrixMutationVariables = Exact<{
  eventId: Scalars['bigint']['input'];
  guestCanEditRoommatrix: Scalars['Boolean']['input'];
}>;


export type UpdateGuestCanEditRoommatrixMutation = { __typename?: 'mutation_root', update_events_by_pk?: { __typename?: 'events', id: any, guestCanEditRoommatrix: boolean } | null };

export type DeleteFileMasterVersionMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteFileMasterVersionMutation = { __typename?: 'mutation_root', delete_fileMasterVersions_by_pk?: { __typename?: 'fileMasterVersions', id: any } | null };

export type DeleteFileMasterMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteFileMasterMutation = { __typename?: 'mutation_root', delete_fileMasters_by_pk?: { __typename?: 'fileMasters', id: any } | null };

export type FileMasterByIdQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type FileMasterByIdQuery = { __typename?: 'query_root', fileMasters_by_pk?: { __typename?: 'fileMasters', id: any, name: string, fileMasterVersions: Array<{ __typename?: 'fileMasterVersions', id: any, fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, name: string, extension: string, updatedAt: any, createdAt: any } }> } | null };

export type FileMasterSearchQueryVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type FileMasterSearchQuery = { __typename?: 'query_root', fileMasters: Array<{ __typename?: 'fileMasters', id: any, name: string, createdAt: any, updatedAt: any, fileMasterVersions: Array<{ __typename?: 'fileMasterVersions', id: any, fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, name: string, extension: string, mimeType?: string | null, updatedAt: any, createdAt: any } }> }> };

export type FileMasterListQueryVariables = Exact<{ [key: string]: never; }>;


export type FileMasterListQuery = { __typename?: 'query_root', fileMasters: Array<{ __typename?: 'fileMasters', id: any, name: string, createdAt: any, updatedAt: any, childVersionsUpdatedAt: any, fileMasterVersions: Array<{ __typename?: 'fileMasterVersions', id: any, fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, name: string, extension: string, mimeType?: string | null, updatedAt: any, createdAt: any } }> }> };

export type FileMasterListRecentQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FileMasterListRecentQuery = { __typename?: 'query_root', fileMasters: Array<{ __typename?: 'fileMasters', id: any, name: string, createdAt: any, updatedAt: any, childVersionsUpdatedAt: any, fileMasterVersions: Array<{ __typename?: 'fileMasterVersions', id: any, fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, name: string, extension: string, mimeType?: string | null, updatedAt: any, createdAt: any } }> }> };

export type InsertFileMasterVersionMutationVariables = Exact<{
  object: FileMasterVersions_Insert_Input;
}>;


export type InsertFileMasterVersionMutation = { __typename?: 'mutation_root', insert_fileMasterVersions_one?: { __typename?: 'fileMasterVersions', id: any, fileId: any } | null };

export type InsertFileMasterMutationVariables = Exact<{
  object: FileMasters_Insert_Input;
}>;


export type InsertFileMasterMutation = { __typename?: 'mutation_root', insert_fileMasters_one?: { __typename?: 'fileMasters', id: any, name: string } | null };

export type UpdateFileMasterMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  changes: FileMasters_Set_Input;
}>;


export type UpdateFileMasterMutation = { __typename?: 'mutation_root', update_fileMasters_by_pk?: { __typename?: 'fileMasters', id: any, name: string } | null };

export type RoomChangesQueryVariables = Exact<{
  where: RoomChanges_Bool_Exp;
}>;


export type RoomChangesQuery = { __typename?: 'query_root', roomChanges: Array<{ __typename?: 'roomChanges', id: any, createdAt: any, eventId: any, roomId: any, roomServiceId?: any | null, userId?: any | null, table: string, op: string, displayData: any, room: { __typename?: 'rooms', name: string }, roomService?: { __typename?: 'roomServices', name: string } | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }> };

export type SingleRoomAttributeQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type SingleRoomAttributeQuery = { __typename?: 'query_root', roomAttributes_by_pk?: { __typename?: 'roomAttributes', id: any, name: string, description?: string | null, attributeType: AttributeTypes_Enum, config: any, order: number, roomAttributeGroup: { __typename?: 'roomAttributeGroups', id: any, name: string } } | null };

export type GetServiceModuleChangesByServiceModuleIdGroupedQueryVariables = Exact<{
  serviceModuleId?: InputMaybe<Scalars['bigint']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetServiceModuleChangesByServiceModuleIdGroupedQuery = { __typename?: 'query_root', serviceModuleChanges_grouped: Array<{ __typename?: 'serviceModuleChanges_grouped', createdAt?: any | null, serviceModuleId?: any | null, changes?: any | null, user?: { __typename?: 'allUsers', firstName?: string | null, lastName?: string | null } | null, serviceModule?: { __typename?: 'serviceModules', moduleType: ModuleTypes_Enum } | null }>, serviceModuleChanges_grouped_aggregate: { __typename?: 'serviceModuleChanges_grouped_aggregate', aggregate?: { __typename?: 'serviceModuleChanges_grouped_aggregate_fields', count: number } | null } };

export type GetModuleByIdQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
  guestOrganisationId?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type GetModuleByIdQuery = { __typename?: 'query_root', serviceModules_by_pk?: { __typename?: 'serviceModules', id: any, moduleType: ModuleTypes_Enum, uploads: Array<{ __typename?: 'uploads', id: any, name: string, comments_aggregate: { __typename?: 'uploadComments_aggregate', aggregate?: { __typename?: 'uploadComments_aggregate_fields', count: number } | null }, current: Array<{ __typename?: 'uploadVersions', id: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, name: string, extension: string, mimeType?: string | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }>, archive: Array<{ __typename?: 'uploadVersions', id: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, name: string, extension: string, mimeType?: string | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> }> } | null };

export type GetModuleByIdWithJaggaerInfoRealtimeSubscriptionVariables = Exact<{
  id: Scalars['bigint']['input'];
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
  guestOrganisationId?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type GetModuleByIdWithJaggaerInfoRealtimeSubscription = { __typename?: 'subscription_root', serviceModules_by_pk?: { __typename?: 'serviceModules', id: any, moduleType: ModuleTypes_Enum, uploads: Array<{ __typename?: 'uploads', id: any, name: string, comments_aggregate: { __typename?: 'uploadComments_aggregate', aggregate?: { __typename?: 'uploadComments_aggregate_fields', count: number } | null }, current: Array<{ __typename?: 'uploadVersions', id: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, name: string, extension: string, mimeType?: string | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }, jaggaerSubmissions: Array<{ __typename?: 'jaggaerSubmissions', id: any, fileId?: any | null, uploadVersionId?: any | null, jaggaerArticleId?: string | null, lastAttachmentResponse?: string | null, nextTryAfter?: any | null, updatedAt: any, createdAt: any, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null, jaggaerBanf?: { __typename?: 'jaggaerBanfs', id: any, jaggaerBanf: string } | null }> }>, archive: Array<{ __typename?: 'uploadVersions', id: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, name: string, extension: string, mimeType?: string | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }, jaggaerSubmissions: Array<{ __typename?: 'jaggaerSubmissions', id: any, fileId?: any | null, uploadVersionId?: any | null, jaggaerArticleId?: string | null, lastAttachmentResponse?: string | null, nextTryAfter?: any | null, updatedAt: any, createdAt: any, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null, jaggaerBanf?: { __typename?: 'jaggaerBanfs', id: any, jaggaerBanf: string } | null }> }> }> } | null };

export type GetModuleByIdRealtimeSubscriptionVariables = Exact<{
  id: Scalars['bigint']['input'];
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
  guestOrganisationId?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type GetModuleByIdRealtimeSubscription = { __typename?: 'subscription_root', serviceModules_by_pk?: { __typename?: 'serviceModules', id: any, moduleType: ModuleTypes_Enum, uploads: Array<{ __typename?: 'uploads', id: any, name: string, comments_aggregate: { __typename?: 'uploadComments_aggregate', aggregate?: { __typename?: 'uploadComments_aggregate_fields', count: number } | null }, current: Array<{ __typename?: 'uploadVersions', id: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, name: string, extension: string, mimeType?: string | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }>, archive: Array<{ __typename?: 'uploadVersions', id: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, name: string, extension: string, mimeType?: string | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> }> } | null };

export type UploadVersionFieldsWithJaggaerInfoFragment = { __typename?: 'uploadVersions', id: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, name: string, extension: string, mimeType?: string | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }, jaggaerSubmissions: Array<{ __typename?: 'jaggaerSubmissions', id: any, fileId?: any | null, uploadVersionId?: any | null, jaggaerArticleId?: string | null, lastAttachmentResponse?: string | null, nextTryAfter?: any | null, updatedAt: any, createdAt: any, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null, jaggaerBanf?: { __typename?: 'jaggaerBanfs', id: any, jaggaerBanf: string } | null }> };

export type UploadVersionFieldsFragment = { __typename?: 'uploadVersions', id: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, name: string, extension: string, mimeType?: string | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } };

export type GetServiceModuleHistoryQueryVariables = Exact<{
  serviceModuleId: Scalars['bigint']['input'];
}>;


export type GetServiceModuleHistoryQuery = { __typename?: 'query_root', serviceModules_by_pk?: { __typename?: 'serviceModules', id: any, name: string, moduleType: ModuleTypes_Enum, service: { __typename?: 'services', name: string, event?: { __typename?: 'events', name: string } | null } } | null };

export type SetPublishOnServiceModuleMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  published: Scalars['Boolean']['input'];
}>;


export type SetPublishOnServiceModuleMutation = { __typename?: 'mutation_root', update_serviceModules_by_pk?: { __typename?: 'serviceModules', id: any, name: string, published?: boolean | null, service: { __typename?: 'services', id: any, eventId?: any | null } } | null };

export type AddNewsMutationVariables = Exact<{
  object: News_Insert_Input;
}>;


export type AddNewsMutation = { __typename?: 'mutation_root', insert_news_one?: { __typename?: 'news', title: string, content: string, createdAt: any, createdBy?: any | null } | null };

export type GetNewsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewsQuery = { __typename?: 'query_root', news: Array<{ __typename?: 'news', title: string, content: string, createdAt: any, createdBy?: any | null }> };

export type NotificationByIdQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type NotificationByIdQuery = { __typename?: 'query_root', notifications_by_pk?: { __typename?: 'notifications', id: any, createdAt: any, userId: any, data: any, eventId?: any | null, serviceId?: any | null, attributeValueCommentId?: any | null, roomAttributeValueId?: any | null, uploadCommentId?: any | null, readAt?: any | null } | null };

export type GetNotificationMessageByIdUnusedQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type GetNotificationMessageByIdUnusedQuery = { __typename?: 'query_root', notificationMessages_by_pk?: { __typename?: 'notificationMessages', id: any, createdAt: any, notificationId: any, readAt?: any | null, sentAt?: any | null, notification: { __typename?: 'notifications', id: any, createdAt: any, userId: any, eventId?: any | null, readAt?: any | null, notificationAction: NotificationActions_Enum, serviceId?: any | null, serviceModuleId?: any | null, eventAttributeValueId?: any | null, authorUserId?: any | null, attributeValueId?: any | null, attributeValueCommentId?: any | null, roomAttributeValueId?: any | null, uploadCommentId?: any | null, fileId?: any | null, event?: { __typename?: 'events', name: string } | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null, organisationId?: any | null } | null, service?: { __typename?: 'services', name: string } | null, serviceModule?: { __typename?: 'serviceModules', name: string, moduleType: ModuleTypes_Enum } | null, eventAttributeValue?: { __typename?: 'eventAttributeValues', eventAttribute?: { __typename?: 'eventAttributes', name: string } | null } | null, attributeValueComment?: { __typename?: 'attributeValueComments', organisationId?: any | null, attributeValueId: any } | null, uploadComment?: { __typename?: 'uploadComments', organisationId?: any | null, uploadId: any } | null, roomAttributeValueComment?: { __typename?: 'roomAttributeValueComments', organisationId?: any | null, roomAttributeValueId: any } | null } } | null };

export type DeleteNotificationPreferenceMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteNotificationPreferenceMutation = { __typename?: 'mutation_root', delete_notificationPreferences_by_pk?: { __typename?: 'notificationPreferences', id: any } | null };

export type AddNotificationPreferenceMutationVariables = Exact<{
  object: NotificationPreferences_Insert_Input;
}>;


export type AddNotificationPreferenceMutation = { __typename?: 'mutation_root', insert_notificationPreferences_one?: { __typename?: 'notificationPreferences', id: any, notificationAction: NotificationActions_Enum, notificationChannel: NotificationChannels_Enum, notificationPreferenceStage: NotificationPreferenceStages_Enum, userId?: any | null } | null };

export type AddNotificationServicePreferencesMutationVariables = Exact<{
  serviceId: Scalars['bigint']['input'];
}>;


export type AddNotificationServicePreferencesMutation = { __typename?: 'mutation_root', insert_notificationServicePreferences_one?: { __typename?: 'notificationServicePreferences', userId: any, serviceId: any } | null };

export type DeleteNotificationServicePreferencesMutationVariables = Exact<{
  serviceId: Scalars['bigint']['input'];
}>;


export type DeleteNotificationServicePreferencesMutation = { __typename?: 'mutation_root', delete_notificationServicePreferences?: { __typename?: 'notificationServicePreferences_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'notificationServicePreferences', userId: any, serviceId: any }> } | null };

export type SetOranisationMentionNotificationPreferenceMutationVariables = Exact<{
  notificationForOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetOranisationMentionNotificationPreferenceMutation = { __typename?: 'mutation_root', update_userSettings?: { __typename?: 'userSettings_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'userSettings', id?: any | null, notificationForOrganisation?: boolean | null, wantRoomOccurrenceNotifications?: boolean | null }> } | null };

export type SetUserSettingsNotificationPreferenceMutationVariables = Exact<{
  userSettings?: InputMaybe<UserSettings_Set_Input>;
}>;


export type SetUserSettingsNotificationPreferenceMutation = { __typename?: 'mutation_root', update_userSettings?: { __typename?: 'userSettings_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'userSettings', id?: any | null, notificationForOrganisation?: boolean | null, wantRoomOccurrenceNotifications?: boolean | null }> } | null };

export type AddRoomServiceCategoryPreferenceMutationVariables = Exact<{
  roomServiceCategoryId: Scalars['bigint']['input'];
}>;


export type AddRoomServiceCategoryPreferenceMutation = { __typename?: 'mutation_root', insert_notificationRoomServiceCategoryPreferences_one?: { __typename?: 'notificationRoomServiceCategoryPreferences', userId: any, roomServiceCategoryId: any } | null };

export type DeleteRoomServiceCategoryPreferenceMutationVariables = Exact<{
  roomServiceCategoryId: Scalars['bigint']['input'];
}>;


export type DeleteRoomServiceCategoryPreferenceMutation = { __typename?: 'mutation_root', delete_notificationRoomServiceCategoryPreferences?: { __typename?: 'notificationRoomServiceCategoryPreferences_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'notificationRoomServiceCategoryPreferences', userId: any, roomServiceCategoryId: any }> } | null };

export type NotificationPreferencesMetaQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationPreferencesMetaQuery = { __typename?: 'query_root', notificationChannels: Array<{ __typename?: 'notificationChannels', name: string }>, notificationActions: Array<{ __typename?: 'notificationActions', name: string }>, notificationPreferenceStages: Array<{ __typename?: 'notificationPreferenceStages', name: string }> };

export type MyNotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyNotificationPreferencesQuery = { __typename?: 'query_root', notificationPreferences: Array<{ __typename?: 'notificationPreferences', id: any, notificationAction: NotificationActions_Enum, notificationChannel: NotificationChannels_Enum, notificationPreferenceStage: NotificationPreferenceStages_Enum, userId?: any | null }> };

export type MyNotificationServicePreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyNotificationServicePreferencesQuery = { __typename?: 'query_root', notificationServicePreferences: Array<{ __typename?: 'notificationServicePreferences', serviceId: any, userId: any }> };

export type MyRoomServiceCategoryPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyRoomServiceCategoryPreferencesQuery = { __typename?: 'query_root', notificationRoomServiceCategoryPreferences: Array<{ __typename?: 'notificationRoomServiceCategoryPreferences', roomServiceCategoryId: any, userId: any }> };

export type UnreadNotificationMessagesListQueryVariables = Exact<{
  where: NotificationMessages_Bool_Exp;
}>;


export type UnreadNotificationMessagesListQuery = { __typename?: 'query_root', notificationMessages: Array<{ __typename?: 'notificationMessages', id: any, createdAt: any, notificationId: any, readAt?: any | null, sentAt?: any | null, notification: { __typename?: 'notifications', id: any, createdAt: any, userId: any, eventId?: any | null, readAt?: any | null, notificationAction: NotificationActions_Enum, serviceId?: any | null, serviceModuleId?: any | null, eventAttributeValueId?: any | null, authorUserId?: any | null, attributeValueId?: any | null, attributeValueCommentId?: any | null, roomAttributeValueId?: any | null, uploadCommentId?: any | null, roomAttributeValueCommentId?: any | null, fileId?: any | null, event?: { __typename?: 'events', name: string } | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null, organisationId?: any | null } | null, service?: { __typename?: 'services', name: string } | null, serviceModule?: { __typename?: 'serviceModules', name: string, moduleType: ModuleTypes_Enum } | null, attributeValueComment?: { __typename?: 'attributeValueComments', attributeValueId: any } | null, uploadComment?: { __typename?: 'uploadComments', organisationId?: any | null, uploadId: any } | null, roomAttributeValueComment?: { __typename?: 'roomAttributeValueComments', id: any, organisationId?: any | null, roomAttributeValueId: any } | null, roomAttributeValue?: { __typename?: 'roomAttributeValues', roomAttribute: { __typename?: 'roomAttributes', name: string, description?: string | null } } | null, roomServiceOccurrence?: { __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any } | null, roomService?: { __typename?: 'roomServices', id: any, name: string } | null, room?: { __typename?: 'rooms', id: any, name: string } | null } }> };

export type GetNotificationMessageByIdQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type GetNotificationMessageByIdQuery = { __typename?: 'query_root', notificationMessages_by_pk?: { __typename?: 'notificationMessages', id: any, createdAt: any, notificationId: any, readAt?: any | null, sentAt?: any | null, notification: { __typename?: 'notifications', id: any, createdAt: any, userId: any, eventId?: any | null, readAt?: any | null, notificationAction: NotificationActions_Enum, serviceId?: any | null, serviceModuleId?: any | null, eventAttributeValueId?: any | null, authorUserId?: any | null, attributeValueId?: any | null, attributeValueCommentId?: any | null, roomAttributeValueId?: any | null, uploadCommentId?: any | null, roomAttributeValueCommentId?: any | null, fileId?: any | null, event?: { __typename?: 'events', name: string, guestOrganisationId?: any | null } | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null, organisationId?: any | null } | null, service?: { __typename?: 'services', name: string } | null, serviceModule?: { __typename?: 'serviceModules', name: string, moduleType: ModuleTypes_Enum } | null, eventAttributeValue?: { __typename?: 'eventAttributeValues', eventAttribute?: { __typename?: 'eventAttributes', name: string } | null } | null, attributeValueComment?: { __typename?: 'attributeValueComments', attributeValueId: any } | null, uploadComment?: { __typename?: 'uploadComments', organisationId?: any | null, uploadId: any } | null, roomAttributeValueComment?: { __typename?: 'roomAttributeValueComments', id: any, organisationId?: any | null, roomAttributeValueId: any } | null, roomAttributeValue?: { __typename?: 'roomAttributeValues', roomAttribute: { __typename?: 'roomAttributes', name: string } } | null, roomServiceOccurrence?: { __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any } | null, roomService?: { __typename?: 'roomServices', id: any, name: string } | null, room?: { __typename?: 'rooms', id: any, name: string } | null } } | null };

export type QueryNotificationMessagesListQueryVariables = Exact<{
  notificationChannel: NotificationChannels_Enum;
  notificationActionsFilter?: InputMaybe<NotificationActions_Enum_Comparison_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type QueryNotificationMessagesListQuery = { __typename?: 'query_root', allNotificationMessagesAggregate: { __typename?: 'notificationMessages_aggregate', aggregate?: { __typename?: 'notificationMessages_aggregate_fields', count: number } | null }, unreadNotificationMessagesAggregate: { __typename?: 'notificationMessages_aggregate', aggregate?: { __typename?: 'notificationMessages_aggregate_fields', count: number } | null }, notificationMessages: Array<{ __typename?: 'notificationMessages', id: any, createdAt: any, notificationId: any, readAt?: any | null, sentAt?: any | null, notification: { __typename?: 'notifications', id: any, createdAt: any, userId: any, eventId?: any | null, readAt?: any | null, newerNotificationId?: any | null, notificationAction: NotificationActions_Enum, serviceId?: any | null, serviceModuleId?: any | null, eventAttributeValueId?: any | null, authorUserId?: any | null, attributeValueId?: any | null, attributeValueCommentId?: any | null, roomAttributeValueId?: any | null, uploadCommentId?: any | null, roomAttributeValueCommentId?: any | null, fileId?: any | null, event?: { __typename?: 'events', name: string, guestOrganisationId?: any | null } | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null, organisationId?: any | null } | null, service?: { __typename?: 'services', name: string } | null, serviceModule?: { __typename?: 'serviceModules', name: string, moduleType: ModuleTypes_Enum } | null, eventAttributeValue?: { __typename?: 'eventAttributeValues', eventAttribute?: { __typename?: 'eventAttributes', name: string } | null } | null, attributeValueComment?: { __typename?: 'attributeValueComments', organisationId?: any | null, attributeValueId: any } | null, uploadComment?: { __typename?: 'uploadComments', organisationId?: any | null, uploadId: any } | null, roomAttributeValueComment?: { __typename?: 'roomAttributeValueComments', id: any, organisationId?: any | null, roomAttributeValueId: any } | null, roomAttributeValue?: { __typename?: 'roomAttributeValues', roomAttribute: { __typename?: 'roomAttributes', name: string, description?: string | null } } | null, roomServiceOccurrence?: { __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any } | null, roomService?: { __typename?: 'roomServices', id: any, name: string } | null, room?: { __typename?: 'rooms', id: any, name: string } | null } }> };

export type QueryCommentNotificationMessagesListQueryVariables = Exact<{
  notificationChannel: NotificationChannels_Enum;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type QueryCommentNotificationMessagesListQuery = { __typename?: 'query_root', allCommentNtificationsAggregat: { __typename?: 'notificationMessages_aggregate', aggregate?: { __typename?: 'notificationMessages_aggregate_fields', count: number } | null }, unreadCommentNtificationsAggregate: { __typename?: 'notificationMessages_aggregate', aggregate?: { __typename?: 'notificationMessages_aggregate_fields', count: number } | null }, notificationMessages: Array<{ __typename?: 'notificationMessages', id: any, createdAt: any, notificationId: any, readAt?: any | null, sentAt?: any | null, notification: { __typename?: 'notifications', id: any, createdAt: any, userId: any, eventId?: any | null, readAt?: any | null, notificationAction: NotificationActions_Enum, serviceId?: any | null, serviceModuleId?: any | null, eventAttributeValueId?: any | null, authorUserId?: any | null, attributeValueId?: any | null, attributeValueCommentId?: any | null, roomAttributeValueId?: any | null, uploadCommentId?: any | null, roomAttributeValueCommentId?: any | null, fileId?: any | null, event?: { __typename?: 'events', name: string, guestOrganisationId?: any | null } | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null, organisationId?: any | null } | null, service?: { __typename?: 'services', name: string } | null, serviceModule?: { __typename?: 'serviceModules', name: string, moduleType: ModuleTypes_Enum } | null, eventAttributeValue?: { __typename?: 'eventAttributeValues', eventAttribute?: { __typename?: 'eventAttributes', name: string } | null } | null, attributeValueComment?: { __typename?: 'attributeValueComments', organisationId?: any | null, attributeValueId: any } | null, uploadComment?: { __typename?: 'uploadComments', organisationId?: any | null, uploadId: any } | null, roomAttributeValueComment?: { __typename?: 'roomAttributeValueComments', id: any, organisationId?: any | null, roomAttributeValueId: any } | null, roomAttributeValue?: { __typename?: 'roomAttributeValues', roomAttribute: { __typename?: 'roomAttributes', name: string, description?: string | null } } | null, roomServiceOccurrence?: { __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any } | null, roomService?: { __typename?: 'roomServices', id: any, name: string } | null, room?: { __typename?: 'rooms', id: any, name: string } | null } }> };

export type UnreadNotificationMessagesCountSubscriptionVariables = Exact<{
  notificationChannel: NotificationChannels_Enum;
  notificationActionsFilter?: InputMaybe<NotificationActions_Enum_Comparison_Exp>;
}>;


export type UnreadNotificationMessagesCountSubscription = { __typename?: 'subscription_root', notificationMessages_aggregate: { __typename?: 'notificationMessages_aggregate', aggregate?: { __typename?: 'notificationMessages_aggregate_fields', count: number } | null } };

export type UnreadWebNotificationsCountSubscriptionVariables = Exact<{
  notificationChannel: NotificationChannels_Enum;
}>;


export type UnreadWebNotificationsCountSubscription = { __typename?: 'subscription_root', notificationMessages_aggregate: { __typename?: 'notificationMessages_aggregate', aggregate?: { __typename?: 'notificationMessages_aggregate_fields', count: number } | null } };

export type UnreadCommentNotificationMessagesCountSubscriptionVariables = Exact<{
  notificationChannel: NotificationChannels_Enum;
}>;


export type UnreadCommentNotificationMessagesCountSubscription = { __typename?: 'subscription_root', notificationMessages_aggregate: { __typename?: 'notificationMessages_aggregate', aggregate?: { __typename?: 'notificationMessages_aggregate_fields', count: number } | null } };

export type NotificationsListSubscriptionVariables = Exact<{
  where?: InputMaybe<Notifications_Bool_Exp>;
}>;


export type NotificationsListSubscription = { __typename?: 'subscription_root', notifications: Array<{ __typename?: 'notifications', id: any, createdAt: any, userId: any, eventId?: any | null, serviceId?: any | null, attributeValueCommentId?: any | null, roomAttributeValueId?: any | null, uploadCommentId?: any | null, readAt?: any | null, notificationAction: NotificationActions_Enum, serviceModuleId?: any | null, eventAttributeValueId?: any | null, authorUserId?: any | null, attributeValueId?: any | null, fileId?: any | null, roomServiceOccurrenceId?: any | null, event?: { __typename?: 'events', name: string } | null, notificationMessages: Array<{ __typename?: 'notificationMessages', id: any }>, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null, organisationId?: any | null } | null, service?: { __typename?: 'services', name: string } | null, eventAttributeValue?: { __typename?: 'eventAttributeValues', eventAttribute?: { __typename?: 'eventAttributes', name: string } | null } | null }> };

export type MarkNotificationsAsReadMutationVariables = Exact<{
  notificationMessageIds: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
  read?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type MarkNotificationsAsReadMutation = { __typename?: 'mutation_root', update_notificationMessages?: { __typename?: 'notificationMessages_mutation_response', returning: Array<{ __typename?: 'notificationMessages', id: any, readAt?: any | null }> } | null };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{
  notificationActionsFilter?: InputMaybe<NotificationActions_Enum_Comparison_Exp>;
  notificationChannelsFilter?: InputMaybe<NotificationChannels_Enum_Comparison_Exp>;
}>;


export type MarkAllNotificationsAsReadMutation = { __typename?: 'mutation_root', update_notificationMessages?: { __typename?: 'notificationMessages_mutation_response', returning: Array<{ __typename?: 'notificationMessages', id: any, readAt?: any | null }> } | null };

export type GetJaggaerSubmissionByFileQueryVariables = Exact<{
  fileId: Scalars['bigint']['input'];
  uploadVersionId: Scalars['bigint']['input'];
}>;


export type GetJaggaerSubmissionByFileQuery = { __typename?: 'query_root', jaggaerSubmissions: Array<{ __typename?: 'jaggaerSubmissions', id: any, data: any, fileId?: any | null, uploadVersionId?: any | null, userId: any, lastAttachmentResponse?: string | null, nextTryAfter?: any | null, updatedAt: any, createdAt: any, uploadVersion?: { __typename?: 'uploadVersions', id: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, name: string, extension: string, mimeType?: string | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }, upload: { __typename?: 'uploads', id: any, name: string, serviceModule: { __typename?: 'serviceModules', service: { __typename?: 'services', event?: { __typename?: 'events', id: any, name: string } | null } } } } | null, jaggaerBanf?: { __typename?: 'jaggaerBanfs', jaggaerBanf: string } | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null, organisation?: { __typename?: 'organisations', id: any, name: string } | null } | null }> };

export type GetJaggaerSubmissionsByFileIdListQueryVariables = Exact<{
  fileIds: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
}>;


export type GetJaggaerSubmissionsByFileIdListQuery = { __typename?: 'query_root', jaggaerSubmissions: Array<{ __typename?: 'jaggaerSubmissions', id: any, fileId?: any | null, uploadVersionId?: any | null, jaggaerArticleId?: string | null, lastAttachmentResponse?: string | null, nextTryAfter?: any | null, updatedAt: any, createdAt: any }> };

export type SubmitJaggaerOrderMutationVariables = Exact<{
  uploadVersionId: Scalars['bigint']['input'];
  fileId: Scalars['bigint']['input'];
  data: Scalars['json']['input'];
}>;


export type SubmitJaggaerOrderMutation = { __typename?: 'mutation_root', insert_jaggaerSubmissions_one?: { __typename?: 'jaggaerSubmissions', id: any, data: any, fileId?: any | null, uploadVersionId?: any | null, userId: any, jaggaerArticleId?: string | null, lastAttachmentRequestAt?: any | null, lastAttachmentResponse?: string | null, lastMonitoringRequestAt?: any | null, lastMonitoringResponse?: string | null, lastQueueRequestAt?: any | null, lastQueueResponse?: string | null, lastUploadRequestAt?: any | null, lastUploadResponse?: string | null, nextTryAfter?: any | null, numAttachmentRequests?: any | null, numMonitoringRequests?: any | null, numQueueRequests: any, numUploadRequests: any, updatedAt: any, createdAt: any, uploadVersion?: { __typename?: 'uploadVersions', id: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, name: string, extension: string, mimeType?: string | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null }, upload: { __typename?: 'uploads', id: any, name: string, serviceModule: { __typename?: 'serviceModules', service: { __typename?: 'services', event?: { __typename?: 'events', id: any, name: string } | null } } } } | null } | null };

export type AddOrganisationGroupsMutationVariables = Exact<{
  objects: Array<OrganisationGroups_Insert_Input> | OrganisationGroups_Insert_Input;
}>;


export type AddOrganisationGroupsMutation = { __typename?: 'mutation_root', insert_organisationGroups?: { __typename?: 'organisationGroups_mutation_response', affected_rows: number } | null };

export type OrganisationGroupByIdQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type OrganisationGroupByIdQuery = { __typename?: 'query_root', organisations_by_pk?: { __typename?: 'organisations', id: any, createdAt: any, updatedAt: any, name: string, users: Array<{ __typename?: 'users', id: any, firstName?: string | null, lastName?: string | null }> } | null };

export type OrganisationGroupsListQueryVariables = Exact<{
  where?: InputMaybe<OrganisationGroups_Bool_Exp>;
}>;


export type OrganisationGroupsListQuery = { __typename?: 'query_root', organisationGroups: Array<{ __typename?: 'organisationGroups', id: any, name: string }> };

export type UpdateOrganisationGroupMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  object: OrganisationGroups_Set_Input;
}>;


export type UpdateOrganisationGroupMutation = { __typename?: 'mutation_root', update_organisationGroups_by_pk?: { __typename?: 'organisationGroups', id: any } | null };

export type AddOrganisationMutationVariables = Exact<{
  object: Organisations_Insert_Input;
}>;


export type AddOrganisationMutation = { __typename?: 'mutation_root', insert_organisations_one?: { __typename?: 'organisations', id: any, createdAt: any, updatedAt: any, name: string, isGuestOrga: boolean, organisationGroups: Array<{ __typename?: 'organisationGroups', organisationId?: any | null }> } | null };

export type DeleteOrganisationMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteOrganisationMutation = { __typename?: 'mutation_root', delete_organisations_by_pk?: { __typename?: 'organisations', id: any } | null };

export type OrganisationByIdQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type OrganisationByIdQuery = { __typename?: 'query_root', organisations_by_pk?: { __typename?: 'organisations', id: any, createdAt: any, updatedAt: any, name: string, isGuestOrga: boolean, organisationGroups: Array<{ __typename?: 'organisationGroups', id: any, name: string, isAdmin: boolean, isOrgaAdmin: boolean, organisationGroupUsers: Array<{ __typename?: 'organisationGroupUsers', user: { __typename?: 'users', id: any, firstName?: string | null, lastName?: string | null } }> }> } | null };

export type OrganisationsListQueryVariables = Exact<{
  where?: InputMaybe<Organisations_Bool_Exp>;
}>;


export type OrganisationsListQuery = { __typename?: 'query_root', organisations: Array<{ __typename?: 'organisations', id: any, name: string, isGuestOrga: boolean, organisationGroups: Array<{ __typename?: 'organisationGroups', id: any, name: string }> }> };

export type UpdateOrganisationMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  object?: InputMaybe<Organisations_Set_Input>;
  organisationGroups: Array<OrganisationGroups_Insert_Input> | OrganisationGroups_Insert_Input;
  organisationGroupsDelete?: InputMaybe<Array<Scalars['bigint']['input']> | Scalars['bigint']['input']>;
}>;


export type UpdateOrganisationMutation = { __typename?: 'mutation_root', delete_organisationGroups?: { __typename?: 'organisationGroups_mutation_response', affected_rows: number } | null, insert_organisationGroups?: { __typename?: 'organisationGroups_mutation_response', affected_rows: number } | null, update_organisations_by_pk?: { __typename?: 'organisations', id: any, createdAt: any, updatedAt: any, name: string, organisationGroups: Array<{ __typename?: 'organisationGroups', id: any, name: string }> } | null };

export type AddServiceModulesAccessesMutationVariables = Exact<{
  objects: Array<ServiceModuleAccesses_Insert_Input> | ServiceModuleAccesses_Insert_Input;
}>;


export type AddServiceModulesAccessesMutation = { __typename?: 'mutation_root', insert_serviceModuleAccesses?: { __typename?: 'serviceModuleAccesses_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'serviceModuleAccesses', id: any }> } | null };

export type DeleteServiceModuleAccessMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteServiceModuleAccessMutation = { __typename?: 'mutation_root', delete_serviceModuleAccesses_by_pk?: { __typename?: 'serviceModuleAccesses', id: any } | null };

export type ServiceModuleAccessesByModuleIdsQueryVariables = Exact<{
  ids: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
}>;


export type ServiceModuleAccessesByModuleIdsQuery = { __typename?: 'query_root', serviceModuleAccesses: Array<{ __typename?: 'serviceModuleAccesses', id: any, guestUsers: boolean, organisationGroupId?: any | null, organisationId?: any | null, serviceModuleId: any, writable: boolean, updatedAt: any }> };

export type UpdateServiceModuleAccessMutationVariables = Exact<{
  pk_columns: ServiceModuleAccesses_Pk_Columns_Input;
  _set: ServiceModuleAccesses_Set_Input;
}>;


export type UpdateServiceModuleAccessMutation = { __typename?: 'mutation_root', update_serviceModuleAccesses_by_pk?: { __typename?: 'serviceModuleAccesses', id: any, serviceModuleId: any, writable: boolean } | null };

export type AddEventRoomWatchesMutationVariables = Exact<{
  object: EventRoomWatches_Insert_Input;
}>;


export type AddEventRoomWatchesMutation = { __typename?: 'mutation_root', insert_eventRoomWatches_one?: { __typename?: 'eventRoomWatches', eventId: any, userId: any } | null };

export type CreateRoomFolderMutationVariables = Exact<{
  roomFolder: RoomFolders_Insert_Input;
}>;


export type CreateRoomFolderMutation = { __typename?: 'mutation_root', insert_roomFolders_one?: { __typename?: 'roomFolders', id: any, name: string, parentId?: any | null } | null };

export type DeleteEventRoomWatchesMutationVariables = Exact<{
  eventId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
}>;


export type DeleteEventRoomWatchesMutation = { __typename?: 'mutation_root', delete_eventRoomWatches_by_pk?: { __typename?: 'eventRoomWatches', eventId: any, userId: any } | null };

export type DeleteRoomFolderMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteRoomFolderMutation = { __typename?: 'mutation_root', delete_roomFolders_by_pk?: { __typename?: 'roomFolders', id: any, name: string, parentId?: any | null } | null };

export type DeleteRoomMutationVariables = Exact<{
  roomId: Scalars['bigint']['input'];
}>;


export type DeleteRoomMutation = { __typename?: 'mutation_root', delete_rooms_by_pk?: { __typename?: 'rooms', id: any } | null };

export type AddRoomToEventMutationVariables = Exact<{
  eventRoom: EventRooms_Insert_Input;
}>;


export type AddRoomToEventMutation = { __typename?: 'mutation_root', insert_eventRooms_one?: { __typename?: 'eventRooms', roomId: any, eventId: any } | null };

export type RemoveRoomFromEventMutationVariables = Exact<{
  eventId: Scalars['bigint']['input'];
  roomId: Scalars['bigint']['input'];
}>;


export type RemoveRoomFromEventMutation = { __typename?: 'mutation_root', delete_eventRooms_by_pk?: { __typename?: 'eventRooms', roomId: any, eventId: any } | null, delete_roomServiceOccurrences?: { __typename?: 'roomServiceOccurrences_mutation_response', affected_rows: number } | null };

export type UpdateEventRoomsMutationVariables = Exact<{
  eventRoomInserts: Array<EventRooms_Insert_Input> | EventRooms_Insert_Input;
  eventRoomDeletes: EventRooms_Bool_Exp;
  roomServiceOccurrenceDeletes: RoomServiceOccurrences_Bool_Exp;
}>;


export type UpdateEventRoomsMutation = { __typename?: 'mutation_root', insert_eventRooms?: { __typename?: 'eventRooms_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'eventRooms', eventId: any, roomId: any }> } | null, delete_eventRooms?: { __typename?: 'eventRooms_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'eventRooms', eventId: any, roomId: any }> } | null, delete_roomServiceOccurrences?: { __typename?: 'roomServiceOccurrences_mutation_response', affected_rows: number } | null };

export type UpdateSingleEventRoomMutationVariables = Exact<{
  roomId: Scalars['bigint']['input'];
  eventId: Scalars['bigint']['input'];
  guestCanEdit?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateSingleEventRoomMutation = { __typename?: 'mutation_root', insert_eventRooms_one?: { __typename?: 'eventRooms', roomId: any, eventId: any, guestCanEdit: boolean } | null };

export type EventRoomWatchesQueryVariables = Exact<{
  userId: Scalars['bigint']['input'];
}>;


export type EventRoomWatchesQuery = { __typename?: 'query_root', eventRoomWatches: Array<{ __typename?: 'eventRoomWatches', eventId: any, userId: any }> };

export type ExportEventRoomsQueryVariables = Exact<{
  eventId: Scalars['bigint']['input'];
  where: EventRooms_Bool_Exp;
}>;


export type ExportEventRoomsQuery = { __typename?: 'query_root', eventRooms: Array<{ __typename?: 'eventRooms', event: { __typename?: 'events', id: any, name: string, subTitle?: string | null, startDate?: any | null, endDate?: any | null }, room: { __typename?: 'rooms', id: any, name: string, description?: string | null, roomServices: Array<{ __typename?: 'roomServices', id: any, name: string, roomServiceCategoryId?: any | null, roomAttributeGroups: Array<{ __typename?: 'roomAttributeGroups', name: string, order: number, roomAttributes: Array<{ __typename?: 'roomAttributes', name: string, description?: string | null, order: number }> }>, roomServiceOccurrences: Array<{ __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any, endDate: any, roomAttributeValueGroups: Array<{ __typename?: 'roomAttributeValueGroups', id: any, roomAttributeValues: Array<{ __typename?: 'roomAttributeValues', id: any, roomAttributeId: any, value: any, roomAttribute: { __typename?: 'roomAttributes', name: string, description?: string | null, attributeType: AttributeTypes_Enum, config: any, order: number, roomAttributeGroup: { __typename?: 'roomAttributeGroups', id: any, name: string, order: number } }, roomAttributeValueUploads: Array<{ __typename?: 'roomAttributeValueUploads', id: any, name: string, roomAttributeValueUploadVersions: Array<{ __typename?: 'roomAttributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> }> }> }> }> }> } }>, roomOccurrences: Array<{ __typename?: 'roomOccurrences', id: any, name: string, startDate: any, endDate: any, roomId: any, wantAirConditioning: boolean }>, roomFolders: Array<{ __typename?: 'roomFolders', id: any, name: string, parentId?: any | null, order: number }> };

export type ExportMultiEventRoomsQueryVariables = Exact<{
  eventIds: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
  where: EventRooms_Bool_Exp;
}>;


export type ExportMultiEventRoomsQuery = { __typename?: 'query_root', eventRooms: Array<{ __typename?: 'eventRooms', event: { __typename?: 'events', id: any, name: string, subTitle?: string | null, startDate?: any | null, endDate?: any | null }, room: { __typename?: 'rooms', id: any, name: string, description?: string | null, roomServices: Array<{ __typename?: 'roomServices', id: any, name: string, roomServiceCategoryId?: any | null, room: { __typename?: 'rooms', eventId?: any | null }, roomAttributeGroups: Array<{ __typename?: 'roomAttributeGroups', name: string, order: number, roomAttributes: Array<{ __typename?: 'roomAttributes', name: string, description?: string | null, order: number }> }>, roomServiceOccurrences: Array<{ __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any, endDate: any, event: { __typename?: 'events', id: any, name: string }, roomAttributeValueGroups: Array<{ __typename?: 'roomAttributeValueGroups', id: any, roomAttributeValues: Array<{ __typename?: 'roomAttributeValues', id: any, roomAttributeId: any, value: any, roomAttribute: { __typename?: 'roomAttributes', name: string, description?: string | null, attributeType: AttributeTypes_Enum, config: any, order: number, roomAttributeGroup: { __typename?: 'roomAttributeGroups', id: any, name: string, order: number } }, roomAttributeValueUploads: Array<{ __typename?: 'roomAttributeValueUploads', id: any, name: string, roomAttributeValueUploadVersions: Array<{ __typename?: 'roomAttributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> }> }> }> }> }> } }>, roomOccurrences: Array<{ __typename?: 'roomOccurrences', id: any, name: string, startDate: any, endDate: any, roomId: any, wantAirConditioning: boolean, event: { __typename?: 'events', id: any, name: string, startDate?: any | null } }>, roomFolders: Array<{ __typename?: 'roomFolders', id: any, name: string, parentId?: any | null, order: number }> };

export type GetSimpleEventRoomsByEventIdQueryVariables = Exact<{
  eventId: Scalars['bigint']['input'];
}>;


export type GetSimpleEventRoomsByEventIdQuery = { __typename?: 'query_root', eventRooms: Array<{ __typename?: 'eventRooms', eventId: any, roomId: any, guestCanEdit: boolean }> };

export type GetOnlyEventRoomsByEventIdQueryVariables = Exact<{
  eventId: Scalars['bigint']['input'];
}>;


export type GetOnlyEventRoomsByEventIdQuery = { __typename?: 'query_root', eventRooms: Array<{ __typename?: 'eventRooms', roomId: any, guestCanEdit: boolean, room: { __typename?: 'rooms', id: any, name: string, order: number, roomServices: Array<{ __typename?: 'roomServices', id: any, name: string, order?: number | null, description?: string | null, roomServiceOccurrences: Array<{ __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any, endDate: any, hasChanges?: boolean | null, isDraft: boolean, fromRoomServiceOccurrenceId?: any | null, guestCanEdit?: boolean | null, userData: Array<{ __typename?: 'userDataRoomServiceOccurrences', data: any }>, roomAttributeValueGroups: Array<{ __typename?: 'roomAttributeValueGroups', id: any }>, event: { __typename?: 'events', id: any, name: string } }> }> } }> };

export type CreateEventSpecificRoomMutationVariables = Exact<{
  object: Rooms_Insert_Input;
}>;


export type CreateEventSpecificRoomMutation = { __typename?: 'mutation_root', insert_rooms_one?: { __typename?: 'rooms', id: any, name: string, description?: string | null, shortDescription?: string | null, fromRoomId?: any | null, eventId?: any | null } | null };

export type CreateEventSpecificRoomsMutationVariables = Exact<{
  objects: Array<Rooms_Insert_Input> | Rooms_Insert_Input;
}>;


export type CreateEventSpecificRoomsMutation = { __typename?: 'mutation_root', insert_rooms?: { __typename?: 'rooms_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'rooms', id: any, name: string, description?: string | null, shortDescription?: string | null, fromRoomId?: any | null, eventId?: any | null, roomServices: Array<{ __typename?: 'roomServices', id: any, name: string, order?: number | null, description?: string | null, fromRoomServiceId?: any | null }> }> } | null };

export type UpdateEventSpecificRoomMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  updates: Rooms_Set_Input;
}>;


export type UpdateEventSpecificRoomMutation = { __typename?: 'mutation_root', update_rooms_by_pk?: { __typename?: 'rooms', id: any, name: string, roomFolderId?: any | null, shortDescription?: string | null, description?: string | null, order: number, fromRoomId?: any | null, eventId?: any | null } | null };

export type DeleteEventSpecificRoomMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteEventSpecificRoomMutation = { __typename?: 'mutation_root', delete_rooms_by_pk?: { __typename?: 'rooms', id: any, name: string, roomFolderId?: any | null, shortDescription?: string | null, description?: string | null, order: number, fromRoomId?: any | null, eventId?: any | null } | null };

export type DeleteEventSpecificRoomsMutationVariables = Exact<{
  roomIds?: InputMaybe<Array<Scalars['bigint']['input']> | Scalars['bigint']['input']>;
}>;


export type DeleteEventSpecificRoomsMutation = { __typename?: 'mutation_root', delete_rooms?: { __typename?: 'rooms_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'rooms', id: any, name: string, roomFolderId?: any | null, shortDescription?: string | null, description?: string | null, order: number, fromRoomId?: any | null, eventId?: any | null }> } | null };

export type GetEventRoomsByEventIdSubscriptionVariables = Exact<{
  eventId: Scalars['bigint']['input'];
  fetchLastUpdatedInfo?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetEventRoomsByEventIdSubscription = { __typename?: 'subscription_root', events_by_pk?: { __typename?: 'events', id: any, name: string, startDate?: any | null, endDate?: any | null, eventType: EventTypes_Enum, config: any, guestOrganisationId?: any | null, guestCanEditRoommatrix: boolean, roommatrixWritable?: boolean | null, parentEvent?: { __typename?: 'events', id: any, name: string, config: any } | null, eventRooms: Array<{ __typename?: 'eventRooms', roomId: any, guestCanEdit: boolean, room: { __typename?: 'rooms', id: any, name: string, order: number, roomServices: Array<{ __typename?: 'roomServices', id: any, name: string, order?: number | null, description?: string | null }> } }>, eventAttributeValues: Array<{ __typename?: 'eventAttributeValues', id: any, value: any, createdAt: any, updatedAt: any, updatedBy?: any | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null, eventAttribute?: { __typename?: 'eventAttributes', id: any, attributeType: AttributeTypes_Enum, config: any, name: string, order: number, eventAttributeGroup: { __typename?: 'eventAttributeGroups', id: any, name: string, order: number } } | null }> } | null };

export type EventRoomsByEventIdQueryVariables = Exact<{
  eventId: Scalars['bigint']['input'];
}>;


export type EventRoomsByEventIdQuery = { __typename?: 'query_root', events_by_pk?: { __typename?: 'events', id: any, name: string, startDate?: any | null, endDate?: any | null, eventType: EventTypes_Enum, config: any, eventAttributeValues: Array<{ __typename?: 'eventAttributeValues', id: any, value: any, eventAttribute?: { __typename?: 'eventAttributes', id: any, attributeType: AttributeTypes_Enum, config: any, name: string, order: number, eventAttributeGroup: { __typename?: 'eventAttributeGroups', id: any, name: string, order: number } } | null }>, parentEvent?: { __typename?: 'events', id: any, name: string, startDate?: any | null, endDate?: any | null } | null, eventRooms: Array<{ __typename?: 'eventRooms', roomId: any, guestCanEdit: boolean, room: { __typename?: 'rooms', id: any, name: string } }> } | null };

export type GetEventRoomsByEventIdsSubscriptionVariables = Exact<{
  eventIds: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
  fetchLastUpdatedInfo?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetEventRoomsByEventIdsSubscription = { __typename?: 'subscription_root', events: Array<{ __typename?: 'events', id: any, name: string, startDate?: any | null, endDate?: any | null, eventType: EventTypes_Enum, config: any, guestOrganisationId?: any | null, guestCanEditRoommatrix: boolean, roommatrixWritable?: boolean | null, parentEvent?: { __typename?: 'events', id: any, name: string, config: any } | null, eventRooms: Array<{ __typename?: 'eventRooms', roomId: any, guestCanEdit: boolean, room: { __typename?: 'rooms', id: any, name: string, order: number, roomServices: Array<{ __typename?: 'roomServices', id: any, name: string, order?: number | null, description?: string | null }> } }>, eventAttributeValues: Array<{ __typename?: 'eventAttributeValues', id: any, value: any, createdAt: any, updatedAt: any, updatedBy?: any | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null, eventAttribute?: { __typename?: 'eventAttributes', id: any, attributeType: AttributeTypes_Enum, config: any, name: string, order: number, eventAttributeGroup: { __typename?: 'eventAttributeGroups', id: any, name: string, order: number } } | null }> }> };

export type GetEventRoomsByEventIdsArrayQueryVariables = Exact<{
  eventIds: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
  fetchLastUpdatedInfo?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetEventRoomsByEventIdsArrayQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'events', id: any, name: string, startDate?: any | null, endDate?: any | null, eventType: EventTypes_Enum, config: any, guestOrganisationId?: any | null, guestCanEditRoommatrix: boolean, roommatrixWritable?: boolean | null, parentEvent?: { __typename?: 'events', id: any, name: string, config: any } | null, eventRooms: Array<{ __typename?: 'eventRooms', roomId: any, guestCanEdit: boolean, room: { __typename?: 'rooms', id: any, name: string, order: number, roomServices: Array<{ __typename?: 'roomServices', id: any, name: string, order?: number | null, description?: string | null, roomServiceOccurrences: Array<{ __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any, endDate: any, hasChanges?: boolean | null, isDraft: boolean, fromRoomServiceOccurrenceId?: any | null, guestCanEdit?: boolean | null, userData: Array<{ __typename?: 'userDataRoomServiceOccurrences', data: any }>, roomAttributeValueGroups: Array<{ __typename?: 'roomAttributeValueGroups', id: any }>, event: { __typename?: 'events', id: any, name: string } }> }> } }>, eventAttributeValues: Array<{ __typename?: 'eventAttributeValues', id: any, value: any, createdAt: any, updatedAt: any, updatedBy?: any | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null, eventAttribute?: { __typename?: 'eventAttributes', id: any, attributeType: AttributeTypes_Enum, config: any, name: string, order: number, eventAttributeGroup: { __typename?: 'eventAttributeGroups', id: any, name: string, order: number } } | null }> }> };

export type GetRoomOccurrencesByEventIdsSubscriptionVariables = Exact<{
  eventIds: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
}>;


export type GetRoomOccurrencesByEventIdsSubscription = { __typename?: 'subscription_root', roomOccurrences: Array<{ __typename?: 'roomOccurrences', id: any, roomId: any, name: string, startDate: any, endDate: any, isDraft: boolean, fromRoomOccurrenceId?: any | null, createdAt: any, guestCanEdit?: boolean | null, eventId: any, wantAirConditioning: boolean, userData: Array<{ __typename?: 'userDataRoomOccurrences', data: any }>, event: { __typename?: 'events', id: any, name: string } }> };

export type GetRoomOccurrencesFirstStartAndLastEndQueryVariables = Exact<{
  eventIds: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
}>;


export type GetRoomOccurrencesFirstStartAndLastEndQuery = { __typename?: 'query_root', roomOccurrenceFirstStart: Array<{ __typename?: 'roomOccurrences', id: any, startDate: any }>, roomOccurenceLastEnd: Array<{ __typename?: 'roomOccurrences', id: any, endDate: any }> };

export type GetRoomServiceOccurrencesByEventIdsSubscriptionVariables = Exact<{
  eventIds: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
}>;


export type GetRoomServiceOccurrencesByEventIdsSubscription = { __typename?: 'subscription_root', roomServiceOccurrences: Array<{ __typename?: 'roomServiceOccurrences', id: any, createdAt: any, roomServiceId: any, name: string, startDate: any, endDate: any, hasChanges?: boolean | null, isDraft: boolean, fromRoomServiceOccurrenceId?: any | null, guestCanEdit?: boolean | null, eventId: any, userData: Array<{ __typename?: 'userDataRoomServiceOccurrences', data: any }>, roomService: { __typename?: 'roomServices', roomId: any, id: any, name: string, order?: number | null, description?: string | null, fromRoomServiceId?: any | null }, roomAttributeValueGroups: Array<{ __typename?: 'roomAttributeValueGroups', id: any }> }> };

export type GetRoomServiceOccurrencesFirstStartAndLastEndQueryVariables = Exact<{
  eventIds: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
}>;


export type GetRoomServiceOccurrencesFirstStartAndLastEndQuery = { __typename?: 'query_root', roomServiceOccurenceFirstStart: Array<{ __typename?: 'roomServiceOccurrences', id: any, startDate: any }>, roomServiceOccurenceLastEnd: Array<{ __typename?: 'roomServiceOccurrences', id: any, endDate: any }> };

export type GetRoomOccurrencesByEventIdqQueryVariables = Exact<{
  eventId: Scalars['bigint']['input'];
}>;


export type GetRoomOccurrencesByEventIdqQuery = { __typename?: 'query_root', roomOccurrences: Array<{ __typename?: 'roomOccurrences', id: any, roomId: any, name: string, startDate: any, endDate: any, wantAirConditioning: boolean, userData: Array<{ __typename?: 'userDataRoomOccurrences', data: any }> }> };

export type GetRoomServiceOccurrencesByEventIdqQueryVariables = Exact<{
  eventId: Scalars['bigint']['input'];
}>;


export type GetRoomServiceOccurrencesByEventIdqQuery = { __typename?: 'query_root', roomServiceOccurrences: Array<{ __typename?: 'roomServiceOccurrences', id: any, roomServiceId: any, name: string, startDate: any, endDate: any, hasChanges?: boolean | null, userData: Array<{ __typename?: 'userDataRoomServiceOccurrences', data: any }>, roomService: { __typename?: 'roomServices', roomId: any, id: any, name: string, order?: number | null, description?: string | null } }> };

export type GetUserDataForRoomServiceOccurrenceQueryVariables = Exact<{
  roomServiceOccurrenceId: Scalars['bigint']['input'];
}>;


export type GetUserDataForRoomServiceOccurrenceQuery = { __typename?: 'query_root', userDataRoomServiceOccurrences: Array<{ __typename?: 'userDataRoomServiceOccurrences', data: any, roomServiceOccurrenceId: any, userId: any }> };

export type GetUserDataForRoomOccurrenceQueryVariables = Exact<{
  roomOccurrenceId: Scalars['bigint']['input'];
}>;


export type GetUserDataForRoomOccurrenceQuery = { __typename?: 'query_root', userDataRoomOccurrences: Array<{ __typename?: 'userDataRoomOccurrences', data: any, roomOccurrenceId: any, userId: any }> };

export type SavePersonalNoteForRoomServiceOccurrencesMutationVariables = Exact<{
  personalData: UserDataRoomServiceOccurrences_Insert_Input;
}>;


export type SavePersonalNoteForRoomServiceOccurrencesMutation = { __typename?: 'mutation_root', insert_userDataRoomServiceOccurrences_one?: { __typename?: 'userDataRoomServiceOccurrences', roomServiceOccurrenceId: any, data: any } | null };

export type SavePersonalNoteForRoomOccurrencesMutationVariables = Exact<{
  personalData: UserDataRoomOccurrences_Insert_Input;
}>;


export type SavePersonalNoteForRoomOccurrencesMutation = { __typename?: 'mutation_root', insert_userDataRoomOccurrences_one?: { __typename?: 'userDataRoomOccurrences', roomOccurrenceId: any, data: any } | null };

export type InsertRoomMutationVariables = Exact<{
  roomData: Rooms_Insert_Input;
}>;


export type InsertRoomMutation = { __typename?: 'mutation_root', insert_rooms_one?: { __typename?: 'rooms', id: any, name: string, description?: string | null, shortDescription?: string | null, roomFolderId?: any | null, roomServices: Array<{ __typename?: 'roomServices', id: any, name: string, order?: number | null }> } | null };

export type GetRoomByIdQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type GetRoomByIdQuery = { __typename?: 'query_root', rooms_by_pk?: { __typename?: 'rooms', id: any, name: string, description?: string | null, shortDescription?: string | null, roomFolderId?: any | null } | null };

export type GetRoomByIdDetailedQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type GetRoomByIdDetailedQuery = { __typename?: 'query_root', rooms_by_pk?: { __typename?: 'rooms', id: any, name: string, description?: string | null, shortDescription?: string | null, roomFolderId?: any | null, roomServices: Array<{ __typename?: 'roomServices', id: any, name: string, description?: string | null, roomServiceCategoryId?: any | null, order?: number | null, roomServiceCategory?: { __typename?: 'roomServiceCategories', id: any, name: string } | null, roomAttributeGroups: Array<{ __typename?: 'roomAttributeGroups', id: any, order: number, description?: string | null, name: string, valuesRepeatable: boolean, roomAttributes: Array<{ __typename?: 'roomAttributes', attributeType: AttributeTypes_Enum, order: number, config: any, createdAt: any, description?: string | null, id: any, name: string, updatedAt: any, roomAttributeFiles: Array<{ __typename?: 'roomAttributeFiles', fileId: any, file: { __typename?: 'files', id: any, size?: any | null, name: string, extension: string } }> }> }> }> } | null };

export type GetMatrixStructureQueryVariables = Exact<{
  eventId: Scalars['bigint']['input'];
}>;


export type GetMatrixStructureQuery = { __typename?: 'query_root', events_by_pk?: { __typename?: 'events', guestCanEditRoommatrix: boolean } | null, roomFolders: Array<{ __typename?: 'roomFolders', id: any, name: string, parentId?: any | null, order: number, rooms: Array<{ __typename?: 'rooms', id: any, name: string, description?: string | null, shortDescription?: string | null, order: number, roomServices: Array<{ __typename?: 'roomServices', id: any, name: string, order?: number | null, description?: string | null, roomServiceCategoryId?: any | null, roomServiceCategory?: { __typename?: 'roomServiceCategories', name: string } | null }> }> }>, rooms: Array<{ __typename?: 'rooms', id: any, name: string, description?: string | null, shortDescription?: string | null, roomFolderId?: any | null, order: number, roomServices: Array<{ __typename?: 'roomServices', id: any, name: string, order?: number | null, description?: string | null, roomServiceCategoryId?: any | null, roomServiceCategory?: { __typename?: 'roomServiceCategories', name: string } | null }> }> };

export type GetMultipleMatrixStructuresQueryVariables = Exact<{
  eventIds: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
}>;


export type GetMultipleMatrixStructuresQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'events', guestCanEditRoommatrix: boolean }>, roomFolders: Array<{ __typename?: 'roomFolders', id: any, name: string, parentId?: any | null, order: number, rooms: Array<{ __typename?: 'rooms', id: any, name: string, description?: string | null, shortDescription?: string | null, order: number, eventId?: any | null, roomServices: Array<{ __typename?: 'roomServices', id: any, name: string, order?: number | null, description?: string | null, roomServiceCategoryId?: any | null, roomServiceCategory?: { __typename?: 'roomServiceCategories', name: string } | null }> }> }>, rooms: Array<{ __typename?: 'rooms', id: any, name: string, description?: string | null, shortDescription?: string | null, roomFolderId?: any | null, order: number, eventId?: any | null, roomServices: Array<{ __typename?: 'roomServices', id: any, name: string, order?: number | null, description?: string | null, roomServiceCategoryId?: any | null, roomServiceCategory?: { __typename?: 'roomServiceCategories', name: string } | null }> }> };

export type RoomFolderListQueryVariables = Exact<{ [key: string]: never; }>;


export type RoomFolderListQuery = { __typename?: 'query_root', roomFolders: Array<{ __typename?: 'roomFolders', id: any, name: string, parentId?: any | null, order: number }> };

export type RoomListQueryVariables = Exact<{
  where: Rooms_Bool_Exp;
}>;


export type RoomListQuery = { __typename?: 'query_root', rooms: Array<{ __typename?: 'rooms', id: any, name: string, roomFolderId?: any | null, shortDescription?: string | null, description?: string | null, order: number, fromRoomId?: any | null, eventId?: any | null, roomServices: Array<{ __typename?: 'roomServices', id: any, name: string, description?: string | null, order?: number | null, roomServiceCategory?: { __typename?: 'roomServiceCategories', id: any, name: string } | null }> }>, roomFolders: Array<{ __typename?: 'roomFolders', id: any, name: string, parentId?: any | null, order: number }> };

export type GetRoomOccurrenceIntersectionsQueryVariables = Exact<{
  where: RoomOccurrence_Intersections_Bool_Exp;
}>;


export type GetRoomOccurrenceIntersectionsQuery = { __typename?: 'query_root', roomOccurrence_intersections: Array<{ __typename?: 'roomOccurrence_intersections', _id?: any | null, id?: any | null, name?: string | null, startDate?: any | null, endDate?: any | null, event?: { __typename?: 'events', id: any, name: string } | null, room?: { __typename?: 'rooms', id: any, name: string } | null }> };

export type InsertRoomOccurenceMutationVariables = Exact<{
  roomOccurrence: RoomOccurrences_Insert_Input;
}>;


export type InsertRoomOccurenceMutation = { __typename?: 'mutation_root', insert_roomOccurrences_one?: { __typename?: 'roomOccurrences', id: any, name: string, startDate: any, endDate: any, eventId: any, wantAirConditioning: boolean, userData: Array<{ __typename?: 'userDataRoomOccurrences', data: any }> } | null };

export type InsertMultipleOccurencesMutationVariables = Exact<{
  roomOccurrences: Array<RoomOccurrences_Insert_Input> | RoomOccurrences_Insert_Input;
  roomServiceOccurrences: Array<RoomServiceOccurrences_Insert_Input> | RoomServiceOccurrences_Insert_Input;
}>;


export type InsertMultipleOccurencesMutation = { __typename?: 'mutation_root', insert_roomOccurrences?: { __typename?: 'roomOccurrences_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'roomOccurrences', id: any, name: string, startDate: any, endDate: any, eventId: any, wantAirConditioning: boolean, userData: Array<{ __typename?: 'userDataRoomOccurrences', data: any }> }> } | null, insert_roomServiceOccurrences?: { __typename?: 'roomServiceOccurrences_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any, endDate: any, eventId: any, userData: Array<{ __typename?: 'userDataRoomServiceOccurrences', data: any }> }> } | null };

export type UpdateRoomOccurrenceMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  roomOccurrence?: InputMaybe<RoomOccurrences_Set_Input>;
}>;


export type UpdateRoomOccurrenceMutation = { __typename?: 'mutation_root', update_roomOccurrences_by_pk?: { __typename?: 'roomOccurrences', id: any, name: string, startDate: any, endDate: any, eventId: any, wantAirConditioning: boolean, userData: Array<{ __typename?: 'userDataRoomOccurrences', data: any }> } | null };

export type UpdateMultipleRoomOccurrencesMutationVariables = Exact<{
  updates: Array<RoomOccurrences_Updates> | RoomOccurrences_Updates;
}>;


export type UpdateMultipleRoomOccurrencesMutation = { __typename?: 'mutation_root', update_roomOccurrences_many?: Array<{ __typename?: 'roomOccurrences_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'roomOccurrences', id: any, name: string, startDate: any, endDate: any, eventId: any, wantAirConditioning: boolean, userData: Array<{ __typename?: 'userDataRoomOccurrences', data: any }> }> } | null> | null };

export type UpdateOccurrencesShallowMutationVariables = Exact<{
  roomOccurrenceUpdates: Array<RoomOccurrences_Updates> | RoomOccurrences_Updates;
  roomServiceOccurrencesUpdates: Array<RoomServiceOccurrences_Updates> | RoomServiceOccurrences_Updates;
}>;


export type UpdateOccurrencesShallowMutation = { __typename?: 'mutation_root', update_roomOccurrences_many?: Array<{ __typename?: 'roomOccurrences_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'roomOccurrences', id: any, name: string, startDate: any, endDate: any, eventId: any, wantAirConditioning: boolean, userData: Array<{ __typename?: 'userDataRoomOccurrences', data: any }> }> } | null> | null, update_roomServiceOccurrences_many?: Array<{ __typename?: 'roomServiceOccurrences_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any, endDate: any, eventId: any }> } | null> | null };

export type DeleteRoomOccurenceByIdMutationVariables = Exact<{
  roomOccurrenceId: Scalars['bigint']['input'];
}>;


export type DeleteRoomOccurenceByIdMutation = { __typename?: 'mutation_root', delete_roomOccurrences_by_pk?: { __typename?: 'roomOccurrences', id: any, name: string } | null };

export type DeleteRoomOccurencesMutationVariables = Exact<{
  ids: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
}>;


export type DeleteRoomOccurencesMutation = { __typename?: 'mutation_root', delete_roomOccurrences?: { __typename?: 'roomOccurrences_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'roomOccurrences', id: any, name: string }> } | null };

export type DeleteOccurencesMutationVariables = Exact<{
  roomOccurrenceIds: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
  roomServiceOccurrenceIds: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
}>;


export type DeleteOccurencesMutation = { __typename?: 'mutation_root', delete_roomOccurrences?: { __typename?: 'roomOccurrences_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'roomOccurrences', id: any, name: string }> } | null, delete_roomServiceOccurrences?: { __typename?: 'roomServiceOccurrences_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'roomServiceOccurrences', id: any, name: string }> } | null };

export type SetRoomOccurenceIsDraftMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  isDraft: Scalars['Boolean']['input'];
}>;


export type SetRoomOccurenceIsDraftMutation = { __typename?: 'mutation_root', update_roomOccurrences_by_pk?: { __typename?: 'roomOccurrences', id: any, isDraft: boolean } | null };

export type RoomServiceCategoryListQueryVariables = Exact<{ [key: string]: never; }>;


export type RoomServiceCategoryListQuery = { __typename?: 'query_root', roomServiceCategories: Array<{ __typename?: 'roomServiceCategories', id: any, name: string }> };

export type InsertRoomServiceOccurenceMutationVariables = Exact<{
  roomServiceOccurrence: RoomServiceOccurrences_Insert_Input;
}>;


export type InsertRoomServiceOccurenceMutation = { __typename?: 'mutation_root', insert_roomServiceOccurrences_one?: { __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any, endDate: any, eventId: any } | null };

export type UpdateRoomServiceOccurrenceMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  roomServiceOccurrence?: InputMaybe<RoomServiceOccurrences_Set_Input>;
  roomAttributeValues: Array<RoomAttributeValues_Insert_Input> | RoomAttributeValues_Insert_Input;
  roomAttributeValueGroups: Array<RoomAttributeValueGroups_Insert_Input> | RoomAttributeValueGroups_Insert_Input;
  roomAttributeValueGroupIdsToDelete: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
  roomAttributeValueUploadsToInsert: Array<RoomAttributeValueUploads_Insert_Input> | RoomAttributeValueUploads_Insert_Input;
  roomAttributeValueUploadsToDelete: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
  roomAttributeValueUploadVersionsToInsert: Array<RoomAttributeValueUploadVersions_Insert_Input> | RoomAttributeValueUploadVersions_Insert_Input;
  roomAttributeValueUploadVersionsToDelete: Array<RoomAttributeValueUploadVersions_Bool_Exp> | RoomAttributeValueUploadVersions_Bool_Exp;
}>;


export type UpdateRoomServiceOccurrenceMutation = { __typename?: 'mutation_root', update_roomServiceOccurrences_by_pk?: { __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any, endDate: any, eventId: any } | null, insert_roomAttributeValues?: { __typename?: 'roomAttributeValues_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'roomAttributeValues', id: any, roomAttributeId: any, roomAttributeValueGroupId: any, value: any, roomAttributeValueUploads: Array<{ __typename?: 'roomAttributeValueUploads', id: any, name: string, roomAttributeValueUploadVersions: Array<{ __typename?: 'roomAttributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> }> }> } | null, insert_roomAttributeValueGroups?: { __typename?: 'roomAttributeValueGroups_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'roomAttributeValueGroups', id: any, roomAttributeGroupId: any, roomServiceOccurrenceId: any, roomAttributeValues: Array<{ __typename?: 'roomAttributeValues', id: any, roomAttributeId: any, roomAttributeValueGroupId: any, value: any, roomAttributeValueUploads: Array<{ __typename?: 'roomAttributeValueUploads', id: any, name: string, roomAttributeValueUploadVersions: Array<{ __typename?: 'roomAttributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> }> }> }> } | null, delete_roomAttributeValueGroups?: { __typename?: 'roomAttributeValueGroups_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'roomAttributeValueGroups', id: any }> } | null, delete_roomAttributeValueUploads?: { __typename?: 'roomAttributeValueUploads_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'roomAttributeValueUploads', id: any }> } | null, delete_roomAttributeValueUploadVersions?: { __typename?: 'roomAttributeValueUploadVersions_mutation_response', affected_rows: number } | null, insert_roomAttributeValueUploads?: { __typename?: 'roomAttributeValueUploads_mutation_response', returning: Array<{ __typename?: 'roomAttributeValueUploads', id: any, roomAttributeValueId: any }> } | null, insert_roomAttributeValueUploadVersions?: { __typename?: 'roomAttributeValueUploadVersions_mutation_response', returning: Array<{ __typename?: 'roomAttributeValueUploadVersions', roomAttributeValueUploadId: any, fileId: any }> } | null };

export type UpdateRoomServiceOccurrencesBasicInfoOnlyMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  roomServiceOccurrence?: InputMaybe<RoomServiceOccurrences_Set_Input>;
}>;


export type UpdateRoomServiceOccurrencesBasicInfoOnlyMutation = { __typename?: 'mutation_root', update_roomServiceOccurrences_by_pk?: { __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any, endDate: any, eventId: any } | null };

export type DeleteRoomServiceOccurenceByIdMutationVariables = Exact<{
  roomServiceOccurrenceId: Scalars['bigint']['input'];
}>;


export type DeleteRoomServiceOccurenceByIdMutation = { __typename?: 'mutation_root', delete_roomServiceOccurrences_by_pk?: { __typename?: 'roomServiceOccurrences', id: any, name: string } | null };

export type DeleteRoomServiceOccurencesMutationVariables = Exact<{
  ids: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
}>;


export type DeleteRoomServiceOccurencesMutation = { __typename?: 'mutation_root', delete_roomServiceOccurrences?: { __typename?: 'roomServiceOccurrences_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'roomServiceOccurrences', id: any, name: string }> } | null };

export type SetRoomServiceOccurenceIsDraftMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  isDraft: Scalars['Boolean']['input'];
}>;


export type SetRoomServiceOccurenceIsDraftMutation = { __typename?: 'mutation_root', update_roomServiceOccurrences_by_pk?: { __typename?: 'roomServiceOccurrences', id: any, isDraft: boolean } | null };

export type GetRoomServiceOccurrenceQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
  fetchLastUpdatedInfo?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRoomServiceOccurrenceQuery = { __typename?: 'query_root', roomServiceOccurrences_by_pk?: { __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any, endDate: any, userData: Array<{ __typename?: 'userDataRoomServiceOccurrences', data: any }>, event: { __typename?: 'events', id: any, name: string, startDate?: any | null, endDate?: any | null }, roomService: { __typename?: 'roomServices', id: any, name: string, order?: number | null, description?: string | null, roomAttributeGroups: Array<{ __typename?: 'roomAttributeGroups', id: any, name: string, description?: string | null, valuesRepeatable: boolean, order: number, roomAttributes: Array<{ __typename?: 'roomAttributes', id: any, name: string, attributeType: AttributeTypes_Enum, config: any, description?: string | null, roomAttributeGroupId: any, roomAttributeFiles: Array<{ __typename?: 'roomAttributeFiles', roomAttributeId: any, fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, size?: any | null, name: string, extension: string } }> }> }> }, roomAttributeValueGroups: Array<{ __typename?: 'roomAttributeValueGroups', id: any, roomAttributeGroupId: any, roomAttributeValues: Array<{ __typename?: 'roomAttributeValues', roomAttributeId: any, id: any, value: any, createdAt: any, updatedAt: any, updatedBy?: any | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null, comments_aggregate: { __typename?: 'roomAttributeValueComments_aggregate', aggregate?: { __typename?: 'roomAttributeValueComments_aggregate_fields', count: number } | null }, roomAttributeValueUploads: Array<{ __typename?: 'roomAttributeValueUploads', id: any, name: string, roomAttributeValueUploadVersions: Array<{ __typename?: 'roomAttributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> }> }> }> } | null };

export type GetRoomServiceOccurrencesQueryVariables = Exact<{
  ids: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
  fetchLastUpdatedInfo?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRoomServiceOccurrencesQuery = { __typename?: 'query_root', roomServiceOccurrences: Array<{ __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any, endDate: any, isDraft: boolean, userData: Array<{ __typename?: 'userDataRoomServiceOccurrences', data: any }>, event: { __typename?: 'events', id: any, name: string, startDate?: any | null, endDate?: any | null }, roomService: { __typename?: 'roomServices', id: any, name: string, order?: number | null, description?: string | null, roomAttributeGroups: Array<{ __typename?: 'roomAttributeGroups', id: any, name: string, description?: string | null, valuesRepeatable: boolean, order: number, roomAttributes: Array<{ __typename?: 'roomAttributes', id: any, name: string, attributeType: AttributeTypes_Enum, config: any, description?: string | null, roomAttributeGroupId: any, roomAttributeFiles: Array<{ __typename?: 'roomAttributeFiles', roomAttributeId: any, fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, size?: any | null, name: string, extension: string } }> }> }> }, roomAttributeValueGroups: Array<{ __typename?: 'roomAttributeValueGroups', id: any, roomAttributeGroupId: any, roomAttributeValues: Array<{ __typename?: 'roomAttributeValues', roomAttributeId: any, id: any, value: any, createdAt: any, updatedAt: any, updatedBy?: any | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null, comments_aggregate: { __typename?: 'roomAttributeValueComments_aggregate', aggregate?: { __typename?: 'roomAttributeValueComments_aggregate_fields', count: number } | null }, roomAttributeValueUploads: Array<{ __typename?: 'roomAttributeValueUploads', id: any, name: string, roomAttributeValueUploadVersions: Array<{ __typename?: 'roomAttributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> }> }> }> }> };

export type GetRoomServiceByIdQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type GetRoomServiceByIdQuery = { __typename?: 'query_root', roomServices_by_pk?: { __typename?: 'roomServices', id: any, name: string, order?: number | null, roomServiceCategoryId?: any | null, roomAttributeGroups: Array<{ __typename?: 'roomAttributeGroups', id: any, name: string, description?: string | null, valuesRepeatable: boolean, order: number, roomAttributeValueGroups: Array<{ __typename?: 'roomAttributeValueGroups', id: any, roomAttributeGroupId: any, roomAttributeValues: Array<{ __typename?: 'roomAttributeValues', id: any, value: any, roomAttributeValueGroupId: any, roomAttributeId: any, createdAt: any, updatedAt: any, roomAttributeValueUploads: Array<{ __typename?: 'roomAttributeValueUploads', id: any, name: string, roomAttributeValueUploadVersions: Array<{ __typename?: 'roomAttributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> }> }> }>, roomAttributes: Array<{ __typename?: 'roomAttributes', id: any, name: string, attributeType: AttributeTypes_Enum, config: any, description?: string | null, roomAttributeGroupId: any, roomAttributeFiles: Array<{ __typename?: 'roomAttributeFiles', roomAttributeId: any, fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, size?: any | null, name: string, extension: string } }> }> }> } | null };

export type GetRoomAttributeGroupByIdQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type GetRoomAttributeGroupByIdQuery = { __typename?: 'query_root', roomAttributeGroups_by_pk?: { __typename?: 'roomAttributeGroups', roomAttributes: Array<{ __typename?: 'roomAttributes', roomAttributeValues: Array<{ __typename?: 'roomAttributeValues', value: any }> }> } | null };

export type GetRoomAttributeByIdQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type GetRoomAttributeByIdQuery = { __typename?: 'query_root', roomAttributes_by_pk?: { __typename?: 'roomAttributes', roomAttributeValues: Array<{ __typename?: 'roomAttributeValues', value: any }> } | null };

export type UpdateRoomFolderMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  updates: RoomFolders_Set_Input;
}>;


export type UpdateRoomFolderMutation = { __typename?: 'mutation_root', update_roomFolders_by_pk?: { __typename?: 'roomFolders', id: any, name: string, parentId?: any | null } | null };

export type UpdateRoomMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  roomData?: InputMaybe<Rooms_Set_Input>;
  newRoomServices: Array<RoomServices_Insert_Input> | RoomServices_Insert_Input;
  roomServiceIdsToDelete?: InputMaybe<Array<Scalars['bigint']['input']> | Scalars['bigint']['input']>;
}>;


export type UpdateRoomMutation = { __typename?: 'mutation_root', update_rooms_by_pk?: { __typename?: 'rooms', id: any, name: string, shortDescription?: string | null, description?: string | null, roomFolderId?: any | null } | null, insert_roomServices?: { __typename?: 'roomServices_mutation_response', returning: Array<{ __typename?: 'roomServices', id: any, name: string, roomId: any, order?: number | null }> } | null, delete_roomServices?: { __typename?: 'roomServices_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'roomServices', id: any, name: string }> } | null };

export type SetUsersLastRoomServiceOccurrenceVisitMutationVariables = Exact<{
  roomServiceOccurrenceAccesses: Array<UserRoomServiceOccurrenceLastVisits_Insert_Input> | UserRoomServiceOccurrenceLastVisits_Insert_Input;
}>;


export type SetUsersLastRoomServiceOccurrenceVisitMutation = { __typename?: 'mutation_root', insert_userRoomServiceOccurrenceLastVisits?: { __typename?: 'userRoomServiceOccurrenceLastVisits_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'userRoomServiceOccurrenceLastVisits', roomServiceOccurrenceId: any }> } | null };

export type RubinEventListQueryVariables = Exact<{
  where?: InputMaybe<V_Organice_Event_Stamm_Bool_Exp>;
  order_by?: InputMaybe<Array<V_Organice_Event_Stamm_Order_By> | V_Organice_Event_Stamm_Order_By>;
}>;


export type RubinEventListQuery = { __typename?: 'query_root', V_ORGANICE_EVENT_STAMM: Array<{ __typename?: 'V_ORGANICE_EVENT_STAMM', T_HASH_Event: any, ID_Rubin?: any | null, DIP_ID_Event: string, Titel?: string | null, Startdatum?: any | null, Startuhrzeit?: any | null, Enddatum?: any | null, Enduhrzeit?: any | null, VG_Typ?: string | null, Kostentraeger_IDK?: string | null }> };

export type RubinEventRoomBookingQueryVariables = Exact<{
  where?: InputMaybe<V_Organice_Event_Raumbuchung_Bool_Exp>;
  orderBy?: InputMaybe<Array<V_Organice_Event_Raumbuchung_Order_By> | V_Organice_Event_Raumbuchung_Order_By>;
}>;


export type RubinEventRoomBookingQuery = { __typename?: 'query_root', V_ORGANICE_EVENT_RAUMBUCHUNG: Array<{ __typename?: 'V_ORGANICE_EVENT_RAUMBUCHUNG', Buchungstag?: any | null, ID_Raumbuchung: any, Nutzungsart_IDK?: string | null, Raum_Bez?: string | null, T_HASH_Event?: any | null }> };

export type SearchServicesQueryVariables = Exact<{
  eventId: Scalars['bigint']['input'];
  search: Scalars['String']['input'];
}>;


export type SearchServicesQuery = { __typename?: 'query_root', files: Array<{ __typename?: 'files', id: any, name: string, extension: string, mimeType?: string | null, size?: any | null, attributeFiles: Array<{ __typename?: 'attributeFiles', attribute: { __typename?: 'attributes', id: any, name: string, description?: string | null, attributeGroup: { __typename?: 'attributeGroups', id: any, name: string, description?: string | null, serviceModule: { __typename?: 'serviceModules', id: any, name: string, service: { __typename?: 'services', id: any, name: string } } } } }>, attributeValueUploadVersions: Array<{ __typename?: 'attributeValueUploadVersions', attributeValueUpload: { __typename?: 'attributeValueUploads', attributeValue: { __typename?: 'attributeValues', attribute: { __typename?: 'attributes', id: any, name: string, description?: string | null, attributeGroup: { __typename?: 'attributeGroups', id: any, name: string, description?: string | null, serviceModule: { __typename?: 'serviceModules', id: any, name: string, service: { __typename?: 'services', id: any, name: string } } } } } } }>, roomAttributeValueUploadVersions: Array<{ __typename?: 'roomAttributeValueUploadVersions', roomAttributeValueUpload: { __typename?: 'roomAttributeValueUploads', roomAttributeValue: { __typename?: 'roomAttributeValues', id: any, roomAttributeValueGroup: { __typename?: 'roomAttributeValueGroups', id: any, roomServiceOccurrence: { __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any, endDate: any, roomService: { __typename?: 'roomServices', id: any, name: string, description?: string | null, room: { __typename?: 'rooms', id: any, name: string, description?: string | null } } } }, roomAttribute: { __typename?: 'roomAttributes', id: any, name: string, description?: string | null, roomAttributeGroup: { __typename?: 'roomAttributeGroups', id: any, name: string, description?: string | null } } } } }>, roomAttributeFiles: Array<{ __typename?: 'roomAttributeFiles', roomAttribute: { __typename?: 'roomAttributes', id: any, name: string, description?: string | null, roomAttributeGroup: { __typename?: 'roomAttributeGroups', id: any, name: string, description?: string | null, roomService: { __typename?: 'roomServices', id: any, name: string, description?: string | null, roomServiceOccurrences: Array<{ __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any, endDate: any }>, room: { __typename?: 'rooms', id: any, name: string, description?: string | null } } } } }> }>, attributes: Array<{ __typename?: 'attributes', id: any, name: string, description?: string | null, attributeGroup: { __typename?: 'attributeGroups', id: any, name: string, description?: string | null, serviceModule: { __typename?: 'serviceModules', id: any, name: string, service: { __typename?: 'services', id: any, name: string } } } }>, attributeGroups: Array<{ __typename?: 'attributeGroups', id: any, name: string, description?: string | null, serviceModule: { __typename?: 'serviceModules', id: any, name: string, service: { __typename?: 'services', id: any, name: string } } }>, serviceModules: Array<{ __typename?: 'serviceModules', id: any, name: string, service: { __typename?: 'services', id: any, name: string } }>, services: Array<{ __typename?: 'services', id: any, name: string }>, roomOccurrences: Array<{ __typename?: 'roomOccurrences', id: any, name: string, startDate: any, endDate: any, room: { __typename?: 'rooms', id: any, name: string, description?: string | null } }>, roomServiceOccurrences: Array<{ __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any, endDate: any, roomService: { __typename?: 'roomServices', id: any, name: string, description?: string | null, room: { __typename?: 'rooms', id: any, name: string, description?: string | null } } }>, roomServiceOccuencesWithMatchingAttributes: Array<{ __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any, endDate: any, roomService: { __typename?: 'roomServices', id: any, name: string, room: { __typename?: 'rooms', id: any, name: string, description?: string | null }, roomAttributeGroups: Array<{ __typename?: 'roomAttributeGroups', id: any, name: string, roomAttributes: Array<{ __typename?: 'roomAttributes', id: any, name: string }> }> } }>, roomServiceOccuencesWithMatchingAttributeGroups: Array<{ __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any, endDate: any, roomService: { __typename?: 'roomServices', id: any, name: string, room: { __typename?: 'rooms', id: any, name: string, description?: string | null }, roomAttributeGroups: Array<{ __typename?: 'roomAttributeGroups', id: any, name: string }> } }>, eventRooms: Array<{ __typename?: 'eventRooms', room: { __typename?: 'rooms', id: any, name: string, description?: string | null } }> };

export type GetRoomAttributeValuesForEventQueryVariables = Exact<{
  eventId: Scalars['bigint']['input'];
}>;


export type GetRoomAttributeValuesForEventQuery = { __typename?: 'query_root', roomServiceOccurrences: Array<{ __typename?: 'roomServiceOccurrences', id: any, name: string, startDate: any, endDate: any, roomService: { __typename?: 'roomServices', id: any, name: string, description?: string | null, room: { __typename?: 'rooms', id: any, name: string, description?: string | null } }, roomAttributeValueGroups: Array<{ __typename?: 'roomAttributeValueGroups', roomAttributeValues: Array<{ __typename?: 'roomAttributeValues', id: any, value: any, roomAttribute: { __typename?: 'roomAttributes', id: any, name: string, description?: string | null, attributeType: AttributeTypes_Enum, config: any, roomAttributeGroup: { __typename?: 'roomAttributeGroups', id: any, name: string, description?: string | null } } }> }> }> };

export type SearchAttributeValuesQueryVariables = Exact<{
  eventId: Scalars['bigint']['input'];
}>;


export type SearchAttributeValuesQuery = { __typename?: 'query_root', attributeValues: Array<{ __typename?: 'attributeValues', id: any, value: any, attributeId: any, attribute: { __typename?: 'attributes', id: any, name: string, attributeType: AttributeTypes_Enum, config: any, attributeGroup: { __typename?: 'attributeGroups', id: any, name: string, serviceModule: { __typename?: 'serviceModules', id: any, name: string, service: { __typename?: 'services', id: any, name: string } } } } }> };

export type SearchFilesQueryVariables = Exact<{
  eventId: Scalars['bigint']['input'];
  search: Scalars['String']['input'];
}>;


export type SearchFilesQuery = { __typename?: 'query_root', files: Array<{ __typename?: 'files', id: any, name: string, attributeFiles: Array<{ __typename?: 'attributeFiles', attribute: { __typename?: 'attributes', id: any, name: string, attributeGroup: { __typename?: 'attributeGroups', id: any, name: string, serviceModule: { __typename?: 'serviceModules', id: any, name: string, service: { __typename?: 'services', id: any, name: string } } } } }>, attributeValueUploadVersions: Array<{ __typename?: 'attributeValueUploadVersions', attributeValueUpload: { __typename?: 'attributeValueUploads', attributeValue: { __typename?: 'attributeValues', attribute: { __typename?: 'attributes', id: any, name: string, attributeGroup: { __typename?: 'attributeGroups', id: any, name: string, serviceModule: { __typename?: 'serviceModules', id: any, name: string, service: { __typename?: 'services', id: any, name: string } } } } } } }> }> };

export type SearchAttributesQueryVariables = Exact<{
  eventId: Scalars['bigint']['input'];
  search: Scalars['String']['input'];
}>;


export type SearchAttributesQuery = { __typename?: 'query_root', attributes: Array<{ __typename?: 'attributes', id: any, name: string, description?: string | null, attributeGroup: { __typename?: 'attributeGroups', id: any, name: string, description?: string | null, serviceModule: { __typename?: 'serviceModules', id: any, name: string, service: { __typename?: 'services', id: any, name: string } } } }> };

export type AddAttributeGroupsMutationVariables = Exact<{
  objects: Array<AttributeGroups_Insert_Input> | AttributeGroups_Insert_Input;
}>;


export type AddAttributeGroupsMutation = { __typename?: 'mutation_root', insert_attributeGroups?: { __typename?: 'attributeGroups_mutation_response', returning: Array<{ __typename?: 'attributeGroups', id: any }> } | null };

export type AddAttributeValueGroupMutationVariables = Exact<{
  object: AttributeValueGroups_Insert_Input;
}>;


export type AddAttributeValueGroupMutation = { __typename?: 'mutation_root', insert_attributeValueGroups_one?: { __typename?: 'attributeValueGroups', id: any } | null };

export type AddAttributeValueGroupsMutationVariables = Exact<{
  objects: Array<AttributeValueGroups_Insert_Input> | AttributeValueGroups_Insert_Input;
}>;


export type AddAttributeValueGroupsMutation = { __typename?: 'mutation_root', insert_attributeValueGroups?: { __typename?: 'attributeValueGroups_mutation_response', affected_rows: number } | null };

export type AddServiceModulesMutationVariables = Exact<{
  objects: Array<ServiceModules_Insert_Input> | ServiceModules_Insert_Input;
}>;


export type AddServiceModulesMutation = { __typename?: 'mutation_root', insert_serviceModules?: { __typename?: 'serviceModules_mutation_response', returning: Array<{ __typename?: 'serviceModules', id: any }> } | null };

export type AddServiceMutationVariables = Exact<{
  object: Services_Insert_Input;
}>;


export type AddServiceMutation = { __typename?: 'mutation_root', insert_services_one?: { __typename?: 'services', createdAt: any, updatedAt: any, name: string, id: any } | null };

export type AddServiceFavouriteMutationVariables = Exact<{
  object: ServiceFavourites_Insert_Input;
}>;


export type AddServiceFavouriteMutation = { __typename?: 'mutation_root', insert_serviceFavourites_one?: { __typename?: 'serviceFavourites', serviceId: any, userId: any } | null };

export type AddServicesMutationVariables = Exact<{
  objects: Array<Services_Insert_Input> | Services_Insert_Input;
}>;


export type AddServicesMutation = { __typename?: 'mutation_root', insert_services?: { __typename?: 'services_mutation_response', affected_rows: number } | null };

export type DeleteServiceModulesMutationVariables = Exact<{
  where: ServiceModules_Bool_Exp;
}>;


export type DeleteServiceModulesMutation = { __typename?: 'mutation_root', delete_serviceModules?: { __typename?: 'serviceModules_mutation_response', returning: Array<{ __typename?: 'serviceModules', id: any }> } | null };

export type DeleteServiceMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteServiceMutation = { __typename?: 'mutation_root', delete_services_by_pk?: { __typename?: 'services', id: any, name: string } | null };

export type DeleteServiceFavouriteMutationVariables = Exact<{
  serviceId: Scalars['bigint']['input'];
  userId: Scalars['bigint']['input'];
}>;


export type DeleteServiceFavouriteMutation = { __typename?: 'mutation_root', delete_serviceFavourites_by_pk?: { __typename?: 'serviceFavourites', serviceId: any, userId: any } | null };

export type DeleteAttributeGroupsMutationVariables = Exact<{
  where: AttributeGroups_Bool_Exp;
}>;


export type DeleteAttributeGroupsMutation = { __typename?: 'mutation_root', delete_attributeGroups?: { __typename?: 'attributeGroups_mutation_response', returning: Array<{ __typename?: 'attributeGroups', id: any }> } | null };

export type InsertAttributeValueMutationVariables = Exact<{
  object: AttributeValues_Insert_Input;
}>;


export type InsertAttributeValueMutation = { __typename?: 'mutation_root', insert_attributeValues_one?: { __typename?: 'attributeValues', id: any } | null };

export type SavePersonalNoteForServiceMutationVariables = Exact<{
  personalData: UserDataServices_Insert_Input;
}>;


export type SavePersonalNoteForServiceMutation = { __typename?: 'mutation_root', insert_userDataServices_one?: { __typename?: 'userDataServices', service: { __typename?: 'services', id: any, userData: Array<{ __typename?: 'userDataServices', data: any }> } } | null };

export type ServiceByIdQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
  attributes_order_by?: InputMaybe<Array<Attributes_Order_By> | Attributes_Order_By>;
  fetchBundleServices?: InputMaybe<Scalars['Boolean']['input']>;
  fetchLastUpdatedInfo?: InputMaybe<Scalars['Boolean']['input']>;
  guestOrganisationId?: InputMaybe<Scalars['bigint']['input']>;
  fetchGuestCanRead?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ServiceByIdQuery = { __typename?: 'query_root', services_by_pk?: { __typename?: 'services', id: any, name: string, tags: any, updatedAt: any, createdAt: any, userData: Array<{ __typename?: 'userDataServices', data: any }>, serviceBundleServices?: Array<{ __typename?: 'serviceBundleServices', serviceBundleId: any, serviceId: any }>, serviceModules_aggregate: { __typename?: 'serviceModules_aggregate', aggregate?: { __typename?: 'serviceModules_aggregate_fields', count: number } | null }, serviceModules: Array<{ __typename?: 'serviceModules', id: any, name: string, moduleType: ModuleTypes_Enum, published?: boolean | null, order: number, config: any, writable?: boolean | null, hasChanges?: boolean | null, guestCanRead?: boolean | null, lastVisits: Array<{ __typename?: 'userServiceModuleLastVisits', userId: any, updatedAt: any }>, attributeGroups: Array<{ __typename?: 'attributeGroups', id: any, order: number, description?: string | null, name: string, valuesRepeatable: boolean, attributeValueGroups: Array<{ __typename?: 'attributeValueGroups', id: any, attributeValues: Array<{ __typename?: 'attributeValues', createdAt: any, updatedAt: any, updatedBy?: any | null, attributeValueGroupId: any, id: any, value: any, updatedBy_user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null, organisation?: { __typename?: 'organisations', id: any, name: string } | null } | null, attributeValueUploads: Array<{ __typename?: 'attributeValueUploads', id: any, name: string, attributeValueUploadVersions: Array<{ __typename?: 'attributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> }>, comments_aggregate: { __typename?: 'attributeValueComments_aggregate', aggregate?: { __typename?: 'attributeValueComments_aggregate_fields', count: number } | null }, attribute: { __typename?: 'attributes', id: any, attributeType: AttributeTypes_Enum, config: any, name: string, description?: string | null, order: number, organisation?: { __typename?: 'organisations', id: any, name: string } | null, attributeFiles: Array<{ __typename?: 'attributeFiles', downloadUrl?: string | null, file: { __typename?: 'files', id: any, size?: any | null, name: string, extension: string } }> } }> }>, attributes: Array<{ __typename?: 'attributes', attributeType: AttributeTypes_Enum, order: number, config: any, createdAt: any, description?: string | null, id: any, name: string, updatedAt: any, organisation?: { __typename?: 'organisations', id: any, name: string } | null, attributeFiles: Array<{ __typename?: 'attributeFiles', downloadUrl?: string | null, file: { __typename?: 'files', id: any, size?: any | null, name: string, extension: string } }>, attributeValues: Array<{ __typename?: 'attributeValues', id: any, updatedAt: any, value: any, attributeValueUploads: Array<{ __typename?: 'attributeValueUploads', id: any, name: string, attributeValueUploadVersions: Array<{ __typename?: 'attributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> }>, comments_aggregate: { __typename?: 'attributeValueComments_aggregate', aggregate?: { __typename?: 'attributeValueComments_aggregate_fields', count: number } | null } }> }> }> }> } | null };

export type EventServiceByIdQueryVariables = Exact<{
  serviceId: Scalars['bigint']['input'];
  eventId: Scalars['bigint']['input'];
  organisationId?: InputMaybe<Scalars['bigint']['input']>;
  fetchGuestCanRead?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EventServiceByIdQuery = { __typename?: 'query_root', services: Array<{ __typename?: 'services', id: any, tags: any, name: string, updatedAt: any, createdAt: any, serviceModules_aggregate: { __typename?: 'serviceModules_aggregate', aggregate?: { __typename?: 'serviceModules_aggregate_fields', count: number } | null }, serviceModules: Array<{ __typename?: 'serviceModules', id: any, name: string, moduleType: ModuleTypes_Enum, config: any, hasChanges?: boolean | null, guestCanRead?: boolean | null, published?: boolean | null, attributeGroups: Array<{ __typename?: 'attributeGroups', id: any, description?: string | null, name: string, valuesRepeatable: boolean, attributeValueGroups: Array<{ __typename?: 'attributeValueGroups', id: any, attributeValues: Array<{ __typename?: 'attributeValues', id: any, value: any, attributeValueGroupId: any, comments_aggregate: { __typename?: 'attributeValueComments_aggregate', aggregate?: { __typename?: 'attributeValueComments_aggregate_fields', count: number } | null }, attributeValueUploads: Array<{ __typename?: 'attributeValueUploads', id: any, name: string, attributeValueUploadVersions: Array<{ __typename?: 'attributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> }>, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null, organisation?: { __typename?: 'organisations', id: any, name: string } | null } | null, attribute: { __typename?: 'attributes', id: any, attributeType: AttributeTypes_Enum, config: any, name: string, description?: string | null, organisation?: { __typename?: 'organisations', id: any, name: string } | null, attributeFiles: Array<{ __typename?: 'attributeFiles', file: { __typename?: 'files', id: any, size?: any | null, name: string, extension: string } }> } }> }>, attributes: Array<{ __typename?: 'attributes', attributeType: AttributeTypes_Enum, config: any, createdAt: any, description?: string | null, id: any, name: string, updatedAt: any, organisation?: { __typename?: 'organisations', id: any, name: string } | null, attributeValues: Array<{ __typename?: 'attributeValues', id: any, updatedAt: any, value: any, attributeValueUploads: Array<{ __typename?: 'attributeValueUploads', id: any, name: string, attributeValueUploadVersions: Array<{ __typename?: 'attributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> }>, comments_aggregate: { __typename?: 'attributeValueComments_aggregate', aggregate?: { __typename?: 'attributeValueComments_aggregate_fields', count: number } | null } }>, attributeFiles: Array<{ __typename?: 'attributeFiles', file: { __typename?: 'files', uploadVersions: Array<{ __typename?: 'uploadVersions', downloadUrl?: string | null, file: { __typename?: 'files', id: any, size?: any | null, name: string, extension: string } }> } }> }> }> }> }> };

export type ServiceModuleByIdQueryVariables = Exact<{
  serviceModuleId: Scalars['bigint']['input'];
  organisationId: Scalars['bigint']['input'];
  fetchLastUpdatedInfo?: InputMaybe<Scalars['Boolean']['input']>;
  fetchGuestCanRead?: InputMaybe<Scalars['Boolean']['input']>;
  guestOrganisationId?: InputMaybe<Scalars['bigint']['input']>;
}>;


export type ServiceModuleByIdQuery = { __typename?: 'query_root', serviceModules_by_pk?: { __typename?: 'serviceModules', id: any, name: string, moduleType: ModuleTypes_Enum, config: any, hasChanges?: boolean | null, guestCanRead?: boolean | null, published?: boolean | null, writable?: boolean | null, lastVisits: Array<{ __typename?: 'userServiceModuleLastVisits', userId: any, updatedAt: any }>, attributeGroups: Array<{ __typename?: 'attributeGroups', id: any, order: number, description?: string | null, name: string, valuesRepeatable: boolean, attributeValueGroups: Array<{ __typename?: 'attributeValueGroups', id: any, attributeValues: Array<{ __typename?: 'attributeValues', createdAt: any, updatedAt: any, updatedBy?: any | null, attributeValueGroupId: any, id: any, value: any, updatedBy_user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null, attributeValueUploads: Array<{ __typename?: 'attributeValueUploads', id: any, name: string, attributeValueUploadVersions: Array<{ __typename?: 'attributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> }>, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null, organisation?: { __typename?: 'organisations', id: any, name: string } | null } | null, comments_aggregate: { __typename?: 'attributeValueComments_aggregate', aggregate?: { __typename?: 'attributeValueComments_aggregate_fields', count: number } | null }, attribute: { __typename?: 'attributes', id: any, attributeType: AttributeTypes_Enum, config: any, name: string, description?: string | null, order: number, organisation?: { __typename?: 'organisations', id: any, name: string } | null, attributeFiles: Array<{ __typename?: 'attributeFiles', downloadUrl?: string | null, file: { __typename?: 'files', id: any, size?: any | null, name: string, extension: string } }> } }> }>, attributes: Array<{ __typename?: 'attributes', attributeType: AttributeTypes_Enum, order: number, config: any, createdAt: any, description?: string | null, id: any, name: string, updatedAt: any, organisation?: { __typename?: 'organisations', id: any, name: string } | null, attributeFiles: Array<{ __typename?: 'attributeFiles', downloadUrl?: string | null, file: { __typename?: 'files', id: any, size?: any | null, name: string, extension: string } }>, attributeValues: Array<{ __typename?: 'attributeValues', id: any, updatedAt: any, value: any, attributeValueUploads: Array<{ __typename?: 'attributeValueUploads', id: any, name: string, attributeValueUploadVersions: Array<{ __typename?: 'attributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> }>, comments_aggregate: { __typename?: 'attributeValueComments_aggregate', aggregate?: { __typename?: 'attributeValueComments_aggregate_fields', count: number } | null } }> }> }> } | null };

export type ServicesTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type ServicesTagsQuery = { __typename?: 'query_root', serviceTags: Array<{ __typename?: 'serviceTags', value?: string | null }> };

export type ServiceFavouritesQueryVariables = Exact<{
  userId: Scalars['bigint']['input'];
}>;


export type ServiceFavouritesQuery = { __typename?: 'query_root', serviceFavourites: Array<{ __typename?: 'serviceFavourites', serviceId: any }> };

export type ServiceListQueryVariables = Exact<{
  where?: InputMaybe<Services_Bool_Exp>;
  order_by?: InputMaybe<Array<Services_Order_By> | Services_Order_By>;
}>;


export type ServiceListQuery = { __typename?: 'query_root', services: Array<{ __typename?: 'services', id: any, name: string, tags: any, updatedAt: any, eventId?: any | null, userData: Array<{ __typename?: 'userDataServices', data: any }>, serviceModules_aggregate: { __typename?: 'serviceModules_aggregate', aggregate?: { __typename?: 'serviceModules_aggregate_fields', count: number } | null }, serviceModules: Array<{ __typename?: 'serviceModules', id: any, published?: boolean | null, config: any, hasChanges?: boolean | null, lastVisits: Array<{ __typename?: 'userServiceModuleLastVisits', userId: any, updatedAt: any }> }> }> };

export type ServiceParentsListQueryVariables = Exact<{
  where?: InputMaybe<ServiceParents_Bool_Exp>;
  order_by?: InputMaybe<Array<ServiceParents_Order_By> | ServiceParents_Order_By>;
}>;


export type ServiceParentsListQuery = { __typename?: 'query_root', serviceParents: Array<{ __typename?: 'serviceParents', id?: any | null, name?: string | null, isArchived?: any | null }> };

export type ServiceListExportQueryVariables = Exact<{
  where?: InputMaybe<Services_Bool_Exp>;
  order_by?: InputMaybe<Array<Services_Order_By> | Services_Order_By>;
  distinct_on?: InputMaybe<Array<Services_Select_Column> | Services_Select_Column>;
}>;


export type ServiceListExportQuery = { __typename?: 'query_root', services: Array<{ __typename?: 'services', id: any, name: string, eventId?: any | null, fromServiceId?: any | null, event?: { __typename?: 'events', name: string, isArchived?: any | null } | null }> };

export type UpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutationVariables = Exact<{
  attributeValues: Array<AttributeValues_Insert_Input> | AttributeValues_Insert_Input;
  attributeValueGroups: Array<AttributeValueGroups_Insert_Input> | AttributeValueGroups_Insert_Input;
  attributeValueUploadsToDelete: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
  attributeValueUploads: Array<AttributeValueUploads_Insert_Input> | AttributeValueUploads_Insert_Input;
  attributeValueUploadVersions: Array<AttributeValueUploadVersions_Insert_Input> | AttributeValueUploadVersions_Insert_Input;
  attributeValueUploadVersionsToDelete: Array<AttributeValueUploadVersions_Bool_Exp> | AttributeValueUploadVersions_Bool_Exp;
  attributeValueGroupsToDelete: Array<Scalars['bigint']['input']> | Scalars['bigint']['input'];
}>;


export type UpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutation = { __typename?: 'mutation_root', delete_attributeValueGroups?: { __typename?: 'attributeValueGroups_mutation_response', affected_rows: number } | null, delete_attributeValueUploadVersions?: { __typename?: 'attributeValueUploadVersions_mutation_response', affected_rows: number } | null, delete_attributeValueUploads?: { __typename?: 'attributeValueUploads_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'attributeValueUploads', id: any }> } | null, insert_attributeValueUploads?: { __typename?: 'attributeValueUploads_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'attributeValueUploads', id: any, attributeValueId: any }> } | null, insert_attributeValueUploadVersions?: { __typename?: 'attributeValueUploadVersions_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'attributeValueUploadVersions', attributeValueUploadId: any, fileId: any }> } | null, insert_attributeValues?: { __typename?: 'attributeValues_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'attributeValues', id: any, value: any, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null, attributes?: any | null, organisation?: { __typename?: 'organisations', id: any, name: string } | null } | null }> } | null, insert_attributeValueGroups?: { __typename?: 'attributeValueGroups_mutation_response', affected_rows: number } | null };

export type UpdateAttributeGroupMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  object: AttributeGroups_Insert_Input;
}>;


export type UpdateAttributeGroupMutation = { __typename?: 'mutation_root', delete_attributeGroups_by_pk?: { __typename?: 'attributeGroups', id: any } | null, insert_attributeGroups_one?: { __typename?: 'attributeGroups', id: any } | null };

export type UpdateServiceModuleMutationVariables = Exact<{
  _set?: InputMaybe<ServiceModules_Set_Input>;
  pk_columns: ServiceModules_Pk_Columns_Input;
}>;


export type UpdateServiceModuleMutation = { __typename?: 'mutation_root', update_serviceModules_by_pk?: { __typename?: 'serviceModules', id: any } | null };

export type UpdateServiceMutationVariables = Exact<{
  _set: Services_Set_Input;
  pk_columns: Services_Pk_Columns_Input;
}>;


export type UpdateServiceMutation = { __typename?: 'mutation_root', update_services_by_pk?: { __typename?: 'services', id: any } | null };

export type AddUploadMutationVariables = Exact<{
  object: Uploads_Insert_Input;
}>;


export type AddUploadMutation = { __typename?: 'mutation_root', insert_uploads_one?: { __typename?: 'uploads', id: any } | null };

export type AddUploadWithUploadVersionMutationVariables = Exact<{
  object: Uploads_Insert_Input;
}>;


export type AddUploadWithUploadVersionMutation = { __typename?: 'mutation_root', insert_uploads_one?: { __typename?: 'uploads', id: any } | null };

export type InsertUploadVersionMutationVariables = Exact<{
  uploadId: Scalars['bigint']['input'];
  fileId: Scalars['bigint']['input'];
}>;


export type InsertUploadVersionMutation = { __typename?: 'mutation_root', insert_uploadVersions_one?: { __typename?: 'uploadVersions', id: any, fileId: any } | null };

export type InsertNewUploadMutationVariables = Exact<{
  fileId: Scalars['bigint']['input'];
  fileName: Scalars['String']['input'];
  serviceModuleId: Scalars['bigint']['input'];
}>;


export type InsertNewUploadMutation = { __typename?: 'mutation_root', insert_uploadVersions_one?: { __typename?: 'uploadVersions', id: any, fileId: any, uploadId: any, downloadUrl?: string | null } | null };

export type InsertAttributeValueFileMutationVariables = Exact<{
  attributeValueId: Scalars['bigint']['input'];
  fileId: Scalars['bigint']['input'];
  fileName: Scalars['String']['input'];
}>;


export type InsertAttributeValueFileMutation = { __typename?: 'mutation_root', insert_attributeValueUploads_one?: { __typename?: 'attributeValueUploads', id: any, attributeValueId: any } | null };

export type InsertAttributeValueUploadVersionMutationVariables = Exact<{
  attributeValueUploadId: Scalars['bigint']['input'];
  fileId: Scalars['bigint']['input'];
}>;


export type InsertAttributeValueUploadVersionMutation = { __typename?: 'mutation_root', insert_attributeValueUploadVersions_one?: { __typename?: 'attributeValueUploadVersions', attributeValueUploadId: any, fileId: any, downloadUrl?: string | null } | null };

export type InsertRoomAttributeValueUploadVersionMutationVariables = Exact<{
  roomAttributeValueUploadId: Scalars['bigint']['input'];
  fileId: Scalars['bigint']['input'];
}>;


export type InsertRoomAttributeValueUploadVersionMutation = { __typename?: 'mutation_root', insert_roomAttributeValueUploadVersions_one?: { __typename?: 'roomAttributeValueUploadVersions', roomAttributeValueUploadId: any, fileId: any, downloadUrl?: string | null } | null };

export type InsertEventAttributeValueUploadVersionMutationVariables = Exact<{
  eventAttributeValueUploadId: Scalars['bigint']['input'];
  fileId: Scalars['bigint']['input'];
}>;


export type InsertEventAttributeValueUploadVersionMutation = { __typename?: 'mutation_root', insert_eventAttributeValueUploadVersions_one?: { __typename?: 'eventAttributeValueUploadVersions', eventAttributeValueUploadId: any, fileId: any } | null };

export type InsertEventAttributeValueFileMutationVariables = Exact<{
  eventAttributeValueId: Scalars['bigint']['input'];
  fileName: Scalars['String']['input'];
}>;


export type InsertEventAttributeValueFileMutation = { __typename?: 'mutation_root', insert_eventAttributeValueUploads_one?: { __typename?: 'eventAttributeValueUploads', id: any, eventAttributeValueId: any } | null };

export type DeleteAttributeValueFileMutationVariables = Exact<{
  fileId: Scalars['bigint']['input'];
  attributeValueUploadId: Scalars['bigint']['input'];
}>;


export type DeleteAttributeValueFileMutation = { __typename?: 'mutation_root', delete_attributeValueUploadVersions_by_pk?: { __typename?: 'attributeValueUploadVersions', fileId: any } | null };

export type DeleteAttributeValueUploadMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteAttributeValueUploadMutation = { __typename?: 'mutation_root', delete_attributeValueUploads_by_pk?: { __typename?: 'attributeValueUploads', id: any } | null };

export type DeleteRoomAttributeValueUploadVersionMutationVariables = Exact<{
  fileId: Scalars['bigint']['input'];
  roomAttributeValueUploadId: Scalars['bigint']['input'];
}>;


export type DeleteRoomAttributeValueUploadVersionMutation = { __typename?: 'mutation_root', delete_roomAttributeValueUploadVersions_by_pk?: { __typename?: 'roomAttributeValueUploadVersions', fileId: any } | null };

export type DeleteRoomAttributeValueUploadMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteRoomAttributeValueUploadMutation = { __typename?: 'mutation_root', delete_roomAttributeValueUploads_by_pk?: { __typename?: 'roomAttributeValueUploads', id: any } | null };

export type DeleteEventAttributeValueUploadVersionMutationVariables = Exact<{
  fileId: Scalars['bigint']['input'];
  eventAttributeValueUploadId: Scalars['bigint']['input'];
}>;


export type DeleteEventAttributeValueUploadVersionMutation = { __typename?: 'mutation_root', delete_eventAttributeValueUploadVersions_by_pk?: { __typename?: 'eventAttributeValueUploadVersions', fileId: any } | null };

export type DeleteEventAttributeValueUploadMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteEventAttributeValueUploadMutation = { __typename?: 'mutation_root', delete_eventAttributeValueUploads_by_pk?: { __typename?: 'eventAttributeValueUploads', id: any } | null };

export type DeleteAttributeFileMutationVariables = Exact<{
  fileId: Scalars['bigint']['input'];
  attributeId: Scalars['bigint']['input'];
}>;


export type DeleteAttributeFileMutation = { __typename?: 'mutation_root', delete_attributeFiles_by_pk?: { __typename?: 'attributeFiles', fileId: any } | null };

export type DeleteUploadVersionsMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteUploadVersionsMutation = { __typename?: 'mutation_root', delete_uploadVersions_by_pk?: { __typename?: 'uploadVersions', id: any } | null };

export type DeleteUploadsMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteUploadsMutation = { __typename?: 'mutation_root', delete_uploads_by_pk?: { __typename?: 'uploads', id: any } | null };

export type AttributeValueUploadFileListFragment = { __typename?: 'attributeValueUploads', id: any, name: string, attributeValueUploadVersions: Array<{ __typename?: 'attributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> };

export type RoomAttributeValueUploadFileListFragment = { __typename?: 'roomAttributeValueUploads', id: any, name: string, roomAttributeValueUploadVersions: Array<{ __typename?: 'roomAttributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> };

export type EventAttributeValueUploadFileListFragment = { __typename?: 'eventAttributeValueUploads', id: any, name: string, eventAttributeValueUploadVersions: Array<{ __typename?: 'eventAttributeValueUploadVersions', fileId: any, downloadUrl?: string | null, file: { __typename?: 'files', id: any, createdAt: any, size?: any | null, name: string, extension: string, user?: { __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null } | null } }> };

export type AddUserMutationVariables = Exact<{
  object: Users_Insert_Input;
}>;


export type AddUserMutation = { __typename?: 'mutation_root', insert_users_one?: { __typename?: 'users', id: any, lastLoginAt?: any | null, email: string, firstName?: string | null, lastName?: string | null, failedLoginCount: number, organisationId: any, organisation: { __typename?: 'organisations', id: any, name: string }, organisationGroupUsers: Array<{ __typename?: 'organisationGroupUsers', organisationGroup: { __typename?: 'organisationGroups', id: any } }>, userAttributeValues: Array<{ __typename?: 'userAttributeValues', value: any, userAttribute: { __typename?: 'userAttributes', id: any, name: string } }> } | null };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'mutation_root', delete_users_by_pk?: { __typename?: 'users', id: any } | null };

export type ResetUserFailedLoginsMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type ResetUserFailedLoginsMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: any, failedLoginCount: number } | null };

export type UpdateUserPasswordMutationVariables = Exact<{
  ownPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  id: Scalars['Int']['input'];
}>;


export type UpdateUserPasswordMutation = { __typename?: 'mutation_root', setPassword?: { __typename?: 'SetPasswordReturn', passwordSet: boolean } | null };

export type SetMailNotificationCadenceMutationVariables = Exact<{
  mailNotificationCadence: Scalars['String']['input'];
}>;


export type SetMailNotificationCadenceMutation = { __typename?: 'mutation_root', update_userSettings?: { __typename?: 'userSettings_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'userSettings', id?: any | null, mailNotificationCadence?: string | null, wantRoomOccurrenceNotifications?: boolean | null }> } | null };

export type DeleteEventAttributeValueChangeNotificationMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteEventAttributeValueChangeNotificationMutation = { __typename?: 'mutation_root', delete_notificationPreferences?: { __typename?: 'notificationPreferences_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'notificationPreferences', id: any, notificationChannel: NotificationChannels_Enum, notificationPreferenceStage: NotificationPreferenceStages_Enum }> } | null };

export type AddEventAttributeValueChangeNotificationMutationVariables = Exact<{ [key: string]: never; }>;


export type AddEventAttributeValueChangeNotificationMutation = { __typename?: 'mutation_root', insert_notificationPreferences?: { __typename?: 'notificationPreferences_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'notificationPreferences', id: any, notificationAction: NotificationActions_Enum, notificationChannel: NotificationChannels_Enum, notificationPreferenceStage: NotificationPreferenceStages_Enum }> } | null };

export type DeleteEventCreatedNotificationMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteEventCreatedNotificationMutation = { __typename?: 'mutation_root', delete_notificationPreferences?: { __typename?: 'notificationPreferences_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'notificationPreferences', id: any, notificationChannel: NotificationChannels_Enum, notificationPreferenceStage: NotificationPreferenceStages_Enum }> } | null };

export type AddEventCreatedNotificationMutationVariables = Exact<{ [key: string]: never; }>;


export type AddEventCreatedNotificationMutation = { __typename?: 'mutation_root', insert_notificationPreferences?: { __typename?: 'notificationPreferences_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'notificationPreferences', id: any, notificationAction: NotificationActions_Enum, notificationChannel: NotificationChannels_Enum, notificationPreferenceStage: NotificationPreferenceStages_Enum }> } | null };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['bigint']['input'];
  object?: InputMaybe<Users_Set_Input>;
  organisationGroupUsers: Array<OrganisationGroupUsers_Insert_Input> | OrganisationGroupUsers_Insert_Input;
  userAttributeValues: Array<UserAttributeValues_Insert_Input> | UserAttributeValues_Insert_Input;
}>;


export type UpdateUserMutation = { __typename?: 'mutation_root', delete_organisationGroupUsers?: { __typename?: 'organisationGroupUsers_mutation_response', affected_rows: number } | null, update_users_by_pk?: { __typename?: 'users', id: any, lastLoginAt?: any | null, email: string, firstName?: string | null, lastName?: string | null, jaggaerUsername: string, organisationId: any, organisation: { __typename?: 'organisations', id: any, name: string }, organisationGroupUsers: Array<{ __typename?: 'organisationGroupUsers', organisationGroup: { __typename?: 'organisationGroups', id: any, name: string } }> } | null, insert_organisationGroupUsers?: { __typename?: 'organisationGroupUsers_mutation_response', affected_rows: number } | null, insert_userAttributeValues?: { __typename?: 'userAttributeValues_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'userAttributeValues', value: any, userId: any, userAttributeId: any }> } | null };

export type InsertUserAttributeValuesMutationVariables = Exact<{
  objects: Array<UserAttributeValues_Insert_Input> | UserAttributeValues_Insert_Input;
}>;


export type InsertUserAttributeValuesMutation = { __typename?: 'mutation_root', insert_userAttributeValues?: { __typename?: 'userAttributeValues_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'userAttributeValues', value: any, userId: any, userAttributeId: any }> } | null };

export type GetUserAttributesQueryVariables = Exact<{
  names?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetUserAttributesQuery = { __typename?: 'query_root', userAttributes: Array<{ __typename?: 'userAttributes', id: any, name: string }> };

export type UserByIdQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type UserByIdQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: any, createdAt: any, updatedAt: any, lastLoginAt?: any | null, email: string, firstName?: string | null, lastName?: string | null, ldapDN?: string | null, failedLoginCount: number, isDisabled?: any | null, organisationId: any, hasPassword?: boolean | null, jaggaerUsername: string, organisation: { __typename?: 'organisations', id: any, name: string, isGuestOrga: boolean }, organisationGroupUsers: Array<{ __typename?: 'organisationGroupUsers', organisationGroup: { __typename?: 'organisationGroups', id: any, name: string } }>, userAttributeValues: Array<{ __typename?: 'userAttributeValues', value: any, userAttribute: { __typename?: 'userAttributes', id: any, name: string } }> } | null };

export type UserByIdOrgaAdminQueryVariables = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type UserByIdOrgaAdminQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', id: any, lastLoginAt?: any | null, email: string, firstName?: string | null, lastName?: string | null, ldapDN?: string | null, failedLoginCount: number, organisationId: any, hasPassword?: boolean | null, organisation: { __typename?: 'organisations', id: any, name: string }, organisationGroupUsers: Array<{ __typename?: 'organisationGroupUsers', organisationGroup: { __typename?: 'organisationGroups', id: any, name: string } }>, userAttributeValues: Array<{ __typename?: 'userAttributeValues', value: any, userAttribute: { __typename?: 'userAttributes', id: any, name: string } }> } | null };

export type GetNotificationUserSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationUserSettingsQuery = { __typename?: 'query_root', currentUser?: { __typename?: 'users', id: any, settings?: { __typename?: 'userSettings', id?: any | null, mailNotificationCadence?: string | null, notificationForOrganisation?: boolean | null, wantRoomOccurrenceNotifications?: boolean | null } | null } | null, notificationPreferences: Array<{ __typename?: 'notificationPreferences', id: any, notificationChannel: NotificationChannels_Enum, notificationPreferenceStage: NotificationPreferenceStages_Enum }>, eventAttributeValueChangePreferences: Array<{ __typename?: 'notificationPreferences', id: any }> };

export type UsersListQueryVariables = Exact<{
  where?: InputMaybe<Users_Bool_Exp>;
}>;


export type UsersListQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, createdAt: any, updatedAt: any, lastLoginAt?: any | null, email: string, firstName?: string | null, lastName?: string | null, failedLoginCount: number, isDisabled?: any | null, organisation: { __typename?: 'organisations', id: any, name: string }, organisationGroupUsers: Array<{ __typename?: 'organisationGroupUsers', organisationGroup: { __typename?: 'organisationGroups', id: any, name: string } }> }> };

export type UsersListForNonAdminUsersQueryVariables = Exact<{
  where?: InputMaybe<AllUsers_Bool_Exp>;
}>;


export type UsersListForNonAdminUsersQuery = { __typename?: 'query_root', allUsers: Array<{ __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null, organisation?: { __typename?: 'organisations', id: any, name: string } | null }> };

export type UsersListOrgaAdminQueryVariables = Exact<{
  where?: InputMaybe<Users_Bool_Exp>;
}>;


export type UsersListOrgaAdminQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, email: string, firstName?: string | null, lastName?: string | null, failedLoginCount: number, organisation: { __typename?: 'organisations', id: any, name: string }, organisationGroupUsers: Array<{ __typename?: 'organisationGroupUsers', organisationGroup: { __typename?: 'organisationGroups', id: any, name: string } }> }> };

export type AllUsersListQueryVariables = Exact<{
  where?: InputMaybe<AllUsers_Bool_Exp>;
}>;


export type AllUsersListQuery = { __typename?: 'query_root', allUsers: Array<{ __typename?: 'allUsers', id?: any | null, firstName?: string | null, lastName?: string | null, attributes?: any | null, organisation?: { __typename?: 'organisations', id: any, name: string } | null }> };

export const UploadVersionFieldsWithJaggaerInfoFragmentDoc = gql`
    fragment uploadVersionFieldsWithJaggaerInfo on uploadVersions {
  id
  downloadUrl
  file {
    id
    createdAt
    name
    extension
    mimeType
    user {
      id
      firstName
      lastName
    }
  }
  jaggaerSubmissions(order_by: {createdAt: desc}) {
    id
    fileId
    uploadVersionId
    jaggaerArticleId
    lastAttachmentResponse
    nextTryAfter
    updatedAt
    createdAt
    user {
      id
      firstName
      lastName
    }
    jaggaerBanf {
      id
      jaggaerBanf
    }
  }
}
    `;
export const UploadVersionFieldsFragmentDoc = gql`
    fragment uploadVersionFields on uploadVersions {
  id
  downloadUrl
  file {
    id
    createdAt
    name
    extension
    mimeType
    user {
      id
      firstName
      lastName
    }
  }
}
    `;
export const AttributeValueUploadFileListFragmentDoc = gql`
    fragment AttributeValueUploadFileList on attributeValueUploads {
  id
  name
  attributeValueUploadVersions(order_by: {file: {createdAt: desc}}) {
    fileId
    downloadUrl
    file {
      id
      createdAt
      size
      name
      extension
      user {
        id
        firstName
        lastName
      }
    }
  }
}
    `;
export const RoomAttributeValueUploadFileListFragmentDoc = gql`
    fragment RoomAttributeValueUploadFileList on roomAttributeValueUploads {
  id
  name
  roomAttributeValueUploadVersions(order_by: {file: {createdAt: desc}}) {
    fileId
    downloadUrl
    file {
      id
      createdAt
      size
      name
      extension
      user {
        id
        firstName
        lastName
      }
    }
  }
}
    `;
export const EventAttributeValueUploadFileListFragmentDoc = gql`
    fragment EventAttributeValueUploadFileList on eventAttributeValueUploads {
  id
  name
  eventAttributeValueUploadVersions(order_by: {file: {createdAt: desc}}) {
    fileId
    downloadUrl
    file {
      id
      createdAt
      size
      name
      extension
      user {
        id
        firstName
        lastName
      }
    }
  }
}
    `;
export const GetUserDocument = gql`
    query getUser($id: bigint!) {
  users_by_pk(id: $id) {
    id
    firstName
    lastName
    email
    userAttributeValues {
      value
      userAttribute {
        name
      }
    }
    organisation {
      name
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetVisibleUserByIdDocument = gql`
    query getVisibleUserById($id: bigint!) {
  allUsers(where: {id: {_eq: $id}}) {
    id
    firstName
    lastName
    attributes
    publicEmail
    organisation {
      name
    }
    isDisabled
  }
}
    `;

/**
 * __useGetVisibleUserByIdQuery__
 *
 * To run a query within a React component, call `useGetVisibleUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisibleUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisibleUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVisibleUserByIdQuery(baseOptions: Apollo.QueryHookOptions<GetVisibleUserByIdQuery, GetVisibleUserByIdQueryVariables> & ({ variables: GetVisibleUserByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVisibleUserByIdQuery, GetVisibleUserByIdQueryVariables>(GetVisibleUserByIdDocument, options);
      }
export function useGetVisibleUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisibleUserByIdQuery, GetVisibleUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVisibleUserByIdQuery, GetVisibleUserByIdQueryVariables>(GetVisibleUserByIdDocument, options);
        }
export function useGetVisibleUserByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVisibleUserByIdQuery, GetVisibleUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVisibleUserByIdQuery, GetVisibleUserByIdQueryVariables>(GetVisibleUserByIdDocument, options);
        }
export type GetVisibleUserByIdQueryHookResult = ReturnType<typeof useGetVisibleUserByIdQuery>;
export type GetVisibleUserByIdLazyQueryHookResult = ReturnType<typeof useGetVisibleUserByIdLazyQuery>;
export type GetVisibleUserByIdSuspenseQueryHookResult = ReturnType<typeof useGetVisibleUserByIdSuspenseQuery>;
export type GetVisibleUserByIdQueryResult = Apollo.QueryResult<GetVisibleUserByIdQuery, GetVisibleUserByIdQueryVariables>;
export const GetInfoBoxeBySlugDocument = gql`
    query getInfoBoxeBySlug($slug: String!, $userIsAdmin: Boolean = false) {
  infoBoxes(where: {slug: {_eq: $slug}}) {
    id
    content
    isInternal @include(if: $userIsAdmin)
    slug
    title
  }
}
    `;

/**
 * __useGetInfoBoxeBySlugQuery__
 *
 * To run a query within a React component, call `useGetInfoBoxeBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfoBoxeBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfoBoxeBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      userIsAdmin: // value for 'userIsAdmin'
 *   },
 * });
 */
export function useGetInfoBoxeBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetInfoBoxeBySlugQuery, GetInfoBoxeBySlugQueryVariables> & ({ variables: GetInfoBoxeBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInfoBoxeBySlugQuery, GetInfoBoxeBySlugQueryVariables>(GetInfoBoxeBySlugDocument, options);
      }
export function useGetInfoBoxeBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInfoBoxeBySlugQuery, GetInfoBoxeBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInfoBoxeBySlugQuery, GetInfoBoxeBySlugQueryVariables>(GetInfoBoxeBySlugDocument, options);
        }
export function useGetInfoBoxeBySlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInfoBoxeBySlugQuery, GetInfoBoxeBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInfoBoxeBySlugQuery, GetInfoBoxeBySlugQueryVariables>(GetInfoBoxeBySlugDocument, options);
        }
export type GetInfoBoxeBySlugQueryHookResult = ReturnType<typeof useGetInfoBoxeBySlugQuery>;
export type GetInfoBoxeBySlugLazyQueryHookResult = ReturnType<typeof useGetInfoBoxeBySlugLazyQuery>;
export type GetInfoBoxeBySlugSuspenseQueryHookResult = ReturnType<typeof useGetInfoBoxeBySlugSuspenseQuery>;
export type GetInfoBoxeBySlugQueryResult = Apollo.QueryResult<GetInfoBoxeBySlugQuery, GetInfoBoxeBySlugQueryVariables>;
export const UpsertInfoBoxDocument = gql`
    mutation upsertInfoBox($slug: String!, $title: String!, $isInternal: Boolean!, $content: json!) {
  insert_infoBoxes_one(
    object: {slug: $slug, title: $title, isInternal: $isInternal, content: $content}
    on_conflict: {constraint: infoBoxes_slug_key, update_columns: [title, content]}
  ) {
    id
    slug
    title
    content
    isInternal
  }
}
    `;
export type UpsertInfoBoxMutationFn = Apollo.MutationFunction<UpsertInfoBoxMutation, UpsertInfoBoxMutationVariables>;

/**
 * __useUpsertInfoBoxMutation__
 *
 * To run a mutation, you first call `useUpsertInfoBoxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertInfoBoxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertInfoBoxMutation, { data, loading, error }] = useUpsertInfoBoxMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      title: // value for 'title'
 *      isInternal: // value for 'isInternal'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpsertInfoBoxMutation(baseOptions?: Apollo.MutationHookOptions<UpsertInfoBoxMutation, UpsertInfoBoxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertInfoBoxMutation, UpsertInfoBoxMutationVariables>(UpsertInfoBoxDocument, options);
      }
export type UpsertInfoBoxMutationHookResult = ReturnType<typeof useUpsertInfoBoxMutation>;
export type UpsertInfoBoxMutationResult = Apollo.MutationResult<UpsertInfoBoxMutation>;
export type UpsertInfoBoxMutationOptions = Apollo.BaseMutationOptions<UpsertInfoBoxMutation, UpsertInfoBoxMutationVariables>;
export const DeleteInfoNewsEntryByIdDocument = gql`
    mutation deleteInfoNewsEntryById($id: bigint!) {
  delete_infoNews_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteInfoNewsEntryByIdMutationFn = Apollo.MutationFunction<DeleteInfoNewsEntryByIdMutation, DeleteInfoNewsEntryByIdMutationVariables>;

/**
 * __useDeleteInfoNewsEntryByIdMutation__
 *
 * To run a mutation, you first call `useDeleteInfoNewsEntryByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInfoNewsEntryByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInfoNewsEntryByIdMutation, { data, loading, error }] = useDeleteInfoNewsEntryByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInfoNewsEntryByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInfoNewsEntryByIdMutation, DeleteInfoNewsEntryByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInfoNewsEntryByIdMutation, DeleteInfoNewsEntryByIdMutationVariables>(DeleteInfoNewsEntryByIdDocument, options);
      }
export type DeleteInfoNewsEntryByIdMutationHookResult = ReturnType<typeof useDeleteInfoNewsEntryByIdMutation>;
export type DeleteInfoNewsEntryByIdMutationResult = Apollo.MutationResult<DeleteInfoNewsEntryByIdMutation>;
export type DeleteInfoNewsEntryByIdMutationOptions = Apollo.BaseMutationOptions<DeleteInfoNewsEntryByIdMutation, DeleteInfoNewsEntryByIdMutationVariables>;
export const InsertInfoNewsEntryDocument = gql`
    mutation insertInfoNewsEntry($object: infoNews_insert_input!) {
  insert_infoNews_one(object: $object) {
    id
    title
    content
    date
    isInternal
  }
}
    `;
export type InsertInfoNewsEntryMutationFn = Apollo.MutationFunction<InsertInfoNewsEntryMutation, InsertInfoNewsEntryMutationVariables>;

/**
 * __useInsertInfoNewsEntryMutation__
 *
 * To run a mutation, you first call `useInsertInfoNewsEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertInfoNewsEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertInfoNewsEntryMutation, { data, loading, error }] = useInsertInfoNewsEntryMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertInfoNewsEntryMutation(baseOptions?: Apollo.MutationHookOptions<InsertInfoNewsEntryMutation, InsertInfoNewsEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertInfoNewsEntryMutation, InsertInfoNewsEntryMutationVariables>(InsertInfoNewsEntryDocument, options);
      }
export type InsertInfoNewsEntryMutationHookResult = ReturnType<typeof useInsertInfoNewsEntryMutation>;
export type InsertInfoNewsEntryMutationResult = Apollo.MutationResult<InsertInfoNewsEntryMutation>;
export type InsertInfoNewsEntryMutationOptions = Apollo.BaseMutationOptions<InsertInfoNewsEntryMutation, InsertInfoNewsEntryMutationVariables>;
export const UpdateInfoNewsEntryByIdDocument = gql`
    mutation updateInfoNewsEntryById($id: bigint!, $title: String!, $content: json!, $date: timestamptz!, $isInternal: Boolean!) {
  update_infoNews_by_pk(
    pk_columns: {id: $id}
    _set: {title: $title, content: $content, date: $date, isInternal: $isInternal}
  ) {
    id
    title
    content
    date
    isInternal
  }
}
    `;
export type UpdateInfoNewsEntryByIdMutationFn = Apollo.MutationFunction<UpdateInfoNewsEntryByIdMutation, UpdateInfoNewsEntryByIdMutationVariables>;

/**
 * __useUpdateInfoNewsEntryByIdMutation__
 *
 * To run a mutation, you first call `useUpdateInfoNewsEntryByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInfoNewsEntryByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInfoNewsEntryByIdMutation, { data, loading, error }] = useUpdateInfoNewsEntryByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      content: // value for 'content'
 *      date: // value for 'date'
 *      isInternal: // value for 'isInternal'
 *   },
 * });
 */
export function useUpdateInfoNewsEntryByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInfoNewsEntryByIdMutation, UpdateInfoNewsEntryByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInfoNewsEntryByIdMutation, UpdateInfoNewsEntryByIdMutationVariables>(UpdateInfoNewsEntryByIdDocument, options);
      }
export type UpdateInfoNewsEntryByIdMutationHookResult = ReturnType<typeof useUpdateInfoNewsEntryByIdMutation>;
export type UpdateInfoNewsEntryByIdMutationResult = Apollo.MutationResult<UpdateInfoNewsEntryByIdMutation>;
export type UpdateInfoNewsEntryByIdMutationOptions = Apollo.BaseMutationOptions<UpdateInfoNewsEntryByIdMutation, UpdateInfoNewsEntryByIdMutationVariables>;
export const GetInfoNewsDocument = gql`
    query getInfoNews($limit: Int, $offset: Int, $where: infoNews_bool_exp, $userIsAdmin: Boolean = false) {
  infoNews(where: $where, limit: $limit, offset: $offset, order_by: {date: desc}) {
    id
    date
    title
    content
    isInternal @include(if: $userIsAdmin)
  }
}
    `;

/**
 * __useGetInfoNewsQuery__
 *
 * To run a query within a React component, call `useGetInfoNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfoNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfoNewsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *      userIsAdmin: // value for 'userIsAdmin'
 *   },
 * });
 */
export function useGetInfoNewsQuery(baseOptions?: Apollo.QueryHookOptions<GetInfoNewsQuery, GetInfoNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInfoNewsQuery, GetInfoNewsQueryVariables>(GetInfoNewsDocument, options);
      }
export function useGetInfoNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInfoNewsQuery, GetInfoNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInfoNewsQuery, GetInfoNewsQueryVariables>(GetInfoNewsDocument, options);
        }
export function useGetInfoNewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInfoNewsQuery, GetInfoNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInfoNewsQuery, GetInfoNewsQueryVariables>(GetInfoNewsDocument, options);
        }
export type GetInfoNewsQueryHookResult = ReturnType<typeof useGetInfoNewsQuery>;
export type GetInfoNewsLazyQueryHookResult = ReturnType<typeof useGetInfoNewsLazyQuery>;
export type GetInfoNewsSuspenseQueryHookResult = ReturnType<typeof useGetInfoNewsSuspenseQuery>;
export type GetInfoNewsQueryResult = Apollo.QueryResult<GetInfoNewsQuery, GetInfoNewsQueryVariables>;
export const GetEventsAutocompleteDocument = gql`
    query getEventsAutocomplete($searchString: String!, $currentEventId: bigint!) {
  events(
    where: {_and: [{name: {_ilike: $searchString}}, {id: {_neq: $currentEventId}}]}
    order_by: {startDate: desc}
  ) {
    id
    name
    startDate
    endDate
  }
}
    `;

/**
 * __useGetEventsAutocompleteQuery__
 *
 * To run a query within a React component, call `useGetEventsAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsAutocompleteQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *      currentEventId: // value for 'currentEventId'
 *   },
 * });
 */
export function useGetEventsAutocompleteQuery(baseOptions: Apollo.QueryHookOptions<GetEventsAutocompleteQuery, GetEventsAutocompleteQueryVariables> & ({ variables: GetEventsAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsAutocompleteQuery, GetEventsAutocompleteQueryVariables>(GetEventsAutocompleteDocument, options);
      }
export function useGetEventsAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsAutocompleteQuery, GetEventsAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsAutocompleteQuery, GetEventsAutocompleteQueryVariables>(GetEventsAutocompleteDocument, options);
        }
export function useGetEventsAutocompleteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventsAutocompleteQuery, GetEventsAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventsAutocompleteQuery, GetEventsAutocompleteQueryVariables>(GetEventsAutocompleteDocument, options);
        }
export type GetEventsAutocompleteQueryHookResult = ReturnType<typeof useGetEventsAutocompleteQuery>;
export type GetEventsAutocompleteLazyQueryHookResult = ReturnType<typeof useGetEventsAutocompleteLazyQuery>;
export type GetEventsAutocompleteSuspenseQueryHookResult = ReturnType<typeof useGetEventsAutocompleteSuspenseQuery>;
export type GetEventsAutocompleteQueryResult = Apollo.QueryResult<GetEventsAutocompleteQuery, GetEventsAutocompleteQueryVariables>;
export const FetchRoomMatrixForImportByEventIdDocument = gql`
    query fetchRoomMatrixForImportByEventId($eventId: bigint!) {
  events_by_pk(id: $eventId) {
    id
    startDate
    endDate
    name
    eventRooms {
      roomId
      guestCanEdit
      room {
        id
        name
        shortDescription
        description
        eventId
        fromRoomId
        roomFolderId
        roomServices(order_by: {order: asc}) {
          id
          name
          fromRoomServiceId
          roomServiceOccurrences(
            where: {eventId: {_eq: $eventId}}
            order_by: {startDate: asc}
          ) {
            id
            createdAt
            startDate
            endDate
            name
            eventId
            fromRoomServiceOccurrenceId
          }
        }
      }
    }
  }
  roomOccurrences(where: {eventId: {_eq: $eventId}}, order_by: {startDate: asc}) {
    id
    createdAt
    startDate
    endDate
    name
    fromRoomOccurrenceId
    room {
      id
      name
      shortDescription
      description
      eventId
      fromRoomId
      roomFolderId
    }
  }
}
    `;

/**
 * __useFetchRoomMatrixForImportByEventIdQuery__
 *
 * To run a query within a React component, call `useFetchRoomMatrixForImportByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRoomMatrixForImportByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRoomMatrixForImportByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useFetchRoomMatrixForImportByEventIdQuery(baseOptions: Apollo.QueryHookOptions<FetchRoomMatrixForImportByEventIdQuery, FetchRoomMatrixForImportByEventIdQueryVariables> & ({ variables: FetchRoomMatrixForImportByEventIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchRoomMatrixForImportByEventIdQuery, FetchRoomMatrixForImportByEventIdQueryVariables>(FetchRoomMatrixForImportByEventIdDocument, options);
      }
export function useFetchRoomMatrixForImportByEventIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchRoomMatrixForImportByEventIdQuery, FetchRoomMatrixForImportByEventIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchRoomMatrixForImportByEventIdQuery, FetchRoomMatrixForImportByEventIdQueryVariables>(FetchRoomMatrixForImportByEventIdDocument, options);
        }
export function useFetchRoomMatrixForImportByEventIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchRoomMatrixForImportByEventIdQuery, FetchRoomMatrixForImportByEventIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchRoomMatrixForImportByEventIdQuery, FetchRoomMatrixForImportByEventIdQueryVariables>(FetchRoomMatrixForImportByEventIdDocument, options);
        }
export type FetchRoomMatrixForImportByEventIdQueryHookResult = ReturnType<typeof useFetchRoomMatrixForImportByEventIdQuery>;
export type FetchRoomMatrixForImportByEventIdLazyQueryHookResult = ReturnType<typeof useFetchRoomMatrixForImportByEventIdLazyQuery>;
export type FetchRoomMatrixForImportByEventIdSuspenseQueryHookResult = ReturnType<typeof useFetchRoomMatrixForImportByEventIdSuspenseQuery>;
export type FetchRoomMatrixForImportByEventIdQueryResult = Apollo.QueryResult<FetchRoomMatrixForImportByEventIdQuery, FetchRoomMatrixForImportByEventIdQueryVariables>;
export const CopyEventRoomsDocument = gql`
    mutation copyEventRooms($objects: [eventRooms_insert_input!]!) {
  insert_eventRooms(objects: $objects) {
    returning {
      eventId
      roomId
      guestCanEdit
      room {
        id
        name
        description
        shortDescription
        fromRoomId
        eventId
      }
    }
  }
}
    `;
export type CopyEventRoomsMutationFn = Apollo.MutationFunction<CopyEventRoomsMutation, CopyEventRoomsMutationVariables>;

/**
 * __useCopyEventRoomsMutation__
 *
 * To run a mutation, you first call `useCopyEventRoomsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyEventRoomsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyEventRoomsMutation, { data, loading, error }] = useCopyEventRoomsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useCopyEventRoomsMutation(baseOptions?: Apollo.MutationHookOptions<CopyEventRoomsMutation, CopyEventRoomsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyEventRoomsMutation, CopyEventRoomsMutationVariables>(CopyEventRoomsDocument, options);
      }
export type CopyEventRoomsMutationHookResult = ReturnType<typeof useCopyEventRoomsMutation>;
export type CopyEventRoomsMutationResult = Apollo.MutationResult<CopyEventRoomsMutation>;
export type CopyEventRoomsMutationOptions = Apollo.BaseMutationOptions<CopyEventRoomsMutation, CopyEventRoomsMutationVariables>;
export const CopyMatrixOccurrencesDocument = gql`
    mutation copyMatrixOccurrences($eventRooms: [eventRooms_insert_input!]!, $roomOccurrences: [roomOccurrences_insert_input!]!, $roomServiceOccurrences: [roomServiceOccurrences_insert_input!]!) {
  insert_eventRooms(
    objects: $eventRooms
    on_conflict: {constraint: eventRooms_pkey}
  ) {
    returning {
      roomId
      eventId
      guestCanEdit
    }
  }
  insert_roomOccurrences(objects: $roomOccurrences) {
    returning {
      id
      startDate
      endDate
      name
      room {
        id
        name
        shortDescription
        description
        eventId
        fromRoomId
        roomFolderId
      }
    }
  }
  insert_roomServiceOccurrences(objects: $roomServiceOccurrences) {
    returning {
      id
      startDate
      endDate
      name
      eventId
      roomService {
        id
        roomId
        order
      }
    }
  }
}
    `;
export type CopyMatrixOccurrencesMutationFn = Apollo.MutationFunction<CopyMatrixOccurrencesMutation, CopyMatrixOccurrencesMutationVariables>;

/**
 * __useCopyMatrixOccurrencesMutation__
 *
 * To run a mutation, you first call `useCopyMatrixOccurrencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyMatrixOccurrencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyMatrixOccurrencesMutation, { data, loading, error }] = useCopyMatrixOccurrencesMutation({
 *   variables: {
 *      eventRooms: // value for 'eventRooms'
 *      roomOccurrences: // value for 'roomOccurrences'
 *      roomServiceOccurrences: // value for 'roomServiceOccurrences'
 *   },
 * });
 */
export function useCopyMatrixOccurrencesMutation(baseOptions?: Apollo.MutationHookOptions<CopyMatrixOccurrencesMutation, CopyMatrixOccurrencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyMatrixOccurrencesMutation, CopyMatrixOccurrencesMutationVariables>(CopyMatrixOccurrencesDocument, options);
      }
export type CopyMatrixOccurrencesMutationHookResult = ReturnType<typeof useCopyMatrixOccurrencesMutation>;
export type CopyMatrixOccurrencesMutationResult = Apollo.MutationResult<CopyMatrixOccurrencesMutation>;
export type CopyMatrixOccurrencesMutationOptions = Apollo.BaseMutationOptions<CopyMatrixOccurrencesMutation, CopyMatrixOccurrencesMutationVariables>;
export const GetServiceOrganisationAccessesDocument = gql`
    query getServiceOrganisationAccesses($serviceIdFilter: bigint_comparison_exp) {
  serviceOrganisationAccesses(
    where: {serviceId: $serviceIdFilter}
    order_by: {updatedAt: desc}
  ) {
    organisation {
      id
      name
    }
    updatedAt
  }
}
    `;

/**
 * __useGetServiceOrganisationAccessesQuery__
 *
 * To run a query within a React component, call `useGetServiceOrganisationAccessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceOrganisationAccessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceOrganisationAccessesQuery({
 *   variables: {
 *      serviceIdFilter: // value for 'serviceIdFilter'
 *   },
 * });
 */
export function useGetServiceOrganisationAccessesQuery(baseOptions?: Apollo.QueryHookOptions<GetServiceOrganisationAccessesQuery, GetServiceOrganisationAccessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceOrganisationAccessesQuery, GetServiceOrganisationAccessesQueryVariables>(GetServiceOrganisationAccessesDocument, options);
      }
export function useGetServiceOrganisationAccessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceOrganisationAccessesQuery, GetServiceOrganisationAccessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceOrganisationAccessesQuery, GetServiceOrganisationAccessesQueryVariables>(GetServiceOrganisationAccessesDocument, options);
        }
export function useGetServiceOrganisationAccessesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceOrganisationAccessesQuery, GetServiceOrganisationAccessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceOrganisationAccessesQuery, GetServiceOrganisationAccessesQueryVariables>(GetServiceOrganisationAccessesDocument, options);
        }
export type GetServiceOrganisationAccessesQueryHookResult = ReturnType<typeof useGetServiceOrganisationAccessesQuery>;
export type GetServiceOrganisationAccessesLazyQueryHookResult = ReturnType<typeof useGetServiceOrganisationAccessesLazyQuery>;
export type GetServiceOrganisationAccessesSuspenseQueryHookResult = ReturnType<typeof useGetServiceOrganisationAccessesSuspenseQuery>;
export type GetServiceOrganisationAccessesQueryResult = Apollo.QueryResult<GetServiceOrganisationAccessesQuery, GetServiceOrganisationAccessesQueryVariables>;
export const GetRoomServiceOrganisationAccessesDocument = gql`
    query getRoomServiceOrganisationAccesses($eventId: bigint) {
  roomServiceOrganisationAccesses(
    where: {eventId: {_eq: $eventId}}
    order_by: {updatedAt: desc}
  ) {
    organisation {
      id
      name
    }
    updatedAt
  }
}
    `;

/**
 * __useGetRoomServiceOrganisationAccessesQuery__
 *
 * To run a query within a React component, call `useGetRoomServiceOrganisationAccessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomServiceOrganisationAccessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomServiceOrganisationAccessesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRoomServiceOrganisationAccessesQuery(baseOptions?: Apollo.QueryHookOptions<GetRoomServiceOrganisationAccessesQuery, GetRoomServiceOrganisationAccessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomServiceOrganisationAccessesQuery, GetRoomServiceOrganisationAccessesQueryVariables>(GetRoomServiceOrganisationAccessesDocument, options);
      }
export function useGetRoomServiceOrganisationAccessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomServiceOrganisationAccessesQuery, GetRoomServiceOrganisationAccessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomServiceOrganisationAccessesQuery, GetRoomServiceOrganisationAccessesQueryVariables>(GetRoomServiceOrganisationAccessesDocument, options);
        }
export function useGetRoomServiceOrganisationAccessesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoomServiceOrganisationAccessesQuery, GetRoomServiceOrganisationAccessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoomServiceOrganisationAccessesQuery, GetRoomServiceOrganisationAccessesQueryVariables>(GetRoomServiceOrganisationAccessesDocument, options);
        }
export type GetRoomServiceOrganisationAccessesQueryHookResult = ReturnType<typeof useGetRoomServiceOrganisationAccessesQuery>;
export type GetRoomServiceOrganisationAccessesLazyQueryHookResult = ReturnType<typeof useGetRoomServiceOrganisationAccessesLazyQuery>;
export type GetRoomServiceOrganisationAccessesSuspenseQueryHookResult = ReturnType<typeof useGetRoomServiceOrganisationAccessesSuspenseQuery>;
export type GetRoomServiceOrganisationAccessesQueryResult = Apollo.QueryResult<GetRoomServiceOrganisationAccessesQuery, GetRoomServiceOrganisationAccessesQueryVariables>;
export const GetAllOrganisationsDocument = gql`
    query getAllOrganisations {
  organisations(order_by: {name: asc}) {
    id
    name
  }
}
    `;

/**
 * __useGetAllOrganisationsQuery__
 *
 * To run a query within a React component, call `useGetAllOrganisationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllOrganisationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllOrganisationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllOrganisationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllOrganisationsQuery, GetAllOrganisationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllOrganisationsQuery, GetAllOrganisationsQueryVariables>(GetAllOrganisationsDocument, options);
      }
export function useGetAllOrganisationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllOrganisationsQuery, GetAllOrganisationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllOrganisationsQuery, GetAllOrganisationsQueryVariables>(GetAllOrganisationsDocument, options);
        }
export function useGetAllOrganisationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllOrganisationsQuery, GetAllOrganisationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllOrganisationsQuery, GetAllOrganisationsQueryVariables>(GetAllOrganisationsDocument, options);
        }
export type GetAllOrganisationsQueryHookResult = ReturnType<typeof useGetAllOrganisationsQuery>;
export type GetAllOrganisationsLazyQueryHookResult = ReturnType<typeof useGetAllOrganisationsLazyQuery>;
export type GetAllOrganisationsSuspenseQueryHookResult = ReturnType<typeof useGetAllOrganisationsSuspenseQuery>;
export type GetAllOrganisationsQueryResult = Apollo.QueryResult<GetAllOrganisationsQuery, GetAllOrganisationsQueryVariables>;
export const InsertServiceOrganisationAccessesDocument = gql`
    mutation insertServiceOrganisationAccesses($serviceAccessObjects: [serviceOrganisationAccesses_insert_input!]!) {
  insert_serviceOrganisationAccesses(
    objects: $serviceAccessObjects
    on_conflict: {constraint: serviceOrganisationAccesses_pkey, update_columns: updatedAt}
  ) {
    returning {
      organisationId
      serviceId
      updatedAt
    }
  }
}
    `;
export type InsertServiceOrganisationAccessesMutationFn = Apollo.MutationFunction<InsertServiceOrganisationAccessesMutation, InsertServiceOrganisationAccessesMutationVariables>;

/**
 * __useInsertServiceOrganisationAccessesMutation__
 *
 * To run a mutation, you first call `useInsertServiceOrganisationAccessesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertServiceOrganisationAccessesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertServiceOrganisationAccessesMutation, { data, loading, error }] = useInsertServiceOrganisationAccessesMutation({
 *   variables: {
 *      serviceAccessObjects: // value for 'serviceAccessObjects'
 *   },
 * });
 */
export function useInsertServiceOrganisationAccessesMutation(baseOptions?: Apollo.MutationHookOptions<InsertServiceOrganisationAccessesMutation, InsertServiceOrganisationAccessesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertServiceOrganisationAccessesMutation, InsertServiceOrganisationAccessesMutationVariables>(InsertServiceOrganisationAccessesDocument, options);
      }
export type InsertServiceOrganisationAccessesMutationHookResult = ReturnType<typeof useInsertServiceOrganisationAccessesMutation>;
export type InsertServiceOrganisationAccessesMutationResult = Apollo.MutationResult<InsertServiceOrganisationAccessesMutation>;
export type InsertServiceOrganisationAccessesMutationOptions = Apollo.BaseMutationOptions<InsertServiceOrganisationAccessesMutation, InsertServiceOrganisationAccessesMutationVariables>;
export const InsertRoomMatrixOrganisationAccessesDocument = gql`
    mutation insertRoomMatrixOrganisationAccesses($eventId: bigint) {
  insert_roomServiceOrganisationAccesses_one(
    object: {eventId: $eventId}
    on_conflict: {constraint: roomServiceOrganisationAccesses_pkey, update_columns: updatedAt}
  ) {
    organisationId
    eventId
    updatedAt
  }
}
    `;
export type InsertRoomMatrixOrganisationAccessesMutationFn = Apollo.MutationFunction<InsertRoomMatrixOrganisationAccessesMutation, InsertRoomMatrixOrganisationAccessesMutationVariables>;

/**
 * __useInsertRoomMatrixOrganisationAccessesMutation__
 *
 * To run a mutation, you first call `useInsertRoomMatrixOrganisationAccessesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertRoomMatrixOrganisationAccessesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertRoomMatrixOrganisationAccessesMutation, { data, loading, error }] = useInsertRoomMatrixOrganisationAccessesMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useInsertRoomMatrixOrganisationAccessesMutation(baseOptions?: Apollo.MutationHookOptions<InsertRoomMatrixOrganisationAccessesMutation, InsertRoomMatrixOrganisationAccessesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertRoomMatrixOrganisationAccessesMutation, InsertRoomMatrixOrganisationAccessesMutationVariables>(InsertRoomMatrixOrganisationAccessesDocument, options);
      }
export type InsertRoomMatrixOrganisationAccessesMutationHookResult = ReturnType<typeof useInsertRoomMatrixOrganisationAccessesMutation>;
export type InsertRoomMatrixOrganisationAccessesMutationResult = Apollo.MutationResult<InsertRoomMatrixOrganisationAccessesMutation>;
export type InsertRoomMatrixOrganisationAccessesMutationOptions = Apollo.BaseMutationOptions<InsertRoomMatrixOrganisationAccessesMutation, InsertRoomMatrixOrganisationAccessesMutationVariables>;
export const SetUsersLastServiceModuleVisitDocument = gql`
    mutation setUsersLastServiceModuleVisit($serviceModuleId: bigint!) {
  insert_userServiceModuleLastVisits_one(
    object: {serviceModuleId: $serviceModuleId}
    on_conflict: {constraint: userServiceModuleLastVisits_pkey, update_columns: updatedAt}
  ) {
    serviceModuleId
    serviceModule {
      id
      hasChanges
      lastVisits {
        userId
        updatedAt
      }
      service {
        id
        serviceModules_aggregate(where: {hasChanges: {_eq: true}}) {
          aggregate {
            count
          }
        }
        serviceModules {
          id
          hasChanges
        }
      }
    }
  }
}
    `;
export type SetUsersLastServiceModuleVisitMutationFn = Apollo.MutationFunction<SetUsersLastServiceModuleVisitMutation, SetUsersLastServiceModuleVisitMutationVariables>;

/**
 * __useSetUsersLastServiceModuleVisitMutation__
 *
 * To run a mutation, you first call `useSetUsersLastServiceModuleVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUsersLastServiceModuleVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUsersLastServiceModuleVisitMutation, { data, loading, error }] = useSetUsersLastServiceModuleVisitMutation({
 *   variables: {
 *      serviceModuleId: // value for 'serviceModuleId'
 *   },
 * });
 */
export function useSetUsersLastServiceModuleVisitMutation(baseOptions?: Apollo.MutationHookOptions<SetUsersLastServiceModuleVisitMutation, SetUsersLastServiceModuleVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUsersLastServiceModuleVisitMutation, SetUsersLastServiceModuleVisitMutationVariables>(SetUsersLastServiceModuleVisitDocument, options);
      }
export type SetUsersLastServiceModuleVisitMutationHookResult = ReturnType<typeof useSetUsersLastServiceModuleVisitMutation>;
export type SetUsersLastServiceModuleVisitMutationResult = Apollo.MutationResult<SetUsersLastServiceModuleVisitMutation>;
export type SetUsersLastServiceModuleVisitMutationOptions = Apollo.BaseMutationOptions<SetUsersLastServiceModuleVisitMutation, SetUsersLastServiceModuleVisitMutationVariables>;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    email
    firstName
    lastName
    needsAgreement
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const SetAgreementDocument = gql`
    mutation setAgreement($version: bigint!) {
  update_userSettings(_set: {agreementVersion: $version}, where: {}) {
    affected_rows
    returning {
      id
      agreementVersion
    }
  }
}
    `;
export type SetAgreementMutationFn = Apollo.MutationFunction<SetAgreementMutation, SetAgreementMutationVariables>;

/**
 * __useSetAgreementMutation__
 *
 * To run a mutation, you first call `useSetAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAgreementMutation, { data, loading, error }] = useSetAgreementMutation({
 *   variables: {
 *      version: // value for 'version'
 *   },
 * });
 */
export function useSetAgreementMutation(baseOptions?: Apollo.MutationHookOptions<SetAgreementMutation, SetAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAgreementMutation, SetAgreementMutationVariables>(SetAgreementDocument, options);
      }
export type SetAgreementMutationHookResult = ReturnType<typeof useSetAgreementMutation>;
export type SetAgreementMutationResult = Apollo.MutationResult<SetAgreementMutation>;
export type SetAgreementMutationOptions = Apollo.BaseMutationOptions<SetAgreementMutation, SetAgreementMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    logout
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const MeDocument = gql`
    query me {
  currentUser {
    id
    email
    firstName
    lastName
    organisationId
    isAdmin
    isOrgaAdmin
    agreementVersion
    jaggaerUsername
    ldapDN
    organisation {
      id
      name
      isGuestOrga
    }
    organisationGroupUsers {
      organisationGroup {
        id
        name
      }
    }
    userAttributeValues {
      imported
      value
      userAttribute {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const ServiceBundleByIdDocument = gql`
    query serviceBundleById($id: bigint!) {
  serviceBundles_by_pk(id: $id) {
    id
    name
    createdAt
    serviceBundleServices {
      service {
        name
        id
        updatedAt
        createdAt
      }
    }
  }
}
    `;

/**
 * __useServiceBundleByIdQuery__
 *
 * To run a query within a React component, call `useServiceBundleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceBundleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceBundleByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useServiceBundleByIdQuery(baseOptions: Apollo.QueryHookOptions<ServiceBundleByIdQuery, ServiceBundleByIdQueryVariables> & ({ variables: ServiceBundleByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceBundleByIdQuery, ServiceBundleByIdQueryVariables>(ServiceBundleByIdDocument, options);
      }
export function useServiceBundleByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceBundleByIdQuery, ServiceBundleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceBundleByIdQuery, ServiceBundleByIdQueryVariables>(ServiceBundleByIdDocument, options);
        }
export function useServiceBundleByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceBundleByIdQuery, ServiceBundleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceBundleByIdQuery, ServiceBundleByIdQueryVariables>(ServiceBundleByIdDocument, options);
        }
export type ServiceBundleByIdQueryHookResult = ReturnType<typeof useServiceBundleByIdQuery>;
export type ServiceBundleByIdLazyQueryHookResult = ReturnType<typeof useServiceBundleByIdLazyQuery>;
export type ServiceBundleByIdSuspenseQueryHookResult = ReturnType<typeof useServiceBundleByIdSuspenseQuery>;
export type ServiceBundleByIdQueryResult = Apollo.QueryResult<ServiceBundleByIdQuery, ServiceBundleByIdQueryVariables>;
export const ServiceBundleListDocument = gql`
    query serviceBundleList($serviceBundlesOrder: [serviceBundles_order_by!]) {
  serviceBundles(order_by: $serviceBundlesOrder) {
    id
    name
    serviceBundleServices(order_by: {service: {name: asc}}) {
      service {
        id
        name
        tags
      }
    }
  }
}
    `;

/**
 * __useServiceBundleListQuery__
 *
 * To run a query within a React component, call `useServiceBundleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceBundleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceBundleListQuery({
 *   variables: {
 *      serviceBundlesOrder: // value for 'serviceBundlesOrder'
 *   },
 * });
 */
export function useServiceBundleListQuery(baseOptions?: Apollo.QueryHookOptions<ServiceBundleListQuery, ServiceBundleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceBundleListQuery, ServiceBundleListQueryVariables>(ServiceBundleListDocument, options);
      }
export function useServiceBundleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceBundleListQuery, ServiceBundleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceBundleListQuery, ServiceBundleListQueryVariables>(ServiceBundleListDocument, options);
        }
export function useServiceBundleListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceBundleListQuery, ServiceBundleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceBundleListQuery, ServiceBundleListQueryVariables>(ServiceBundleListDocument, options);
        }
export type ServiceBundleListQueryHookResult = ReturnType<typeof useServiceBundleListQuery>;
export type ServiceBundleListLazyQueryHookResult = ReturnType<typeof useServiceBundleListLazyQuery>;
export type ServiceBundleListSuspenseQueryHookResult = ReturnType<typeof useServiceBundleListSuspenseQuery>;
export type ServiceBundleListQueryResult = Apollo.QueryResult<ServiceBundleListQuery, ServiceBundleListQueryVariables>;
export const BundleListDocument = gql`
    query bundleList($where: serviceBundles_bool_exp, $order_by: [serviceBundles_order_by!] = [{name: asc}]) {
  serviceBundles(where: $where, order_by: $order_by) {
    id
    name
    updatedAt
    createdAt
  }
}
    `;

/**
 * __useBundleListQuery__
 *
 * To run a query within a React component, call `useBundleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBundleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBundleListQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useBundleListQuery(baseOptions?: Apollo.QueryHookOptions<BundleListQuery, BundleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BundleListQuery, BundleListQueryVariables>(BundleListDocument, options);
      }
export function useBundleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BundleListQuery, BundleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BundleListQuery, BundleListQueryVariables>(BundleListDocument, options);
        }
export function useBundleListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BundleListQuery, BundleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BundleListQuery, BundleListQueryVariables>(BundleListDocument, options);
        }
export type BundleListQueryHookResult = ReturnType<typeof useBundleListQuery>;
export type BundleListLazyQueryHookResult = ReturnType<typeof useBundleListLazyQuery>;
export type BundleListSuspenseQueryHookResult = ReturnType<typeof useBundleListSuspenseQuery>;
export type BundleListQueryResult = Apollo.QueryResult<BundleListQuery, BundleListQueryVariables>;
export const DeleteBundleDocument = gql`
    mutation deleteBundle($id: bigint!) {
  delete_serviceBundles_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteBundleMutationFn = Apollo.MutationFunction<DeleteBundleMutation, DeleteBundleMutationVariables>;

/**
 * __useDeleteBundleMutation__
 *
 * To run a mutation, you first call `useDeleteBundleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBundleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBundleMutation, { data, loading, error }] = useDeleteBundleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBundleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBundleMutation, DeleteBundleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBundleMutation, DeleteBundleMutationVariables>(DeleteBundleDocument, options);
      }
export type DeleteBundleMutationHookResult = ReturnType<typeof useDeleteBundleMutation>;
export type DeleteBundleMutationResult = Apollo.MutationResult<DeleteBundleMutation>;
export type DeleteBundleMutationOptions = Apollo.BaseMutationOptions<DeleteBundleMutation, DeleteBundleMutationVariables>;
export const InsertBundleDocument = gql`
    mutation insertBundle($object: serviceBundles_insert_input!) {
  insert_serviceBundles_one(object: $object) {
    id
    name
    updatedAt
    createdAt
  }
}
    `;
export type InsertBundleMutationFn = Apollo.MutationFunction<InsertBundleMutation, InsertBundleMutationVariables>;

/**
 * __useInsertBundleMutation__
 *
 * To run a mutation, you first call `useInsertBundleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertBundleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertBundleMutation, { data, loading, error }] = useInsertBundleMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertBundleMutation(baseOptions?: Apollo.MutationHookOptions<InsertBundleMutation, InsertBundleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertBundleMutation, InsertBundleMutationVariables>(InsertBundleDocument, options);
      }
export type InsertBundleMutationHookResult = ReturnType<typeof useInsertBundleMutation>;
export type InsertBundleMutationResult = Apollo.MutationResult<InsertBundleMutation>;
export type InsertBundleMutationOptions = Apollo.BaseMutationOptions<InsertBundleMutation, InsertBundleMutationVariables>;
export const UpdateBundleDocument = gql`
    mutation updateBundle($id: bigint!, $object: serviceBundles_insert_input!) {
  delete_serviceBundles_by_pk(id: $id) {
    id
  }
  insert_serviceBundles_one(object: $object) {
    id
    name
    updatedAt
    createdAt
  }
}
    `;
export type UpdateBundleMutationFn = Apollo.MutationFunction<UpdateBundleMutation, UpdateBundleMutationVariables>;

/**
 * __useUpdateBundleMutation__
 *
 * To run a mutation, you first call `useUpdateBundleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBundleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBundleMutation, { data, loading, error }] = useUpdateBundleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpdateBundleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBundleMutation, UpdateBundleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBundleMutation, UpdateBundleMutationVariables>(UpdateBundleDocument, options);
      }
export type UpdateBundleMutationHookResult = ReturnType<typeof useUpdateBundleMutation>;
export type UpdateBundleMutationResult = Apollo.MutationResult<UpdateBundleMutation>;
export type UpdateBundleMutationOptions = Apollo.BaseMutationOptions<UpdateBundleMutation, UpdateBundleMutationVariables>;
export const AddAttributeValueCommentDocument = gql`
    mutation addAttributeValueComment($input: attributeValueComments_insert_input!) {
  insert_attributeValueComments_one(object: $input) {
    id
    attributeValueId
    parentId
    createdAt
    updatedAt
    user {
      id
      firstName
      lastName
    }
    isDone
    comment
    comments {
      user {
        id
        firstName
        lastName
      }
      id
      createdAt
      updatedAt
      comment
    }
  }
}
    `;
export type AddAttributeValueCommentMutationFn = Apollo.MutationFunction<AddAttributeValueCommentMutation, AddAttributeValueCommentMutationVariables>;

/**
 * __useAddAttributeValueCommentMutation__
 *
 * To run a mutation, you first call `useAddAttributeValueCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAttributeValueCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAttributeValueCommentMutation, { data, loading, error }] = useAddAttributeValueCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAttributeValueCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddAttributeValueCommentMutation, AddAttributeValueCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAttributeValueCommentMutation, AddAttributeValueCommentMutationVariables>(AddAttributeValueCommentDocument, options);
      }
export type AddAttributeValueCommentMutationHookResult = ReturnType<typeof useAddAttributeValueCommentMutation>;
export type AddAttributeValueCommentMutationResult = Apollo.MutationResult<AddAttributeValueCommentMutation>;
export type AddAttributeValueCommentMutationOptions = Apollo.BaseMutationOptions<AddAttributeValueCommentMutation, AddAttributeValueCommentMutationVariables>;
export const AddUploadCommentDocument = gql`
    mutation addUploadComment($input: uploadComments_insert_input!) {
  insert_uploadComments_one(object: $input) {
    id
    parentId
    createdAt
    updatedAt
    user {
      id
      firstName
      lastName
    }
    isDone
    comment
    comments {
      user {
        id
        firstName
        lastName
      }
      id
      createdAt
      updatedAt
      comment
    }
  }
}
    `;
export type AddUploadCommentMutationFn = Apollo.MutationFunction<AddUploadCommentMutation, AddUploadCommentMutationVariables>;

/**
 * __useAddUploadCommentMutation__
 *
 * To run a mutation, you first call `useAddUploadCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUploadCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUploadCommentMutation, { data, loading, error }] = useAddUploadCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUploadCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddUploadCommentMutation, AddUploadCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUploadCommentMutation, AddUploadCommentMutationVariables>(AddUploadCommentDocument, options);
      }
export type AddUploadCommentMutationHookResult = ReturnType<typeof useAddUploadCommentMutation>;
export type AddUploadCommentMutationResult = Apollo.MutationResult<AddUploadCommentMutation>;
export type AddUploadCommentMutationOptions = Apollo.BaseMutationOptions<AddUploadCommentMutation, AddUploadCommentMutationVariables>;
export const AddRoomAttributeValueCommentDocument = gql`
    mutation addRoomAttributeValueComment($input: roomAttributeValueComments_insert_input!) {
  insert_roomAttributeValueComments_one(object: $input) {
    id
    roomAttributeValueId
    parentId
    createdAt
    updatedAt
    user {
      id
      firstName
      lastName
    }
    isDone
    comment
    comments {
      user {
        id
        firstName
        lastName
      }
      id
      createdAt
      updatedAt
      comment
    }
  }
}
    `;
export type AddRoomAttributeValueCommentMutationFn = Apollo.MutationFunction<AddRoomAttributeValueCommentMutation, AddRoomAttributeValueCommentMutationVariables>;

/**
 * __useAddRoomAttributeValueCommentMutation__
 *
 * To run a mutation, you first call `useAddRoomAttributeValueCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRoomAttributeValueCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRoomAttributeValueCommentMutation, { data, loading, error }] = useAddRoomAttributeValueCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRoomAttributeValueCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddRoomAttributeValueCommentMutation, AddRoomAttributeValueCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRoomAttributeValueCommentMutation, AddRoomAttributeValueCommentMutationVariables>(AddRoomAttributeValueCommentDocument, options);
      }
export type AddRoomAttributeValueCommentMutationHookResult = ReturnType<typeof useAddRoomAttributeValueCommentMutation>;
export type AddRoomAttributeValueCommentMutationResult = Apollo.MutationResult<AddRoomAttributeValueCommentMutation>;
export type AddRoomAttributeValueCommentMutationOptions = Apollo.BaseMutationOptions<AddRoomAttributeValueCommentMutation, AddRoomAttributeValueCommentMutationVariables>;
export const ArchiveAttributeValueCommentDocument = gql`
    mutation archiveAttributeValueComment($id: bigint!, $isDone: timestamptz) {
  update_attributeValueComments_by_pk(
    pk_columns: {id: $id}
    _set: {isDone: $isDone}
  ) {
    id
    isDone
    organisationId
  }
}
    `;
export type ArchiveAttributeValueCommentMutationFn = Apollo.MutationFunction<ArchiveAttributeValueCommentMutation, ArchiveAttributeValueCommentMutationVariables>;

/**
 * __useArchiveAttributeValueCommentMutation__
 *
 * To run a mutation, you first call `useArchiveAttributeValueCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveAttributeValueCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveAttributeValueCommentMutation, { data, loading, error }] = useArchiveAttributeValueCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isDone: // value for 'isDone'
 *   },
 * });
 */
export function useArchiveAttributeValueCommentMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveAttributeValueCommentMutation, ArchiveAttributeValueCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveAttributeValueCommentMutation, ArchiveAttributeValueCommentMutationVariables>(ArchiveAttributeValueCommentDocument, options);
      }
export type ArchiveAttributeValueCommentMutationHookResult = ReturnType<typeof useArchiveAttributeValueCommentMutation>;
export type ArchiveAttributeValueCommentMutationResult = Apollo.MutationResult<ArchiveAttributeValueCommentMutation>;
export type ArchiveAttributeValueCommentMutationOptions = Apollo.BaseMutationOptions<ArchiveAttributeValueCommentMutation, ArchiveAttributeValueCommentMutationVariables>;
export const ArchiveUploadCommentDocument = gql`
    mutation archiveUploadComment($id: bigint!, $isDone: timestamptz) {
  update_uploadComments_by_pk(pk_columns: {id: $id}, _set: {isDone: $isDone}) {
    id
    isDone
    organisationId
  }
}
    `;
export type ArchiveUploadCommentMutationFn = Apollo.MutationFunction<ArchiveUploadCommentMutation, ArchiveUploadCommentMutationVariables>;

/**
 * __useArchiveUploadCommentMutation__
 *
 * To run a mutation, you first call `useArchiveUploadCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveUploadCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveUploadCommentMutation, { data, loading, error }] = useArchiveUploadCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isDone: // value for 'isDone'
 *   },
 * });
 */
export function useArchiveUploadCommentMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveUploadCommentMutation, ArchiveUploadCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveUploadCommentMutation, ArchiveUploadCommentMutationVariables>(ArchiveUploadCommentDocument, options);
      }
export type ArchiveUploadCommentMutationHookResult = ReturnType<typeof useArchiveUploadCommentMutation>;
export type ArchiveUploadCommentMutationResult = Apollo.MutationResult<ArchiveUploadCommentMutation>;
export type ArchiveUploadCommentMutationOptions = Apollo.BaseMutationOptions<ArchiveUploadCommentMutation, ArchiveUploadCommentMutationVariables>;
export const ArchiveRoomAttributeValueCommentDocument = gql`
    mutation archiveRoomAttributeValueComment($id: bigint!, $isDone: timestamptz) {
  update_roomAttributeValueComments_by_pk(
    pk_columns: {id: $id}
    _set: {isDone: $isDone}
  ) {
    id
    isDone
    organisationId
  }
}
    `;
export type ArchiveRoomAttributeValueCommentMutationFn = Apollo.MutationFunction<ArchiveRoomAttributeValueCommentMutation, ArchiveRoomAttributeValueCommentMutationVariables>;

/**
 * __useArchiveRoomAttributeValueCommentMutation__
 *
 * To run a mutation, you first call `useArchiveRoomAttributeValueCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveRoomAttributeValueCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveRoomAttributeValueCommentMutation, { data, loading, error }] = useArchiveRoomAttributeValueCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isDone: // value for 'isDone'
 *   },
 * });
 */
export function useArchiveRoomAttributeValueCommentMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveRoomAttributeValueCommentMutation, ArchiveRoomAttributeValueCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveRoomAttributeValueCommentMutation, ArchiveRoomAttributeValueCommentMutationVariables>(ArchiveRoomAttributeValueCommentDocument, options);
      }
export type ArchiveRoomAttributeValueCommentMutationHookResult = ReturnType<typeof useArchiveRoomAttributeValueCommentMutation>;
export type ArchiveRoomAttributeValueCommentMutationResult = Apollo.MutationResult<ArchiveRoomAttributeValueCommentMutation>;
export type ArchiveRoomAttributeValueCommentMutationOptions = Apollo.BaseMutationOptions<ArchiveRoomAttributeValueCommentMutation, ArchiveRoomAttributeValueCommentMutationVariables>;
export const CommentMentionsDocument = gql`
    query commentMentions {
  allUsers(where: {isDisabled: {_neq: true}}, order_by: {firstName: asc}) {
    id
    firstName
    lastName
    organisationId
    organisation {
      isGuestOrga
    }
  }
  events(order_by: {name: asc}) {
    id
    name
  }
  organisations(where: {isMentionable: {_eq: true}}, order_by: {name: asc}) {
    id
    name
    isGuestOrga
  }
}
    `;

/**
 * __useCommentMentionsQuery__
 *
 * To run a query within a React component, call `useCommentMentionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentMentionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentMentionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommentMentionsQuery(baseOptions?: Apollo.QueryHookOptions<CommentMentionsQuery, CommentMentionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentMentionsQuery, CommentMentionsQueryVariables>(CommentMentionsDocument, options);
      }
export function useCommentMentionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentMentionsQuery, CommentMentionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentMentionsQuery, CommentMentionsQueryVariables>(CommentMentionsDocument, options);
        }
export function useCommentMentionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommentMentionsQuery, CommentMentionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommentMentionsQuery, CommentMentionsQueryVariables>(CommentMentionsDocument, options);
        }
export type CommentMentionsQueryHookResult = ReturnType<typeof useCommentMentionsQuery>;
export type CommentMentionsLazyQueryHookResult = ReturnType<typeof useCommentMentionsLazyQuery>;
export type CommentMentionsSuspenseQueryHookResult = ReturnType<typeof useCommentMentionsSuspenseQuery>;
export type CommentMentionsQueryResult = Apollo.QueryResult<CommentMentionsQuery, CommentMentionsQueryVariables>;
export const AttributeValueCommentsByReferenceDocument = gql`
    query attributeValueCommentsByReference($id: bigint!) {
  attributeValueComments(
    order_by: [{createdAt: desc}]
    where: {attributeValueId: {_eq: $id}}
  ) {
    id
    createdAt
    updatedAt
    organisationId
    user {
      id
      firstName
      lastName
    }
    isDone
    comment
    comments(order_by: [{createdAt: asc}]) {
      user {
        id
        firstName
        lastName
      }
      id
      createdAt
      updatedAt
      organisationId
      comment
    }
  }
}
    `;

/**
 * __useAttributeValueCommentsByReferenceQuery__
 *
 * To run a query within a React component, call `useAttributeValueCommentsByReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributeValueCommentsByReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributeValueCommentsByReferenceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAttributeValueCommentsByReferenceQuery(baseOptions: Apollo.QueryHookOptions<AttributeValueCommentsByReferenceQuery, AttributeValueCommentsByReferenceQueryVariables> & ({ variables: AttributeValueCommentsByReferenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributeValueCommentsByReferenceQuery, AttributeValueCommentsByReferenceQueryVariables>(AttributeValueCommentsByReferenceDocument, options);
      }
export function useAttributeValueCommentsByReferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributeValueCommentsByReferenceQuery, AttributeValueCommentsByReferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributeValueCommentsByReferenceQuery, AttributeValueCommentsByReferenceQueryVariables>(AttributeValueCommentsByReferenceDocument, options);
        }
export function useAttributeValueCommentsByReferenceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AttributeValueCommentsByReferenceQuery, AttributeValueCommentsByReferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AttributeValueCommentsByReferenceQuery, AttributeValueCommentsByReferenceQueryVariables>(AttributeValueCommentsByReferenceDocument, options);
        }
export type AttributeValueCommentsByReferenceQueryHookResult = ReturnType<typeof useAttributeValueCommentsByReferenceQuery>;
export type AttributeValueCommentsByReferenceLazyQueryHookResult = ReturnType<typeof useAttributeValueCommentsByReferenceLazyQuery>;
export type AttributeValueCommentsByReferenceSuspenseQueryHookResult = ReturnType<typeof useAttributeValueCommentsByReferenceSuspenseQuery>;
export type AttributeValueCommentsByReferenceQueryResult = Apollo.QueryResult<AttributeValueCommentsByReferenceQuery, AttributeValueCommentsByReferenceQueryVariables>;
export const UploadCommentsByReferenceDocument = gql`
    query uploadCommentsByReference($id: bigint!) {
  uploadComments(order_by: [{createdAt: desc}], where: {uploadId: {_eq: $id}}) {
    id
    createdAt
    updatedAt
    organisationId
    user {
      id
      firstName
      lastName
    }
    isDone
    comment
    comments(order_by: [{createdAt: asc}]) {
      user {
        id
        firstName
        lastName
      }
      id
      createdAt
      updatedAt
      organisationId
      comment
    }
  }
}
    `;

/**
 * __useUploadCommentsByReferenceQuery__
 *
 * To run a query within a React component, call `useUploadCommentsByReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useUploadCommentsByReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUploadCommentsByReferenceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUploadCommentsByReferenceQuery(baseOptions: Apollo.QueryHookOptions<UploadCommentsByReferenceQuery, UploadCommentsByReferenceQueryVariables> & ({ variables: UploadCommentsByReferenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UploadCommentsByReferenceQuery, UploadCommentsByReferenceQueryVariables>(UploadCommentsByReferenceDocument, options);
      }
export function useUploadCommentsByReferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UploadCommentsByReferenceQuery, UploadCommentsByReferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UploadCommentsByReferenceQuery, UploadCommentsByReferenceQueryVariables>(UploadCommentsByReferenceDocument, options);
        }
export function useUploadCommentsByReferenceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UploadCommentsByReferenceQuery, UploadCommentsByReferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UploadCommentsByReferenceQuery, UploadCommentsByReferenceQueryVariables>(UploadCommentsByReferenceDocument, options);
        }
export type UploadCommentsByReferenceQueryHookResult = ReturnType<typeof useUploadCommentsByReferenceQuery>;
export type UploadCommentsByReferenceLazyQueryHookResult = ReturnType<typeof useUploadCommentsByReferenceLazyQuery>;
export type UploadCommentsByReferenceSuspenseQueryHookResult = ReturnType<typeof useUploadCommentsByReferenceSuspenseQuery>;
export type UploadCommentsByReferenceQueryResult = Apollo.QueryResult<UploadCommentsByReferenceQuery, UploadCommentsByReferenceQueryVariables>;
export const AttributeValueCommentsByReferencePollingDocument = gql`
    subscription attributeValueCommentsByReferencePolling($where: attributeValueComments_bool_exp) {
  attributeValueComments(order_by: [{createdAt: desc}], where: $where) {
    id
    createdAt
    updatedAt
    organisationId
    user {
      id
      firstName
      lastName
    }
    isDone
    comment
    comments(order_by: [{createdAt: asc}]) {
      user {
        id
        firstName
        lastName
      }
      id
      createdAt
      updatedAt
      organisationId
      comment
    }
  }
}
    `;

/**
 * __useAttributeValueCommentsByReferencePollingSubscription__
 *
 * To run a query within a React component, call `useAttributeValueCommentsByReferencePollingSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAttributeValueCommentsByReferencePollingSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributeValueCommentsByReferencePollingSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAttributeValueCommentsByReferencePollingSubscription(baseOptions?: Apollo.SubscriptionHookOptions<AttributeValueCommentsByReferencePollingSubscription, AttributeValueCommentsByReferencePollingSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AttributeValueCommentsByReferencePollingSubscription, AttributeValueCommentsByReferencePollingSubscriptionVariables>(AttributeValueCommentsByReferencePollingDocument, options);
      }
export type AttributeValueCommentsByReferencePollingSubscriptionHookResult = ReturnType<typeof useAttributeValueCommentsByReferencePollingSubscription>;
export type AttributeValueCommentsByReferencePollingSubscriptionResult = Apollo.SubscriptionResult<AttributeValueCommentsByReferencePollingSubscription>;
export const UploadCommentsByReferencePollingDocument = gql`
    subscription uploadCommentsByReferencePolling($where: uploadComments_bool_exp) {
  uploadComments(order_by: [{createdAt: desc}], where: $where) {
    id
    createdAt
    updatedAt
    organisationId
    user {
      id
      firstName
      lastName
    }
    isDone
    comment
    comments(order_by: [{createdAt: asc}]) {
      user {
        id
        firstName
        lastName
      }
      id
      createdAt
      updatedAt
      organisationId
      comment
    }
  }
}
    `;

/**
 * __useUploadCommentsByReferencePollingSubscription__
 *
 * To run a query within a React component, call `useUploadCommentsByReferencePollingSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUploadCommentsByReferencePollingSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUploadCommentsByReferencePollingSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUploadCommentsByReferencePollingSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UploadCommentsByReferencePollingSubscription, UploadCommentsByReferencePollingSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UploadCommentsByReferencePollingSubscription, UploadCommentsByReferencePollingSubscriptionVariables>(UploadCommentsByReferencePollingDocument, options);
      }
export type UploadCommentsByReferencePollingSubscriptionHookResult = ReturnType<typeof useUploadCommentsByReferencePollingSubscription>;
export type UploadCommentsByReferencePollingSubscriptionResult = Apollo.SubscriptionResult<UploadCommentsByReferencePollingSubscription>;
export const RoomAttributeValueCommentsByReferencePollingDocument = gql`
    subscription roomAttributeValueCommentsByReferencePolling($where: roomAttributeValueComments_bool_exp) {
  roomAttributeValueComments(order_by: [{createdAt: desc}], where: $where) {
    id
    createdAt
    updatedAt
    organisationId
    user {
      id
      firstName
      lastName
    }
    isDone
    comment
    comments(order_by: [{createdAt: asc}]) {
      user {
        id
        firstName
        lastName
      }
      id
      createdAt
      updatedAt
      organisationId
      comment
    }
  }
}
    `;

/**
 * __useRoomAttributeValueCommentsByReferencePollingSubscription__
 *
 * To run a query within a React component, call `useRoomAttributeValueCommentsByReferencePollingSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRoomAttributeValueCommentsByReferencePollingSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomAttributeValueCommentsByReferencePollingSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRoomAttributeValueCommentsByReferencePollingSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RoomAttributeValueCommentsByReferencePollingSubscription, RoomAttributeValueCommentsByReferencePollingSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RoomAttributeValueCommentsByReferencePollingSubscription, RoomAttributeValueCommentsByReferencePollingSubscriptionVariables>(RoomAttributeValueCommentsByReferencePollingDocument, options);
      }
export type RoomAttributeValueCommentsByReferencePollingSubscriptionHookResult = ReturnType<typeof useRoomAttributeValueCommentsByReferencePollingSubscription>;
export type RoomAttributeValueCommentsByReferencePollingSubscriptionResult = Apollo.SubscriptionResult<RoomAttributeValueCommentsByReferencePollingSubscription>;
export const DeleteAttributeValueCommentDocument = gql`
    mutation deleteAttributeValueComment($id: bigint!) {
  delete_attributeValueComments_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteAttributeValueCommentMutationFn = Apollo.MutationFunction<DeleteAttributeValueCommentMutation, DeleteAttributeValueCommentMutationVariables>;

/**
 * __useDeleteAttributeValueCommentMutation__
 *
 * To run a mutation, you first call `useDeleteAttributeValueCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttributeValueCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttributeValueCommentMutation, { data, loading, error }] = useDeleteAttributeValueCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAttributeValueCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttributeValueCommentMutation, DeleteAttributeValueCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttributeValueCommentMutation, DeleteAttributeValueCommentMutationVariables>(DeleteAttributeValueCommentDocument, options);
      }
export type DeleteAttributeValueCommentMutationHookResult = ReturnType<typeof useDeleteAttributeValueCommentMutation>;
export type DeleteAttributeValueCommentMutationResult = Apollo.MutationResult<DeleteAttributeValueCommentMutation>;
export type DeleteAttributeValueCommentMutationOptions = Apollo.BaseMutationOptions<DeleteAttributeValueCommentMutation, DeleteAttributeValueCommentMutationVariables>;
export const DeleteUploadCommentDocument = gql`
    mutation deleteUploadComment($id: bigint!) {
  delete_uploadComments_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteUploadCommentMutationFn = Apollo.MutationFunction<DeleteUploadCommentMutation, DeleteUploadCommentMutationVariables>;

/**
 * __useDeleteUploadCommentMutation__
 *
 * To run a mutation, you first call `useDeleteUploadCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUploadCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUploadCommentMutation, { data, loading, error }] = useDeleteUploadCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUploadCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUploadCommentMutation, DeleteUploadCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUploadCommentMutation, DeleteUploadCommentMutationVariables>(DeleteUploadCommentDocument, options);
      }
export type DeleteUploadCommentMutationHookResult = ReturnType<typeof useDeleteUploadCommentMutation>;
export type DeleteUploadCommentMutationResult = Apollo.MutationResult<DeleteUploadCommentMutation>;
export type DeleteUploadCommentMutationOptions = Apollo.BaseMutationOptions<DeleteUploadCommentMutation, DeleteUploadCommentMutationVariables>;
export const DeleteRoomAttributeValueCommentDocument = gql`
    mutation deleteRoomAttributeValueComment($id: bigint!) {
  delete_roomAttributeValueComments_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteRoomAttributeValueCommentMutationFn = Apollo.MutationFunction<DeleteRoomAttributeValueCommentMutation, DeleteRoomAttributeValueCommentMutationVariables>;

/**
 * __useDeleteRoomAttributeValueCommentMutation__
 *
 * To run a mutation, you first call `useDeleteRoomAttributeValueCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoomAttributeValueCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoomAttributeValueCommentMutation, { data, loading, error }] = useDeleteRoomAttributeValueCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRoomAttributeValueCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoomAttributeValueCommentMutation, DeleteRoomAttributeValueCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoomAttributeValueCommentMutation, DeleteRoomAttributeValueCommentMutationVariables>(DeleteRoomAttributeValueCommentDocument, options);
      }
export type DeleteRoomAttributeValueCommentMutationHookResult = ReturnType<typeof useDeleteRoomAttributeValueCommentMutation>;
export type DeleteRoomAttributeValueCommentMutationResult = Apollo.MutationResult<DeleteRoomAttributeValueCommentMutation>;
export type DeleteRoomAttributeValueCommentMutationOptions = Apollo.BaseMutationOptions<DeleteRoomAttributeValueCommentMutation, DeleteRoomAttributeValueCommentMutationVariables>;
export const IsPublicAttributeValueCommentDocument = gql`
    mutation isPublicAttributeValueComment($id: bigint!, $organisationId: bigint) {
  update_attributeValueComments_by_pk(
    pk_columns: {id: $id}
    _set: {organisationId: $organisationId}
  ) {
    id
    isDone
    organisationId
  }
}
    `;
export type IsPublicAttributeValueCommentMutationFn = Apollo.MutationFunction<IsPublicAttributeValueCommentMutation, IsPublicAttributeValueCommentMutationVariables>;

/**
 * __useIsPublicAttributeValueCommentMutation__
 *
 * To run a mutation, you first call `useIsPublicAttributeValueCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIsPublicAttributeValueCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [isPublicAttributeValueCommentMutation, { data, loading, error }] = useIsPublicAttributeValueCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useIsPublicAttributeValueCommentMutation(baseOptions?: Apollo.MutationHookOptions<IsPublicAttributeValueCommentMutation, IsPublicAttributeValueCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IsPublicAttributeValueCommentMutation, IsPublicAttributeValueCommentMutationVariables>(IsPublicAttributeValueCommentDocument, options);
      }
export type IsPublicAttributeValueCommentMutationHookResult = ReturnType<typeof useIsPublicAttributeValueCommentMutation>;
export type IsPublicAttributeValueCommentMutationResult = Apollo.MutationResult<IsPublicAttributeValueCommentMutation>;
export type IsPublicAttributeValueCommentMutationOptions = Apollo.BaseMutationOptions<IsPublicAttributeValueCommentMutation, IsPublicAttributeValueCommentMutationVariables>;
export const IsPublicUploadCommentDocument = gql`
    mutation isPublicUploadComment($id: bigint!, $organisationId: bigint) {
  update_uploadComments_by_pk(
    pk_columns: {id: $id}
    _set: {organisationId: $organisationId}
  ) {
    id
    isDone
    organisationId
  }
}
    `;
export type IsPublicUploadCommentMutationFn = Apollo.MutationFunction<IsPublicUploadCommentMutation, IsPublicUploadCommentMutationVariables>;

/**
 * __useIsPublicUploadCommentMutation__
 *
 * To run a mutation, you first call `useIsPublicUploadCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIsPublicUploadCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [isPublicUploadCommentMutation, { data, loading, error }] = useIsPublicUploadCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useIsPublicUploadCommentMutation(baseOptions?: Apollo.MutationHookOptions<IsPublicUploadCommentMutation, IsPublicUploadCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IsPublicUploadCommentMutation, IsPublicUploadCommentMutationVariables>(IsPublicUploadCommentDocument, options);
      }
export type IsPublicUploadCommentMutationHookResult = ReturnType<typeof useIsPublicUploadCommentMutation>;
export type IsPublicUploadCommentMutationResult = Apollo.MutationResult<IsPublicUploadCommentMutation>;
export type IsPublicUploadCommentMutationOptions = Apollo.BaseMutationOptions<IsPublicUploadCommentMutation, IsPublicUploadCommentMutationVariables>;
export const IsPublicRoomAttributeValueCommentDocument = gql`
    mutation isPublicRoomAttributeValueComment($id: bigint!, $organisationId: bigint) {
  update_roomAttributeValueComments_by_pk(
    pk_columns: {id: $id}
    _set: {organisationId: $organisationId}
  ) {
    id
    isDone
    organisationId
  }
}
    `;
export type IsPublicRoomAttributeValueCommentMutationFn = Apollo.MutationFunction<IsPublicRoomAttributeValueCommentMutation, IsPublicRoomAttributeValueCommentMutationVariables>;

/**
 * __useIsPublicRoomAttributeValueCommentMutation__
 *
 * To run a mutation, you first call `useIsPublicRoomAttributeValueCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIsPublicRoomAttributeValueCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [isPublicRoomAttributeValueCommentMutation, { data, loading, error }] = useIsPublicRoomAttributeValueCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useIsPublicRoomAttributeValueCommentMutation(baseOptions?: Apollo.MutationHookOptions<IsPublicRoomAttributeValueCommentMutation, IsPublicRoomAttributeValueCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IsPublicRoomAttributeValueCommentMutation, IsPublicRoomAttributeValueCommentMutationVariables>(IsPublicRoomAttributeValueCommentDocument, options);
      }
export type IsPublicRoomAttributeValueCommentMutationHookResult = ReturnType<typeof useIsPublicRoomAttributeValueCommentMutation>;
export type IsPublicRoomAttributeValueCommentMutationResult = Apollo.MutationResult<IsPublicRoomAttributeValueCommentMutation>;
export type IsPublicRoomAttributeValueCommentMutationOptions = Apollo.BaseMutationOptions<IsPublicRoomAttributeValueCommentMutation, IsPublicRoomAttributeValueCommentMutationVariables>;
export const UpdateAttributeValueCommentDocument = gql`
    mutation updateAttributeValueComment($id: bigint!, $object: attributeValueComments_set_input) {
  update_attributeValueComments_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
    isDone
    comment
    parentId
    attributeValueId
  }
}
    `;
export type UpdateAttributeValueCommentMutationFn = Apollo.MutationFunction<UpdateAttributeValueCommentMutation, UpdateAttributeValueCommentMutationVariables>;

/**
 * __useUpdateAttributeValueCommentMutation__
 *
 * To run a mutation, you first call `useUpdateAttributeValueCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttributeValueCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttributeValueCommentMutation, { data, loading, error }] = useUpdateAttributeValueCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpdateAttributeValueCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAttributeValueCommentMutation, UpdateAttributeValueCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAttributeValueCommentMutation, UpdateAttributeValueCommentMutationVariables>(UpdateAttributeValueCommentDocument, options);
      }
export type UpdateAttributeValueCommentMutationHookResult = ReturnType<typeof useUpdateAttributeValueCommentMutation>;
export type UpdateAttributeValueCommentMutationResult = Apollo.MutationResult<UpdateAttributeValueCommentMutation>;
export type UpdateAttributeValueCommentMutationOptions = Apollo.BaseMutationOptions<UpdateAttributeValueCommentMutation, UpdateAttributeValueCommentMutationVariables>;
export const UpdateUploadCommentDocument = gql`
    mutation updateUploadComment($id: bigint!, $object: uploadComments_set_input) {
  update_uploadComments_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
    isDone
    comment
    parentId
    uploadId
    uploadVersionId
  }
}
    `;
export type UpdateUploadCommentMutationFn = Apollo.MutationFunction<UpdateUploadCommentMutation, UpdateUploadCommentMutationVariables>;

/**
 * __useUpdateUploadCommentMutation__
 *
 * To run a mutation, you first call `useUpdateUploadCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUploadCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUploadCommentMutation, { data, loading, error }] = useUpdateUploadCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpdateUploadCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUploadCommentMutation, UpdateUploadCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUploadCommentMutation, UpdateUploadCommentMutationVariables>(UpdateUploadCommentDocument, options);
      }
export type UpdateUploadCommentMutationHookResult = ReturnType<typeof useUpdateUploadCommentMutation>;
export type UpdateUploadCommentMutationResult = Apollo.MutationResult<UpdateUploadCommentMutation>;
export type UpdateUploadCommentMutationOptions = Apollo.BaseMutationOptions<UpdateUploadCommentMutation, UpdateUploadCommentMutationVariables>;
export const UpdateRoomAttributeValueCommentDocument = gql`
    mutation updateRoomAttributeValueComment($id: bigint!, $object: roomAttributeValueComments_set_input) {
  update_roomAttributeValueComments_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
    isDone
    comment
    parentId
    roomAttributeValueId
  }
}
    `;
export type UpdateRoomAttributeValueCommentMutationFn = Apollo.MutationFunction<UpdateRoomAttributeValueCommentMutation, UpdateRoomAttributeValueCommentMutationVariables>;

/**
 * __useUpdateRoomAttributeValueCommentMutation__
 *
 * To run a mutation, you first call `useUpdateRoomAttributeValueCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomAttributeValueCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomAttributeValueCommentMutation, { data, loading, error }] = useUpdateRoomAttributeValueCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpdateRoomAttributeValueCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomAttributeValueCommentMutation, UpdateRoomAttributeValueCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoomAttributeValueCommentMutation, UpdateRoomAttributeValueCommentMutationVariables>(UpdateRoomAttributeValueCommentDocument, options);
      }
export type UpdateRoomAttributeValueCommentMutationHookResult = ReturnType<typeof useUpdateRoomAttributeValueCommentMutation>;
export type UpdateRoomAttributeValueCommentMutationResult = Apollo.MutationResult<UpdateRoomAttributeValueCommentMutation>;
export type UpdateRoomAttributeValueCommentMutationOptions = Apollo.BaseMutationOptions<UpdateRoomAttributeValueCommentMutation, UpdateRoomAttributeValueCommentMutationVariables>;
export const CreateEventDocument = gql`
    mutation createEvent($object: events_insert_input!) {
  insert_events_one(object: $object) {
    id
    name
    subTitle
    startDate
    endDate
    eventType
    isArchived
    isCanceled
    parentId
    guestCanEdit
    guestCanEditRoommatrix
    guestOrganisationId
    guestOrganisation {
      name
    }
    services {
      id
      name
    }
    eventOrganisers {
      user {
        id
        firstName
        lastName
      }
    }
    rubinHashEvent
  }
}
    `;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const DeleteEventDocument = gql`
    mutation deleteEvent($id: bigint!) {
  delete_events_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteEventMutationFn = Apollo.MutationFunction<DeleteEventMutation, DeleteEventMutationVariables>;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventMutation, DeleteEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(DeleteEventDocument, options);
      }
export type DeleteEventMutationHookResult = ReturnType<typeof useDeleteEventMutation>;
export type DeleteEventMutationResult = Apollo.MutationResult<DeleteEventMutation>;
export type DeleteEventMutationOptions = Apollo.BaseMutationOptions<DeleteEventMutation, DeleteEventMutationVariables>;
export const GetEventAttributeGroupsDocument = gql`
    query getEventAttributeGroups {
  eventAttributeGroups(order_by: [{order: asc}]) {
    id
    name
    order
    eventAttributes(order_by: [{order: asc}]) {
      id
      slug
      attributeType
      description
      name
      config
      order
    }
  }
}
    `;

/**
 * __useGetEventAttributeGroupsQuery__
 *
 * To run a query within a React component, call `useGetEventAttributeGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventAttributeGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventAttributeGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEventAttributeGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetEventAttributeGroupsQuery, GetEventAttributeGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventAttributeGroupsQuery, GetEventAttributeGroupsQueryVariables>(GetEventAttributeGroupsDocument, options);
      }
export function useGetEventAttributeGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventAttributeGroupsQuery, GetEventAttributeGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventAttributeGroupsQuery, GetEventAttributeGroupsQueryVariables>(GetEventAttributeGroupsDocument, options);
        }
export function useGetEventAttributeGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventAttributeGroupsQuery, GetEventAttributeGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventAttributeGroupsQuery, GetEventAttributeGroupsQueryVariables>(GetEventAttributeGroupsDocument, options);
        }
export type GetEventAttributeGroupsQueryHookResult = ReturnType<typeof useGetEventAttributeGroupsQuery>;
export type GetEventAttributeGroupsLazyQueryHookResult = ReturnType<typeof useGetEventAttributeGroupsLazyQuery>;
export type GetEventAttributeGroupsSuspenseQueryHookResult = ReturnType<typeof useGetEventAttributeGroupsSuspenseQuery>;
export type GetEventAttributeGroupsQueryResult = Apollo.QueryResult<GetEventAttributeGroupsQuery, GetEventAttributeGroupsQueryVariables>;
export const EventByIdDetailedDocument = gql`
    query eventByIdDetailed($id: bigint!, $where: services_bool_exp) {
  events_by_pk(id: $id) {
    id
    name
    subTitle
    startDate
    endDate
    eventType
    isArchived
    isCanceled
    parentId
    services(order_by: [{name: asc}], where: $where) {
      id
      name
      tags
      updatedAt
      createdAt
      serviceModules_aggregate(where: {hasChanges: {_eq: true}}) {
        aggregate {
          count
        }
      }
      serviceModules(order_by: {order: asc_nulls_last}) {
        id
        name
        published
        order
        config
        moduleType
        hasChanges
        lastVisits {
          userId
          updatedAt
        }
        attributeGroups(order_by: {order: asc_nulls_last}) {
          id
          order
          description
          name
          valuesRepeatable
          attributeValueGroups {
            id
            attributeValues(order_by: {attribute: {order: asc_nulls_last}}) {
              id
              value
              user {
                id
                firstName
                lastName
                organisation {
                  id
                  name
                }
              }
              attributeValueUploads {
                ...AttributeValueUploadFileList
              }
              comments_aggregate {
                aggregate {
                  count
                }
              }
              attribute {
                id
                attributeType
                config
                name
                description
                order
                attributeFiles {
                  downloadUrl
                  file {
                    id
                    size
                    name
                    extension
                  }
                }
              }
            }
          }
          attributes {
            attributeType
            config
            createdAt
            description
            id
            name
            updatedAt
            attributeValues {
              id
              updatedAt
              value
              user {
                id
                firstName
                lastName
                organisation {
                  id
                  name
                }
              }
              comments_aggregate {
                aggregate {
                  count
                }
              }
            }
          }
        }
        uploads {
          id
        }
      }
    }
    eventOrganisers {
      user {
        id
        firstName
        lastName
      }
    }
    events {
      id
      name
      subTitle
    }
    eventAttributeValues {
      id
      value
      eventAttributeId
      eventAttributeValueUploads {
        ...EventAttributeValueUploadFileList
      }
      eventAttribute {
        id
        slug
        attributeType
        config
        eventAttributeGroup {
          id
        }
      }
    }
    parentEvent {
      id
      name
    }
  }
}
    ${AttributeValueUploadFileListFragmentDoc}
${EventAttributeValueUploadFileListFragmentDoc}`;

/**
 * __useEventByIdDetailedQuery__
 *
 * To run a query within a React component, call `useEventByIdDetailedQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventByIdDetailedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventByIdDetailedQuery({
 *   variables: {
 *      id: // value for 'id'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useEventByIdDetailedQuery(baseOptions: Apollo.QueryHookOptions<EventByIdDetailedQuery, EventByIdDetailedQueryVariables> & ({ variables: EventByIdDetailedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventByIdDetailedQuery, EventByIdDetailedQueryVariables>(EventByIdDetailedDocument, options);
      }
export function useEventByIdDetailedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventByIdDetailedQuery, EventByIdDetailedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventByIdDetailedQuery, EventByIdDetailedQueryVariables>(EventByIdDetailedDocument, options);
        }
export function useEventByIdDetailedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventByIdDetailedQuery, EventByIdDetailedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventByIdDetailedQuery, EventByIdDetailedQueryVariables>(EventByIdDetailedDocument, options);
        }
export type EventByIdDetailedQueryHookResult = ReturnType<typeof useEventByIdDetailedQuery>;
export type EventByIdDetailedLazyQueryHookResult = ReturnType<typeof useEventByIdDetailedLazyQuery>;
export type EventByIdDetailedSuspenseQueryHookResult = ReturnType<typeof useEventByIdDetailedSuspenseQuery>;
export type EventByIdDetailedQueryResult = Apollo.QueryResult<EventByIdDetailedQuery, EventByIdDetailedQueryVariables>;
export const EventByIdDocument = gql`
    query eventById($id: bigint!, $fetchRubin: Boolean = false, $fetchLastUpdatedInfo: Boolean = true, $fetchGuestCanRead: Boolean = false) {
  events_by_pk(id: $id) {
    id
    name
    subTitle
    startDate
    endDate
    eventType
    isArchived
    isCanceled
    parentId
    guestCanEdit
    guestCanEditRoommatrix
    roommatrixWritable
    guestOrganisationId
    guestOrganisation {
      name
    }
    services(order_by: [{name: asc}]) {
      id
      name
      tags
      fromServiceId
      eventId
      updatedAt
      isFavourite
      userData {
        data
      }
      serviceModules_aggregate(where: {hasChanges: {_eq: true}}) {
        aggregate {
          count
        }
      }
      serviceModules {
        id
        updatedAt
        published
        config
        hasChanges
        guestCanRead @include(if: $fetchGuestCanRead)
        lastVisits {
          userId
          updatedAt
        }
        attributeGroups {
          id
          updatedAt
          attributes {
            id
            updatedAt
            attributeValues {
              id
              createdAt
              updatedAt
              user {
                id
                firstName
                lastName
              }
            }
          }
        }
        uploads {
          updatedAt
        }
      }
    }
    eventOrganisers {
      user {
        id
        firstName
        lastName
      }
    }
    events {
      id
      name
      subTitle
    }
    eventAttributeValues {
      id
      eventAttributeId
      value
      eventAttributeValueUploads {
        ...EventAttributeValueUploadFileList
      }
      createdAt
      updatedAt
      updatedBy @include(if: $fetchLastUpdatedInfo)
      user @include(if: $fetchLastUpdatedInfo) {
        id
        firstName
        lastName
      }
      eventAttribute {
        id
        slug
        attributeType
        config
        name
        order
        eventAttributeGroup {
          id
          name
          order
        }
      }
    }
    parentEvent {
      id
      name
    }
    rubinHashEvent @include(if: $fetchRubin)
    rubinSTAMM @include(if: $fetchRubin) {
      Titel
      ID_Rubin
      T_HASH_Event
      Startdatum
      Enddatum
    }
  }
}
    ${EventAttributeValueUploadFileListFragmentDoc}`;

/**
 * __useEventByIdQuery__
 *
 * To run a query within a React component, call `useEventByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      fetchRubin: // value for 'fetchRubin'
 *      fetchLastUpdatedInfo: // value for 'fetchLastUpdatedInfo'
 *      fetchGuestCanRead: // value for 'fetchGuestCanRead'
 *   },
 * });
 */
export function useEventByIdQuery(baseOptions: Apollo.QueryHookOptions<EventByIdQuery, EventByIdQueryVariables> & ({ variables: EventByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventByIdQuery, EventByIdQueryVariables>(EventByIdDocument, options);
      }
export function useEventByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventByIdQuery, EventByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventByIdQuery, EventByIdQueryVariables>(EventByIdDocument, options);
        }
export function useEventByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventByIdQuery, EventByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventByIdQuery, EventByIdQueryVariables>(EventByIdDocument, options);
        }
export type EventByIdQueryHookResult = ReturnType<typeof useEventByIdQuery>;
export type EventByIdLazyQueryHookResult = ReturnType<typeof useEventByIdLazyQuery>;
export type EventByIdSuspenseQueryHookResult = ReturnType<typeof useEventByIdSuspenseQuery>;
export type EventByIdQueryResult = Apollo.QueryResult<EventByIdQuery, EventByIdQueryVariables>;
export const SetEventFavouriteDocument = gql`
    mutation setEventFavourite($eventId: bigint!) {
  insert_eventFavourites_one(
    object: {eventId: $eventId}
    on_conflict: {constraint: eventFavourites_pkey}
  ) {
    eventId
    userId
  }
}
    `;
export type SetEventFavouriteMutationFn = Apollo.MutationFunction<SetEventFavouriteMutation, SetEventFavouriteMutationVariables>;

/**
 * __useSetEventFavouriteMutation__
 *
 * To run a mutation, you first call `useSetEventFavouriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEventFavouriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEventFavouriteMutation, { data, loading, error }] = useSetEventFavouriteMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useSetEventFavouriteMutation(baseOptions?: Apollo.MutationHookOptions<SetEventFavouriteMutation, SetEventFavouriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEventFavouriteMutation, SetEventFavouriteMutationVariables>(SetEventFavouriteDocument, options);
      }
export type SetEventFavouriteMutationHookResult = ReturnType<typeof useSetEventFavouriteMutation>;
export type SetEventFavouriteMutationResult = Apollo.MutationResult<SetEventFavouriteMutation>;
export type SetEventFavouriteMutationOptions = Apollo.BaseMutationOptions<SetEventFavouriteMutation, SetEventFavouriteMutationVariables>;
export const UnsetEventFavouriteDocument = gql`
    mutation unsetEventFavourite($eventId: bigint!, $userId: bigint!) {
  delete_eventFavourites_by_pk(eventId: $eventId, userId: $userId) {
    eventId
    userId
  }
}
    `;
export type UnsetEventFavouriteMutationFn = Apollo.MutationFunction<UnsetEventFavouriteMutation, UnsetEventFavouriteMutationVariables>;

/**
 * __useUnsetEventFavouriteMutation__
 *
 * To run a mutation, you first call `useUnsetEventFavouriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsetEventFavouriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsetEventFavouriteMutation, { data, loading, error }] = useUnsetEventFavouriteMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnsetEventFavouriteMutation(baseOptions?: Apollo.MutationHookOptions<UnsetEventFavouriteMutation, UnsetEventFavouriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsetEventFavouriteMutation, UnsetEventFavouriteMutationVariables>(UnsetEventFavouriteDocument, options);
      }
export type UnsetEventFavouriteMutationHookResult = ReturnType<typeof useUnsetEventFavouriteMutation>;
export type UnsetEventFavouriteMutationResult = Apollo.MutationResult<UnsetEventFavouriteMutation>;
export type UnsetEventFavouriteMutationOptions = Apollo.BaseMutationOptions<UnsetEventFavouriteMutation, UnsetEventFavouriteMutationVariables>;
export const EventListDocument = gql`
    query eventList($where: events_bool_exp, $order_by: [events_order_by!], $whereEventAttribute: eventAttributeValues_bool_exp) {
  events(where: $where, order_by: $order_by) {
    id
    name
    subTitle
    startDate
    endDate
    eventType
    isArchived
    isCanceled
    parentId
    isFavourite
    guestCanEdit
    guestOrganisationId
    guestCanEditRoommatrix
    guestOrganisation {
      name
    }
    eventOrganisers {
      user {
        id
        firstName
        lastName
      }
    }
    events {
      id
      name
      subTitle
      parentId
      isFavourite
      startDate
      endDate
      eventAttributeValues(where: $whereEventAttribute) {
        value
        eventAttribute {
          name
          id
          slug
        }
      }
    }
    eventAttributeValues(where: $whereEventAttribute) {
      value
      eventAttribute {
        name
        id
        slug
      }
    }
  }
}
    `;

/**
 * __useEventListQuery__
 *
 * To run a query within a React component, call `useEventListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventListQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *      whereEventAttribute: // value for 'whereEventAttribute'
 *   },
 * });
 */
export function useEventListQuery(baseOptions?: Apollo.QueryHookOptions<EventListQuery, EventListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventListQuery, EventListQueryVariables>(EventListDocument, options);
      }
export function useEventListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventListQuery, EventListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventListQuery, EventListQueryVariables>(EventListDocument, options);
        }
export function useEventListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventListQuery, EventListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventListQuery, EventListQueryVariables>(EventListDocument, options);
        }
export type EventListQueryHookResult = ReturnType<typeof useEventListQuery>;
export type EventListLazyQueryHookResult = ReturnType<typeof useEventListLazyQuery>;
export type EventListSuspenseQueryHookResult = ReturnType<typeof useEventListSuspenseQuery>;
export type EventListQueryResult = Apollo.QueryResult<EventListQuery, EventListQueryVariables>;
export const EventListWithRubinDocument = gql`
    query eventListWithRubin($where: events_bool_exp, $order_by: [events_order_by!], $whereEventAttribute: eventAttributeValues_bool_exp) {
  events(where: $where, order_by: $order_by) {
    id
    name
    rubinHashEvent
    rubinSTAMM {
      Titel
      ID_Rubin
      T_HASH_Event
      Startdatum
      Enddatum
    }
  }
}
    `;

/**
 * __useEventListWithRubinQuery__
 *
 * To run a query within a React component, call `useEventListWithRubinQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventListWithRubinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventListWithRubinQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *      whereEventAttribute: // value for 'whereEventAttribute'
 *   },
 * });
 */
export function useEventListWithRubinQuery(baseOptions?: Apollo.QueryHookOptions<EventListWithRubinQuery, EventListWithRubinQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventListWithRubinQuery, EventListWithRubinQueryVariables>(EventListWithRubinDocument, options);
      }
export function useEventListWithRubinLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventListWithRubinQuery, EventListWithRubinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventListWithRubinQuery, EventListWithRubinQueryVariables>(EventListWithRubinDocument, options);
        }
export function useEventListWithRubinSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventListWithRubinQuery, EventListWithRubinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventListWithRubinQuery, EventListWithRubinQueryVariables>(EventListWithRubinDocument, options);
        }
export type EventListWithRubinQueryHookResult = ReturnType<typeof useEventListWithRubinQuery>;
export type EventListWithRubinLazyQueryHookResult = ReturnType<typeof useEventListWithRubinLazyQuery>;
export type EventListWithRubinSuspenseQueryHookResult = ReturnType<typeof useEventListWithRubinSuspenseQuery>;
export type EventListWithRubinQueryResult = Apollo.QueryResult<EventListWithRubinQuery, EventListWithRubinQueryVariables>;
export const EventListExportDocument = gql`
    query eventListExport($where: events_bool_exp, $order_by: [events_order_by!], $whereEventAttribute: eventAttributeValues_bool_exp) {
  events(where: $where, order_by: $order_by) {
    id
    name
    subTitle
    startDate
    endDate
    eventType
    isArchived
    isCanceled
    parentId
    isFavourite
    services {
      id
      name
      serviceModules {
        id
        name
      }
    }
    events {
      id
      name
      subTitle
      parentId
      isFavourite
      startDate
      endDate
      eventAttributeValues(where: $whereEventAttribute) {
        value
        eventAttribute {
          name
          id
        }
      }
    }
  }
}
    `;

/**
 * __useEventListExportQuery__
 *
 * To run a query within a React component, call `useEventListExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventListExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventListExportQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *      whereEventAttribute: // value for 'whereEventAttribute'
 *   },
 * });
 */
export function useEventListExportQuery(baseOptions?: Apollo.QueryHookOptions<EventListExportQuery, EventListExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventListExportQuery, EventListExportQueryVariables>(EventListExportDocument, options);
      }
export function useEventListExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventListExportQuery, EventListExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventListExportQuery, EventListExportQueryVariables>(EventListExportDocument, options);
        }
export function useEventListExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventListExportQuery, EventListExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventListExportQuery, EventListExportQueryVariables>(EventListExportDocument, options);
        }
export type EventListExportQueryHookResult = ReturnType<typeof useEventListExportQuery>;
export type EventListExportLazyQueryHookResult = ReturnType<typeof useEventListExportLazyQuery>;
export type EventListExportSuspenseQueryHookResult = ReturnType<typeof useEventListExportSuspenseQuery>;
export type EventListExportQueryResult = Apollo.QueryResult<EventListExportQuery, EventListExportQueryVariables>;
export const GetEventsInDateRangeDocument = gql`
    query getEventsInDateRange($startDate: date!, $endDate: date!) {
  events(
    where: {_and: [{startDate: {_lte: $endDate}}, {endDate: {_gte: $startDate}}]}
    order_by: {startDate: asc}
  ) {
    id
    name
    startDate
    endDate
    eventRooms {
      roomId
      guestCanEdit
      room {
        id
        name
        order
        roomServices {
          id
          name
          order
          description
        }
      }
    }
    eventAttributeValues {
      id
      value
      createdAt
      updatedAt
      eventAttribute {
        id
        attributeType
        config
        name
        order
        eventAttributeGroup {
          id
          name
          order
        }
      }
    }
  }
}
    `;

/**
 * __useGetEventsInDateRangeQuery__
 *
 * To run a query within a React component, call `useGetEventsInDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsInDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsInDateRangeQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetEventsInDateRangeQuery(baseOptions: Apollo.QueryHookOptions<GetEventsInDateRangeQuery, GetEventsInDateRangeQueryVariables> & ({ variables: GetEventsInDateRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsInDateRangeQuery, GetEventsInDateRangeQueryVariables>(GetEventsInDateRangeDocument, options);
      }
export function useGetEventsInDateRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsInDateRangeQuery, GetEventsInDateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsInDateRangeQuery, GetEventsInDateRangeQueryVariables>(GetEventsInDateRangeDocument, options);
        }
export function useGetEventsInDateRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventsInDateRangeQuery, GetEventsInDateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventsInDateRangeQuery, GetEventsInDateRangeQueryVariables>(GetEventsInDateRangeDocument, options);
        }
export type GetEventsInDateRangeQueryHookResult = ReturnType<typeof useGetEventsInDateRangeQuery>;
export type GetEventsInDateRangeLazyQueryHookResult = ReturnType<typeof useGetEventsInDateRangeLazyQuery>;
export type GetEventsInDateRangeSuspenseQueryHookResult = ReturnType<typeof useGetEventsInDateRangeSuspenseQuery>;
export type GetEventsInDateRangeQueryResult = Apollo.QueryResult<GetEventsInDateRangeQuery, GetEventsInDateRangeQueryVariables>;
export const GetEventsByOccurencesInRangeDocument = gql`
    query getEventsByOccurencesInRange($startDate: timestamptz!, $endDate: timestamptz!) {
  roomOccurrences(
    distinct_on: eventId
    where: {event: {isCanceled: {_is_null: true}}, _not: {_or: [{endDate: {_lte: $startDate}}, {startDate: {_gte: $endDate}}]}}
    order_by: [{eventId: asc}, {startDate: asc}]
  ) {
    event {
      id
      name
      startDate
      endDate
      eventRooms {
        roomId
        guestCanEdit
        room {
          id
          name
          order
          roomServices {
            id
            name
            order
            description
          }
        }
      }
      eventAttributeValues {
        id
        value
        createdAt
        updatedAt
        eventAttribute {
          id
          attributeType
          config
          name
          order
          eventAttributeGroup {
            id
            name
            order
          }
        }
      }
    }
  }
  roomServiceOccurrences(
    distinct_on: eventId
    where: {event: {isCanceled: {_is_null: true}}, _not: {_or: [{endDate: {_lte: $startDate}}, {startDate: {_gte: $endDate}}]}}
    order_by: [{eventId: asc}, {startDate: asc}]
  ) {
    event {
      id
      name
      startDate
      endDate
      eventRooms {
        roomId
        guestCanEdit
        room {
          id
          name
          order
          roomServices {
            id
            name
            order
            description
          }
        }
      }
      eventAttributeValues {
        id
        value
        createdAt
        updatedAt
        eventAttribute {
          id
          attributeType
          config
          name
          order
          eventAttributeGroup {
            id
            name
            order
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEventsByOccurencesInRangeQuery__
 *
 * To run a query within a React component, call `useGetEventsByOccurencesInRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsByOccurencesInRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsByOccurencesInRangeQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetEventsByOccurencesInRangeQuery(baseOptions: Apollo.QueryHookOptions<GetEventsByOccurencesInRangeQuery, GetEventsByOccurencesInRangeQueryVariables> & ({ variables: GetEventsByOccurencesInRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsByOccurencesInRangeQuery, GetEventsByOccurencesInRangeQueryVariables>(GetEventsByOccurencesInRangeDocument, options);
      }
export function useGetEventsByOccurencesInRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsByOccurencesInRangeQuery, GetEventsByOccurencesInRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsByOccurencesInRangeQuery, GetEventsByOccurencesInRangeQueryVariables>(GetEventsByOccurencesInRangeDocument, options);
        }
export function useGetEventsByOccurencesInRangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventsByOccurencesInRangeQuery, GetEventsByOccurencesInRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventsByOccurencesInRangeQuery, GetEventsByOccurencesInRangeQueryVariables>(GetEventsByOccurencesInRangeDocument, options);
        }
export type GetEventsByOccurencesInRangeQueryHookResult = ReturnType<typeof useGetEventsByOccurencesInRangeQuery>;
export type GetEventsByOccurencesInRangeLazyQueryHookResult = ReturnType<typeof useGetEventsByOccurencesInRangeLazyQuery>;
export type GetEventsByOccurencesInRangeSuspenseQueryHookResult = ReturnType<typeof useGetEventsByOccurencesInRangeSuspenseQuery>;
export type GetEventsByOccurencesInRangeQueryResult = Apollo.QueryResult<GetEventsByOccurencesInRangeQuery, GetEventsByOccurencesInRangeQueryVariables>;
export const GetEventConfigDocument = gql`
    query getEventConfig($eventId: bigint!) {
  events_by_pk(id: $eventId) {
    id
    name
    config
  }
}
    `;

/**
 * __useGetEventConfigQuery__
 *
 * To run a query within a React component, call `useGetEventConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventConfigQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventConfigQuery(baseOptions: Apollo.QueryHookOptions<GetEventConfigQuery, GetEventConfigQueryVariables> & ({ variables: GetEventConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventConfigQuery, GetEventConfigQueryVariables>(GetEventConfigDocument, options);
      }
export function useGetEventConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventConfigQuery, GetEventConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventConfigQuery, GetEventConfigQueryVariables>(GetEventConfigDocument, options);
        }
export function useGetEventConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventConfigQuery, GetEventConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventConfigQuery, GetEventConfigQueryVariables>(GetEventConfigDocument, options);
        }
export type GetEventConfigQueryHookResult = ReturnType<typeof useGetEventConfigQuery>;
export type GetEventConfigLazyQueryHookResult = ReturnType<typeof useGetEventConfigLazyQuery>;
export type GetEventConfigSuspenseQueryHookResult = ReturnType<typeof useGetEventConfigSuspenseQuery>;
export type GetEventConfigQueryResult = Apollo.QueryResult<GetEventConfigQuery, GetEventConfigQueryVariables>;
export const GetMultipleEventConfigsDocument = gql`
    query getMultipleEventConfigs($eventIds: [bigint!]!) {
  events(where: {id: {_in: $eventIds}}) {
    id
    name
    config
  }
}
    `;

/**
 * __useGetMultipleEventConfigsQuery__
 *
 * To run a query within a React component, call `useGetMultipleEventConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultipleEventConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultipleEventConfigsQuery({
 *   variables: {
 *      eventIds: // value for 'eventIds'
 *   },
 * });
 */
export function useGetMultipleEventConfigsQuery(baseOptions: Apollo.QueryHookOptions<GetMultipleEventConfigsQuery, GetMultipleEventConfigsQueryVariables> & ({ variables: GetMultipleEventConfigsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMultipleEventConfigsQuery, GetMultipleEventConfigsQueryVariables>(GetMultipleEventConfigsDocument, options);
      }
export function useGetMultipleEventConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMultipleEventConfigsQuery, GetMultipleEventConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMultipleEventConfigsQuery, GetMultipleEventConfigsQueryVariables>(GetMultipleEventConfigsDocument, options);
        }
export function useGetMultipleEventConfigsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMultipleEventConfigsQuery, GetMultipleEventConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMultipleEventConfigsQuery, GetMultipleEventConfigsQueryVariables>(GetMultipleEventConfigsDocument, options);
        }
export type GetMultipleEventConfigsQueryHookResult = ReturnType<typeof useGetMultipleEventConfigsQuery>;
export type GetMultipleEventConfigsLazyQueryHookResult = ReturnType<typeof useGetMultipleEventConfigsLazyQuery>;
export type GetMultipleEventConfigsSuspenseQueryHookResult = ReturnType<typeof useGetMultipleEventConfigsSuspenseQuery>;
export type GetMultipleEventConfigsQueryResult = Apollo.QueryResult<GetMultipleEventConfigsQuery, GetMultipleEventConfigsQueryVariables>;
export const UpdateEventConfigDocument = gql`
    mutation updateEventConfig($eventId: bigint!, $eventConfigUpdate: json!) {
  update_events_by_pk(
    pk_columns: {id: $eventId}
    _set: {config: $eventConfigUpdate}
  ) {
    id
    config
  }
}
    `;
export type UpdateEventConfigMutationFn = Apollo.MutationFunction<UpdateEventConfigMutation, UpdateEventConfigMutationVariables>;

/**
 * __useUpdateEventConfigMutation__
 *
 * To run a mutation, you first call `useUpdateEventConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventConfigMutation, { data, loading, error }] = useUpdateEventConfigMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      eventConfigUpdate: // value for 'eventConfigUpdate'
 *   },
 * });
 */
export function useUpdateEventConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventConfigMutation, UpdateEventConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventConfigMutation, UpdateEventConfigMutationVariables>(UpdateEventConfigDocument, options);
      }
export type UpdateEventConfigMutationHookResult = ReturnType<typeof useUpdateEventConfigMutation>;
export type UpdateEventConfigMutationResult = Apollo.MutationResult<UpdateEventConfigMutation>;
export type UpdateEventConfigMutationOptions = Apollo.BaseMutationOptions<UpdateEventConfigMutation, UpdateEventConfigMutationVariables>;
export const UpdateEventDocument = gql`
    mutation updateEvent($id: bigint!, $_set: events_set_input, $eventAttributesToUpsert: [eventAttributeValues_insert_input!]!, $eventAttributesToDelete: [bigint!]!, $eventAttributeValueUploadsToInsert: [eventAttributeValueUploads_insert_input!]!, $eventAttributeValueUploadVersionsToInsert: [eventAttributeValueUploadVersions_insert_input!]!, $eventAttributeValueUploadVersionsToDelete: [eventAttributeValueUploadVersions_bool_exp!]!, $eventAttributeValueUploadsToDelete: [bigint!]!) {
  delete_eventAttributeValueUploadVersions(
    where: {_or: $eventAttributeValueUploadVersionsToDelete}
  ) {
    affected_rows
  }
  delete_eventAttributeValueUploads(
    where: {id: {_in: $eventAttributeValueUploadsToDelete}}
  ) {
    affected_rows
  }
  insert_eventAttributeValues(
    objects: $eventAttributesToUpsert
    on_conflict: {constraint: eventAttributeValues_eventId_eventAttributeId_key, update_columns: [value]}
  ) {
    returning {
      id
      value
      eventAttributeId
    }
  }
  insert_eventAttributeValueUploads(objects: $eventAttributeValueUploadsToInsert) {
    affected_rows
    returning {
      id
      eventAttributeValueId
      eventAttributeValueUploadVersions {
        eventAttributeValueUploadId
        fileId
      }
    }
  }
  insert_eventAttributeValueUploadVersions(
    objects: $eventAttributeValueUploadVersionsToInsert
  ) {
    affected_rows
    returning {
      eventAttributeValueUploadId
      fileId
    }
  }
  delete_eventAttributeValues(
    where: {_and: [{eventAttributeId: {_in: $eventAttributesToDelete}}, {eventId: {_eq: $id}}]}
  ) {
    affected_rows
  }
  update_events_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
    name
    subTitle
    startDate
    endDate
    eventType
    isArchived
    isCanceled
    parentId
    guestCanEdit
    guestCanEditRoommatrix
    guestOrganisationId
    guestOrganisation {
      name
    }
    services {
      id
      name
    }
    eventOrganisers {
      user {
        id
        firstName
        lastName
      }
    }
    events {
      id
      name
      subTitle
      rubinHashEvent
    }
    eventAttributeValues {
      id
      eventAttributeId
      value
      eventAttributeValueUploads {
        ...EventAttributeValueUploadFileList
      }
      eventAttribute {
        id
        attributeType
        eventAttributeGroup {
          id
        }
      }
    }
    rubinHashEvent
    rubinSTAMM {
      Titel
      ID_Rubin
      T_HASH_Event
      Startdatum
      Enddatum
    }
  }
}
    ${EventAttributeValueUploadFileListFragmentDoc}`;
export type UpdateEventMutationFn = Apollo.MutationFunction<UpdateEventMutation, UpdateEventMutationVariables>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *      eventAttributesToUpsert: // value for 'eventAttributesToUpsert'
 *      eventAttributesToDelete: // value for 'eventAttributesToDelete'
 *      eventAttributeValueUploadsToInsert: // value for 'eventAttributeValueUploadsToInsert'
 *      eventAttributeValueUploadVersionsToInsert: // value for 'eventAttributeValueUploadVersionsToInsert'
 *      eventAttributeValueUploadVersionsToDelete: // value for 'eventAttributeValueUploadVersionsToDelete'
 *      eventAttributeValueUploadsToDelete: // value for 'eventAttributeValueUploadsToDelete'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, options);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = Apollo.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>;
export const UpdateEventWithOrganisersDocument = gql`
    mutation updateEventWithOrganisers($id: bigint!, $_set: events_set_input, $organisers: [eventOrganisers_insert_input!]!, $eventAttributesToUpsert: [eventAttributeValues_insert_input!]!, $eventAttributesToDelete: [bigint!]!, $eventAttributeValueUploadsToInsert: [eventAttributeValueUploads_insert_input!]!, $eventAttributeValueUploadVersionsToInsert: [eventAttributeValueUploadVersions_insert_input!]!, $eventAttributeValueUploadVersionsToDelete: [eventAttributeValueUploadVersions_bool_exp!]!, $eventAttributeValueUploadsToDelete: [bigint!]!) {
  delete_eventOrganisers(where: {eventId: {_eq: $id}}) {
    affected_rows
  }
  insert_eventOrganisers(objects: $organisers) {
    affected_rows
  }
  delete_eventAttributeValueUploadVersions(
    where: {_or: $eventAttributeValueUploadVersionsToDelete}
  ) {
    affected_rows
  }
  delete_eventAttributeValueUploads(
    where: {id: {_in: $eventAttributeValueUploadsToDelete}}
  ) {
    affected_rows
  }
  insert_eventAttributeValues(
    objects: $eventAttributesToUpsert
    on_conflict: {constraint: eventAttributeValues_eventId_eventAttributeId_key, update_columns: [value]}
  ) {
    returning {
      id
      value
      eventAttributeId
    }
  }
  insert_eventAttributeValueUploads(objects: $eventAttributeValueUploadsToInsert) {
    affected_rows
    returning {
      id
      eventAttributeValueId
      eventAttributeValueUploadVersions {
        eventAttributeValueUploadId
        fileId
      }
    }
  }
  insert_eventAttributeValueUploadVersions(
    objects: $eventAttributeValueUploadVersionsToInsert
  ) {
    affected_rows
    returning {
      eventAttributeValueUploadId
      fileId
    }
  }
  delete_eventAttributeValues(
    where: {_and: [{eventAttributeId: {_in: $eventAttributesToDelete}}, {eventId: {_eq: $id}}]}
  ) {
    affected_rows
  }
  update_events_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
    name
    subTitle
    startDate
    endDate
    eventType
    isArchived
    isCanceled
    parentId
    guestCanEdit
    guestCanEditRoommatrix
    guestOrganisationId
    guestOrganisation {
      name
    }
    services {
      id
      name
    }
    eventOrganisers {
      user {
        id
        firstName
        lastName
      }
    }
    events {
      id
      name
      subTitle
      rubinHashEvent
    }
    eventAttributeValues {
      id
      eventAttributeId
      value
      eventAttributeValueUploads {
        ...EventAttributeValueUploadFileList
      }
      eventAttribute {
        id
        attributeType
        eventAttributeGroup {
          id
        }
      }
    }
    rubinHashEvent
    rubinSTAMM {
      Titel
      ID_Rubin
      T_HASH_Event
      Startdatum
      Enddatum
    }
  }
}
    ${EventAttributeValueUploadFileListFragmentDoc}`;
export type UpdateEventWithOrganisersMutationFn = Apollo.MutationFunction<UpdateEventWithOrganisersMutation, UpdateEventWithOrganisersMutationVariables>;

/**
 * __useUpdateEventWithOrganisersMutation__
 *
 * To run a mutation, you first call `useUpdateEventWithOrganisersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventWithOrganisersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventWithOrganisersMutation, { data, loading, error }] = useUpdateEventWithOrganisersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *      organisers: // value for 'organisers'
 *      eventAttributesToUpsert: // value for 'eventAttributesToUpsert'
 *      eventAttributesToDelete: // value for 'eventAttributesToDelete'
 *      eventAttributeValueUploadsToInsert: // value for 'eventAttributeValueUploadsToInsert'
 *      eventAttributeValueUploadVersionsToInsert: // value for 'eventAttributeValueUploadVersionsToInsert'
 *      eventAttributeValueUploadVersionsToDelete: // value for 'eventAttributeValueUploadVersionsToDelete'
 *      eventAttributeValueUploadsToDelete: // value for 'eventAttributeValueUploadsToDelete'
 *   },
 * });
 */
export function useUpdateEventWithOrganisersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventWithOrganisersMutation, UpdateEventWithOrganisersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventWithOrganisersMutation, UpdateEventWithOrganisersMutationVariables>(UpdateEventWithOrganisersDocument, options);
      }
export type UpdateEventWithOrganisersMutationHookResult = ReturnType<typeof useUpdateEventWithOrganisersMutation>;
export type UpdateEventWithOrganisersMutationResult = Apollo.MutationResult<UpdateEventWithOrganisersMutation>;
export type UpdateEventWithOrganisersMutationOptions = Apollo.BaseMutationOptions<UpdateEventWithOrganisersMutation, UpdateEventWithOrganisersMutationVariables>;
export const UpdateGuestCanEditRoommatrixDocument = gql`
    mutation updateGuestCanEditRoommatrix($eventId: bigint!, $guestCanEditRoommatrix: Boolean!) {
  update_events_by_pk(
    pk_columns: {id: $eventId}
    _set: {guestCanEditRoommatrix: $guestCanEditRoommatrix}
  ) {
    id
    guestCanEditRoommatrix
  }
}
    `;
export type UpdateGuestCanEditRoommatrixMutationFn = Apollo.MutationFunction<UpdateGuestCanEditRoommatrixMutation, UpdateGuestCanEditRoommatrixMutationVariables>;

/**
 * __useUpdateGuestCanEditRoommatrixMutation__
 *
 * To run a mutation, you first call `useUpdateGuestCanEditRoommatrixMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGuestCanEditRoommatrixMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGuestCanEditRoommatrixMutation, { data, loading, error }] = useUpdateGuestCanEditRoommatrixMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      guestCanEditRoommatrix: // value for 'guestCanEditRoommatrix'
 *   },
 * });
 */
export function useUpdateGuestCanEditRoommatrixMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGuestCanEditRoommatrixMutation, UpdateGuestCanEditRoommatrixMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGuestCanEditRoommatrixMutation, UpdateGuestCanEditRoommatrixMutationVariables>(UpdateGuestCanEditRoommatrixDocument, options);
      }
export type UpdateGuestCanEditRoommatrixMutationHookResult = ReturnType<typeof useUpdateGuestCanEditRoommatrixMutation>;
export type UpdateGuestCanEditRoommatrixMutationResult = Apollo.MutationResult<UpdateGuestCanEditRoommatrixMutation>;
export type UpdateGuestCanEditRoommatrixMutationOptions = Apollo.BaseMutationOptions<UpdateGuestCanEditRoommatrixMutation, UpdateGuestCanEditRoommatrixMutationVariables>;
export const DeleteFileMasterVersionDocument = gql`
    mutation DeleteFileMasterVersion($id: bigint!) {
  delete_fileMasterVersions_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteFileMasterVersionMutationFn = Apollo.MutationFunction<DeleteFileMasterVersionMutation, DeleteFileMasterVersionMutationVariables>;

/**
 * __useDeleteFileMasterVersionMutation__
 *
 * To run a mutation, you first call `useDeleteFileMasterVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMasterVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMasterVersionMutation, { data, loading, error }] = useDeleteFileMasterVersionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFileMasterVersionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileMasterVersionMutation, DeleteFileMasterVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileMasterVersionMutation, DeleteFileMasterVersionMutationVariables>(DeleteFileMasterVersionDocument, options);
      }
export type DeleteFileMasterVersionMutationHookResult = ReturnType<typeof useDeleteFileMasterVersionMutation>;
export type DeleteFileMasterVersionMutationResult = Apollo.MutationResult<DeleteFileMasterVersionMutation>;
export type DeleteFileMasterVersionMutationOptions = Apollo.BaseMutationOptions<DeleteFileMasterVersionMutation, DeleteFileMasterVersionMutationVariables>;
export const DeleteFileMasterDocument = gql`
    mutation DeleteFileMaster($id: bigint!) {
  delete_fileMasters_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteFileMasterMutationFn = Apollo.MutationFunction<DeleteFileMasterMutation, DeleteFileMasterMutationVariables>;

/**
 * __useDeleteFileMasterMutation__
 *
 * To run a mutation, you first call `useDeleteFileMasterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMasterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMasterMutation, { data, loading, error }] = useDeleteFileMasterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFileMasterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileMasterMutation, DeleteFileMasterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileMasterMutation, DeleteFileMasterMutationVariables>(DeleteFileMasterDocument, options);
      }
export type DeleteFileMasterMutationHookResult = ReturnType<typeof useDeleteFileMasterMutation>;
export type DeleteFileMasterMutationResult = Apollo.MutationResult<DeleteFileMasterMutation>;
export type DeleteFileMasterMutationOptions = Apollo.BaseMutationOptions<DeleteFileMasterMutation, DeleteFileMasterMutationVariables>;
export const FileMasterByIdDocument = gql`
    query FileMasterById($id: bigint!) {
  fileMasters_by_pk(id: $id) {
    id
    name
    fileMasterVersions(order_by: {id: desc}) {
      id
      fileId
      downloadUrl
      file {
        id
        name
        extension
        updatedAt
        createdAt
      }
    }
  }
}
    `;

/**
 * __useFileMasterByIdQuery__
 *
 * To run a query within a React component, call `useFileMasterByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileMasterByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileMasterByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFileMasterByIdQuery(baseOptions: Apollo.QueryHookOptions<FileMasterByIdQuery, FileMasterByIdQueryVariables> & ({ variables: FileMasterByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FileMasterByIdQuery, FileMasterByIdQueryVariables>(FileMasterByIdDocument, options);
      }
export function useFileMasterByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FileMasterByIdQuery, FileMasterByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FileMasterByIdQuery, FileMasterByIdQueryVariables>(FileMasterByIdDocument, options);
        }
export function useFileMasterByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FileMasterByIdQuery, FileMasterByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FileMasterByIdQuery, FileMasterByIdQueryVariables>(FileMasterByIdDocument, options);
        }
export type FileMasterByIdQueryHookResult = ReturnType<typeof useFileMasterByIdQuery>;
export type FileMasterByIdLazyQueryHookResult = ReturnType<typeof useFileMasterByIdLazyQuery>;
export type FileMasterByIdSuspenseQueryHookResult = ReturnType<typeof useFileMasterByIdSuspenseQuery>;
export type FileMasterByIdQueryResult = Apollo.QueryResult<FileMasterByIdQuery, FileMasterByIdQueryVariables>;
export const FileMasterSearchDocument = gql`
    query FileMasterSearch($searchTerm: String = "%%") {
  fileMasters(
    where: {_or: [{name: {_ilike: $searchTerm}}, {fileMasterVersions: {file: {_or: [{name: {_ilike: $searchTerm}}, {extension: {_ilike: $searchTerm}}]}}}]}
    order_by: {updatedAt: desc}
  ) {
    id
    name
    createdAt
    updatedAt
    fileMasterVersions(order_by: {id: desc}, limit: 1) {
      id
      fileId
      downloadUrl
      file {
        id
        name
        extension
        mimeType
        updatedAt
        createdAt
      }
    }
  }
}
    `;

/**
 * __useFileMasterSearchQuery__
 *
 * To run a query within a React component, call `useFileMasterSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileMasterSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileMasterSearchQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useFileMasterSearchQuery(baseOptions?: Apollo.QueryHookOptions<FileMasterSearchQuery, FileMasterSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FileMasterSearchQuery, FileMasterSearchQueryVariables>(FileMasterSearchDocument, options);
      }
export function useFileMasterSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FileMasterSearchQuery, FileMasterSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FileMasterSearchQuery, FileMasterSearchQueryVariables>(FileMasterSearchDocument, options);
        }
export function useFileMasterSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FileMasterSearchQuery, FileMasterSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FileMasterSearchQuery, FileMasterSearchQueryVariables>(FileMasterSearchDocument, options);
        }
export type FileMasterSearchQueryHookResult = ReturnType<typeof useFileMasterSearchQuery>;
export type FileMasterSearchLazyQueryHookResult = ReturnType<typeof useFileMasterSearchLazyQuery>;
export type FileMasterSearchSuspenseQueryHookResult = ReturnType<typeof useFileMasterSearchSuspenseQuery>;
export type FileMasterSearchQueryResult = Apollo.QueryResult<FileMasterSearchQuery, FileMasterSearchQueryVariables>;
export const FileMasterListDocument = gql`
    query FileMasterList {
  fileMasters(order_by: {name: asc}) {
    id
    name
    createdAt
    updatedAt
    childVersionsUpdatedAt
    fileMasterVersions(order_by: {id: desc}, limit: 1) {
      id
      fileId
      downloadUrl
      file {
        id
        name
        extension
        mimeType
        updatedAt
        createdAt
      }
    }
  }
}
    `;

/**
 * __useFileMasterListQuery__
 *
 * To run a query within a React component, call `useFileMasterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileMasterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileMasterListQuery({
 *   variables: {
 *   },
 * });
 */
export function useFileMasterListQuery(baseOptions?: Apollo.QueryHookOptions<FileMasterListQuery, FileMasterListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FileMasterListQuery, FileMasterListQueryVariables>(FileMasterListDocument, options);
      }
export function useFileMasterListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FileMasterListQuery, FileMasterListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FileMasterListQuery, FileMasterListQueryVariables>(FileMasterListDocument, options);
        }
export function useFileMasterListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FileMasterListQuery, FileMasterListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FileMasterListQuery, FileMasterListQueryVariables>(FileMasterListDocument, options);
        }
export type FileMasterListQueryHookResult = ReturnType<typeof useFileMasterListQuery>;
export type FileMasterListLazyQueryHookResult = ReturnType<typeof useFileMasterListLazyQuery>;
export type FileMasterListSuspenseQueryHookResult = ReturnType<typeof useFileMasterListSuspenseQuery>;
export type FileMasterListQueryResult = Apollo.QueryResult<FileMasterListQuery, FileMasterListQueryVariables>;
export const FileMasterListRecentDocument = gql`
    query FileMasterListRecent($limit: Int = 10) {
  fileMasters(limit: $limit, order_by: {childVersionsUpdatedAt: desc}) {
    id
    name
    createdAt
    updatedAt
    childVersionsUpdatedAt
    fileMasterVersions(order_by: {id: desc}, limit: 1) {
      id
      fileId
      downloadUrl
      file {
        id
        name
        extension
        mimeType
        updatedAt
        createdAt
      }
    }
  }
}
    `;

/**
 * __useFileMasterListRecentQuery__
 *
 * To run a query within a React component, call `useFileMasterListRecentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileMasterListRecentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileMasterListRecentQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFileMasterListRecentQuery(baseOptions?: Apollo.QueryHookOptions<FileMasterListRecentQuery, FileMasterListRecentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FileMasterListRecentQuery, FileMasterListRecentQueryVariables>(FileMasterListRecentDocument, options);
      }
export function useFileMasterListRecentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FileMasterListRecentQuery, FileMasterListRecentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FileMasterListRecentQuery, FileMasterListRecentQueryVariables>(FileMasterListRecentDocument, options);
        }
export function useFileMasterListRecentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FileMasterListRecentQuery, FileMasterListRecentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FileMasterListRecentQuery, FileMasterListRecentQueryVariables>(FileMasterListRecentDocument, options);
        }
export type FileMasterListRecentQueryHookResult = ReturnType<typeof useFileMasterListRecentQuery>;
export type FileMasterListRecentLazyQueryHookResult = ReturnType<typeof useFileMasterListRecentLazyQuery>;
export type FileMasterListRecentSuspenseQueryHookResult = ReturnType<typeof useFileMasterListRecentSuspenseQuery>;
export type FileMasterListRecentQueryResult = Apollo.QueryResult<FileMasterListRecentQuery, FileMasterListRecentQueryVariables>;
export const InsertFileMasterVersionDocument = gql`
    mutation InsertFileMasterVersion($object: fileMasterVersions_insert_input!) {
  insert_fileMasterVersions_one(object: $object) {
    id
    fileId
  }
}
    `;
export type InsertFileMasterVersionMutationFn = Apollo.MutationFunction<InsertFileMasterVersionMutation, InsertFileMasterVersionMutationVariables>;

/**
 * __useInsertFileMasterVersionMutation__
 *
 * To run a mutation, you first call `useInsertFileMasterVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertFileMasterVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertFileMasterVersionMutation, { data, loading, error }] = useInsertFileMasterVersionMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertFileMasterVersionMutation(baseOptions?: Apollo.MutationHookOptions<InsertFileMasterVersionMutation, InsertFileMasterVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertFileMasterVersionMutation, InsertFileMasterVersionMutationVariables>(InsertFileMasterVersionDocument, options);
      }
export type InsertFileMasterVersionMutationHookResult = ReturnType<typeof useInsertFileMasterVersionMutation>;
export type InsertFileMasterVersionMutationResult = Apollo.MutationResult<InsertFileMasterVersionMutation>;
export type InsertFileMasterVersionMutationOptions = Apollo.BaseMutationOptions<InsertFileMasterVersionMutation, InsertFileMasterVersionMutationVariables>;
export const InsertFileMasterDocument = gql`
    mutation InsertFileMaster($object: fileMasters_insert_input!) {
  insert_fileMasters_one(object: $object) {
    id
    name
  }
}
    `;
export type InsertFileMasterMutationFn = Apollo.MutationFunction<InsertFileMasterMutation, InsertFileMasterMutationVariables>;

/**
 * __useInsertFileMasterMutation__
 *
 * To run a mutation, you first call `useInsertFileMasterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertFileMasterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertFileMasterMutation, { data, loading, error }] = useInsertFileMasterMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertFileMasterMutation(baseOptions?: Apollo.MutationHookOptions<InsertFileMasterMutation, InsertFileMasterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertFileMasterMutation, InsertFileMasterMutationVariables>(InsertFileMasterDocument, options);
      }
export type InsertFileMasterMutationHookResult = ReturnType<typeof useInsertFileMasterMutation>;
export type InsertFileMasterMutationResult = Apollo.MutationResult<InsertFileMasterMutation>;
export type InsertFileMasterMutationOptions = Apollo.BaseMutationOptions<InsertFileMasterMutation, InsertFileMasterMutationVariables>;
export const UpdateFileMasterDocument = gql`
    mutation UpdateFileMaster($id: bigint!, $changes: fileMasters_set_input!) {
  update_fileMasters_by_pk(pk_columns: {id: $id}, _set: $changes) {
    id
    name
  }
}
    `;
export type UpdateFileMasterMutationFn = Apollo.MutationFunction<UpdateFileMasterMutation, UpdateFileMasterMutationVariables>;

/**
 * __useUpdateFileMasterMutation__
 *
 * To run a mutation, you first call `useUpdateFileMasterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileMasterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileMasterMutation, { data, loading, error }] = useUpdateFileMasterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useUpdateFileMasterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileMasterMutation, UpdateFileMasterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileMasterMutation, UpdateFileMasterMutationVariables>(UpdateFileMasterDocument, options);
      }
export type UpdateFileMasterMutationHookResult = ReturnType<typeof useUpdateFileMasterMutation>;
export type UpdateFileMasterMutationResult = Apollo.MutationResult<UpdateFileMasterMutation>;
export type UpdateFileMasterMutationOptions = Apollo.BaseMutationOptions<UpdateFileMasterMutation, UpdateFileMasterMutationVariables>;
export const RoomChangesDocument = gql`
    query roomChanges($where: roomChanges_bool_exp!) {
  roomChanges(where: $where, order_by: {id: desc}) {
    id
    createdAt
    eventId
    roomId
    room {
      name
    }
    roomServiceId
    roomService {
      name
    }
    userId
    table
    op
    displayData
    user {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useRoomChangesQuery__
 *
 * To run a query within a React component, call `useRoomChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomChangesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRoomChangesQuery(baseOptions: Apollo.QueryHookOptions<RoomChangesQuery, RoomChangesQueryVariables> & ({ variables: RoomChangesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomChangesQuery, RoomChangesQueryVariables>(RoomChangesDocument, options);
      }
export function useRoomChangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomChangesQuery, RoomChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomChangesQuery, RoomChangesQueryVariables>(RoomChangesDocument, options);
        }
export function useRoomChangesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RoomChangesQuery, RoomChangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RoomChangesQuery, RoomChangesQueryVariables>(RoomChangesDocument, options);
        }
export type RoomChangesQueryHookResult = ReturnType<typeof useRoomChangesQuery>;
export type RoomChangesLazyQueryHookResult = ReturnType<typeof useRoomChangesLazyQuery>;
export type RoomChangesSuspenseQueryHookResult = ReturnType<typeof useRoomChangesSuspenseQuery>;
export type RoomChangesQueryResult = Apollo.QueryResult<RoomChangesQuery, RoomChangesQueryVariables>;
export const SingleRoomAttributeDocument = gql`
    query singleRoomAttribute($id: bigint!) {
  roomAttributes_by_pk(id: $id) {
    id
    name
    description
    attributeType
    config
    order
    roomAttributeGroup {
      id
      name
    }
  }
}
    `;

/**
 * __useSingleRoomAttributeQuery__
 *
 * To run a query within a React component, call `useSingleRoomAttributeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleRoomAttributeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleRoomAttributeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleRoomAttributeQuery(baseOptions: Apollo.QueryHookOptions<SingleRoomAttributeQuery, SingleRoomAttributeQueryVariables> & ({ variables: SingleRoomAttributeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleRoomAttributeQuery, SingleRoomAttributeQueryVariables>(SingleRoomAttributeDocument, options);
      }
export function useSingleRoomAttributeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleRoomAttributeQuery, SingleRoomAttributeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleRoomAttributeQuery, SingleRoomAttributeQueryVariables>(SingleRoomAttributeDocument, options);
        }
export function useSingleRoomAttributeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SingleRoomAttributeQuery, SingleRoomAttributeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SingleRoomAttributeQuery, SingleRoomAttributeQueryVariables>(SingleRoomAttributeDocument, options);
        }
export type SingleRoomAttributeQueryHookResult = ReturnType<typeof useSingleRoomAttributeQuery>;
export type SingleRoomAttributeLazyQueryHookResult = ReturnType<typeof useSingleRoomAttributeLazyQuery>;
export type SingleRoomAttributeSuspenseQueryHookResult = ReturnType<typeof useSingleRoomAttributeSuspenseQuery>;
export type SingleRoomAttributeQueryResult = Apollo.QueryResult<SingleRoomAttributeQuery, SingleRoomAttributeQueryVariables>;
export const GetServiceModuleChangesByServiceModuleIdGroupedDocument = gql`
    query getServiceModuleChangesByServiceModuleIdGrouped($serviceModuleId: bigint, $limit: Int, $offset: Int) {
  serviceModuleChanges_grouped(
    where: {serviceModuleId: {_eq: $serviceModuleId}}
    order_by: {createdAt: desc}
  ) {
    createdAt
    serviceModuleId
    changes
    user {
      firstName
      lastName
    }
    serviceModuleId
    serviceModule {
      moduleType
    }
  }
  serviceModuleChanges_grouped_aggregate(
    where: {serviceModuleId: {_eq: $serviceModuleId}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetServiceModuleChangesByServiceModuleIdGroupedQuery__
 *
 * To run a query within a React component, call `useGetServiceModuleChangesByServiceModuleIdGroupedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceModuleChangesByServiceModuleIdGroupedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceModuleChangesByServiceModuleIdGroupedQuery({
 *   variables: {
 *      serviceModuleId: // value for 'serviceModuleId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetServiceModuleChangesByServiceModuleIdGroupedQuery(baseOptions?: Apollo.QueryHookOptions<GetServiceModuleChangesByServiceModuleIdGroupedQuery, GetServiceModuleChangesByServiceModuleIdGroupedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceModuleChangesByServiceModuleIdGroupedQuery, GetServiceModuleChangesByServiceModuleIdGroupedQueryVariables>(GetServiceModuleChangesByServiceModuleIdGroupedDocument, options);
      }
export function useGetServiceModuleChangesByServiceModuleIdGroupedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceModuleChangesByServiceModuleIdGroupedQuery, GetServiceModuleChangesByServiceModuleIdGroupedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceModuleChangesByServiceModuleIdGroupedQuery, GetServiceModuleChangesByServiceModuleIdGroupedQueryVariables>(GetServiceModuleChangesByServiceModuleIdGroupedDocument, options);
        }
export function useGetServiceModuleChangesByServiceModuleIdGroupedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceModuleChangesByServiceModuleIdGroupedQuery, GetServiceModuleChangesByServiceModuleIdGroupedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceModuleChangesByServiceModuleIdGroupedQuery, GetServiceModuleChangesByServiceModuleIdGroupedQueryVariables>(GetServiceModuleChangesByServiceModuleIdGroupedDocument, options);
        }
export type GetServiceModuleChangesByServiceModuleIdGroupedQueryHookResult = ReturnType<typeof useGetServiceModuleChangesByServiceModuleIdGroupedQuery>;
export type GetServiceModuleChangesByServiceModuleIdGroupedLazyQueryHookResult = ReturnType<typeof useGetServiceModuleChangesByServiceModuleIdGroupedLazyQuery>;
export type GetServiceModuleChangesByServiceModuleIdGroupedSuspenseQueryHookResult = ReturnType<typeof useGetServiceModuleChangesByServiceModuleIdGroupedSuspenseQuery>;
export type GetServiceModuleChangesByServiceModuleIdGroupedQueryResult = Apollo.QueryResult<GetServiceModuleChangesByServiceModuleIdGroupedQuery, GetServiceModuleChangesByServiceModuleIdGroupedQueryVariables>;
export const GetModuleByIdDocument = gql`
    query getModuleById($id: bigint!, $organisationId: bigint = 0, $guestOrganisationId: bigint = 0) {
  serviceModules_by_pk(id: $id) {
    id
    moduleType
    uploads(order_by: {createdAt: desc}) {
      id
      name
      comments_aggregate(
        where: {_or: [{organisationId: {_eq: $organisationId}}, {organisationId: {_eq: $guestOrganisationId}}, {organisationId: {_is_null: true}}], _and: {isDone: {_is_null: true}, parentId: {_is_null: true}}}
      ) {
        aggregate {
          count
        }
      }
      current: uploadVersions(limit: 1, order_by: {file: {createdAt: desc}}) {
        ...uploadVersionFields
      }
      archive: uploadVersions(offset: 1, order_by: {file: {createdAt: desc}}) {
        ...uploadVersionFields
      }
    }
  }
}
    ${UploadVersionFieldsFragmentDoc}`;

/**
 * __useGetModuleByIdQuery__
 *
 * To run a query within a React component, call `useGetModuleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModuleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModuleByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      organisationId: // value for 'organisationId'
 *      guestOrganisationId: // value for 'guestOrganisationId'
 *   },
 * });
 */
export function useGetModuleByIdQuery(baseOptions: Apollo.QueryHookOptions<GetModuleByIdQuery, GetModuleByIdQueryVariables> & ({ variables: GetModuleByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModuleByIdQuery, GetModuleByIdQueryVariables>(GetModuleByIdDocument, options);
      }
export function useGetModuleByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModuleByIdQuery, GetModuleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModuleByIdQuery, GetModuleByIdQueryVariables>(GetModuleByIdDocument, options);
        }
export function useGetModuleByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetModuleByIdQuery, GetModuleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetModuleByIdQuery, GetModuleByIdQueryVariables>(GetModuleByIdDocument, options);
        }
export type GetModuleByIdQueryHookResult = ReturnType<typeof useGetModuleByIdQuery>;
export type GetModuleByIdLazyQueryHookResult = ReturnType<typeof useGetModuleByIdLazyQuery>;
export type GetModuleByIdSuspenseQueryHookResult = ReturnType<typeof useGetModuleByIdSuspenseQuery>;
export type GetModuleByIdQueryResult = Apollo.QueryResult<GetModuleByIdQuery, GetModuleByIdQueryVariables>;
export const GetModuleByIdWithJaggaerInfoRealtimeDocument = gql`
    subscription getModuleByIdWithJaggaerInfoRealtime($id: bigint!, $organisationId: bigint = 0, $guestOrganisationId: bigint = 0) {
  serviceModules_by_pk(id: $id) {
    id
    moduleType
    uploads(order_by: {createdAt: desc}) {
      id
      name
      comments_aggregate(
        where: {_or: [{organisationId: {_eq: $organisationId}}, {organisationId: {_eq: $guestOrganisationId}}, {organisationId: {_is_null: true}}], _and: {isDone: {_is_null: true}, parentId: {_is_null: true}}}
      ) {
        aggregate {
          count
        }
      }
      current: uploadVersions(limit: 1, order_by: {file: {createdAt: desc}}) {
        ...uploadVersionFieldsWithJaggaerInfo
      }
      archive: uploadVersions(offset: 1, order_by: {file: {createdAt: desc}}) {
        ...uploadVersionFieldsWithJaggaerInfo
      }
    }
  }
}
    ${UploadVersionFieldsWithJaggaerInfoFragmentDoc}`;

/**
 * __useGetModuleByIdWithJaggaerInfoRealtimeSubscription__
 *
 * To run a query within a React component, call `useGetModuleByIdWithJaggaerInfoRealtimeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetModuleByIdWithJaggaerInfoRealtimeSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModuleByIdWithJaggaerInfoRealtimeSubscription({
 *   variables: {
 *      id: // value for 'id'
 *      organisationId: // value for 'organisationId'
 *      guestOrganisationId: // value for 'guestOrganisationId'
 *   },
 * });
 */
export function useGetModuleByIdWithJaggaerInfoRealtimeSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetModuleByIdWithJaggaerInfoRealtimeSubscription, GetModuleByIdWithJaggaerInfoRealtimeSubscriptionVariables> & ({ variables: GetModuleByIdWithJaggaerInfoRealtimeSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetModuleByIdWithJaggaerInfoRealtimeSubscription, GetModuleByIdWithJaggaerInfoRealtimeSubscriptionVariables>(GetModuleByIdWithJaggaerInfoRealtimeDocument, options);
      }
export type GetModuleByIdWithJaggaerInfoRealtimeSubscriptionHookResult = ReturnType<typeof useGetModuleByIdWithJaggaerInfoRealtimeSubscription>;
export type GetModuleByIdWithJaggaerInfoRealtimeSubscriptionResult = Apollo.SubscriptionResult<GetModuleByIdWithJaggaerInfoRealtimeSubscription>;
export const GetModuleByIdRealtimeDocument = gql`
    subscription getModuleByIdRealtime($id: bigint!, $organisationId: bigint = 0, $guestOrganisationId: bigint = 0) {
  serviceModules_by_pk(id: $id) {
    id
    moduleType
    uploads(order_by: {createdAt: desc}) {
      id
      name
      comments_aggregate(
        where: {_or: [{organisationId: {_eq: $organisationId}}, {organisationId: {_eq: $guestOrganisationId}}, {organisationId: {_is_null: true}}], _and: {isDone: {_is_null: true}, parentId: {_is_null: true}}}
      ) {
        aggregate {
          count
        }
      }
      current: uploadVersions(limit: 1, order_by: {file: {createdAt: desc}}) {
        ...uploadVersionFields
      }
      archive: uploadVersions(offset: 1, order_by: {file: {createdAt: desc}}) {
        ...uploadVersionFields
      }
    }
  }
}
    ${UploadVersionFieldsFragmentDoc}`;

/**
 * __useGetModuleByIdRealtimeSubscription__
 *
 * To run a query within a React component, call `useGetModuleByIdRealtimeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetModuleByIdRealtimeSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModuleByIdRealtimeSubscription({
 *   variables: {
 *      id: // value for 'id'
 *      organisationId: // value for 'organisationId'
 *      guestOrganisationId: // value for 'guestOrganisationId'
 *   },
 * });
 */
export function useGetModuleByIdRealtimeSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetModuleByIdRealtimeSubscription, GetModuleByIdRealtimeSubscriptionVariables> & ({ variables: GetModuleByIdRealtimeSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetModuleByIdRealtimeSubscription, GetModuleByIdRealtimeSubscriptionVariables>(GetModuleByIdRealtimeDocument, options);
      }
export type GetModuleByIdRealtimeSubscriptionHookResult = ReturnType<typeof useGetModuleByIdRealtimeSubscription>;
export type GetModuleByIdRealtimeSubscriptionResult = Apollo.SubscriptionResult<GetModuleByIdRealtimeSubscription>;
export const GetServiceModuleHistoryDocument = gql`
    query getServiceModuleHistory($serviceModuleId: bigint!) {
  serviceModules_by_pk(id: $serviceModuleId) {
    id
    name
    moduleType
    service {
      name
      event {
        name
      }
    }
  }
}
    `;

/**
 * __useGetServiceModuleHistoryQuery__
 *
 * To run a query within a React component, call `useGetServiceModuleHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceModuleHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceModuleHistoryQuery({
 *   variables: {
 *      serviceModuleId: // value for 'serviceModuleId'
 *   },
 * });
 */
export function useGetServiceModuleHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetServiceModuleHistoryQuery, GetServiceModuleHistoryQueryVariables> & ({ variables: GetServiceModuleHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceModuleHistoryQuery, GetServiceModuleHistoryQueryVariables>(GetServiceModuleHistoryDocument, options);
      }
export function useGetServiceModuleHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceModuleHistoryQuery, GetServiceModuleHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceModuleHistoryQuery, GetServiceModuleHistoryQueryVariables>(GetServiceModuleHistoryDocument, options);
        }
export function useGetServiceModuleHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceModuleHistoryQuery, GetServiceModuleHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceModuleHistoryQuery, GetServiceModuleHistoryQueryVariables>(GetServiceModuleHistoryDocument, options);
        }
export type GetServiceModuleHistoryQueryHookResult = ReturnType<typeof useGetServiceModuleHistoryQuery>;
export type GetServiceModuleHistoryLazyQueryHookResult = ReturnType<typeof useGetServiceModuleHistoryLazyQuery>;
export type GetServiceModuleHistorySuspenseQueryHookResult = ReturnType<typeof useGetServiceModuleHistorySuspenseQuery>;
export type GetServiceModuleHistoryQueryResult = Apollo.QueryResult<GetServiceModuleHistoryQuery, GetServiceModuleHistoryQueryVariables>;
export const SetPublishOnServiceModuleDocument = gql`
    mutation setPublishOnServiceModule($id: bigint!, $published: Boolean!) {
  update_serviceModules_by_pk(
    pk_columns: {id: $id}
    _set: {published: $published}
  ) {
    id
    name
    published
    service {
      id
      eventId
    }
  }
}
    `;
export type SetPublishOnServiceModuleMutationFn = Apollo.MutationFunction<SetPublishOnServiceModuleMutation, SetPublishOnServiceModuleMutationVariables>;

/**
 * __useSetPublishOnServiceModuleMutation__
 *
 * To run a mutation, you first call `useSetPublishOnServiceModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPublishOnServiceModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPublishOnServiceModuleMutation, { data, loading, error }] = useSetPublishOnServiceModuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      published: // value for 'published'
 *   },
 * });
 */
export function useSetPublishOnServiceModuleMutation(baseOptions?: Apollo.MutationHookOptions<SetPublishOnServiceModuleMutation, SetPublishOnServiceModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPublishOnServiceModuleMutation, SetPublishOnServiceModuleMutationVariables>(SetPublishOnServiceModuleDocument, options);
      }
export type SetPublishOnServiceModuleMutationHookResult = ReturnType<typeof useSetPublishOnServiceModuleMutation>;
export type SetPublishOnServiceModuleMutationResult = Apollo.MutationResult<SetPublishOnServiceModuleMutation>;
export type SetPublishOnServiceModuleMutationOptions = Apollo.BaseMutationOptions<SetPublishOnServiceModuleMutation, SetPublishOnServiceModuleMutationVariables>;
export const AddNewsDocument = gql`
    mutation addNews($object: news_insert_input!) {
  insert_news_one(object: $object) {
    title
    content
    createdAt
    createdBy
  }
}
    `;
export type AddNewsMutationFn = Apollo.MutationFunction<AddNewsMutation, AddNewsMutationVariables>;

/**
 * __useAddNewsMutation__
 *
 * To run a mutation, you first call `useAddNewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNewsMutation, { data, loading, error }] = useAddNewsMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAddNewsMutation(baseOptions?: Apollo.MutationHookOptions<AddNewsMutation, AddNewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNewsMutation, AddNewsMutationVariables>(AddNewsDocument, options);
      }
export type AddNewsMutationHookResult = ReturnType<typeof useAddNewsMutation>;
export type AddNewsMutationResult = Apollo.MutationResult<AddNewsMutation>;
export type AddNewsMutationOptions = Apollo.BaseMutationOptions<AddNewsMutation, AddNewsMutationVariables>;
export const GetNewsDocument = gql`
    query getNews {
  news {
    title
    content
    createdAt
    createdBy
  }
}
    `;

/**
 * __useGetNewsQuery__
 *
 * To run a query within a React component, call `useGetNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNewsQuery(baseOptions?: Apollo.QueryHookOptions<GetNewsQuery, GetNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsQuery, GetNewsQueryVariables>(GetNewsDocument, options);
      }
export function useGetNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsQuery, GetNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsQuery, GetNewsQueryVariables>(GetNewsDocument, options);
        }
export function useGetNewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNewsQuery, GetNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNewsQuery, GetNewsQueryVariables>(GetNewsDocument, options);
        }
export type GetNewsQueryHookResult = ReturnType<typeof useGetNewsQuery>;
export type GetNewsLazyQueryHookResult = ReturnType<typeof useGetNewsLazyQuery>;
export type GetNewsSuspenseQueryHookResult = ReturnType<typeof useGetNewsSuspenseQuery>;
export type GetNewsQueryResult = Apollo.QueryResult<GetNewsQuery, GetNewsQueryVariables>;
export const NotificationByIdDocument = gql`
    query notificationById($id: bigint!) {
  notifications_by_pk(id: $id) {
    id
    createdAt
    userId
    data
    eventId
    serviceId
    attributeValueCommentId
    roomAttributeValueId
    uploadCommentId
    readAt
  }
}
    `;

/**
 * __useNotificationByIdQuery__
 *
 * To run a query within a React component, call `useNotificationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNotificationByIdQuery(baseOptions: Apollo.QueryHookOptions<NotificationByIdQuery, NotificationByIdQueryVariables> & ({ variables: NotificationByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationByIdQuery, NotificationByIdQueryVariables>(NotificationByIdDocument, options);
      }
export function useNotificationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationByIdQuery, NotificationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationByIdQuery, NotificationByIdQueryVariables>(NotificationByIdDocument, options);
        }
export function useNotificationByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotificationByIdQuery, NotificationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationByIdQuery, NotificationByIdQueryVariables>(NotificationByIdDocument, options);
        }
export type NotificationByIdQueryHookResult = ReturnType<typeof useNotificationByIdQuery>;
export type NotificationByIdLazyQueryHookResult = ReturnType<typeof useNotificationByIdLazyQuery>;
export type NotificationByIdSuspenseQueryHookResult = ReturnType<typeof useNotificationByIdSuspenseQuery>;
export type NotificationByIdQueryResult = Apollo.QueryResult<NotificationByIdQuery, NotificationByIdQueryVariables>;
export const GetNotificationMessageByIdUnusedDocument = gql`
    query getNotificationMessageByIdUnused($id: bigint!) {
  notificationMessages_by_pk(id: $id) {
    id
    createdAt
    notificationId
    readAt
    sentAt
    notification {
      id
      createdAt
      userId
      eventId
      event {
        name
      }
      readAt
      notificationAction
      user {
        id
        firstName
        lastName
        organisationId
      }
      serviceId
      service {
        name
      }
      serviceModuleId
      serviceModule {
        name
        moduleType
      }
      eventAttributeValueId
      eventAttributeValue {
        eventAttribute {
          name
        }
      }
      authorUserId
      attributeValueId
      attributeValueCommentId
      roomAttributeValueId
      uploadCommentId
      attributeValueComment {
        organisationId
        attributeValueId
      }
      uploadComment {
        organisationId
        uploadId
      }
      roomAttributeValueComment {
        organisationId
        roomAttributeValueId
      }
      fileId
    }
  }
}
    `;

/**
 * __useGetNotificationMessageByIdUnusedQuery__
 *
 * To run a query within a React component, call `useGetNotificationMessageByIdUnusedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationMessageByIdUnusedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationMessageByIdUnusedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNotificationMessageByIdUnusedQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationMessageByIdUnusedQuery, GetNotificationMessageByIdUnusedQueryVariables> & ({ variables: GetNotificationMessageByIdUnusedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationMessageByIdUnusedQuery, GetNotificationMessageByIdUnusedQueryVariables>(GetNotificationMessageByIdUnusedDocument, options);
      }
export function useGetNotificationMessageByIdUnusedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationMessageByIdUnusedQuery, GetNotificationMessageByIdUnusedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationMessageByIdUnusedQuery, GetNotificationMessageByIdUnusedQueryVariables>(GetNotificationMessageByIdUnusedDocument, options);
        }
export function useGetNotificationMessageByIdUnusedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationMessageByIdUnusedQuery, GetNotificationMessageByIdUnusedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationMessageByIdUnusedQuery, GetNotificationMessageByIdUnusedQueryVariables>(GetNotificationMessageByIdUnusedDocument, options);
        }
export type GetNotificationMessageByIdUnusedQueryHookResult = ReturnType<typeof useGetNotificationMessageByIdUnusedQuery>;
export type GetNotificationMessageByIdUnusedLazyQueryHookResult = ReturnType<typeof useGetNotificationMessageByIdUnusedLazyQuery>;
export type GetNotificationMessageByIdUnusedSuspenseQueryHookResult = ReturnType<typeof useGetNotificationMessageByIdUnusedSuspenseQuery>;
export type GetNotificationMessageByIdUnusedQueryResult = Apollo.QueryResult<GetNotificationMessageByIdUnusedQuery, GetNotificationMessageByIdUnusedQueryVariables>;
export const DeleteNotificationPreferenceDocument = gql`
    mutation deleteNotificationPreference($id: bigint!) {
  delete_notificationPreferences_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteNotificationPreferenceMutationFn = Apollo.MutationFunction<DeleteNotificationPreferenceMutation, DeleteNotificationPreferenceMutationVariables>;

/**
 * __useDeleteNotificationPreferenceMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationPreferenceMutation, { data, loading, error }] = useDeleteNotificationPreferenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNotificationPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationPreferenceMutation, DeleteNotificationPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationPreferenceMutation, DeleteNotificationPreferenceMutationVariables>(DeleteNotificationPreferenceDocument, options);
      }
export type DeleteNotificationPreferenceMutationHookResult = ReturnType<typeof useDeleteNotificationPreferenceMutation>;
export type DeleteNotificationPreferenceMutationResult = Apollo.MutationResult<DeleteNotificationPreferenceMutation>;
export type DeleteNotificationPreferenceMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationPreferenceMutation, DeleteNotificationPreferenceMutationVariables>;
export const AddNotificationPreferenceDocument = gql`
    mutation addNotificationPreference($object: notificationPreferences_insert_input!) {
  insert_notificationPreferences_one(object: $object) {
    id
    notificationAction
    notificationChannel
    notificationPreferenceStage
    userId
  }
}
    `;
export type AddNotificationPreferenceMutationFn = Apollo.MutationFunction<AddNotificationPreferenceMutation, AddNotificationPreferenceMutationVariables>;

/**
 * __useAddNotificationPreferenceMutation__
 *
 * To run a mutation, you first call `useAddNotificationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNotificationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNotificationPreferenceMutation, { data, loading, error }] = useAddNotificationPreferenceMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAddNotificationPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<AddNotificationPreferenceMutation, AddNotificationPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNotificationPreferenceMutation, AddNotificationPreferenceMutationVariables>(AddNotificationPreferenceDocument, options);
      }
export type AddNotificationPreferenceMutationHookResult = ReturnType<typeof useAddNotificationPreferenceMutation>;
export type AddNotificationPreferenceMutationResult = Apollo.MutationResult<AddNotificationPreferenceMutation>;
export type AddNotificationPreferenceMutationOptions = Apollo.BaseMutationOptions<AddNotificationPreferenceMutation, AddNotificationPreferenceMutationVariables>;
export const AddNotificationServicePreferencesDocument = gql`
    mutation addNotificationServicePreferences($serviceId: bigint!) {
  insert_notificationServicePreferences_one(object: {serviceId: $serviceId}) {
    userId
    serviceId
  }
}
    `;
export type AddNotificationServicePreferencesMutationFn = Apollo.MutationFunction<AddNotificationServicePreferencesMutation, AddNotificationServicePreferencesMutationVariables>;

/**
 * __useAddNotificationServicePreferencesMutation__
 *
 * To run a mutation, you first call `useAddNotificationServicePreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNotificationServicePreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNotificationServicePreferencesMutation, { data, loading, error }] = useAddNotificationServicePreferencesMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useAddNotificationServicePreferencesMutation(baseOptions?: Apollo.MutationHookOptions<AddNotificationServicePreferencesMutation, AddNotificationServicePreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNotificationServicePreferencesMutation, AddNotificationServicePreferencesMutationVariables>(AddNotificationServicePreferencesDocument, options);
      }
export type AddNotificationServicePreferencesMutationHookResult = ReturnType<typeof useAddNotificationServicePreferencesMutation>;
export type AddNotificationServicePreferencesMutationResult = Apollo.MutationResult<AddNotificationServicePreferencesMutation>;
export type AddNotificationServicePreferencesMutationOptions = Apollo.BaseMutationOptions<AddNotificationServicePreferencesMutation, AddNotificationServicePreferencesMutationVariables>;
export const DeleteNotificationServicePreferencesDocument = gql`
    mutation deleteNotificationServicePreferences($serviceId: bigint!) {
  delete_notificationServicePreferences(where: {serviceId: {_eq: $serviceId}}) {
    affected_rows
    returning {
      userId
      serviceId
    }
  }
}
    `;
export type DeleteNotificationServicePreferencesMutationFn = Apollo.MutationFunction<DeleteNotificationServicePreferencesMutation, DeleteNotificationServicePreferencesMutationVariables>;

/**
 * __useDeleteNotificationServicePreferencesMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationServicePreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationServicePreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationServicePreferencesMutation, { data, loading, error }] = useDeleteNotificationServicePreferencesMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useDeleteNotificationServicePreferencesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationServicePreferencesMutation, DeleteNotificationServicePreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationServicePreferencesMutation, DeleteNotificationServicePreferencesMutationVariables>(DeleteNotificationServicePreferencesDocument, options);
      }
export type DeleteNotificationServicePreferencesMutationHookResult = ReturnType<typeof useDeleteNotificationServicePreferencesMutation>;
export type DeleteNotificationServicePreferencesMutationResult = Apollo.MutationResult<DeleteNotificationServicePreferencesMutation>;
export type DeleteNotificationServicePreferencesMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationServicePreferencesMutation, DeleteNotificationServicePreferencesMutationVariables>;
export const SetOranisationMentionNotificationPreferenceDocument = gql`
    mutation setOranisationMentionNotificationPreference($notificationForOrganisation: Boolean) {
  update_userSettings(
    _set: {notificationForOrganisation: $notificationForOrganisation}
    where: {}
  ) {
    affected_rows
    returning {
      id
      notificationForOrganisation
      wantRoomOccurrenceNotifications
    }
  }
}
    `;
export type SetOranisationMentionNotificationPreferenceMutationFn = Apollo.MutationFunction<SetOranisationMentionNotificationPreferenceMutation, SetOranisationMentionNotificationPreferenceMutationVariables>;

/**
 * __useSetOranisationMentionNotificationPreferenceMutation__
 *
 * To run a mutation, you first call `useSetOranisationMentionNotificationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOranisationMentionNotificationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOranisationMentionNotificationPreferenceMutation, { data, loading, error }] = useSetOranisationMentionNotificationPreferenceMutation({
 *   variables: {
 *      notificationForOrganisation: // value for 'notificationForOrganisation'
 *   },
 * });
 */
export function useSetOranisationMentionNotificationPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<SetOranisationMentionNotificationPreferenceMutation, SetOranisationMentionNotificationPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOranisationMentionNotificationPreferenceMutation, SetOranisationMentionNotificationPreferenceMutationVariables>(SetOranisationMentionNotificationPreferenceDocument, options);
      }
export type SetOranisationMentionNotificationPreferenceMutationHookResult = ReturnType<typeof useSetOranisationMentionNotificationPreferenceMutation>;
export type SetOranisationMentionNotificationPreferenceMutationResult = Apollo.MutationResult<SetOranisationMentionNotificationPreferenceMutation>;
export type SetOranisationMentionNotificationPreferenceMutationOptions = Apollo.BaseMutationOptions<SetOranisationMentionNotificationPreferenceMutation, SetOranisationMentionNotificationPreferenceMutationVariables>;
export const SetUserSettingsNotificationPreferenceDocument = gql`
    mutation setUserSettingsNotificationPreference($userSettings: userSettings_set_input) {
  update_userSettings(_set: $userSettings, where: {}) {
    affected_rows
    returning {
      id
      notificationForOrganisation
      wantRoomOccurrenceNotifications
    }
  }
}
    `;
export type SetUserSettingsNotificationPreferenceMutationFn = Apollo.MutationFunction<SetUserSettingsNotificationPreferenceMutation, SetUserSettingsNotificationPreferenceMutationVariables>;

/**
 * __useSetUserSettingsNotificationPreferenceMutation__
 *
 * To run a mutation, you first call `useSetUserSettingsNotificationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserSettingsNotificationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserSettingsNotificationPreferenceMutation, { data, loading, error }] = useSetUserSettingsNotificationPreferenceMutation({
 *   variables: {
 *      userSettings: // value for 'userSettings'
 *   },
 * });
 */
export function useSetUserSettingsNotificationPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<SetUserSettingsNotificationPreferenceMutation, SetUserSettingsNotificationPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserSettingsNotificationPreferenceMutation, SetUserSettingsNotificationPreferenceMutationVariables>(SetUserSettingsNotificationPreferenceDocument, options);
      }
export type SetUserSettingsNotificationPreferenceMutationHookResult = ReturnType<typeof useSetUserSettingsNotificationPreferenceMutation>;
export type SetUserSettingsNotificationPreferenceMutationResult = Apollo.MutationResult<SetUserSettingsNotificationPreferenceMutation>;
export type SetUserSettingsNotificationPreferenceMutationOptions = Apollo.BaseMutationOptions<SetUserSettingsNotificationPreferenceMutation, SetUserSettingsNotificationPreferenceMutationVariables>;
export const AddRoomServiceCategoryPreferenceDocument = gql`
    mutation addRoomServiceCategoryPreference($roomServiceCategoryId: bigint!) {
  insert_notificationRoomServiceCategoryPreferences_one(
    object: {roomServiceCategoryId: $roomServiceCategoryId}
  ) {
    userId
    roomServiceCategoryId
  }
}
    `;
export type AddRoomServiceCategoryPreferenceMutationFn = Apollo.MutationFunction<AddRoomServiceCategoryPreferenceMutation, AddRoomServiceCategoryPreferenceMutationVariables>;

/**
 * __useAddRoomServiceCategoryPreferenceMutation__
 *
 * To run a mutation, you first call `useAddRoomServiceCategoryPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRoomServiceCategoryPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRoomServiceCategoryPreferenceMutation, { data, loading, error }] = useAddRoomServiceCategoryPreferenceMutation({
 *   variables: {
 *      roomServiceCategoryId: // value for 'roomServiceCategoryId'
 *   },
 * });
 */
export function useAddRoomServiceCategoryPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<AddRoomServiceCategoryPreferenceMutation, AddRoomServiceCategoryPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRoomServiceCategoryPreferenceMutation, AddRoomServiceCategoryPreferenceMutationVariables>(AddRoomServiceCategoryPreferenceDocument, options);
      }
export type AddRoomServiceCategoryPreferenceMutationHookResult = ReturnType<typeof useAddRoomServiceCategoryPreferenceMutation>;
export type AddRoomServiceCategoryPreferenceMutationResult = Apollo.MutationResult<AddRoomServiceCategoryPreferenceMutation>;
export type AddRoomServiceCategoryPreferenceMutationOptions = Apollo.BaseMutationOptions<AddRoomServiceCategoryPreferenceMutation, AddRoomServiceCategoryPreferenceMutationVariables>;
export const DeleteRoomServiceCategoryPreferenceDocument = gql`
    mutation deleteRoomServiceCategoryPreference($roomServiceCategoryId: bigint!) {
  delete_notificationRoomServiceCategoryPreferences(
    where: {roomServiceCategoryId: {_eq: $roomServiceCategoryId}}
  ) {
    affected_rows
    returning {
      userId
      roomServiceCategoryId
    }
  }
}
    `;
export type DeleteRoomServiceCategoryPreferenceMutationFn = Apollo.MutationFunction<DeleteRoomServiceCategoryPreferenceMutation, DeleteRoomServiceCategoryPreferenceMutationVariables>;

/**
 * __useDeleteRoomServiceCategoryPreferenceMutation__
 *
 * To run a mutation, you first call `useDeleteRoomServiceCategoryPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoomServiceCategoryPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoomServiceCategoryPreferenceMutation, { data, loading, error }] = useDeleteRoomServiceCategoryPreferenceMutation({
 *   variables: {
 *      roomServiceCategoryId: // value for 'roomServiceCategoryId'
 *   },
 * });
 */
export function useDeleteRoomServiceCategoryPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoomServiceCategoryPreferenceMutation, DeleteRoomServiceCategoryPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoomServiceCategoryPreferenceMutation, DeleteRoomServiceCategoryPreferenceMutationVariables>(DeleteRoomServiceCategoryPreferenceDocument, options);
      }
export type DeleteRoomServiceCategoryPreferenceMutationHookResult = ReturnType<typeof useDeleteRoomServiceCategoryPreferenceMutation>;
export type DeleteRoomServiceCategoryPreferenceMutationResult = Apollo.MutationResult<DeleteRoomServiceCategoryPreferenceMutation>;
export type DeleteRoomServiceCategoryPreferenceMutationOptions = Apollo.BaseMutationOptions<DeleteRoomServiceCategoryPreferenceMutation, DeleteRoomServiceCategoryPreferenceMutationVariables>;
export const NotificationPreferencesMetaDocument = gql`
    query notificationPreferencesMeta {
  notificationChannels {
    name
  }
  notificationActions {
    name
  }
  notificationPreferenceStages {
    name
  }
}
    `;

/**
 * __useNotificationPreferencesMetaQuery__
 *
 * To run a query within a React component, call `useNotificationPreferencesMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationPreferencesMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationPreferencesMetaQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationPreferencesMetaQuery(baseOptions?: Apollo.QueryHookOptions<NotificationPreferencesMetaQuery, NotificationPreferencesMetaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationPreferencesMetaQuery, NotificationPreferencesMetaQueryVariables>(NotificationPreferencesMetaDocument, options);
      }
export function useNotificationPreferencesMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationPreferencesMetaQuery, NotificationPreferencesMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationPreferencesMetaQuery, NotificationPreferencesMetaQueryVariables>(NotificationPreferencesMetaDocument, options);
        }
export function useNotificationPreferencesMetaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NotificationPreferencesMetaQuery, NotificationPreferencesMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationPreferencesMetaQuery, NotificationPreferencesMetaQueryVariables>(NotificationPreferencesMetaDocument, options);
        }
export type NotificationPreferencesMetaQueryHookResult = ReturnType<typeof useNotificationPreferencesMetaQuery>;
export type NotificationPreferencesMetaLazyQueryHookResult = ReturnType<typeof useNotificationPreferencesMetaLazyQuery>;
export type NotificationPreferencesMetaSuspenseQueryHookResult = ReturnType<typeof useNotificationPreferencesMetaSuspenseQuery>;
export type NotificationPreferencesMetaQueryResult = Apollo.QueryResult<NotificationPreferencesMetaQuery, NotificationPreferencesMetaQueryVariables>;
export const MyNotificationPreferencesDocument = gql`
    query myNotificationPreferences {
  notificationPreferences {
    id
    notificationAction
    notificationChannel
    notificationPreferenceStage
    userId
  }
}
    `;

/**
 * __useMyNotificationPreferencesQuery__
 *
 * To run a query within a React component, call `useMyNotificationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyNotificationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyNotificationPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyNotificationPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<MyNotificationPreferencesQuery, MyNotificationPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyNotificationPreferencesQuery, MyNotificationPreferencesQueryVariables>(MyNotificationPreferencesDocument, options);
      }
export function useMyNotificationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyNotificationPreferencesQuery, MyNotificationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyNotificationPreferencesQuery, MyNotificationPreferencesQueryVariables>(MyNotificationPreferencesDocument, options);
        }
export function useMyNotificationPreferencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyNotificationPreferencesQuery, MyNotificationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyNotificationPreferencesQuery, MyNotificationPreferencesQueryVariables>(MyNotificationPreferencesDocument, options);
        }
export type MyNotificationPreferencesQueryHookResult = ReturnType<typeof useMyNotificationPreferencesQuery>;
export type MyNotificationPreferencesLazyQueryHookResult = ReturnType<typeof useMyNotificationPreferencesLazyQuery>;
export type MyNotificationPreferencesSuspenseQueryHookResult = ReturnType<typeof useMyNotificationPreferencesSuspenseQuery>;
export type MyNotificationPreferencesQueryResult = Apollo.QueryResult<MyNotificationPreferencesQuery, MyNotificationPreferencesQueryVariables>;
export const MyNotificationServicePreferencesDocument = gql`
    query myNotificationServicePreferences {
  notificationServicePreferences {
    serviceId
    userId
  }
}
    `;

/**
 * __useMyNotificationServicePreferencesQuery__
 *
 * To run a query within a React component, call `useMyNotificationServicePreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyNotificationServicePreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyNotificationServicePreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyNotificationServicePreferencesQuery(baseOptions?: Apollo.QueryHookOptions<MyNotificationServicePreferencesQuery, MyNotificationServicePreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyNotificationServicePreferencesQuery, MyNotificationServicePreferencesQueryVariables>(MyNotificationServicePreferencesDocument, options);
      }
export function useMyNotificationServicePreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyNotificationServicePreferencesQuery, MyNotificationServicePreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyNotificationServicePreferencesQuery, MyNotificationServicePreferencesQueryVariables>(MyNotificationServicePreferencesDocument, options);
        }
export function useMyNotificationServicePreferencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyNotificationServicePreferencesQuery, MyNotificationServicePreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyNotificationServicePreferencesQuery, MyNotificationServicePreferencesQueryVariables>(MyNotificationServicePreferencesDocument, options);
        }
export type MyNotificationServicePreferencesQueryHookResult = ReturnType<typeof useMyNotificationServicePreferencesQuery>;
export type MyNotificationServicePreferencesLazyQueryHookResult = ReturnType<typeof useMyNotificationServicePreferencesLazyQuery>;
export type MyNotificationServicePreferencesSuspenseQueryHookResult = ReturnType<typeof useMyNotificationServicePreferencesSuspenseQuery>;
export type MyNotificationServicePreferencesQueryResult = Apollo.QueryResult<MyNotificationServicePreferencesQuery, MyNotificationServicePreferencesQueryVariables>;
export const MyRoomServiceCategoryPreferencesDocument = gql`
    query myRoomServiceCategoryPreferences {
  notificationRoomServiceCategoryPreferences {
    roomServiceCategoryId
    userId
  }
}
    `;

/**
 * __useMyRoomServiceCategoryPreferencesQuery__
 *
 * To run a query within a React component, call `useMyRoomServiceCategoryPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyRoomServiceCategoryPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyRoomServiceCategoryPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyRoomServiceCategoryPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<MyRoomServiceCategoryPreferencesQuery, MyRoomServiceCategoryPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyRoomServiceCategoryPreferencesQuery, MyRoomServiceCategoryPreferencesQueryVariables>(MyRoomServiceCategoryPreferencesDocument, options);
      }
export function useMyRoomServiceCategoryPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyRoomServiceCategoryPreferencesQuery, MyRoomServiceCategoryPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyRoomServiceCategoryPreferencesQuery, MyRoomServiceCategoryPreferencesQueryVariables>(MyRoomServiceCategoryPreferencesDocument, options);
        }
export function useMyRoomServiceCategoryPreferencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyRoomServiceCategoryPreferencesQuery, MyRoomServiceCategoryPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyRoomServiceCategoryPreferencesQuery, MyRoomServiceCategoryPreferencesQueryVariables>(MyRoomServiceCategoryPreferencesDocument, options);
        }
export type MyRoomServiceCategoryPreferencesQueryHookResult = ReturnType<typeof useMyRoomServiceCategoryPreferencesQuery>;
export type MyRoomServiceCategoryPreferencesLazyQueryHookResult = ReturnType<typeof useMyRoomServiceCategoryPreferencesLazyQuery>;
export type MyRoomServiceCategoryPreferencesSuspenseQueryHookResult = ReturnType<typeof useMyRoomServiceCategoryPreferencesSuspenseQuery>;
export type MyRoomServiceCategoryPreferencesQueryResult = Apollo.QueryResult<MyRoomServiceCategoryPreferencesQuery, MyRoomServiceCategoryPreferencesQueryVariables>;
export const UnreadNotificationMessagesListDocument = gql`
    query unreadNotificationMessagesList($where: notificationMessages_bool_exp!) {
  notificationMessages(where: $where, order_by: {createdAt: desc}, limit: 10) {
    id
    createdAt
    notificationId
    readAt
    sentAt
    notification {
      id
      createdAt
      userId
      eventId
      event {
        name
      }
      readAt
      notificationAction
      user {
        id
        firstName
        lastName
        organisationId
      }
      serviceId
      service {
        name
      }
      serviceModuleId
      serviceModule {
        name
        moduleType
      }
      eventAttributeValueId
      authorUserId
      attributeValueId
      attributeValueCommentId
      roomAttributeValueId
      uploadCommentId
      attributeValueComment {
        attributeValueId
      }
      uploadComment {
        organisationId
        uploadId
      }
      roomAttributeValueCommentId
      roomAttributeValueComment {
        id
        organisationId
        roomAttributeValueId
      }
      fileId
      roomAttributeValue {
        roomAttribute {
          name
          description
        }
      }
      roomServiceOccurrence {
        id
        name
        startDate
      }
      roomService {
        id
        name
      }
      room {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useUnreadNotificationMessagesListQuery__
 *
 * To run a query within a React component, call `useUnreadNotificationMessagesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadNotificationMessagesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadNotificationMessagesListQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUnreadNotificationMessagesListQuery(baseOptions: Apollo.QueryHookOptions<UnreadNotificationMessagesListQuery, UnreadNotificationMessagesListQueryVariables> & ({ variables: UnreadNotificationMessagesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnreadNotificationMessagesListQuery, UnreadNotificationMessagesListQueryVariables>(UnreadNotificationMessagesListDocument, options);
      }
export function useUnreadNotificationMessagesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnreadNotificationMessagesListQuery, UnreadNotificationMessagesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnreadNotificationMessagesListQuery, UnreadNotificationMessagesListQueryVariables>(UnreadNotificationMessagesListDocument, options);
        }
export function useUnreadNotificationMessagesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnreadNotificationMessagesListQuery, UnreadNotificationMessagesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnreadNotificationMessagesListQuery, UnreadNotificationMessagesListQueryVariables>(UnreadNotificationMessagesListDocument, options);
        }
export type UnreadNotificationMessagesListQueryHookResult = ReturnType<typeof useUnreadNotificationMessagesListQuery>;
export type UnreadNotificationMessagesListLazyQueryHookResult = ReturnType<typeof useUnreadNotificationMessagesListLazyQuery>;
export type UnreadNotificationMessagesListSuspenseQueryHookResult = ReturnType<typeof useUnreadNotificationMessagesListSuspenseQuery>;
export type UnreadNotificationMessagesListQueryResult = Apollo.QueryResult<UnreadNotificationMessagesListQuery, UnreadNotificationMessagesListQueryVariables>;
export const GetNotificationMessageByIdDocument = gql`
    query getNotificationMessageById($id: bigint!) {
  notificationMessages_by_pk(id: $id) {
    id
    createdAt
    notificationId
    readAt
    sentAt
    notification {
      id
      createdAt
      userId
      eventId
      event {
        name
        guestOrganisationId
      }
      readAt
      notificationAction
      user {
        id
        firstName
        lastName
        organisationId
      }
      serviceId
      service {
        name
      }
      serviceModuleId
      serviceModule {
        name
        moduleType
      }
      eventAttributeValueId
      authorUserId
      attributeValueId
      attributeValueCommentId
      eventAttributeValue {
        eventAttribute {
          name
        }
      }
      roomAttributeValueId
      uploadCommentId
      attributeValueComment {
        attributeValueId
      }
      uploadComment {
        organisationId
        uploadId
      }
      roomAttributeValueCommentId
      roomAttributeValueComment {
        id
        organisationId
        roomAttributeValueId
      }
      fileId
      roomAttributeValue {
        roomAttribute {
          name
        }
      }
      roomServiceOccurrence {
        id
        name
        startDate
      }
      roomService {
        id
        name
      }
      room {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetNotificationMessageByIdQuery__
 *
 * To run a query within a React component, call `useGetNotificationMessageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationMessageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationMessageByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNotificationMessageByIdQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationMessageByIdQuery, GetNotificationMessageByIdQueryVariables> & ({ variables: GetNotificationMessageByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationMessageByIdQuery, GetNotificationMessageByIdQueryVariables>(GetNotificationMessageByIdDocument, options);
      }
export function useGetNotificationMessageByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationMessageByIdQuery, GetNotificationMessageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationMessageByIdQuery, GetNotificationMessageByIdQueryVariables>(GetNotificationMessageByIdDocument, options);
        }
export function useGetNotificationMessageByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationMessageByIdQuery, GetNotificationMessageByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationMessageByIdQuery, GetNotificationMessageByIdQueryVariables>(GetNotificationMessageByIdDocument, options);
        }
export type GetNotificationMessageByIdQueryHookResult = ReturnType<typeof useGetNotificationMessageByIdQuery>;
export type GetNotificationMessageByIdLazyQueryHookResult = ReturnType<typeof useGetNotificationMessageByIdLazyQuery>;
export type GetNotificationMessageByIdSuspenseQueryHookResult = ReturnType<typeof useGetNotificationMessageByIdSuspenseQuery>;
export type GetNotificationMessageByIdQueryResult = Apollo.QueryResult<GetNotificationMessageByIdQuery, GetNotificationMessageByIdQueryVariables>;
export const QueryNotificationMessagesListDocument = gql`
    query queryNotificationMessagesList($notificationChannel: notificationChannels_enum!, $notificationActionsFilter: notificationActions_enum_comparison_exp, $limit: Int, $skip: Int) {
  allNotificationMessagesAggregate: notificationMessages_aggregate(
    where: {_and: [{notificationChannel: {_eq: $notificationChannel}}, {notification: {notificationAction: $notificationActionsFilter}}, {notification: {newerNotificationId: {_is_null: true}}}]}
  ) {
    aggregate {
      count
    }
  }
  unreadNotificationMessagesAggregate: notificationMessages_aggregate(
    where: {_and: [{notificationChannel: {_eq: $notificationChannel}}, {notification: {notificationAction: $notificationActionsFilter}}, {notification: {newerNotificationId: {_is_null: true}}}, {readAt: {_is_null: true}}]}
  ) {
    aggregate {
      count
    }
  }
  notificationMessages(
    where: {_and: [{notificationChannel: {_eq: $notificationChannel}}, {notification: {notificationAction: $notificationActionsFilter}}, {notification: {newerNotificationId: {_is_null: true}}}]}
    order_by: {createdAt: desc}
    limit: $limit
    offset: $skip
  ) {
    id
    createdAt
    notificationId
    readAt
    sentAt
    notification {
      id
      createdAt
      userId
      eventId
      event {
        name
        guestOrganisationId
      }
      readAt
      newerNotificationId
      notificationAction
      user {
        id
        firstName
        lastName
        organisationId
      }
      serviceId
      service {
        name
      }
      serviceModuleId
      serviceModule {
        name
        moduleType
      }
      eventAttributeValueId
      eventAttributeValue {
        eventAttribute {
          name
        }
      }
      authorUserId
      attributeValueId
      attributeValueCommentId
      roomAttributeValueId
      uploadCommentId
      attributeValueComment {
        organisationId
        attributeValueId
      }
      uploadComment {
        organisationId
        uploadId
      }
      roomAttributeValueCommentId
      roomAttributeValueComment {
        id
        organisationId
        roomAttributeValueId
      }
      fileId
      roomAttributeValue {
        roomAttribute {
          name
          description
        }
      }
      roomServiceOccurrence {
        id
        name
        startDate
      }
      roomService {
        id
        name
      }
      room {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useQueryNotificationMessagesListQuery__
 *
 * To run a query within a React component, call `useQueryNotificationMessagesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryNotificationMessagesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryNotificationMessagesListQuery({
 *   variables: {
 *      notificationChannel: // value for 'notificationChannel'
 *      notificationActionsFilter: // value for 'notificationActionsFilter'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useQueryNotificationMessagesListQuery(baseOptions: Apollo.QueryHookOptions<QueryNotificationMessagesListQuery, QueryNotificationMessagesListQueryVariables> & ({ variables: QueryNotificationMessagesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryNotificationMessagesListQuery, QueryNotificationMessagesListQueryVariables>(QueryNotificationMessagesListDocument, options);
      }
export function useQueryNotificationMessagesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryNotificationMessagesListQuery, QueryNotificationMessagesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryNotificationMessagesListQuery, QueryNotificationMessagesListQueryVariables>(QueryNotificationMessagesListDocument, options);
        }
export function useQueryNotificationMessagesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryNotificationMessagesListQuery, QueryNotificationMessagesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryNotificationMessagesListQuery, QueryNotificationMessagesListQueryVariables>(QueryNotificationMessagesListDocument, options);
        }
export type QueryNotificationMessagesListQueryHookResult = ReturnType<typeof useQueryNotificationMessagesListQuery>;
export type QueryNotificationMessagesListLazyQueryHookResult = ReturnType<typeof useQueryNotificationMessagesListLazyQuery>;
export type QueryNotificationMessagesListSuspenseQueryHookResult = ReturnType<typeof useQueryNotificationMessagesListSuspenseQuery>;
export type QueryNotificationMessagesListQueryResult = Apollo.QueryResult<QueryNotificationMessagesListQuery, QueryNotificationMessagesListQueryVariables>;
export const QueryCommentNotificationMessagesListDocument = gql`
    query queryCommentNotificationMessagesList($notificationChannel: notificationChannels_enum!, $limit: Int, $skip: Int) {
  allCommentNtificationsAggregat: notificationMessages_aggregate(
    where: {_and: [{notificationChannel: {_eq: $notificationChannel}}, {notification: {notificationAction: {_in: [comment, commentAuthoredReply, commentMentionGroup, commentMentionOrganisation, commentMentionUser]}}}]}
  ) {
    aggregate {
      count
    }
  }
  unreadCommentNtificationsAggregate: notificationMessages_aggregate(
    where: {_and: [{notificationChannel: {_eq: $notificationChannel}}, {notification: {notificationAction: {_in: [comment, commentAuthoredReply, commentMentionGroup, commentMentionOrganisation, commentMentionUser]}}}, {readAt: {_is_null: true}}]}
  ) {
    aggregate {
      count
    }
  }
  notificationMessages(
    where: {_and: [{notificationChannel: {_eq: $notificationChannel}}, {notification: {notificationAction: {_in: [comment, commentAuthoredReply, commentMentionGroup, commentMentionOrganisation, commentMentionUser]}}}]}
    order_by: {createdAt: desc}
    limit: $limit
    offset: $skip
  ) {
    id
    createdAt
    notificationId
    readAt
    sentAt
    notification {
      id
      createdAt
      userId
      eventId
      event {
        name
        guestOrganisationId
      }
      readAt
      notificationAction
      user {
        id
        firstName
        lastName
        organisationId
      }
      serviceId
      service {
        name
      }
      serviceModuleId
      serviceModule {
        name
        moduleType
      }
      eventAttributeValueId
      eventAttributeValue {
        eventAttribute {
          name
        }
      }
      authorUserId
      attributeValueId
      attributeValueCommentId
      roomAttributeValueId
      uploadCommentId
      attributeValueComment {
        organisationId
        attributeValueId
      }
      uploadComment {
        organisationId
        uploadId
      }
      roomAttributeValueCommentId
      roomAttributeValueComment {
        id
        organisationId
        roomAttributeValueId
      }
      fileId
      roomAttributeValue {
        roomAttribute {
          name
          description
        }
      }
      roomServiceOccurrence {
        id
        name
        startDate
      }
      roomService {
        id
        name
      }
      room {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useQueryCommentNotificationMessagesListQuery__
 *
 * To run a query within a React component, call `useQueryCommentNotificationMessagesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryCommentNotificationMessagesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryCommentNotificationMessagesListQuery({
 *   variables: {
 *      notificationChannel: // value for 'notificationChannel'
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useQueryCommentNotificationMessagesListQuery(baseOptions: Apollo.QueryHookOptions<QueryCommentNotificationMessagesListQuery, QueryCommentNotificationMessagesListQueryVariables> & ({ variables: QueryCommentNotificationMessagesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryCommentNotificationMessagesListQuery, QueryCommentNotificationMessagesListQueryVariables>(QueryCommentNotificationMessagesListDocument, options);
      }
export function useQueryCommentNotificationMessagesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryCommentNotificationMessagesListQuery, QueryCommentNotificationMessagesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryCommentNotificationMessagesListQuery, QueryCommentNotificationMessagesListQueryVariables>(QueryCommentNotificationMessagesListDocument, options);
        }
export function useQueryCommentNotificationMessagesListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryCommentNotificationMessagesListQuery, QueryCommentNotificationMessagesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryCommentNotificationMessagesListQuery, QueryCommentNotificationMessagesListQueryVariables>(QueryCommentNotificationMessagesListDocument, options);
        }
export type QueryCommentNotificationMessagesListQueryHookResult = ReturnType<typeof useQueryCommentNotificationMessagesListQuery>;
export type QueryCommentNotificationMessagesListLazyQueryHookResult = ReturnType<typeof useQueryCommentNotificationMessagesListLazyQuery>;
export type QueryCommentNotificationMessagesListSuspenseQueryHookResult = ReturnType<typeof useQueryCommentNotificationMessagesListSuspenseQuery>;
export type QueryCommentNotificationMessagesListQueryResult = Apollo.QueryResult<QueryCommentNotificationMessagesListQuery, QueryCommentNotificationMessagesListQueryVariables>;
export const UnreadNotificationMessagesCountDocument = gql`
    subscription unreadNotificationMessagesCount($notificationChannel: notificationChannels_enum!, $notificationActionsFilter: notificationActions_enum_comparison_exp) {
  notificationMessages_aggregate(
    where: {_and: [{notificationChannel: {_eq: $notificationChannel}}, {notification: {notificationAction: $notificationActionsFilter}}, {notification: {newerNotificationId: {_is_null: true}}}, {readAt: {_is_null: true}}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useUnreadNotificationMessagesCountSubscription__
 *
 * To run a query within a React component, call `useUnreadNotificationMessagesCountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUnreadNotificationMessagesCountSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadNotificationMessagesCountSubscription({
 *   variables: {
 *      notificationChannel: // value for 'notificationChannel'
 *      notificationActionsFilter: // value for 'notificationActionsFilter'
 *   },
 * });
 */
export function useUnreadNotificationMessagesCountSubscription(baseOptions: Apollo.SubscriptionHookOptions<UnreadNotificationMessagesCountSubscription, UnreadNotificationMessagesCountSubscriptionVariables> & ({ variables: UnreadNotificationMessagesCountSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UnreadNotificationMessagesCountSubscription, UnreadNotificationMessagesCountSubscriptionVariables>(UnreadNotificationMessagesCountDocument, options);
      }
export type UnreadNotificationMessagesCountSubscriptionHookResult = ReturnType<typeof useUnreadNotificationMessagesCountSubscription>;
export type UnreadNotificationMessagesCountSubscriptionResult = Apollo.SubscriptionResult<UnreadNotificationMessagesCountSubscription>;
export const UnreadWebNotificationsCountDocument = gql`
    subscription unreadWebNotificationsCount($notificationChannel: notificationChannels_enum!) {
  notificationMessages_aggregate(
    where: {_and: [{notificationChannel: {_eq: $notificationChannel}}, {notification: {newerNotificationId: {_is_null: true}}}, {readAt: {_is_null: true}}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useUnreadWebNotificationsCountSubscription__
 *
 * To run a query within a React component, call `useUnreadWebNotificationsCountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUnreadWebNotificationsCountSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadWebNotificationsCountSubscription({
 *   variables: {
 *      notificationChannel: // value for 'notificationChannel'
 *   },
 * });
 */
export function useUnreadWebNotificationsCountSubscription(baseOptions: Apollo.SubscriptionHookOptions<UnreadWebNotificationsCountSubscription, UnreadWebNotificationsCountSubscriptionVariables> & ({ variables: UnreadWebNotificationsCountSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UnreadWebNotificationsCountSubscription, UnreadWebNotificationsCountSubscriptionVariables>(UnreadWebNotificationsCountDocument, options);
      }
export type UnreadWebNotificationsCountSubscriptionHookResult = ReturnType<typeof useUnreadWebNotificationsCountSubscription>;
export type UnreadWebNotificationsCountSubscriptionResult = Apollo.SubscriptionResult<UnreadWebNotificationsCountSubscription>;
export const UnreadCommentNotificationMessagesCountDocument = gql`
    subscription unreadCommentNotificationMessagesCount($notificationChannel: notificationChannels_enum!) {
  notificationMessages_aggregate(
    where: {_and: [{notificationChannel: {_eq: $notificationChannel}}, {notification: {notificationAction: {_in: [comment, commentAuthoredReply, commentMentionGroup, commentMentionOrganisation, commentMentionUser]}}}, {readAt: {_is_null: true}}]}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useUnreadCommentNotificationMessagesCountSubscription__
 *
 * To run a query within a React component, call `useUnreadCommentNotificationMessagesCountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUnreadCommentNotificationMessagesCountSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadCommentNotificationMessagesCountSubscription({
 *   variables: {
 *      notificationChannel: // value for 'notificationChannel'
 *   },
 * });
 */
export function useUnreadCommentNotificationMessagesCountSubscription(baseOptions: Apollo.SubscriptionHookOptions<UnreadCommentNotificationMessagesCountSubscription, UnreadCommentNotificationMessagesCountSubscriptionVariables> & ({ variables: UnreadCommentNotificationMessagesCountSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UnreadCommentNotificationMessagesCountSubscription, UnreadCommentNotificationMessagesCountSubscriptionVariables>(UnreadCommentNotificationMessagesCountDocument, options);
      }
export type UnreadCommentNotificationMessagesCountSubscriptionHookResult = ReturnType<typeof useUnreadCommentNotificationMessagesCountSubscription>;
export type UnreadCommentNotificationMessagesCountSubscriptionResult = Apollo.SubscriptionResult<UnreadCommentNotificationMessagesCountSubscription>;
export const NotificationsListDocument = gql`
    subscription notificationsList($where: notifications_bool_exp) {
  notifications(where: $where, order_by: {createdAt: desc}) {
    id
    createdAt
    userId
    eventId
    event {
      name
    }
    serviceId
    attributeValueCommentId
    roomAttributeValueId
    uploadCommentId
    readAt
    notificationMessages {
      id
    }
    notificationAction
    user {
      id
      firstName
      lastName
      organisationId
    }
    service {
      name
    }
    serviceModuleId
    eventAttributeValueId
    eventAttributeValue {
      eventAttribute {
        name
      }
    }
    authorUserId
    attributeValueId
    attributeValueCommentId
    roomAttributeValueId
    uploadCommentId
    fileId
    roomServiceOccurrenceId
  }
}
    `;

/**
 * __useNotificationsListSubscription__
 *
 * To run a query within a React component, call `useNotificationsListSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsListSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsListSubscription({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useNotificationsListSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NotificationsListSubscription, NotificationsListSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NotificationsListSubscription, NotificationsListSubscriptionVariables>(NotificationsListDocument, options);
      }
export type NotificationsListSubscriptionHookResult = ReturnType<typeof useNotificationsListSubscription>;
export type NotificationsListSubscriptionResult = Apollo.SubscriptionResult<NotificationsListSubscription>;
export const MarkNotificationsAsReadDocument = gql`
    mutation markNotificationsAsRead($notificationMessageIds: [bigint!]!, $read: timestamptz) {
  update_notificationMessages(
    where: {id: {_in: $notificationMessageIds}}
    _set: {readAt: $read}
  ) {
    returning {
      id
      readAt
    }
  }
}
    `;
export type MarkNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;

/**
 * __useMarkNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsAsReadMutation, { data, loading, error }] = useMarkNotificationsAsReadMutation({
 *   variables: {
 *      notificationMessageIds: // value for 'notificationMessageIds'
 *      read: // value for 'read'
 *   },
 * });
 */
export function useMarkNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>(MarkNotificationsAsReadDocument, options);
      }
export type MarkNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkNotificationsAsReadMutation>;
export type MarkNotificationsAsReadMutationResult = Apollo.MutationResult<MarkNotificationsAsReadMutation>;
export type MarkNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;
export const MarkAllNotificationsAsReadDocument = gql`
    mutation markAllNotificationsAsRead($notificationActionsFilter: notificationActions_enum_comparison_exp, $notificationChannelsFilter: notificationChannels_enum_comparison_exp) {
  update_notificationMessages(
    where: {_and: [{readAt: {_is_null: true}}, {notification: {notificationAction: $notificationActionsFilter}}, {notificationChannel: $notificationChannelsFilter}]}
    _set: {readAt: "now"}
  ) {
    returning {
      id
      readAt
    }
  }
}
    `;
export type MarkAllNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;

/**
 * __useMarkAllNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsAsReadMutation, { data, loading, error }] = useMarkAllNotificationsAsReadMutation({
 *   variables: {
 *      notificationActionsFilter: // value for 'notificationActionsFilter'
 *      notificationChannelsFilter: // value for 'notificationChannelsFilter'
 *   },
 * });
 */
export function useMarkAllNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>(MarkAllNotificationsAsReadDocument, options);
      }
export type MarkAllNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationResult = Apollo.MutationResult<MarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;
export const GetJaggaerSubmissionByFileDocument = gql`
    query getJaggaerSubmissionByFile($fileId: bigint!, $uploadVersionId: bigint!) {
  jaggaerSubmissions(
    where: {_and: [{fileId: {_eq: $fileId}}, {uploadVersionId: {_eq: $uploadVersionId}}]}
  ) {
    id
    data
    fileId
    uploadVersionId
    uploadVersion {
      id
      downloadUrl
      file {
        id
        createdAt
        name
        extension
        mimeType
        user {
          id
          firstName
          lastName
        }
      }
      upload {
        id
        name
        serviceModule {
          service {
            event {
              id
              name
            }
          }
        }
      }
    }
    jaggaerBanf {
      jaggaerBanf
    }
    user {
      id
      firstName
      lastName
      organisation {
        id
        name
      }
    }
    userId
    lastAttachmentResponse
    nextTryAfter
    updatedAt
    createdAt
  }
}
    `;

/**
 * __useGetJaggaerSubmissionByFileQuery__
 *
 * To run a query within a React component, call `useGetJaggaerSubmissionByFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJaggaerSubmissionByFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJaggaerSubmissionByFileQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      uploadVersionId: // value for 'uploadVersionId'
 *   },
 * });
 */
export function useGetJaggaerSubmissionByFileQuery(baseOptions: Apollo.QueryHookOptions<GetJaggaerSubmissionByFileQuery, GetJaggaerSubmissionByFileQueryVariables> & ({ variables: GetJaggaerSubmissionByFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJaggaerSubmissionByFileQuery, GetJaggaerSubmissionByFileQueryVariables>(GetJaggaerSubmissionByFileDocument, options);
      }
export function useGetJaggaerSubmissionByFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJaggaerSubmissionByFileQuery, GetJaggaerSubmissionByFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJaggaerSubmissionByFileQuery, GetJaggaerSubmissionByFileQueryVariables>(GetJaggaerSubmissionByFileDocument, options);
        }
export function useGetJaggaerSubmissionByFileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJaggaerSubmissionByFileQuery, GetJaggaerSubmissionByFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJaggaerSubmissionByFileQuery, GetJaggaerSubmissionByFileQueryVariables>(GetJaggaerSubmissionByFileDocument, options);
        }
export type GetJaggaerSubmissionByFileQueryHookResult = ReturnType<typeof useGetJaggaerSubmissionByFileQuery>;
export type GetJaggaerSubmissionByFileLazyQueryHookResult = ReturnType<typeof useGetJaggaerSubmissionByFileLazyQuery>;
export type GetJaggaerSubmissionByFileSuspenseQueryHookResult = ReturnType<typeof useGetJaggaerSubmissionByFileSuspenseQuery>;
export type GetJaggaerSubmissionByFileQueryResult = Apollo.QueryResult<GetJaggaerSubmissionByFileQuery, GetJaggaerSubmissionByFileQueryVariables>;
export const GetJaggaerSubmissionsByFileIdListDocument = gql`
    query getJaggaerSubmissionsByFileIdList($fileIds: [bigint!]!) {
  jaggaerSubmissions(
    where: {fileId: {_in: $fileIds}}
    order_by: {createdAt: desc}
  ) {
    id
    fileId
    uploadVersionId
    jaggaerArticleId
    lastAttachmentResponse
    nextTryAfter
    updatedAt
    createdAt
  }
}
    `;

/**
 * __useGetJaggaerSubmissionsByFileIdListQuery__
 *
 * To run a query within a React component, call `useGetJaggaerSubmissionsByFileIdListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJaggaerSubmissionsByFileIdListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJaggaerSubmissionsByFileIdListQuery({
 *   variables: {
 *      fileIds: // value for 'fileIds'
 *   },
 * });
 */
export function useGetJaggaerSubmissionsByFileIdListQuery(baseOptions: Apollo.QueryHookOptions<GetJaggaerSubmissionsByFileIdListQuery, GetJaggaerSubmissionsByFileIdListQueryVariables> & ({ variables: GetJaggaerSubmissionsByFileIdListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJaggaerSubmissionsByFileIdListQuery, GetJaggaerSubmissionsByFileIdListQueryVariables>(GetJaggaerSubmissionsByFileIdListDocument, options);
      }
export function useGetJaggaerSubmissionsByFileIdListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJaggaerSubmissionsByFileIdListQuery, GetJaggaerSubmissionsByFileIdListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJaggaerSubmissionsByFileIdListQuery, GetJaggaerSubmissionsByFileIdListQueryVariables>(GetJaggaerSubmissionsByFileIdListDocument, options);
        }
export function useGetJaggaerSubmissionsByFileIdListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetJaggaerSubmissionsByFileIdListQuery, GetJaggaerSubmissionsByFileIdListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJaggaerSubmissionsByFileIdListQuery, GetJaggaerSubmissionsByFileIdListQueryVariables>(GetJaggaerSubmissionsByFileIdListDocument, options);
        }
export type GetJaggaerSubmissionsByFileIdListQueryHookResult = ReturnType<typeof useGetJaggaerSubmissionsByFileIdListQuery>;
export type GetJaggaerSubmissionsByFileIdListLazyQueryHookResult = ReturnType<typeof useGetJaggaerSubmissionsByFileIdListLazyQuery>;
export type GetJaggaerSubmissionsByFileIdListSuspenseQueryHookResult = ReturnType<typeof useGetJaggaerSubmissionsByFileIdListSuspenseQuery>;
export type GetJaggaerSubmissionsByFileIdListQueryResult = Apollo.QueryResult<GetJaggaerSubmissionsByFileIdListQuery, GetJaggaerSubmissionsByFileIdListQueryVariables>;
export const SubmitJaggaerOrderDocument = gql`
    mutation submitJaggaerOrder($uploadVersionId: bigint!, $fileId: bigint!, $data: json!) {
  insert_jaggaerSubmissions_one(
    object: {data: $data, uploadVersionId: $uploadVersionId, fileId: $fileId}
  ) {
    id
    data
    fileId
    uploadVersionId
    uploadVersion {
      id
      downloadUrl
      file {
        id
        createdAt
        name
        extension
        mimeType
        user {
          id
          firstName
          lastName
        }
      }
      upload {
        id
        name
        serviceModule {
          service {
            event {
              id
              name
            }
          }
        }
      }
    }
    userId
    jaggaerArticleId
    lastAttachmentRequestAt
    lastAttachmentResponse
    lastMonitoringRequestAt
    lastMonitoringResponse
    lastQueueRequestAt
    lastQueueResponse
    lastUploadRequestAt
    lastUploadResponse
    nextTryAfter
    numAttachmentRequests
    numMonitoringRequests
    numQueueRequests
    numUploadRequests
    updatedAt
    createdAt
    data
  }
}
    `;
export type SubmitJaggaerOrderMutationFn = Apollo.MutationFunction<SubmitJaggaerOrderMutation, SubmitJaggaerOrderMutationVariables>;

/**
 * __useSubmitJaggaerOrderMutation__
 *
 * To run a mutation, you first call `useSubmitJaggaerOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitJaggaerOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitJaggaerOrderMutation, { data, loading, error }] = useSubmitJaggaerOrderMutation({
 *   variables: {
 *      uploadVersionId: // value for 'uploadVersionId'
 *      fileId: // value for 'fileId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSubmitJaggaerOrderMutation(baseOptions?: Apollo.MutationHookOptions<SubmitJaggaerOrderMutation, SubmitJaggaerOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitJaggaerOrderMutation, SubmitJaggaerOrderMutationVariables>(SubmitJaggaerOrderDocument, options);
      }
export type SubmitJaggaerOrderMutationHookResult = ReturnType<typeof useSubmitJaggaerOrderMutation>;
export type SubmitJaggaerOrderMutationResult = Apollo.MutationResult<SubmitJaggaerOrderMutation>;
export type SubmitJaggaerOrderMutationOptions = Apollo.BaseMutationOptions<SubmitJaggaerOrderMutation, SubmitJaggaerOrderMutationVariables>;
export const AddOrganisationGroupsDocument = gql`
    mutation addOrganisationGroups($objects: [organisationGroups_insert_input!]!) {
  insert_organisationGroups(objects: $objects) {
    affected_rows
  }
}
    `;
export type AddOrganisationGroupsMutationFn = Apollo.MutationFunction<AddOrganisationGroupsMutation, AddOrganisationGroupsMutationVariables>;

/**
 * __useAddOrganisationGroupsMutation__
 *
 * To run a mutation, you first call `useAddOrganisationGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganisationGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganisationGroupsMutation, { data, loading, error }] = useAddOrganisationGroupsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddOrganisationGroupsMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganisationGroupsMutation, AddOrganisationGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrganisationGroupsMutation, AddOrganisationGroupsMutationVariables>(AddOrganisationGroupsDocument, options);
      }
export type AddOrganisationGroupsMutationHookResult = ReturnType<typeof useAddOrganisationGroupsMutation>;
export type AddOrganisationGroupsMutationResult = Apollo.MutationResult<AddOrganisationGroupsMutation>;
export type AddOrganisationGroupsMutationOptions = Apollo.BaseMutationOptions<AddOrganisationGroupsMutation, AddOrganisationGroupsMutationVariables>;
export const OrganisationGroupByIdDocument = gql`
    query organisationGroupById($id: bigint!) {
  organisations_by_pk(id: $id) {
    id
    createdAt
    updatedAt
    name
    users {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useOrganisationGroupByIdQuery__
 *
 * To run a query within a React component, call `useOrganisationGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationGroupByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganisationGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<OrganisationGroupByIdQuery, OrganisationGroupByIdQueryVariables> & ({ variables: OrganisationGroupByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationGroupByIdQuery, OrganisationGroupByIdQueryVariables>(OrganisationGroupByIdDocument, options);
      }
export function useOrganisationGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationGroupByIdQuery, OrganisationGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationGroupByIdQuery, OrganisationGroupByIdQueryVariables>(OrganisationGroupByIdDocument, options);
        }
export function useOrganisationGroupByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganisationGroupByIdQuery, OrganisationGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationGroupByIdQuery, OrganisationGroupByIdQueryVariables>(OrganisationGroupByIdDocument, options);
        }
export type OrganisationGroupByIdQueryHookResult = ReturnType<typeof useOrganisationGroupByIdQuery>;
export type OrganisationGroupByIdLazyQueryHookResult = ReturnType<typeof useOrganisationGroupByIdLazyQuery>;
export type OrganisationGroupByIdSuspenseQueryHookResult = ReturnType<typeof useOrganisationGroupByIdSuspenseQuery>;
export type OrganisationGroupByIdQueryResult = Apollo.QueryResult<OrganisationGroupByIdQuery, OrganisationGroupByIdQueryVariables>;
export const OrganisationGroupsListDocument = gql`
    query organisationGroupsList($where: organisationGroups_bool_exp) {
  organisationGroups(where: $where) {
    id
    name
  }
}
    `;

/**
 * __useOrganisationGroupsListQuery__
 *
 * To run a query within a React component, call `useOrganisationGroupsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationGroupsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationGroupsListQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrganisationGroupsListQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationGroupsListQuery, OrganisationGroupsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationGroupsListQuery, OrganisationGroupsListQueryVariables>(OrganisationGroupsListDocument, options);
      }
export function useOrganisationGroupsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationGroupsListQuery, OrganisationGroupsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationGroupsListQuery, OrganisationGroupsListQueryVariables>(OrganisationGroupsListDocument, options);
        }
export function useOrganisationGroupsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganisationGroupsListQuery, OrganisationGroupsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationGroupsListQuery, OrganisationGroupsListQueryVariables>(OrganisationGroupsListDocument, options);
        }
export type OrganisationGroupsListQueryHookResult = ReturnType<typeof useOrganisationGroupsListQuery>;
export type OrganisationGroupsListLazyQueryHookResult = ReturnType<typeof useOrganisationGroupsListLazyQuery>;
export type OrganisationGroupsListSuspenseQueryHookResult = ReturnType<typeof useOrganisationGroupsListSuspenseQuery>;
export type OrganisationGroupsListQueryResult = Apollo.QueryResult<OrganisationGroupsListQuery, OrganisationGroupsListQueryVariables>;
export const UpdateOrganisationGroupDocument = gql`
    mutation updateOrganisationGroup($id: bigint!, $object: organisationGroups_set_input!) {
  update_organisationGroups_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
  }
}
    `;
export type UpdateOrganisationGroupMutationFn = Apollo.MutationFunction<UpdateOrganisationGroupMutation, UpdateOrganisationGroupMutationVariables>;

/**
 * __useUpdateOrganisationGroupMutation__
 *
 * To run a mutation, you first call `useUpdateOrganisationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganisationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganisationGroupMutation, { data, loading, error }] = useUpdateOrganisationGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpdateOrganisationGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganisationGroupMutation, UpdateOrganisationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganisationGroupMutation, UpdateOrganisationGroupMutationVariables>(UpdateOrganisationGroupDocument, options);
      }
export type UpdateOrganisationGroupMutationHookResult = ReturnType<typeof useUpdateOrganisationGroupMutation>;
export type UpdateOrganisationGroupMutationResult = Apollo.MutationResult<UpdateOrganisationGroupMutation>;
export type UpdateOrganisationGroupMutationOptions = Apollo.BaseMutationOptions<UpdateOrganisationGroupMutation, UpdateOrganisationGroupMutationVariables>;
export const AddOrganisationDocument = gql`
    mutation addOrganisation($object: organisations_insert_input!) {
  insert_organisations_one(object: $object) {
    id
    createdAt
    updatedAt
    name
    isGuestOrga
    organisationGroups {
      organisationId
    }
  }
}
    `;
export type AddOrganisationMutationFn = Apollo.MutationFunction<AddOrganisationMutation, AddOrganisationMutationVariables>;

/**
 * __useAddOrganisationMutation__
 *
 * To run a mutation, you first call `useAddOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganisationMutation, { data, loading, error }] = useAddOrganisationMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAddOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganisationMutation, AddOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrganisationMutation, AddOrganisationMutationVariables>(AddOrganisationDocument, options);
      }
export type AddOrganisationMutationHookResult = ReturnType<typeof useAddOrganisationMutation>;
export type AddOrganisationMutationResult = Apollo.MutationResult<AddOrganisationMutation>;
export type AddOrganisationMutationOptions = Apollo.BaseMutationOptions<AddOrganisationMutation, AddOrganisationMutationVariables>;
export const DeleteOrganisationDocument = gql`
    mutation deleteOrganisation($id: bigint!) {
  delete_organisations_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteOrganisationMutationFn = Apollo.MutationFunction<DeleteOrganisationMutation, DeleteOrganisationMutationVariables>;

/**
 * __useDeleteOrganisationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganisationMutation, { data, loading, error }] = useDeleteOrganisationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganisationMutation, DeleteOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganisationMutation, DeleteOrganisationMutationVariables>(DeleteOrganisationDocument, options);
      }
export type DeleteOrganisationMutationHookResult = ReturnType<typeof useDeleteOrganisationMutation>;
export type DeleteOrganisationMutationResult = Apollo.MutationResult<DeleteOrganisationMutation>;
export type DeleteOrganisationMutationOptions = Apollo.BaseMutationOptions<DeleteOrganisationMutation, DeleteOrganisationMutationVariables>;
export const OrganisationByIdDocument = gql`
    query organisationById($id: bigint!) {
  organisations_by_pk(id: $id) {
    id
    createdAt
    updatedAt
    name
    isGuestOrga
    organisationGroups(order_by: {isAdmin: desc, isOrgaAdmin: desc}) {
      id
      name
      isAdmin
      isOrgaAdmin
      organisationGroupUsers {
        user {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `;

/**
 * __useOrganisationByIdQuery__
 *
 * To run a query within a React component, call `useOrganisationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganisationByIdQuery(baseOptions: Apollo.QueryHookOptions<OrganisationByIdQuery, OrganisationByIdQueryVariables> & ({ variables: OrganisationByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationByIdQuery, OrganisationByIdQueryVariables>(OrganisationByIdDocument, options);
      }
export function useOrganisationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationByIdQuery, OrganisationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationByIdQuery, OrganisationByIdQueryVariables>(OrganisationByIdDocument, options);
        }
export function useOrganisationByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganisationByIdQuery, OrganisationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationByIdQuery, OrganisationByIdQueryVariables>(OrganisationByIdDocument, options);
        }
export type OrganisationByIdQueryHookResult = ReturnType<typeof useOrganisationByIdQuery>;
export type OrganisationByIdLazyQueryHookResult = ReturnType<typeof useOrganisationByIdLazyQuery>;
export type OrganisationByIdSuspenseQueryHookResult = ReturnType<typeof useOrganisationByIdSuspenseQuery>;
export type OrganisationByIdQueryResult = Apollo.QueryResult<OrganisationByIdQuery, OrganisationByIdQueryVariables>;
export const OrganisationsListDocument = gql`
    query organisationsList($where: organisations_bool_exp) {
  organisations(where: $where, order_by: {name: asc}) {
    id
    name
    isGuestOrga
    organisationGroups {
      id
      name
    }
  }
}
    `;

/**
 * __useOrganisationsListQuery__
 *
 * To run a query within a React component, call `useOrganisationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationsListQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrganisationsListQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationsListQuery, OrganisationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationsListQuery, OrganisationsListQueryVariables>(OrganisationsListDocument, options);
      }
export function useOrganisationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationsListQuery, OrganisationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationsListQuery, OrganisationsListQueryVariables>(OrganisationsListDocument, options);
        }
export function useOrganisationsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganisationsListQuery, OrganisationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationsListQuery, OrganisationsListQueryVariables>(OrganisationsListDocument, options);
        }
export type OrganisationsListQueryHookResult = ReturnType<typeof useOrganisationsListQuery>;
export type OrganisationsListLazyQueryHookResult = ReturnType<typeof useOrganisationsListLazyQuery>;
export type OrganisationsListSuspenseQueryHookResult = ReturnType<typeof useOrganisationsListSuspenseQuery>;
export type OrganisationsListQueryResult = Apollo.QueryResult<OrganisationsListQuery, OrganisationsListQueryVariables>;
export const UpdateOrganisationDocument = gql`
    mutation updateOrganisation($id: bigint!, $object: organisations_set_input, $organisationGroups: [organisationGroups_insert_input!]!, $organisationGroupsDelete: [bigint!]) {
  delete_organisationGroups(where: {id: {_in: $organisationGroupsDelete}}) {
    affected_rows
  }
  insert_organisationGroups(
    objects: $organisationGroups
    on_conflict: {constraint: organisationGroups_pkey, update_columns: [name]}
  ) {
    affected_rows
  }
  update_organisations_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
    createdAt
    updatedAt
    name
    organisationGroups {
      id
      name
    }
  }
}
    `;
export type UpdateOrganisationMutationFn = Apollo.MutationFunction<UpdateOrganisationMutation, UpdateOrganisationMutationVariables>;

/**
 * __useUpdateOrganisationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganisationMutation, { data, loading, error }] = useUpdateOrganisationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      object: // value for 'object'
 *      organisationGroups: // value for 'organisationGroups'
 *      organisationGroupsDelete: // value for 'organisationGroupsDelete'
 *   },
 * });
 */
export function useUpdateOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganisationMutation, UpdateOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganisationMutation, UpdateOrganisationMutationVariables>(UpdateOrganisationDocument, options);
      }
export type UpdateOrganisationMutationHookResult = ReturnType<typeof useUpdateOrganisationMutation>;
export type UpdateOrganisationMutationResult = Apollo.MutationResult<UpdateOrganisationMutation>;
export type UpdateOrganisationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganisationMutation, UpdateOrganisationMutationVariables>;
export const AddServiceModulesAccessesDocument = gql`
    mutation addServiceModulesAccesses($objects: [serviceModuleAccesses_insert_input!]!) {
  insert_serviceModuleAccesses(objects: $objects) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export type AddServiceModulesAccessesMutationFn = Apollo.MutationFunction<AddServiceModulesAccessesMutation, AddServiceModulesAccessesMutationVariables>;

/**
 * __useAddServiceModulesAccessesMutation__
 *
 * To run a mutation, you first call `useAddServiceModulesAccessesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddServiceModulesAccessesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addServiceModulesAccessesMutation, { data, loading, error }] = useAddServiceModulesAccessesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddServiceModulesAccessesMutation(baseOptions?: Apollo.MutationHookOptions<AddServiceModulesAccessesMutation, AddServiceModulesAccessesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddServiceModulesAccessesMutation, AddServiceModulesAccessesMutationVariables>(AddServiceModulesAccessesDocument, options);
      }
export type AddServiceModulesAccessesMutationHookResult = ReturnType<typeof useAddServiceModulesAccessesMutation>;
export type AddServiceModulesAccessesMutationResult = Apollo.MutationResult<AddServiceModulesAccessesMutation>;
export type AddServiceModulesAccessesMutationOptions = Apollo.BaseMutationOptions<AddServiceModulesAccessesMutation, AddServiceModulesAccessesMutationVariables>;
export const DeleteServiceModuleAccessDocument = gql`
    mutation deleteServiceModuleAccess($id: bigint!) {
  delete_serviceModuleAccesses_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteServiceModuleAccessMutationFn = Apollo.MutationFunction<DeleteServiceModuleAccessMutation, DeleteServiceModuleAccessMutationVariables>;

/**
 * __useDeleteServiceModuleAccessMutation__
 *
 * To run a mutation, you first call `useDeleteServiceModuleAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceModuleAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceModuleAccessMutation, { data, loading, error }] = useDeleteServiceModuleAccessMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteServiceModuleAccessMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceModuleAccessMutation, DeleteServiceModuleAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceModuleAccessMutation, DeleteServiceModuleAccessMutationVariables>(DeleteServiceModuleAccessDocument, options);
      }
export type DeleteServiceModuleAccessMutationHookResult = ReturnType<typeof useDeleteServiceModuleAccessMutation>;
export type DeleteServiceModuleAccessMutationResult = Apollo.MutationResult<DeleteServiceModuleAccessMutation>;
export type DeleteServiceModuleAccessMutationOptions = Apollo.BaseMutationOptions<DeleteServiceModuleAccessMutation, DeleteServiceModuleAccessMutationVariables>;
export const ServiceModuleAccessesByModuleIdsDocument = gql`
    query serviceModuleAccessesByModuleIds($ids: [bigint!]!) {
  serviceModuleAccesses(where: {serviceModuleId: {_in: $ids}}) {
    id
    guestUsers
    organisationGroupId
    organisationId
    serviceModuleId
    writable
    updatedAt
  }
}
    `;

/**
 * __useServiceModuleAccessesByModuleIdsQuery__
 *
 * To run a query within a React component, call `useServiceModuleAccessesByModuleIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceModuleAccessesByModuleIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceModuleAccessesByModuleIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useServiceModuleAccessesByModuleIdsQuery(baseOptions: Apollo.QueryHookOptions<ServiceModuleAccessesByModuleIdsQuery, ServiceModuleAccessesByModuleIdsQueryVariables> & ({ variables: ServiceModuleAccessesByModuleIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceModuleAccessesByModuleIdsQuery, ServiceModuleAccessesByModuleIdsQueryVariables>(ServiceModuleAccessesByModuleIdsDocument, options);
      }
export function useServiceModuleAccessesByModuleIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceModuleAccessesByModuleIdsQuery, ServiceModuleAccessesByModuleIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceModuleAccessesByModuleIdsQuery, ServiceModuleAccessesByModuleIdsQueryVariables>(ServiceModuleAccessesByModuleIdsDocument, options);
        }
export function useServiceModuleAccessesByModuleIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceModuleAccessesByModuleIdsQuery, ServiceModuleAccessesByModuleIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceModuleAccessesByModuleIdsQuery, ServiceModuleAccessesByModuleIdsQueryVariables>(ServiceModuleAccessesByModuleIdsDocument, options);
        }
export type ServiceModuleAccessesByModuleIdsQueryHookResult = ReturnType<typeof useServiceModuleAccessesByModuleIdsQuery>;
export type ServiceModuleAccessesByModuleIdsLazyQueryHookResult = ReturnType<typeof useServiceModuleAccessesByModuleIdsLazyQuery>;
export type ServiceModuleAccessesByModuleIdsSuspenseQueryHookResult = ReturnType<typeof useServiceModuleAccessesByModuleIdsSuspenseQuery>;
export type ServiceModuleAccessesByModuleIdsQueryResult = Apollo.QueryResult<ServiceModuleAccessesByModuleIdsQuery, ServiceModuleAccessesByModuleIdsQueryVariables>;
export const UpdateServiceModuleAccessDocument = gql`
    mutation updateServiceModuleAccess($pk_columns: serviceModuleAccesses_pk_columns_input!, $_set: serviceModuleAccesses_set_input!) {
  update_serviceModuleAccesses_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
    serviceModuleId
    writable
  }
}
    `;
export type UpdateServiceModuleAccessMutationFn = Apollo.MutationFunction<UpdateServiceModuleAccessMutation, UpdateServiceModuleAccessMutationVariables>;

/**
 * __useUpdateServiceModuleAccessMutation__
 *
 * To run a mutation, you first call `useUpdateServiceModuleAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceModuleAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceModuleAccessMutation, { data, loading, error }] = useUpdateServiceModuleAccessMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateServiceModuleAccessMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceModuleAccessMutation, UpdateServiceModuleAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceModuleAccessMutation, UpdateServiceModuleAccessMutationVariables>(UpdateServiceModuleAccessDocument, options);
      }
export type UpdateServiceModuleAccessMutationHookResult = ReturnType<typeof useUpdateServiceModuleAccessMutation>;
export type UpdateServiceModuleAccessMutationResult = Apollo.MutationResult<UpdateServiceModuleAccessMutation>;
export type UpdateServiceModuleAccessMutationOptions = Apollo.BaseMutationOptions<UpdateServiceModuleAccessMutation, UpdateServiceModuleAccessMutationVariables>;
export const AddEventRoomWatchesDocument = gql`
    mutation addEventRoomWatches($object: eventRoomWatches_insert_input!) {
  insert_eventRoomWatches_one(
    object: $object
    on_conflict: {constraint: eventRoomWatches_pkey}
  ) {
    eventId
    userId
  }
}
    `;
export type AddEventRoomWatchesMutationFn = Apollo.MutationFunction<AddEventRoomWatchesMutation, AddEventRoomWatchesMutationVariables>;

/**
 * __useAddEventRoomWatchesMutation__
 *
 * To run a mutation, you first call `useAddEventRoomWatchesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEventRoomWatchesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEventRoomWatchesMutation, { data, loading, error }] = useAddEventRoomWatchesMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAddEventRoomWatchesMutation(baseOptions?: Apollo.MutationHookOptions<AddEventRoomWatchesMutation, AddEventRoomWatchesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEventRoomWatchesMutation, AddEventRoomWatchesMutationVariables>(AddEventRoomWatchesDocument, options);
      }
export type AddEventRoomWatchesMutationHookResult = ReturnType<typeof useAddEventRoomWatchesMutation>;
export type AddEventRoomWatchesMutationResult = Apollo.MutationResult<AddEventRoomWatchesMutation>;
export type AddEventRoomWatchesMutationOptions = Apollo.BaseMutationOptions<AddEventRoomWatchesMutation, AddEventRoomWatchesMutationVariables>;
export const CreateRoomFolderDocument = gql`
    mutation createRoomFolder($roomFolder: roomFolders_insert_input!) {
  insert_roomFolders_one(object: $roomFolder) {
    id
    name
    parentId
  }
}
    `;
export type CreateRoomFolderMutationFn = Apollo.MutationFunction<CreateRoomFolderMutation, CreateRoomFolderMutationVariables>;

/**
 * __useCreateRoomFolderMutation__
 *
 * To run a mutation, you first call `useCreateRoomFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoomFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoomFolderMutation, { data, loading, error }] = useCreateRoomFolderMutation({
 *   variables: {
 *      roomFolder: // value for 'roomFolder'
 *   },
 * });
 */
export function useCreateRoomFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoomFolderMutation, CreateRoomFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoomFolderMutation, CreateRoomFolderMutationVariables>(CreateRoomFolderDocument, options);
      }
export type CreateRoomFolderMutationHookResult = ReturnType<typeof useCreateRoomFolderMutation>;
export type CreateRoomFolderMutationResult = Apollo.MutationResult<CreateRoomFolderMutation>;
export type CreateRoomFolderMutationOptions = Apollo.BaseMutationOptions<CreateRoomFolderMutation, CreateRoomFolderMutationVariables>;
export const DeleteEventRoomWatchesDocument = gql`
    mutation deleteEventRoomWatches($eventId: bigint!, $userId: bigint!) {
  delete_eventRoomWatches_by_pk(eventId: $eventId, userId: $userId) {
    eventId
    userId
  }
}
    `;
export type DeleteEventRoomWatchesMutationFn = Apollo.MutationFunction<DeleteEventRoomWatchesMutation, DeleteEventRoomWatchesMutationVariables>;

/**
 * __useDeleteEventRoomWatchesMutation__
 *
 * To run a mutation, you first call `useDeleteEventRoomWatchesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventRoomWatchesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventRoomWatchesMutation, { data, loading, error }] = useDeleteEventRoomWatchesMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteEventRoomWatchesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventRoomWatchesMutation, DeleteEventRoomWatchesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventRoomWatchesMutation, DeleteEventRoomWatchesMutationVariables>(DeleteEventRoomWatchesDocument, options);
      }
export type DeleteEventRoomWatchesMutationHookResult = ReturnType<typeof useDeleteEventRoomWatchesMutation>;
export type DeleteEventRoomWatchesMutationResult = Apollo.MutationResult<DeleteEventRoomWatchesMutation>;
export type DeleteEventRoomWatchesMutationOptions = Apollo.BaseMutationOptions<DeleteEventRoomWatchesMutation, DeleteEventRoomWatchesMutationVariables>;
export const DeleteRoomFolderDocument = gql`
    mutation deleteRoomFolder($id: bigint!) {
  delete_roomFolders_by_pk(id: $id) {
    id
    name
    parentId
  }
}
    `;
export type DeleteRoomFolderMutationFn = Apollo.MutationFunction<DeleteRoomFolderMutation, DeleteRoomFolderMutationVariables>;

/**
 * __useDeleteRoomFolderMutation__
 *
 * To run a mutation, you first call `useDeleteRoomFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoomFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoomFolderMutation, { data, loading, error }] = useDeleteRoomFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRoomFolderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoomFolderMutation, DeleteRoomFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoomFolderMutation, DeleteRoomFolderMutationVariables>(DeleteRoomFolderDocument, options);
      }
export type DeleteRoomFolderMutationHookResult = ReturnType<typeof useDeleteRoomFolderMutation>;
export type DeleteRoomFolderMutationResult = Apollo.MutationResult<DeleteRoomFolderMutation>;
export type DeleteRoomFolderMutationOptions = Apollo.BaseMutationOptions<DeleteRoomFolderMutation, DeleteRoomFolderMutationVariables>;
export const DeleteRoomDocument = gql`
    mutation deleteRoom($roomId: bigint!) {
  delete_rooms_by_pk(id: $roomId) {
    id
  }
}
    `;
export type DeleteRoomMutationFn = Apollo.MutationFunction<DeleteRoomMutation, DeleteRoomMutationVariables>;

/**
 * __useDeleteRoomMutation__
 *
 * To run a mutation, you first call `useDeleteRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoomMutation, { data, loading, error }] = useDeleteRoomMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useDeleteRoomMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoomMutation, DeleteRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoomMutation, DeleteRoomMutationVariables>(DeleteRoomDocument, options);
      }
export type DeleteRoomMutationHookResult = ReturnType<typeof useDeleteRoomMutation>;
export type DeleteRoomMutationResult = Apollo.MutationResult<DeleteRoomMutation>;
export type DeleteRoomMutationOptions = Apollo.BaseMutationOptions<DeleteRoomMutation, DeleteRoomMutationVariables>;
export const AddRoomToEventDocument = gql`
    mutation addRoomToEvent($eventRoom: eventRooms_insert_input!) {
  insert_eventRooms_one(object: $eventRoom) {
    roomId
    eventId
  }
}
    `;
export type AddRoomToEventMutationFn = Apollo.MutationFunction<AddRoomToEventMutation, AddRoomToEventMutationVariables>;

/**
 * __useAddRoomToEventMutation__
 *
 * To run a mutation, you first call `useAddRoomToEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRoomToEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRoomToEventMutation, { data, loading, error }] = useAddRoomToEventMutation({
 *   variables: {
 *      eventRoom: // value for 'eventRoom'
 *   },
 * });
 */
export function useAddRoomToEventMutation(baseOptions?: Apollo.MutationHookOptions<AddRoomToEventMutation, AddRoomToEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRoomToEventMutation, AddRoomToEventMutationVariables>(AddRoomToEventDocument, options);
      }
export type AddRoomToEventMutationHookResult = ReturnType<typeof useAddRoomToEventMutation>;
export type AddRoomToEventMutationResult = Apollo.MutationResult<AddRoomToEventMutation>;
export type AddRoomToEventMutationOptions = Apollo.BaseMutationOptions<AddRoomToEventMutation, AddRoomToEventMutationVariables>;
export const RemoveRoomFromEventDocument = gql`
    mutation removeRoomFromEvent($eventId: bigint!, $roomId: bigint!) {
  delete_eventRooms_by_pk(eventId: $eventId, roomId: $roomId) {
    roomId
    eventId
  }
  delete_roomServiceOccurrences(
    where: {_and: [{eventId: {_eq: $eventId}}, {roomService: {roomId: {_eq: $roomId}}}]}
  ) {
    affected_rows
  }
}
    `;
export type RemoveRoomFromEventMutationFn = Apollo.MutationFunction<RemoveRoomFromEventMutation, RemoveRoomFromEventMutationVariables>;

/**
 * __useRemoveRoomFromEventMutation__
 *
 * To run a mutation, you first call `useRemoveRoomFromEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRoomFromEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRoomFromEventMutation, { data, loading, error }] = useRemoveRoomFromEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      roomId: // value for 'roomId'
 *   },
 * });
 */
export function useRemoveRoomFromEventMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRoomFromEventMutation, RemoveRoomFromEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRoomFromEventMutation, RemoveRoomFromEventMutationVariables>(RemoveRoomFromEventDocument, options);
      }
export type RemoveRoomFromEventMutationHookResult = ReturnType<typeof useRemoveRoomFromEventMutation>;
export type RemoveRoomFromEventMutationResult = Apollo.MutationResult<RemoveRoomFromEventMutation>;
export type RemoveRoomFromEventMutationOptions = Apollo.BaseMutationOptions<RemoveRoomFromEventMutation, RemoveRoomFromEventMutationVariables>;
export const UpdateEventRoomsDocument = gql`
    mutation updateEventRooms($eventRoomInserts: [eventRooms_insert_input!]!, $eventRoomDeletes: eventRooms_bool_exp!, $roomServiceOccurrenceDeletes: roomServiceOccurrences_bool_exp!) {
  insert_eventRooms(
    objects: $eventRoomInserts
    on_conflict: {constraint: eventRooms_pkey, update_columns: guestCanEdit}
  ) {
    affected_rows
    returning {
      eventId
      roomId
    }
  }
  delete_eventRooms(where: $eventRoomDeletes) {
    affected_rows
    returning {
      eventId
      roomId
    }
  }
  delete_roomServiceOccurrences(where: $roomServiceOccurrenceDeletes) {
    affected_rows
  }
}
    `;
export type UpdateEventRoomsMutationFn = Apollo.MutationFunction<UpdateEventRoomsMutation, UpdateEventRoomsMutationVariables>;

/**
 * __useUpdateEventRoomsMutation__
 *
 * To run a mutation, you first call `useUpdateEventRoomsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventRoomsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventRoomsMutation, { data, loading, error }] = useUpdateEventRoomsMutation({
 *   variables: {
 *      eventRoomInserts: // value for 'eventRoomInserts'
 *      eventRoomDeletes: // value for 'eventRoomDeletes'
 *      roomServiceOccurrenceDeletes: // value for 'roomServiceOccurrenceDeletes'
 *   },
 * });
 */
export function useUpdateEventRoomsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventRoomsMutation, UpdateEventRoomsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventRoomsMutation, UpdateEventRoomsMutationVariables>(UpdateEventRoomsDocument, options);
      }
export type UpdateEventRoomsMutationHookResult = ReturnType<typeof useUpdateEventRoomsMutation>;
export type UpdateEventRoomsMutationResult = Apollo.MutationResult<UpdateEventRoomsMutation>;
export type UpdateEventRoomsMutationOptions = Apollo.BaseMutationOptions<UpdateEventRoomsMutation, UpdateEventRoomsMutationVariables>;
export const UpdateSingleEventRoomDocument = gql`
    mutation updateSingleEventRoom($roomId: bigint!, $eventId: bigint!, $guestCanEdit: Boolean) {
  insert_eventRooms_one(
    object: {roomId: $roomId, eventId: $eventId, guestCanEdit: $guestCanEdit}
    on_conflict: {constraint: eventRooms_pkey, update_columns: guestCanEdit}
  ) {
    roomId
    eventId
    guestCanEdit
  }
}
    `;
export type UpdateSingleEventRoomMutationFn = Apollo.MutationFunction<UpdateSingleEventRoomMutation, UpdateSingleEventRoomMutationVariables>;

/**
 * __useUpdateSingleEventRoomMutation__
 *
 * To run a mutation, you first call `useUpdateSingleEventRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSingleEventRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSingleEventRoomMutation, { data, loading, error }] = useUpdateSingleEventRoomMutation({
 *   variables: {
 *      roomId: // value for 'roomId'
 *      eventId: // value for 'eventId'
 *      guestCanEdit: // value for 'guestCanEdit'
 *   },
 * });
 */
export function useUpdateSingleEventRoomMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSingleEventRoomMutation, UpdateSingleEventRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSingleEventRoomMutation, UpdateSingleEventRoomMutationVariables>(UpdateSingleEventRoomDocument, options);
      }
export type UpdateSingleEventRoomMutationHookResult = ReturnType<typeof useUpdateSingleEventRoomMutation>;
export type UpdateSingleEventRoomMutationResult = Apollo.MutationResult<UpdateSingleEventRoomMutation>;
export type UpdateSingleEventRoomMutationOptions = Apollo.BaseMutationOptions<UpdateSingleEventRoomMutation, UpdateSingleEventRoomMutationVariables>;
export const EventRoomWatchesDocument = gql`
    query eventRoomWatches($userId: bigint!) {
  eventRoomWatches(where: {userId: {_eq: $userId}}) {
    eventId
    userId
  }
}
    `;

/**
 * __useEventRoomWatchesQuery__
 *
 * To run a query within a React component, call `useEventRoomWatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventRoomWatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventRoomWatchesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useEventRoomWatchesQuery(baseOptions: Apollo.QueryHookOptions<EventRoomWatchesQuery, EventRoomWatchesQueryVariables> & ({ variables: EventRoomWatchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventRoomWatchesQuery, EventRoomWatchesQueryVariables>(EventRoomWatchesDocument, options);
      }
export function useEventRoomWatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventRoomWatchesQuery, EventRoomWatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventRoomWatchesQuery, EventRoomWatchesQueryVariables>(EventRoomWatchesDocument, options);
        }
export function useEventRoomWatchesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventRoomWatchesQuery, EventRoomWatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventRoomWatchesQuery, EventRoomWatchesQueryVariables>(EventRoomWatchesDocument, options);
        }
export type EventRoomWatchesQueryHookResult = ReturnType<typeof useEventRoomWatchesQuery>;
export type EventRoomWatchesLazyQueryHookResult = ReturnType<typeof useEventRoomWatchesLazyQuery>;
export type EventRoomWatchesSuspenseQueryHookResult = ReturnType<typeof useEventRoomWatchesSuspenseQuery>;
export type EventRoomWatchesQueryResult = Apollo.QueryResult<EventRoomWatchesQuery, EventRoomWatchesQueryVariables>;
export const ExportEventRoomsDocument = gql`
    query exportEventRooms($eventId: bigint!, $where: eventRooms_bool_exp!) {
  eventRooms(where: $where, order_by: {room: {id: desc}}) {
    event {
      id
      name
      subTitle
      startDate
      endDate
    }
    room {
      id
      name
      description
      roomServices(order_by: {order: asc}) {
        id
        name
        roomAttributeGroups {
          name
          order
          roomAttributes {
            name
            description
            order
          }
        }
        roomServiceCategoryId
        roomServiceOccurrences(
          where: {eventId: {_eq: $eventId}}
          order_by: {startDate: asc}
        ) {
          id
          name
          startDate
          endDate
          roomAttributeValueGroups {
            id
            roomAttributeValues {
              id
              roomAttributeId
              roomAttribute {
                name
                description
                attributeType
                config
                order
                roomAttributeGroup {
                  id
                  name
                  order
                }
              }
              value
              roomAttributeValueUploads {
                ...RoomAttributeValueUploadFileList
              }
            }
          }
        }
      }
    }
  }
  roomOccurrences(where: {eventId: {_eq: $eventId}}, order_by: {startDate: asc}) {
    id
    name
    startDate
    endDate
    roomId
    wantAirConditioning
  }
  roomFolders(order_by: [{name: asc}]) {
    id
    name
    parentId
    order
  }
}
    ${RoomAttributeValueUploadFileListFragmentDoc}`;

/**
 * __useExportEventRoomsQuery__
 *
 * To run a query within a React component, call `useExportEventRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportEventRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportEventRoomsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useExportEventRoomsQuery(baseOptions: Apollo.QueryHookOptions<ExportEventRoomsQuery, ExportEventRoomsQueryVariables> & ({ variables: ExportEventRoomsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportEventRoomsQuery, ExportEventRoomsQueryVariables>(ExportEventRoomsDocument, options);
      }
export function useExportEventRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportEventRoomsQuery, ExportEventRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportEventRoomsQuery, ExportEventRoomsQueryVariables>(ExportEventRoomsDocument, options);
        }
export function useExportEventRoomsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportEventRoomsQuery, ExportEventRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportEventRoomsQuery, ExportEventRoomsQueryVariables>(ExportEventRoomsDocument, options);
        }
export type ExportEventRoomsQueryHookResult = ReturnType<typeof useExportEventRoomsQuery>;
export type ExportEventRoomsLazyQueryHookResult = ReturnType<typeof useExportEventRoomsLazyQuery>;
export type ExportEventRoomsSuspenseQueryHookResult = ReturnType<typeof useExportEventRoomsSuspenseQuery>;
export type ExportEventRoomsQueryResult = Apollo.QueryResult<ExportEventRoomsQuery, ExportEventRoomsQueryVariables>;
export const ExportMultiEventRoomsDocument = gql`
    query exportMultiEventRooms($eventIds: [bigint!]!, $where: eventRooms_bool_exp!) {
  eventRooms(where: $where, order_by: {room: {id: desc}}) {
    event {
      id
      name
      subTitle
      startDate
      endDate
    }
    room {
      id
      name
      description
      roomServices(order_by: {order: asc}) {
        id
        name
        room {
          eventId
        }
        roomAttributeGroups {
          name
          order
          roomAttributes {
            name
            description
            order
          }
        }
        roomServiceCategoryId
        roomServiceOccurrences(
          where: {eventId: {_in: $eventIds}}
          order_by: {startDate: asc}
        ) {
          id
          name
          startDate
          endDate
          event {
            id
            name
          }
          roomAttributeValueGroups {
            id
            roomAttributeValues {
              id
              roomAttributeId
              roomAttribute {
                name
                description
                attributeType
                config
                order
                roomAttributeGroup {
                  id
                  name
                  order
                }
              }
              value
              roomAttributeValueUploads {
                ...RoomAttributeValueUploadFileList
              }
            }
          }
        }
      }
    }
  }
  roomOccurrences(where: {eventId: {_in: $eventIds}}, order_by: {startDate: asc}) {
    id
    name
    startDate
    endDate
    roomId
    wantAirConditioning
    event {
      id
      name
      startDate
    }
  }
  roomFolders(order_by: [{name: asc}]) {
    id
    name
    parentId
    order
  }
}
    ${RoomAttributeValueUploadFileListFragmentDoc}`;

/**
 * __useExportMultiEventRoomsQuery__
 *
 * To run a query within a React component, call `useExportMultiEventRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportMultiEventRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportMultiEventRoomsQuery({
 *   variables: {
 *      eventIds: // value for 'eventIds'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useExportMultiEventRoomsQuery(baseOptions: Apollo.QueryHookOptions<ExportMultiEventRoomsQuery, ExportMultiEventRoomsQueryVariables> & ({ variables: ExportMultiEventRoomsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportMultiEventRoomsQuery, ExportMultiEventRoomsQueryVariables>(ExportMultiEventRoomsDocument, options);
      }
export function useExportMultiEventRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportMultiEventRoomsQuery, ExportMultiEventRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportMultiEventRoomsQuery, ExportMultiEventRoomsQueryVariables>(ExportMultiEventRoomsDocument, options);
        }
export function useExportMultiEventRoomsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportMultiEventRoomsQuery, ExportMultiEventRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportMultiEventRoomsQuery, ExportMultiEventRoomsQueryVariables>(ExportMultiEventRoomsDocument, options);
        }
export type ExportMultiEventRoomsQueryHookResult = ReturnType<typeof useExportMultiEventRoomsQuery>;
export type ExportMultiEventRoomsLazyQueryHookResult = ReturnType<typeof useExportMultiEventRoomsLazyQuery>;
export type ExportMultiEventRoomsSuspenseQueryHookResult = ReturnType<typeof useExportMultiEventRoomsSuspenseQuery>;
export type ExportMultiEventRoomsQueryResult = Apollo.QueryResult<ExportMultiEventRoomsQuery, ExportMultiEventRoomsQueryVariables>;
export const GetSimpleEventRoomsByEventIdDocument = gql`
    query getSimpleEventRoomsByEventId($eventId: bigint!) {
  eventRooms(where: {eventId: {_eq: $eventId}}) {
    eventId
    roomId
    guestCanEdit
  }
}
    `;

/**
 * __useGetSimpleEventRoomsByEventIdQuery__
 *
 * To run a query within a React component, call `useGetSimpleEventRoomsByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimpleEventRoomsByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimpleEventRoomsByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetSimpleEventRoomsByEventIdQuery(baseOptions: Apollo.QueryHookOptions<GetSimpleEventRoomsByEventIdQuery, GetSimpleEventRoomsByEventIdQueryVariables> & ({ variables: GetSimpleEventRoomsByEventIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimpleEventRoomsByEventIdQuery, GetSimpleEventRoomsByEventIdQueryVariables>(GetSimpleEventRoomsByEventIdDocument, options);
      }
export function useGetSimpleEventRoomsByEventIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimpleEventRoomsByEventIdQuery, GetSimpleEventRoomsByEventIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimpleEventRoomsByEventIdQuery, GetSimpleEventRoomsByEventIdQueryVariables>(GetSimpleEventRoomsByEventIdDocument, options);
        }
export function useGetSimpleEventRoomsByEventIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSimpleEventRoomsByEventIdQuery, GetSimpleEventRoomsByEventIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSimpleEventRoomsByEventIdQuery, GetSimpleEventRoomsByEventIdQueryVariables>(GetSimpleEventRoomsByEventIdDocument, options);
        }
export type GetSimpleEventRoomsByEventIdQueryHookResult = ReturnType<typeof useGetSimpleEventRoomsByEventIdQuery>;
export type GetSimpleEventRoomsByEventIdLazyQueryHookResult = ReturnType<typeof useGetSimpleEventRoomsByEventIdLazyQuery>;
export type GetSimpleEventRoomsByEventIdSuspenseQueryHookResult = ReturnType<typeof useGetSimpleEventRoomsByEventIdSuspenseQuery>;
export type GetSimpleEventRoomsByEventIdQueryResult = Apollo.QueryResult<GetSimpleEventRoomsByEventIdQuery, GetSimpleEventRoomsByEventIdQueryVariables>;
export const GetOnlyEventRoomsByEventIdDocument = gql`
    query getOnlyEventRoomsByEventId($eventId: bigint!) {
  eventRooms(where: {eventId: {_eq: $eventId}}) {
    roomId
    guestCanEdit
    room {
      id
      name
      order
      roomServices {
        id
        name
        order
        description
        roomServiceOccurrences {
          id
          name
          startDate
          endDate
          hasChanges
          isDraft
          fromRoomServiceOccurrenceId
          guestCanEdit
          userData {
            data
          }
          roomAttributeValueGroups {
            id
          }
          event {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetOnlyEventRoomsByEventIdQuery__
 *
 * To run a query within a React component, call `useGetOnlyEventRoomsByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnlyEventRoomsByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnlyEventRoomsByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetOnlyEventRoomsByEventIdQuery(baseOptions: Apollo.QueryHookOptions<GetOnlyEventRoomsByEventIdQuery, GetOnlyEventRoomsByEventIdQueryVariables> & ({ variables: GetOnlyEventRoomsByEventIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOnlyEventRoomsByEventIdQuery, GetOnlyEventRoomsByEventIdQueryVariables>(GetOnlyEventRoomsByEventIdDocument, options);
      }
export function useGetOnlyEventRoomsByEventIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOnlyEventRoomsByEventIdQuery, GetOnlyEventRoomsByEventIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOnlyEventRoomsByEventIdQuery, GetOnlyEventRoomsByEventIdQueryVariables>(GetOnlyEventRoomsByEventIdDocument, options);
        }
export function useGetOnlyEventRoomsByEventIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOnlyEventRoomsByEventIdQuery, GetOnlyEventRoomsByEventIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOnlyEventRoomsByEventIdQuery, GetOnlyEventRoomsByEventIdQueryVariables>(GetOnlyEventRoomsByEventIdDocument, options);
        }
export type GetOnlyEventRoomsByEventIdQueryHookResult = ReturnType<typeof useGetOnlyEventRoomsByEventIdQuery>;
export type GetOnlyEventRoomsByEventIdLazyQueryHookResult = ReturnType<typeof useGetOnlyEventRoomsByEventIdLazyQuery>;
export type GetOnlyEventRoomsByEventIdSuspenseQueryHookResult = ReturnType<typeof useGetOnlyEventRoomsByEventIdSuspenseQuery>;
export type GetOnlyEventRoomsByEventIdQueryResult = Apollo.QueryResult<GetOnlyEventRoomsByEventIdQuery, GetOnlyEventRoomsByEventIdQueryVariables>;
export const CreateEventSpecificRoomDocument = gql`
    mutation createEventSpecificRoom($object: rooms_insert_input!) {
  insert_rooms_one(object: $object) {
    id
    name
    description
    shortDescription
    fromRoomId
    eventId
  }
}
    `;
export type CreateEventSpecificRoomMutationFn = Apollo.MutationFunction<CreateEventSpecificRoomMutation, CreateEventSpecificRoomMutationVariables>;

/**
 * __useCreateEventSpecificRoomMutation__
 *
 * To run a mutation, you first call `useCreateEventSpecificRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventSpecificRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventSpecificRoomMutation, { data, loading, error }] = useCreateEventSpecificRoomMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useCreateEventSpecificRoomMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventSpecificRoomMutation, CreateEventSpecificRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventSpecificRoomMutation, CreateEventSpecificRoomMutationVariables>(CreateEventSpecificRoomDocument, options);
      }
export type CreateEventSpecificRoomMutationHookResult = ReturnType<typeof useCreateEventSpecificRoomMutation>;
export type CreateEventSpecificRoomMutationResult = Apollo.MutationResult<CreateEventSpecificRoomMutation>;
export type CreateEventSpecificRoomMutationOptions = Apollo.BaseMutationOptions<CreateEventSpecificRoomMutation, CreateEventSpecificRoomMutationVariables>;
export const CreateEventSpecificRoomsDocument = gql`
    mutation createEventSpecificRooms($objects: [rooms_insert_input!]!) {
  insert_rooms(objects: $objects) {
    affected_rows
    returning {
      id
      name
      description
      shortDescription
      fromRoomId
      eventId
      roomServices(order_by: {order: asc}) {
        id
        name
        order
        description
        fromRoomServiceId
      }
    }
  }
}
    `;
export type CreateEventSpecificRoomsMutationFn = Apollo.MutationFunction<CreateEventSpecificRoomsMutation, CreateEventSpecificRoomsMutationVariables>;

/**
 * __useCreateEventSpecificRoomsMutation__
 *
 * To run a mutation, you first call `useCreateEventSpecificRoomsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventSpecificRoomsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventSpecificRoomsMutation, { data, loading, error }] = useCreateEventSpecificRoomsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useCreateEventSpecificRoomsMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventSpecificRoomsMutation, CreateEventSpecificRoomsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventSpecificRoomsMutation, CreateEventSpecificRoomsMutationVariables>(CreateEventSpecificRoomsDocument, options);
      }
export type CreateEventSpecificRoomsMutationHookResult = ReturnType<typeof useCreateEventSpecificRoomsMutation>;
export type CreateEventSpecificRoomsMutationResult = Apollo.MutationResult<CreateEventSpecificRoomsMutation>;
export type CreateEventSpecificRoomsMutationOptions = Apollo.BaseMutationOptions<CreateEventSpecificRoomsMutation, CreateEventSpecificRoomsMutationVariables>;
export const UpdateEventSpecificRoomDocument = gql`
    mutation updateEventSpecificRoom($id: bigint!, $updates: rooms_set_input!) {
  update_rooms_by_pk(pk_columns: {id: $id}, _set: $updates) {
    id
    name
    roomFolderId
    shortDescription
    description
    order
    fromRoomId
    eventId
  }
}
    `;
export type UpdateEventSpecificRoomMutationFn = Apollo.MutationFunction<UpdateEventSpecificRoomMutation, UpdateEventSpecificRoomMutationVariables>;

/**
 * __useUpdateEventSpecificRoomMutation__
 *
 * To run a mutation, you first call `useUpdateEventSpecificRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventSpecificRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventSpecificRoomMutation, { data, loading, error }] = useUpdateEventSpecificRoomMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateEventSpecificRoomMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventSpecificRoomMutation, UpdateEventSpecificRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventSpecificRoomMutation, UpdateEventSpecificRoomMutationVariables>(UpdateEventSpecificRoomDocument, options);
      }
export type UpdateEventSpecificRoomMutationHookResult = ReturnType<typeof useUpdateEventSpecificRoomMutation>;
export type UpdateEventSpecificRoomMutationResult = Apollo.MutationResult<UpdateEventSpecificRoomMutation>;
export type UpdateEventSpecificRoomMutationOptions = Apollo.BaseMutationOptions<UpdateEventSpecificRoomMutation, UpdateEventSpecificRoomMutationVariables>;
export const DeleteEventSpecificRoomDocument = gql`
    mutation deleteEventSpecificRoom($id: bigint!) {
  delete_rooms_by_pk(id: $id) {
    id
    name
    roomFolderId
    shortDescription
    description
    order
    fromRoomId
    eventId
  }
}
    `;
export type DeleteEventSpecificRoomMutationFn = Apollo.MutationFunction<DeleteEventSpecificRoomMutation, DeleteEventSpecificRoomMutationVariables>;

/**
 * __useDeleteEventSpecificRoomMutation__
 *
 * To run a mutation, you first call `useDeleteEventSpecificRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventSpecificRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventSpecificRoomMutation, { data, loading, error }] = useDeleteEventSpecificRoomMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEventSpecificRoomMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventSpecificRoomMutation, DeleteEventSpecificRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventSpecificRoomMutation, DeleteEventSpecificRoomMutationVariables>(DeleteEventSpecificRoomDocument, options);
      }
export type DeleteEventSpecificRoomMutationHookResult = ReturnType<typeof useDeleteEventSpecificRoomMutation>;
export type DeleteEventSpecificRoomMutationResult = Apollo.MutationResult<DeleteEventSpecificRoomMutation>;
export type DeleteEventSpecificRoomMutationOptions = Apollo.BaseMutationOptions<DeleteEventSpecificRoomMutation, DeleteEventSpecificRoomMutationVariables>;
export const DeleteEventSpecificRoomsDocument = gql`
    mutation deleteEventSpecificRooms($roomIds: [bigint!]) {
  delete_rooms(where: {id: {_in: $roomIds}}) {
    affected_rows
    returning {
      id
      name
      roomFolderId
      shortDescription
      description
      order
      fromRoomId
      eventId
    }
  }
}
    `;
export type DeleteEventSpecificRoomsMutationFn = Apollo.MutationFunction<DeleteEventSpecificRoomsMutation, DeleteEventSpecificRoomsMutationVariables>;

/**
 * __useDeleteEventSpecificRoomsMutation__
 *
 * To run a mutation, you first call `useDeleteEventSpecificRoomsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventSpecificRoomsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventSpecificRoomsMutation, { data, loading, error }] = useDeleteEventSpecificRoomsMutation({
 *   variables: {
 *      roomIds: // value for 'roomIds'
 *   },
 * });
 */
export function useDeleteEventSpecificRoomsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventSpecificRoomsMutation, DeleteEventSpecificRoomsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventSpecificRoomsMutation, DeleteEventSpecificRoomsMutationVariables>(DeleteEventSpecificRoomsDocument, options);
      }
export type DeleteEventSpecificRoomsMutationHookResult = ReturnType<typeof useDeleteEventSpecificRoomsMutation>;
export type DeleteEventSpecificRoomsMutationResult = Apollo.MutationResult<DeleteEventSpecificRoomsMutation>;
export type DeleteEventSpecificRoomsMutationOptions = Apollo.BaseMutationOptions<DeleteEventSpecificRoomsMutation, DeleteEventSpecificRoomsMutationVariables>;
export const GetEventRoomsByEventIdDocument = gql`
    subscription getEventRoomsByEventId($eventId: bigint!, $fetchLastUpdatedInfo: Boolean = true) {
  events_by_pk(id: $eventId) {
    id
    name
    startDate
    endDate
    eventType
    config
    guestOrganisationId
    guestCanEditRoommatrix
    roommatrixWritable
    parentEvent {
      id
      name
      config
    }
    eventRooms {
      roomId
      guestCanEdit
      room {
        id
        name
        order
        roomServices {
          id
          name
          order
          description
        }
      }
    }
    eventAttributeValues {
      id
      value
      createdAt
      updatedAt
      updatedBy @include(if: $fetchLastUpdatedInfo)
      user @include(if: $fetchLastUpdatedInfo) {
        id
        firstName
        lastName
      }
      eventAttribute {
        id
        attributeType
        config
        name
        order
        eventAttributeGroup {
          id
          name
          order
        }
      }
    }
  }
}
    `;

/**
 * __useGetEventRoomsByEventIdSubscription__
 *
 * To run a query within a React component, call `useGetEventRoomsByEventIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetEventRoomsByEventIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventRoomsByEventIdSubscription({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      fetchLastUpdatedInfo: // value for 'fetchLastUpdatedInfo'
 *   },
 * });
 */
export function useGetEventRoomsByEventIdSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetEventRoomsByEventIdSubscription, GetEventRoomsByEventIdSubscriptionVariables> & ({ variables: GetEventRoomsByEventIdSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetEventRoomsByEventIdSubscription, GetEventRoomsByEventIdSubscriptionVariables>(GetEventRoomsByEventIdDocument, options);
      }
export type GetEventRoomsByEventIdSubscriptionHookResult = ReturnType<typeof useGetEventRoomsByEventIdSubscription>;
export type GetEventRoomsByEventIdSubscriptionResult = Apollo.SubscriptionResult<GetEventRoomsByEventIdSubscription>;
export const EventRoomsByEventIdDocument = gql`
    query eventRoomsByEventId($eventId: bigint!) {
  events_by_pk(id: $eventId) {
    id
    name
    startDate
    endDate
    eventType
    config
    eventAttributeValues {
      id
      value
      eventAttribute {
        id
        attributeType
        config
        name
        order
        eventAttributeGroup {
          id
          name
          order
        }
      }
    }
    parentEvent {
      id
      name
      startDate
      endDate
    }
    eventRooms {
      roomId
      guestCanEdit
      room {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useEventRoomsByEventIdQuery__
 *
 * To run a query within a React component, call `useEventRoomsByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventRoomsByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventRoomsByEventIdQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventRoomsByEventIdQuery(baseOptions: Apollo.QueryHookOptions<EventRoomsByEventIdQuery, EventRoomsByEventIdQueryVariables> & ({ variables: EventRoomsByEventIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventRoomsByEventIdQuery, EventRoomsByEventIdQueryVariables>(EventRoomsByEventIdDocument, options);
      }
export function useEventRoomsByEventIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventRoomsByEventIdQuery, EventRoomsByEventIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventRoomsByEventIdQuery, EventRoomsByEventIdQueryVariables>(EventRoomsByEventIdDocument, options);
        }
export function useEventRoomsByEventIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventRoomsByEventIdQuery, EventRoomsByEventIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventRoomsByEventIdQuery, EventRoomsByEventIdQueryVariables>(EventRoomsByEventIdDocument, options);
        }
export type EventRoomsByEventIdQueryHookResult = ReturnType<typeof useEventRoomsByEventIdQuery>;
export type EventRoomsByEventIdLazyQueryHookResult = ReturnType<typeof useEventRoomsByEventIdLazyQuery>;
export type EventRoomsByEventIdSuspenseQueryHookResult = ReturnType<typeof useEventRoomsByEventIdSuspenseQuery>;
export type EventRoomsByEventIdQueryResult = Apollo.QueryResult<EventRoomsByEventIdQuery, EventRoomsByEventIdQueryVariables>;
export const GetEventRoomsByEventIdsDocument = gql`
    subscription getEventRoomsByEventIds($eventIds: [bigint!]!, $fetchLastUpdatedInfo: Boolean = true) {
  events(where: {id: {_in: $eventIds}}, order_by: {startDate: asc}) {
    id
    name
    startDate
    endDate
    eventType
    config
    guestOrganisationId
    guestCanEditRoommatrix
    roommatrixWritable
    parentEvent {
      id
      name
      config
    }
    eventRooms {
      roomId
      guestCanEdit
      room {
        id
        name
        order
        roomServices {
          id
          name
          order
          description
        }
      }
    }
    eventAttributeValues {
      id
      value
      createdAt
      updatedAt
      updatedBy @include(if: $fetchLastUpdatedInfo)
      user @include(if: $fetchLastUpdatedInfo) {
        id
        firstName
        lastName
      }
      eventAttribute {
        id
        attributeType
        config
        name
        order
        eventAttributeGroup {
          id
          name
          order
        }
      }
    }
  }
}
    `;

/**
 * __useGetEventRoomsByEventIdsSubscription__
 *
 * To run a query within a React component, call `useGetEventRoomsByEventIdsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetEventRoomsByEventIdsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventRoomsByEventIdsSubscription({
 *   variables: {
 *      eventIds: // value for 'eventIds'
 *      fetchLastUpdatedInfo: // value for 'fetchLastUpdatedInfo'
 *   },
 * });
 */
export function useGetEventRoomsByEventIdsSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetEventRoomsByEventIdsSubscription, GetEventRoomsByEventIdsSubscriptionVariables> & ({ variables: GetEventRoomsByEventIdsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetEventRoomsByEventIdsSubscription, GetEventRoomsByEventIdsSubscriptionVariables>(GetEventRoomsByEventIdsDocument, options);
      }
export type GetEventRoomsByEventIdsSubscriptionHookResult = ReturnType<typeof useGetEventRoomsByEventIdsSubscription>;
export type GetEventRoomsByEventIdsSubscriptionResult = Apollo.SubscriptionResult<GetEventRoomsByEventIdsSubscription>;
export const GetEventRoomsByEventIdsArrayDocument = gql`
    query getEventRoomsByEventIdsArray($eventIds: [bigint!]!, $fetchLastUpdatedInfo: Boolean = true) {
  events(where: {id: {_in: $eventIds}}, order_by: {startDate: asc}) {
    id
    name
    startDate
    endDate
    eventType
    config
    guestOrganisationId
    guestCanEditRoommatrix
    roommatrixWritable
    parentEvent {
      id
      name
      config
    }
    eventRooms {
      roomId
      guestCanEdit
      room {
        id
        name
        order
        roomServices {
          id
          name
          order
          description
          roomServiceOccurrences(where: {eventId: {_in: $eventIds}}) {
            id
            name
            startDate
            endDate
            hasChanges
            isDraft
            fromRoomServiceOccurrenceId
            guestCanEdit
            userData {
              data
            }
            roomAttributeValueGroups {
              id
            }
            event {
              id
              name
            }
          }
        }
      }
    }
    eventAttributeValues {
      id
      value
      createdAt
      updatedAt
      updatedBy @include(if: $fetchLastUpdatedInfo)
      user @include(if: $fetchLastUpdatedInfo) {
        id
        firstName
        lastName
      }
      eventAttribute {
        id
        attributeType
        config
        name
        order
        eventAttributeGroup {
          id
          name
          order
        }
      }
    }
  }
}
    `;

/**
 * __useGetEventRoomsByEventIdsArrayQuery__
 *
 * To run a query within a React component, call `useGetEventRoomsByEventIdsArrayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventRoomsByEventIdsArrayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventRoomsByEventIdsArrayQuery({
 *   variables: {
 *      eventIds: // value for 'eventIds'
 *      fetchLastUpdatedInfo: // value for 'fetchLastUpdatedInfo'
 *   },
 * });
 */
export function useGetEventRoomsByEventIdsArrayQuery(baseOptions: Apollo.QueryHookOptions<GetEventRoomsByEventIdsArrayQuery, GetEventRoomsByEventIdsArrayQueryVariables> & ({ variables: GetEventRoomsByEventIdsArrayQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventRoomsByEventIdsArrayQuery, GetEventRoomsByEventIdsArrayQueryVariables>(GetEventRoomsByEventIdsArrayDocument, options);
      }
export function useGetEventRoomsByEventIdsArrayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventRoomsByEventIdsArrayQuery, GetEventRoomsByEventIdsArrayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventRoomsByEventIdsArrayQuery, GetEventRoomsByEventIdsArrayQueryVariables>(GetEventRoomsByEventIdsArrayDocument, options);
        }
export function useGetEventRoomsByEventIdsArraySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventRoomsByEventIdsArrayQuery, GetEventRoomsByEventIdsArrayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventRoomsByEventIdsArrayQuery, GetEventRoomsByEventIdsArrayQueryVariables>(GetEventRoomsByEventIdsArrayDocument, options);
        }
export type GetEventRoomsByEventIdsArrayQueryHookResult = ReturnType<typeof useGetEventRoomsByEventIdsArrayQuery>;
export type GetEventRoomsByEventIdsArrayLazyQueryHookResult = ReturnType<typeof useGetEventRoomsByEventIdsArrayLazyQuery>;
export type GetEventRoomsByEventIdsArraySuspenseQueryHookResult = ReturnType<typeof useGetEventRoomsByEventIdsArraySuspenseQuery>;
export type GetEventRoomsByEventIdsArrayQueryResult = Apollo.QueryResult<GetEventRoomsByEventIdsArrayQuery, GetEventRoomsByEventIdsArrayQueryVariables>;
export const GetRoomOccurrencesByEventIdsDocument = gql`
    subscription getRoomOccurrencesByEventIds($eventIds: [bigint!]!) {
  roomOccurrences(where: {eventId: {_in: $eventIds}}, order_by: {startDate: asc}) {
    id
    roomId
    name
    startDate
    endDate
    isDraft
    fromRoomOccurrenceId
    createdAt
    guestCanEdit
    userData {
      data
    }
    eventId
    event {
      id
      name
    }
    wantAirConditioning
  }
}
    `;

/**
 * __useGetRoomOccurrencesByEventIdsSubscription__
 *
 * To run a query within a React component, call `useGetRoomOccurrencesByEventIdsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomOccurrencesByEventIdsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomOccurrencesByEventIdsSubscription({
 *   variables: {
 *      eventIds: // value for 'eventIds'
 *   },
 * });
 */
export function useGetRoomOccurrencesByEventIdsSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetRoomOccurrencesByEventIdsSubscription, GetRoomOccurrencesByEventIdsSubscriptionVariables> & ({ variables: GetRoomOccurrencesByEventIdsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetRoomOccurrencesByEventIdsSubscription, GetRoomOccurrencesByEventIdsSubscriptionVariables>(GetRoomOccurrencesByEventIdsDocument, options);
      }
export type GetRoomOccurrencesByEventIdsSubscriptionHookResult = ReturnType<typeof useGetRoomOccurrencesByEventIdsSubscription>;
export type GetRoomOccurrencesByEventIdsSubscriptionResult = Apollo.SubscriptionResult<GetRoomOccurrencesByEventIdsSubscription>;
export const GetRoomOccurrencesFirstStartAndLastEndDocument = gql`
    query getRoomOccurrencesFirstStartAndLastEnd($eventIds: [bigint!]!) {
  roomOccurrenceFirstStart: roomOccurrences(
    where: {eventId: {_in: $eventIds}}
    order_by: {startDate: asc}
    limit: 1
  ) {
    id
    startDate
  }
  roomOccurenceLastEnd: roomOccurrences(
    where: {eventId: {_in: $eventIds}}
    order_by: {endDate: desc}
    limit: 1
  ) {
    id
    endDate
  }
}
    `;

/**
 * __useGetRoomOccurrencesFirstStartAndLastEndQuery__
 *
 * To run a query within a React component, call `useGetRoomOccurrencesFirstStartAndLastEndQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomOccurrencesFirstStartAndLastEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomOccurrencesFirstStartAndLastEndQuery({
 *   variables: {
 *      eventIds: // value for 'eventIds'
 *   },
 * });
 */
export function useGetRoomOccurrencesFirstStartAndLastEndQuery(baseOptions: Apollo.QueryHookOptions<GetRoomOccurrencesFirstStartAndLastEndQuery, GetRoomOccurrencesFirstStartAndLastEndQueryVariables> & ({ variables: GetRoomOccurrencesFirstStartAndLastEndQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomOccurrencesFirstStartAndLastEndQuery, GetRoomOccurrencesFirstStartAndLastEndQueryVariables>(GetRoomOccurrencesFirstStartAndLastEndDocument, options);
      }
export function useGetRoomOccurrencesFirstStartAndLastEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomOccurrencesFirstStartAndLastEndQuery, GetRoomOccurrencesFirstStartAndLastEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomOccurrencesFirstStartAndLastEndQuery, GetRoomOccurrencesFirstStartAndLastEndQueryVariables>(GetRoomOccurrencesFirstStartAndLastEndDocument, options);
        }
export function useGetRoomOccurrencesFirstStartAndLastEndSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoomOccurrencesFirstStartAndLastEndQuery, GetRoomOccurrencesFirstStartAndLastEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoomOccurrencesFirstStartAndLastEndQuery, GetRoomOccurrencesFirstStartAndLastEndQueryVariables>(GetRoomOccurrencesFirstStartAndLastEndDocument, options);
        }
export type GetRoomOccurrencesFirstStartAndLastEndQueryHookResult = ReturnType<typeof useGetRoomOccurrencesFirstStartAndLastEndQuery>;
export type GetRoomOccurrencesFirstStartAndLastEndLazyQueryHookResult = ReturnType<typeof useGetRoomOccurrencesFirstStartAndLastEndLazyQuery>;
export type GetRoomOccurrencesFirstStartAndLastEndSuspenseQueryHookResult = ReturnType<typeof useGetRoomOccurrencesFirstStartAndLastEndSuspenseQuery>;
export type GetRoomOccurrencesFirstStartAndLastEndQueryResult = Apollo.QueryResult<GetRoomOccurrencesFirstStartAndLastEndQuery, GetRoomOccurrencesFirstStartAndLastEndQueryVariables>;
export const GetRoomServiceOccurrencesByEventIdsDocument = gql`
    subscription getRoomServiceOccurrencesByEventIds($eventIds: [bigint!]!) {
  roomServiceOccurrences(
    where: {eventId: {_in: $eventIds}}
    order_by: {startDate: asc}
  ) {
    id
    createdAt
    roomServiceId
    name
    startDate
    endDate
    hasChanges
    isDraft
    fromRoomServiceOccurrenceId
    guestCanEdit
    userData {
      data
    }
    roomService {
      roomId
      id
      name
      order
      description
      fromRoomServiceId
    }
    roomAttributeValueGroups {
      id
    }
    eventId
  }
}
    `;

/**
 * __useGetRoomServiceOccurrencesByEventIdsSubscription__
 *
 * To run a query within a React component, call `useGetRoomServiceOccurrencesByEventIdsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomServiceOccurrencesByEventIdsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomServiceOccurrencesByEventIdsSubscription({
 *   variables: {
 *      eventIds: // value for 'eventIds'
 *   },
 * });
 */
export function useGetRoomServiceOccurrencesByEventIdsSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetRoomServiceOccurrencesByEventIdsSubscription, GetRoomServiceOccurrencesByEventIdsSubscriptionVariables> & ({ variables: GetRoomServiceOccurrencesByEventIdsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetRoomServiceOccurrencesByEventIdsSubscription, GetRoomServiceOccurrencesByEventIdsSubscriptionVariables>(GetRoomServiceOccurrencesByEventIdsDocument, options);
      }
export type GetRoomServiceOccurrencesByEventIdsSubscriptionHookResult = ReturnType<typeof useGetRoomServiceOccurrencesByEventIdsSubscription>;
export type GetRoomServiceOccurrencesByEventIdsSubscriptionResult = Apollo.SubscriptionResult<GetRoomServiceOccurrencesByEventIdsSubscription>;
export const GetRoomServiceOccurrencesFirstStartAndLastEndDocument = gql`
    query getRoomServiceOccurrencesFirstStartAndLastEnd($eventIds: [bigint!]!) {
  roomServiceOccurenceFirstStart: roomServiceOccurrences(
    where: {eventId: {_in: $eventIds}}
    order_by: {startDate: asc}
    limit: 1
  ) {
    id
    startDate
  }
  roomServiceOccurenceLastEnd: roomServiceOccurrences(
    where: {eventId: {_in: $eventIds}}
    order_by: {endDate: desc}
    limit: 1
  ) {
    id
    endDate
  }
}
    `;

/**
 * __useGetRoomServiceOccurrencesFirstStartAndLastEndQuery__
 *
 * To run a query within a React component, call `useGetRoomServiceOccurrencesFirstStartAndLastEndQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomServiceOccurrencesFirstStartAndLastEndQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomServiceOccurrencesFirstStartAndLastEndQuery({
 *   variables: {
 *      eventIds: // value for 'eventIds'
 *   },
 * });
 */
export function useGetRoomServiceOccurrencesFirstStartAndLastEndQuery(baseOptions: Apollo.QueryHookOptions<GetRoomServiceOccurrencesFirstStartAndLastEndQuery, GetRoomServiceOccurrencesFirstStartAndLastEndQueryVariables> & ({ variables: GetRoomServiceOccurrencesFirstStartAndLastEndQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomServiceOccurrencesFirstStartAndLastEndQuery, GetRoomServiceOccurrencesFirstStartAndLastEndQueryVariables>(GetRoomServiceOccurrencesFirstStartAndLastEndDocument, options);
      }
export function useGetRoomServiceOccurrencesFirstStartAndLastEndLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomServiceOccurrencesFirstStartAndLastEndQuery, GetRoomServiceOccurrencesFirstStartAndLastEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomServiceOccurrencesFirstStartAndLastEndQuery, GetRoomServiceOccurrencesFirstStartAndLastEndQueryVariables>(GetRoomServiceOccurrencesFirstStartAndLastEndDocument, options);
        }
export function useGetRoomServiceOccurrencesFirstStartAndLastEndSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoomServiceOccurrencesFirstStartAndLastEndQuery, GetRoomServiceOccurrencesFirstStartAndLastEndQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoomServiceOccurrencesFirstStartAndLastEndQuery, GetRoomServiceOccurrencesFirstStartAndLastEndQueryVariables>(GetRoomServiceOccurrencesFirstStartAndLastEndDocument, options);
        }
export type GetRoomServiceOccurrencesFirstStartAndLastEndQueryHookResult = ReturnType<typeof useGetRoomServiceOccurrencesFirstStartAndLastEndQuery>;
export type GetRoomServiceOccurrencesFirstStartAndLastEndLazyQueryHookResult = ReturnType<typeof useGetRoomServiceOccurrencesFirstStartAndLastEndLazyQuery>;
export type GetRoomServiceOccurrencesFirstStartAndLastEndSuspenseQueryHookResult = ReturnType<typeof useGetRoomServiceOccurrencesFirstStartAndLastEndSuspenseQuery>;
export type GetRoomServiceOccurrencesFirstStartAndLastEndQueryResult = Apollo.QueryResult<GetRoomServiceOccurrencesFirstStartAndLastEndQuery, GetRoomServiceOccurrencesFirstStartAndLastEndQueryVariables>;
export const GetRoomOccurrencesByEventIdqDocument = gql`
    query getRoomOccurrencesByEventIdq($eventId: bigint!) {
  roomOccurrences(where: {eventId: {_eq: $eventId}}, order_by: {startDate: asc}) {
    id
    roomId
    name
    startDate
    endDate
    userData {
      data
    }
    wantAirConditioning
  }
}
    `;

/**
 * __useGetRoomOccurrencesByEventIdqQuery__
 *
 * To run a query within a React component, call `useGetRoomOccurrencesByEventIdqQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomOccurrencesByEventIdqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomOccurrencesByEventIdqQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRoomOccurrencesByEventIdqQuery(baseOptions: Apollo.QueryHookOptions<GetRoomOccurrencesByEventIdqQuery, GetRoomOccurrencesByEventIdqQueryVariables> & ({ variables: GetRoomOccurrencesByEventIdqQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomOccurrencesByEventIdqQuery, GetRoomOccurrencesByEventIdqQueryVariables>(GetRoomOccurrencesByEventIdqDocument, options);
      }
export function useGetRoomOccurrencesByEventIdqLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomOccurrencesByEventIdqQuery, GetRoomOccurrencesByEventIdqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomOccurrencesByEventIdqQuery, GetRoomOccurrencesByEventIdqQueryVariables>(GetRoomOccurrencesByEventIdqDocument, options);
        }
export function useGetRoomOccurrencesByEventIdqSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoomOccurrencesByEventIdqQuery, GetRoomOccurrencesByEventIdqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoomOccurrencesByEventIdqQuery, GetRoomOccurrencesByEventIdqQueryVariables>(GetRoomOccurrencesByEventIdqDocument, options);
        }
export type GetRoomOccurrencesByEventIdqQueryHookResult = ReturnType<typeof useGetRoomOccurrencesByEventIdqQuery>;
export type GetRoomOccurrencesByEventIdqLazyQueryHookResult = ReturnType<typeof useGetRoomOccurrencesByEventIdqLazyQuery>;
export type GetRoomOccurrencesByEventIdqSuspenseQueryHookResult = ReturnType<typeof useGetRoomOccurrencesByEventIdqSuspenseQuery>;
export type GetRoomOccurrencesByEventIdqQueryResult = Apollo.QueryResult<GetRoomOccurrencesByEventIdqQuery, GetRoomOccurrencesByEventIdqQueryVariables>;
export const GetRoomServiceOccurrencesByEventIdqDocument = gql`
    query getRoomServiceOccurrencesByEventIdq($eventId: bigint!) {
  roomServiceOccurrences(
    where: {eventId: {_eq: $eventId}}
    order_by: {startDate: asc}
  ) {
    id
    roomServiceId
    name
    startDate
    endDate
    hasChanges
    userData {
      data
    }
    roomService {
      roomId
      id
      name
      order
      description
    }
  }
}
    `;

/**
 * __useGetRoomServiceOccurrencesByEventIdqQuery__
 *
 * To run a query within a React component, call `useGetRoomServiceOccurrencesByEventIdqQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomServiceOccurrencesByEventIdqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomServiceOccurrencesByEventIdqQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRoomServiceOccurrencesByEventIdqQuery(baseOptions: Apollo.QueryHookOptions<GetRoomServiceOccurrencesByEventIdqQuery, GetRoomServiceOccurrencesByEventIdqQueryVariables> & ({ variables: GetRoomServiceOccurrencesByEventIdqQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomServiceOccurrencesByEventIdqQuery, GetRoomServiceOccurrencesByEventIdqQueryVariables>(GetRoomServiceOccurrencesByEventIdqDocument, options);
      }
export function useGetRoomServiceOccurrencesByEventIdqLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomServiceOccurrencesByEventIdqQuery, GetRoomServiceOccurrencesByEventIdqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomServiceOccurrencesByEventIdqQuery, GetRoomServiceOccurrencesByEventIdqQueryVariables>(GetRoomServiceOccurrencesByEventIdqDocument, options);
        }
export function useGetRoomServiceOccurrencesByEventIdqSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoomServiceOccurrencesByEventIdqQuery, GetRoomServiceOccurrencesByEventIdqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoomServiceOccurrencesByEventIdqQuery, GetRoomServiceOccurrencesByEventIdqQueryVariables>(GetRoomServiceOccurrencesByEventIdqDocument, options);
        }
export type GetRoomServiceOccurrencesByEventIdqQueryHookResult = ReturnType<typeof useGetRoomServiceOccurrencesByEventIdqQuery>;
export type GetRoomServiceOccurrencesByEventIdqLazyQueryHookResult = ReturnType<typeof useGetRoomServiceOccurrencesByEventIdqLazyQuery>;
export type GetRoomServiceOccurrencesByEventIdqSuspenseQueryHookResult = ReturnType<typeof useGetRoomServiceOccurrencesByEventIdqSuspenseQuery>;
export type GetRoomServiceOccurrencesByEventIdqQueryResult = Apollo.QueryResult<GetRoomServiceOccurrencesByEventIdqQuery, GetRoomServiceOccurrencesByEventIdqQueryVariables>;
export const GetUserDataForRoomServiceOccurrenceDocument = gql`
    query getUserDataForRoomServiceOccurrence($roomServiceOccurrenceId: bigint!) {
  userDataRoomServiceOccurrences(
    where: {roomServiceOccurrenceId: {_eq: $roomServiceOccurrenceId}}
  ) {
    data
    roomServiceOccurrenceId
    userId
  }
}
    `;

/**
 * __useGetUserDataForRoomServiceOccurrenceQuery__
 *
 * To run a query within a React component, call `useGetUserDataForRoomServiceOccurrenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDataForRoomServiceOccurrenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDataForRoomServiceOccurrenceQuery({
 *   variables: {
 *      roomServiceOccurrenceId: // value for 'roomServiceOccurrenceId'
 *   },
 * });
 */
export function useGetUserDataForRoomServiceOccurrenceQuery(baseOptions: Apollo.QueryHookOptions<GetUserDataForRoomServiceOccurrenceQuery, GetUserDataForRoomServiceOccurrenceQueryVariables> & ({ variables: GetUserDataForRoomServiceOccurrenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDataForRoomServiceOccurrenceQuery, GetUserDataForRoomServiceOccurrenceQueryVariables>(GetUserDataForRoomServiceOccurrenceDocument, options);
      }
export function useGetUserDataForRoomServiceOccurrenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDataForRoomServiceOccurrenceQuery, GetUserDataForRoomServiceOccurrenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDataForRoomServiceOccurrenceQuery, GetUserDataForRoomServiceOccurrenceQueryVariables>(GetUserDataForRoomServiceOccurrenceDocument, options);
        }
export function useGetUserDataForRoomServiceOccurrenceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserDataForRoomServiceOccurrenceQuery, GetUserDataForRoomServiceOccurrenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserDataForRoomServiceOccurrenceQuery, GetUserDataForRoomServiceOccurrenceQueryVariables>(GetUserDataForRoomServiceOccurrenceDocument, options);
        }
export type GetUserDataForRoomServiceOccurrenceQueryHookResult = ReturnType<typeof useGetUserDataForRoomServiceOccurrenceQuery>;
export type GetUserDataForRoomServiceOccurrenceLazyQueryHookResult = ReturnType<typeof useGetUserDataForRoomServiceOccurrenceLazyQuery>;
export type GetUserDataForRoomServiceOccurrenceSuspenseQueryHookResult = ReturnType<typeof useGetUserDataForRoomServiceOccurrenceSuspenseQuery>;
export type GetUserDataForRoomServiceOccurrenceQueryResult = Apollo.QueryResult<GetUserDataForRoomServiceOccurrenceQuery, GetUserDataForRoomServiceOccurrenceQueryVariables>;
export const GetUserDataForRoomOccurrenceDocument = gql`
    query getUserDataForRoomOccurrence($roomOccurrenceId: bigint!) {
  userDataRoomOccurrences(where: {roomOccurrenceId: {_eq: $roomOccurrenceId}}) {
    data
    roomOccurrenceId
    userId
  }
}
    `;

/**
 * __useGetUserDataForRoomOccurrenceQuery__
 *
 * To run a query within a React component, call `useGetUserDataForRoomOccurrenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDataForRoomOccurrenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDataForRoomOccurrenceQuery({
 *   variables: {
 *      roomOccurrenceId: // value for 'roomOccurrenceId'
 *   },
 * });
 */
export function useGetUserDataForRoomOccurrenceQuery(baseOptions: Apollo.QueryHookOptions<GetUserDataForRoomOccurrenceQuery, GetUserDataForRoomOccurrenceQueryVariables> & ({ variables: GetUserDataForRoomOccurrenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDataForRoomOccurrenceQuery, GetUserDataForRoomOccurrenceQueryVariables>(GetUserDataForRoomOccurrenceDocument, options);
      }
export function useGetUserDataForRoomOccurrenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDataForRoomOccurrenceQuery, GetUserDataForRoomOccurrenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDataForRoomOccurrenceQuery, GetUserDataForRoomOccurrenceQueryVariables>(GetUserDataForRoomOccurrenceDocument, options);
        }
export function useGetUserDataForRoomOccurrenceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserDataForRoomOccurrenceQuery, GetUserDataForRoomOccurrenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserDataForRoomOccurrenceQuery, GetUserDataForRoomOccurrenceQueryVariables>(GetUserDataForRoomOccurrenceDocument, options);
        }
export type GetUserDataForRoomOccurrenceQueryHookResult = ReturnType<typeof useGetUserDataForRoomOccurrenceQuery>;
export type GetUserDataForRoomOccurrenceLazyQueryHookResult = ReturnType<typeof useGetUserDataForRoomOccurrenceLazyQuery>;
export type GetUserDataForRoomOccurrenceSuspenseQueryHookResult = ReturnType<typeof useGetUserDataForRoomOccurrenceSuspenseQuery>;
export type GetUserDataForRoomOccurrenceQueryResult = Apollo.QueryResult<GetUserDataForRoomOccurrenceQuery, GetUserDataForRoomOccurrenceQueryVariables>;
export const SavePersonalNoteForRoomServiceOccurrencesDocument = gql`
    mutation savePersonalNoteForRoomServiceOccurrences($personalData: userDataRoomServiceOccurrences_insert_input!) {
  insert_userDataRoomServiceOccurrences_one(
    object: $personalData
    on_conflict: {constraint: userDataRoomServiceOccurrences_pkey, update_columns: [data]}
  ) {
    roomServiceOccurrenceId
    data
  }
}
    `;
export type SavePersonalNoteForRoomServiceOccurrencesMutationFn = Apollo.MutationFunction<SavePersonalNoteForRoomServiceOccurrencesMutation, SavePersonalNoteForRoomServiceOccurrencesMutationVariables>;

/**
 * __useSavePersonalNoteForRoomServiceOccurrencesMutation__
 *
 * To run a mutation, you first call `useSavePersonalNoteForRoomServiceOccurrencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePersonalNoteForRoomServiceOccurrencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePersonalNoteForRoomServiceOccurrencesMutation, { data, loading, error }] = useSavePersonalNoteForRoomServiceOccurrencesMutation({
 *   variables: {
 *      personalData: // value for 'personalData'
 *   },
 * });
 */
export function useSavePersonalNoteForRoomServiceOccurrencesMutation(baseOptions?: Apollo.MutationHookOptions<SavePersonalNoteForRoomServiceOccurrencesMutation, SavePersonalNoteForRoomServiceOccurrencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePersonalNoteForRoomServiceOccurrencesMutation, SavePersonalNoteForRoomServiceOccurrencesMutationVariables>(SavePersonalNoteForRoomServiceOccurrencesDocument, options);
      }
export type SavePersonalNoteForRoomServiceOccurrencesMutationHookResult = ReturnType<typeof useSavePersonalNoteForRoomServiceOccurrencesMutation>;
export type SavePersonalNoteForRoomServiceOccurrencesMutationResult = Apollo.MutationResult<SavePersonalNoteForRoomServiceOccurrencesMutation>;
export type SavePersonalNoteForRoomServiceOccurrencesMutationOptions = Apollo.BaseMutationOptions<SavePersonalNoteForRoomServiceOccurrencesMutation, SavePersonalNoteForRoomServiceOccurrencesMutationVariables>;
export const SavePersonalNoteForRoomOccurrencesDocument = gql`
    mutation savePersonalNoteForRoomOccurrences($personalData: userDataRoomOccurrences_insert_input!) {
  insert_userDataRoomOccurrences_one(
    object: $personalData
    on_conflict: {constraint: userDataRoomOccurrences_pkey, update_columns: [data]}
  ) {
    roomOccurrenceId
    data
  }
}
    `;
export type SavePersonalNoteForRoomOccurrencesMutationFn = Apollo.MutationFunction<SavePersonalNoteForRoomOccurrencesMutation, SavePersonalNoteForRoomOccurrencesMutationVariables>;

/**
 * __useSavePersonalNoteForRoomOccurrencesMutation__
 *
 * To run a mutation, you first call `useSavePersonalNoteForRoomOccurrencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePersonalNoteForRoomOccurrencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePersonalNoteForRoomOccurrencesMutation, { data, loading, error }] = useSavePersonalNoteForRoomOccurrencesMutation({
 *   variables: {
 *      personalData: // value for 'personalData'
 *   },
 * });
 */
export function useSavePersonalNoteForRoomOccurrencesMutation(baseOptions?: Apollo.MutationHookOptions<SavePersonalNoteForRoomOccurrencesMutation, SavePersonalNoteForRoomOccurrencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePersonalNoteForRoomOccurrencesMutation, SavePersonalNoteForRoomOccurrencesMutationVariables>(SavePersonalNoteForRoomOccurrencesDocument, options);
      }
export type SavePersonalNoteForRoomOccurrencesMutationHookResult = ReturnType<typeof useSavePersonalNoteForRoomOccurrencesMutation>;
export type SavePersonalNoteForRoomOccurrencesMutationResult = Apollo.MutationResult<SavePersonalNoteForRoomOccurrencesMutation>;
export type SavePersonalNoteForRoomOccurrencesMutationOptions = Apollo.BaseMutationOptions<SavePersonalNoteForRoomOccurrencesMutation, SavePersonalNoteForRoomOccurrencesMutationVariables>;
export const InsertRoomDocument = gql`
    mutation insertRoom($roomData: rooms_insert_input!) {
  insert_rooms_one(object: $roomData) {
    id
    name
    description
    shortDescription
    roomServices(order_by: {order: asc}) {
      id
      name
      order
    }
    roomFolderId
  }
}
    `;
export type InsertRoomMutationFn = Apollo.MutationFunction<InsertRoomMutation, InsertRoomMutationVariables>;

/**
 * __useInsertRoomMutation__
 *
 * To run a mutation, you first call `useInsertRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertRoomMutation, { data, loading, error }] = useInsertRoomMutation({
 *   variables: {
 *      roomData: // value for 'roomData'
 *   },
 * });
 */
export function useInsertRoomMutation(baseOptions?: Apollo.MutationHookOptions<InsertRoomMutation, InsertRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertRoomMutation, InsertRoomMutationVariables>(InsertRoomDocument, options);
      }
export type InsertRoomMutationHookResult = ReturnType<typeof useInsertRoomMutation>;
export type InsertRoomMutationResult = Apollo.MutationResult<InsertRoomMutation>;
export type InsertRoomMutationOptions = Apollo.BaseMutationOptions<InsertRoomMutation, InsertRoomMutationVariables>;
export const GetRoomByIdDocument = gql`
    query getRoomById($id: bigint!) {
  rooms_by_pk(id: $id) {
    id
    name
    description
    shortDescription
    roomFolderId
  }
}
    `;

/**
 * __useGetRoomByIdQuery__
 *
 * To run a query within a React component, call `useGetRoomByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRoomByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRoomByIdQuery, GetRoomByIdQueryVariables> & ({ variables: GetRoomByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomByIdQuery, GetRoomByIdQueryVariables>(GetRoomByIdDocument, options);
      }
export function useGetRoomByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomByIdQuery, GetRoomByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomByIdQuery, GetRoomByIdQueryVariables>(GetRoomByIdDocument, options);
        }
export function useGetRoomByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoomByIdQuery, GetRoomByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoomByIdQuery, GetRoomByIdQueryVariables>(GetRoomByIdDocument, options);
        }
export type GetRoomByIdQueryHookResult = ReturnType<typeof useGetRoomByIdQuery>;
export type GetRoomByIdLazyQueryHookResult = ReturnType<typeof useGetRoomByIdLazyQuery>;
export type GetRoomByIdSuspenseQueryHookResult = ReturnType<typeof useGetRoomByIdSuspenseQuery>;
export type GetRoomByIdQueryResult = Apollo.QueryResult<GetRoomByIdQuery, GetRoomByIdQueryVariables>;
export const GetRoomByIdDetailedDocument = gql`
    query getRoomByIdDetailed($id: bigint!) {
  rooms_by_pk(id: $id) {
    id
    name
    description
    shortDescription
    roomServices(order_by: {order: asc}) {
      id
      name
      description
      roomServiceCategoryId
      roomServiceCategory {
        id
        name
      }
      order
      roomAttributeGroups(order_by: {order: asc_nulls_last}) {
        id
        order
        description
        name
        valuesRepeatable
        roomAttributes(order_by: {order: asc}) {
          attributeType
          order
          config
          createdAt
          description
          id
          name
          updatedAt
          roomAttributeFiles {
            fileId
            file {
              id
              size
              name
              extension
            }
          }
        }
      }
    }
    roomFolderId
  }
}
    `;

/**
 * __useGetRoomByIdDetailedQuery__
 *
 * To run a query within a React component, call `useGetRoomByIdDetailedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomByIdDetailedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomByIdDetailedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRoomByIdDetailedQuery(baseOptions: Apollo.QueryHookOptions<GetRoomByIdDetailedQuery, GetRoomByIdDetailedQueryVariables> & ({ variables: GetRoomByIdDetailedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomByIdDetailedQuery, GetRoomByIdDetailedQueryVariables>(GetRoomByIdDetailedDocument, options);
      }
export function useGetRoomByIdDetailedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomByIdDetailedQuery, GetRoomByIdDetailedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomByIdDetailedQuery, GetRoomByIdDetailedQueryVariables>(GetRoomByIdDetailedDocument, options);
        }
export function useGetRoomByIdDetailedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoomByIdDetailedQuery, GetRoomByIdDetailedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoomByIdDetailedQuery, GetRoomByIdDetailedQueryVariables>(GetRoomByIdDetailedDocument, options);
        }
export type GetRoomByIdDetailedQueryHookResult = ReturnType<typeof useGetRoomByIdDetailedQuery>;
export type GetRoomByIdDetailedLazyQueryHookResult = ReturnType<typeof useGetRoomByIdDetailedLazyQuery>;
export type GetRoomByIdDetailedSuspenseQueryHookResult = ReturnType<typeof useGetRoomByIdDetailedSuspenseQuery>;
export type GetRoomByIdDetailedQueryResult = Apollo.QueryResult<GetRoomByIdDetailedQuery, GetRoomByIdDetailedQueryVariables>;
export const GetMatrixStructureDocument = gql`
    query GetMatrixStructure($eventId: bigint!) {
  events_by_pk(id: $eventId) {
    guestCanEditRoommatrix
  }
  roomFolders(order_by: [{order: asc}, {name: asc}]) {
    id
    name
    parentId
    order
    rooms(
      where: {_or: [{eventId: {_is_null: true}}, {eventId: {_eq: $eventId}}]}
      order_by: [{order: asc}, {name: asc}]
    ) {
      id
      name
      description
      shortDescription
      order
      roomServices(order_by: [{order: asc}, {name: asc}]) {
        id
        name
        order
        description
        roomServiceCategoryId
        roomServiceCategory {
          name
        }
      }
    }
  }
  rooms(
    where: {_and: [{roomFolderId: {_is_null: true}}, {_or: [{eventId: {_is_null: true}}, {eventId: {_eq: $eventId}}]}]}
    order_by: [{order: asc}, {name: asc}]
  ) {
    id
    name
    description
    shortDescription
    roomFolderId
    order
    roomServices(order_by: [{order: asc}, {name: asc}]) {
      id
      name
      order
      description
      roomServiceCategoryId
      roomServiceCategory {
        name
      }
    }
  }
}
    `;

/**
 * __useGetMatrixStructureQuery__
 *
 * To run a query within a React component, call `useGetMatrixStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatrixStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatrixStructureQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetMatrixStructureQuery(baseOptions: Apollo.QueryHookOptions<GetMatrixStructureQuery, GetMatrixStructureQueryVariables> & ({ variables: GetMatrixStructureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatrixStructureQuery, GetMatrixStructureQueryVariables>(GetMatrixStructureDocument, options);
      }
export function useGetMatrixStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatrixStructureQuery, GetMatrixStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatrixStructureQuery, GetMatrixStructureQueryVariables>(GetMatrixStructureDocument, options);
        }
export function useGetMatrixStructureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMatrixStructureQuery, GetMatrixStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMatrixStructureQuery, GetMatrixStructureQueryVariables>(GetMatrixStructureDocument, options);
        }
export type GetMatrixStructureQueryHookResult = ReturnType<typeof useGetMatrixStructureQuery>;
export type GetMatrixStructureLazyQueryHookResult = ReturnType<typeof useGetMatrixStructureLazyQuery>;
export type GetMatrixStructureSuspenseQueryHookResult = ReturnType<typeof useGetMatrixStructureSuspenseQuery>;
export type GetMatrixStructureQueryResult = Apollo.QueryResult<GetMatrixStructureQuery, GetMatrixStructureQueryVariables>;
export const GetMultipleMatrixStructuresDocument = gql`
    query GetMultipleMatrixStructures($eventIds: [bigint!]!) {
  events(where: {id: {_in: $eventIds}}) {
    guestCanEditRoommatrix
  }
  roomFolders(order_by: [{order: asc}, {name: asc}]) {
    id
    name
    parentId
    order
    rooms(
      where: {_or: [{eventId: {_is_null: true}}, {eventId: {_in: $eventIds}}]}
      order_by: [{order: asc}, {name: asc}]
    ) {
      id
      name
      description
      shortDescription
      order
      eventId
      roomServices(order_by: [{order: asc}, {name: asc}]) {
        id
        name
        order
        description
        roomServiceCategoryId
        roomServiceCategory {
          name
        }
      }
    }
  }
  rooms(
    where: {_and: [{roomFolderId: {_is_null: true}}, {_or: [{eventId: {_is_null: true}}, {eventId: {_in: $eventIds}}]}]}
    order_by: [{order: asc}, {name: asc}]
  ) {
    id
    name
    description
    shortDescription
    roomFolderId
    order
    eventId
    roomServices(order_by: [{order: asc}, {name: asc}]) {
      id
      name
      order
      description
      roomServiceCategoryId
      roomServiceCategory {
        name
      }
    }
  }
}
    `;

/**
 * __useGetMultipleMatrixStructuresQuery__
 *
 * To run a query within a React component, call `useGetMultipleMatrixStructuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultipleMatrixStructuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultipleMatrixStructuresQuery({
 *   variables: {
 *      eventIds: // value for 'eventIds'
 *   },
 * });
 */
export function useGetMultipleMatrixStructuresQuery(baseOptions: Apollo.QueryHookOptions<GetMultipleMatrixStructuresQuery, GetMultipleMatrixStructuresQueryVariables> & ({ variables: GetMultipleMatrixStructuresQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMultipleMatrixStructuresQuery, GetMultipleMatrixStructuresQueryVariables>(GetMultipleMatrixStructuresDocument, options);
      }
export function useGetMultipleMatrixStructuresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMultipleMatrixStructuresQuery, GetMultipleMatrixStructuresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMultipleMatrixStructuresQuery, GetMultipleMatrixStructuresQueryVariables>(GetMultipleMatrixStructuresDocument, options);
        }
export function useGetMultipleMatrixStructuresSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMultipleMatrixStructuresQuery, GetMultipleMatrixStructuresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMultipleMatrixStructuresQuery, GetMultipleMatrixStructuresQueryVariables>(GetMultipleMatrixStructuresDocument, options);
        }
export type GetMultipleMatrixStructuresQueryHookResult = ReturnType<typeof useGetMultipleMatrixStructuresQuery>;
export type GetMultipleMatrixStructuresLazyQueryHookResult = ReturnType<typeof useGetMultipleMatrixStructuresLazyQuery>;
export type GetMultipleMatrixStructuresSuspenseQueryHookResult = ReturnType<typeof useGetMultipleMatrixStructuresSuspenseQuery>;
export type GetMultipleMatrixStructuresQueryResult = Apollo.QueryResult<GetMultipleMatrixStructuresQuery, GetMultipleMatrixStructuresQueryVariables>;
export const RoomFolderListDocument = gql`
    query roomFolderList {
  roomFolders {
    id
    name
    parentId
    order
  }
}
    `;

/**
 * __useRoomFolderListQuery__
 *
 * To run a query within a React component, call `useRoomFolderListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomFolderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomFolderListQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoomFolderListQuery(baseOptions?: Apollo.QueryHookOptions<RoomFolderListQuery, RoomFolderListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomFolderListQuery, RoomFolderListQueryVariables>(RoomFolderListDocument, options);
      }
export function useRoomFolderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomFolderListQuery, RoomFolderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomFolderListQuery, RoomFolderListQueryVariables>(RoomFolderListDocument, options);
        }
export function useRoomFolderListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RoomFolderListQuery, RoomFolderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RoomFolderListQuery, RoomFolderListQueryVariables>(RoomFolderListDocument, options);
        }
export type RoomFolderListQueryHookResult = ReturnType<typeof useRoomFolderListQuery>;
export type RoomFolderListLazyQueryHookResult = ReturnType<typeof useRoomFolderListLazyQuery>;
export type RoomFolderListSuspenseQueryHookResult = ReturnType<typeof useRoomFolderListSuspenseQuery>;
export type RoomFolderListQueryResult = Apollo.QueryResult<RoomFolderListQuery, RoomFolderListQueryVariables>;
export const RoomListDocument = gql`
    query roomList($where: rooms_bool_exp!) {
  rooms(where: $where) {
    id
    name
    roomFolderId
    shortDescription
    description
    order
    fromRoomId
    eventId
    roomServices(order_by: {order: asc}) {
      id
      name
      description
      roomServiceCategory {
        id
        name
      }
      order
    }
  }
  roomFolders {
    id
    name
    parentId
    order
  }
}
    `;

/**
 * __useRoomListQuery__
 *
 * To run a query within a React component, call `useRoomListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomListQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRoomListQuery(baseOptions: Apollo.QueryHookOptions<RoomListQuery, RoomListQueryVariables> & ({ variables: RoomListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomListQuery, RoomListQueryVariables>(RoomListDocument, options);
      }
export function useRoomListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomListQuery, RoomListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomListQuery, RoomListQueryVariables>(RoomListDocument, options);
        }
export function useRoomListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RoomListQuery, RoomListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RoomListQuery, RoomListQueryVariables>(RoomListDocument, options);
        }
export type RoomListQueryHookResult = ReturnType<typeof useRoomListQuery>;
export type RoomListLazyQueryHookResult = ReturnType<typeof useRoomListLazyQuery>;
export type RoomListSuspenseQueryHookResult = ReturnType<typeof useRoomListSuspenseQuery>;
export type RoomListQueryResult = Apollo.QueryResult<RoomListQuery, RoomListQueryVariables>;
export const GetRoomOccurrenceIntersectionsDocument = gql`
    query getRoomOccurrenceIntersections($where: roomOccurrence_intersections_bool_exp!) {
  roomOccurrence_intersections(
    where: $where
    order_by: [{startDate: asc}, {id: asc}]
  ) {
    _id
    id
    name
    startDate
    endDate
    event {
      id
      name
    }
    room {
      id
      name
    }
  }
}
    `;

/**
 * __useGetRoomOccurrenceIntersectionsQuery__
 *
 * To run a query within a React component, call `useGetRoomOccurrenceIntersectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomOccurrenceIntersectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomOccurrenceIntersectionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetRoomOccurrenceIntersectionsQuery(baseOptions: Apollo.QueryHookOptions<GetRoomOccurrenceIntersectionsQuery, GetRoomOccurrenceIntersectionsQueryVariables> & ({ variables: GetRoomOccurrenceIntersectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomOccurrenceIntersectionsQuery, GetRoomOccurrenceIntersectionsQueryVariables>(GetRoomOccurrenceIntersectionsDocument, options);
      }
export function useGetRoomOccurrenceIntersectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomOccurrenceIntersectionsQuery, GetRoomOccurrenceIntersectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomOccurrenceIntersectionsQuery, GetRoomOccurrenceIntersectionsQueryVariables>(GetRoomOccurrenceIntersectionsDocument, options);
        }
export function useGetRoomOccurrenceIntersectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoomOccurrenceIntersectionsQuery, GetRoomOccurrenceIntersectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoomOccurrenceIntersectionsQuery, GetRoomOccurrenceIntersectionsQueryVariables>(GetRoomOccurrenceIntersectionsDocument, options);
        }
export type GetRoomOccurrenceIntersectionsQueryHookResult = ReturnType<typeof useGetRoomOccurrenceIntersectionsQuery>;
export type GetRoomOccurrenceIntersectionsLazyQueryHookResult = ReturnType<typeof useGetRoomOccurrenceIntersectionsLazyQuery>;
export type GetRoomOccurrenceIntersectionsSuspenseQueryHookResult = ReturnType<typeof useGetRoomOccurrenceIntersectionsSuspenseQuery>;
export type GetRoomOccurrenceIntersectionsQueryResult = Apollo.QueryResult<GetRoomOccurrenceIntersectionsQuery, GetRoomOccurrenceIntersectionsQueryVariables>;
export const InsertRoomOccurenceDocument = gql`
    mutation insertRoomOccurence($roomOccurrence: roomOccurrences_insert_input!) {
  insert_roomOccurrences_one(object: $roomOccurrence) {
    id
    name
    startDate
    endDate
    eventId
    wantAirConditioning
    userData {
      data
    }
  }
}
    `;
export type InsertRoomOccurenceMutationFn = Apollo.MutationFunction<InsertRoomOccurenceMutation, InsertRoomOccurenceMutationVariables>;

/**
 * __useInsertRoomOccurenceMutation__
 *
 * To run a mutation, you first call `useInsertRoomOccurenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertRoomOccurenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertRoomOccurenceMutation, { data, loading, error }] = useInsertRoomOccurenceMutation({
 *   variables: {
 *      roomOccurrence: // value for 'roomOccurrence'
 *   },
 * });
 */
export function useInsertRoomOccurenceMutation(baseOptions?: Apollo.MutationHookOptions<InsertRoomOccurenceMutation, InsertRoomOccurenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertRoomOccurenceMutation, InsertRoomOccurenceMutationVariables>(InsertRoomOccurenceDocument, options);
      }
export type InsertRoomOccurenceMutationHookResult = ReturnType<typeof useInsertRoomOccurenceMutation>;
export type InsertRoomOccurenceMutationResult = Apollo.MutationResult<InsertRoomOccurenceMutation>;
export type InsertRoomOccurenceMutationOptions = Apollo.BaseMutationOptions<InsertRoomOccurenceMutation, InsertRoomOccurenceMutationVariables>;
export const InsertMultipleOccurencesDocument = gql`
    mutation insertMultipleOccurences($roomOccurrences: [roomOccurrences_insert_input!]!, $roomServiceOccurrences: [roomServiceOccurrences_insert_input!]!) {
  insert_roomOccurrences(objects: $roomOccurrences) {
    affected_rows
    returning {
      id
      name
      startDate
      endDate
      eventId
      wantAirConditioning
      userData {
        data
      }
    }
  }
  insert_roomServiceOccurrences(objects: $roomServiceOccurrences) {
    affected_rows
    returning {
      id
      name
      startDate
      endDate
      eventId
      userData {
        data
      }
    }
  }
}
    `;
export type InsertMultipleOccurencesMutationFn = Apollo.MutationFunction<InsertMultipleOccurencesMutation, InsertMultipleOccurencesMutationVariables>;

/**
 * __useInsertMultipleOccurencesMutation__
 *
 * To run a mutation, you first call `useInsertMultipleOccurencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertMultipleOccurencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertMultipleOccurencesMutation, { data, loading, error }] = useInsertMultipleOccurencesMutation({
 *   variables: {
 *      roomOccurrences: // value for 'roomOccurrences'
 *      roomServiceOccurrences: // value for 'roomServiceOccurrences'
 *   },
 * });
 */
export function useInsertMultipleOccurencesMutation(baseOptions?: Apollo.MutationHookOptions<InsertMultipleOccurencesMutation, InsertMultipleOccurencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertMultipleOccurencesMutation, InsertMultipleOccurencesMutationVariables>(InsertMultipleOccurencesDocument, options);
      }
export type InsertMultipleOccurencesMutationHookResult = ReturnType<typeof useInsertMultipleOccurencesMutation>;
export type InsertMultipleOccurencesMutationResult = Apollo.MutationResult<InsertMultipleOccurencesMutation>;
export type InsertMultipleOccurencesMutationOptions = Apollo.BaseMutationOptions<InsertMultipleOccurencesMutation, InsertMultipleOccurencesMutationVariables>;
export const UpdateRoomOccurrenceDocument = gql`
    mutation updateRoomOccurrence($id: bigint!, $roomOccurrence: roomOccurrences_set_input) {
  update_roomOccurrences_by_pk(pk_columns: {id: $id}, _set: $roomOccurrence) {
    id
    name
    startDate
    endDate
    eventId
    wantAirConditioning
    userData {
      data
    }
  }
}
    `;
export type UpdateRoomOccurrenceMutationFn = Apollo.MutationFunction<UpdateRoomOccurrenceMutation, UpdateRoomOccurrenceMutationVariables>;

/**
 * __useUpdateRoomOccurrenceMutation__
 *
 * To run a mutation, you first call `useUpdateRoomOccurrenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomOccurrenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomOccurrenceMutation, { data, loading, error }] = useUpdateRoomOccurrenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      roomOccurrence: // value for 'roomOccurrence'
 *   },
 * });
 */
export function useUpdateRoomOccurrenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomOccurrenceMutation, UpdateRoomOccurrenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoomOccurrenceMutation, UpdateRoomOccurrenceMutationVariables>(UpdateRoomOccurrenceDocument, options);
      }
export type UpdateRoomOccurrenceMutationHookResult = ReturnType<typeof useUpdateRoomOccurrenceMutation>;
export type UpdateRoomOccurrenceMutationResult = Apollo.MutationResult<UpdateRoomOccurrenceMutation>;
export type UpdateRoomOccurrenceMutationOptions = Apollo.BaseMutationOptions<UpdateRoomOccurrenceMutation, UpdateRoomOccurrenceMutationVariables>;
export const UpdateMultipleRoomOccurrencesDocument = gql`
    mutation updateMultipleRoomOccurrences($updates: [roomOccurrences_updates!]!) {
  update_roomOccurrences_many(updates: $updates) {
    affected_rows
    returning {
      id
      name
      startDate
      endDate
      eventId
      wantAirConditioning
      userData {
        data
      }
    }
  }
}
    `;
export type UpdateMultipleRoomOccurrencesMutationFn = Apollo.MutationFunction<UpdateMultipleRoomOccurrencesMutation, UpdateMultipleRoomOccurrencesMutationVariables>;

/**
 * __useUpdateMultipleRoomOccurrencesMutation__
 *
 * To run a mutation, you first call `useUpdateMultipleRoomOccurrencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMultipleRoomOccurrencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMultipleRoomOccurrencesMutation, { data, loading, error }] = useUpdateMultipleRoomOccurrencesMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateMultipleRoomOccurrencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMultipleRoomOccurrencesMutation, UpdateMultipleRoomOccurrencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMultipleRoomOccurrencesMutation, UpdateMultipleRoomOccurrencesMutationVariables>(UpdateMultipleRoomOccurrencesDocument, options);
      }
export type UpdateMultipleRoomOccurrencesMutationHookResult = ReturnType<typeof useUpdateMultipleRoomOccurrencesMutation>;
export type UpdateMultipleRoomOccurrencesMutationResult = Apollo.MutationResult<UpdateMultipleRoomOccurrencesMutation>;
export type UpdateMultipleRoomOccurrencesMutationOptions = Apollo.BaseMutationOptions<UpdateMultipleRoomOccurrencesMutation, UpdateMultipleRoomOccurrencesMutationVariables>;
export const UpdateOccurrencesShallowDocument = gql`
    mutation updateOccurrencesShallow($roomOccurrenceUpdates: [roomOccurrences_updates!]!, $roomServiceOccurrencesUpdates: [roomServiceOccurrences_updates!]!) {
  update_roomOccurrences_many(updates: $roomOccurrenceUpdates) {
    affected_rows
    returning {
      id
      name
      startDate
      endDate
      eventId
      wantAirConditioning
      userData {
        data
      }
    }
  }
  update_roomServiceOccurrences_many(updates: $roomServiceOccurrencesUpdates) {
    affected_rows
    returning {
      id
      name
      startDate
      endDate
      eventId
    }
  }
}
    `;
export type UpdateOccurrencesShallowMutationFn = Apollo.MutationFunction<UpdateOccurrencesShallowMutation, UpdateOccurrencesShallowMutationVariables>;

/**
 * __useUpdateOccurrencesShallowMutation__
 *
 * To run a mutation, you first call `useUpdateOccurrencesShallowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOccurrencesShallowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOccurrencesShallowMutation, { data, loading, error }] = useUpdateOccurrencesShallowMutation({
 *   variables: {
 *      roomOccurrenceUpdates: // value for 'roomOccurrenceUpdates'
 *      roomServiceOccurrencesUpdates: // value for 'roomServiceOccurrencesUpdates'
 *   },
 * });
 */
export function useUpdateOccurrencesShallowMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOccurrencesShallowMutation, UpdateOccurrencesShallowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOccurrencesShallowMutation, UpdateOccurrencesShallowMutationVariables>(UpdateOccurrencesShallowDocument, options);
      }
export type UpdateOccurrencesShallowMutationHookResult = ReturnType<typeof useUpdateOccurrencesShallowMutation>;
export type UpdateOccurrencesShallowMutationResult = Apollo.MutationResult<UpdateOccurrencesShallowMutation>;
export type UpdateOccurrencesShallowMutationOptions = Apollo.BaseMutationOptions<UpdateOccurrencesShallowMutation, UpdateOccurrencesShallowMutationVariables>;
export const DeleteRoomOccurenceByIdDocument = gql`
    mutation deleteRoomOccurenceById($roomOccurrenceId: bigint!) {
  delete_roomOccurrences_by_pk(id: $roomOccurrenceId) {
    id
    name
  }
}
    `;
export type DeleteRoomOccurenceByIdMutationFn = Apollo.MutationFunction<DeleteRoomOccurenceByIdMutation, DeleteRoomOccurenceByIdMutationVariables>;

/**
 * __useDeleteRoomOccurenceByIdMutation__
 *
 * To run a mutation, you first call `useDeleteRoomOccurenceByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoomOccurenceByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoomOccurenceByIdMutation, { data, loading, error }] = useDeleteRoomOccurenceByIdMutation({
 *   variables: {
 *      roomOccurrenceId: // value for 'roomOccurrenceId'
 *   },
 * });
 */
export function useDeleteRoomOccurenceByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoomOccurenceByIdMutation, DeleteRoomOccurenceByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoomOccurenceByIdMutation, DeleteRoomOccurenceByIdMutationVariables>(DeleteRoomOccurenceByIdDocument, options);
      }
export type DeleteRoomOccurenceByIdMutationHookResult = ReturnType<typeof useDeleteRoomOccurenceByIdMutation>;
export type DeleteRoomOccurenceByIdMutationResult = Apollo.MutationResult<DeleteRoomOccurenceByIdMutation>;
export type DeleteRoomOccurenceByIdMutationOptions = Apollo.BaseMutationOptions<DeleteRoomOccurenceByIdMutation, DeleteRoomOccurenceByIdMutationVariables>;
export const DeleteRoomOccurencesDocument = gql`
    mutation deleteRoomOccurences($ids: [bigint!]!) {
  delete_roomOccurrences(where: {id: {_in: $ids}}) {
    affected_rows
    returning {
      id
      name
    }
  }
}
    `;
export type DeleteRoomOccurencesMutationFn = Apollo.MutationFunction<DeleteRoomOccurencesMutation, DeleteRoomOccurencesMutationVariables>;

/**
 * __useDeleteRoomOccurencesMutation__
 *
 * To run a mutation, you first call `useDeleteRoomOccurencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoomOccurencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoomOccurencesMutation, { data, loading, error }] = useDeleteRoomOccurencesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteRoomOccurencesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoomOccurencesMutation, DeleteRoomOccurencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoomOccurencesMutation, DeleteRoomOccurencesMutationVariables>(DeleteRoomOccurencesDocument, options);
      }
export type DeleteRoomOccurencesMutationHookResult = ReturnType<typeof useDeleteRoomOccurencesMutation>;
export type DeleteRoomOccurencesMutationResult = Apollo.MutationResult<DeleteRoomOccurencesMutation>;
export type DeleteRoomOccurencesMutationOptions = Apollo.BaseMutationOptions<DeleteRoomOccurencesMutation, DeleteRoomOccurencesMutationVariables>;
export const DeleteOccurencesDocument = gql`
    mutation deleteOccurences($roomOccurrenceIds: [bigint!]!, $roomServiceOccurrenceIds: [bigint!]!) {
  delete_roomOccurrences(where: {id: {_in: $roomOccurrenceIds}}) {
    affected_rows
    returning {
      id
      name
    }
  }
  delete_roomServiceOccurrences(where: {id: {_in: $roomServiceOccurrenceIds}}) {
    affected_rows
    returning {
      id
      name
    }
  }
}
    `;
export type DeleteOccurencesMutationFn = Apollo.MutationFunction<DeleteOccurencesMutation, DeleteOccurencesMutationVariables>;

/**
 * __useDeleteOccurencesMutation__
 *
 * To run a mutation, you first call `useDeleteOccurencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOccurencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOccurencesMutation, { data, loading, error }] = useDeleteOccurencesMutation({
 *   variables: {
 *      roomOccurrenceIds: // value for 'roomOccurrenceIds'
 *      roomServiceOccurrenceIds: // value for 'roomServiceOccurrenceIds'
 *   },
 * });
 */
export function useDeleteOccurencesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOccurencesMutation, DeleteOccurencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOccurencesMutation, DeleteOccurencesMutationVariables>(DeleteOccurencesDocument, options);
      }
export type DeleteOccurencesMutationHookResult = ReturnType<typeof useDeleteOccurencesMutation>;
export type DeleteOccurencesMutationResult = Apollo.MutationResult<DeleteOccurencesMutation>;
export type DeleteOccurencesMutationOptions = Apollo.BaseMutationOptions<DeleteOccurencesMutation, DeleteOccurencesMutationVariables>;
export const SetRoomOccurenceIsDraftDocument = gql`
    mutation setRoomOccurenceIsDraft($id: bigint!, $isDraft: Boolean!) {
  update_roomOccurrences_by_pk(pk_columns: {id: $id}, _set: {isDraft: $isDraft}) {
    id
    isDraft
  }
}
    `;
export type SetRoomOccurenceIsDraftMutationFn = Apollo.MutationFunction<SetRoomOccurenceIsDraftMutation, SetRoomOccurenceIsDraftMutationVariables>;

/**
 * __useSetRoomOccurenceIsDraftMutation__
 *
 * To run a mutation, you first call `useSetRoomOccurenceIsDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRoomOccurenceIsDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRoomOccurenceIsDraftMutation, { data, loading, error }] = useSetRoomOccurenceIsDraftMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isDraft: // value for 'isDraft'
 *   },
 * });
 */
export function useSetRoomOccurenceIsDraftMutation(baseOptions?: Apollo.MutationHookOptions<SetRoomOccurenceIsDraftMutation, SetRoomOccurenceIsDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRoomOccurenceIsDraftMutation, SetRoomOccurenceIsDraftMutationVariables>(SetRoomOccurenceIsDraftDocument, options);
      }
export type SetRoomOccurenceIsDraftMutationHookResult = ReturnType<typeof useSetRoomOccurenceIsDraftMutation>;
export type SetRoomOccurenceIsDraftMutationResult = Apollo.MutationResult<SetRoomOccurenceIsDraftMutation>;
export type SetRoomOccurenceIsDraftMutationOptions = Apollo.BaseMutationOptions<SetRoomOccurenceIsDraftMutation, SetRoomOccurenceIsDraftMutationVariables>;
export const RoomServiceCategoryListDocument = gql`
    query roomServiceCategoryList {
  roomServiceCategories(order_by: {name: asc}) {
    id
    name
  }
}
    `;

/**
 * __useRoomServiceCategoryListQuery__
 *
 * To run a query within a React component, call `useRoomServiceCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomServiceCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomServiceCategoryListQuery({
 *   variables: {
 *   },
 * });
 */
export function useRoomServiceCategoryListQuery(baseOptions?: Apollo.QueryHookOptions<RoomServiceCategoryListQuery, RoomServiceCategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoomServiceCategoryListQuery, RoomServiceCategoryListQueryVariables>(RoomServiceCategoryListDocument, options);
      }
export function useRoomServiceCategoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoomServiceCategoryListQuery, RoomServiceCategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoomServiceCategoryListQuery, RoomServiceCategoryListQueryVariables>(RoomServiceCategoryListDocument, options);
        }
export function useRoomServiceCategoryListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RoomServiceCategoryListQuery, RoomServiceCategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RoomServiceCategoryListQuery, RoomServiceCategoryListQueryVariables>(RoomServiceCategoryListDocument, options);
        }
export type RoomServiceCategoryListQueryHookResult = ReturnType<typeof useRoomServiceCategoryListQuery>;
export type RoomServiceCategoryListLazyQueryHookResult = ReturnType<typeof useRoomServiceCategoryListLazyQuery>;
export type RoomServiceCategoryListSuspenseQueryHookResult = ReturnType<typeof useRoomServiceCategoryListSuspenseQuery>;
export type RoomServiceCategoryListQueryResult = Apollo.QueryResult<RoomServiceCategoryListQuery, RoomServiceCategoryListQueryVariables>;
export const InsertRoomServiceOccurenceDocument = gql`
    mutation insertRoomServiceOccurence($roomServiceOccurrence: roomServiceOccurrences_insert_input!) {
  insert_roomServiceOccurrences_one(object: $roomServiceOccurrence) {
    id
    name
    startDate
    endDate
    eventId
  }
}
    `;
export type InsertRoomServiceOccurenceMutationFn = Apollo.MutationFunction<InsertRoomServiceOccurenceMutation, InsertRoomServiceOccurenceMutationVariables>;

/**
 * __useInsertRoomServiceOccurenceMutation__
 *
 * To run a mutation, you first call `useInsertRoomServiceOccurenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertRoomServiceOccurenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertRoomServiceOccurenceMutation, { data, loading, error }] = useInsertRoomServiceOccurenceMutation({
 *   variables: {
 *      roomServiceOccurrence: // value for 'roomServiceOccurrence'
 *   },
 * });
 */
export function useInsertRoomServiceOccurenceMutation(baseOptions?: Apollo.MutationHookOptions<InsertRoomServiceOccurenceMutation, InsertRoomServiceOccurenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertRoomServiceOccurenceMutation, InsertRoomServiceOccurenceMutationVariables>(InsertRoomServiceOccurenceDocument, options);
      }
export type InsertRoomServiceOccurenceMutationHookResult = ReturnType<typeof useInsertRoomServiceOccurenceMutation>;
export type InsertRoomServiceOccurenceMutationResult = Apollo.MutationResult<InsertRoomServiceOccurenceMutation>;
export type InsertRoomServiceOccurenceMutationOptions = Apollo.BaseMutationOptions<InsertRoomServiceOccurenceMutation, InsertRoomServiceOccurenceMutationVariables>;
export const UpdateRoomServiceOccurrenceDocument = gql`
    mutation updateRoomServiceOccurrence($id: bigint!, $roomServiceOccurrence: roomServiceOccurrences_set_input, $roomAttributeValues: [roomAttributeValues_insert_input!]!, $roomAttributeValueGroups: [roomAttributeValueGroups_insert_input!]!, $roomAttributeValueGroupIdsToDelete: [bigint!]!, $roomAttributeValueUploadsToInsert: [roomAttributeValueUploads_insert_input!]!, $roomAttributeValueUploadsToDelete: [bigint!]!, $roomAttributeValueUploadVersionsToInsert: [roomAttributeValueUploadVersions_insert_input!]!, $roomAttributeValueUploadVersionsToDelete: [roomAttributeValueUploadVersions_bool_exp!]!) {
  update_roomServiceOccurrences_by_pk(
    pk_columns: {id: $id}
    _set: $roomServiceOccurrence
  ) {
    id
    name
    startDate
    endDate
    eventId
  }
  insert_roomAttributeValues(
    objects: $roomAttributeValues
    on_conflict: {constraint: roomAttributeValues_roomAttributeId_roomAttributeValueGroup_key, update_columns: value}
  ) {
    affected_rows
    returning {
      id
      roomAttributeId
      roomAttributeValueGroupId
      value
      roomAttributeValueUploads {
        ...RoomAttributeValueUploadFileList
      }
    }
  }
  insert_roomAttributeValueGroups(objects: $roomAttributeValueGroups) {
    affected_rows
    returning {
      id
      roomAttributeGroupId
      roomServiceOccurrenceId
      roomAttributeValues {
        id
        roomAttributeId
        roomAttributeValueGroupId
        value
        roomAttributeValueUploads {
          ...RoomAttributeValueUploadFileList
        }
      }
    }
  }
  delete_roomAttributeValueGroups(
    where: {id: {_in: $roomAttributeValueGroupIdsToDelete}}
  ) {
    affected_rows
    returning {
      id
    }
  }
  delete_roomAttributeValueUploads(
    where: {id: {_in: $roomAttributeValueUploadsToDelete}}
  ) {
    affected_rows
    returning {
      id
    }
  }
  delete_roomAttributeValueUploadVersions(
    where: {_or: $roomAttributeValueUploadVersionsToDelete}
  ) {
    affected_rows
  }
  insert_roomAttributeValueUploads(objects: $roomAttributeValueUploadsToInsert) {
    returning {
      id
      roomAttributeValueId
    }
  }
  insert_roomAttributeValueUploadVersions(
    objects: $roomAttributeValueUploadVersionsToInsert
  ) {
    returning {
      roomAttributeValueUploadId
      fileId
    }
  }
}
    ${RoomAttributeValueUploadFileListFragmentDoc}`;
export type UpdateRoomServiceOccurrenceMutationFn = Apollo.MutationFunction<UpdateRoomServiceOccurrenceMutation, UpdateRoomServiceOccurrenceMutationVariables>;

/**
 * __useUpdateRoomServiceOccurrenceMutation__
 *
 * To run a mutation, you first call `useUpdateRoomServiceOccurrenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomServiceOccurrenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomServiceOccurrenceMutation, { data, loading, error }] = useUpdateRoomServiceOccurrenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      roomServiceOccurrence: // value for 'roomServiceOccurrence'
 *      roomAttributeValues: // value for 'roomAttributeValues'
 *      roomAttributeValueGroups: // value for 'roomAttributeValueGroups'
 *      roomAttributeValueGroupIdsToDelete: // value for 'roomAttributeValueGroupIdsToDelete'
 *      roomAttributeValueUploadsToInsert: // value for 'roomAttributeValueUploadsToInsert'
 *      roomAttributeValueUploadsToDelete: // value for 'roomAttributeValueUploadsToDelete'
 *      roomAttributeValueUploadVersionsToInsert: // value for 'roomAttributeValueUploadVersionsToInsert'
 *      roomAttributeValueUploadVersionsToDelete: // value for 'roomAttributeValueUploadVersionsToDelete'
 *   },
 * });
 */
export function useUpdateRoomServiceOccurrenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomServiceOccurrenceMutation, UpdateRoomServiceOccurrenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoomServiceOccurrenceMutation, UpdateRoomServiceOccurrenceMutationVariables>(UpdateRoomServiceOccurrenceDocument, options);
      }
export type UpdateRoomServiceOccurrenceMutationHookResult = ReturnType<typeof useUpdateRoomServiceOccurrenceMutation>;
export type UpdateRoomServiceOccurrenceMutationResult = Apollo.MutationResult<UpdateRoomServiceOccurrenceMutation>;
export type UpdateRoomServiceOccurrenceMutationOptions = Apollo.BaseMutationOptions<UpdateRoomServiceOccurrenceMutation, UpdateRoomServiceOccurrenceMutationVariables>;
export const UpdateRoomServiceOccurrencesBasicInfoOnlyDocument = gql`
    mutation updateRoomServiceOccurrencesBasicInfoOnly($id: bigint!, $roomServiceOccurrence: roomServiceOccurrences_set_input) {
  update_roomServiceOccurrences_by_pk(
    pk_columns: {id: $id}
    _set: $roomServiceOccurrence
  ) {
    id
    name
    startDate
    endDate
    eventId
  }
}
    `;
export type UpdateRoomServiceOccurrencesBasicInfoOnlyMutationFn = Apollo.MutationFunction<UpdateRoomServiceOccurrencesBasicInfoOnlyMutation, UpdateRoomServiceOccurrencesBasicInfoOnlyMutationVariables>;

/**
 * __useUpdateRoomServiceOccurrencesBasicInfoOnlyMutation__
 *
 * To run a mutation, you first call `useUpdateRoomServiceOccurrencesBasicInfoOnlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomServiceOccurrencesBasicInfoOnlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomServiceOccurrencesBasicInfoOnlyMutation, { data, loading, error }] = useUpdateRoomServiceOccurrencesBasicInfoOnlyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      roomServiceOccurrence: // value for 'roomServiceOccurrence'
 *   },
 * });
 */
export function useUpdateRoomServiceOccurrencesBasicInfoOnlyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomServiceOccurrencesBasicInfoOnlyMutation, UpdateRoomServiceOccurrencesBasicInfoOnlyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoomServiceOccurrencesBasicInfoOnlyMutation, UpdateRoomServiceOccurrencesBasicInfoOnlyMutationVariables>(UpdateRoomServiceOccurrencesBasicInfoOnlyDocument, options);
      }
export type UpdateRoomServiceOccurrencesBasicInfoOnlyMutationHookResult = ReturnType<typeof useUpdateRoomServiceOccurrencesBasicInfoOnlyMutation>;
export type UpdateRoomServiceOccurrencesBasicInfoOnlyMutationResult = Apollo.MutationResult<UpdateRoomServiceOccurrencesBasicInfoOnlyMutation>;
export type UpdateRoomServiceOccurrencesBasicInfoOnlyMutationOptions = Apollo.BaseMutationOptions<UpdateRoomServiceOccurrencesBasicInfoOnlyMutation, UpdateRoomServiceOccurrencesBasicInfoOnlyMutationVariables>;
export const DeleteRoomServiceOccurenceByIdDocument = gql`
    mutation deleteRoomServiceOccurenceById($roomServiceOccurrenceId: bigint!) {
  delete_roomServiceOccurrences_by_pk(id: $roomServiceOccurrenceId) {
    id
    name
  }
}
    `;
export type DeleteRoomServiceOccurenceByIdMutationFn = Apollo.MutationFunction<DeleteRoomServiceOccurenceByIdMutation, DeleteRoomServiceOccurenceByIdMutationVariables>;

/**
 * __useDeleteRoomServiceOccurenceByIdMutation__
 *
 * To run a mutation, you first call `useDeleteRoomServiceOccurenceByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoomServiceOccurenceByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoomServiceOccurenceByIdMutation, { data, loading, error }] = useDeleteRoomServiceOccurenceByIdMutation({
 *   variables: {
 *      roomServiceOccurrenceId: // value for 'roomServiceOccurrenceId'
 *   },
 * });
 */
export function useDeleteRoomServiceOccurenceByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoomServiceOccurenceByIdMutation, DeleteRoomServiceOccurenceByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoomServiceOccurenceByIdMutation, DeleteRoomServiceOccurenceByIdMutationVariables>(DeleteRoomServiceOccurenceByIdDocument, options);
      }
export type DeleteRoomServiceOccurenceByIdMutationHookResult = ReturnType<typeof useDeleteRoomServiceOccurenceByIdMutation>;
export type DeleteRoomServiceOccurenceByIdMutationResult = Apollo.MutationResult<DeleteRoomServiceOccurenceByIdMutation>;
export type DeleteRoomServiceOccurenceByIdMutationOptions = Apollo.BaseMutationOptions<DeleteRoomServiceOccurenceByIdMutation, DeleteRoomServiceOccurenceByIdMutationVariables>;
export const DeleteRoomServiceOccurencesDocument = gql`
    mutation deleteRoomServiceOccurences($ids: [bigint!]!) {
  delete_roomServiceOccurrences(where: {id: {_in: $ids}}) {
    affected_rows
    returning {
      id
      name
    }
  }
}
    `;
export type DeleteRoomServiceOccurencesMutationFn = Apollo.MutationFunction<DeleteRoomServiceOccurencesMutation, DeleteRoomServiceOccurencesMutationVariables>;

/**
 * __useDeleteRoomServiceOccurencesMutation__
 *
 * To run a mutation, you first call `useDeleteRoomServiceOccurencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoomServiceOccurencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoomServiceOccurencesMutation, { data, loading, error }] = useDeleteRoomServiceOccurencesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteRoomServiceOccurencesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoomServiceOccurencesMutation, DeleteRoomServiceOccurencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoomServiceOccurencesMutation, DeleteRoomServiceOccurencesMutationVariables>(DeleteRoomServiceOccurencesDocument, options);
      }
export type DeleteRoomServiceOccurencesMutationHookResult = ReturnType<typeof useDeleteRoomServiceOccurencesMutation>;
export type DeleteRoomServiceOccurencesMutationResult = Apollo.MutationResult<DeleteRoomServiceOccurencesMutation>;
export type DeleteRoomServiceOccurencesMutationOptions = Apollo.BaseMutationOptions<DeleteRoomServiceOccurencesMutation, DeleteRoomServiceOccurencesMutationVariables>;
export const SetRoomServiceOccurenceIsDraftDocument = gql`
    mutation setRoomServiceOccurenceIsDraft($id: bigint!, $isDraft: Boolean!) {
  update_roomServiceOccurrences_by_pk(
    pk_columns: {id: $id}
    _set: {isDraft: $isDraft}
  ) {
    id
    isDraft
  }
}
    `;
export type SetRoomServiceOccurenceIsDraftMutationFn = Apollo.MutationFunction<SetRoomServiceOccurenceIsDraftMutation, SetRoomServiceOccurenceIsDraftMutationVariables>;

/**
 * __useSetRoomServiceOccurenceIsDraftMutation__
 *
 * To run a mutation, you first call `useSetRoomServiceOccurenceIsDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRoomServiceOccurenceIsDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRoomServiceOccurenceIsDraftMutation, { data, loading, error }] = useSetRoomServiceOccurenceIsDraftMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isDraft: // value for 'isDraft'
 *   },
 * });
 */
export function useSetRoomServiceOccurenceIsDraftMutation(baseOptions?: Apollo.MutationHookOptions<SetRoomServiceOccurenceIsDraftMutation, SetRoomServiceOccurenceIsDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRoomServiceOccurenceIsDraftMutation, SetRoomServiceOccurenceIsDraftMutationVariables>(SetRoomServiceOccurenceIsDraftDocument, options);
      }
export type SetRoomServiceOccurenceIsDraftMutationHookResult = ReturnType<typeof useSetRoomServiceOccurenceIsDraftMutation>;
export type SetRoomServiceOccurenceIsDraftMutationResult = Apollo.MutationResult<SetRoomServiceOccurenceIsDraftMutation>;
export type SetRoomServiceOccurenceIsDraftMutationOptions = Apollo.BaseMutationOptions<SetRoomServiceOccurenceIsDraftMutation, SetRoomServiceOccurenceIsDraftMutationVariables>;
export const GetRoomServiceOccurrenceDocument = gql`
    query getRoomServiceOccurrence($id: bigint!, $fetchLastUpdatedInfo: Boolean = true) {
  roomServiceOccurrences_by_pk(id: $id) {
    id
    name
    startDate
    endDate
    userData {
      data
    }
    event {
      id
      name
      startDate
      endDate
    }
    roomService {
      id
      name
      order
      description
      roomAttributeGroups(order_by: {order: asc}) {
        id
        name
        description
        valuesRepeatable
        order
        roomAttributes(order_by: {order: asc}) {
          id
          name
          attributeType
          config
          description
          roomAttributeGroupId
          roomAttributeFiles {
            roomAttributeId
            fileId
            file {
              id
              size
              name
              extension
            }
            downloadUrl
          }
        }
      }
    }
    roomAttributeValueGroups(order_by: {id: asc}) {
      id
      roomAttributeGroupId
      roomAttributeValues {
        roomAttributeId
        id
        value
        createdAt
        updatedAt
        updatedBy @include(if: $fetchLastUpdatedInfo)
        user @include(if: $fetchLastUpdatedInfo) {
          id
          firstName
          lastName
        }
        comments_aggregate {
          aggregate {
            count
          }
        }
        roomAttributeValueUploads {
          ...RoomAttributeValueUploadFileList
        }
      }
    }
  }
}
    ${RoomAttributeValueUploadFileListFragmentDoc}`;

/**
 * __useGetRoomServiceOccurrenceQuery__
 *
 * To run a query within a React component, call `useGetRoomServiceOccurrenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomServiceOccurrenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomServiceOccurrenceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      fetchLastUpdatedInfo: // value for 'fetchLastUpdatedInfo'
 *   },
 * });
 */
export function useGetRoomServiceOccurrenceQuery(baseOptions: Apollo.QueryHookOptions<GetRoomServiceOccurrenceQuery, GetRoomServiceOccurrenceQueryVariables> & ({ variables: GetRoomServiceOccurrenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomServiceOccurrenceQuery, GetRoomServiceOccurrenceQueryVariables>(GetRoomServiceOccurrenceDocument, options);
      }
export function useGetRoomServiceOccurrenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomServiceOccurrenceQuery, GetRoomServiceOccurrenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomServiceOccurrenceQuery, GetRoomServiceOccurrenceQueryVariables>(GetRoomServiceOccurrenceDocument, options);
        }
export function useGetRoomServiceOccurrenceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoomServiceOccurrenceQuery, GetRoomServiceOccurrenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoomServiceOccurrenceQuery, GetRoomServiceOccurrenceQueryVariables>(GetRoomServiceOccurrenceDocument, options);
        }
export type GetRoomServiceOccurrenceQueryHookResult = ReturnType<typeof useGetRoomServiceOccurrenceQuery>;
export type GetRoomServiceOccurrenceLazyQueryHookResult = ReturnType<typeof useGetRoomServiceOccurrenceLazyQuery>;
export type GetRoomServiceOccurrenceSuspenseQueryHookResult = ReturnType<typeof useGetRoomServiceOccurrenceSuspenseQuery>;
export type GetRoomServiceOccurrenceQueryResult = Apollo.QueryResult<GetRoomServiceOccurrenceQuery, GetRoomServiceOccurrenceQueryVariables>;
export const GetRoomServiceOccurrencesDocument = gql`
    query getRoomServiceOccurrences($ids: [bigint!]!, $fetchLastUpdatedInfo: Boolean = true) {
  roomServiceOccurrences(where: {id: {_in: $ids}}) {
    id
    name
    startDate
    endDate
    isDraft
    userData {
      data
    }
    event {
      id
      name
      startDate
      endDate
    }
    roomService {
      id
      name
      order
      description
      roomAttributeGroups(order_by: {order: asc}) {
        id
        name
        description
        valuesRepeatable
        order
        roomAttributes(order_by: {order: asc}) {
          id
          name
          attributeType
          config
          description
          roomAttributeGroupId
          roomAttributeFiles {
            roomAttributeId
            fileId
            file {
              id
              size
              name
              extension
            }
            downloadUrl
          }
        }
      }
    }
    roomAttributeValueGroups(order_by: {id: asc}) {
      id
      roomAttributeGroupId
      roomAttributeValues {
        roomAttributeId
        id
        value
        createdAt
        updatedAt
        updatedBy @include(if: $fetchLastUpdatedInfo)
        user @include(if: $fetchLastUpdatedInfo) {
          id
          firstName
          lastName
        }
        comments_aggregate {
          aggregate {
            count
          }
        }
        roomAttributeValueUploads {
          ...RoomAttributeValueUploadFileList
        }
      }
    }
  }
}
    ${RoomAttributeValueUploadFileListFragmentDoc}`;

/**
 * __useGetRoomServiceOccurrencesQuery__
 *
 * To run a query within a React component, call `useGetRoomServiceOccurrencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomServiceOccurrencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomServiceOccurrencesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      fetchLastUpdatedInfo: // value for 'fetchLastUpdatedInfo'
 *   },
 * });
 */
export function useGetRoomServiceOccurrencesQuery(baseOptions: Apollo.QueryHookOptions<GetRoomServiceOccurrencesQuery, GetRoomServiceOccurrencesQueryVariables> & ({ variables: GetRoomServiceOccurrencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomServiceOccurrencesQuery, GetRoomServiceOccurrencesQueryVariables>(GetRoomServiceOccurrencesDocument, options);
      }
export function useGetRoomServiceOccurrencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomServiceOccurrencesQuery, GetRoomServiceOccurrencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomServiceOccurrencesQuery, GetRoomServiceOccurrencesQueryVariables>(GetRoomServiceOccurrencesDocument, options);
        }
export function useGetRoomServiceOccurrencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoomServiceOccurrencesQuery, GetRoomServiceOccurrencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoomServiceOccurrencesQuery, GetRoomServiceOccurrencesQueryVariables>(GetRoomServiceOccurrencesDocument, options);
        }
export type GetRoomServiceOccurrencesQueryHookResult = ReturnType<typeof useGetRoomServiceOccurrencesQuery>;
export type GetRoomServiceOccurrencesLazyQueryHookResult = ReturnType<typeof useGetRoomServiceOccurrencesLazyQuery>;
export type GetRoomServiceOccurrencesSuspenseQueryHookResult = ReturnType<typeof useGetRoomServiceOccurrencesSuspenseQuery>;
export type GetRoomServiceOccurrencesQueryResult = Apollo.QueryResult<GetRoomServiceOccurrencesQuery, GetRoomServiceOccurrencesQueryVariables>;
export const GetRoomServiceByIdDocument = gql`
    query getRoomServiceById($id: bigint!) {
  roomServices_by_pk(id: $id) {
    id
    name
    order
    roomServiceCategoryId
    roomAttributeGroups(order_by: {order: asc}) {
      id
      name
      description
      valuesRepeatable
      order
      roomAttributeValueGroups(
        where: {roomServiceOccurrenceId: {_eq: $id}}
        order_by: {id: asc}
      ) {
        id
        roomAttributeGroupId
        roomAttributeValues {
          id
          value
          roomAttributeValueGroupId
          roomAttributeId
          createdAt
          updatedAt
          roomAttributeValueUploads {
            ...RoomAttributeValueUploadFileList
          }
        }
      }
      roomAttributes(order_by: {order: asc}) {
        id
        name
        attributeType
        config
        description
        roomAttributeGroupId
        roomAttributeFiles {
          roomAttributeId
          fileId
          file {
            id
            size
            name
            extension
          }
          downloadUrl
        }
      }
    }
  }
}
    ${RoomAttributeValueUploadFileListFragmentDoc}`;

/**
 * __useGetRoomServiceByIdQuery__
 *
 * To run a query within a React component, call `useGetRoomServiceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomServiceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomServiceByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRoomServiceByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRoomServiceByIdQuery, GetRoomServiceByIdQueryVariables> & ({ variables: GetRoomServiceByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomServiceByIdQuery, GetRoomServiceByIdQueryVariables>(GetRoomServiceByIdDocument, options);
      }
export function useGetRoomServiceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomServiceByIdQuery, GetRoomServiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomServiceByIdQuery, GetRoomServiceByIdQueryVariables>(GetRoomServiceByIdDocument, options);
        }
export function useGetRoomServiceByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoomServiceByIdQuery, GetRoomServiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoomServiceByIdQuery, GetRoomServiceByIdQueryVariables>(GetRoomServiceByIdDocument, options);
        }
export type GetRoomServiceByIdQueryHookResult = ReturnType<typeof useGetRoomServiceByIdQuery>;
export type GetRoomServiceByIdLazyQueryHookResult = ReturnType<typeof useGetRoomServiceByIdLazyQuery>;
export type GetRoomServiceByIdSuspenseQueryHookResult = ReturnType<typeof useGetRoomServiceByIdSuspenseQuery>;
export type GetRoomServiceByIdQueryResult = Apollo.QueryResult<GetRoomServiceByIdQuery, GetRoomServiceByIdQueryVariables>;
export const GetRoomAttributeGroupByIdDocument = gql`
    query getRoomAttributeGroupById($id: bigint!) {
  roomAttributeGroups_by_pk(id: $id) {
    roomAttributes {
      roomAttributeValues {
        value
      }
    }
  }
}
    `;

/**
 * __useGetRoomAttributeGroupByIdQuery__
 *
 * To run a query within a React component, call `useGetRoomAttributeGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomAttributeGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomAttributeGroupByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRoomAttributeGroupByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRoomAttributeGroupByIdQuery, GetRoomAttributeGroupByIdQueryVariables> & ({ variables: GetRoomAttributeGroupByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomAttributeGroupByIdQuery, GetRoomAttributeGroupByIdQueryVariables>(GetRoomAttributeGroupByIdDocument, options);
      }
export function useGetRoomAttributeGroupByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomAttributeGroupByIdQuery, GetRoomAttributeGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomAttributeGroupByIdQuery, GetRoomAttributeGroupByIdQueryVariables>(GetRoomAttributeGroupByIdDocument, options);
        }
export function useGetRoomAttributeGroupByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoomAttributeGroupByIdQuery, GetRoomAttributeGroupByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoomAttributeGroupByIdQuery, GetRoomAttributeGroupByIdQueryVariables>(GetRoomAttributeGroupByIdDocument, options);
        }
export type GetRoomAttributeGroupByIdQueryHookResult = ReturnType<typeof useGetRoomAttributeGroupByIdQuery>;
export type GetRoomAttributeGroupByIdLazyQueryHookResult = ReturnType<typeof useGetRoomAttributeGroupByIdLazyQuery>;
export type GetRoomAttributeGroupByIdSuspenseQueryHookResult = ReturnType<typeof useGetRoomAttributeGroupByIdSuspenseQuery>;
export type GetRoomAttributeGroupByIdQueryResult = Apollo.QueryResult<GetRoomAttributeGroupByIdQuery, GetRoomAttributeGroupByIdQueryVariables>;
export const GetRoomAttributeByIdDocument = gql`
    query getRoomAttributeById($id: bigint!) {
  roomAttributes_by_pk(id: $id) {
    roomAttributeValues {
      value
    }
  }
}
    `;

/**
 * __useGetRoomAttributeByIdQuery__
 *
 * To run a query within a React component, call `useGetRoomAttributeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomAttributeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomAttributeByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRoomAttributeByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRoomAttributeByIdQuery, GetRoomAttributeByIdQueryVariables> & ({ variables: GetRoomAttributeByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomAttributeByIdQuery, GetRoomAttributeByIdQueryVariables>(GetRoomAttributeByIdDocument, options);
      }
export function useGetRoomAttributeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomAttributeByIdQuery, GetRoomAttributeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomAttributeByIdQuery, GetRoomAttributeByIdQueryVariables>(GetRoomAttributeByIdDocument, options);
        }
export function useGetRoomAttributeByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoomAttributeByIdQuery, GetRoomAttributeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoomAttributeByIdQuery, GetRoomAttributeByIdQueryVariables>(GetRoomAttributeByIdDocument, options);
        }
export type GetRoomAttributeByIdQueryHookResult = ReturnType<typeof useGetRoomAttributeByIdQuery>;
export type GetRoomAttributeByIdLazyQueryHookResult = ReturnType<typeof useGetRoomAttributeByIdLazyQuery>;
export type GetRoomAttributeByIdSuspenseQueryHookResult = ReturnType<typeof useGetRoomAttributeByIdSuspenseQuery>;
export type GetRoomAttributeByIdQueryResult = Apollo.QueryResult<GetRoomAttributeByIdQuery, GetRoomAttributeByIdQueryVariables>;
export const UpdateRoomFolderDocument = gql`
    mutation updateRoomFolder($id: bigint!, $updates: roomFolders_set_input!) {
  update_roomFolders_by_pk(pk_columns: {id: $id}, _set: $updates) {
    id
    name
    parentId
  }
}
    `;
export type UpdateRoomFolderMutationFn = Apollo.MutationFunction<UpdateRoomFolderMutation, UpdateRoomFolderMutationVariables>;

/**
 * __useUpdateRoomFolderMutation__
 *
 * To run a mutation, you first call `useUpdateRoomFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomFolderMutation, { data, loading, error }] = useUpdateRoomFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateRoomFolderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomFolderMutation, UpdateRoomFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoomFolderMutation, UpdateRoomFolderMutationVariables>(UpdateRoomFolderDocument, options);
      }
export type UpdateRoomFolderMutationHookResult = ReturnType<typeof useUpdateRoomFolderMutation>;
export type UpdateRoomFolderMutationResult = Apollo.MutationResult<UpdateRoomFolderMutation>;
export type UpdateRoomFolderMutationOptions = Apollo.BaseMutationOptions<UpdateRoomFolderMutation, UpdateRoomFolderMutationVariables>;
export const UpdateRoomDocument = gql`
    mutation updateRoom($id: bigint!, $roomData: rooms_set_input, $newRoomServices: [roomServices_insert_input!]!, $roomServiceIdsToDelete: [bigint!]) {
  update_rooms_by_pk(pk_columns: {id: $id}, _set: $roomData) {
    id
    name
    shortDescription
    description
    roomFolderId
  }
  insert_roomServices(objects: $newRoomServices) {
    returning {
      id
      name
      roomId
      order
    }
  }
  delete_roomServices(where: {id: {_in: $roomServiceIdsToDelete}}) {
    affected_rows
    returning {
      id
      name
    }
  }
}
    `;
export type UpdateRoomMutationFn = Apollo.MutationFunction<UpdateRoomMutation, UpdateRoomMutationVariables>;

/**
 * __useUpdateRoomMutation__
 *
 * To run a mutation, you first call `useUpdateRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomMutation, { data, loading, error }] = useUpdateRoomMutation({
 *   variables: {
 *      id: // value for 'id'
 *      roomData: // value for 'roomData'
 *      newRoomServices: // value for 'newRoomServices'
 *      roomServiceIdsToDelete: // value for 'roomServiceIdsToDelete'
 *   },
 * });
 */
export function useUpdateRoomMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoomMutation, UpdateRoomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoomMutation, UpdateRoomMutationVariables>(UpdateRoomDocument, options);
      }
export type UpdateRoomMutationHookResult = ReturnType<typeof useUpdateRoomMutation>;
export type UpdateRoomMutationResult = Apollo.MutationResult<UpdateRoomMutation>;
export type UpdateRoomMutationOptions = Apollo.BaseMutationOptions<UpdateRoomMutation, UpdateRoomMutationVariables>;
export const SetUsersLastRoomServiceOccurrenceVisitDocument = gql`
    mutation setUsersLastRoomServiceOccurrenceVisit($roomServiceOccurrenceAccesses: [userRoomServiceOccurrenceLastVisits_insert_input!]!) {
  insert_userRoomServiceOccurrenceLastVisits(
    objects: $roomServiceOccurrenceAccesses
    on_conflict: {constraint: userRoomServiceOccurrenceLastVisits_pkey, update_columns: updatedAt}
  ) {
    returning {
      roomServiceOccurrenceId
    }
    affected_rows
  }
}
    `;
export type SetUsersLastRoomServiceOccurrenceVisitMutationFn = Apollo.MutationFunction<SetUsersLastRoomServiceOccurrenceVisitMutation, SetUsersLastRoomServiceOccurrenceVisitMutationVariables>;

/**
 * __useSetUsersLastRoomServiceOccurrenceVisitMutation__
 *
 * To run a mutation, you first call `useSetUsersLastRoomServiceOccurrenceVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUsersLastRoomServiceOccurrenceVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUsersLastRoomServiceOccurrenceVisitMutation, { data, loading, error }] = useSetUsersLastRoomServiceOccurrenceVisitMutation({
 *   variables: {
 *      roomServiceOccurrenceAccesses: // value for 'roomServiceOccurrenceAccesses'
 *   },
 * });
 */
export function useSetUsersLastRoomServiceOccurrenceVisitMutation(baseOptions?: Apollo.MutationHookOptions<SetUsersLastRoomServiceOccurrenceVisitMutation, SetUsersLastRoomServiceOccurrenceVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUsersLastRoomServiceOccurrenceVisitMutation, SetUsersLastRoomServiceOccurrenceVisitMutationVariables>(SetUsersLastRoomServiceOccurrenceVisitDocument, options);
      }
export type SetUsersLastRoomServiceOccurrenceVisitMutationHookResult = ReturnType<typeof useSetUsersLastRoomServiceOccurrenceVisitMutation>;
export type SetUsersLastRoomServiceOccurrenceVisitMutationResult = Apollo.MutationResult<SetUsersLastRoomServiceOccurrenceVisitMutation>;
export type SetUsersLastRoomServiceOccurrenceVisitMutationOptions = Apollo.BaseMutationOptions<SetUsersLastRoomServiceOccurrenceVisitMutation, SetUsersLastRoomServiceOccurrenceVisitMutationVariables>;
export const RubinEventListDocument = gql`
    query rubinEventList($where: V_ORGANICE_EVENT_STAMM_bool_exp, $order_by: [V_ORGANICE_EVENT_STAMM_order_by!]) {
  V_ORGANICE_EVENT_STAMM(where: $where, order_by: $order_by) {
    T_HASH_Event
    ID_Rubin
    DIP_ID_Event
    Titel
    Startdatum
    Startuhrzeit
    Enddatum
    Enduhrzeit
    VG_Typ
    Kostentraeger_IDK
  }
}
    `;

/**
 * __useRubinEventListQuery__
 *
 * To run a query within a React component, call `useRubinEventListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRubinEventListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRubinEventListQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useRubinEventListQuery(baseOptions?: Apollo.QueryHookOptions<RubinEventListQuery, RubinEventListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RubinEventListQuery, RubinEventListQueryVariables>(RubinEventListDocument, options);
      }
export function useRubinEventListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RubinEventListQuery, RubinEventListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RubinEventListQuery, RubinEventListQueryVariables>(RubinEventListDocument, options);
        }
export function useRubinEventListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RubinEventListQuery, RubinEventListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RubinEventListQuery, RubinEventListQueryVariables>(RubinEventListDocument, options);
        }
export type RubinEventListQueryHookResult = ReturnType<typeof useRubinEventListQuery>;
export type RubinEventListLazyQueryHookResult = ReturnType<typeof useRubinEventListLazyQuery>;
export type RubinEventListSuspenseQueryHookResult = ReturnType<typeof useRubinEventListSuspenseQuery>;
export type RubinEventListQueryResult = Apollo.QueryResult<RubinEventListQuery, RubinEventListQueryVariables>;
export const RubinEventRoomBookingDocument = gql`
    query rubinEventRoomBooking($where: V_ORGANICE_EVENT_RAUMBUCHUNG_bool_exp, $orderBy: [V_ORGANICE_EVENT_RAUMBUCHUNG_order_by!]) {
  V_ORGANICE_EVENT_RAUMBUCHUNG(where: $where, order_by: $orderBy) {
    Buchungstag
    ID_Raumbuchung
    Nutzungsart_IDK
    Raum_Bez
    T_HASH_Event
  }
}
    `;

/**
 * __useRubinEventRoomBookingQuery__
 *
 * To run a query within a React component, call `useRubinEventRoomBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useRubinEventRoomBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRubinEventRoomBookingQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useRubinEventRoomBookingQuery(baseOptions?: Apollo.QueryHookOptions<RubinEventRoomBookingQuery, RubinEventRoomBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RubinEventRoomBookingQuery, RubinEventRoomBookingQueryVariables>(RubinEventRoomBookingDocument, options);
      }
export function useRubinEventRoomBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RubinEventRoomBookingQuery, RubinEventRoomBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RubinEventRoomBookingQuery, RubinEventRoomBookingQueryVariables>(RubinEventRoomBookingDocument, options);
        }
export function useRubinEventRoomBookingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RubinEventRoomBookingQuery, RubinEventRoomBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RubinEventRoomBookingQuery, RubinEventRoomBookingQueryVariables>(RubinEventRoomBookingDocument, options);
        }
export type RubinEventRoomBookingQueryHookResult = ReturnType<typeof useRubinEventRoomBookingQuery>;
export type RubinEventRoomBookingLazyQueryHookResult = ReturnType<typeof useRubinEventRoomBookingLazyQuery>;
export type RubinEventRoomBookingSuspenseQueryHookResult = ReturnType<typeof useRubinEventRoomBookingSuspenseQuery>;
export type RubinEventRoomBookingQueryResult = Apollo.QueryResult<RubinEventRoomBookingQuery, RubinEventRoomBookingQueryVariables>;
export const SearchServicesDocument = gql`
    query searchServices($eventId: bigint!, $search: String!) {
  files(
    where: {_and: [{_or: [{attributeFiles: {attribute: {attributeGroup: {serviceModule: {service: {eventId: {_eq: $eventId}}}}}}}, {attributeValueUploadVersions: {attributeValueUpload: {attributeValue: {attribute: {attributeGroup: {serviceModule: {service: {eventId: {_eq: $eventId}}}}}}}}}, {roomAttributeValueUploadVersions: {roomAttributeValueUpload: {roomAttributeValue: {roomAttributeValueGroup: {roomServiceOccurrence: {eventId: {_eq: $eventId}}}}}}}, {roomAttributeFiles: {roomAttribute: {roomAttributeGroup: {roomService: {roomServiceOccurrences: {eventId: {_eq: $eventId}}}}}}}]}, {_or: [{name: {_ilike: $search}}, {extension: {_ilike: $search}}]}]}
  ) {
    id
    name
    extension
    mimeType
    size
    attributeFiles(
      where: {attribute: {attributeGroup: {serviceModule: {service: {eventId: {_eq: $eventId}}}}}}
    ) {
      attribute {
        id
        name
        description
        attributeGroup {
          id
          name
          description
          serviceModule {
            id
            name
            service {
              id
              name
            }
          }
        }
      }
    }
    attributeValueUploadVersions {
      attributeValueUpload {
        attributeValue {
          attribute {
            id
            name
            description
            attributeGroup {
              id
              name
              description
              serviceModule {
                id
                name
                service {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
    roomAttributeValueUploadVersions {
      roomAttributeValueUpload {
        roomAttributeValue {
          id
          roomAttributeValueGroup {
            id
            roomServiceOccurrence {
              id
              name
              startDate
              endDate
              roomService {
                id
                name
                description
                room {
                  id
                  name
                  description
                }
              }
            }
          }
          roomAttribute {
            id
            name
            description
            roomAttributeGroup {
              id
              name
              description
            }
          }
        }
      }
    }
    roomAttributeFiles {
      roomAttribute {
        id
        name
        description
        roomAttributeGroup {
          id
          name
          description
          roomService {
            id
            name
            description
            roomServiceOccurrences(where: {eventId: {_eq: $eventId}}) {
              id
              name
              startDate
              endDate
            }
            room {
              id
              name
              description
            }
          }
        }
      }
    }
  }
  attributes(
    where: {_and: [{attributeGroup: {serviceModule: {service: {eventId: {_eq: $eventId}}}}}, {_or: [{name: {_ilike: $search}}, {description: {_ilike: $search}}]}]}
  ) {
    id
    name
    description
    attributeGroup {
      id
      name
      description
      serviceModule {
        id
        name
        service {
          id
          name
        }
      }
    }
  }
  attributeGroups(
    where: {_and: [{serviceModule: {service: {eventId: {_eq: $eventId}}}}, {_or: [{name: {_ilike: $search}}, {description: {_ilike: $search}}]}]}
  ) {
    id
    name
    description
    serviceModule {
      id
      name
      service {
        id
        name
      }
    }
  }
  serviceModules(
    where: {_and: [{service: {eventId: {_eq: $eventId}}}, {name: {_ilike: $search}}]}
  ) {
    id
    name
    service {
      id
      name
    }
  }
  services(where: {_and: [{eventId: {_eq: $eventId}}, {name: {_ilike: $search}}]}) {
    id
    name
  }
  roomOccurrences(
    where: {_and: [{eventId: {_eq: $eventId}}, {name: {_ilike: $search}}]}
  ) {
    id
    name
    startDate
    endDate
    room {
      id
      name
      description
    }
  }
  roomServiceOccurrences(
    where: {_and: [{eventId: {_eq: $eventId}}, {name: {_ilike: $search}}]}
  ) {
    id
    name
    startDate
    endDate
    roomService {
      id
      name
      description
      room {
        id
        name
        description
      }
    }
  }
  roomServiceOccuencesWithMatchingAttributes: roomServiceOccurrences(
    where: {_and: [{eventId: {_eq: $eventId}}, {roomService: {roomAttributeGroups: {roomAttributes: {name: {_ilike: $search}}}}}]}
  ) {
    id
    name
    startDate
    endDate
    roomService {
      id
      name
      room {
        id
        name
        description
      }
      roomAttributeGroups(where: {roomAttributes: {name: {_ilike: $search}}}) {
        id
        name
        roomAttributes(where: {name: {_ilike: $search}}) {
          id
          name
        }
      }
    }
  }
  roomServiceOccuencesWithMatchingAttributeGroups: roomServiceOccurrences(
    where: {_and: [{eventId: {_eq: $eventId}}, {roomService: {roomAttributeGroups: {name: {_ilike: $search}}}}]}
  ) {
    id
    name
    startDate
    endDate
    roomService {
      id
      name
      room {
        id
        name
        description
      }
      roomAttributeGroups(where: {name: {_ilike: $search}}) {
        id
        name
      }
    }
  }
  eventRooms(
    where: {_and: [{eventId: {_eq: $eventId}}, {room: {name: {_ilike: $search}}}]}
  ) {
    room {
      id
      name
      description
    }
  }
}
    `;

/**
 * __useSearchServicesQuery__
 *
 * To run a query within a React component, call `useSearchServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchServicesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchServicesQuery(baseOptions: Apollo.QueryHookOptions<SearchServicesQuery, SearchServicesQueryVariables> & ({ variables: SearchServicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchServicesQuery, SearchServicesQueryVariables>(SearchServicesDocument, options);
      }
export function useSearchServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchServicesQuery, SearchServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchServicesQuery, SearchServicesQueryVariables>(SearchServicesDocument, options);
        }
export function useSearchServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchServicesQuery, SearchServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchServicesQuery, SearchServicesQueryVariables>(SearchServicesDocument, options);
        }
export type SearchServicesQueryHookResult = ReturnType<typeof useSearchServicesQuery>;
export type SearchServicesLazyQueryHookResult = ReturnType<typeof useSearchServicesLazyQuery>;
export type SearchServicesSuspenseQueryHookResult = ReturnType<typeof useSearchServicesSuspenseQuery>;
export type SearchServicesQueryResult = Apollo.QueryResult<SearchServicesQuery, SearchServicesQueryVariables>;
export const GetRoomAttributeValuesForEventDocument = gql`
    query getRoomAttributeValuesForEvent($eventId: bigint!) {
  roomServiceOccurrences(
    where: {_and: [{eventId: {_eq: $eventId}}, {roomAttributeValueGroups: {roomAttributeValues: {value: {_is_null: false}}}}]}
  ) {
    id
    name
    startDate
    endDate
    roomService {
      id
      name
      description
      room {
        id
        name
        description
      }
    }
    roomAttributeValueGroups {
      roomAttributeValues(where: {value: {_is_null: false}}) {
        id
        value
        roomAttribute {
          id
          name
          description
          attributeType
          config
          roomAttributeGroup {
            id
            name
            description
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetRoomAttributeValuesForEventQuery__
 *
 * To run a query within a React component, call `useGetRoomAttributeValuesForEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomAttributeValuesForEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomAttributeValuesForEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRoomAttributeValuesForEventQuery(baseOptions: Apollo.QueryHookOptions<GetRoomAttributeValuesForEventQuery, GetRoomAttributeValuesForEventQueryVariables> & ({ variables: GetRoomAttributeValuesForEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoomAttributeValuesForEventQuery, GetRoomAttributeValuesForEventQueryVariables>(GetRoomAttributeValuesForEventDocument, options);
      }
export function useGetRoomAttributeValuesForEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoomAttributeValuesForEventQuery, GetRoomAttributeValuesForEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoomAttributeValuesForEventQuery, GetRoomAttributeValuesForEventQueryVariables>(GetRoomAttributeValuesForEventDocument, options);
        }
export function useGetRoomAttributeValuesForEventSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoomAttributeValuesForEventQuery, GetRoomAttributeValuesForEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoomAttributeValuesForEventQuery, GetRoomAttributeValuesForEventQueryVariables>(GetRoomAttributeValuesForEventDocument, options);
        }
export type GetRoomAttributeValuesForEventQueryHookResult = ReturnType<typeof useGetRoomAttributeValuesForEventQuery>;
export type GetRoomAttributeValuesForEventLazyQueryHookResult = ReturnType<typeof useGetRoomAttributeValuesForEventLazyQuery>;
export type GetRoomAttributeValuesForEventSuspenseQueryHookResult = ReturnType<typeof useGetRoomAttributeValuesForEventSuspenseQuery>;
export type GetRoomAttributeValuesForEventQueryResult = Apollo.QueryResult<GetRoomAttributeValuesForEventQuery, GetRoomAttributeValuesForEventQueryVariables>;
export const SearchAttributeValuesDocument = gql`
    query searchAttributeValues($eventId: bigint!) {
  attributeValues(
    where: {_and: [{attributeValueGroup: {attributeGroup: {serviceModule: {service: {eventId: {_eq: $eventId}}}}}}]}
  ) {
    id
    value
    attributeId
    attribute {
      id
      name
      attributeType
      config
      attributeGroup {
        id
        name
        serviceModule {
          id
          name
          service {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchAttributeValuesQuery__
 *
 * To run a query within a React component, call `useSearchAttributeValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAttributeValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAttributeValuesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useSearchAttributeValuesQuery(baseOptions: Apollo.QueryHookOptions<SearchAttributeValuesQuery, SearchAttributeValuesQueryVariables> & ({ variables: SearchAttributeValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAttributeValuesQuery, SearchAttributeValuesQueryVariables>(SearchAttributeValuesDocument, options);
      }
export function useSearchAttributeValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAttributeValuesQuery, SearchAttributeValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAttributeValuesQuery, SearchAttributeValuesQueryVariables>(SearchAttributeValuesDocument, options);
        }
export function useSearchAttributeValuesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchAttributeValuesQuery, SearchAttributeValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchAttributeValuesQuery, SearchAttributeValuesQueryVariables>(SearchAttributeValuesDocument, options);
        }
export type SearchAttributeValuesQueryHookResult = ReturnType<typeof useSearchAttributeValuesQuery>;
export type SearchAttributeValuesLazyQueryHookResult = ReturnType<typeof useSearchAttributeValuesLazyQuery>;
export type SearchAttributeValuesSuspenseQueryHookResult = ReturnType<typeof useSearchAttributeValuesSuspenseQuery>;
export type SearchAttributeValuesQueryResult = Apollo.QueryResult<SearchAttributeValuesQuery, SearchAttributeValuesQueryVariables>;
export const SearchFilesDocument = gql`
    query searchFiles($eventId: bigint!, $search: String!) {
  files(
    where: {_and: [{_or: [{attributeFiles: {attribute: {attributeGroup: {serviceModule: {service: {eventId: {_eq: $eventId}}}}}}}, {attributeValueUploadVersions: {attributeValueUpload: {attributeValue: {attribute: {attributeGroup: {serviceModule: {service: {eventId: {_eq: $eventId}}}}}}}}}, {roomAttributeValueUploadVersions: {roomAttributeValueUpload: {roomAttributeValue: {roomAttributeValueGroup: {roomServiceOccurrence: {eventId: {_eq: $eventId}}}}}}}]}, {name: {_ilike: $search}}]}
  ) {
    id
    name
    attributeFiles {
      attribute {
        id
        name
        attributeGroup {
          id
          name
          serviceModule {
            id
            name
            service {
              id
              name
            }
          }
        }
      }
    }
    attributeValueUploadVersions {
      attributeValueUpload {
        attributeValue {
          attribute {
            id
            name
            attributeGroup {
              id
              name
              serviceModule {
                id
                name
                service {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchFilesQuery__
 *
 * To run a query within a React component, call `useSearchFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFilesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchFilesQuery(baseOptions: Apollo.QueryHookOptions<SearchFilesQuery, SearchFilesQueryVariables> & ({ variables: SearchFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchFilesQuery, SearchFilesQueryVariables>(SearchFilesDocument, options);
      }
export function useSearchFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchFilesQuery, SearchFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchFilesQuery, SearchFilesQueryVariables>(SearchFilesDocument, options);
        }
export function useSearchFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchFilesQuery, SearchFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchFilesQuery, SearchFilesQueryVariables>(SearchFilesDocument, options);
        }
export type SearchFilesQueryHookResult = ReturnType<typeof useSearchFilesQuery>;
export type SearchFilesLazyQueryHookResult = ReturnType<typeof useSearchFilesLazyQuery>;
export type SearchFilesSuspenseQueryHookResult = ReturnType<typeof useSearchFilesSuspenseQuery>;
export type SearchFilesQueryResult = Apollo.QueryResult<SearchFilesQuery, SearchFilesQueryVariables>;
export const SearchAttributesDocument = gql`
    query searchAttributes($eventId: bigint!, $search: String!) {
  attributes(
    where: {_and: [{attributeGroup: {serviceModule: {service: {eventId: {_eq: $eventId}}}}}, {_or: [{name: {_ilike: $search}}, {description: {_ilike: $search}}]}]}
  ) {
    id
    name
    description
    attributeGroup {
      id
      name
      description
      serviceModule {
        id
        name
        service {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useSearchAttributesQuery__
 *
 * To run a query within a React component, call `useSearchAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAttributesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchAttributesQuery(baseOptions: Apollo.QueryHookOptions<SearchAttributesQuery, SearchAttributesQueryVariables> & ({ variables: SearchAttributesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAttributesQuery, SearchAttributesQueryVariables>(SearchAttributesDocument, options);
      }
export function useSearchAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAttributesQuery, SearchAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAttributesQuery, SearchAttributesQueryVariables>(SearchAttributesDocument, options);
        }
export function useSearchAttributesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchAttributesQuery, SearchAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchAttributesQuery, SearchAttributesQueryVariables>(SearchAttributesDocument, options);
        }
export type SearchAttributesQueryHookResult = ReturnType<typeof useSearchAttributesQuery>;
export type SearchAttributesLazyQueryHookResult = ReturnType<typeof useSearchAttributesLazyQuery>;
export type SearchAttributesSuspenseQueryHookResult = ReturnType<typeof useSearchAttributesSuspenseQuery>;
export type SearchAttributesQueryResult = Apollo.QueryResult<SearchAttributesQuery, SearchAttributesQueryVariables>;
export const AddAttributeGroupsDocument = gql`
    mutation addAttributeGroups($objects: [attributeGroups_insert_input!]!) {
  insert_attributeGroups(objects: $objects) {
    returning {
      id
    }
  }
}
    `;
export type AddAttributeGroupsMutationFn = Apollo.MutationFunction<AddAttributeGroupsMutation, AddAttributeGroupsMutationVariables>;

/**
 * __useAddAttributeGroupsMutation__
 *
 * To run a mutation, you first call `useAddAttributeGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAttributeGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAttributeGroupsMutation, { data, loading, error }] = useAddAttributeGroupsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddAttributeGroupsMutation(baseOptions?: Apollo.MutationHookOptions<AddAttributeGroupsMutation, AddAttributeGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAttributeGroupsMutation, AddAttributeGroupsMutationVariables>(AddAttributeGroupsDocument, options);
      }
export type AddAttributeGroupsMutationHookResult = ReturnType<typeof useAddAttributeGroupsMutation>;
export type AddAttributeGroupsMutationResult = Apollo.MutationResult<AddAttributeGroupsMutation>;
export type AddAttributeGroupsMutationOptions = Apollo.BaseMutationOptions<AddAttributeGroupsMutation, AddAttributeGroupsMutationVariables>;
export const AddAttributeValueGroupDocument = gql`
    mutation addAttributeValueGroup($object: attributeValueGroups_insert_input!) {
  insert_attributeValueGroups_one(object: $object) {
    id
  }
}
    `;
export type AddAttributeValueGroupMutationFn = Apollo.MutationFunction<AddAttributeValueGroupMutation, AddAttributeValueGroupMutationVariables>;

/**
 * __useAddAttributeValueGroupMutation__
 *
 * To run a mutation, you first call `useAddAttributeValueGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAttributeValueGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAttributeValueGroupMutation, { data, loading, error }] = useAddAttributeValueGroupMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAddAttributeValueGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddAttributeValueGroupMutation, AddAttributeValueGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAttributeValueGroupMutation, AddAttributeValueGroupMutationVariables>(AddAttributeValueGroupDocument, options);
      }
export type AddAttributeValueGroupMutationHookResult = ReturnType<typeof useAddAttributeValueGroupMutation>;
export type AddAttributeValueGroupMutationResult = Apollo.MutationResult<AddAttributeValueGroupMutation>;
export type AddAttributeValueGroupMutationOptions = Apollo.BaseMutationOptions<AddAttributeValueGroupMutation, AddAttributeValueGroupMutationVariables>;
export const AddAttributeValueGroupsDocument = gql`
    mutation addAttributeValueGroups($objects: [attributeValueGroups_insert_input!]!) {
  insert_attributeValueGroups(objects: $objects) {
    affected_rows
  }
}
    `;
export type AddAttributeValueGroupsMutationFn = Apollo.MutationFunction<AddAttributeValueGroupsMutation, AddAttributeValueGroupsMutationVariables>;

/**
 * __useAddAttributeValueGroupsMutation__
 *
 * To run a mutation, you first call `useAddAttributeValueGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAttributeValueGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAttributeValueGroupsMutation, { data, loading, error }] = useAddAttributeValueGroupsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddAttributeValueGroupsMutation(baseOptions?: Apollo.MutationHookOptions<AddAttributeValueGroupsMutation, AddAttributeValueGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAttributeValueGroupsMutation, AddAttributeValueGroupsMutationVariables>(AddAttributeValueGroupsDocument, options);
      }
export type AddAttributeValueGroupsMutationHookResult = ReturnType<typeof useAddAttributeValueGroupsMutation>;
export type AddAttributeValueGroupsMutationResult = Apollo.MutationResult<AddAttributeValueGroupsMutation>;
export type AddAttributeValueGroupsMutationOptions = Apollo.BaseMutationOptions<AddAttributeValueGroupsMutation, AddAttributeValueGroupsMutationVariables>;
export const AddServiceModulesDocument = gql`
    mutation addServiceModules($objects: [serviceModules_insert_input!]!) {
  insert_serviceModules(objects: $objects) {
    returning {
      id
    }
  }
}
    `;
export type AddServiceModulesMutationFn = Apollo.MutationFunction<AddServiceModulesMutation, AddServiceModulesMutationVariables>;

/**
 * __useAddServiceModulesMutation__
 *
 * To run a mutation, you first call `useAddServiceModulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddServiceModulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addServiceModulesMutation, { data, loading, error }] = useAddServiceModulesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddServiceModulesMutation(baseOptions?: Apollo.MutationHookOptions<AddServiceModulesMutation, AddServiceModulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddServiceModulesMutation, AddServiceModulesMutationVariables>(AddServiceModulesDocument, options);
      }
export type AddServiceModulesMutationHookResult = ReturnType<typeof useAddServiceModulesMutation>;
export type AddServiceModulesMutationResult = Apollo.MutationResult<AddServiceModulesMutation>;
export type AddServiceModulesMutationOptions = Apollo.BaseMutationOptions<AddServiceModulesMutation, AddServiceModulesMutationVariables>;
export const AddServiceDocument = gql`
    mutation addService($object: services_insert_input!) {
  insert_services_one(object: $object) {
    createdAt
    updatedAt
    name
    id
  }
}
    `;
export type AddServiceMutationFn = Apollo.MutationFunction<AddServiceMutation, AddServiceMutationVariables>;

/**
 * __useAddServiceMutation__
 *
 * To run a mutation, you first call `useAddServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addServiceMutation, { data, loading, error }] = useAddServiceMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAddServiceMutation(baseOptions?: Apollo.MutationHookOptions<AddServiceMutation, AddServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddServiceMutation, AddServiceMutationVariables>(AddServiceDocument, options);
      }
export type AddServiceMutationHookResult = ReturnType<typeof useAddServiceMutation>;
export type AddServiceMutationResult = Apollo.MutationResult<AddServiceMutation>;
export type AddServiceMutationOptions = Apollo.BaseMutationOptions<AddServiceMutation, AddServiceMutationVariables>;
export const AddServiceFavouriteDocument = gql`
    mutation addServiceFavourite($object: serviceFavourites_insert_input!) {
  insert_serviceFavourites_one(
    object: $object
    on_conflict: {constraint: serviceFavourites_pkey}
  ) {
    serviceId
    userId
  }
}
    `;
export type AddServiceFavouriteMutationFn = Apollo.MutationFunction<AddServiceFavouriteMutation, AddServiceFavouriteMutationVariables>;

/**
 * __useAddServiceFavouriteMutation__
 *
 * To run a mutation, you first call `useAddServiceFavouriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddServiceFavouriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addServiceFavouriteMutation, { data, loading, error }] = useAddServiceFavouriteMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAddServiceFavouriteMutation(baseOptions?: Apollo.MutationHookOptions<AddServiceFavouriteMutation, AddServiceFavouriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddServiceFavouriteMutation, AddServiceFavouriteMutationVariables>(AddServiceFavouriteDocument, options);
      }
export type AddServiceFavouriteMutationHookResult = ReturnType<typeof useAddServiceFavouriteMutation>;
export type AddServiceFavouriteMutationResult = Apollo.MutationResult<AddServiceFavouriteMutation>;
export type AddServiceFavouriteMutationOptions = Apollo.BaseMutationOptions<AddServiceFavouriteMutation, AddServiceFavouriteMutationVariables>;
export const AddServicesDocument = gql`
    mutation addServices($objects: [services_insert_input!]!) {
  insert_services(objects: $objects) {
    affected_rows
  }
}
    `;
export type AddServicesMutationFn = Apollo.MutationFunction<AddServicesMutation, AddServicesMutationVariables>;

/**
 * __useAddServicesMutation__
 *
 * To run a mutation, you first call `useAddServicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddServicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addServicesMutation, { data, loading, error }] = useAddServicesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddServicesMutation(baseOptions?: Apollo.MutationHookOptions<AddServicesMutation, AddServicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddServicesMutation, AddServicesMutationVariables>(AddServicesDocument, options);
      }
export type AddServicesMutationHookResult = ReturnType<typeof useAddServicesMutation>;
export type AddServicesMutationResult = Apollo.MutationResult<AddServicesMutation>;
export type AddServicesMutationOptions = Apollo.BaseMutationOptions<AddServicesMutation, AddServicesMutationVariables>;
export const DeleteServiceModulesDocument = gql`
    mutation deleteServiceModules($where: serviceModules_bool_exp!) {
  delete_serviceModules(where: $where) {
    returning {
      id
    }
  }
}
    `;
export type DeleteServiceModulesMutationFn = Apollo.MutationFunction<DeleteServiceModulesMutation, DeleteServiceModulesMutationVariables>;

/**
 * __useDeleteServiceModulesMutation__
 *
 * To run a mutation, you first call `useDeleteServiceModulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceModulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceModulesMutation, { data, loading, error }] = useDeleteServiceModulesMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteServiceModulesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceModulesMutation, DeleteServiceModulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceModulesMutation, DeleteServiceModulesMutationVariables>(DeleteServiceModulesDocument, options);
      }
export type DeleteServiceModulesMutationHookResult = ReturnType<typeof useDeleteServiceModulesMutation>;
export type DeleteServiceModulesMutationResult = Apollo.MutationResult<DeleteServiceModulesMutation>;
export type DeleteServiceModulesMutationOptions = Apollo.BaseMutationOptions<DeleteServiceModulesMutation, DeleteServiceModulesMutationVariables>;
export const DeleteServiceDocument = gql`
    mutation deleteService($id: bigint!) {
  delete_services_by_pk(id: $id) {
    id
    name
  }
}
    `;
export type DeleteServiceMutationFn = Apollo.MutationFunction<DeleteServiceMutation, DeleteServiceMutationVariables>;

/**
 * __useDeleteServiceMutation__
 *
 * To run a mutation, you first call `useDeleteServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceMutation, { data, loading, error }] = useDeleteServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceMutation, DeleteServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceMutation, DeleteServiceMutationVariables>(DeleteServiceDocument, options);
      }
export type DeleteServiceMutationHookResult = ReturnType<typeof useDeleteServiceMutation>;
export type DeleteServiceMutationResult = Apollo.MutationResult<DeleteServiceMutation>;
export type DeleteServiceMutationOptions = Apollo.BaseMutationOptions<DeleteServiceMutation, DeleteServiceMutationVariables>;
export const DeleteServiceFavouriteDocument = gql`
    mutation deleteServiceFavourite($serviceId: bigint!, $userId: bigint!) {
  delete_serviceFavourites_by_pk(serviceId: $serviceId, userId: $userId) {
    serviceId
    userId
  }
}
    `;
export type DeleteServiceFavouriteMutationFn = Apollo.MutationFunction<DeleteServiceFavouriteMutation, DeleteServiceFavouriteMutationVariables>;

/**
 * __useDeleteServiceFavouriteMutation__
 *
 * To run a mutation, you first call `useDeleteServiceFavouriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceFavouriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceFavouriteMutation, { data, loading, error }] = useDeleteServiceFavouriteMutation({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteServiceFavouriteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceFavouriteMutation, DeleteServiceFavouriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceFavouriteMutation, DeleteServiceFavouriteMutationVariables>(DeleteServiceFavouriteDocument, options);
      }
export type DeleteServiceFavouriteMutationHookResult = ReturnType<typeof useDeleteServiceFavouriteMutation>;
export type DeleteServiceFavouriteMutationResult = Apollo.MutationResult<DeleteServiceFavouriteMutation>;
export type DeleteServiceFavouriteMutationOptions = Apollo.BaseMutationOptions<DeleteServiceFavouriteMutation, DeleteServiceFavouriteMutationVariables>;
export const DeleteAttributeGroupsDocument = gql`
    mutation deleteAttributeGroups($where: attributeGroups_bool_exp!) {
  delete_attributeGroups(where: $where) {
    returning {
      id
    }
  }
}
    `;
export type DeleteAttributeGroupsMutationFn = Apollo.MutationFunction<DeleteAttributeGroupsMutation, DeleteAttributeGroupsMutationVariables>;

/**
 * __useDeleteAttributeGroupsMutation__
 *
 * To run a mutation, you first call `useDeleteAttributeGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttributeGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttributeGroupsMutation, { data, loading, error }] = useDeleteAttributeGroupsMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteAttributeGroupsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttributeGroupsMutation, DeleteAttributeGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttributeGroupsMutation, DeleteAttributeGroupsMutationVariables>(DeleteAttributeGroupsDocument, options);
      }
export type DeleteAttributeGroupsMutationHookResult = ReturnType<typeof useDeleteAttributeGroupsMutation>;
export type DeleteAttributeGroupsMutationResult = Apollo.MutationResult<DeleteAttributeGroupsMutation>;
export type DeleteAttributeGroupsMutationOptions = Apollo.BaseMutationOptions<DeleteAttributeGroupsMutation, DeleteAttributeGroupsMutationVariables>;
export const InsertAttributeValueDocument = gql`
    mutation insertAttributeValue($object: attributeValues_insert_input!) {
  insert_attributeValues_one(object: $object) {
    id
  }
}
    `;
export type InsertAttributeValueMutationFn = Apollo.MutationFunction<InsertAttributeValueMutation, InsertAttributeValueMutationVariables>;

/**
 * __useInsertAttributeValueMutation__
 *
 * To run a mutation, you first call `useInsertAttributeValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAttributeValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAttributeValueMutation, { data, loading, error }] = useInsertAttributeValueMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertAttributeValueMutation(baseOptions?: Apollo.MutationHookOptions<InsertAttributeValueMutation, InsertAttributeValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAttributeValueMutation, InsertAttributeValueMutationVariables>(InsertAttributeValueDocument, options);
      }
export type InsertAttributeValueMutationHookResult = ReturnType<typeof useInsertAttributeValueMutation>;
export type InsertAttributeValueMutationResult = Apollo.MutationResult<InsertAttributeValueMutation>;
export type InsertAttributeValueMutationOptions = Apollo.BaseMutationOptions<InsertAttributeValueMutation, InsertAttributeValueMutationVariables>;
export const SavePersonalNoteForServiceDocument = gql`
    mutation savePersonalNoteForService($personalData: userDataServices_insert_input!) {
  insert_userDataServices_one(
    object: $personalData
    on_conflict: {constraint: userDataServices_pkey, update_columns: [data]}
  ) {
    service {
      id
      userData {
        data
      }
    }
  }
}
    `;
export type SavePersonalNoteForServiceMutationFn = Apollo.MutationFunction<SavePersonalNoteForServiceMutation, SavePersonalNoteForServiceMutationVariables>;

/**
 * __useSavePersonalNoteForServiceMutation__
 *
 * To run a mutation, you first call `useSavePersonalNoteForServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePersonalNoteForServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePersonalNoteForServiceMutation, { data, loading, error }] = useSavePersonalNoteForServiceMutation({
 *   variables: {
 *      personalData: // value for 'personalData'
 *   },
 * });
 */
export function useSavePersonalNoteForServiceMutation(baseOptions?: Apollo.MutationHookOptions<SavePersonalNoteForServiceMutation, SavePersonalNoteForServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePersonalNoteForServiceMutation, SavePersonalNoteForServiceMutationVariables>(SavePersonalNoteForServiceDocument, options);
      }
export type SavePersonalNoteForServiceMutationHookResult = ReturnType<typeof useSavePersonalNoteForServiceMutation>;
export type SavePersonalNoteForServiceMutationResult = Apollo.MutationResult<SavePersonalNoteForServiceMutation>;
export type SavePersonalNoteForServiceMutationOptions = Apollo.BaseMutationOptions<SavePersonalNoteForServiceMutation, SavePersonalNoteForServiceMutationVariables>;
export const ServiceByIdDocument = gql`
    query serviceById($id: bigint!, $organisationId: bigint = 0, $attributes_order_by: [attributes_order_by!] = {order: asc_nulls_last}, $fetchBundleServices: Boolean = true, $fetchLastUpdatedInfo: Boolean = true, $guestOrganisationId: bigint = 0, $fetchGuestCanRead: Boolean = false) {
  services_by_pk(id: $id) {
    id
    name
    tags
    updatedAt
    createdAt
    userData {
      data
    }
    serviceBundleServices @include(if: $fetchBundleServices) {
      serviceBundleId
      serviceId
    }
    serviceModules_aggregate(where: {hasChanges: {_eq: true}}) {
      aggregate {
        count
      }
    }
    serviceModules(order_by: {order: asc_nulls_last}) {
      id
      name
      moduleType
      published
      order
      config
      writable
      hasChanges
      guestCanRead @include(if: $fetchGuestCanRead)
      lastVisits {
        userId
        updatedAt
      }
      attributeGroups(order_by: {order: asc_nulls_last}) {
        id
        order
        description
        name
        valuesRepeatable
        attributeValueGroups(order_by: {id: asc}) {
          id
          attributeValues(order_by: {attribute: {order: asc_nulls_last}}) {
            createdAt
            updatedAt
            updatedBy @include(if: $fetchLastUpdatedInfo)
            updatedBy_user @include(if: $fetchLastUpdatedInfo) {
              id
              firstName
              lastName
            }
            user {
              id
              firstName
              lastName
              organisation {
                id
                name
              }
            }
            attributeValueGroupId
            attributeValueUploads {
              ...AttributeValueUploadFileList
            }
            id
            value
            comments_aggregate(
              where: {_or: [{organisationId: {_eq: $organisationId}}, {organisationId: {_eq: $guestOrganisationId}}, {organisationId: {_is_null: true}}], _and: {isDone: {_is_null: true}, parentId: {_is_null: true}}}
            ) {
              aggregate {
                count
              }
            }
            attribute {
              id
              attributeType
              config
              organisation {
                id
                name
              }
              name
              description
              order
              attributeFiles {
                downloadUrl
                file {
                  id
                  size
                  name
                  extension
                }
              }
            }
          }
        }
        attributes(order_by: $attributes_order_by) {
          attributeType
          order
          config
          organisation {
            id
            name
          }
          createdAt
          description
          id
          name
          updatedAt
          attributeFiles {
            downloadUrl
            file {
              id
              size
              name
              extension
            }
          }
          attributeValues {
            attributeValueUploads {
              ...AttributeValueUploadFileList
            }
            id
            updatedAt
            value
            comments_aggregate(
              where: {_or: [{organisationId: {_eq: $organisationId}}, {organisationId: {_eq: $guestOrganisationId}}, {organisationId: {_is_null: true}}], _and: {isDone: {_is_null: true}, parentId: {_is_null: true}}}
            ) {
              aggregate {
                count
              }
            }
          }
        }
      }
    }
  }
}
    ${AttributeValueUploadFileListFragmentDoc}`;

/**
 * __useServiceByIdQuery__
 *
 * To run a query within a React component, call `useServiceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      organisationId: // value for 'organisationId'
 *      attributes_order_by: // value for 'attributes_order_by'
 *      fetchBundleServices: // value for 'fetchBundleServices'
 *      fetchLastUpdatedInfo: // value for 'fetchLastUpdatedInfo'
 *      guestOrganisationId: // value for 'guestOrganisationId'
 *      fetchGuestCanRead: // value for 'fetchGuestCanRead'
 *   },
 * });
 */
export function useServiceByIdQuery(baseOptions: Apollo.QueryHookOptions<ServiceByIdQuery, ServiceByIdQueryVariables> & ({ variables: ServiceByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceByIdQuery, ServiceByIdQueryVariables>(ServiceByIdDocument, options);
      }
export function useServiceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceByIdQuery, ServiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceByIdQuery, ServiceByIdQueryVariables>(ServiceByIdDocument, options);
        }
export function useServiceByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceByIdQuery, ServiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceByIdQuery, ServiceByIdQueryVariables>(ServiceByIdDocument, options);
        }
export type ServiceByIdQueryHookResult = ReturnType<typeof useServiceByIdQuery>;
export type ServiceByIdLazyQueryHookResult = ReturnType<typeof useServiceByIdLazyQuery>;
export type ServiceByIdSuspenseQueryHookResult = ReturnType<typeof useServiceByIdSuspenseQuery>;
export type ServiceByIdQueryResult = Apollo.QueryResult<ServiceByIdQuery, ServiceByIdQueryVariables>;
export const EventServiceByIdDocument = gql`
    query eventServiceById($serviceId: bigint!, $eventId: bigint!, $organisationId: bigint = 0, $fetchGuestCanRead: Boolean = false) {
  services(where: {_and: [{id: {_eq: $serviceId}}, {eventId: {_eq: $eventId}}]}) {
    id
    tags
    name
    updatedAt
    createdAt
    serviceModules_aggregate(where: {hasChanges: {_eq: true}}) {
      aggregate {
        count
      }
    }
    serviceModules {
      id
      name
      moduleType
      config
      hasChanges
      guestCanRead @include(if: $fetchGuestCanRead)
      published
      attributeGroups {
        id
        description
        name
        valuesRepeatable
        attributeValueGroups {
          id
          attributeValues {
            id
            value
            comments_aggregate(
              where: {_or: [{organisationId: {_eq: $organisationId}}, {organisationId: {_is_null: true}}], _and: {isDone: {_is_null: true}}}
            ) {
              aggregate {
                count
              }
            }
            attributeValueGroupId
            attributeValueUploads {
              ...AttributeValueUploadFileList
            }
            user {
              id
              firstName
              lastName
              organisation {
                id
                name
              }
            }
            attribute {
              id
              attributeType
              config
              organisation {
                id
                name
              }
              name
              description
              attributeFiles {
                file {
                  id
                  size
                  name
                  extension
                }
              }
            }
          }
        }
        attributes {
          attributeType
          config
          organisation {
            id
            name
          }
          createdAt
          description
          id
          name
          updatedAt
          attributeValues {
            id
            updatedAt
            value
            attributeValueUploads {
              ...AttributeValueUploadFileList
            }
            comments_aggregate(
              where: {_or: [{organisationId: {_eq: $organisationId}}, {organisationId: {_is_null: true}}], _and: {isDone: {_is_null: true}}}
            ) {
              aggregate {
                count
              }
            }
          }
          attributeFiles {
            file {
              uploadVersions {
                downloadUrl
                file {
                  id
                  size
                  name
                  extension
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${AttributeValueUploadFileListFragmentDoc}`;

/**
 * __useEventServiceByIdQuery__
 *
 * To run a query within a React component, call `useEventServiceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventServiceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventServiceByIdQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      eventId: // value for 'eventId'
 *      organisationId: // value for 'organisationId'
 *      fetchGuestCanRead: // value for 'fetchGuestCanRead'
 *   },
 * });
 */
export function useEventServiceByIdQuery(baseOptions: Apollo.QueryHookOptions<EventServiceByIdQuery, EventServiceByIdQueryVariables> & ({ variables: EventServiceByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventServiceByIdQuery, EventServiceByIdQueryVariables>(EventServiceByIdDocument, options);
      }
export function useEventServiceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventServiceByIdQuery, EventServiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventServiceByIdQuery, EventServiceByIdQueryVariables>(EventServiceByIdDocument, options);
        }
export function useEventServiceByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EventServiceByIdQuery, EventServiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventServiceByIdQuery, EventServiceByIdQueryVariables>(EventServiceByIdDocument, options);
        }
export type EventServiceByIdQueryHookResult = ReturnType<typeof useEventServiceByIdQuery>;
export type EventServiceByIdLazyQueryHookResult = ReturnType<typeof useEventServiceByIdLazyQuery>;
export type EventServiceByIdSuspenseQueryHookResult = ReturnType<typeof useEventServiceByIdSuspenseQuery>;
export type EventServiceByIdQueryResult = Apollo.QueryResult<EventServiceByIdQuery, EventServiceByIdQueryVariables>;
export const ServiceModuleByIdDocument = gql`
    query serviceModuleById($serviceModuleId: bigint!, $organisationId: bigint!, $fetchLastUpdatedInfo: Boolean = true, $fetchGuestCanRead: Boolean = false, $guestOrganisationId: bigint = 0) {
  serviceModules_by_pk(id: $serviceModuleId) {
    id
    name
    moduleType
    config
    hasChanges
    guestCanRead @include(if: $fetchGuestCanRead)
    published
    lastVisits {
      userId
      updatedAt
    }
    writable
    attributeGroups(order_by: {order: asc_nulls_last}) {
      id
      order
      description
      name
      valuesRepeatable
      attributeValueGroups(order_by: {id: asc}) {
        id
        attributeValues(order_by: {attribute: {order: asc_nulls_last}}) {
          createdAt
          updatedAt
          updatedBy @include(if: $fetchLastUpdatedInfo)
          updatedBy_user @include(if: $fetchLastUpdatedInfo) {
            id
            firstName
            lastName
          }
          attributeValueGroupId
          attributeValueUploads {
            ...AttributeValueUploadFileList
          }
          user {
            id
            firstName
            lastName
            organisation {
              id
              name
            }
          }
          id
          value
          comments_aggregate(
            where: {_or: [{organisationId: {_eq: $organisationId}}, {organisationId: {_eq: $guestOrganisationId}}, {organisationId: {_is_null: true}}], _and: {isDone: {_is_null: true}, parentId: {_is_null: true}}}
          ) {
            aggregate {
              count
            }
          }
          attribute {
            id
            attributeType
            config
            organisation {
              id
              name
            }
            name
            description
            order
            attributeFiles {
              downloadUrl
              file {
                id
                size
                name
                extension
              }
            }
          }
        }
      }
      attributes(order_by: {order: asc_nulls_last}) {
        attributeType
        order
        config
        organisation {
          id
          name
        }
        createdAt
        description
        id
        name
        updatedAt
        attributeFiles {
          downloadUrl
          file {
            id
            size
            name
            extension
          }
        }
        attributeValues {
          attributeValueUploads {
            ...AttributeValueUploadFileList
          }
          id
          updatedAt
          value
          comments_aggregate(
            where: {_or: [{organisationId: {_eq: $organisationId}}, {organisationId: {_eq: $guestOrganisationId}}, {organisationId: {_is_null: true}}], _and: {isDone: {_is_null: true}, parentId: {_is_null: true}}}
          ) {
            aggregate {
              count
            }
          }
        }
      }
    }
  }
}
    ${AttributeValueUploadFileListFragmentDoc}`;

/**
 * __useServiceModuleByIdQuery__
 *
 * To run a query within a React component, call `useServiceModuleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceModuleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceModuleByIdQuery({
 *   variables: {
 *      serviceModuleId: // value for 'serviceModuleId'
 *      organisationId: // value for 'organisationId'
 *      fetchLastUpdatedInfo: // value for 'fetchLastUpdatedInfo'
 *      fetchGuestCanRead: // value for 'fetchGuestCanRead'
 *      guestOrganisationId: // value for 'guestOrganisationId'
 *   },
 * });
 */
export function useServiceModuleByIdQuery(baseOptions: Apollo.QueryHookOptions<ServiceModuleByIdQuery, ServiceModuleByIdQueryVariables> & ({ variables: ServiceModuleByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceModuleByIdQuery, ServiceModuleByIdQueryVariables>(ServiceModuleByIdDocument, options);
      }
export function useServiceModuleByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceModuleByIdQuery, ServiceModuleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceModuleByIdQuery, ServiceModuleByIdQueryVariables>(ServiceModuleByIdDocument, options);
        }
export function useServiceModuleByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceModuleByIdQuery, ServiceModuleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceModuleByIdQuery, ServiceModuleByIdQueryVariables>(ServiceModuleByIdDocument, options);
        }
export type ServiceModuleByIdQueryHookResult = ReturnType<typeof useServiceModuleByIdQuery>;
export type ServiceModuleByIdLazyQueryHookResult = ReturnType<typeof useServiceModuleByIdLazyQuery>;
export type ServiceModuleByIdSuspenseQueryHookResult = ReturnType<typeof useServiceModuleByIdSuspenseQuery>;
export type ServiceModuleByIdQueryResult = Apollo.QueryResult<ServiceModuleByIdQuery, ServiceModuleByIdQueryVariables>;
export const ServicesTagsDocument = gql`
    query servicesTags {
  serviceTags(distinct_on: [value]) {
    value
  }
}
    `;

/**
 * __useServicesTagsQuery__
 *
 * To run a query within a React component, call `useServicesTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicesTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicesTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useServicesTagsQuery(baseOptions?: Apollo.QueryHookOptions<ServicesTagsQuery, ServicesTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServicesTagsQuery, ServicesTagsQueryVariables>(ServicesTagsDocument, options);
      }
export function useServicesTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServicesTagsQuery, ServicesTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServicesTagsQuery, ServicesTagsQueryVariables>(ServicesTagsDocument, options);
        }
export function useServicesTagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServicesTagsQuery, ServicesTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServicesTagsQuery, ServicesTagsQueryVariables>(ServicesTagsDocument, options);
        }
export type ServicesTagsQueryHookResult = ReturnType<typeof useServicesTagsQuery>;
export type ServicesTagsLazyQueryHookResult = ReturnType<typeof useServicesTagsLazyQuery>;
export type ServicesTagsSuspenseQueryHookResult = ReturnType<typeof useServicesTagsSuspenseQuery>;
export type ServicesTagsQueryResult = Apollo.QueryResult<ServicesTagsQuery, ServicesTagsQueryVariables>;
export const ServiceFavouritesDocument = gql`
    query serviceFavourites($userId: bigint!) {
  serviceFavourites(where: {userId: {_eq: $userId}}) {
    serviceId
  }
}
    `;

/**
 * __useServiceFavouritesQuery__
 *
 * To run a query within a React component, call `useServiceFavouritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceFavouritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceFavouritesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useServiceFavouritesQuery(baseOptions: Apollo.QueryHookOptions<ServiceFavouritesQuery, ServiceFavouritesQueryVariables> & ({ variables: ServiceFavouritesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceFavouritesQuery, ServiceFavouritesQueryVariables>(ServiceFavouritesDocument, options);
      }
export function useServiceFavouritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceFavouritesQuery, ServiceFavouritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceFavouritesQuery, ServiceFavouritesQueryVariables>(ServiceFavouritesDocument, options);
        }
export function useServiceFavouritesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceFavouritesQuery, ServiceFavouritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceFavouritesQuery, ServiceFavouritesQueryVariables>(ServiceFavouritesDocument, options);
        }
export type ServiceFavouritesQueryHookResult = ReturnType<typeof useServiceFavouritesQuery>;
export type ServiceFavouritesLazyQueryHookResult = ReturnType<typeof useServiceFavouritesLazyQuery>;
export type ServiceFavouritesSuspenseQueryHookResult = ReturnType<typeof useServiceFavouritesSuspenseQuery>;
export type ServiceFavouritesQueryResult = Apollo.QueryResult<ServiceFavouritesQuery, ServiceFavouritesQueryVariables>;
export const ServiceListDocument = gql`
    query serviceList($where: services_bool_exp, $order_by: [services_order_by!] = [{name: asc}]) {
  services(where: $where, order_by: $order_by) {
    id
    name
    tags
    updatedAt
    eventId
    userData {
      data
    }
    serviceModules_aggregate(where: {hasChanges: {_eq: true}}) {
      aggregate {
        count
      }
    }
    serviceModules {
      id
      published
      config
      hasChanges
      lastVisits {
        userId
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useServiceListQuery__
 *
 * To run a query within a React component, call `useServiceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceListQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useServiceListQuery(baseOptions?: Apollo.QueryHookOptions<ServiceListQuery, ServiceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceListQuery, ServiceListQueryVariables>(ServiceListDocument, options);
      }
export function useServiceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceListQuery, ServiceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceListQuery, ServiceListQueryVariables>(ServiceListDocument, options);
        }
export function useServiceListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceListQuery, ServiceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceListQuery, ServiceListQueryVariables>(ServiceListDocument, options);
        }
export type ServiceListQueryHookResult = ReturnType<typeof useServiceListQuery>;
export type ServiceListLazyQueryHookResult = ReturnType<typeof useServiceListLazyQuery>;
export type ServiceListSuspenseQueryHookResult = ReturnType<typeof useServiceListSuspenseQuery>;
export type ServiceListQueryResult = Apollo.QueryResult<ServiceListQuery, ServiceListQueryVariables>;
export const ServiceParentsListDocument = gql`
    query serviceParentsList($where: serviceParents_bool_exp, $order_by: [serviceParents_order_by!] = [{name: asc}]) {
  serviceParents(where: $where, order_by: $order_by) {
    id
    name
    isArchived
  }
}
    `;

/**
 * __useServiceParentsListQuery__
 *
 * To run a query within a React component, call `useServiceParentsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceParentsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceParentsListQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *   },
 * });
 */
export function useServiceParentsListQuery(baseOptions?: Apollo.QueryHookOptions<ServiceParentsListQuery, ServiceParentsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceParentsListQuery, ServiceParentsListQueryVariables>(ServiceParentsListDocument, options);
      }
export function useServiceParentsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceParentsListQuery, ServiceParentsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceParentsListQuery, ServiceParentsListQueryVariables>(ServiceParentsListDocument, options);
        }
export function useServiceParentsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceParentsListQuery, ServiceParentsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceParentsListQuery, ServiceParentsListQueryVariables>(ServiceParentsListDocument, options);
        }
export type ServiceParentsListQueryHookResult = ReturnType<typeof useServiceParentsListQuery>;
export type ServiceParentsListLazyQueryHookResult = ReturnType<typeof useServiceParentsListLazyQuery>;
export type ServiceParentsListSuspenseQueryHookResult = ReturnType<typeof useServiceParentsListSuspenseQuery>;
export type ServiceParentsListQueryResult = Apollo.QueryResult<ServiceParentsListQuery, ServiceParentsListQueryVariables>;
export const ServiceListExportDocument = gql`
    query serviceListExport($where: services_bool_exp, $order_by: [services_order_by!] = [{name: asc}], $distinct_on: [services_select_column!]) {
  services(where: $where, order_by: $order_by, distinct_on: $distinct_on) {
    id
    name
    eventId
    fromServiceId
    event {
      name
      isArchived
    }
  }
}
    `;

/**
 * __useServiceListExportQuery__
 *
 * To run a query within a React component, call `useServiceListExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceListExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceListExportQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order_by: // value for 'order_by'
 *      distinct_on: // value for 'distinct_on'
 *   },
 * });
 */
export function useServiceListExportQuery(baseOptions?: Apollo.QueryHookOptions<ServiceListExportQuery, ServiceListExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceListExportQuery, ServiceListExportQueryVariables>(ServiceListExportDocument, options);
      }
export function useServiceListExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceListExportQuery, ServiceListExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceListExportQuery, ServiceListExportQueryVariables>(ServiceListExportDocument, options);
        }
export function useServiceListExportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ServiceListExportQuery, ServiceListExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceListExportQuery, ServiceListExportQueryVariables>(ServiceListExportDocument, options);
        }
export type ServiceListExportQueryHookResult = ReturnType<typeof useServiceListExportQuery>;
export type ServiceListExportLazyQueryHookResult = ReturnType<typeof useServiceListExportLazyQuery>;
export type ServiceListExportSuspenseQueryHookResult = ReturnType<typeof useServiceListExportSuspenseQuery>;
export type ServiceListExportQueryResult = Apollo.QueryResult<ServiceListExportQuery, ServiceListExportQueryVariables>;
export const UpdateMultipleAttributeValuesAndAddAttributeValueGroupsDocument = gql`
    mutation updateMultipleAttributeValuesAndAddAttributeValueGroups($attributeValues: [attributeValues_insert_input!]!, $attributeValueGroups: [attributeValueGroups_insert_input!]!, $attributeValueUploadsToDelete: [bigint!]!, $attributeValueUploads: [attributeValueUploads_insert_input!]!, $attributeValueUploadVersions: [attributeValueUploadVersions_insert_input!]!, $attributeValueUploadVersionsToDelete: [attributeValueUploadVersions_bool_exp!]!, $attributeValueGroupsToDelete: [bigint!]!) {
  delete_attributeValueGroups(where: {id: {_in: $attributeValueGroupsToDelete}}) {
    affected_rows
  }
  delete_attributeValueUploadVersions(
    where: {_or: $attributeValueUploadVersionsToDelete}
  ) {
    affected_rows
  }
  delete_attributeValueUploads(where: {id: {_in: $attributeValueUploadsToDelete}}) {
    affected_rows
    returning {
      id
    }
  }
  insert_attributeValueUploads(objects: $attributeValueUploads) {
    affected_rows
    returning {
      id
      attributeValueId
    }
  }
  insert_attributeValueUploadVersions(objects: $attributeValueUploadVersions) {
    affected_rows
    returning {
      attributeValueUploadId
      fileId
    }
  }
  insert_attributeValues(
    objects: $attributeValues
    on_conflict: {constraint: attributeValues_attributeId_attributeValueGroupId_key, update_columns: [value, userId]}
  ) {
    affected_rows
    returning {
      id
      value
      user {
        id
        firstName
        lastName
        attributes
        organisation {
          id
          name
        }
      }
    }
  }
  insert_attributeValueGroups(objects: $attributeValueGroups) {
    affected_rows
  }
}
    `;
export type UpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutationFn = Apollo.MutationFunction<UpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutation, UpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutationVariables>;

/**
 * __useUpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutation__
 *
 * To run a mutation, you first call `useUpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMultipleAttributeValuesAndAddAttributeValueGroupsMutation, { data, loading, error }] = useUpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutation({
 *   variables: {
 *      attributeValues: // value for 'attributeValues'
 *      attributeValueGroups: // value for 'attributeValueGroups'
 *      attributeValueUploadsToDelete: // value for 'attributeValueUploadsToDelete'
 *      attributeValueUploads: // value for 'attributeValueUploads'
 *      attributeValueUploadVersions: // value for 'attributeValueUploadVersions'
 *      attributeValueUploadVersionsToDelete: // value for 'attributeValueUploadVersionsToDelete'
 *      attributeValueGroupsToDelete: // value for 'attributeValueGroupsToDelete'
 *   },
 * });
 */
export function useUpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutation, UpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutation, UpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutationVariables>(UpdateMultipleAttributeValuesAndAddAttributeValueGroupsDocument, options);
      }
export type UpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutationHookResult = ReturnType<typeof useUpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutation>;
export type UpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutationResult = Apollo.MutationResult<UpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutation>;
export type UpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutationOptions = Apollo.BaseMutationOptions<UpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutation, UpdateMultipleAttributeValuesAndAddAttributeValueGroupsMutationVariables>;
export const UpdateAttributeGroupDocument = gql`
    mutation updateAttributeGroup($id: bigint!, $object: attributeGroups_insert_input!) {
  delete_attributeGroups_by_pk(id: $id) {
    id
  }
  insert_attributeGroups_one(object: $object) {
    id
  }
}
    `;
export type UpdateAttributeGroupMutationFn = Apollo.MutationFunction<UpdateAttributeGroupMutation, UpdateAttributeGroupMutationVariables>;

/**
 * __useUpdateAttributeGroupMutation__
 *
 * To run a mutation, you first call `useUpdateAttributeGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttributeGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttributeGroupMutation, { data, loading, error }] = useUpdateAttributeGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpdateAttributeGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAttributeGroupMutation, UpdateAttributeGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAttributeGroupMutation, UpdateAttributeGroupMutationVariables>(UpdateAttributeGroupDocument, options);
      }
export type UpdateAttributeGroupMutationHookResult = ReturnType<typeof useUpdateAttributeGroupMutation>;
export type UpdateAttributeGroupMutationResult = Apollo.MutationResult<UpdateAttributeGroupMutation>;
export type UpdateAttributeGroupMutationOptions = Apollo.BaseMutationOptions<UpdateAttributeGroupMutation, UpdateAttributeGroupMutationVariables>;
export const UpdateServiceModuleDocument = gql`
    mutation updateServiceModule($_set: serviceModules_set_input, $pk_columns: serviceModules_pk_columns_input!) {
  update_serviceModules_by_pk(_set: $_set, pk_columns: $pk_columns) {
    id
  }
}
    `;
export type UpdateServiceModuleMutationFn = Apollo.MutationFunction<UpdateServiceModuleMutation, UpdateServiceModuleMutationVariables>;

/**
 * __useUpdateServiceModuleMutation__
 *
 * To run a mutation, you first call `useUpdateServiceModuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceModuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceModuleMutation, { data, loading, error }] = useUpdateServiceModuleMutation({
 *   variables: {
 *      _set: // value for '_set'
 *      pk_columns: // value for 'pk_columns'
 *   },
 * });
 */
export function useUpdateServiceModuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceModuleMutation, UpdateServiceModuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceModuleMutation, UpdateServiceModuleMutationVariables>(UpdateServiceModuleDocument, options);
      }
export type UpdateServiceModuleMutationHookResult = ReturnType<typeof useUpdateServiceModuleMutation>;
export type UpdateServiceModuleMutationResult = Apollo.MutationResult<UpdateServiceModuleMutation>;
export type UpdateServiceModuleMutationOptions = Apollo.BaseMutationOptions<UpdateServiceModuleMutation, UpdateServiceModuleMutationVariables>;
export const UpdateServiceDocument = gql`
    mutation updateService($_set: services_set_input!, $pk_columns: services_pk_columns_input!) {
  update_services_by_pk(_set: $_set, pk_columns: $pk_columns) {
    id
  }
}
    `;
export type UpdateServiceMutationFn = Apollo.MutationFunction<UpdateServiceMutation, UpdateServiceMutationVariables>;

/**
 * __useUpdateServiceMutation__
 *
 * To run a mutation, you first call `useUpdateServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceMutation, { data, loading, error }] = useUpdateServiceMutation({
 *   variables: {
 *      _set: // value for '_set'
 *      pk_columns: // value for 'pk_columns'
 *   },
 * });
 */
export function useUpdateServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceMutation, UpdateServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceMutation, UpdateServiceMutationVariables>(UpdateServiceDocument, options);
      }
export type UpdateServiceMutationHookResult = ReturnType<typeof useUpdateServiceMutation>;
export type UpdateServiceMutationResult = Apollo.MutationResult<UpdateServiceMutation>;
export type UpdateServiceMutationOptions = Apollo.BaseMutationOptions<UpdateServiceMutation, UpdateServiceMutationVariables>;
export const AddUploadDocument = gql`
    mutation addUpload($object: uploads_insert_input!) {
  insert_uploads_one(object: $object) {
    id
  }
}
    `;
export type AddUploadMutationFn = Apollo.MutationFunction<AddUploadMutation, AddUploadMutationVariables>;

/**
 * __useAddUploadMutation__
 *
 * To run a mutation, you first call `useAddUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUploadMutation, { data, loading, error }] = useAddUploadMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAddUploadMutation(baseOptions?: Apollo.MutationHookOptions<AddUploadMutation, AddUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUploadMutation, AddUploadMutationVariables>(AddUploadDocument, options);
      }
export type AddUploadMutationHookResult = ReturnType<typeof useAddUploadMutation>;
export type AddUploadMutationResult = Apollo.MutationResult<AddUploadMutation>;
export type AddUploadMutationOptions = Apollo.BaseMutationOptions<AddUploadMutation, AddUploadMutationVariables>;
export const AddUploadWithUploadVersionDocument = gql`
    mutation addUploadWithUploadVersion($object: uploads_insert_input!) {
  insert_uploads_one(object: $object) {
    id
  }
}
    `;
export type AddUploadWithUploadVersionMutationFn = Apollo.MutationFunction<AddUploadWithUploadVersionMutation, AddUploadWithUploadVersionMutationVariables>;

/**
 * __useAddUploadWithUploadVersionMutation__
 *
 * To run a mutation, you first call `useAddUploadWithUploadVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUploadWithUploadVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUploadWithUploadVersionMutation, { data, loading, error }] = useAddUploadWithUploadVersionMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAddUploadWithUploadVersionMutation(baseOptions?: Apollo.MutationHookOptions<AddUploadWithUploadVersionMutation, AddUploadWithUploadVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUploadWithUploadVersionMutation, AddUploadWithUploadVersionMutationVariables>(AddUploadWithUploadVersionDocument, options);
      }
export type AddUploadWithUploadVersionMutationHookResult = ReturnType<typeof useAddUploadWithUploadVersionMutation>;
export type AddUploadWithUploadVersionMutationResult = Apollo.MutationResult<AddUploadWithUploadVersionMutation>;
export type AddUploadWithUploadVersionMutationOptions = Apollo.BaseMutationOptions<AddUploadWithUploadVersionMutation, AddUploadWithUploadVersionMutationVariables>;
export const InsertUploadVersionDocument = gql`
    mutation insertUploadVersion($uploadId: bigint!, $fileId: bigint!) {
  insert_uploadVersions_one(object: {uploadId: $uploadId, fileId: $fileId}) {
    id
    fileId
  }
}
    `;
export type InsertUploadVersionMutationFn = Apollo.MutationFunction<InsertUploadVersionMutation, InsertUploadVersionMutationVariables>;

/**
 * __useInsertUploadVersionMutation__
 *
 * To run a mutation, you first call `useInsertUploadVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUploadVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUploadVersionMutation, { data, loading, error }] = useInsertUploadVersionMutation({
 *   variables: {
 *      uploadId: // value for 'uploadId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useInsertUploadVersionMutation(baseOptions?: Apollo.MutationHookOptions<InsertUploadVersionMutation, InsertUploadVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertUploadVersionMutation, InsertUploadVersionMutationVariables>(InsertUploadVersionDocument, options);
      }
export type InsertUploadVersionMutationHookResult = ReturnType<typeof useInsertUploadVersionMutation>;
export type InsertUploadVersionMutationResult = Apollo.MutationResult<InsertUploadVersionMutation>;
export type InsertUploadVersionMutationOptions = Apollo.BaseMutationOptions<InsertUploadVersionMutation, InsertUploadVersionMutationVariables>;
export const InsertNewUploadDocument = gql`
    mutation insertNewUpload($fileId: bigint!, $fileName: String!, $serviceModuleId: bigint!) {
  insert_uploadVersions_one(
    object: {fileId: $fileId, upload: {data: {serviceModuleId: $serviceModuleId, name: $fileName}, on_conflict: {constraint: uploads_pkey, update_columns: [name]}}}
  ) {
    id
    fileId
    uploadId
    downloadUrl
  }
}
    `;
export type InsertNewUploadMutationFn = Apollo.MutationFunction<InsertNewUploadMutation, InsertNewUploadMutationVariables>;

/**
 * __useInsertNewUploadMutation__
 *
 * To run a mutation, you first call `useInsertNewUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertNewUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertNewUploadMutation, { data, loading, error }] = useInsertNewUploadMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      fileName: // value for 'fileName'
 *      serviceModuleId: // value for 'serviceModuleId'
 *   },
 * });
 */
export function useInsertNewUploadMutation(baseOptions?: Apollo.MutationHookOptions<InsertNewUploadMutation, InsertNewUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertNewUploadMutation, InsertNewUploadMutationVariables>(InsertNewUploadDocument, options);
      }
export type InsertNewUploadMutationHookResult = ReturnType<typeof useInsertNewUploadMutation>;
export type InsertNewUploadMutationResult = Apollo.MutationResult<InsertNewUploadMutation>;
export type InsertNewUploadMutationOptions = Apollo.BaseMutationOptions<InsertNewUploadMutation, InsertNewUploadMutationVariables>;
export const InsertAttributeValueFileDocument = gql`
    mutation insertAttributeValueFile($attributeValueId: bigint!, $fileId: bigint!, $fileName: String!) {
  insert_attributeValueUploads_one(
    object: {attributeValueId: $attributeValueId, name: $fileName, attributeValueUploadVersions: {data: {fileId: $fileId}}}
  ) {
    id
    attributeValueId
  }
}
    `;
export type InsertAttributeValueFileMutationFn = Apollo.MutationFunction<InsertAttributeValueFileMutation, InsertAttributeValueFileMutationVariables>;

/**
 * __useInsertAttributeValueFileMutation__
 *
 * To run a mutation, you first call `useInsertAttributeValueFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAttributeValueFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAttributeValueFileMutation, { data, loading, error }] = useInsertAttributeValueFileMutation({
 *   variables: {
 *      attributeValueId: // value for 'attributeValueId'
 *      fileId: // value for 'fileId'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useInsertAttributeValueFileMutation(baseOptions?: Apollo.MutationHookOptions<InsertAttributeValueFileMutation, InsertAttributeValueFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAttributeValueFileMutation, InsertAttributeValueFileMutationVariables>(InsertAttributeValueFileDocument, options);
      }
export type InsertAttributeValueFileMutationHookResult = ReturnType<typeof useInsertAttributeValueFileMutation>;
export type InsertAttributeValueFileMutationResult = Apollo.MutationResult<InsertAttributeValueFileMutation>;
export type InsertAttributeValueFileMutationOptions = Apollo.BaseMutationOptions<InsertAttributeValueFileMutation, InsertAttributeValueFileMutationVariables>;
export const InsertAttributeValueUploadVersionDocument = gql`
    mutation insertAttributeValueUploadVersion($attributeValueUploadId: bigint!, $fileId: bigint!) {
  insert_attributeValueUploadVersions_one(
    object: {attributeValueUploadId: $attributeValueUploadId, fileId: $fileId}
  ) {
    attributeValueUploadId
    fileId
    downloadUrl
  }
}
    `;
export type InsertAttributeValueUploadVersionMutationFn = Apollo.MutationFunction<InsertAttributeValueUploadVersionMutation, InsertAttributeValueUploadVersionMutationVariables>;

/**
 * __useInsertAttributeValueUploadVersionMutation__
 *
 * To run a mutation, you first call `useInsertAttributeValueUploadVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAttributeValueUploadVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAttributeValueUploadVersionMutation, { data, loading, error }] = useInsertAttributeValueUploadVersionMutation({
 *   variables: {
 *      attributeValueUploadId: // value for 'attributeValueUploadId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useInsertAttributeValueUploadVersionMutation(baseOptions?: Apollo.MutationHookOptions<InsertAttributeValueUploadVersionMutation, InsertAttributeValueUploadVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAttributeValueUploadVersionMutation, InsertAttributeValueUploadVersionMutationVariables>(InsertAttributeValueUploadVersionDocument, options);
      }
export type InsertAttributeValueUploadVersionMutationHookResult = ReturnType<typeof useInsertAttributeValueUploadVersionMutation>;
export type InsertAttributeValueUploadVersionMutationResult = Apollo.MutationResult<InsertAttributeValueUploadVersionMutation>;
export type InsertAttributeValueUploadVersionMutationOptions = Apollo.BaseMutationOptions<InsertAttributeValueUploadVersionMutation, InsertAttributeValueUploadVersionMutationVariables>;
export const InsertRoomAttributeValueUploadVersionDocument = gql`
    mutation insertRoomAttributeValueUploadVersion($roomAttributeValueUploadId: bigint!, $fileId: bigint!) {
  insert_roomAttributeValueUploadVersions_one(
    object: {roomAttributeValueUploadId: $roomAttributeValueUploadId, fileId: $fileId}
  ) {
    roomAttributeValueUploadId
    fileId
    downloadUrl
  }
}
    `;
export type InsertRoomAttributeValueUploadVersionMutationFn = Apollo.MutationFunction<InsertRoomAttributeValueUploadVersionMutation, InsertRoomAttributeValueUploadVersionMutationVariables>;

/**
 * __useInsertRoomAttributeValueUploadVersionMutation__
 *
 * To run a mutation, you first call `useInsertRoomAttributeValueUploadVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertRoomAttributeValueUploadVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertRoomAttributeValueUploadVersionMutation, { data, loading, error }] = useInsertRoomAttributeValueUploadVersionMutation({
 *   variables: {
 *      roomAttributeValueUploadId: // value for 'roomAttributeValueUploadId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useInsertRoomAttributeValueUploadVersionMutation(baseOptions?: Apollo.MutationHookOptions<InsertRoomAttributeValueUploadVersionMutation, InsertRoomAttributeValueUploadVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertRoomAttributeValueUploadVersionMutation, InsertRoomAttributeValueUploadVersionMutationVariables>(InsertRoomAttributeValueUploadVersionDocument, options);
      }
export type InsertRoomAttributeValueUploadVersionMutationHookResult = ReturnType<typeof useInsertRoomAttributeValueUploadVersionMutation>;
export type InsertRoomAttributeValueUploadVersionMutationResult = Apollo.MutationResult<InsertRoomAttributeValueUploadVersionMutation>;
export type InsertRoomAttributeValueUploadVersionMutationOptions = Apollo.BaseMutationOptions<InsertRoomAttributeValueUploadVersionMutation, InsertRoomAttributeValueUploadVersionMutationVariables>;
export const InsertEventAttributeValueUploadVersionDocument = gql`
    mutation insertEventAttributeValueUploadVersion($eventAttributeValueUploadId: bigint!, $fileId: bigint!) {
  insert_eventAttributeValueUploadVersions_one(
    object: {eventAttributeValueUploadId: $eventAttributeValueUploadId, fileId: $fileId}
  ) {
    eventAttributeValueUploadId
    fileId
  }
}
    `;
export type InsertEventAttributeValueUploadVersionMutationFn = Apollo.MutationFunction<InsertEventAttributeValueUploadVersionMutation, InsertEventAttributeValueUploadVersionMutationVariables>;

/**
 * __useInsertEventAttributeValueUploadVersionMutation__
 *
 * To run a mutation, you first call `useInsertEventAttributeValueUploadVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertEventAttributeValueUploadVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertEventAttributeValueUploadVersionMutation, { data, loading, error }] = useInsertEventAttributeValueUploadVersionMutation({
 *   variables: {
 *      eventAttributeValueUploadId: // value for 'eventAttributeValueUploadId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useInsertEventAttributeValueUploadVersionMutation(baseOptions?: Apollo.MutationHookOptions<InsertEventAttributeValueUploadVersionMutation, InsertEventAttributeValueUploadVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertEventAttributeValueUploadVersionMutation, InsertEventAttributeValueUploadVersionMutationVariables>(InsertEventAttributeValueUploadVersionDocument, options);
      }
export type InsertEventAttributeValueUploadVersionMutationHookResult = ReturnType<typeof useInsertEventAttributeValueUploadVersionMutation>;
export type InsertEventAttributeValueUploadVersionMutationResult = Apollo.MutationResult<InsertEventAttributeValueUploadVersionMutation>;
export type InsertEventAttributeValueUploadVersionMutationOptions = Apollo.BaseMutationOptions<InsertEventAttributeValueUploadVersionMutation, InsertEventAttributeValueUploadVersionMutationVariables>;
export const InsertEventAttributeValueFileDocument = gql`
    mutation insertEventAttributeValueFile($eventAttributeValueId: bigint!, $fileName: String!) {
  insert_eventAttributeValueUploads_one(
    object: {eventAttributeValueId: $eventAttributeValueId, name: $fileName}
  ) {
    id
    eventAttributeValueId
  }
}
    `;
export type InsertEventAttributeValueFileMutationFn = Apollo.MutationFunction<InsertEventAttributeValueFileMutation, InsertEventAttributeValueFileMutationVariables>;

/**
 * __useInsertEventAttributeValueFileMutation__
 *
 * To run a mutation, you first call `useInsertEventAttributeValueFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertEventAttributeValueFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertEventAttributeValueFileMutation, { data, loading, error }] = useInsertEventAttributeValueFileMutation({
 *   variables: {
 *      eventAttributeValueId: // value for 'eventAttributeValueId'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useInsertEventAttributeValueFileMutation(baseOptions?: Apollo.MutationHookOptions<InsertEventAttributeValueFileMutation, InsertEventAttributeValueFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertEventAttributeValueFileMutation, InsertEventAttributeValueFileMutationVariables>(InsertEventAttributeValueFileDocument, options);
      }
export type InsertEventAttributeValueFileMutationHookResult = ReturnType<typeof useInsertEventAttributeValueFileMutation>;
export type InsertEventAttributeValueFileMutationResult = Apollo.MutationResult<InsertEventAttributeValueFileMutation>;
export type InsertEventAttributeValueFileMutationOptions = Apollo.BaseMutationOptions<InsertEventAttributeValueFileMutation, InsertEventAttributeValueFileMutationVariables>;
export const DeleteAttributeValueFileDocument = gql`
    mutation deleteAttributeValueFile($fileId: bigint!, $attributeValueUploadId: bigint!) {
  delete_attributeValueUploadVersions_by_pk(
    fileId: $fileId
    attributeValueUploadId: $attributeValueUploadId
  ) {
    fileId
  }
}
    `;
export type DeleteAttributeValueFileMutationFn = Apollo.MutationFunction<DeleteAttributeValueFileMutation, DeleteAttributeValueFileMutationVariables>;

/**
 * __useDeleteAttributeValueFileMutation__
 *
 * To run a mutation, you first call `useDeleteAttributeValueFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttributeValueFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttributeValueFileMutation, { data, loading, error }] = useDeleteAttributeValueFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      attributeValueUploadId: // value for 'attributeValueUploadId'
 *   },
 * });
 */
export function useDeleteAttributeValueFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttributeValueFileMutation, DeleteAttributeValueFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttributeValueFileMutation, DeleteAttributeValueFileMutationVariables>(DeleteAttributeValueFileDocument, options);
      }
export type DeleteAttributeValueFileMutationHookResult = ReturnType<typeof useDeleteAttributeValueFileMutation>;
export type DeleteAttributeValueFileMutationResult = Apollo.MutationResult<DeleteAttributeValueFileMutation>;
export type DeleteAttributeValueFileMutationOptions = Apollo.BaseMutationOptions<DeleteAttributeValueFileMutation, DeleteAttributeValueFileMutationVariables>;
export const DeleteAttributeValueUploadDocument = gql`
    mutation deleteAttributeValueUpload($id: bigint!) {
  delete_attributeValueUploads_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteAttributeValueUploadMutationFn = Apollo.MutationFunction<DeleteAttributeValueUploadMutation, DeleteAttributeValueUploadMutationVariables>;

/**
 * __useDeleteAttributeValueUploadMutation__
 *
 * To run a mutation, you first call `useDeleteAttributeValueUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttributeValueUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttributeValueUploadMutation, { data, loading, error }] = useDeleteAttributeValueUploadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAttributeValueUploadMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttributeValueUploadMutation, DeleteAttributeValueUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttributeValueUploadMutation, DeleteAttributeValueUploadMutationVariables>(DeleteAttributeValueUploadDocument, options);
      }
export type DeleteAttributeValueUploadMutationHookResult = ReturnType<typeof useDeleteAttributeValueUploadMutation>;
export type DeleteAttributeValueUploadMutationResult = Apollo.MutationResult<DeleteAttributeValueUploadMutation>;
export type DeleteAttributeValueUploadMutationOptions = Apollo.BaseMutationOptions<DeleteAttributeValueUploadMutation, DeleteAttributeValueUploadMutationVariables>;
export const DeleteRoomAttributeValueUploadVersionDocument = gql`
    mutation deleteRoomAttributeValueUploadVersion($fileId: bigint!, $roomAttributeValueUploadId: bigint!) {
  delete_roomAttributeValueUploadVersions_by_pk(
    fileId: $fileId
    roomAttributeValueUploadId: $roomAttributeValueUploadId
  ) {
    fileId
  }
}
    `;
export type DeleteRoomAttributeValueUploadVersionMutationFn = Apollo.MutationFunction<DeleteRoomAttributeValueUploadVersionMutation, DeleteRoomAttributeValueUploadVersionMutationVariables>;

/**
 * __useDeleteRoomAttributeValueUploadVersionMutation__
 *
 * To run a mutation, you first call `useDeleteRoomAttributeValueUploadVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoomAttributeValueUploadVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoomAttributeValueUploadVersionMutation, { data, loading, error }] = useDeleteRoomAttributeValueUploadVersionMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      roomAttributeValueUploadId: // value for 'roomAttributeValueUploadId'
 *   },
 * });
 */
export function useDeleteRoomAttributeValueUploadVersionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoomAttributeValueUploadVersionMutation, DeleteRoomAttributeValueUploadVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoomAttributeValueUploadVersionMutation, DeleteRoomAttributeValueUploadVersionMutationVariables>(DeleteRoomAttributeValueUploadVersionDocument, options);
      }
export type DeleteRoomAttributeValueUploadVersionMutationHookResult = ReturnType<typeof useDeleteRoomAttributeValueUploadVersionMutation>;
export type DeleteRoomAttributeValueUploadVersionMutationResult = Apollo.MutationResult<DeleteRoomAttributeValueUploadVersionMutation>;
export type DeleteRoomAttributeValueUploadVersionMutationOptions = Apollo.BaseMutationOptions<DeleteRoomAttributeValueUploadVersionMutation, DeleteRoomAttributeValueUploadVersionMutationVariables>;
export const DeleteRoomAttributeValueUploadDocument = gql`
    mutation deleteRoomAttributeValueUpload($id: bigint!) {
  delete_roomAttributeValueUploads_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteRoomAttributeValueUploadMutationFn = Apollo.MutationFunction<DeleteRoomAttributeValueUploadMutation, DeleteRoomAttributeValueUploadMutationVariables>;

/**
 * __useDeleteRoomAttributeValueUploadMutation__
 *
 * To run a mutation, you first call `useDeleteRoomAttributeValueUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoomAttributeValueUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoomAttributeValueUploadMutation, { data, loading, error }] = useDeleteRoomAttributeValueUploadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRoomAttributeValueUploadMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoomAttributeValueUploadMutation, DeleteRoomAttributeValueUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoomAttributeValueUploadMutation, DeleteRoomAttributeValueUploadMutationVariables>(DeleteRoomAttributeValueUploadDocument, options);
      }
export type DeleteRoomAttributeValueUploadMutationHookResult = ReturnType<typeof useDeleteRoomAttributeValueUploadMutation>;
export type DeleteRoomAttributeValueUploadMutationResult = Apollo.MutationResult<DeleteRoomAttributeValueUploadMutation>;
export type DeleteRoomAttributeValueUploadMutationOptions = Apollo.BaseMutationOptions<DeleteRoomAttributeValueUploadMutation, DeleteRoomAttributeValueUploadMutationVariables>;
export const DeleteEventAttributeValueUploadVersionDocument = gql`
    mutation deleteEventAttributeValueUploadVersion($fileId: bigint!, $eventAttributeValueUploadId: bigint!) {
  delete_eventAttributeValueUploadVersions_by_pk(
    fileId: $fileId
    eventAttributeValueUploadId: $eventAttributeValueUploadId
  ) {
    fileId
  }
}
    `;
export type DeleteEventAttributeValueUploadVersionMutationFn = Apollo.MutationFunction<DeleteEventAttributeValueUploadVersionMutation, DeleteEventAttributeValueUploadVersionMutationVariables>;

/**
 * __useDeleteEventAttributeValueUploadVersionMutation__
 *
 * To run a mutation, you first call `useDeleteEventAttributeValueUploadVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventAttributeValueUploadVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventAttributeValueUploadVersionMutation, { data, loading, error }] = useDeleteEventAttributeValueUploadVersionMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      eventAttributeValueUploadId: // value for 'eventAttributeValueUploadId'
 *   },
 * });
 */
export function useDeleteEventAttributeValueUploadVersionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventAttributeValueUploadVersionMutation, DeleteEventAttributeValueUploadVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventAttributeValueUploadVersionMutation, DeleteEventAttributeValueUploadVersionMutationVariables>(DeleteEventAttributeValueUploadVersionDocument, options);
      }
export type DeleteEventAttributeValueUploadVersionMutationHookResult = ReturnType<typeof useDeleteEventAttributeValueUploadVersionMutation>;
export type DeleteEventAttributeValueUploadVersionMutationResult = Apollo.MutationResult<DeleteEventAttributeValueUploadVersionMutation>;
export type DeleteEventAttributeValueUploadVersionMutationOptions = Apollo.BaseMutationOptions<DeleteEventAttributeValueUploadVersionMutation, DeleteEventAttributeValueUploadVersionMutationVariables>;
export const DeleteEventAttributeValueUploadDocument = gql`
    mutation deleteEventAttributeValueUpload($id: bigint!) {
  delete_eventAttributeValueUploads_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteEventAttributeValueUploadMutationFn = Apollo.MutationFunction<DeleteEventAttributeValueUploadMutation, DeleteEventAttributeValueUploadMutationVariables>;

/**
 * __useDeleteEventAttributeValueUploadMutation__
 *
 * To run a mutation, you first call `useDeleteEventAttributeValueUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventAttributeValueUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventAttributeValueUploadMutation, { data, loading, error }] = useDeleteEventAttributeValueUploadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEventAttributeValueUploadMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventAttributeValueUploadMutation, DeleteEventAttributeValueUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventAttributeValueUploadMutation, DeleteEventAttributeValueUploadMutationVariables>(DeleteEventAttributeValueUploadDocument, options);
      }
export type DeleteEventAttributeValueUploadMutationHookResult = ReturnType<typeof useDeleteEventAttributeValueUploadMutation>;
export type DeleteEventAttributeValueUploadMutationResult = Apollo.MutationResult<DeleteEventAttributeValueUploadMutation>;
export type DeleteEventAttributeValueUploadMutationOptions = Apollo.BaseMutationOptions<DeleteEventAttributeValueUploadMutation, DeleteEventAttributeValueUploadMutationVariables>;
export const DeleteAttributeFileDocument = gql`
    mutation deleteAttributeFile($fileId: bigint!, $attributeId: bigint!) {
  delete_attributeFiles_by_pk(fileId: $fileId, attributeId: $attributeId) {
    fileId
  }
}
    `;
export type DeleteAttributeFileMutationFn = Apollo.MutationFunction<DeleteAttributeFileMutation, DeleteAttributeFileMutationVariables>;

/**
 * __useDeleteAttributeFileMutation__
 *
 * To run a mutation, you first call `useDeleteAttributeFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttributeFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttributeFileMutation, { data, loading, error }] = useDeleteAttributeFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *      attributeId: // value for 'attributeId'
 *   },
 * });
 */
export function useDeleteAttributeFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttributeFileMutation, DeleteAttributeFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttributeFileMutation, DeleteAttributeFileMutationVariables>(DeleteAttributeFileDocument, options);
      }
export type DeleteAttributeFileMutationHookResult = ReturnType<typeof useDeleteAttributeFileMutation>;
export type DeleteAttributeFileMutationResult = Apollo.MutationResult<DeleteAttributeFileMutation>;
export type DeleteAttributeFileMutationOptions = Apollo.BaseMutationOptions<DeleteAttributeFileMutation, DeleteAttributeFileMutationVariables>;
export const DeleteUploadVersionsDocument = gql`
    mutation deleteUploadVersions($id: bigint!) {
  delete_uploadVersions_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteUploadVersionsMutationFn = Apollo.MutationFunction<DeleteUploadVersionsMutation, DeleteUploadVersionsMutationVariables>;

/**
 * __useDeleteUploadVersionsMutation__
 *
 * To run a mutation, you first call `useDeleteUploadVersionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUploadVersionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUploadVersionsMutation, { data, loading, error }] = useDeleteUploadVersionsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUploadVersionsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUploadVersionsMutation, DeleteUploadVersionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUploadVersionsMutation, DeleteUploadVersionsMutationVariables>(DeleteUploadVersionsDocument, options);
      }
export type DeleteUploadVersionsMutationHookResult = ReturnType<typeof useDeleteUploadVersionsMutation>;
export type DeleteUploadVersionsMutationResult = Apollo.MutationResult<DeleteUploadVersionsMutation>;
export type DeleteUploadVersionsMutationOptions = Apollo.BaseMutationOptions<DeleteUploadVersionsMutation, DeleteUploadVersionsMutationVariables>;
export const DeleteUploadsDocument = gql`
    mutation deleteUploads($id: bigint!) {
  delete_uploads_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteUploadsMutationFn = Apollo.MutationFunction<DeleteUploadsMutation, DeleteUploadsMutationVariables>;

/**
 * __useDeleteUploadsMutation__
 *
 * To run a mutation, you first call `useDeleteUploadsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUploadsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUploadsMutation, { data, loading, error }] = useDeleteUploadsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUploadsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUploadsMutation, DeleteUploadsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUploadsMutation, DeleteUploadsMutationVariables>(DeleteUploadsDocument, options);
      }
export type DeleteUploadsMutationHookResult = ReturnType<typeof useDeleteUploadsMutation>;
export type DeleteUploadsMutationResult = Apollo.MutationResult<DeleteUploadsMutation>;
export type DeleteUploadsMutationOptions = Apollo.BaseMutationOptions<DeleteUploadsMutation, DeleteUploadsMutationVariables>;
export const AddUserDocument = gql`
    mutation addUser($object: users_insert_input!) {
  insert_users_one(object: $object) {
    id
    lastLoginAt
    email
    firstName
    lastName
    failedLoginCount
    organisationId
    organisation {
      id
      name
    }
    organisationGroupUsers {
      organisationGroup {
        id
      }
    }
    userAttributeValues {
      value
      userAttribute {
        id
        name
      }
    }
  }
}
    `;
export type AddUserMutationFn = Apollo.MutationFunction<AddUserMutation, AddUserMutationVariables>;

/**
 * __useAddUserMutation__
 *
 * To run a mutation, you first call `useAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserMutation, { data, loading, error }] = useAddUserMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAddUserMutation(baseOptions?: Apollo.MutationHookOptions<AddUserMutation, AddUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserMutation, AddUserMutationVariables>(AddUserDocument, options);
      }
export type AddUserMutationHookResult = ReturnType<typeof useAddUserMutation>;
export type AddUserMutationResult = Apollo.MutationResult<AddUserMutation>;
export type AddUserMutationOptions = Apollo.BaseMutationOptions<AddUserMutation, AddUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($id: bigint!) {
  delete_users_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const ResetUserFailedLoginsDocument = gql`
    mutation resetUserFailedLogins($id: bigint!) {
  update_users_by_pk(pk_columns: {id: $id}, _set: {failedLoginCount: 0}) {
    id
    failedLoginCount
  }
}
    `;
export type ResetUserFailedLoginsMutationFn = Apollo.MutationFunction<ResetUserFailedLoginsMutation, ResetUserFailedLoginsMutationVariables>;

/**
 * __useResetUserFailedLoginsMutation__
 *
 * To run a mutation, you first call `useResetUserFailedLoginsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserFailedLoginsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserFailedLoginsMutation, { data, loading, error }] = useResetUserFailedLoginsMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResetUserFailedLoginsMutation(baseOptions?: Apollo.MutationHookOptions<ResetUserFailedLoginsMutation, ResetUserFailedLoginsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetUserFailedLoginsMutation, ResetUserFailedLoginsMutationVariables>(ResetUserFailedLoginsDocument, options);
      }
export type ResetUserFailedLoginsMutationHookResult = ReturnType<typeof useResetUserFailedLoginsMutation>;
export type ResetUserFailedLoginsMutationResult = Apollo.MutationResult<ResetUserFailedLoginsMutation>;
export type ResetUserFailedLoginsMutationOptions = Apollo.BaseMutationOptions<ResetUserFailedLoginsMutation, ResetUserFailedLoginsMutationVariables>;
export const UpdateUserPasswordDocument = gql`
    mutation updateUserPassword($ownPassword: String!, $password: String!, $id: Int!) {
  setPassword(ownPassword: $ownPassword, password: $password, userId: $id) {
    passwordSet
  }
}
    `;
export type UpdateUserPasswordMutationFn = Apollo.MutationFunction<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;

/**
 * __useUpdateUserPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPasswordMutation, { data, loading, error }] = useUpdateUserPasswordMutation({
 *   variables: {
 *      ownPassword: // value for 'ownPassword'
 *      password: // value for 'password'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>(UpdateUserPasswordDocument, options);
      }
export type UpdateUserPasswordMutationHookResult = ReturnType<typeof useUpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationResult = Apollo.MutationResult<UpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;
export const SetMailNotificationCadenceDocument = gql`
    mutation setMailNotificationCadence($mailNotificationCadence: String!) {
  update_userSettings(
    _set: {mailNotificationCadence: $mailNotificationCadence}
    where: {}
  ) {
    affected_rows
    returning {
      id
      mailNotificationCadence
      wantRoomOccurrenceNotifications
    }
  }
}
    `;
export type SetMailNotificationCadenceMutationFn = Apollo.MutationFunction<SetMailNotificationCadenceMutation, SetMailNotificationCadenceMutationVariables>;

/**
 * __useSetMailNotificationCadenceMutation__
 *
 * To run a mutation, you first call `useSetMailNotificationCadenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMailNotificationCadenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMailNotificationCadenceMutation, { data, loading, error }] = useSetMailNotificationCadenceMutation({
 *   variables: {
 *      mailNotificationCadence: // value for 'mailNotificationCadence'
 *   },
 * });
 */
export function useSetMailNotificationCadenceMutation(baseOptions?: Apollo.MutationHookOptions<SetMailNotificationCadenceMutation, SetMailNotificationCadenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMailNotificationCadenceMutation, SetMailNotificationCadenceMutationVariables>(SetMailNotificationCadenceDocument, options);
      }
export type SetMailNotificationCadenceMutationHookResult = ReturnType<typeof useSetMailNotificationCadenceMutation>;
export type SetMailNotificationCadenceMutationResult = Apollo.MutationResult<SetMailNotificationCadenceMutation>;
export type SetMailNotificationCadenceMutationOptions = Apollo.BaseMutationOptions<SetMailNotificationCadenceMutation, SetMailNotificationCadenceMutationVariables>;
export const DeleteEventAttributeValueChangeNotificationDocument = gql`
    mutation deleteEventAttributeValueChangeNotification {
  delete_notificationPreferences(
    where: {notificationAction: {_eq: eventAttributeValueChange}}
  ) {
    affected_rows
    returning {
      id
      notificationChannel
      notificationPreferenceStage
    }
  }
}
    `;
export type DeleteEventAttributeValueChangeNotificationMutationFn = Apollo.MutationFunction<DeleteEventAttributeValueChangeNotificationMutation, DeleteEventAttributeValueChangeNotificationMutationVariables>;

/**
 * __useDeleteEventAttributeValueChangeNotificationMutation__
 *
 * To run a mutation, you first call `useDeleteEventAttributeValueChangeNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventAttributeValueChangeNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventAttributeValueChangeNotificationMutation, { data, loading, error }] = useDeleteEventAttributeValueChangeNotificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteEventAttributeValueChangeNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventAttributeValueChangeNotificationMutation, DeleteEventAttributeValueChangeNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventAttributeValueChangeNotificationMutation, DeleteEventAttributeValueChangeNotificationMutationVariables>(DeleteEventAttributeValueChangeNotificationDocument, options);
      }
export type DeleteEventAttributeValueChangeNotificationMutationHookResult = ReturnType<typeof useDeleteEventAttributeValueChangeNotificationMutation>;
export type DeleteEventAttributeValueChangeNotificationMutationResult = Apollo.MutationResult<DeleteEventAttributeValueChangeNotificationMutation>;
export type DeleteEventAttributeValueChangeNotificationMutationOptions = Apollo.BaseMutationOptions<DeleteEventAttributeValueChangeNotificationMutation, DeleteEventAttributeValueChangeNotificationMutationVariables>;
export const AddEventAttributeValueChangeNotificationDocument = gql`
    mutation addEventAttributeValueChangeNotification {
  insert_notificationPreferences(
    objects: [{notificationAction: eventAttributeValueChange, notificationChannel: web, notificationPreferenceStage: planning}, {notificationAction: eventAttributeValueChange, notificationChannel: web, notificationPreferenceStage: buildUp}, {notificationAction: eventAttributeValueChange, notificationChannel: web, notificationPreferenceStage: event}, {notificationAction: eventAttributeValueChange, notificationChannel: web, notificationPreferenceStage: organice}, {notificationAction: eventAttributeValueChange, notificationChannel: email, notificationPreferenceStage: planning}, {notificationAction: eventAttributeValueChange, notificationChannel: email, notificationPreferenceStage: buildUp}, {notificationAction: eventAttributeValueChange, notificationChannel: email, notificationPreferenceStage: event}, {notificationAction: eventAttributeValueChange, notificationChannel: email, notificationPreferenceStage: organice}, {notificationAction: eventAttributeValueChange, notificationChannel: message, notificationPreferenceStage: planning}, {notificationAction: eventAttributeValueChange, notificationChannel: message, notificationPreferenceStage: buildUp}, {notificationAction: eventAttributeValueChange, notificationChannel: message, notificationPreferenceStage: event}, {notificationAction: eventAttributeValueChange, notificationChannel: message, notificationPreferenceStage: organice}]
    on_conflict: {constraint: notificationPreferences_idx_1}
  ) {
    affected_rows
    returning {
      id
      notificationAction
      notificationChannel
      notificationPreferenceStage
    }
  }
}
    `;
export type AddEventAttributeValueChangeNotificationMutationFn = Apollo.MutationFunction<AddEventAttributeValueChangeNotificationMutation, AddEventAttributeValueChangeNotificationMutationVariables>;

/**
 * __useAddEventAttributeValueChangeNotificationMutation__
 *
 * To run a mutation, you first call `useAddEventAttributeValueChangeNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEventAttributeValueChangeNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEventAttributeValueChangeNotificationMutation, { data, loading, error }] = useAddEventAttributeValueChangeNotificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useAddEventAttributeValueChangeNotificationMutation(baseOptions?: Apollo.MutationHookOptions<AddEventAttributeValueChangeNotificationMutation, AddEventAttributeValueChangeNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEventAttributeValueChangeNotificationMutation, AddEventAttributeValueChangeNotificationMutationVariables>(AddEventAttributeValueChangeNotificationDocument, options);
      }
export type AddEventAttributeValueChangeNotificationMutationHookResult = ReturnType<typeof useAddEventAttributeValueChangeNotificationMutation>;
export type AddEventAttributeValueChangeNotificationMutationResult = Apollo.MutationResult<AddEventAttributeValueChangeNotificationMutation>;
export type AddEventAttributeValueChangeNotificationMutationOptions = Apollo.BaseMutationOptions<AddEventAttributeValueChangeNotificationMutation, AddEventAttributeValueChangeNotificationMutationVariables>;
export const DeleteEventCreatedNotificationDocument = gql`
    mutation deleteEventCreatedNotification {
  delete_notificationPreferences(where: {notificationAction: {_eq: eventCreated}}) {
    affected_rows
    returning {
      id
      notificationChannel
      notificationPreferenceStage
    }
  }
}
    `;
export type DeleteEventCreatedNotificationMutationFn = Apollo.MutationFunction<DeleteEventCreatedNotificationMutation, DeleteEventCreatedNotificationMutationVariables>;

/**
 * __useDeleteEventCreatedNotificationMutation__
 *
 * To run a mutation, you first call `useDeleteEventCreatedNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventCreatedNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventCreatedNotificationMutation, { data, loading, error }] = useDeleteEventCreatedNotificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteEventCreatedNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventCreatedNotificationMutation, DeleteEventCreatedNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventCreatedNotificationMutation, DeleteEventCreatedNotificationMutationVariables>(DeleteEventCreatedNotificationDocument, options);
      }
export type DeleteEventCreatedNotificationMutationHookResult = ReturnType<typeof useDeleteEventCreatedNotificationMutation>;
export type DeleteEventCreatedNotificationMutationResult = Apollo.MutationResult<DeleteEventCreatedNotificationMutation>;
export type DeleteEventCreatedNotificationMutationOptions = Apollo.BaseMutationOptions<DeleteEventCreatedNotificationMutation, DeleteEventCreatedNotificationMutationVariables>;
export const AddEventCreatedNotificationDocument = gql`
    mutation addEventCreatedNotification {
  insert_notificationPreferences(
    objects: [{notificationAction: eventCreated, notificationChannel: web, notificationPreferenceStage: planning}, {notificationAction: eventCreated, notificationChannel: web, notificationPreferenceStage: buildUp}, {notificationAction: eventCreated, notificationChannel: web, notificationPreferenceStage: event}, {notificationAction: eventCreated, notificationChannel: web, notificationPreferenceStage: organice}, {notificationAction: eventCreated, notificationChannel: email, notificationPreferenceStage: planning}, {notificationAction: eventCreated, notificationChannel: email, notificationPreferenceStage: buildUp}, {notificationAction: eventCreated, notificationChannel: email, notificationPreferenceStage: event}, {notificationAction: eventCreated, notificationChannel: email, notificationPreferenceStage: organice}, {notificationAction: eventCreated, notificationChannel: message, notificationPreferenceStage: planning}, {notificationAction: eventCreated, notificationChannel: message, notificationPreferenceStage: buildUp}, {notificationAction: eventCreated, notificationChannel: message, notificationPreferenceStage: event}, {notificationAction: eventCreated, notificationChannel: message, notificationPreferenceStage: organice}]
    on_conflict: {constraint: notificationPreferences_idx_1}
  ) {
    affected_rows
    returning {
      id
      notificationAction
      notificationChannel
      notificationPreferenceStage
    }
  }
}
    `;
export type AddEventCreatedNotificationMutationFn = Apollo.MutationFunction<AddEventCreatedNotificationMutation, AddEventCreatedNotificationMutationVariables>;

/**
 * __useAddEventCreatedNotificationMutation__
 *
 * To run a mutation, you first call `useAddEventCreatedNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEventCreatedNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEventCreatedNotificationMutation, { data, loading, error }] = useAddEventCreatedNotificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useAddEventCreatedNotificationMutation(baseOptions?: Apollo.MutationHookOptions<AddEventCreatedNotificationMutation, AddEventCreatedNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEventCreatedNotificationMutation, AddEventCreatedNotificationMutationVariables>(AddEventCreatedNotificationDocument, options);
      }
export type AddEventCreatedNotificationMutationHookResult = ReturnType<typeof useAddEventCreatedNotificationMutation>;
export type AddEventCreatedNotificationMutationResult = Apollo.MutationResult<AddEventCreatedNotificationMutation>;
export type AddEventCreatedNotificationMutationOptions = Apollo.BaseMutationOptions<AddEventCreatedNotificationMutation, AddEventCreatedNotificationMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($id: bigint!, $object: users_set_input, $organisationGroupUsers: [organisationGroupUsers_insert_input!]!, $userAttributeValues: [userAttributeValues_insert_input!]!) {
  delete_organisationGroupUsers(where: {userId: {_eq: $id}}) {
    affected_rows
  }
  update_users_by_pk(pk_columns: {id: $id}, _set: $object) {
    id
    lastLoginAt
    email
    firstName
    lastName
    jaggaerUsername
    organisationId
    organisation {
      id
      name
    }
    organisationGroupUsers {
      organisationGroup {
        id
        name
      }
    }
  }
  insert_organisationGroupUsers(objects: $organisationGroupUsers) {
    affected_rows
  }
  insert_userAttributeValues(
    objects: $userAttributeValues
    on_conflict: {constraint: userAttributeValues_pkey, update_columns: [value]}
  ) {
    affected_rows
    returning {
      value
      userId
      userAttributeId
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      object: // value for 'object'
 *      organisationGroupUsers: // value for 'organisationGroupUsers'
 *      userAttributeValues: // value for 'userAttributeValues'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const InsertUserAttributeValuesDocument = gql`
    mutation insertUserAttributeValues($objects: [userAttributeValues_insert_input!]!) {
  insert_userAttributeValues(
    objects: $objects
    on_conflict: {constraint: userAttributeValues_pkey, update_columns: [value]}
  ) {
    affected_rows
    returning {
      value
      userId
      userAttributeId
    }
  }
}
    `;
export type InsertUserAttributeValuesMutationFn = Apollo.MutationFunction<InsertUserAttributeValuesMutation, InsertUserAttributeValuesMutationVariables>;

/**
 * __useInsertUserAttributeValuesMutation__
 *
 * To run a mutation, you first call `useInsertUserAttributeValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserAttributeValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserAttributeValuesMutation, { data, loading, error }] = useInsertUserAttributeValuesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertUserAttributeValuesMutation(baseOptions?: Apollo.MutationHookOptions<InsertUserAttributeValuesMutation, InsertUserAttributeValuesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertUserAttributeValuesMutation, InsertUserAttributeValuesMutationVariables>(InsertUserAttributeValuesDocument, options);
      }
export type InsertUserAttributeValuesMutationHookResult = ReturnType<typeof useInsertUserAttributeValuesMutation>;
export type InsertUserAttributeValuesMutationResult = Apollo.MutationResult<InsertUserAttributeValuesMutation>;
export type InsertUserAttributeValuesMutationOptions = Apollo.BaseMutationOptions<InsertUserAttributeValuesMutation, InsertUserAttributeValuesMutationVariables>;
export const GetUserAttributesDocument = gql`
    query getUserAttributes($names: [String!]) {
  userAttributes(where: {name: {_in: $names}}) {
    id
    name
  }
}
    `;

/**
 * __useGetUserAttributesQuery__
 *
 * To run a query within a React component, call `useGetUserAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAttributesQuery({
 *   variables: {
 *      names: // value for 'names'
 *   },
 * });
 */
export function useGetUserAttributesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserAttributesQuery, GetUserAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAttributesQuery, GetUserAttributesQueryVariables>(GetUserAttributesDocument, options);
      }
export function useGetUserAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAttributesQuery, GetUserAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAttributesQuery, GetUserAttributesQueryVariables>(GetUserAttributesDocument, options);
        }
export function useGetUserAttributesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserAttributesQuery, GetUserAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserAttributesQuery, GetUserAttributesQueryVariables>(GetUserAttributesDocument, options);
        }
export type GetUserAttributesQueryHookResult = ReturnType<typeof useGetUserAttributesQuery>;
export type GetUserAttributesLazyQueryHookResult = ReturnType<typeof useGetUserAttributesLazyQuery>;
export type GetUserAttributesSuspenseQueryHookResult = ReturnType<typeof useGetUserAttributesSuspenseQuery>;
export type GetUserAttributesQueryResult = Apollo.QueryResult<GetUserAttributesQuery, GetUserAttributesQueryVariables>;
export const UserByIdDocument = gql`
    query userById($id: bigint!) {
  users_by_pk(id: $id) {
    id
    createdAt
    updatedAt
    lastLoginAt
    email
    firstName
    lastName
    ldapDN
    failedLoginCount
    isDisabled
    organisationId
    hasPassword
    jaggaerUsername
    organisation {
      id
      name
      isGuestOrga
    }
    organisationGroupUsers {
      organisationGroup {
        id
        name
      }
    }
    userAttributeValues {
      value
      userAttribute {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useUserByIdQuery__
 *
 * To run a query within a React component, call `useUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserByIdQuery(baseOptions: Apollo.QueryHookOptions<UserByIdQuery, UserByIdQueryVariables> & ({ variables: UserByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
      }
export function useUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
        }
export function useUserByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
        }
export type UserByIdQueryHookResult = ReturnType<typeof useUserByIdQuery>;
export type UserByIdLazyQueryHookResult = ReturnType<typeof useUserByIdLazyQuery>;
export type UserByIdSuspenseQueryHookResult = ReturnType<typeof useUserByIdSuspenseQuery>;
export type UserByIdQueryResult = Apollo.QueryResult<UserByIdQuery, UserByIdQueryVariables>;
export const UserByIdOrgaAdminDocument = gql`
    query userByIdOrgaAdmin($id: bigint!) {
  users_by_pk(id: $id) {
    id
    lastLoginAt
    email
    firstName
    lastName
    ldapDN
    failedLoginCount
    organisationId
    hasPassword
    organisation {
      id
      name
    }
    organisationGroupUsers {
      organisationGroup {
        id
        name
      }
    }
    userAttributeValues {
      value
      userAttribute {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useUserByIdOrgaAdminQuery__
 *
 * To run a query within a React component, call `useUserByIdOrgaAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByIdOrgaAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByIdOrgaAdminQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserByIdOrgaAdminQuery(baseOptions: Apollo.QueryHookOptions<UserByIdOrgaAdminQuery, UserByIdOrgaAdminQueryVariables> & ({ variables: UserByIdOrgaAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserByIdOrgaAdminQuery, UserByIdOrgaAdminQueryVariables>(UserByIdOrgaAdminDocument, options);
      }
export function useUserByIdOrgaAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserByIdOrgaAdminQuery, UserByIdOrgaAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserByIdOrgaAdminQuery, UserByIdOrgaAdminQueryVariables>(UserByIdOrgaAdminDocument, options);
        }
export function useUserByIdOrgaAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserByIdOrgaAdminQuery, UserByIdOrgaAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserByIdOrgaAdminQuery, UserByIdOrgaAdminQueryVariables>(UserByIdOrgaAdminDocument, options);
        }
export type UserByIdOrgaAdminQueryHookResult = ReturnType<typeof useUserByIdOrgaAdminQuery>;
export type UserByIdOrgaAdminLazyQueryHookResult = ReturnType<typeof useUserByIdOrgaAdminLazyQuery>;
export type UserByIdOrgaAdminSuspenseQueryHookResult = ReturnType<typeof useUserByIdOrgaAdminSuspenseQuery>;
export type UserByIdOrgaAdminQueryResult = Apollo.QueryResult<UserByIdOrgaAdminQuery, UserByIdOrgaAdminQueryVariables>;
export const GetNotificationUserSettingsDocument = gql`
    query getNotificationUserSettings {
  currentUser {
    id
    settings {
      id
      mailNotificationCadence
      notificationForOrganisation
      wantRoomOccurrenceNotifications
    }
  }
  notificationPreferences(where: {notificationAction: {_eq: eventCreated}}) {
    id
    notificationChannel
    notificationPreferenceStage
  }
  eventAttributeValueChangePreferences: notificationPreferences(
    where: {notificationAction: {_eq: eventAttributeValueChange}}
  ) {
    id
  }
}
    `;

/**
 * __useGetNotificationUserSettingsQuery__
 *
 * To run a query within a React component, call `useGetNotificationUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationUserSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationUserSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationUserSettingsQuery, GetNotificationUserSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationUserSettingsQuery, GetNotificationUserSettingsQueryVariables>(GetNotificationUserSettingsDocument, options);
      }
export function useGetNotificationUserSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationUserSettingsQuery, GetNotificationUserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationUserSettingsQuery, GetNotificationUserSettingsQueryVariables>(GetNotificationUserSettingsDocument, options);
        }
export function useGetNotificationUserSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationUserSettingsQuery, GetNotificationUserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationUserSettingsQuery, GetNotificationUserSettingsQueryVariables>(GetNotificationUserSettingsDocument, options);
        }
export type GetNotificationUserSettingsQueryHookResult = ReturnType<typeof useGetNotificationUserSettingsQuery>;
export type GetNotificationUserSettingsLazyQueryHookResult = ReturnType<typeof useGetNotificationUserSettingsLazyQuery>;
export type GetNotificationUserSettingsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationUserSettingsSuspenseQuery>;
export type GetNotificationUserSettingsQueryResult = Apollo.QueryResult<GetNotificationUserSettingsQuery, GetNotificationUserSettingsQueryVariables>;
export const UsersListDocument = gql`
    query usersList($where: users_bool_exp) {
  users(where: $where) {
    id
    createdAt
    updatedAt
    lastLoginAt
    email
    firstName
    lastName
    failedLoginCount
    isDisabled
    organisation {
      id
      name
    }
    organisationGroupUsers {
      organisationGroup {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useUsersListQuery__
 *
 * To run a query within a React component, call `useUsersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersListQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUsersListQuery(baseOptions?: Apollo.QueryHookOptions<UsersListQuery, UsersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersListQuery, UsersListQueryVariables>(UsersListDocument, options);
      }
export function useUsersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersListQuery, UsersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersListQuery, UsersListQueryVariables>(UsersListDocument, options);
        }
export function useUsersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersListQuery, UsersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersListQuery, UsersListQueryVariables>(UsersListDocument, options);
        }
export type UsersListQueryHookResult = ReturnType<typeof useUsersListQuery>;
export type UsersListLazyQueryHookResult = ReturnType<typeof useUsersListLazyQuery>;
export type UsersListSuspenseQueryHookResult = ReturnType<typeof useUsersListSuspenseQuery>;
export type UsersListQueryResult = Apollo.QueryResult<UsersListQuery, UsersListQueryVariables>;
export const UsersListForNonAdminUsersDocument = gql`
    query usersListForNonAdminUsers($where: allUsers_bool_exp) {
  allUsers(where: $where) {
    id
    firstName
    lastName
    organisation {
      id
      name
    }
  }
}
    `;

/**
 * __useUsersListForNonAdminUsersQuery__
 *
 * To run a query within a React component, call `useUsersListForNonAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersListForNonAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersListForNonAdminUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUsersListForNonAdminUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersListForNonAdminUsersQuery, UsersListForNonAdminUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersListForNonAdminUsersQuery, UsersListForNonAdminUsersQueryVariables>(UsersListForNonAdminUsersDocument, options);
      }
export function useUsersListForNonAdminUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersListForNonAdminUsersQuery, UsersListForNonAdminUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersListForNonAdminUsersQuery, UsersListForNonAdminUsersQueryVariables>(UsersListForNonAdminUsersDocument, options);
        }
export function useUsersListForNonAdminUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersListForNonAdminUsersQuery, UsersListForNonAdminUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersListForNonAdminUsersQuery, UsersListForNonAdminUsersQueryVariables>(UsersListForNonAdminUsersDocument, options);
        }
export type UsersListForNonAdminUsersQueryHookResult = ReturnType<typeof useUsersListForNonAdminUsersQuery>;
export type UsersListForNonAdminUsersLazyQueryHookResult = ReturnType<typeof useUsersListForNonAdminUsersLazyQuery>;
export type UsersListForNonAdminUsersSuspenseQueryHookResult = ReturnType<typeof useUsersListForNonAdminUsersSuspenseQuery>;
export type UsersListForNonAdminUsersQueryResult = Apollo.QueryResult<UsersListForNonAdminUsersQuery, UsersListForNonAdminUsersQueryVariables>;
export const UsersListOrgaAdminDocument = gql`
    query usersListOrgaAdmin($where: users_bool_exp) {
  users(where: $where) {
    id
    email
    firstName
    lastName
    failedLoginCount
    organisation {
      id
      name
    }
    organisationGroupUsers {
      organisationGroup {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useUsersListOrgaAdminQuery__
 *
 * To run a query within a React component, call `useUsersListOrgaAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersListOrgaAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersListOrgaAdminQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUsersListOrgaAdminQuery(baseOptions?: Apollo.QueryHookOptions<UsersListOrgaAdminQuery, UsersListOrgaAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersListOrgaAdminQuery, UsersListOrgaAdminQueryVariables>(UsersListOrgaAdminDocument, options);
      }
export function useUsersListOrgaAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersListOrgaAdminQuery, UsersListOrgaAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersListOrgaAdminQuery, UsersListOrgaAdminQueryVariables>(UsersListOrgaAdminDocument, options);
        }
export function useUsersListOrgaAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersListOrgaAdminQuery, UsersListOrgaAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersListOrgaAdminQuery, UsersListOrgaAdminQueryVariables>(UsersListOrgaAdminDocument, options);
        }
export type UsersListOrgaAdminQueryHookResult = ReturnType<typeof useUsersListOrgaAdminQuery>;
export type UsersListOrgaAdminLazyQueryHookResult = ReturnType<typeof useUsersListOrgaAdminLazyQuery>;
export type UsersListOrgaAdminSuspenseQueryHookResult = ReturnType<typeof useUsersListOrgaAdminSuspenseQuery>;
export type UsersListOrgaAdminQueryResult = Apollo.QueryResult<UsersListOrgaAdminQuery, UsersListOrgaAdminQueryVariables>;
export const AllUsersListDocument = gql`
    query allUsersList($where: allUsers_bool_exp) {
  allUsers(where: $where, order_by: {firstName: asc}) {
    id
    firstName
    lastName
    attributes
    organisation {
      id
      name
    }
  }
}
    `;

/**
 * __useAllUsersListQuery__
 *
 * To run a query within a React component, call `useAllUsersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersListQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAllUsersListQuery(baseOptions?: Apollo.QueryHookOptions<AllUsersListQuery, AllUsersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUsersListQuery, AllUsersListQueryVariables>(AllUsersListDocument, options);
      }
export function useAllUsersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUsersListQuery, AllUsersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUsersListQuery, AllUsersListQueryVariables>(AllUsersListDocument, options);
        }
export function useAllUsersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllUsersListQuery, AllUsersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllUsersListQuery, AllUsersListQueryVariables>(AllUsersListDocument, options);
        }
export type AllUsersListQueryHookResult = ReturnType<typeof useAllUsersListQuery>;
export type AllUsersListLazyQueryHookResult = ReturnType<typeof useAllUsersListLazyQuery>;
export type AllUsersListSuspenseQueryHookResult = ReturnType<typeof useAllUsersListSuspenseQuery>;
export type AllUsersListQueryResult = Apollo.QueryResult<AllUsersListQuery, AllUsersListQueryVariables>;